import React, { useState, useMemo } from 'react';
import { BarChart, Bar, LineChart, Line, PieChart, Pie, Cell, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, ScatterChart, Scatter } from 'recharts';
import { AlertTriangle, Users, Clock, Activity, TrendingUp, Shield, HardHat, Shirt, User } from 'lucide-react';
import { useEffect } from "react";
import VideoPlayer from './VideoPlayer';

const PPEAnalyticsDashboard = () => {
  const [selectedView, setSelectedView] = useState('overview');
  const [timeRange, setTimeRange] = useState('all');

  // Sample data structure - in production, this would come from your Excel/CSV
  const sampleData = [
     {
        "timestamp": "00:15:24",
        "id": 1,
        "className": "Person",
        coords: [
            343.0,
            531.0,
            451.0,
            718.0
        ],
        "status": "First Seen",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:15:24",
        "id": 1,
        "className": "Person",
        coords: [
            342.0,
            530.0,
            451.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:15:24.100000",
        "id": 1,
        "className": "Person",
        coords: [
            342.0,
            530.0,
            451.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:15:24.200000",
        "id": 1,
        "className": "Person",
        coords: [
            343.0,
            530.0,
            451.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:15:24.300000",
        "id": 1,
        "className": "Person",
        coords: [
            343.0,
            530.0,
            451.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:15:24.300000",
        "id": 1,
        "className": "Person",
        coords: [
            343.0,
            529.0,
            452.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:15:24.400000",
        "id": 1,
        "className": "Person",
        coords: [
            343.0,
            530.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:24.500000",
        "id": 1,
        "className": "Person",
        coords: [
            343.0,
            529.0,
            452.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:24.500000",
        "id": 1,
        "className": "Person",
        coords: [
            344.0,
            530.0,
            453.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:24.600000",
        "id": 1,
        "className": "Person",
        coords: [
            344.0,
            530.0,
            453.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:24.700000",
        "id": 1,
        "className": "Person",
        coords: [
            344.0,
            530.0,
            453.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:24.800000",
        "id": 2,
        "className": "Person",
        coords: [
            766.0,
            191.0,
            806.0,
            264.0
        ],
        "status": "First Seen",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:15:24.900000",
        "id": 1,
        "className": "Person",
        coords: [
            345.0,
            531.0,
            454.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:24.900000",
        "id": 2,
        "className": "Person",
        coords: [
            766.0,
            191.0,
            806.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:15:25",
        "id": 1,
        "className": "Person",
        coords: [
            347.0,
            532.0,
            455.0,
            718.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:25",
        "id": 2,
        "className": "Person",
        coords: [
            766.0,
            191.0,
            807.0,
            265.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:15:25.100000",
        "id": 1,
        "className": "Person",
        coords: [
            347.0,
            534.0,
            454.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:25.100000",
        "id": 2,
        "className": "Person",
        coords: [
            766.0,
            191.0,
            807.0,
            265.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:15:25.200000",
        "id": 1,
        "className": "Person",
        coords: [
            348.0,
            536.0,
            454.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:25.200000",
        "id": 2,
        "className": "Person",
        coords: [
            766.0,
            190.0,
            806.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:25.200000",
        "id": 1,
        "className": "Person",
        coords: [
            349.0,
            538.0,
            455.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:25.300000",
        "id": 2,
        "className": "Person",
        coords: [
            766.0,
            190.0,
            805.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:25.300000",
        "id": 2,
        "className": "Person",
        coords: [
            765.0,
            190.0,
            806.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:25.400000",
        "id": 2,
        "className": "Person",
        coords: [
            765.0,
            190.0,
            805.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:25.400000",
        "id": 1,
        "className": "Person",
        coords: [
            351.0,
            540.0,
            456.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:25.500000",
        "id": 2,
        "className": "Person",
        coords: [
            765.0,
            190.0,
            806.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:25.500000",
        "id": 1,
        "className": "Person",
        coords: [
            352.0,
            541.0,
            457.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:25.600000",
        "id": 2,
        "className": "Person",
        coords: [
            765.0,
            190.0,
            805.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:25.700000",
        "id": 2,
        "className": "Person",
        coords: [
            765.0,
            190.0,
            804.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:25.700000",
        "id": 1,
        "className": "Person",
        coords: [
            354.0,
            542.0,
            461.0,
            717.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:25.800000",
        "id": 2,
        "className": "Person",
        coords: [
            764.0,
            190.0,
            804.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:25.800000",
        "id": 1,
        "className": "Person",
        coords: [
            355.0,
            542.0,
            463.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:25.900000",
        "id": 2,
        "className": "Person",
        coords: [
            764.0,
            190.0,
            804.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:25.900000",
        "id": 3,
        "className": "Person",
        coords: [
            1005.0,
            388.0,
            1081.0,
            579.0
        ],
        "status": "First Seen",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:15:26",
        "id": 2,
        "className": "Person",
        coords: [
            764.0,
            190.0,
            804.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:26.100000",
        "id": 3,
        "className": "Person",
        coords: [
            987.0,
            389.0,
            1061.0,
            572.0
        ],
        "status": "Moving",
        "speed": 288.51,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:15:26.400000",
        "id": 5,
        "className": "Person",
        coords: [
            1104.0,
            431.0,
            1191.0,
            565.0
        ],
        "status": "First Seen",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:15:26.400000",
        "id": 6,
        "className": "Person",
        coords: [
            913.0,
            396.0,
            1047.0,
            556.0
        ],
        "status": "First Seen",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:15:26.500000",
        "id": 5,
        "className": "Person",
        coords: [
            1102.0,
            429.0,
            1192.0,
            566.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:15:26.600000",
        "id": 6,
        "className": "Person",
        coords: [
            909.0,
            391.0,
            1050.0,
            560.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:15:26.600000",
        "id": 5,
        "className": "Person",
        coords: [
            1101.0,
            426.0,
            1192.0,
            565.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:15:26.600000",
        "id": 6,
        "className": "Person",
        coords: [
            904.0,
            392.0,
            1046.0,
            562.0
        ],
        "status": "Moving",
        "speed": 67.08,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:15:26.700000",
        "id": 5,
        "className": "Person",
        coords: [
            1100.0,
            423.0,
            1193.0,
            565.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:15:26.700000",
        "id": 6,
        "className": "Person",
        coords: [
            899.0,
            378.0,
            1052.0,
            563.0
        ],
        "status": "Moving",
        "speed": 104.99,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:15:26.800000",
        "id": 5,
        "className": "Person",
        coords: [
            1100.0,
            421.0,
            1193.0,
            565.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:26.800000",
        "id": 6,
        "className": "Person",
        coords: [
            896.0,
            373.0,
            1051.0,
            564.0
        ],
        "status": "Moving",
        "speed": 42.42,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:26.800000",
        "id": 5,
        "className": "Person",
        coords: [
            1099.0,
            419.0,
            1194.0,
            565.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:26.900000",
        "id": 6,
        "className": "Person",
        coords: [
            895.0,
            370.0,
            1050.0,
            564.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:27",
        "id": 6,
        "className": "Person",
        coords: [
            893.0,
            369.0,
            1046.0,
            567.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:27",
        "id": 2,
        "className": "Person",
        coords: [
            760.0,
            189.0,
            800.0,
            261.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:27.100000",
        "id": 6,
        "className": "Person",
        coords: [
            893.0,
            369.0,
            1042.0,
            567.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:27.100000",
        "id": 2,
        "className": "Person",
        coords: [
            760.0,
            190.0,
            800.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:27.100000",
        "id": 2,
        "className": "Person",
        coords: [
            759.0,
            189.0,
            801.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:27.200000",
        "id": 2,
        "className": "Person",
        coords: [
            759.0,
            190.0,
            801.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:27.200000",
        "id": 2,
        "className": "Person",
        coords: [
            759.0,
            190.0,
            801.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:27.300000",
        "id": 6,
        "className": "Person",
        coords: [
            898.0,
            369.0,
            1041.0,
            564.0
        ],
        "status": "Moving",
        "speed": 42.42,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:27.400000",
        "id": 2,
        "className": "Person",
        coords: [
            759.0,
            190.0,
            801.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:27.400000",
        "id": 6,
        "className": "Person",
        coords: [
            899.0,
            370.0,
            1039.0,
            565.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:27.500000",
        "id": 2,
        "className": "Person",
        coords: [
            759.0,
            190.0,
            801.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:27.500000",
        "id": 6,
        "className": "Person",
        coords: [
            900.0,
            370.0,
            1034.0,
            564.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:27.500000",
        "id": 2,
        "className": "Person",
        coords: [
            759.0,
            190.0,
            801.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:27.600000",
        "id": 6,
        "className": "Person",
        coords: [
            899.0,
            370.0,
            1029.0,
            565.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:27.600000",
        "id": 2,
        "className": "Person",
        coords: [
            759.0,
            190.0,
            801.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:27.700000",
        "id": 6,
        "className": "Person",
        coords: [
            903.0,
            370.0,
            1030.0,
            565.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:27.700000",
        "id": 2,
        "className": "Person",
        coords: [
            759.0,
            189.0,
            801.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:27.700000",
        "id": 6,
        "className": "Person",
        coords: [
            903.0,
            370.0,
            1025.0,
            565.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:27.800000",
        "id": 2,
        "className": "Person",
        coords: [
            759.0,
            190.0,
            801.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:27.800000",
        "id": 6,
        "className": "Person",
        coords: [
            904.0,
            370.0,
            1023.0,
            565.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:27.900000",
        "id": 2,
        "className": "Person",
        coords: [
            759.0,
            190.0,
            801.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:27.900000",
        "id": 6,
        "className": "Person",
        coords: [
            906.0,
            369.0,
            1020.0,
            563.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:27.900000",
        "id": 1,
        "className": "Person",
        coords: [
            343.0,
            554.0,
            461.0,
            714.0
        ],
        "status": "Moving",
        "speed": 129.02,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:28",
        "id": 2,
        "className": "Person",
        coords: [
            759.0,
            190.0,
            801.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:28",
        "id": 6,
        "className": "Person",
        coords: [
            907.0,
            368.0,
            1018.0,
            562.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:28.100000",
        "id": 2,
        "className": "Person",
        coords: [
            759.0,
            190.0,
            801.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:28.100000",
        "id": 6,
        "className": "Person",
        coords: [
            908.0,
            368.0,
            1016.0,
            562.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:28.200000",
        "id": 2,
        "className": "Person",
        coords: [
            759.0,
            190.0,
            801.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:28.200000",
        "id": 6,
        "className": "Person",
        coords: [
            908.0,
            367.0,
            1014.0,
            562.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:28.200000",
        "id": 1,
        "className": "Person",
        coords: [
            346.0,
            554.0,
            484.0,
            717.0
        ],
        "status": "Moving",
        "speed": 195.56,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:28.300000",
        "id": 2,
        "className": "Person",
        coords: [
            759.0,
            190.0,
            801.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:28.300000",
        "id": 6,
        "className": "Person",
        coords: [
            910.0,
            366.0,
            1012.0,
            559.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:28.300000",
        "id": 2,
        "className": "Person",
        coords: [
            759.0,
            190.0,
            801.0,
            260.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:28.400000",
        "id": 6,
        "className": "Person",
        coords: [
            911.0,
            366.0,
            1011.0,
            559.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:28.400000",
        "id": 2,
        "className": "Person",
        coords: [
            759.0,
            190.0,
            801.0,
            260.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:28.400000",
        "id": 6,
        "className": "Person",
        coords: [
            912.0,
            365.0,
            1010.0,
            560.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:28.500000",
        "id": 1,
        "className": "Person",
        coords: [
            353.0,
            554.0,
            510.0,
            717.0
        ],
        "status": "Moving",
        "speed": 239.98,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:28.500000",
        "id": 2,
        "className": "Person",
        coords: [
            759.0,
            190.0,
            801.0,
            260.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:28.600000",
        "id": 6,
        "className": "Person",
        coords: [
            911.0,
            363.0,
            1009.0,
            561.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:28.700000",
        "id": 2,
        "className": "Person",
        coords: [
            759.0,
            190.0,
            801.0,
            260.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:28.700000",
        "id": 6,
        "className": "Person",
        coords: [
            911.0,
            362.0,
            1007.0,
            559.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:28.800000",
        "id": 2,
        "className": "Person",
        coords: [
            759.0,
            190.0,
            801.0,
            260.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:28.800000",
        "id": 2,
        "className": "Person",
        coords: [
            759.0,
            189.0,
            801.0,
            260.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:28.800000",
        "id": 6,
        "className": "Person",
        coords: [
            918.0,
            361.0,
            1000.0,
            527.0
        ],
        "status": "Moving",
        "speed": 239.98,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:28.900000",
        "id": 2,
        "className": "Person",
        coords: [
            759.0,
            189.0,
            801.0,
            260.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:28.900000",
        "id": 6,
        "className": "Person",
        coords: [
            915.0,
            360.0,
            1002.0,
            540.0
        ],
        "status": "Moving",
        "speed": 91.23,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:29",
        "id": 2,
        "className": "Person",
        coords: [
            759.0,
            189.0,
            801.0,
            260.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:29",
        "id": 6,
        "className": "Person",
        coords: [
            921.0,
            361.0,
            998.0,
            519.0
        ],
        "status": "Moving",
        "speed": 150.74,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:29",
        "id": 2,
        "className": "Person",
        coords: [
            759.0,
            189.0,
            801.0,
            260.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:29.100000",
        "id": 6,
        "className": "Person",
        coords: [
            915.0,
            361.0,
            1001.0,
            538.0
        ],
        "status": "Moving",
        "speed": 135.82,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:29.100000",
        "id": 2,
        "className": "Person",
        coords: [
            759.0,
            189.0,
            801.0,
            260.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:29.100000",
        "id": 6,
        "className": "Person",
        coords: [
            913.0,
            361.0,
            1002.0,
            544.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:29.200000",
        "id": 2,
        "className": "Person",
        coords: [
            759.0,
            190.0,
            801.0,
            260.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:29.300000",
        "id": 2,
        "className": "Person",
        coords: [
            759.0,
            190.0,
            801.0,
            260.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:29.300000",
        "id": 2,
        "className": "Person",
        coords: [
            759.0,
            190.0,
            801.0,
            260.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:29.400000",
        "id": 2,
        "className": "Person",
        coords: [
            759.0,
            190.0,
            801.0,
            260.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:29.400000",
        "id": 2,
        "className": "Person",
        coords: [
            759.0,
            189.0,
            801.0,
            260.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:29.500000",
        "id": 1,
        "className": "Person",
        coords: [
            315.0,
            540.0,
            483.0,
            718.0
        ],
        "status": "Moving",
        "speed": 488.32,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:29.600000",
        "id": 2,
        "className": "Person",
        coords: [
            759.0,
            189.0,
            801.0,
            259.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:29.600000",
        "id": 1,
        "className": "Person",
        coords: [
            315.0,
            540.0,
            480.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:29.600000",
        "id": 6,
        "className": "Person",
        coords: [
            924.0,
            364.0,
            994.0,
            508.0
        ],
        "status": "Moving",
        "speed": 241.85,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:29.700000",
        "id": 2,
        "className": "Person",
        coords: [
            759.0,
            189.0,
            801.0,
            259.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:29.700000",
        "id": 1,
        "className": "Person",
        coords: [
            315.0,
            540.0,
            479.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:29.800000",
        "id": 6,
        "className": "Person",
        coords: [
            925.0,
            365.0,
            993.0,
            506.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:29.800000",
        "id": 2,
        "className": "Person",
        coords: [
            759.0,
            189.0,
            801.0,
            259.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:29.900000",
        "id": 1,
        "className": "Person",
        coords: [
            317.0,
            539.0,
            479.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:29.900000",
        "id": 6,
        "className": "Person",
        coords: [
            926.0,
            366.0,
            992.0,
            504.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:29.900000",
        "id": 2,
        "className": "Person",
        coords: [
            759.0,
            189.0,
            801.0,
            259.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:30",
        "id": 1,
        "className": "Person",
        coords: [
            317.0,
            539.0,
            478.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:30",
        "id": 6,
        "className": "Person",
        coords: [
            926.0,
            367.0,
            991.0,
            504.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:30",
        "id": 5,
        "className": "Person",
        coords: [
            1092.0,
            399.0,
            1202.0,
            575.0
        ],
        "status": "Moving",
        "speed": 76.48,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:30.100000",
        "id": 2,
        "className": "Person",
        coords: [
            759.0,
            189.0,
            801.0,
            259.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:30.100000",
        "id": 1,
        "className": "Person",
        coords: [
            318.0,
            539.0,
            477.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:30.200000",
        "id": 6,
        "className": "Person",
        coords: [
            928.0,
            368.0,
            992.0,
            504.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:30.200000",
        "id": 2,
        "className": "Person",
        coords: [
            759.0,
            189.0,
            801.0,
            259.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:30.300000",
        "id": 1,
        "className": "Person",
        coords: [
            316.0,
            539.0,
            474.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:30.300000",
        "id": 6,
        "className": "Person",
        coords: [
            928.0,
            368.0,
            992.0,
            505.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:30.300000",
        "id": 5,
        "className": "Person",
        coords: [
            1089.0,
            399.0,
            1199.0,
            583.0
        ],
        "status": "Moving",
        "speed": 74.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:30.400000",
        "id": 2,
        "className": "Person",
        coords: [
            759.0,
            189.0,
            801.0,
            259.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:30.400000",
        "id": 1,
        "className": "Person",
        coords: [
            315.0,
            539.0,
            472.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:30.400000",
        "id": 6,
        "className": "Person",
        coords: [
            929.0,
            368.0,
            993.0,
            505.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:30.400000",
        "id": 5,
        "className": "Person",
        coords: [
            1089.0,
            400.0,
            1197.0,
            585.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:30.500000",
        "id": 2,
        "className": "Person",
        coords: [
            759.0,
            189.0,
            801.0,
            259.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:30.500000",
        "id": 1,
        "className": "Person",
        coords: [
            314.0,
            538.0,
            471.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:30.600000",
        "id": 6,
        "className": "Person",
        coords: [
            929.0,
            369.0,
            991.0,
            505.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:30.600000",
        "id": 5,
        "className": "Person",
        coords: [
            1089.0,
            399.0,
            1196.0,
            587.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:30.600000",
        "id": 2,
        "className": "Person",
        coords: [
            759.0,
            189.0,
            801.0,
            259.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:30.700000",
        "id": 1,
        "className": "Person",
        coords: [
            314.0,
            538.0,
            471.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:30.700000",
        "id": 6,
        "className": "Person",
        coords: [
            929.0,
            369.0,
            991.0,
            505.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:30.700000",
        "id": 5,
        "className": "Person",
        coords: [
            1088.0,
            400.0,
            1196.0,
            596.0
        ],
        "status": "Moving",
        "speed": 74.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:30.700000",
        "id": 8,
        "className": "Person",
        coords: [
            143.0,
            194.0,
            176.0,
            276.0
        ],
        "status": "First Seen",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:15:30.800000",
        "id": 2,
        "className": "Person",
        coords: [
            759.0,
            189.0,
            801.0,
            259.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:30.800000",
        "id": 1,
        "className": "Person",
        coords: [
            314.0,
            538.0,
            470.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:30.800000",
        "id": 6,
        "className": "Person",
        coords: [
            929.0,
            369.0,
            991.0,
            506.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:30.900000",
        "id": 5,
        "className": "Person",
        coords: [
            1078.0,
            401.0,
            1195.0,
            616.0
        ],
        "status": "Moving",
        "speed": 174.91,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:30.900000",
        "id": 8,
        "className": "Person",
        coords: [
            143.0,
            194.0,
            176.0,
            276.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:15:30.900000",
        "id": 2,
        "className": "Person",
        coords: [
            759.0,
            189.0,
            801.0,
            259.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:31",
        "id": 1,
        "className": "Person",
        coords: [
            315.0,
            539.0,
            471.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:31",
        "id": 6,
        "className": "Person",
        coords: [
            929.0,
            369.0,
            991.0,
            505.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:31",
        "id": 5,
        "className": "Person",
        coords: [
            1074.0,
            403.0,
            1192.0,
            620.0
        ],
        "status": "Moving",
        "speed": 63.63,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:31",
        "id": 8,
        "className": "Person",
        coords: [
            143.0,
            194.0,
            176.0,
            276.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:15:31.100000",
        "id": 2,
        "className": "Person",
        coords: [
            759.0,
            189.0,
            801.0,
            259.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:31.100000",
        "id": 1,
        "className": "Person",
        coords: [
            316.0,
            539.0,
            471.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:31.100000",
        "id": 6,
        "className": "Person",
        coords: [
            930.0,
            370.0,
            991.0,
            505.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:31.200000",
        "id": 5,
        "className": "Person",
        coords: [
            1072.0,
            405.0,
            1189.0,
            623.0
        ],
        "status": "Moving",
        "speed": 63.63,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:31.200000",
        "id": 8,
        "className": "Person",
        coords: [
            143.0,
            194.0,
            176.0,
            276.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:15:31.200000",
        "id": 2,
        "className": "Person",
        coords: [
            759.0,
            189.0,
            801.0,
            259.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:31.300000",
        "id": 1,
        "className": "Person",
        coords: [
            316.0,
            539.0,
            471.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:31.300000",
        "id": 6,
        "className": "Person",
        coords: [
            930.0,
            370.0,
            991.0,
            505.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:31.400000",
        "id": 5,
        "className": "Person",
        coords: [
            1069.0,
            408.0,
            1188.0,
            633.0
        ],
        "status": "Moving",
        "speed": 94.86,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:31.400000",
        "id": 8,
        "className": "Person",
        coords: [
            143.0,
            194.0,
            176.0,
            276.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:31.400000",
        "id": 2,
        "className": "Person",
        coords: [
            759.0,
            189.0,
            801.0,
            259.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:31.500000",
        "id": 1,
        "className": "Person",
        coords: [
            318.0,
            538.0,
            473.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:31.500000",
        "id": 6,
        "className": "Person",
        coords: [
            930.0,
            370.0,
            991.0,
            505.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:31.500000",
        "id": 5,
        "className": "Person",
        coords: [
            1068.0,
            410.0,
            1184.0,
            632.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:31.500000",
        "id": 8,
        "className": "Person",
        coords: [
            143.0,
            194.0,
            176.0,
            276.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:31.600000",
        "id": 2,
        "className": "Person",
        coords: [
            759.0,
            189.0,
            802.0,
            260.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:31.600000",
        "id": 1,
        "className": "Person",
        coords: [
            323.0,
            538.0,
            476.0,
            718.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:31.600000",
        "id": 6,
        "className": "Person",
        coords: [
            929.0,
            370.0,
            991.0,
            506.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:31.700000",
        "id": 5,
        "className": "Person",
        coords: [
            1067.0,
            412.0,
            1183.0,
            638.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:31.700000",
        "id": 8,
        "className": "Person",
        coords: [
            143.0,
            194.0,
            176.0,
            276.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:31.700000",
        "id": 2,
        "className": "Person",
        coords: [
            759.0,
            189.0,
            802.0,
            260.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:31.800000",
        "id": 1,
        "className": "Person",
        coords: [
            329.0,
            538.0,
            480.0,
            718.0
        ],
        "status": "Moving",
        "speed": 74.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:31.800000",
        "id": 6,
        "className": "Person",
        coords: [
            930.0,
            370.0,
            991.0,
            506.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:31.800000",
        "id": 5,
        "className": "Person",
        coords: [
            1068.0,
            413.0,
            1179.0,
            632.0
        ],
        "status": "Moving",
        "speed": 54.08,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:31.800000",
        "id": 8,
        "className": "Person",
        coords: [
            143.0,
            194.0,
            176.0,
            276.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:31.800000",
        "id": 9,
        "className": "Person",
        coords: [
            486.0,
            249.0,
            562.0,
            338.0
        ],
        "status": "First Seen",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:15:31.900000",
        "id": 2,
        "className": "Person",
        coords: [
            759.0,
            189.0,
            802.0,
            260.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:31.900000",
        "id": 1,
        "className": "Person",
        coords: [
            326.0,
            539.0,
            475.0,
            718.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:32",
        "id": 6,
        "className": "Person",
        coords: [
            930.0,
            370.0,
            992.0,
            507.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:32",
        "id": 5,
        "className": "Person",
        coords: [
            1067.0,
            414.0,
            1178.0,
            634.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:32",
        "id": 8,
        "className": "Person",
        coords: [
            142.0,
            194.0,
            176.0,
            276.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:32",
        "id": 9,
        "className": "Person",
        coords: [
            487.0,
            249.0,
            562.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:15:32.100000",
        "id": 2,
        "className": "Person",
        coords: [
            759.0,
            189.0,
            802.0,
            260.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:32.100000",
        "id": 1,
        "className": "Person",
        coords: [
            323.0,
            540.0,
            471.0,
            718.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:32.200000",
        "id": 6,
        "className": "Person",
        coords: [
            930.0,
            370.0,
            992.0,
            506.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:32.200000",
        "id": 5,
        "className": "Person",
        coords: [
            1064.0,
            415.0,
            1170.0,
            628.0
        ],
        "status": "Moving",
        "speed": 87.46,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:32.200000",
        "id": 8,
        "className": "Person",
        coords: [
            142.0,
            194.0,
            176.0,
            276.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:32.200000",
        "id": 9,
        "className": "Person",
        coords: [
            488.0,
            250.0,
            561.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:15:32.300000",
        "id": 2,
        "className": "Person",
        coords: [
            759.0,
            189.0,
            802.0,
            260.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:32.300000",
        "id": 1,
        "className": "Person",
        coords: [
            322.0,
            540.0,
            469.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:32.300000",
        "id": 6,
        "className": "Person",
        coords: [
            930.0,
            370.0,
            991.0,
            506.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:32.300000",
        "id": 5,
        "className": "Person",
        coords: [
            1052.0,
            415.0,
            1157.0,
            626.0
        ],
        "status": "Moving",
        "speed": 195.56,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:32.400000",
        "id": 8,
        "className": "Person",
        coords: [
            142.0,
            195.0,
            176.0,
            276.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:32.400000",
        "id": 9,
        "className": "Person",
        coords: [
            487.0,
            250.0,
            562.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:15:32.400000",
        "id": 2,
        "className": "Person",
        coords: [
            759.0,
            189.0,
            802.0,
            260.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:32.500000",
        "id": 1,
        "className": "Person",
        coords: [
            324.0,
            540.0,
            470.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:32.500000",
        "id": 6,
        "className": "Person",
        coords: [
            929.0,
            370.0,
            991.0,
            506.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:32.500000",
        "id": 5,
        "className": "Person",
        coords: [
            1043.0,
            415.0,
            1148.0,
            626.0
        ],
        "status": "Moving",
        "speed": 134.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:32.500000",
        "id": 8,
        "className": "Person",
        coords: [
            142.0,
            195.0,
            176.0,
            276.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:32.600000",
        "id": 9,
        "className": "Person",
        coords: [
            487.0,
            250.0,
            563.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:32.600000",
        "id": 2,
        "className": "Person",
        coords: [
            759.0,
            189.0,
            802.0,
            260.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:32.600000",
        "id": 1,
        "className": "Person",
        coords: [
            324.0,
            540.0,
            469.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:32.700000",
        "id": 6,
        "className": "Person",
        coords: [
            928.0,
            370.0,
            990.0,
            506.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:32.700000",
        "id": 5,
        "className": "Person",
        coords: [
            1040.0,
            417.0,
            1145.0,
            625.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:32.700000",
        "id": 8,
        "className": "Person",
        coords: [
            142.0,
            195.0,
            176.0,
            276.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:32.700000",
        "id": 9,
        "className": "Person",
        coords: [
            487.0,
            249.0,
            563.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:32.800000",
        "id": 2,
        "className": "Person",
        coords: [
            759.0,
            189.0,
            802.0,
            260.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:32.800000",
        "id": 1,
        "className": "Person",
        coords: [
            327.0,
            540.0,
            469.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:32.800000",
        "id": 6,
        "className": "Person",
        coords: [
            928.0,
            370.0,
            991.0,
            506.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:32.900000",
        "id": 5,
        "className": "Person",
        coords: [
            1039.0,
            419.0,
            1144.0,
            626.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:32.900000",
        "id": 8,
        "className": "Person",
        coords: [
            142.0,
            195.0,
            176.0,
            276.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:32.900000",
        "id": 9,
        "className": "Person",
        coords: [
            487.0,
            249.0,
            563.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:33",
        "id": 2,
        "className": "Person",
        coords: [
            759.0,
            189.0,
            802.0,
            260.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:33",
        "id": 1,
        "className": "Person",
        coords: [
            330.0,
            538.0,
            470.0,
            718.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:33",
        "id": 6,
        "className": "Person",
        coords: [
            926.0,
            370.0,
            990.0,
            506.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:33",
        "id": 5,
        "className": "Person",
        coords: [
            1038.0,
            420.0,
            1142.0,
            625.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:33",
        "id": 8,
        "className": "Person",
        coords: [
            142.0,
            195.0,
            176.0,
            276.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:33.100000",
        "id": 9,
        "className": "Person",
        coords: [
            487.0,
            248.0,
            563.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:33.100000",
        "id": 2,
        "className": "Person",
        coords: [
            759.0,
            189.0,
            802.0,
            260.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:33.200000",
        "id": 1,
        "className": "Person",
        coords: [
            332.0,
            538.0,
            470.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:33.200000",
        "id": 6,
        "className": "Person",
        coords: [
            926.0,
            370.0,
            991.0,
            507.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:33.200000",
        "id": 5,
        "className": "Person",
        coords: [
            1033.0,
            420.0,
            1138.0,
            626.0
        ],
        "status": "Moving",
        "speed": 76.48,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:33.200000",
        "id": 8,
        "className": "Person",
        coords: [
            142.0,
            195.0,
            176.0,
            275.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:33.200000",
        "id": 9,
        "className": "Person",
        coords: [
            486.0,
            247.0,
            563.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:33.300000",
        "id": 2,
        "className": "Person",
        coords: [
            759.0,
            189.0,
            802.0,
            260.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:33.300000",
        "id": 6,
        "className": "Person",
        coords: [
            927.0,
            370.0,
            991.0,
            507.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:33.300000",
        "id": 5,
        "className": "Person",
        coords: [
            1030.0,
            419.0,
            1135.0,
            626.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:33.400000",
        "id": 8,
        "className": "Person",
        coords: [
            142.0,
            194.0,
            176.0,
            276.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:33.400000",
        "id": 9,
        "className": "Person",
        coords: [
            486.0,
            247.0,
            565.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:33.400000",
        "id": 2,
        "className": "Person",
        coords: [
            759.0,
            189.0,
            801.0,
            260.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:33.500000",
        "id": 6,
        "className": "Person",
        coords: [
            926.0,
            370.0,
            992.0,
            507.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:33.500000",
        "id": 5,
        "className": "Person",
        coords: [
            1028.0,
            419.0,
            1133.0,
            627.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:33.500000",
        "id": 8,
        "className": "Person",
        coords: [
            142.0,
            194.0,
            176.0,
            276.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:33.500000",
        "id": 9,
        "className": "Person",
        coords: [
            487.0,
            246.0,
            565.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:33.600000",
        "id": 2,
        "className": "Person",
        coords: [
            759.0,
            189.0,
            801.0,
            260.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:33.600000",
        "id": 6,
        "className": "Person",
        coords: [
            926.0,
            370.0,
            992.0,
            507.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:33.600000",
        "id": 5,
        "className": "Person",
        coords: [
            1028.0,
            419.0,
            1131.0,
            625.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:33.600000",
        "id": 8,
        "className": "Person",
        coords: [
            142.0,
            194.0,
            176.0,
            276.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:33.700000",
        "id": 9,
        "className": "Person",
        coords: [
            487.0,
            247.0,
            564.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:33.700000",
        "id": 2,
        "className": "Person",
        coords: [
            759.0,
            190.0,
            801.0,
            260.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:33.700000",
        "id": 6,
        "className": "Person",
        coords: [
            927.0,
            370.0,
            992.0,
            506.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:33.800000",
        "id": 5,
        "className": "Person",
        coords: [
            1022.0,
            421.0,
            1127.0,
            627.0
        ],
        "status": "Moving",
        "speed": 80.77,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:33.800000",
        "id": 8,
        "className": "Person",
        coords: [
            142.0,
            194.0,
            176.0,
            276.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:33.800000",
        "id": 9,
        "className": "Person",
        coords: [
            486.0,
            247.0,
            564.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:33.900000",
        "id": 2,
        "className": "Person",
        coords: [
            759.0,
            190.0,
            801.0,
            260.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:33.900000",
        "id": 6,
        "className": "Person",
        coords: [
            926.0,
            370.0,
            992.0,
            506.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:33.900000",
        "id": 5,
        "className": "Person",
        coords: [
            1015.0,
            423.0,
            1119.0,
            628.0
        ],
        "status": "Moving",
        "speed": 106.06,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:33.900000",
        "id": 8,
        "className": "Person",
        coords: [
            142.0,
            194.0,
            176.0,
            276.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:34",
        "id": 9,
        "className": "Person",
        coords: [
            487.0,
            248.0,
            563.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:34",
        "id": 2,
        "className": "Person",
        coords: [
            759.0,
            189.0,
            801.0,
            260.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:34",
        "id": 6,
        "className": "Person",
        coords: [
            926.0,
            370.0,
            993.0,
            506.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:34.100000",
        "id": 5,
        "className": "Person",
        coords: [
            1010.0,
            426.0,
            1114.0,
            633.0
        ],
        "status": "Moving",
        "speed": 96.04,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:34.100000",
        "id": 8,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            176.0,
            275.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:34.100000",
        "id": 9,
        "className": "Person",
        coords: [
            486.0,
            245.0,
            564.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:34.200000",
        "id": 2,
        "className": "Person",
        coords: [
            759.0,
            188.0,
            801.0,
            260.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:34.200000",
        "id": 6,
        "className": "Person",
        coords: [
            926.0,
            370.0,
            993.0,
            507.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:34.200000",
        "id": 5,
        "className": "Person",
        coords: [
            995.0,
            428.0,
            1104.0,
            642.0
        ],
        "status": "Moving",
        "speed": 214.75,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:34.200000",
        "id": 8,
        "className": "Person",
        coords: [
            141.0,
            192.0,
            176.0,
            275.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:34.200000",
        "id": 9,
        "className": "Person",
        coords: [
            485.0,
            244.0,
            564.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:34.300000",
        "id": 2,
        "className": "Person",
        coords: [
            758.0,
            188.0,
            800.0,
            260.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:34.300000",
        "id": 6,
        "className": "Person",
        coords: [
            926.0,
            370.0,
            993.0,
            507.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:34.400000",
        "id": 5,
        "className": "Person",
        coords: [
            989.0,
            432.0,
            1098.0,
            645.0
        ],
        "status": "Moving",
        "speed": 100.61,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:34.400000",
        "id": 8,
        "className": "Person",
        coords: [
            141.0,
            192.0,
            176.0,
            275.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:34.400000",
        "id": 9,
        "className": "Person",
        coords: [
            485.0,
            244.0,
            564.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:34.500000",
        "id": 2,
        "className": "Person",
        coords: [
            758.0,
            188.0,
            800.0,
            260.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:34.500000",
        "id": 6,
        "className": "Person",
        coords: [
            925.0,
            370.0,
            993.0,
            507.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:34.500000",
        "id": 5,
        "className": "Person",
        coords: [
            987.0,
            433.0,
            1095.0,
            645.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:34.500000",
        "id": 8,
        "className": "Person",
        coords: [
            141.0,
            192.0,
            176.0,
            275.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:34.500000",
        "id": 9,
        "className": "Person",
        coords: [
            486.0,
            244.0,
            564.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:34.600000",
        "id": 2,
        "className": "Person",
        coords: [
            758.0,
            189.0,
            799.0,
            260.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:34.600000",
        "id": 6,
        "className": "Person",
        coords: [
            925.0,
            370.0,
            993.0,
            507.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:34.600000",
        "id": 5,
        "className": "Person",
        coords: [
            983.0,
            434.0,
            1091.0,
            647.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:34.700000",
        "id": 8,
        "className": "Person",
        coords: [
            141.0,
            192.0,
            176.0,
            275.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:34.700000",
        "id": 9,
        "className": "Person",
        coords: [
            486.0,
            244.0,
            563.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:34.700000",
        "id": 1,
        "className": "Person",
        coords: [
            329.0,
            532.0,
            465.0,
            715.0
        ],
        "status": "Moving",
        "speed": 84.85,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:34.800000",
        "id": 2,
        "className": "Person",
        coords: [
            758.0,
            190.0,
            798.0,
            260.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:34.800000",
        "id": 6,
        "className": "Person",
        coords: [
            926.0,
            371.0,
            994.0,
            507.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:34.800000",
        "id": 5,
        "className": "Person",
        coords: [
            980.0,
            433.0,
            1087.0,
            648.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:34.800000",
        "id": 8,
        "className": "Person",
        coords: [
            141.0,
            192.0,
            176.0,
            275.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:34.900000",
        "id": 9,
        "className": "Person",
        coords: [
            486.0,
            241.0,
            563.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:34.900000",
        "id": 1,
        "className": "Person",
        coords: [
            331.0,
            531.0,
            462.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:34.900000",
        "id": 2,
        "className": "Person",
        coords: [
            757.0,
            189.0,
            797.0,
            260.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:35",
        "id": 6,
        "className": "Person",
        coords: [
            927.0,
            370.0,
            995.0,
            506.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:35",
        "id": 5,
        "className": "Person",
        coords: [
            973.0,
            433.0,
            1080.0,
            647.0
        ],
        "status": "Moving",
        "speed": 104.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:35",
        "id": 8,
        "className": "Person",
        coords: [
            141.0,
            192.0,
            176.0,
            275.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:35",
        "id": 9,
        "className": "Person",
        coords: [
            485.0,
            239.0,
            563.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:35.100000",
        "id": 1,
        "className": "Person",
        coords: [
            332.0,
            531.0,
            461.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:35.200000",
        "id": 2,
        "className": "Person",
        coords: [
            756.0,
            189.0,
            796.0,
            259.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:35.200000",
        "id": 6,
        "className": "Person",
        coords: [
            928.0,
            370.0,
            995.0,
            504.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:35.200000",
        "id": 5,
        "className": "Person",
        coords: [
            966.0,
            432.0,
            1069.0,
            638.0
        ],
        "status": "Moving",
        "speed": 154.42,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:35.200000",
        "id": 8,
        "className": "Person",
        coords: [
            141.0,
            192.0,
            176.0,
            275.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:35.300000",
        "id": 9,
        "className": "Person",
        coords: [
            485.0,
            238.0,
            563.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:35.300000",
        "id": 1,
        "className": "Person",
        coords: [
            333.0,
            532.0,
            459.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:35.400000",
        "id": 2,
        "className": "Person",
        coords: [
            756.0,
            190.0,
            795.0,
            259.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:35.400000",
        "id": 6,
        "className": "Person",
        coords: [
            928.0,
            370.0,
            996.0,
            503.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:35.400000",
        "id": 5,
        "className": "Person",
        coords: [
            952.0,
            432.0,
            1059.0,
            642.0
        ],
        "status": "Moving",
        "speed": 182.47,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:35.400000",
        "id": 8,
        "className": "Person",
        coords: [
            141.0,
            192.0,
            176.0,
            275.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:35.400000",
        "id": 9,
        "className": "Person",
        coords: [
            485.0,
            238.0,
            561.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:35.500000",
        "id": 1,
        "className": "Person",
        coords: [
            334.0,
            532.0,
            458.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:35.500000",
        "id": 2,
        "className": "Person",
        coords: [
            754.0,
            191.0,
            792.0,
            259.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:35.600000",
        "id": 6,
        "className": "Person",
        coords: [
            928.0,
            370.0,
            996.0,
            503.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:35.600000",
        "id": 5,
        "className": "Person",
        coords: [
            945.0,
            432.0,
            1052.0,
            639.0
        ],
        "status": "Moving",
        "speed": 109.19,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:35.600000",
        "id": 8,
        "className": "Person",
        coords: [
            141.0,
            192.0,
            176.0,
            275.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:35.600000",
        "id": 9,
        "className": "Person",
        coords: [
            485.0,
            238.0,
            560.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:35.700000",
        "id": 2,
        "className": "Person",
        coords: [
            753.0,
            189.0,
            791.0,
            259.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:35.700000",
        "id": 6,
        "className": "Person",
        coords: [
            930.0,
            370.0,
            998.0,
            503.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:35.700000",
        "id": 5,
        "className": "Person",
        coords: [
            941.0,
            433.0,
            1048.0,
            641.0
        ],
        "status": "Moving",
        "speed": 67.08,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:35.700000",
        "id": 8,
        "className": "Person",
        coords: [
            141.0,
            192.0,
            176.0,
            275.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:35.800000",
        "id": 9,
        "className": "Person",
        coords: [
            485.0,
            238.0,
            561.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:35.800000",
        "id": 2,
        "className": "Person",
        coords: [
            751.0,
            188.0,
            790.0,
            259.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:35.900000",
        "id": 6,
        "className": "Person",
        coords: [
            918.0,
            370.0,
            1002.0,
            537.0
        ],
        "status": "Moving",
        "speed": 261.94,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:35.900000",
        "id": 5,
        "className": "Person",
        coords: [
            933.0,
            435.0,
            1037.0,
            637.0
        ],
        "status": "Moving",
        "speed": 135.82,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:36",
        "id": 8,
        "className": "Person",
        coords: [
            141.0,
            192.0,
            176.0,
            275.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:36",
        "id": 9,
        "className": "Person",
        coords: [
            484.0,
            237.0,
            561.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:36.100000",
        "id": 2,
        "className": "Person",
        coords: [
            748.0,
            188.0,
            790.0,
            266.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:36.100000",
        "id": 6,
        "className": "Person",
        coords: [
            916.0,
            370.0,
            1004.0,
            547.0
        ],
        "status": "Moving",
        "speed": 74.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:36.100000",
        "id": 5,
        "className": "Person",
        coords: [
            921.0,
            439.0,
            1026.0,
            638.0
        ],
        "status": "Moving",
        "speed": 182.47,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:36.200000",
        "id": 8,
        "className": "Person",
        coords: [
            141.0,
            192.0,
            176.0,
            275.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:36.200000",
        "id": 9,
        "className": "Person",
        coords: [
            485.0,
            237.0,
            560.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:36.300000",
        "id": 2,
        "className": "Person",
        coords: [
            748.0,
            188.0,
            790.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:36.300000",
        "id": 5,
        "className": "Person",
        coords: [
            905.0,
            439.0,
            1015.0,
            645.0
        ],
        "status": "Moving",
        "speed": 204.01,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:36.300000",
        "id": 8,
        "className": "Person",
        coords: [
            141.0,
            192.0,
            176.0,
            275.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:36.400000",
        "id": 9,
        "className": "Person",
        coords: [
            485.0,
            237.0,
            558.0,
            335.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:36.400000",
        "id": 2,
        "className": "Person",
        coords: [
            746.0,
            189.0,
            790.0,
            273.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:36.400000",
        "id": 5,
        "className": "Person",
        coords: [
            897.0,
            438.0,
            1008.0,
            647.0
        ],
        "status": "Moving",
        "speed": 119.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:36.500000",
        "id": 8,
        "className": "Person",
        coords: [
            141.0,
            192.0,
            176.0,
            275.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:36.500000",
        "id": 9,
        "className": "Person",
        coords: [
            486.0,
            238.0,
            559.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:36.600000",
        "id": 2,
        "className": "Person",
        coords: [
            746.0,
            188.0,
            789.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:36.600000",
        "id": 5,
        "className": "Person",
        coords: [
            890.0,
            437.0,
            1003.0,
            649.0
        ],
        "status": "Moving",
        "speed": 91.23,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:36.600000",
        "id": 8,
        "className": "Person",
        coords: [
            141.0,
            191.0,
            176.0,
            275.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:36.600000",
        "id": 9,
        "className": "Person",
        coords: [
            489.0,
            238.0,
            560.0,
            333.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:36.700000",
        "id": 2,
        "className": "Person",
        coords: [
            745.0,
            188.0,
            788.0,
            275.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:36.800000",
        "id": 5,
        "className": "Person",
        coords: [
            883.0,
            435.0,
            997.0,
            649.0
        ],
        "status": "Moving",
        "speed": 91.23,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:36.800000",
        "id": 8,
        "className": "Person",
        coords: [
            142.0,
            191.0,
            176.0,
            275.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:36.800000",
        "id": 9,
        "className": "Person",
        coords: [
            490.0,
            238.0,
            561.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:36.900000",
        "id": 2,
        "className": "Person",
        coords: [
            746.0,
            188.0,
            787.0,
            275.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:36.900000",
        "id": 5,
        "className": "Person",
        coords: [
            870.0,
            434.0,
            991.0,
            663.0
        ],
        "status": "Moving",
        "speed": 174.91,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:36.900000",
        "id": 8,
        "className": "Person",
        coords: [
            142.0,
            191.0,
            176.0,
            275.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:37",
        "id": 9,
        "className": "Person",
        coords: [
            490.0,
            238.0,
            562.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:37",
        "id": 6,
        "className": "Person",
        coords: [
            933.0,
            371.0,
            1000.0,
            505.0
        ],
        "status": "Moving",
        "speed": 313.18,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:37.100000",
        "id": 2,
        "className": "Person",
        coords: [
            743.0,
            188.0,
            786.0,
            279.0
        ],
        "status": "Moving",
        "speed": 42.42,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:37.100000",
        "id": 5,
        "className": "Person",
        coords: [
            857.0,
            434.0,
            984.0,
            678.0
        ],
        "status": "Moving",
        "speed": 192.08,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:37.100000",
        "id": 8,
        "className": "Person",
        coords: [
            142.0,
            191.0,
            176.0,
            275.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:37.200000",
        "id": 9,
        "className": "Person",
        coords: [
            490.0,
            238.0,
            562.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:37.200000",
        "id": 6,
        "className": "Person",
        coords: [
            936.0,
            372.0,
            1000.0,
            501.0
        ],
        "status": "Moving",
        "speed": 42.42,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:37.200000",
        "id": 2,
        "className": "Person",
        coords: [
            742.0,
            188.0,
            784.0,
            281.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:37.300000",
        "id": 5,
        "className": "Person",
        coords: [
            841.0,
            435.0,
            973.0,
            688.0
        ],
        "status": "Moving",
        "speed": 208.91,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:37.300000",
        "id": 8,
        "className": "Person",
        coords: [
            142.0,
            191.0,
            176.0,
            275.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:37.300000",
        "id": 9,
        "className": "Person",
        coords: [
            490.0,
            238.0,
            563.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:37.300000",
        "id": 6,
        "className": "Person",
        coords: [
            936.0,
            372.0,
            1000.0,
            501.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:37.400000",
        "id": 5,
        "className": "Person",
        coords: [
            837.0,
            439.0,
            961.0,
            678.0
        ],
        "status": "Moving",
        "speed": 128.15,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:37.400000",
        "id": 8,
        "className": "Person",
        coords: [
            142.0,
            191.0,
            176.0,
            275.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:37.500000",
        "id": 9,
        "className": "Person",
        coords: [
            491.0,
            237.0,
            563.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:37.500000",
        "id": 6,
        "className": "Person",
        coords: [
            935.0,
            373.0,
            999.0,
            502.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:37.600000",
        "id": 5,
        "className": "Person",
        coords: [
            812.0,
            442.0,
            944.0,
            690.0
        ],
        "status": "Moving",
        "speed": 337.06,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:37.600000",
        "id": 8,
        "className": "Person",
        coords: [
            142.0,
            191.0,
            176.0,
            275.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:37.600000",
        "id": 9,
        "className": "Person",
        coords: [
            491.0,
            236.0,
            564.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:37.600000",
        "id": 6,
        "className": "Person",
        coords: [
            934.0,
            373.0,
            998.0,
            503.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:37.700000",
        "id": 2,
        "className": "Person",
        coords: [
            741.0,
            188.0,
            782.0,
            282.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:37.700000",
        "id": 5,
        "className": "Person",
        coords: [
            800.0,
            444.0,
            933.0,
            694.0
        ],
        "status": "Moving",
        "speed": 185.52,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:37.800000",
        "id": 8,
        "className": "Person",
        coords: [
            142.0,
            191.0,
            176.0,
            275.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:37.800000",
        "id": 9,
        "className": "Person",
        coords: [
            492.0,
            235.0,
            565.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:37.800000",
        "id": 6,
        "className": "Person",
        coords: [
            932.0,
            373.0,
            998.0,
            504.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:37.900000",
        "id": 5,
        "className": "Person",
        coords: [
            791.0,
            444.0,
            925.0,
            693.0
        ],
        "status": "Moving",
        "speed": 120.92,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:37.900000",
        "id": 8,
        "className": "Person",
        coords: [
            142.0,
            191.0,
            176.0,
            275.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:37.900000",
        "id": 9,
        "className": "Person",
        coords: [
            492.0,
            235.0,
            566.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:37.900000",
        "id": 6,
        "className": "Person",
        coords: [
            931.0,
            373.0,
            997.0,
            503.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:38",
        "id": 5,
        "className": "Person",
        coords: [
            785.0,
            442.0,
            919.0,
            693.0
        ],
        "status": "Moving",
        "speed": 91.23,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:38",
        "id": 8,
        "className": "Person",
        coords: [
            142.0,
            191.0,
            176.0,
            275.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:38",
        "id": 9,
        "className": "Person",
        coords: [
            492.0,
            235.0,
            566.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:38.100000",
        "id": 5,
        "className": "Person",
        coords: [
            782.0,
            441.0,
            914.0,
            691.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:38.100000",
        "id": 8,
        "className": "Person",
        coords: [
            141.0,
            191.0,
            176.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:38.100000",
        "id": 9,
        "className": "Person",
        coords: [
            492.0,
            235.0,
            567.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:38.200000",
        "id": 5,
        "className": "Person",
        coords: [
            775.0,
            440.0,
            906.0,
            692.0
        ],
        "status": "Moving",
        "speed": 119.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:38.200000",
        "id": 8,
        "className": "Person",
        coords: [
            140.0,
            191.0,
            175.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:38.200000",
        "id": 9,
        "className": "Person",
        coords: [
            491.0,
            235.0,
            568.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:38.300000",
        "id": 5,
        "className": "Person",
        coords: [
            766.0,
            440.0,
            895.0,
            691.0
        ],
        "status": "Moving",
        "speed": 150.74,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:38.300000",
        "id": 8,
        "className": "Person",
        coords: [
            140.0,
            191.0,
            175.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:38.400000",
        "id": 9,
        "className": "Person",
        coords: [
            492.0,
            234.0,
            569.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:38.400000",
        "id": 2,
        "className": "Person",
        coords: [
            738.0,
            183.0,
            780.0,
            284.0
        ],
        "status": "Moving",
        "speed": 42.42,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:38.400000",
        "id": 5,
        "className": "Person",
        coords: [
            758.0,
            440.0,
            885.0,
            691.0
        ],
        "status": "Moving",
        "speed": 134.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:38.500000",
        "id": 8,
        "className": "Person",
        coords: [
            140.0,
            191.0,
            175.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:38.500000",
        "id": 9,
        "className": "Person",
        coords: [
            493.0,
            234.0,
            570.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:38.500000",
        "id": 2,
        "className": "Person",
        coords: [
            738.0,
            183.0,
            779.0,
            284.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:38.500000",
        "id": 6,
        "className": "Person",
        coords: [
            927.0,
            374.0,
            993.0,
            503.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:38.600000",
        "id": 5,
        "className": "Person",
        coords: [
            727.0,
            440.0,
            857.0,
            692.0
        ],
        "status": "Moving",
        "speed": 435.22,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:38.600000",
        "id": 8,
        "className": "Person",
        coords: [
            140.0,
            191.0,
            175.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:38.600000",
        "id": 9,
        "className": "Person",
        coords: [
            493.0,
            234.0,
            571.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:38.600000",
        "id": 2,
        "className": "Person",
        coords: [
            739.0,
            183.0,
            778.0,
            284.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:38.600000",
        "id": 6,
        "className": "Person",
        coords: [
            925.0,
            374.0,
            993.0,
            503.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:38.700000",
        "id": 5,
        "className": "Person",
        coords: [
            709.0,
            442.0,
            840.0,
            691.0
        ],
        "status": "Moving",
        "speed": 269.98,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:38.700000",
        "id": 8,
        "className": "Person",
        coords: [
            139.0,
            190.0,
            175.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:38.700000",
        "id": 9,
        "className": "Person",
        coords: [
            494.0,
            234.0,
            572.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:38.800000",
        "id": 2,
        "className": "Person",
        coords: [
            739.0,
            182.0,
            777.0,
            284.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:38.800000",
        "id": 6,
        "className": "Person",
        coords: [
            923.0,
            375.0,
            991.0,
            499.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:38.900000",
        "id": 5,
        "className": "Person",
        coords: [
            700.0,
            441.0,
            834.0,
            692.0
        ],
        "status": "Moving",
        "speed": 104.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:38.900000",
        "id": 8,
        "className": "Person",
        coords: [
            139.0,
            190.0,
            175.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:38.900000",
        "id": 9,
        "className": "Person",
        coords: [
            495.0,
            234.0,
            572.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:38.900000",
        "id": 2,
        "className": "Person",
        coords: [
            739.0,
            182.0,
            777.0,
            284.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:39",
        "id": 5,
        "className": "Person",
        coords: [
            692.0,
            438.0,
            829.0,
            693.0
        ],
        "status": "Moving",
        "speed": 106.06,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:39",
        "id": 8,
        "className": "Person",
        coords: [
            137.0,
            189.0,
            174.0,
            274.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:39.100000",
        "id": 9,
        "className": "Person",
        coords: [
            496.0,
            234.0,
            572.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:39.100000",
        "id": 2,
        "className": "Person",
        coords: [
            739.0,
            182.0,
            776.0,
            282.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:39.100000",
        "id": 6,
        "className": "Person",
        coords: [
            919.0,
            375.0,
            990.0,
            500.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:39.200000",
        "id": 5,
        "className": "Person",
        coords: [
            687.0,
            435.0,
            821.0,
            687.0
        ],
        "status": "Moving",
        "speed": 108.16,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:39.200000",
        "id": 8,
        "className": "Person",
        coords: [
            137.0,
            189.0,
            173.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:39.200000",
        "id": 9,
        "className": "Person",
        coords: [
            496.0,
            234.0,
            571.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:39.200000",
        "id": 2,
        "className": "Person",
        coords: [
            739.0,
            182.0,
            776.0,
            282.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:39.200000",
        "id": 6,
        "className": "Person",
        coords: [
            919.0,
            377.0,
            991.0,
            501.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:39.300000",
        "id": 5,
        "className": "Person",
        coords: [
            679.0,
            432.0,
            811.0,
            683.0
        ],
        "status": "Moving",
        "speed": 147.72,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:39.300000",
        "id": 8,
        "className": "Person",
        coords: [
            137.0,
            189.0,
            173.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:39.400000",
        "id": 9,
        "className": "Person",
        coords: [
            496.0,
            234.0,
            571.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:39.400000",
        "id": 2,
        "className": "Person",
        coords: [
            740.0,
            182.0,
            776.0,
            283.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:39.400000",
        "id": 5,
        "className": "Person",
        coords: [
            670.0,
            429.0,
            801.0,
            688.0
        ],
        "status": "Moving",
        "speed": 150.74,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:39.500000",
        "id": 8,
        "className": "Person",
        coords: [
            137.0,
            189.0,
            173.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:39.500000",
        "id": 9,
        "className": "Person",
        coords: [
            496.0,
            234.0,
            571.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:39.500000",
        "id": 2,
        "className": "Person",
        coords: [
            740.0,
            182.0,
            776.0,
            283.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:39.500000",
        "id": 1,
        "className": "Person",
        coords: [
            338.0,
            533.0,
            457.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:39.600000",
        "id": 5,
        "className": "Person",
        coords: [
            659.0,
            428.0,
            788.0,
            687.0
        ],
        "status": "Moving",
        "speed": 180.61,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:39.600000",
        "id": 8,
        "className": "Person",
        coords: [
            137.0,
            189.0,
            173.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:39.700000",
        "id": 9,
        "className": "Person",
        coords: [
            495.0,
            234.0,
            570.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:39.700000",
        "id": 2,
        "className": "Person",
        coords: [
            740.0,
            182.0,
            775.0,
            283.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:39.800000",
        "id": 1,
        "className": "Person",
        coords: [
            339.0,
            533.0,
            456.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:39.800000",
        "id": 6,
        "className": "Person",
        coords: [
            919.0,
            384.0,
            989.0,
            501.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:39.800000",
        "id": 5,
        "className": "Person",
        coords: [
            636.0,
            430.0,
            765.0,
            686.0
        ],
        "status": "Moving",
        "speed": 345.3,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:39.900000",
        "id": 8,
        "className": "Person",
        coords: [
            137.0,
            189.0,
            173.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:39.900000",
        "id": 9,
        "className": "Person",
        coords: [
            494.0,
            235.0,
            568.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:39.900000",
        "id": 2,
        "className": "Person",
        coords: [
            740.0,
            182.0,
            774.0,
            283.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:39.900000",
        "id": 5,
        "className": "Person",
        coords: [
            615.0,
            430.0,
            747.0,
            686.0
        ],
        "status": "Moving",
        "speed": 284.98,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:40",
        "id": 8,
        "className": "Person",
        coords: [
            137.0,
            189.0,
            173.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:40",
        "id": 9,
        "className": "Person",
        coords: [
            494.0,
            235.0,
            567.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:40",
        "id": 2,
        "className": "Person",
        coords: [
            740.0,
            182.0,
            773.0,
            279.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:40.100000",
        "id": 6,
        "className": "Person",
        coords: [
            905.0,
            386.0,
            997.0,
            540.0
        ],
        "status": "Moving",
        "speed": 318.17,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:40.100000",
        "id": 5,
        "className": "Person",
        coords: [
            599.0,
            430.0,
            732.0,
            684.0
        ],
        "status": "Moving",
        "speed": 240.45,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:40.100000",
        "id": 8,
        "className": "Person",
        coords: [
            137.0,
            189.0,
            172.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:40.200000",
        "id": 9,
        "className": "Person",
        coords: [
            494.0,
            235.0,
            566.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:40.200000",
        "id": 2,
        "className": "Person",
        coords: [
            740.0,
            182.0,
            772.0,
            279.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:40.200000",
        "id": 10,
        "className": "Person",
        coords: [
            726.0,
            451.0,
            824.0,
            640.0
        ],
        "status": "First Seen",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:15:40.300000",
        "id": 6,
        "className": "Person",
        coords: [
            903.0,
            387.0,
            998.0,
            548.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:40.300000",
        "id": 1,
        "className": "Person",
        coords: [
            340.0,
            532.0,
            455.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:40.300000",
        "id": 5,
        "className": "Person",
        coords: [
            591.0,
            430.0,
            725.0,
            681.0
        ],
        "status": "Moving",
        "speed": 109.19,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:40.400000",
        "id": 8,
        "className": "Person",
        coords: [
            136.0,
            189.0,
            172.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:40.400000",
        "id": 9,
        "className": "Person",
        coords: [
            495.0,
            236.0,
            565.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:40.400000",
        "id": 2,
        "className": "Person",
        coords: [
            739.0,
            182.0,
            772.0,
            281.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:40.500000",
        "id": 10,
        "className": "Person",
        coords: [
            722.0,
            451.0,
            819.0,
            637.0
        ],
        "status": "Moving",
        "speed": 76.48,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:15:40.500000",
        "id": 6,
        "className": "Person",
        coords: [
            902.0,
            388.0,
            999.0,
            552.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:40.500000",
        "id": 1,
        "className": "Person",
        coords: [
            340.0,
            532.0,
            454.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:40.600000",
        "id": 5,
        "className": "Person",
        coords: [
            586.0,
            431.0,
            721.0,
            678.0
        ],
        "status": "Moving",
        "speed": 76.48,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:40.600000",
        "id": 8,
        "className": "Person",
        coords: [
            136.0,
            190.0,
            171.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:40.600000",
        "id": 9,
        "className": "Person",
        coords: [
            495.0,
            237.0,
            564.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:40.600000",
        "id": 2,
        "className": "Person",
        coords: [
            739.0,
            181.0,
            772.0,
            282.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:40.600000",
        "id": 10,
        "className": "Person",
        coords: [
            714.0,
            452.0,
            810.0,
            632.0
        ],
        "status": "Moving",
        "speed": 123.68,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:15:40.700000",
        "id": 6,
        "className": "Person",
        coords: [
            901.0,
            390.0,
            999.0,
            554.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:40.700000",
        "id": 1,
        "className": "Person",
        coords: [
            340.0,
            532.0,
            453.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:40.800000",
        "id": 5,
        "className": "Person",
        coords: [
            577.0,
            429.0,
            712.0,
            678.0
        ],
        "status": "Moving",
        "speed": 135.82,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:40.800000",
        "id": 8,
        "className": "Person",
        coords: [
            136.0,
            190.0,
            171.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:40.800000",
        "id": 9,
        "className": "Person",
        coords: [
            495.0,
            236.0,
            564.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:40.800000",
        "id": 2,
        "className": "Person",
        coords: [
            739.0,
            181.0,
            772.0,
            282.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:40.800000",
        "id": 6,
        "className": "Person",
        coords: [
            901.0,
            390.0,
            999.0,
            554.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:40.900000",
        "id": 1,
        "className": "Person",
        coords: [
            340.0,
            532.0,
            453.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:40.900000",
        "id": 5,
        "className": "Person",
        coords: [
            567.0,
            424.0,
            701.0,
            676.0
        ],
        "status": "Moving",
        "speed": 156.59,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:41",
        "id": 8,
        "className": "Person",
        coords: [
            136.0,
            189.0,
            171.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:41",
        "id": 9,
        "className": "Person",
        coords: [
            495.0,
            237.0,
            563.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:41",
        "id": 2,
        "className": "Person",
        coords: [
            739.0,
            181.0,
            772.0,
            280.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:41",
        "id": 6,
        "className": "Person",
        coords: [
            902.0,
            391.0,
            999.0,
            554.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:41",
        "id": 1,
        "className": "Person",
        coords: [
            341.0,
            532.0,
            453.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:41.100000",
        "id": 10,
        "className": "Person",
        coords: [
            722.0,
            456.0,
            804.0,
            607.0
        ],
        "status": "Moving",
        "speed": 165.67,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:15:41.100000",
        "id": 5,
        "className": "Person",
        coords: [
            560.0,
            420.0,
            691.0,
            673.0
        ],
        "status": "Moving",
        "speed": 147.72,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:41.100000",
        "id": 8,
        "className": "Person",
        coords: [
            136.0,
            189.0,
            171.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:41.200000",
        "id": 9,
        "className": "Person",
        coords: [
            495.0,
            237.0,
            562.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:41.200000",
        "id": 2,
        "className": "Person",
        coords: [
            739.0,
            181.0,
            772.0,
            281.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:41.200000",
        "id": 6,
        "className": "Person",
        coords: [
            903.0,
            391.0,
            999.0,
            553.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:41.200000",
        "id": 1,
        "className": "Person",
        coords: [
            341.0,
            532.0,
            453.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:41.200000",
        "id": 10,
        "className": "Person",
        coords: [
            731.0,
            458.0,
            811.0,
            602.0
        ],
        "status": "Moving",
        "speed": 120.92,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:41.300000",
        "id": 5,
        "className": "Person",
        coords: [
            548.0,
            416.0,
            678.0,
            673.0
        ],
        "status": "Moving",
        "speed": 182.47,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:41.300000",
        "id": 9,
        "className": "Person",
        coords: [
            492.0,
            237.0,
            560.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:41.300000",
        "id": 2,
        "className": "Person",
        coords: [
            739.0,
            181.0,
            771.0,
            280.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:41.400000",
        "id": 6,
        "className": "Person",
        coords: [
            915.0,
            392.0,
            994.0,
            522.0
        ],
        "status": "Moving",
        "speed": 229.44,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:41.400000",
        "id": 1,
        "className": "Person",
        coords: [
            341.0,
            532.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:41.400000",
        "id": 10,
        "className": "Person",
        coords: [
            733.0,
            461.0,
            814.0,
            606.0
        ],
        "status": "Moving",
        "speed": 54.08,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:41.500000",
        "id": 5,
        "className": "Person",
        coords: [
            534.0,
            414.0,
            663.0,
            672.0
        ],
        "status": "Moving",
        "speed": 225.48,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:41.500000",
        "id": 9,
        "className": "Person",
        coords: [
            491.0,
            236.0,
            559.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:41.500000",
        "id": 2,
        "className": "Person",
        coords: [
            739.0,
            181.0,
            770.0,
            279.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:41.500000",
        "id": 6,
        "className": "Person",
        coords: [
            920.0,
            392.0,
            992.0,
            507.0
        ],
        "status": "Moving",
        "speed": 123.68,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:41.600000",
        "id": 1,
        "className": "Person",
        coords: [
            341.0,
            532.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:41.600000",
        "id": 10,
        "className": "Person",
        coords: [
            733.0,
            464.0,
            817.0,
            611.0
        ],
        "status": "Moving",
        "speed": 67.08,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:41.700000",
        "id": 5,
        "className": "Person",
        coords: [
            516.0,
            412.0,
            645.0,
            672.0
        ],
        "status": "Moving",
        "speed": 270.39,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:41.700000",
        "id": 9,
        "className": "Person",
        coords: [
            491.0,
            236.0,
            558.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:41.700000",
        "id": 2,
        "className": "Person",
        coords: [
            739.0,
            181.0,
            770.0,
            279.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:41.700000",
        "id": 6,
        "className": "Person",
        coords: [
            907.0,
            393.0,
            999.0,
            539.0
        ],
        "status": "Moving",
        "speed": 258.92,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:41.700000",
        "id": 1,
        "className": "Person",
        coords: [
            342.0,
            532.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:41.800000",
        "id": 10,
        "className": "Person",
        coords: [
            732.0,
            466.0,
            816.0,
            611.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:41.800000",
        "id": 5,
        "className": "Person",
        coords: [
            503.0,
            411.0,
            632.0,
            671.0
        ],
        "status": "Moving",
        "speed": 195.56,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:41.900000",
        "id": 9,
        "className": "Person",
        coords: [
            491.0,
            236.0,
            558.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:41.900000",
        "id": 2,
        "className": "Person",
        coords: [
            739.0,
            181.0,
            770.0,
            278.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:41.900000",
        "id": 6,
        "className": "Person",
        coords: [
            902.0,
            393.0,
            999.0,
            549.0
        ],
        "status": "Moving",
        "speed": 87.46,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:41.900000",
        "id": 1,
        "className": "Person",
        coords: [
            342.0,
            532.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:42",
        "id": 10,
        "className": "Person",
        coords: [
            732.0,
            467.0,
            817.0,
            611.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:42",
        "id": 5,
        "className": "Person",
        coords: [
            495.0,
            409.0,
            627.0,
            672.0
        ],
        "status": "Moving",
        "speed": 91.23,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:42.100000",
        "id": 9,
        "className": "Person",
        coords: [
            491.0,
            236.0,
            558.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:42.100000",
        "id": 2,
        "className": "Person",
        coords: [
            739.0,
            181.0,
            770.0,
            278.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:42.100000",
        "id": 6,
        "className": "Person",
        coords: [
            914.0,
            393.0,
            995.0,
            520.0
        ],
        "status": "Moving",
        "speed": 232.84,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:42.100000",
        "id": 1,
        "className": "Person",
        coords: [
            342.0,
            532.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:42.200000",
        "id": 10,
        "className": "Person",
        coords: [
            746.0,
            470.0,
            828.0,
            611.0
        ],
        "status": "Moving",
        "speed": 195.56,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:42.200000",
        "id": 5,
        "className": "Person",
        coords: [
            492.0,
            407.0,
            625.0,
            672.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:42.300000",
        "id": 9,
        "className": "Person",
        coords: [
            491.0,
            237.0,
            557.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:42.300000",
        "id": 2,
        "className": "Person",
        coords: [
            739.0,
            181.0,
            770.0,
            277.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:42.300000",
        "id": 6,
        "className": "Person",
        coords: [
            919.0,
            392.0,
            992.0,
            503.0
        ],
        "status": "Moving",
        "speed": 135.82,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:42.400000",
        "id": 1,
        "className": "Person",
        coords: [
            343.0,
            532.0,
            453.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:42.400000",
        "id": 10,
        "className": "Person",
        coords: [
            737.0,
            471.0,
            820.0,
            612.0
        ],
        "status": "Moving",
        "speed": 135.82,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:42.400000",
        "id": 5,
        "className": "Person",
        coords: [
            488.0,
            404.0,
            618.0,
            663.0
        ],
        "status": "Moving",
        "speed": 117.14,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:42.500000",
        "id": 9,
        "className": "Person",
        coords: [
            492.0,
            237.0,
            557.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:42.500000",
        "id": 2,
        "className": "Person",
        coords: [
            739.0,
            181.0,
            770.0,
            278.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:42.500000",
        "id": 6,
        "className": "Person",
        coords: [
            920.0,
            392.0,
            994.0,
            502.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:42.500000",
        "id": 1,
        "className": "Person",
        coords: [
            344.0,
            532.0,
            453.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:42.500000",
        "id": 10,
        "className": "Person",
        coords: [
            733.0,
            471.0,
            818.0,
            612.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:42.600000",
        "id": 5,
        "className": "Person",
        coords: [
            481.0,
            399.0,
            605.0,
            653.0
        ],
        "status": "Moving",
        "speed": 183.08,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:42.600000",
        "id": 9,
        "className": "Person",
        coords: [
            491.0,
            236.0,
            558.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:42.600000",
        "id": 2,
        "className": "Person",
        coords: [
            740.0,
            181.0,
            769.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:42.700000",
        "id": 6,
        "className": "Person",
        coords: [
            920.0,
            392.0,
            994.0,
            501.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:42.700000",
        "id": 1,
        "className": "Person",
        coords: [
            349.0,
            532.0,
            447.0,
            696.0
        ],
        "status": "Moving",
        "speed": 149.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:42.700000",
        "id": 10,
        "className": "Person",
        coords: [
            732.0,
            471.0,
            818.0,
            612.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:42.800000",
        "id": 8,
        "className": "Person",
        coords: [
            139.0,
            204.0,
            166.0,
            268.0
        ],
        "status": "Moving",
        "speed": 76.48,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:42.800000",
        "id": 5,
        "className": "Person",
        coords: [
            472.0,
            395.0,
            592.0,
            648.0
        ],
        "status": "Moving",
        "speed": 181.23,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:42.800000",
        "id": 9,
        "className": "Person",
        coords: [
            491.0,
            237.0,
            558.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:42.900000",
        "id": 2,
        "className": "Person",
        coords: [
            740.0,
            181.0,
            769.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:42.900000",
        "id": 6,
        "className": "Person",
        coords: [
            919.0,
            392.0,
            994.0,
            500.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:42.900000",
        "id": 10,
        "className": "Person",
        coords: [
            733.0,
            471.0,
            822.0,
            614.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:43",
        "id": 8,
        "className": "Person",
        coords: [
            137.0,
            200.0,
            167.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:43",
        "id": 5,
        "className": "Person",
        coords: [
            462.0,
            393.0,
            579.0,
            645.0
        ],
        "status": "Moving",
        "speed": 182.47,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:43",
        "id": 9,
        "className": "Person",
        coords: [
            491.0,
            237.0,
            558.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:43.100000",
        "id": 2,
        "className": "Person",
        coords: [
            740.0,
            181.0,
            769.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:43.100000",
        "id": 6,
        "className": "Person",
        coords: [
            924.0,
            392.0,
            989.0,
            481.0
        ],
        "status": "Moving",
        "speed": 149.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:43.100000",
        "id": 10,
        "className": "Person",
        coords: [
            730.0,
            471.0,
            820.0,
            614.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:43.100000",
        "id": 8,
        "className": "Person",
        coords: [
            135.0,
            196.0,
            166.0,
            268.0
        ],
        "status": "Moving",
        "speed": 42.42,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:43.200000",
        "id": 5,
        "className": "Person",
        coords: [
            451.0,
            391.0,
            565.0,
            641.0
        ],
        "status": "Moving",
        "speed": 185.52,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:43.200000",
        "id": 9,
        "className": "Person",
        coords: [
            491.0,
            237.0,
            558.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:43.300000",
        "id": 2,
        "className": "Person",
        coords: [
            739.0,
            181.0,
            769.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:43.300000",
        "id": 10,
        "className": "Person",
        coords: [
            727.0,
            470.0,
            818.0,
            610.0
        ],
        "status": "Moving",
        "speed": 54.08,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:43.300000",
        "id": 8,
        "className": "Person",
        coords: [
            134.0,
            197.0,
            165.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:43.300000",
        "id": 11,
        "className": "Person",
        coords: [
            172.0,
            184.0,
            211.0,
            287.0
        ],
        "status": "First Seen",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:15:43.400000",
        "id": 5,
        "className": "Person",
        coords: [
            441.0,
            389.0,
            552.0,
            639.0
        ],
        "status": "Moving",
        "speed": 182.47,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:43.400000",
        "id": 9,
        "className": "Person",
        coords: [
            491.0,
            237.0,
            558.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:43.400000",
        "id": 2,
        "className": "Person",
        coords: [
            739.0,
            181.0,
            770.0,
            275.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:43.400000",
        "id": 10,
        "className": "Person",
        coords: [
            726.0,
            469.0,
            820.0,
            612.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:43.400000",
        "id": 8,
        "className": "Person",
        coords: [
            134.0,
            201.0,
            164.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:43.500000",
        "id": 11,
        "className": "Person",
        coords: [
            173.0,
            186.0,
            211.0,
            288.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:15:43.500000",
        "id": 5,
        "className": "Person",
        coords: [
            434.0,
            390.0,
            544.0,
            638.0
        ],
        "status": "Moving",
        "speed": 104.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:43.600000",
        "id": 9,
        "className": "Person",
        coords: [
            491.0,
            237.0,
            558.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:43.600000",
        "id": 2,
        "className": "Person",
        coords: [
            739.0,
            181.0,
            770.0,
            275.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:43.600000",
        "id": 10,
        "className": "Person",
        coords: [
            725.0,
            469.0,
            821.0,
            611.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:43.700000",
        "id": 8,
        "className": "Person",
        coords: [
            133.0,
            205.0,
            163.0,
            268.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:43.700000",
        "id": 11,
        "className": "Person",
        coords: [
            173.0,
            185.0,
            212.0,
            288.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:15:43.700000",
        "id": 1,
        "className": "Person",
        coords: [
            343.0,
            533.0,
            452.0,
            715.0
        ],
        "status": "Moving",
        "speed": 150.74,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:43.800000",
        "id": 5,
        "className": "Person",
        coords: [
            431.0,
            391.0,
            540.0,
            638.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:43.800000",
        "id": 9,
        "className": "Person",
        coords: [
            492.0,
            237.0,
            558.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:43.800000",
        "id": 2,
        "className": "Person",
        coords: [
            739.0,
            181.0,
            770.0,
            275.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:43.900000",
        "id": 10,
        "className": "Person",
        coords: [
            725.0,
            468.0,
            822.0,
            611.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:43.900000",
        "id": 8,
        "className": "Person",
        coords: [
            132.0,
            205.0,
            163.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:43.900000",
        "id": 11,
        "className": "Person",
        coords: [
            174.0,
            184.0,
            212.0,
            284.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:15:44",
        "id": 5,
        "className": "Person",
        coords: [
            428.0,
            389.0,
            537.0,
            637.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:44",
        "id": 9,
        "className": "Person",
        coords: [
            493.0,
            237.0,
            558.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:44",
        "id": 2,
        "className": "Person",
        coords: [
            740.0,
            181.0,
            770.0,
            272.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:44",
        "id": 10,
        "className": "Person",
        coords: [
            723.0,
            468.0,
            822.0,
            609.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:44",
        "id": 8,
        "className": "Person",
        coords: [
            131.0,
            204.0,
            163.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:44.100000",
        "id": 11,
        "className": "Person",
        coords: [
            176.0,
            184.0,
            212.0,
            281.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:44.100000",
        "id": 5,
        "className": "Person",
        coords: [
            416.0,
            388.0,
            527.0,
            635.0
        ],
        "status": "Moving",
        "speed": 167.69,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:44.200000",
        "id": 9,
        "className": "Person",
        coords: [
            494.0,
            239.0,
            559.0,
            338.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:44.200000",
        "id": 2,
        "className": "Person",
        coords: [
            741.0,
            181.0,
            770.0,
            266.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:44.200000",
        "id": 10,
        "className": "Person",
        coords: [
            720.0,
            467.0,
            821.0,
            610.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:44.200000",
        "id": 8,
        "className": "Person",
        coords: [
            124.0,
            203.0,
            159.0,
            268.0
        ],
        "status": "Moving",
        "speed": 91.23,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:44.300000",
        "id": 11,
        "className": "Person",
        coords: [
            177.0,
            183.0,
            215.0,
            281.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:44.300000",
        "id": 5,
        "className": "Person",
        coords: [
            407.0,
            383.0,
            515.0,
            627.0
        ],
        "status": "Moving",
        "speed": 174.91,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:44.300000",
        "id": 9,
        "className": "Person",
        coords: [
            496.0,
            240.0,
            560.0,
            339.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:44.400000",
        "id": 2,
        "className": "Person",
        coords: [
            741.0,
            181.0,
            770.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:44.400000",
        "id": 10,
        "className": "Person",
        coords: [
            719.0,
            467.0,
            822.0,
            611.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:44.400000",
        "id": 8,
        "className": "Person",
        coords: [
            125.0,
            204.0,
            160.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:44.500000",
        "id": 11,
        "className": "Person",
        coords: [
            179.0,
            184.0,
            215.0,
            279.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:44.500000",
        "id": 5,
        "className": "Person",
        coords: [
            394.0,
            382.0,
            497.0,
            616.0
        ],
        "status": "Moving",
        "speed": 256.3,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:44.500000",
        "id": 9,
        "className": "Person",
        coords: [
            497.0,
            240.0,
            560.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:44.600000",
        "id": 2,
        "className": "Person",
        coords: [
            741.0,
            181.0,
            770.0,
            266.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:44.600000",
        "id": 10,
        "className": "Person",
        coords: [
            717.0,
            467.0,
            823.0,
            611.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:44.600000",
        "id": 8,
        "className": "Person",
        coords: [
            127.0,
            206.0,
            162.0,
            268.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:44.700000",
        "id": 5,
        "className": "Person",
        coords: [
            376.0,
            379.0,
            476.0,
            603.0
        ],
        "status": "Moving",
        "speed": 309.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:44.700000",
        "id": 9,
        "className": "Person",
        coords: [
            498.0,
            241.0,
            560.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:44.700000",
        "id": 2,
        "className": "Person",
        coords: [
            741.0,
            181.0,
            770.0,
            265.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:44.800000",
        "id": 10,
        "className": "Person",
        coords: [
            690.0,
            466.0,
            807.0,
            615.0
        ],
        "status": "Moving",
        "speed": 330.31,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:44.800000",
        "id": 8,
        "className": "Person",
        coords: [
            126.0,
            200.0,
            165.0,
            268.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:44.800000",
        "id": 1,
        "className": "Person",
        coords: [
            344.0,
            534.0,
            453.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:44.900000",
        "id": 5,
        "className": "Person",
        coords: [
            369.0,
            377.0,
            465.0,
            587.0
        ],
        "status": "Moving",
        "speed": 190.9,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:44.900000",
        "id": 9,
        "className": "Person",
        coords: [
            497.0,
            240.0,
            560.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:45",
        "id": 2,
        "className": "Person",
        coords: [
            741.0,
            181.0,
            771.0,
            266.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:45",
        "id": 10,
        "className": "Person",
        coords: [
            686.0,
            466.0,
            808.0,
            616.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:45",
        "id": 1,
        "className": "Person",
        coords: [
            348.0,
            535.0,
            449.0,
            700.0
        ],
        "status": "Moving",
        "speed": 119.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:45.100000",
        "id": 5,
        "className": "Person",
        coords: [
            360.0,
            374.0,
            458.0,
            581.0
        ],
        "status": "Moving",
        "speed": 141.5,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:45.100000",
        "id": 9,
        "className": "Person",
        coords: [
            496.0,
            240.0,
            559.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:45.100000",
        "id": 2,
        "className": "Person",
        coords: [
            741.0,
            181.0,
            771.0,
            265.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:45.200000",
        "id": 10,
        "className": "Person",
        coords: [
            680.0,
            465.0,
            802.0,
            608.0
        ],
        "status": "Moving",
        "speed": 117.14,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:45.200000",
        "id": 5,
        "className": "Person",
        coords: [
            353.0,
            370.0,
            454.0,
            577.0
        ],
        "status": "Moving",
        "speed": 108.16,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:45.300000",
        "id": 9,
        "className": "Person",
        coords: [
            494.0,
            239.0,
            559.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:45.300000",
        "id": 2,
        "className": "Person",
        coords: [
            741.0,
            181.0,
            771.0,
            265.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:45.400000",
        "id": 5,
        "className": "Person",
        coords: [
            349.0,
            365.0,
            449.0,
            568.0
        ],
        "status": "Moving",
        "speed": 120.92,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:45.400000",
        "id": 9,
        "className": "Person",
        coords: [
            495.0,
            239.0,
            559.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:45.400000",
        "id": 2,
        "className": "Person",
        coords: [
            741.0,
            181.0,
            771.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:45.500000",
        "id": 5,
        "className": "Person",
        coords: [
            346.0,
            363.0,
            443.0,
            554.0
        ],
        "status": "Moving",
        "speed": 141.5,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:45.500000",
        "id": 9,
        "className": "Person",
        coords: [
            496.0,
            239.0,
            559.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:45.600000",
        "id": 2,
        "className": "Person",
        coords: [
            741.0,
            181.0,
            772.0,
            265.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:45.600000",
        "id": 5,
        "className": "Person",
        coords: [
            347.0,
            360.0,
            449.0,
            554.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:45.600000",
        "id": 9,
        "className": "Person",
        coords: [
            496.0,
            239.0,
            560.0,
            341.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:45.700000",
        "id": 2,
        "className": "Person",
        coords: [
            741.0,
            181.0,
            772.0,
            265.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:45.700000",
        "id": 5,
        "className": "Person",
        coords: [
            348.0,
            359.0,
            453.0,
            552.0
        ],
        "status": "Moving",
        "speed": 42.42,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:45.700000",
        "id": 9,
        "className": "Person",
        coords: [
            497.0,
            239.0,
            560.0,
            341.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:45.800000",
        "id": 2,
        "className": "Person",
        coords: [
            741.0,
            181.0,
            772.0,
            265.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:45.800000",
        "id": 5,
        "className": "Person",
        coords: [
            338.0,
            358.0,
            439.0,
            545.0
        ],
        "status": "Moving",
        "speed": 189.72,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:45.800000",
        "id": 2,
        "className": "Person",
        coords: [
            741.0,
            181.0,
            772.0,
            265.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:45.900000",
        "id": 1,
        "className": "Person",
        coords: [
            345.0,
            537.0,
            454.0,
            717.0
        ],
        "status": "Moving",
        "speed": 150.74,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:45.900000",
        "id": 5,
        "className": "Person",
        coords: [
            326.0,
            355.0,
            439.0,
            567.0
        ],
        "status": "Moving",
        "speed": 174.91,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:46",
        "id": 2,
        "className": "Person",
        coords: [
            741.0,
            181.0,
            772.0,
            265.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:46",
        "id": 1,
        "className": "Person",
        coords: [
            345.0,
            537.0,
            454.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:46",
        "id": 8,
        "className": "Person",
        coords: [
            114.0,
            194.0,
            160.0,
            270.0
        ],
        "status": "Moving",
        "speed": 123.68,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:46.100000",
        "id": 5,
        "className": "Person",
        coords: [
            319.0,
            350.0,
            437.0,
            576.0
        ],
        "status": "Moving",
        "speed": 67.08,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:46.200000",
        "id": 2,
        "className": "Person",
        coords: [
            740.0,
            181.0,
            773.0,
            273.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:46.200000",
        "id": 1,
        "className": "Person",
        coords: [
            345.0,
            537.0,
            454.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:46.200000",
        "id": 8,
        "className": "Person",
        coords: [
            112.0,
            195.0,
            161.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:46.300000",
        "id": 5,
        "className": "Person",
        coords: [
            318.0,
            345.0,
            434.0,
            573.0
        ],
        "status": "Moving",
        "speed": 67.08,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:46.300000",
        "id": 2,
        "className": "Person",
        coords: [
            739.0,
            181.0,
            774.0,
            276.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:46.300000",
        "id": 1,
        "className": "Person",
        coords: [
            345.0,
            537.0,
            454.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:46.300000",
        "id": 8,
        "className": "Person",
        coords: [
            110.0,
            195.0,
            162.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:46.400000",
        "id": 5,
        "className": "Person",
        coords: [
            315.0,
            341.0,
            431.0,
            576.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:46.400000",
        "id": 2,
        "className": "Person",
        coords: [
            739.0,
            181.0,
            775.0,
            280.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:46.500000",
        "id": 1,
        "className": "Person",
        coords: [
            345.0,
            537.0,
            454.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:46.500000",
        "id": 8,
        "className": "Person",
        coords: [
            109.0,
            195.0,
            163.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:46.500000",
        "id": 11,
        "className": "Person",
        coords: [
            197.0,
            200.0,
            226.0,
            275.0
        ],
        "status": "Moving",
        "speed": 228.45,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:46.600000",
        "id": 5,
        "className": "Person",
        coords: [
            313.0,
            340.0,
            430.0,
            581.0
        ],
        "status": "Moving",
        "speed": 42.42,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:46.600000",
        "id": 2,
        "className": "Person",
        coords: [
            739.0,
            181.0,
            775.0,
            282.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:46.600000",
        "id": 1,
        "className": "Person",
        coords: [
            345.0,
            537.0,
            454.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:46.700000",
        "id": 8,
        "className": "Person",
        coords: [
            108.0,
            196.0,
            164.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:46.700000",
        "id": 11,
        "className": "Person",
        coords: [
            197.0,
            200.0,
            226.0,
            275.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:46.800000",
        "id": 5,
        "className": "Person",
        coords: [
            314.0,
            339.0,
            428.0,
            583.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:46.800000",
        "id": 2,
        "className": "Person",
        coords: [
            739.0,
            181.0,
            775.0,
            282.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:46.800000",
        "id": 1,
        "className": "Person",
        coords: [
            345.0,
            537.0,
            454.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:46.900000",
        "id": 8,
        "className": "Person",
        coords: [
            108.0,
            196.0,
            164.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:46.900000",
        "id": 11,
        "className": "Person",
        coords: [
            198.0,
            200.0,
            227.0,
            275.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:46.900000",
        "id": 9,
        "className": "Person",
        coords: [
            499.0,
            241.0,
            559.0,
            336.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:47",
        "id": 5,
        "className": "Person",
        coords: [
            313.0,
            340.0,
            420.0,
            574.0
        ],
        "status": "Moving",
        "speed": 96.04,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:47",
        "id": 2,
        "className": "Person",
        coords: [
            739.0,
            181.0,
            775.0,
            282.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:47",
        "id": 1,
        "className": "Person",
        coords: [
            345.0,
            537.0,
            454.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:47.100000",
        "id": 8,
        "className": "Person",
        coords: [
            107.0,
            196.0,
            165.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:47.100000",
        "id": 11,
        "className": "Person",
        coords: [
            197.0,
            200.0,
            227.0,
            276.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:47.100000",
        "id": 9,
        "className": "Person",
        coords: [
            498.0,
            240.0,
            559.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:47.200000",
        "id": 5,
        "className": "Person",
        coords: [
            314.0,
            342.0,
            411.0,
            557.0
        ],
        "status": "Moving",
        "speed": 134.15,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:47.200000",
        "id": 2,
        "className": "Person",
        coords: [
            739.0,
            181.0,
            775.0,
            282.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:47.200000",
        "id": 1,
        "className": "Person",
        coords: [
            345.0,
            538.0,
            454.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:47.200000",
        "id": 8,
        "className": "Person",
        coords: [
            106.0,
            197.0,
            165.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:47.300000",
        "id": 11,
        "className": "Person",
        coords: [
            197.0,
            200.0,
            227.0,
            276.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:47.300000",
        "id": 9,
        "className": "Person",
        coords: [
            498.0,
            240.0,
            559.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:47.400000",
        "id": 5,
        "className": "Person",
        coords: [
            312.0,
            338.0,
            408.0,
            552.0
        ],
        "status": "Moving",
        "speed": 67.08,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:47.400000",
        "id": 2,
        "className": "Person",
        coords: [
            739.0,
            182.0,
            775.0,
            282.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:47.400000",
        "id": 1,
        "className": "Person",
        coords: [
            346.0,
            538.0,
            454.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:47.400000",
        "id": 8,
        "className": "Person",
        coords: [
            106.0,
            198.0,
            165.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:47.500000",
        "id": 11,
        "className": "Person",
        coords: [
            197.0,
            200.0,
            227.0,
            276.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:47.500000",
        "id": 9,
        "className": "Person",
        coords: [
            498.0,
            240.0,
            559.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:47.600000",
        "id": 5,
        "className": "Person",
        coords: [
            306.0,
            336.0,
            400.0,
            546.0
        ],
        "status": "Moving",
        "speed": 120.92,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:47.600000",
        "id": 2,
        "className": "Person",
        coords: [
            740.0,
            182.0,
            775.0,
            282.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:47.600000",
        "id": 1,
        "className": "Person",
        coords: [
            345.0,
            538.0,
            454.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:47.600000",
        "id": 8,
        "className": "Person",
        coords: [
            106.0,
            198.0,
            166.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:47.700000",
        "id": 11,
        "className": "Person",
        coords: [
            197.0,
            200.0,
            227.0,
            276.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:47.700000",
        "id": 9,
        "className": "Person",
        coords: [
            499.0,
            240.0,
            559.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:47.700000",
        "id": 5,
        "className": "Person",
        coords: [
            300.0,
            333.0,
            397.0,
            554.0
        ],
        "status": "Moving",
        "speed": 80.77,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:47.700000",
        "id": 2,
        "className": "Person",
        coords: [
            740.0,
            182.0,
            775.0,
            282.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:47.800000",
        "id": 1,
        "className": "Person",
        coords: [
            346.0,
            538.0,
            454.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:47.800000",
        "id": 8,
        "className": "Person",
        coords: [
            105.0,
            198.0,
            166.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:47.800000",
        "id": 11,
        "className": "Person",
        coords: [
            196.0,
            200.0,
            226.0,
            275.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:47.800000",
        "id": 9,
        "className": "Person",
        coords: [
            498.0,
            241.0,
            558.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:47.900000",
        "id": 5,
        "className": "Person",
        coords: [
            295.0,
            329.0,
            397.0,
            565.0
        ],
        "status": "Moving",
        "speed": 67.08,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:47.900000",
        "id": 2,
        "className": "Person",
        coords: [
            740.0,
            182.0,
            775.0,
            282.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:48",
        "id": 1,
        "className": "Person",
        coords: [
            346.0,
            538.0,
            454.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:48",
        "id": 8,
        "className": "Person",
        coords: [
            105.0,
            198.0,
            166.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:48",
        "id": 11,
        "className": "Person",
        coords: [
            196.0,
            200.0,
            226.0,
            275.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:48",
        "id": 9,
        "className": "Person",
        coords: [
            498.0,
            241.0,
            558.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:48.100000",
        "id": 5,
        "className": "Person",
        coords: [
            294.0,
            325.0,
            389.0,
            544.0
        ],
        "status": "Moving",
        "speed": 208.91,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:48.100000",
        "id": 2,
        "className": "Person",
        coords: [
            740.0,
            181.0,
            775.0,
            282.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:48.100000",
        "id": 1,
        "className": "Person",
        coords: [
            346.0,
            538.0,
            454.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:48.200000",
        "id": 8,
        "className": "Person",
        coords: [
            105.0,
            198.0,
            167.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:48.200000",
        "id": 11,
        "className": "Person",
        coords: [
            196.0,
            200.0,
            226.0,
            275.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:48.300000",
        "id": 5,
        "className": "Person",
        coords: [
            299.0,
            322.0,
            375.0,
            491.0
        ],
        "status": "Moving",
        "speed": 424.23,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:48.300000",
        "id": 2,
        "className": "Person",
        coords: [
            740.0,
            181.0,
            775.0,
            282.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:48.300000",
        "id": 1,
        "className": "Person",
        coords: [
            346.0,
            537.0,
            454.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:48.400000",
        "id": 8,
        "className": "Person",
        coords: [
            104.0,
            198.0,
            167.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:48.400000",
        "id": 11,
        "className": "Person",
        coords: [
            195.0,
            200.0,
            226.0,
            275.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:48.500000",
        "id": 5,
        "className": "Person",
        coords: [
            299.0,
            321.0,
            367.0,
            466.0
        ],
        "status": "Moving",
        "speed": 204.01,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:48.500000",
        "id": 2,
        "className": "Person",
        coords: [
            740.0,
            181.0,
            775.0,
            282.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:48.500000",
        "id": 1,
        "className": "Person",
        coords: [
            346.0,
            538.0,
            454.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:48.500000",
        "id": 8,
        "className": "Person",
        coords: [
            104.0,
            198.0,
            168.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:48.500000",
        "id": 11,
        "className": "Person",
        coords: [
            195.0,
            200.0,
            226.0,
            275.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:48.600000",
        "id": 5,
        "className": "Person",
        coords: [
            298.0,
            319.0,
            364.0,
            458.0
        ],
        "status": "Moving",
        "speed": 80.77,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:48.600000",
        "id": 2,
        "className": "Person",
        coords: [
            740.0,
            181.0,
            774.0,
            281.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:48.700000",
        "id": 1,
        "className": "Person",
        coords: [
            346.0,
            538.0,
            454.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:48.700000",
        "id": 8,
        "className": "Person",
        coords: [
            104.0,
            197.0,
            168.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:48.800000",
        "id": 11,
        "className": "Person",
        coords: [
            195.0,
            200.0,
            227.0,
            275.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:48.800000",
        "id": 5,
        "className": "Person",
        coords: [
            295.0,
            314.0,
            363.0,
            457.0
        ],
        "status": "Moving",
        "speed": 54.08,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:48.900000",
        "id": 2,
        "className": "Person",
        coords: [
            740.0,
            181.0,
            774.0,
            281.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:48.900000",
        "id": 1,
        "className": "Person",
        coords: [
            346.0,
            538.0,
            454.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:48.900000",
        "id": 8,
        "className": "Person",
        coords: [
            104.0,
            196.0,
            169.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:49",
        "id": 11,
        "className": "Person",
        coords: [
            194.0,
            200.0,
            226.0,
            276.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:49",
        "id": 5,
        "className": "Person",
        coords: [
            293.0,
            312.0,
            362.0,
            453.0
        ],
        "status": "Moving",
        "speed": 54.08,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:49",
        "id": 2,
        "className": "Person",
        coords: [
            740.0,
            181.0,
            774.0,
            281.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:49.100000",
        "id": 8,
        "className": "Person",
        coords: [
            104.0,
            196.0,
            169.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:49.100000",
        "id": 11,
        "className": "Person",
        coords: [
            194.0,
            200.0,
            225.0,
            276.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:49.600000",
        "id": 9,
        "className": "Person",
        coords: [
            497.0,
            236.0,
            564.0,
            344.0
        ],
        "status": "Moving",
        "speed": 54.08,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:49.600000",
        "id": 1,
        "className": "Person",
        coords: [
            320.0,
            530.0,
            439.0,
            718.0
        ],
        "status": "Moving",
        "speed": 320.64,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:49.600000",
        "id": 2,
        "className": "Person",
        coords: [
            751.0,
            189.0,
            784.0,
            285.0
        ],
        "status": "Moving",
        "speed": 174.91,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:49.600000",
        "id": 9,
        "className": "Person",
        coords: [
            496.0,
            235.0,
            562.0,
            344.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:49.700000",
        "id": 1,
        "className": "Person",
        coords: [
            317.0,
            530.0,
            441.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:49.700000",
        "id": 2,
        "className": "Person",
        coords: [
            751.0,
            189.0,
            785.0,
            285.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:49.700000",
        "id": 9,
        "className": "Person",
        coords: [
            499.0,
            236.0,
            563.0,
            344.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:49.800000",
        "id": 1,
        "className": "Person",
        coords: [
            315.0,
            530.0,
            443.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:49.800000",
        "id": 2,
        "className": "Person",
        coords: [
            751.0,
            189.0,
            785.0,
            285.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:49.900000",
        "id": 9,
        "className": "Person",
        coords: [
            500.0,
            236.0,
            562.0,
            344.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:49.900000",
        "id": 1,
        "className": "Person",
        coords: [
            314.0,
            529.0,
            444.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:49.900000",
        "id": 2,
        "className": "Person",
        coords: [
            751.0,
            189.0,
            785.0,
            285.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:50",
        "id": 9,
        "className": "Person",
        coords: [
            500.0,
            236.0,
            562.0,
            344.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:50",
        "id": 1,
        "className": "Person",
        coords: [
            313.0,
            530.0,
            445.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:50",
        "id": 2,
        "className": "Person",
        coords: [
            751.0,
            189.0,
            785.0,
            285.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:50.100000",
        "id": 9,
        "className": "Person",
        coords: [
            501.0,
            235.0,
            562.0,
            344.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:50.100000",
        "id": 1,
        "className": "Person",
        coords: [
            312.0,
            530.0,
            446.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:50.200000",
        "id": 2,
        "className": "Person",
        coords: [
            751.0,
            189.0,
            785.0,
            285.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:50.200000",
        "id": 9,
        "className": "Person",
        coords: [
            503.0,
            235.0,
            563.0,
            344.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:50.300000",
        "id": 1,
        "className": "Person",
        coords: [
            312.0,
            530.0,
            446.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:50.300000",
        "id": 2,
        "className": "Person",
        coords: [
            751.0,
            189.0,
            785.0,
            285.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:50.300000",
        "id": 9,
        "className": "Person",
        coords: [
            504.0,
            236.0,
            563.0,
            344.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:50.400000",
        "id": 1,
        "className": "Person",
        coords: [
            311.0,
            530.0,
            447.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:50.400000",
        "id": 2,
        "className": "Person",
        coords: [
            751.0,
            189.0,
            785.0,
            285.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:50.400000",
        "id": 9,
        "className": "Person",
        coords: [
            505.0,
            236.0,
            563.0,
            344.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:50.500000",
        "id": 1,
        "className": "Person",
        coords: [
            310.0,
            530.0,
            448.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:50.500000",
        "id": 2,
        "className": "Person",
        coords: [
            750.0,
            189.0,
            785.0,
            285.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:50.500000",
        "id": 9,
        "className": "Person",
        coords: [
            506.0,
            236.0,
            563.0,
            344.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:50.600000",
        "id": 1,
        "className": "Person",
        coords: [
            310.0,
            530.0,
            448.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:50.600000",
        "id": 2,
        "className": "Person",
        coords: [
            750.0,
            189.0,
            785.0,
            284.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:50.600000",
        "id": 9,
        "className": "Person",
        coords: [
            506.0,
            236.0,
            562.0,
            344.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:50.700000",
        "id": 1,
        "className": "Person",
        coords: [
            310.0,
            530.0,
            448.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:50.700000",
        "id": 2,
        "className": "Person",
        coords: [
            750.0,
            188.0,
            784.0,
            284.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:50.800000",
        "id": 9,
        "className": "Person",
        coords: [
            507.0,
            236.0,
            562.0,
            344.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:50.800000",
        "id": 1,
        "className": "Person",
        coords: [
            309.0,
            530.0,
            449.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:50.800000",
        "id": 2,
        "className": "Person",
        coords: [
            749.0,
            188.0,
            782.0,
            283.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:50.900000",
        "id": 9,
        "className": "Person",
        coords: [
            507.0,
            236.0,
            562.0,
            344.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:50.900000",
        "id": 1,
        "className": "Person",
        coords: [
            309.0,
            530.0,
            449.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:50.900000",
        "id": 2,
        "className": "Person",
        coords: [
            748.0,
            188.0,
            781.0,
            283.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:51",
        "id": 9,
        "className": "Person",
        coords: [
            508.0,
            236.0,
            562.0,
            344.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:51",
        "id": 1,
        "className": "Person",
        coords: [
            309.0,
            530.0,
            449.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:51.100000",
        "id": 2,
        "className": "Person",
        coords: [
            748.0,
            188.0,
            781.0,
            283.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:51.100000",
        "id": 11,
        "className": "Person",
        coords: [
            191.0,
            193.0,
            226.0,
            285.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:51.100000",
        "id": 9,
        "className": "Person",
        coords: [
            508.0,
            236.0,
            562.0,
            344.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:51.200000",
        "id": 1,
        "className": "Person",
        coords: [
            309.0,
            530.0,
            449.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:51.200000",
        "id": 2,
        "className": "Person",
        coords: [
            746.0,
            185.0,
            779.0,
            283.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:51.200000",
        "id": 11,
        "className": "Person",
        coords: [
            192.0,
            192.0,
            226.0,
            285.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:51.200000",
        "id": 9,
        "className": "Person",
        coords: [
            510.0,
            237.0,
            562.0,
            344.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:51.300000",
        "id": 1,
        "className": "Person",
        coords: [
            309.0,
            530.0,
            450.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:51.300000",
        "id": 2,
        "className": "Person",
        coords: [
            745.0,
            185.0,
            777.0,
            282.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:51.400000",
        "id": 9,
        "className": "Person",
        coords: [
            511.0,
            238.0,
            562.0,
            342.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:51.400000",
        "id": 1,
        "className": "Person",
        coords: [
            309.0,
            530.0,
            450.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:51.400000",
        "id": 2,
        "className": "Person",
        coords: [
            744.0,
            184.0,
            777.0,
            283.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:51.500000",
        "id": 9,
        "className": "Person",
        coords: [
            511.0,
            238.0,
            562.0,
            342.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:51.500000",
        "id": 1,
        "className": "Person",
        coords: [
            308.0,
            530.0,
            450.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:51.500000",
        "id": 2,
        "className": "Person",
        coords: [
            743.0,
            182.0,
            776.0,
            284.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:51.600000",
        "id": 9,
        "className": "Person",
        coords: [
            511.0,
            238.0,
            562.0,
            342.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:51.600000",
        "id": 1,
        "className": "Person",
        coords: [
            308.0,
            530.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:51.600000",
        "id": 2,
        "className": "Person",
        coords: [
            743.0,
            182.0,
            775.0,
            283.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:51.700000",
        "id": 9,
        "className": "Person",
        coords: [
            512.0,
            238.0,
            561.0,
            342.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:51.700000",
        "id": 1,
        "className": "Person",
        coords: [
            308.0,
            530.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:51.700000",
        "id": 2,
        "className": "Person",
        coords: [
            743.0,
            182.0,
            774.0,
            278.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:51.800000",
        "id": 9,
        "className": "Person",
        coords: [
            512.0,
            238.0,
            561.0,
            342.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:51.800000",
        "id": 1,
        "className": "Person",
        coords: [
            308.0,
            530.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:51.900000",
        "id": 2,
        "className": "Person",
        coords: [
            742.0,
            182.0,
            773.0,
            278.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:52",
        "id": 9,
        "className": "Person",
        coords: [
            512.0,
            238.0,
            562.0,
            342.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:52",
        "id": 1,
        "className": "Person",
        coords: [
            308.0,
            530.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:52",
        "id": 2,
        "className": "Person",
        coords: [
            742.0,
            182.0,
            772.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:52.100000",
        "id": 9,
        "className": "Person",
        coords: [
            513.0,
            238.0,
            562.0,
            342.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:52.100000",
        "id": 1,
        "className": "Person",
        coords: [
            308.0,
            530.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:52.100000",
        "id": 2,
        "className": "Person",
        coords: [
            741.0,
            182.0,
            770.0,
            270.0
        ],
        "status": "Moving",
        "speed": 42.42,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:52.200000",
        "id": 9,
        "className": "Person",
        coords: [
            512.0,
            238.0,
            561.0,
            342.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:52.200000",
        "id": 1,
        "className": "Person",
        coords: [
            308.0,
            530.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:52.200000",
        "id": 2,
        "className": "Person",
        coords: [
            739.0,
            182.0,
            768.0,
            267.0
        ],
        "status": "Moving",
        "speed": 42.42,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:52.300000",
        "id": 9,
        "className": "Person",
        coords: [
            512.0,
            238.0,
            561.0,
            341.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:52.300000",
        "id": 1,
        "className": "Person",
        coords: [
            308.0,
            530.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:52.300000",
        "id": 2,
        "className": "Person",
        coords: [
            737.0,
            182.0,
            766.0,
            265.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:52.400000",
        "id": 9,
        "className": "Person",
        coords: [
            512.0,
            237.0,
            560.0,
            341.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:52.400000",
        "id": 1,
        "className": "Person",
        coords: [
            308.0,
            530.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:52.500000",
        "id": 2,
        "className": "Person",
        coords: [
            737.0,
            182.0,
            766.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:52.500000",
        "id": 9,
        "className": "Person",
        coords: [
            511.0,
            237.0,
            560.0,
            342.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:52.500000",
        "id": 1,
        "className": "Person",
        coords: [
            309.0,
            530.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:52.600000",
        "id": 2,
        "className": "Person",
        coords: [
            736.0,
            182.0,
            763.0,
            260.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:52.600000",
        "id": 9,
        "className": "Person",
        coords: [
            511.0,
            237.0,
            560.0,
            342.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:52.700000",
        "id": 1,
        "className": "Person",
        coords: [
            309.0,
            529.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:52.700000",
        "id": 2,
        "className": "Person",
        coords: [
            734.0,
            181.0,
            761.0,
            259.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:52.700000",
        "id": 9,
        "className": "Person",
        coords: [
            510.0,
            237.0,
            559.0,
            342.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:52.800000",
        "id": 1,
        "className": "Person",
        coords: [
            308.0,
            529.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:52.800000",
        "id": 2,
        "className": "Person",
        coords: [
            733.0,
            181.0,
            759.0,
            255.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:52.800000",
        "id": 9,
        "className": "Person",
        coords: [
            510.0,
            237.0,
            559.0,
            341.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:52.900000",
        "id": 1,
        "className": "Person",
        coords: [
            308.0,
            529.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:52.900000",
        "id": 2,
        "className": "Person",
        coords: [
            732.0,
            181.0,
            758.0,
            256.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:53",
        "id": 9,
        "className": "Person",
        coords: [
            509.0,
            236.0,
            559.0,
            342.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:53",
        "id": 1,
        "className": "Person",
        coords: [
            308.0,
            529.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:53",
        "id": 2,
        "className": "Person",
        coords: [
            730.0,
            181.0,
            757.0,
            257.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:53.100000",
        "id": 9,
        "className": "Person",
        coords: [
            509.0,
            236.0,
            559.0,
            342.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:53.100000",
        "id": 1,
        "className": "Person",
        coords: [
            308.0,
            528.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:53.100000",
        "id": 2,
        "className": "Person",
        coords: [
            729.0,
            181.0,
            756.0,
            257.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:53.200000",
        "id": 9,
        "className": "Person",
        coords: [
            509.0,
            236.0,
            559.0,
            342.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:53.200000",
        "id": 1,
        "className": "Person",
        coords: [
            308.0,
            528.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:53.200000",
        "id": 2,
        "className": "Person",
        coords: [
            727.0,
            181.0,
            756.0,
            260.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:53.300000",
        "id": 9,
        "className": "Person",
        coords: [
            509.0,
            236.0,
            560.0,
            342.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:53.400000",
        "id": 1,
        "className": "Person",
        coords: [
            308.0,
            528.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:53.400000",
        "id": 2,
        "className": "Person",
        coords: [
            729.0,
            180.0,
            753.0,
            242.0
        ],
        "status": "Moving",
        "speed": 134.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:53.500000",
        "id": 9,
        "className": "Person",
        coords: [
            509.0,
            236.0,
            559.0,
            342.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:53.500000",
        "id": 1,
        "className": "Person",
        coords: [
            308.0,
            528.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:53.500000",
        "id": 2,
        "className": "Person",
        coords: [
            730.0,
            180.0,
            751.0,
            232.0
        ],
        "status": "Moving",
        "speed": 76.48,
        "hardhat": "No",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:53.600000",
        "id": 9,
        "className": "Person",
        coords: [
            510.0,
            236.0,
            560.0,
            342.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:53.600000",
        "id": 1,
        "className": "Person",
        coords: [
            309.0,
            528.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:53.700000",
        "id": 9,
        "className": "Person",
        coords: [
            510.0,
            236.0,
            560.0,
            342.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:53.700000",
        "id": 1,
        "className": "Person",
        coords: [
            309.0,
            528.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:53.800000",
        "id": 9,
        "className": "Person",
        coords: [
            509.0,
            236.0,
            560.0,
            342.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:53.900000",
        "id": 1,
        "className": "Person",
        coords: [
            309.0,
            529.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:53.900000",
        "id": 9,
        "className": "Person",
        coords: [
            508.0,
            236.0,
            559.0,
            342.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:53.900000",
        "id": 1,
        "className": "Person",
        coords: [
            311.0,
            529.0,
            453.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:54",
        "id": 9,
        "className": "Person",
        coords: [
            508.0,
            236.0,
            559.0,
            341.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:54",
        "id": 1,
        "className": "Person",
        coords: [
            313.0,
            530.0,
            454.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:54.100000",
        "id": 9,
        "className": "Person",
        coords: [
            508.0,
            236.0,
            558.0,
            341.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:54.100000",
        "id": 1,
        "className": "Person",
        coords: [
            313.0,
            530.0,
            454.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:54.200000",
        "id": 9,
        "className": "Person",
        coords: [
            508.0,
            236.0,
            559.0,
            341.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:54.200000",
        "id": 1,
        "className": "Person",
        coords: [
            318.0,
            530.0,
            457.0,
            718.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:54.300000",
        "id": 11,
        "className": "Person",
        coords: [
            194.0,
            193.0,
            228.0,
            283.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:54.300000",
        "id": 9,
        "className": "Person",
        coords: [
            508.0,
            235.0,
            559.0,
            341.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:54.400000",
        "id": 1,
        "className": "Person",
        coords: [
            325.0,
            530.0,
            463.0,
            718.0
        ],
        "status": "Moving",
        "speed": 104.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:54.400000",
        "id": 11,
        "className": "Person",
        coords: [
            194.0,
            193.0,
            228.0,
            284.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:54.500000",
        "id": 9,
        "className": "Person",
        coords: [
            507.0,
            234.0,
            559.0,
            341.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:54.500000",
        "id": 1,
        "className": "Person",
        coords: [
            329.0,
            530.0,
            464.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:54.500000",
        "id": 11,
        "className": "Person",
        coords: [
            194.0,
            193.0,
            229.0,
            284.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:54.600000",
        "id": 9,
        "className": "Person",
        coords: [
            507.0,
            234.0,
            559.0,
            341.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:54.600000",
        "id": 1,
        "className": "Person",
        coords: [
            331.0,
            530.0,
            464.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:54.700000",
        "id": 9,
        "className": "Person",
        coords: [
            505.0,
            234.0,
            557.0,
            337.0
        ],
        "status": "Moving",
        "speed": 42.42,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:54.700000",
        "id": 1,
        "className": "Person",
        coords: [
            331.0,
            531.0,
            462.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:54.700000",
        "id": 9,
        "className": "Person",
        coords: [
            505.0,
            234.0,
            557.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:54.800000",
        "id": 1,
        "className": "Person",
        coords: [
            332.0,
            531.0,
            461.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:54.800000",
        "id": 9,
        "className": "Person",
        coords: [
            504.0,
            234.0,
            557.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:54.800000",
        "id": 1,
        "className": "Person",
        coords: [
            332.0,
            532.0,
            460.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:54.900000",
        "id": 9,
        "className": "Person",
        coords: [
            504.0,
            234.0,
            557.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:54.900000",
        "id": 1,
        "className": "Person",
        coords: [
            333.0,
            532.0,
            460.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:55",
        "id": 9,
        "className": "Person",
        coords: [
            504.0,
            234.0,
            558.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:55",
        "id": 1,
        "className": "Person",
        coords: [
            334.0,
            533.0,
            460.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:55.100000",
        "id": 9,
        "className": "Person",
        coords: [
            503.0,
            235.0,
            558.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:55.100000",
        "id": 1,
        "className": "Person",
        coords: [
            335.0,
            533.0,
            459.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:55.100000",
        "id": 9,
        "className": "Person",
        coords: [
            503.0,
            235.0,
            559.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:55.200000",
        "id": 1,
        "className": "Person",
        coords: [
            335.0,
            533.0,
            459.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:55.200000",
        "id": 9,
        "className": "Person",
        coords: [
            504.0,
            235.0,
            559.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:55.200000",
        "id": 1,
        "className": "Person",
        coords: [
            339.0,
            532.0,
            462.0,
            718.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:55.300000",
        "id": 9,
        "className": "Person",
        coords: [
            504.0,
            235.0,
            560.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:55.300000",
        "id": 1,
        "className": "Person",
        coords: [
            342.0,
            533.0,
            462.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:55.400000",
        "id": 9,
        "className": "Person",
        coords: [
            503.0,
            234.0,
            560.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:55.400000",
        "id": 1,
        "className": "Person",
        coords: [
            343.0,
            533.0,
            462.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:55.500000",
        "id": 9,
        "className": "Person",
        coords: [
            504.0,
            235.0,
            560.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:55.500000",
        "id": 1,
        "className": "Person",
        coords: [
            344.0,
            533.0,
            461.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:55.600000",
        "id": 9,
        "className": "Person",
        coords: [
            503.0,
            235.0,
            560.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:55.600000",
        "id": 1,
        "className": "Person",
        coords: [
            344.0,
            533.0,
            461.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:55.600000",
        "id": 9,
        "className": "Person",
        coords: [
            503.0,
            235.0,
            559.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:55.700000",
        "id": 1,
        "className": "Person",
        coords: [
            345.0,
            533.0,
            460.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:55.700000",
        "id": 9,
        "className": "Person",
        coords: [
            503.0,
            236.0,
            560.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:55.800000",
        "id": 1,
        "className": "Person",
        coords: [
            345.0,
            533.0,
            459.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:55.800000",
        "id": 9,
        "className": "Person",
        coords: [
            503.0,
            236.0,
            560.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:55.800000",
        "id": 1,
        "className": "Person",
        coords: [
            345.0,
            533.0,
            459.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:55.900000",
        "id": 9,
        "className": "Person",
        coords: [
            501.0,
            236.0,
            559.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:55.900000",
        "id": 1,
        "className": "Person",
        coords: [
            345.0,
            533.0,
            458.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:56",
        "id": 9,
        "className": "Person",
        coords: [
            501.0,
            235.0,
            560.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:56",
        "id": 1,
        "className": "Person",
        coords: [
            346.0,
            533.0,
            458.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:56",
        "id": 9,
        "className": "Person",
        coords: [
            501.0,
            235.0,
            560.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:56.100000",
        "id": 1,
        "className": "Person",
        coords: [
            344.0,
            533.0,
            456.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:56.100000",
        "id": 9,
        "className": "Person",
        coords: [
            506.0,
            236.0,
            564.0,
            335.0
        ],
        "status": "Moving",
        "speed": 74.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:56.200000",
        "id": 1,
        "className": "Person",
        coords: [
            344.0,
            533.0,
            456.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:56.200000",
        "id": 9,
        "className": "Person",
        coords: [
            507.0,
            236.0,
            565.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:56.200000",
        "id": 1,
        "className": "Person",
        coords: [
            346.0,
            533.0,
            457.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:56.300000",
        "id": 9,
        "className": "Person",
        coords: [
            508.0,
            237.0,
            566.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:56.400000",
        "id": 1,
        "className": "Person",
        coords: [
            347.0,
            534.0,
            457.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:56.400000",
        "id": 9,
        "className": "Person",
        coords: [
            508.0,
            238.0,
            566.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:56.400000",
        "id": 1,
        "className": "Person",
        coords: [
            347.0,
            534.0,
            457.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:56.500000",
        "id": 9,
        "className": "Person",
        coords: [
            509.0,
            238.0,
            565.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:56.500000",
        "id": 1,
        "className": "Person",
        coords: [
            348.0,
            534.0,
            456.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:56.600000",
        "id": 9,
        "className": "Person",
        coords: [
            508.0,
            237.0,
            565.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:56.600000",
        "id": 1,
        "className": "Person",
        coords: [
            348.0,
            534.0,
            456.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:56.600000",
        "id": 9,
        "className": "Person",
        coords: [
            508.0,
            238.0,
            564.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:56.700000",
        "id": 1,
        "className": "Person",
        coords: [
            348.0,
            534.0,
            456.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:56.700000",
        "id": 9,
        "className": "Person",
        coords: [
            505.0,
            238.0,
            563.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:56.800000",
        "id": 1,
        "className": "Person",
        coords: [
            348.0,
            535.0,
            455.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:56.800000",
        "id": 9,
        "className": "Person",
        coords: [
            507.0,
            238.0,
            564.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:56.900000",
        "id": 1,
        "className": "Person",
        coords: [
            348.0,
            535.0,
            455.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:56.900000",
        "id": 9,
        "className": "Person",
        coords: [
            507.0,
            238.0,
            564.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:57",
        "id": 1,
        "className": "Person",
        coords: [
            348.0,
            535.0,
            455.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:57",
        "id": 9,
        "className": "Person",
        coords: [
            508.0,
            238.0,
            565.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:57",
        "id": 1,
        "className": "Person",
        coords: [
            348.0,
            535.0,
            455.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:57.100000",
        "id": 9,
        "className": "Person",
        coords: [
            508.0,
            238.0,
            565.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:57.100000",
        "id": 1,
        "className": "Person",
        coords: [
            348.0,
            535.0,
            455.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:57.100000",
        "id": 9,
        "className": "Person",
        coords: [
            509.0,
            238.0,
            565.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:57.200000",
        "id": 1,
        "className": "Person",
        coords: [
            348.0,
            535.0,
            454.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:57.200000",
        "id": 9,
        "className": "Person",
        coords: [
            509.0,
            237.0,
            566.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:57.200000",
        "id": 1,
        "className": "Person",
        coords: [
            347.0,
            535.0,
            454.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:57.300000",
        "id": 9,
        "className": "Person",
        coords: [
            509.0,
            237.0,
            565.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:57.300000",
        "id": 1,
        "className": "Person",
        coords: [
            347.0,
            535.0,
            454.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:57.400000",
        "id": 9,
        "className": "Person",
        coords: [
            509.0,
            238.0,
            565.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:57.400000",
        "id": 1,
        "className": "Person",
        coords: [
            347.0,
            535.0,
            454.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:57.500000",
        "id": 9,
        "className": "Person",
        coords: [
            509.0,
            238.0,
            565.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:57.500000",
        "id": 1,
        "className": "Person",
        coords: [
            347.0,
            535.0,
            454.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:57.600000",
        "id": 9,
        "className": "Person",
        coords: [
            509.0,
            238.0,
            565.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:57.600000",
        "id": 1,
        "className": "Person",
        coords: [
            347.0,
            535.0,
            454.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:57.700000",
        "id": 9,
        "className": "Person",
        coords: [
            509.0,
            238.0,
            565.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:57.700000",
        "id": 1,
        "className": "Person",
        coords: [
            348.0,
            535.0,
            454.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:57.800000",
        "id": 9,
        "className": "Person",
        coords: [
            510.0,
            238.0,
            565.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:57.800000",
        "id": 1,
        "className": "Person",
        coords: [
            348.0,
            535.0,
            454.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:57.900000",
        "id": 9,
        "className": "Person",
        coords: [
            510.0,
            239.0,
            566.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:57.900000",
        "id": 1,
        "className": "Person",
        coords: [
            348.0,
            535.0,
            454.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:57.900000",
        "id": 9,
        "className": "Person",
        coords: [
            510.0,
            239.0,
            566.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:58",
        "id": 1,
        "className": "Person",
        coords: [
            348.0,
            535.0,
            454.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:58",
        "id": 9,
        "className": "Person",
        coords: [
            510.0,
            239.0,
            566.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:58",
        "id": 1,
        "className": "Person",
        coords: [
            348.0,
            535.0,
            454.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:58.100000",
        "id": 9,
        "className": "Person",
        coords: [
            510.0,
            239.0,
            565.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:58.100000",
        "id": 1,
        "className": "Person",
        coords: [
            348.0,
            535.0,
            454.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:58.200000",
        "id": 9,
        "className": "Person",
        coords: [
            510.0,
            238.0,
            566.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:58.200000",
        "id": 1,
        "className": "Person",
        coords: [
            348.0,
            535.0,
            454.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:58.300000",
        "id": 9,
        "className": "Person",
        coords: [
            510.0,
            238.0,
            566.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:58.300000",
        "id": 1,
        "className": "Person",
        coords: [
            348.0,
            535.0,
            454.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:58.400000",
        "id": 9,
        "className": "Person",
        coords: [
            509.0,
            238.0,
            566.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:58.400000",
        "id": 1,
        "className": "Person",
        coords: [
            348.0,
            535.0,
            453.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:58.500000",
        "id": 9,
        "className": "Person",
        coords: [
            511.0,
            237.0,
            568.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:58.500000",
        "id": 1,
        "className": "Person",
        coords: [
            347.0,
            535.0,
            453.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:58.500000",
        "id": 11,
        "className": "Person",
        coords: [
            193.0,
            193.0,
            225.0,
            286.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:58.600000",
        "id": 9,
        "className": "Person",
        coords: [
            512.0,
            237.0,
            569.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:58.600000",
        "id": 1,
        "className": "Person",
        coords: [
            333.0,
            535.0,
            442.0,
            718.0
        ],
        "status": "Moving",
        "speed": 194.98,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:58.600000",
        "id": 11,
        "className": "Person",
        coords: [
            194.0,
            193.0,
            225.0,
            287.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:58.700000",
        "id": 9,
        "className": "Person",
        coords: [
            513.0,
            237.0,
            569.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:58.700000",
        "id": 1,
        "className": "Person",
        coords: [
            327.0,
            535.0,
            439.0,
            718.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:58.800000",
        "id": 11,
        "className": "Person",
        coords: [
            194.0,
            194.0,
            225.0,
            287.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:58.800000",
        "id": 13,
        "className": "Person",
        coords: [
            497.0,
            177.0,
            531.0,
            260.0
        ],
        "status": "First Seen",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:15:58.800000",
        "id": 9,
        "className": "Person",
        coords: [
            513.0,
            237.0,
            569.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:58.900000",
        "id": 1,
        "className": "Person",
        coords: [
            324.0,
            534.0,
            439.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:58.900000",
        "id": 13,
        "className": "Person",
        coords: [
            496.0,
            177.0,
            530.0,
            260.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:15:58.900000",
        "id": 9,
        "className": "Person",
        coords: [
            513.0,
            237.0,
            569.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:58.900000",
        "id": 1,
        "className": "Person",
        coords: [
            322.0,
            534.0,
            440.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:59",
        "id": 13,
        "className": "Person",
        coords: [
            496.0,
            177.0,
            530.0,
            260.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:15:59",
        "id": 9,
        "className": "Person",
        coords: [
            513.0,
            237.0,
            569.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:59",
        "id": 1,
        "className": "Person",
        coords: [
            320.0,
            534.0,
            441.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:59.100000",
        "id": 13,
        "className": "Person",
        coords: [
            495.0,
            177.0,
            529.0,
            260.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:15:59.100000",
        "id": 11,
        "className": "Person",
        coords: [
            197.0,
            195.0,
            228.0,
            287.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:59.100000",
        "id": 9,
        "className": "Person",
        coords: [
            513.0,
            237.0,
            569.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:59.200000",
        "id": 1,
        "className": "Person",
        coords: [
            319.0,
            535.0,
            441.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:59.200000",
        "id": 13,
        "className": "Person",
        coords: [
            495.0,
            177.0,
            529.0,
            260.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:59.200000",
        "id": 11,
        "className": "Person",
        coords: [
            197.0,
            195.0,
            230.0,
            288.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:59.300000",
        "id": 9,
        "className": "Person",
        coords: [
            513.0,
            237.0,
            569.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:59.300000",
        "id": 1,
        "className": "Person",
        coords: [
            317.0,
            535.0,
            442.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:59.300000",
        "id": 13,
        "className": "Person",
        coords: [
            495.0,
            178.0,
            528.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:59.300000",
        "id": 11,
        "className": "Person",
        coords: [
            196.0,
            195.0,
            228.0,
            288.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:59.400000",
        "id": 9,
        "className": "Person",
        coords: [
            513.0,
            237.0,
            569.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:59.400000",
        "id": 1,
        "className": "Person",
        coords: [
            319.0,
            535.0,
            445.0,
            717.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:59.400000",
        "id": 13,
        "className": "Person",
        coords: [
            495.0,
            178.0,
            529.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:59.500000",
        "id": 11,
        "className": "Person",
        coords: [
            196.0,
            196.0,
            229.0,
            288.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:59.500000",
        "id": 9,
        "className": "Person",
        coords: [
            513.0,
            237.0,
            569.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:59.600000",
        "id": 1,
        "className": "Person",
        coords: [
            324.0,
            535.0,
            449.0,
            717.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:59.600000",
        "id": 13,
        "className": "Person",
        coords: [
            496.0,
            178.0,
            529.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:59.600000",
        "id": 11,
        "className": "Person",
        coords: [
            196.0,
            196.0,
            229.0,
            289.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:59.700000",
        "id": 9,
        "className": "Person",
        coords: [
            513.0,
            237.0,
            569.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:59.700000",
        "id": 1,
        "className": "Person",
        coords: [
            323.0,
            535.0,
            449.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:59.700000",
        "id": 13,
        "className": "Person",
        coords: [
            496.0,
            178.0,
            530.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:59.800000",
        "id": 9,
        "className": "Person",
        coords: [
            513.0,
            236.0,
            569.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:59.800000",
        "id": 1,
        "className": "Person",
        coords: [
            323.0,
            535.0,
            450.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:15:59.800000",
        "id": 13,
        "className": "Person",
        coords: [
            497.0,
            179.0,
            530.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:59.900000",
        "id": 9,
        "className": "Person",
        coords: [
            513.0,
            237.0,
            568.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:15:59.900000",
        "id": 1,
        "className": "Person",
        coords: [
            318.0,
            535.0,
            446.0,
            717.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:00",
        "id": 13,
        "className": "Person",
        coords: [
            497.0,
            179.0,
            531.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:00",
        "id": 9,
        "className": "Person",
        coords: [
            513.0,
            237.0,
            568.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:00.100000",
        "id": 1,
        "className": "Person",
        coords: [
            316.0,
            535.0,
            446.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:00.100000",
        "id": 13,
        "className": "Person",
        coords: [
            498.0,
            179.0,
            531.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:00.100000",
        "id": 9,
        "className": "Person",
        coords: [
            513.0,
            238.0,
            568.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:00.200000",
        "id": 1,
        "className": "Person",
        coords: [
            315.0,
            535.0,
            447.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:00.200000",
        "id": 13,
        "className": "Person",
        coords: [
            498.0,
            180.0,
            532.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:00.300000",
        "id": 9,
        "className": "Person",
        coords: [
            512.0,
            238.0,
            567.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:00.300000",
        "id": 1,
        "className": "Person",
        coords: [
            316.0,
            535.0,
            448.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:00.300000",
        "id": 13,
        "className": "Person",
        coords: [
            497.0,
            180.0,
            532.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:00.400000",
        "id": 9,
        "className": "Person",
        coords: [
            512.0,
            238.0,
            567.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:00.400000",
        "id": 1,
        "className": "Person",
        coords: [
            319.0,
            535.0,
            451.0,
            718.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:00.400000",
        "id": 13,
        "className": "Person",
        coords: [
            496.0,
            180.0,
            532.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:00.400000",
        "id": 11,
        "className": "Person",
        coords: [
            196.0,
            195.0,
            229.0,
            289.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:00.500000",
        "id": 9,
        "className": "Person",
        coords: [
            511.0,
            238.0,
            567.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:00.500000",
        "id": 1,
        "className": "Person",
        coords: [
            321.0,
            535.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:00.500000",
        "id": 13,
        "className": "Person",
        coords: [
            495.0,
            180.0,
            532.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:00.500000",
        "id": 11,
        "className": "Person",
        coords: [
            196.0,
            195.0,
            229.0,
            290.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:00.600000",
        "id": 9,
        "className": "Person",
        coords: [
            511.0,
            238.0,
            567.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:00.600000",
        "id": 1,
        "className": "Person",
        coords: [
            322.0,
            535.0,
            454.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:00.600000",
        "id": 13,
        "className": "Person",
        coords: [
            495.0,
            179.0,
            533.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:00.700000",
        "id": 11,
        "className": "Person",
        coords: [
            196.0,
            195.0,
            229.0,
            291.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:00.700000",
        "id": 9,
        "className": "Person",
        coords: [
            511.0,
            238.0,
            567.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:00.800000",
        "id": 1,
        "className": "Person",
        coords: [
            317.0,
            535.0,
            450.0,
            718.0
        ],
        "status": "Moving",
        "speed": 74.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:00.800000",
        "id": 13,
        "className": "Person",
        coords: [
            495.0,
            179.0,
            534.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:00.800000",
        "id": 11,
        "className": "Person",
        coords: [
            196.0,
            195.0,
            229.0,
            292.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:00.900000",
        "id": 9,
        "className": "Person",
        coords: [
            511.0,
            238.0,
            567.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:00.900000",
        "id": 1,
        "className": "Person",
        coords: [
            316.0,
            535.0,
            449.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:00.900000",
        "id": 13,
        "className": "Person",
        coords: [
            494.0,
            179.0,
            535.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:00.900000",
        "id": 11,
        "className": "Person",
        coords: [
            196.0,
            195.0,
            229.0,
            292.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:01",
        "id": 9,
        "className": "Person",
        coords: [
            511.0,
            237.0,
            567.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:01",
        "id": 1,
        "className": "Person",
        coords: [
            322.0,
            535.0,
            454.0,
            718.0
        ],
        "status": "Moving",
        "speed": 89.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:01.100000",
        "id": 13,
        "className": "Person",
        coords: [
            495.0,
            179.0,
            536.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:01.100000",
        "id": 11,
        "className": "Person",
        coords: [
            196.0,
            195.0,
            230.0,
            294.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:01.200000",
        "id": 9,
        "className": "Person",
        coords: [
            511.0,
            237.0,
            567.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:01.200000",
        "id": 1,
        "className": "Person",
        coords: [
            323.0,
            535.0,
            455.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:01.200000",
        "id": 13,
        "className": "Person",
        coords: [
            496.0,
            179.0,
            537.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:01.200000",
        "id": 11,
        "className": "Person",
        coords: [
            196.0,
            197.0,
            230.0,
            294.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:01.300000",
        "id": 9,
        "className": "Person",
        coords: [
            510.0,
            237.0,
            566.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:01.300000",
        "id": 1,
        "className": "Person",
        coords: [
            332.0,
            535.0,
            461.0,
            718.0
        ],
        "status": "Moving",
        "speed": 104.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:01.300000",
        "id": 13,
        "className": "Person",
        coords: [
            497.0,
            179.0,
            537.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:01.300000",
        "id": 11,
        "className": "Person",
        coords: [
            195.0,
            196.0,
            229.0,
            294.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:01.400000",
        "id": 9,
        "className": "Person",
        coords: [
            510.0,
            237.0,
            566.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:01.400000",
        "id": 1,
        "className": "Person",
        coords: [
            336.0,
            535.0,
            463.0,
            718.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:01.500000",
        "id": 13,
        "className": "Person",
        coords: [
            497.0,
            179.0,
            538.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:01.500000",
        "id": 11,
        "className": "Person",
        coords: [
            194.0,
            195.0,
            228.0,
            292.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:01.500000",
        "id": 9,
        "className": "Person",
        coords: [
            510.0,
            237.0,
            566.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:01.600000",
        "id": 1,
        "className": "Person",
        coords: [
            338.0,
            535.0,
            462.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:01.600000",
        "id": 13,
        "className": "Person",
        coords: [
            497.0,
            179.0,
            537.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:01.600000",
        "id": 11,
        "className": "Person",
        coords: [
            194.0,
            196.0,
            227.0,
            291.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:01.700000",
        "id": 9,
        "className": "Person",
        coords: [
            510.0,
            237.0,
            566.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:01.700000",
        "id": 1,
        "className": "Person",
        coords: [
            339.0,
            535.0,
            462.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:01.700000",
        "id": 13,
        "className": "Person",
        coords: [
            497.0,
            179.0,
            538.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:01.700000",
        "id": 11,
        "className": "Person",
        coords: [
            193.0,
            196.0,
            227.0,
            294.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:01.800000",
        "id": 9,
        "className": "Person",
        coords: [
            510.0,
            237.0,
            566.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:01.800000",
        "id": 1,
        "className": "Person",
        coords: [
            340.0,
            535.0,
            461.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:01.900000",
        "id": 13,
        "className": "Person",
        coords: [
            498.0,
            179.0,
            538.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:01.900000",
        "id": 11,
        "className": "Person",
        coords: [
            192.0,
            196.0,
            227.0,
            296.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:01.900000",
        "id": 9,
        "className": "Person",
        coords: [
            510.0,
            237.0,
            566.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:02",
        "id": 1,
        "className": "Person",
        coords: [
            341.0,
            535.0,
            460.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:02",
        "id": 13,
        "className": "Person",
        coords: [
            498.0,
            179.0,
            538.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:02",
        "id": 11,
        "className": "Person",
        coords: [
            193.0,
            196.0,
            226.0,
            290.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:02.100000",
        "id": 9,
        "className": "Person",
        coords: [
            509.0,
            237.0,
            566.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:02.100000",
        "id": 1,
        "className": "Person",
        coords: [
            342.0,
            535.0,
            460.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:02.100000",
        "id": 13,
        "className": "Person",
        coords: [
            497.0,
            179.0,
            538.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:02.200000",
        "id": 9,
        "className": "Person",
        coords: [
            508.0,
            237.0,
            564.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:02.200000",
        "id": 1,
        "className": "Person",
        coords: [
            342.0,
            535.0,
            459.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:02.200000",
        "id": 13,
        "className": "Person",
        coords: [
            498.0,
            178.0,
            539.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:02.300000",
        "id": 9,
        "className": "Person",
        coords: [
            508.0,
            237.0,
            564.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:02.300000",
        "id": 1,
        "className": "Person",
        coords: [
            343.0,
            535.0,
            458.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:02.300000",
        "id": 13,
        "className": "Person",
        coords: [
            498.0,
            178.0,
            539.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:02.400000",
        "id": 9,
        "className": "Person",
        coords: [
            509.0,
            237.0,
            564.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:02.400000",
        "id": 1,
        "className": "Person",
        coords: [
            344.0,
            535.0,
            458.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:02.400000",
        "id": 13,
        "className": "Person",
        coords: [
            498.0,
            178.0,
            540.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:02.500000",
        "id": 9,
        "className": "Person",
        coords: [
            509.0,
            237.0,
            564.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:02.500000",
        "id": 1,
        "className": "Person",
        coords: [
            344.0,
            535.0,
            458.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:02.600000",
        "id": 13,
        "className": "Person",
        coords: [
            498.0,
            178.0,
            540.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:02.600000",
        "id": 9,
        "className": "Person",
        coords: [
            510.0,
            237.0,
            565.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:02.700000",
        "id": 1,
        "className": "Person",
        coords: [
            345.0,
            535.0,
            457.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:02.700000",
        "id": 13,
        "className": "Person",
        coords: [
            497.0,
            178.0,
            539.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:02.800000",
        "id": 9,
        "className": "Person",
        coords: [
            511.0,
            238.0,
            565.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:02.800000",
        "id": 1,
        "className": "Person",
        coords: [
            345.0,
            535.0,
            457.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:02.800000",
        "id": 13,
        "className": "Person",
        coords: [
            497.0,
            178.0,
            539.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:02.900000",
        "id": 9,
        "className": "Person",
        coords: [
            511.0,
            237.0,
            565.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:02.900000",
        "id": 1,
        "className": "Person",
        coords: [
            345.0,
            535.0,
            456.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:02.900000",
        "id": 13,
        "className": "Person",
        coords: [
            497.0,
            178.0,
            539.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:03",
        "id": 9,
        "className": "Person",
        coords: [
            511.0,
            237.0,
            565.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:03",
        "id": 1,
        "className": "Person",
        coords: [
            345.0,
            535.0,
            456.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:03",
        "id": 13,
        "className": "Person",
        coords: [
            497.0,
            178.0,
            539.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:03.100000",
        "id": 9,
        "className": "Person",
        coords: [
            512.0,
            238.0,
            566.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:03.100000",
        "id": 1,
        "className": "Person",
        coords: [
            346.0,
            535.0,
            455.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:03.200000",
        "id": 13,
        "className": "Person",
        coords: [
            497.0,
            178.0,
            539.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:03.200000",
        "id": 9,
        "className": "Person",
        coords: [
            513.0,
            239.0,
            566.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:03.200000",
        "id": 1,
        "className": "Person",
        coords: [
            340.0,
            535.0,
            451.0,
            718.0
        ],
        "status": "Moving",
        "speed": 74.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:03.200000",
        "id": 13,
        "className": "Person",
        coords: [
            497.0,
            178.0,
            539.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:03.300000",
        "id": 9,
        "className": "Person",
        coords: [
            513.0,
            238.0,
            566.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:03.300000",
        "id": 1,
        "className": "Person",
        coords: [
            331.0,
            535.0,
            444.0,
            718.0
        ],
        "status": "Moving",
        "speed": 119.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:03.300000",
        "id": 13,
        "className": "Person",
        coords: [
            497.0,
            178.0,
            539.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:03.400000",
        "id": 9,
        "className": "Person",
        coords: [
            513.0,
            238.0,
            566.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:03.400000",
        "id": 1,
        "className": "Person",
        coords: [
            332.0,
            535.0,
            447.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:03.400000",
        "id": 13,
        "className": "Person",
        coords: [
            497.0,
            178.0,
            540.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:03.500000",
        "id": 9,
        "className": "Person",
        coords: [
            513.0,
            238.0,
            566.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:03.500000",
        "id": 13,
        "className": "Person",
        coords: [
            497.0,
            178.0,
            540.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:03.600000",
        "id": 9,
        "className": "Person",
        coords: [
            513.0,
            238.0,
            566.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:03.600000",
        "id": 13,
        "className": "Person",
        coords: [
            497.0,
            178.0,
            540.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:03.600000",
        "id": 9,
        "className": "Person",
        coords: [
            513.0,
            238.0,
            566.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:03.700000",
        "id": 13,
        "className": "Person",
        coords: [
            497.0,
            177.0,
            540.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:03.700000",
        "id": 9,
        "className": "Person",
        coords: [
            510.0,
            237.0,
            565.0,
            337.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:03.700000",
        "id": 13,
        "className": "Person",
        coords: [
            495.0,
            177.0,
            538.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:03.800000",
        "id": 9,
        "className": "Person",
        coords: [
            509.0,
            237.0,
            565.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:03.800000",
        "id": 13,
        "className": "Person",
        coords: [
            494.0,
            177.0,
            536.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:03.800000",
        "id": 1,
        "className": "Person",
        coords: [
            341.0,
            535.0,
            455.0,
            718.0
        ],
        "status": "Moving",
        "speed": 134.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:03.900000",
        "id": 9,
        "className": "Person",
        coords: [
            509.0,
            237.0,
            565.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:03.900000",
        "id": 13,
        "className": "Person",
        coords: [
            494.0,
            177.0,
            536.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:04",
        "id": 1,
        "className": "Person",
        coords: [
            342.0,
            534.0,
            456.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:04",
        "id": 9,
        "className": "Person",
        coords: [
            509.0,
            237.0,
            565.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:04",
        "id": 13,
        "className": "Person",
        coords: [
            494.0,
            177.0,
            535.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:04.100000",
        "id": 9,
        "className": "Person",
        coords: [
            509.0,
            237.0,
            565.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:04.100000",
        "id": 13,
        "className": "Person",
        coords: [
            494.0,
            177.0,
            535.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:04.100000",
        "id": 14,
        "className": "Person",
        coords: [
            196.0,
            214.0,
            243.0,
            338.0
        ],
        "status": "First Seen",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:16:04.200000",
        "id": 1,
        "className": "Person",
        coords: [
            343.0,
            533.0,
            456.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:04.200000",
        "id": 9,
        "className": "Person",
        coords: [
            509.0,
            236.0,
            564.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:04.200000",
        "id": 13,
        "className": "Person",
        coords: [
            494.0,
            177.0,
            534.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:04.300000",
        "id": 14,
        "className": "Person",
        coords: [
            199.0,
            215.0,
            245.0,
            338.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:16:04.300000",
        "id": 1,
        "className": "Person",
        coords: [
            343.0,
            533.0,
            456.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:04.400000",
        "id": 9,
        "className": "Person",
        coords: [
            508.0,
            236.0,
            564.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:04.400000",
        "id": 13,
        "className": "Person",
        coords: [
            494.0,
            177.0,
            533.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:04.400000",
        "id": 14,
        "className": "Person",
        coords: [
            201.0,
            217.0,
            247.0,
            338.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:16:04.500000",
        "id": 1,
        "className": "Person",
        coords: [
            344.0,
            533.0,
            455.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:04.500000",
        "id": 9,
        "className": "Person",
        coords: [
            509.0,
            237.0,
            563.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:04.600000",
        "id": 13,
        "className": "Person",
        coords: [
            493.0,
            177.0,
            533.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:04.600000",
        "id": 14,
        "className": "Person",
        coords: [
            201.0,
            218.0,
            247.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:16:04.600000",
        "id": 1,
        "className": "Person",
        coords: [
            344.0,
            534.0,
            455.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:04.700000",
        "id": 9,
        "className": "Person",
        coords: [
            509.0,
            237.0,
            563.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:04.700000",
        "id": 13,
        "className": "Person",
        coords: [
            494.0,
            177.0,
            533.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:04.700000",
        "id": 14,
        "className": "Person",
        coords: [
            202.0,
            220.0,
            248.0,
            341.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:04.700000",
        "id": 1,
        "className": "Person",
        coords: [
            345.0,
            535.0,
            455.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:04.800000",
        "id": 9,
        "className": "Person",
        coords: [
            509.0,
            237.0,
            564.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:04.800000",
        "id": 13,
        "className": "Person",
        coords: [
            494.0,
            178.0,
            534.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:04.800000",
        "id": 14,
        "className": "Person",
        coords: [
            202.0,
            221.0,
            247.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:04.900000",
        "id": 1,
        "className": "Person",
        coords: [
            345.0,
            536.0,
            454.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:04.900000",
        "id": 9,
        "className": "Person",
        coords: [
            509.0,
            238.0,
            564.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:04.900000",
        "id": 13,
        "className": "Person",
        coords: [
            494.0,
            178.0,
            534.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:04.900000",
        "id": 14,
        "className": "Person",
        coords: [
            202.0,
            222.0,
            247.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:05",
        "id": 1,
        "className": "Person",
        coords: [
            345.0,
            536.0,
            454.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:05",
        "id": 9,
        "className": "Person",
        coords: [
            510.0,
            238.0,
            565.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:05.100000",
        "id": 13,
        "className": "Person",
        coords: [
            494.0,
            177.0,
            533.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:05.100000",
        "id": 14,
        "className": "Person",
        coords: [
            204.0,
            225.0,
            248.0,
            338.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:05.100000",
        "id": 1,
        "className": "Person",
        coords: [
            345.0,
            536.0,
            453.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:05.200000",
        "id": 9,
        "className": "Person",
        coords: [
            511.0,
            239.0,
            565.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:05.200000",
        "id": 13,
        "className": "Person",
        coords: [
            494.0,
            178.0,
            533.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:05.200000",
        "id": 14,
        "className": "Person",
        coords: [
            206.0,
            228.0,
            249.0,
            338.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:05.200000",
        "id": 1,
        "className": "Person",
        coords: [
            345.0,
            536.0,
            454.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:05.300000",
        "id": 9,
        "className": "Person",
        coords: [
            511.0,
            239.0,
            565.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:05.300000",
        "id": 13,
        "className": "Person",
        coords: [
            494.0,
            178.0,
            533.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:05.300000",
        "id": 14,
        "className": "Person",
        coords: [
            207.0,
            229.0,
            251.0,
            339.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:05.400000",
        "id": 1,
        "className": "Person",
        coords: [
            346.0,
            537.0,
            454.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:05.400000",
        "id": 9,
        "className": "Person",
        coords: [
            511.0,
            239.0,
            564.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:05.400000",
        "id": 13,
        "className": "Person",
        coords: [
            494.0,
            178.0,
            533.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:05.500000",
        "id": 14,
        "className": "Person",
        coords: [
            211.0,
            226.0,
            257.0,
            340.0
        ],
        "status": "Moving",
        "speed": 76.48,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:05.500000",
        "id": 1,
        "className": "Person",
        coords: [
            347.0,
            537.0,
            454.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:05.600000",
        "id": 9,
        "className": "Person",
        coords: [
            510.0,
            238.0,
            565.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:05.600000",
        "id": 13,
        "className": "Person",
        coords: [
            492.0,
            178.0,
            532.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:05.600000",
        "id": 1,
        "className": "Person",
        coords: [
            348.0,
            537.0,
            455.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:05.700000",
        "id": 9,
        "className": "Person",
        coords: [
            510.0,
            238.0,
            566.0,
            341.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:05.700000",
        "id": 13,
        "className": "Person",
        coords: [
            491.0,
            178.0,
            532.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:05.800000",
        "id": 1,
        "className": "Person",
        coords: [
            348.0,
            537.0,
            455.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:05.800000",
        "id": 9,
        "className": "Person",
        coords: [
            510.0,
            238.0,
            565.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:05.800000",
        "id": 13,
        "className": "Person",
        coords: [
            491.0,
            178.0,
            532.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:05.900000",
        "id": 1,
        "className": "Person",
        coords: [
            348.0,
            537.0,
            455.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:06",
        "id": 9,
        "className": "Person",
        coords: [
            510.0,
            238.0,
            565.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:06",
        "id": 13,
        "className": "Person",
        coords: [
            491.0,
            178.0,
            532.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:06",
        "id": 1,
        "className": "Person",
        coords: [
            348.0,
            537.0,
            455.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:06.100000",
        "id": 9,
        "className": "Person",
        coords: [
            509.0,
            237.0,
            564.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:06.100000",
        "id": 13,
        "className": "Person",
        coords: [
            491.0,
            178.0,
            532.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:06.100000",
        "id": 1,
        "className": "Person",
        coords: [
            348.0,
            537.0,
            454.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:06.200000",
        "id": 9,
        "className": "Person",
        coords: [
            509.0,
            238.0,
            563.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:06.200000",
        "id": 13,
        "className": "Person",
        coords: [
            491.0,
            178.0,
            532.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:06.200000",
        "id": 1,
        "className": "Person",
        coords: [
            348.0,
            536.0,
            455.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:06.300000",
        "id": 9,
        "className": "Person",
        coords: [
            509.0,
            238.0,
            563.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:06.300000",
        "id": 13,
        "className": "Person",
        coords: [
            492.0,
            178.0,
            533.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:06.300000",
        "id": 1,
        "className": "Person",
        coords: [
            349.0,
            536.0,
            455.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:06.400000",
        "id": 9,
        "className": "Person",
        coords: [
            509.0,
            238.0,
            563.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:06.400000",
        "id": 13,
        "className": "Person",
        coords: [
            492.0,
            178.0,
            534.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:06.400000",
        "id": 1,
        "className": "Person",
        coords: [
            349.0,
            536.0,
            455.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:06.500000",
        "id": 9,
        "className": "Person",
        coords: [
            509.0,
            238.0,
            563.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:06.500000",
        "id": 13,
        "className": "Person",
        coords: [
            493.0,
            178.0,
            534.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:06.500000",
        "id": 1,
        "className": "Person",
        coords: [
            349.0,
            536.0,
            455.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:06.600000",
        "id": 9,
        "className": "Person",
        coords: [
            509.0,
            238.0,
            563.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:06.600000",
        "id": 13,
        "className": "Person",
        coords: [
            495.0,
            178.0,
            536.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:06.600000",
        "id": 1,
        "className": "Person",
        coords: [
            349.0,
            536.0,
            455.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:06.700000",
        "id": 14,
        "className": "Person",
        coords: [
            226.0,
            234.0,
            280.0,
            364.0
        ],
        "status": "Moving",
        "speed": 372.56,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:06.700000",
        "id": 9,
        "className": "Person",
        coords: [
            510.0,
            238.0,
            564.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:06.700000",
        "id": 13,
        "className": "Person",
        coords: [
            496.0,
            178.0,
            539.0,
            262.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:06.800000",
        "id": 1,
        "className": "Person",
        coords: [
            341.0,
            535.0,
            449.0,
            718.0
        ],
        "status": "Moving",
        "speed": 104.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:06.800000",
        "id": 14,
        "className": "Person",
        coords: [
            225.0,
            234.0,
            283.0,
            373.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:06.800000",
        "id": 9,
        "className": "Person",
        coords: [
            509.0,
            237.0,
            564.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:06.900000",
        "id": 13,
        "className": "Person",
        coords: [
            497.0,
            178.0,
            541.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:06.900000",
        "id": 1,
        "className": "Person",
        coords: [
            344.0,
            534.0,
            452.0,
            718.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:06.900000",
        "id": 14,
        "className": "Person",
        coords: [
            225.0,
            235.0,
            284.0,
            378.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:07",
        "id": 9,
        "className": "Person",
        coords: [
            510.0,
            236.0,
            565.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:07",
        "id": 13,
        "className": "Person",
        coords: [
            497.0,
            178.0,
            542.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:07",
        "id": 1,
        "className": "Person",
        coords: [
            331.0,
            534.0,
            443.0,
            717.0
        ],
        "status": "Moving",
        "speed": 165.67,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:07",
        "id": 14,
        "className": "Person",
        coords: [
            225.0,
            236.0,
            285.0,
            381.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:07.100000",
        "id": 9,
        "className": "Person",
        coords: [
            511.0,
            236.0,
            566.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:07.100000",
        "id": 13,
        "className": "Person",
        coords: [
            498.0,
            178.0,
            543.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:07.200000",
        "id": 1,
        "className": "Person",
        coords: [
            327.0,
            534.0,
            442.0,
            718.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:07.200000",
        "id": 14,
        "className": "Person",
        coords: [
            226.0,
            237.0,
            286.0,
            381.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:07.200000",
        "id": 9,
        "className": "Person",
        coords: [
            511.0,
            236.0,
            566.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:07.300000",
        "id": 13,
        "className": "Person",
        coords: [
            499.0,
            178.0,
            544.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:07.300000",
        "id": 1,
        "className": "Person",
        coords: [
            325.0,
            534.0,
            442.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:07.300000",
        "id": 14,
        "className": "Person",
        coords: [
            226.0,
            238.0,
            287.0,
            382.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:07.400000",
        "id": 9,
        "className": "Person",
        coords: [
            513.0,
            235.0,
            569.0,
            339.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:07.400000",
        "id": 13,
        "className": "Person",
        coords: [
            499.0,
            179.0,
            544.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:07.400000",
        "id": 1,
        "className": "Person",
        coords: [
            322.0,
            534.0,
            442.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:07.400000",
        "id": 14,
        "className": "Person",
        coords: [
            229.0,
            239.0,
            290.0,
            384.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:07.500000",
        "id": 9,
        "className": "Person",
        coords: [
            515.0,
            234.0,
            571.0,
            339.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:07.500000",
        "id": 13,
        "className": "Person",
        coords: [
            499.0,
            179.0,
            544.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:07.500000",
        "id": 1,
        "className": "Person",
        coords: [
            322.0,
            534.0,
            444.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:07.500000",
        "id": 14,
        "className": "Person",
        coords: [
            232.0,
            241.0,
            293.0,
            386.0
        ],
        "status": "Moving",
        "speed": 54.08,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:07.600000",
        "id": 9,
        "className": "Person",
        coords: [
            516.0,
            235.0,
            572.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:07.600000",
        "id": 13,
        "className": "Person",
        coords: [
            499.0,
            178.0,
            545.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:07.600000",
        "id": 1,
        "className": "Person",
        coords: [
            322.0,
            534.0,
            446.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:07.600000",
        "id": 14,
        "className": "Person",
        coords: [
            236.0,
            244.0,
            294.0,
            382.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:07.700000",
        "id": 9,
        "className": "Person",
        coords: [
            516.0,
            235.0,
            572.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:07.700000",
        "id": 13,
        "className": "Person",
        coords: [
            499.0,
            179.0,
            545.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:07.700000",
        "id": 1,
        "className": "Person",
        coords: [
            322.0,
            534.0,
            447.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:07.800000",
        "id": 14,
        "className": "Person",
        coords: [
            239.0,
            246.0,
            297.0,
            382.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:07.800000",
        "id": 9,
        "className": "Person",
        coords: [
            516.0,
            235.0,
            572.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:07.800000",
        "id": 13,
        "className": "Person",
        coords: [
            499.0,
            178.0,
            545.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:07.900000",
        "id": 1,
        "className": "Person",
        coords: [
            320.0,
            534.0,
            447.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:07.900000",
        "id": 14,
        "className": "Person",
        coords: [
            240.0,
            247.0,
            301.0,
            388.0
        ],
        "status": "Moving",
        "speed": 54.08,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:07.900000",
        "id": 9,
        "className": "Person",
        coords: [
            516.0,
            235.0,
            572.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:08",
        "id": 13,
        "className": "Person",
        coords: [
            498.0,
            178.0,
            544.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:08",
        "id": 1,
        "className": "Person",
        coords: [
            326.0,
            534.0,
            452.0,
            718.0
        ],
        "status": "Moving",
        "speed": 89.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:08",
        "id": 14,
        "className": "Person",
        coords: [
            241.0,
            247.0,
            304.0,
            395.0
        ],
        "status": "Moving",
        "speed": 67.08,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:08.100000",
        "id": 9,
        "className": "Person",
        coords: [
            516.0,
            235.0,
            572.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:08.100000",
        "id": 13,
        "className": "Person",
        coords: [
            498.0,
            178.0,
            543.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:08.200000",
        "id": 1,
        "className": "Person",
        coords: [
            326.0,
            534.0,
            453.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:08.200000",
        "id": 14,
        "className": "Person",
        coords: [
            242.0,
            247.0,
            309.0,
            402.0
        ],
        "status": "Moving",
        "speed": 63.63,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:08.300000",
        "id": 9,
        "className": "Person",
        coords: [
            516.0,
            235.0,
            571.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:08.300000",
        "id": 13,
        "className": "Person",
        coords: [
            498.0,
            179.0,
            543.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:08.300000",
        "id": 1,
        "className": "Person",
        coords: [
            328.0,
            534.0,
            454.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:08.300000",
        "id": 14,
        "className": "Person",
        coords: [
            243.0,
            247.0,
            311.0,
            403.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:08.400000",
        "id": 9,
        "className": "Person",
        coords: [
            515.0,
            235.0,
            571.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:08.400000",
        "id": 13,
        "className": "Person",
        coords: [
            498.0,
            179.0,
            543.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:08.500000",
        "id": 1,
        "className": "Person",
        coords: [
            332.0,
            534.0,
            458.0,
            718.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:08.500000",
        "id": 14,
        "className": "Person",
        coords: [
            243.0,
            247.0,
            312.0,
            404.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:08.600000",
        "id": 9,
        "className": "Person",
        coords: [
            514.0,
            235.0,
            570.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:08.600000",
        "id": 13,
        "className": "Person",
        coords: [
            498.0,
            179.0,
            543.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:08.600000",
        "id": 1,
        "className": "Person",
        coords: [
            329.0,
            535.0,
            454.0,
            718.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:08.600000",
        "id": 14,
        "className": "Person",
        coords: [
            245.0,
            249.0,
            314.0,
            404.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:08.700000",
        "id": 9,
        "className": "Person",
        coords: [
            514.0,
            235.0,
            570.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:08.700000",
        "id": 13,
        "className": "Person",
        coords: [
            499.0,
            179.0,
            543.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:08.700000",
        "id": 1,
        "className": "Person",
        coords: [
            321.0,
            535.0,
            448.0,
            718.0
        ],
        "status": "Moving",
        "speed": 104.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:08.700000",
        "id": 14,
        "className": "Person",
        coords: [
            247.0,
            252.0,
            316.0,
            404.0
        ],
        "status": "Moving",
        "speed": 42.42,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:08.800000",
        "id": 9,
        "className": "Person",
        coords: [
            514.0,
            235.0,
            571.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:08.800000",
        "id": 13,
        "className": "Person",
        coords: [
            499.0,
            180.0,
            543.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:08.800000",
        "id": 1,
        "className": "Person",
        coords: [
            319.0,
            535.0,
            447.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:08.900000",
        "id": 14,
        "className": "Person",
        coords: [
            247.0,
            257.0,
            315.0,
            404.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:08.900000",
        "id": 9,
        "className": "Person",
        coords: [
            514.0,
            234.0,
            571.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:08.900000",
        "id": 13,
        "className": "Person",
        coords: [
            499.0,
            181.0,
            542.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:09",
        "id": 1,
        "className": "Person",
        coords: [
            317.0,
            535.0,
            447.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:09",
        "id": 14,
        "className": "Person",
        coords: [
            250.0,
            260.0,
            317.0,
            404.0
        ],
        "status": "Moving",
        "speed": 42.42,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:09",
        "id": 9,
        "className": "Person",
        coords: [
            514.0,
            234.0,
            571.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:09.100000",
        "id": 13,
        "className": "Person",
        coords: [
            499.0,
            181.0,
            542.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:09.100000",
        "id": 14,
        "className": "Person",
        coords: [
            251.0,
            262.0,
            319.0,
            407.0
        ],
        "status": "Moving",
        "speed": 42.42,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:09.100000",
        "id": 9,
        "className": "Person",
        coords: [
            514.0,
            234.0,
            570.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:09.100000",
        "id": 13,
        "className": "Person",
        coords: [
            499.0,
            182.0,
            542.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:09.200000",
        "id": 14,
        "className": "Person",
        coords: [
            251.0,
            264.0,
            321.0,
            412.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:09.200000",
        "id": 9,
        "className": "Person",
        coords: [
            514.0,
            236.0,
            569.0,
            340.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:09.200000",
        "id": 13,
        "className": "Person",
        coords: [
            500.0,
            183.0,
            542.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:09.300000",
        "id": 14,
        "className": "Person",
        coords: [
            252.0,
            265.0,
            322.0,
            416.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:09.300000",
        "id": 9,
        "className": "Person",
        coords: [
            514.0,
            237.0,
            569.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:09.400000",
        "id": 13,
        "className": "Person",
        coords: [
            501.0,
            183.0,
            542.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:09.400000",
        "id": 14,
        "className": "Person",
        coords: [
            252.0,
            265.0,
            323.0,
            418.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:09.500000",
        "id": 15,
        "className": "Person",
        coords: [
            642.0,
            451.0,
            831.0,
            604.0
        ],
        "status": "First Seen",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:16:09.500000",
        "id": 1,
        "className": "Person",
        coords: [
            323.0,
            533.0,
            453.0,
            718.0
        ],
        "status": "Moving",
        "speed": 91.23,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:09.500000",
        "id": 9,
        "className": "Person",
        coords: [
            514.0,
            237.0,
            569.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:09.600000",
        "id": 13,
        "className": "Person",
        coords: [
            501.0,
            183.0,
            542.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:09.600000",
        "id": 14,
        "className": "Person",
        coords: [
            251.0,
            266.0,
            323.0,
            422.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:09.600000",
        "id": 15,
        "className": "Person",
        coords: [
            642.0,
            451.0,
            831.0,
            604.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:16:09.700000",
        "id": 9,
        "className": "Person",
        coords: [
            514.0,
            237.0,
            569.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:09.700000",
        "id": 13,
        "className": "Person",
        coords: [
            501.0,
            183.0,
            542.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:09.800000",
        "id": 14,
        "className": "Person",
        coords: [
            251.0,
            267.0,
            325.0,
            428.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:09.800000",
        "id": 15,
        "className": "Person",
        coords: [
            642.0,
            451.0,
            831.0,
            604.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:16:09.800000",
        "id": 9,
        "className": "Person",
        coords: [
            514.0,
            237.0,
            569.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:09.900000",
        "id": 13,
        "className": "Person",
        coords: [
            501.0,
            184.0,
            542.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:09.900000",
        "id": 14,
        "className": "Person",
        coords: [
            252.0,
            268.0,
            327.0,
            432.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:09.900000",
        "id": 15,
        "className": "Person",
        coords: [
            642.0,
            451.0,
            831.0,
            604.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:16:10",
        "id": 1,
        "className": "Person",
        coords: [
            315.0,
            530.0,
            447.0,
            715.0
        ],
        "status": "Moving",
        "speed": 114.23,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:10",
        "id": 9,
        "className": "Person",
        coords: [
            511.0,
            237.0,
            566.0,
            340.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:10.100000",
        "id": 13,
        "className": "Person",
        coords: [
            501.0,
            184.0,
            543.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:10.100000",
        "id": 14,
        "className": "Person",
        coords: [
            255.0,
            270.0,
            329.0,
            432.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:10.100000",
        "id": 15,
        "className": "Person",
        coords: [
            642.0,
            451.0,
            831.0,
            604.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:10.100000",
        "id": 1,
        "className": "Person",
        coords: [
            313.0,
            530.0,
            447.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:10.200000",
        "id": 9,
        "className": "Person",
        coords: [
            510.0,
            237.0,
            565.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:10.200000",
        "id": 13,
        "className": "Person",
        coords: [
            501.0,
            183.0,
            543.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:10.200000",
        "id": 14,
        "className": "Person",
        coords: [
            259.0,
            274.0,
            330.0,
            431.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:10.300000",
        "id": 15,
        "className": "Person",
        coords: [
            642.0,
            451.0,
            831.0,
            604.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:10.300000",
        "id": 1,
        "className": "Person",
        coords: [
            311.0,
            530.0,
            447.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:10.400000",
        "id": 9,
        "className": "Person",
        coords: [
            510.0,
            237.0,
            565.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:10.400000",
        "id": 13,
        "className": "Person",
        coords: [
            501.0,
            184.0,
            542.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:10.400000",
        "id": 14,
        "className": "Person",
        coords: [
            263.0,
            277.0,
            333.0,
            429.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:10.400000",
        "id": 15,
        "className": "Person",
        coords: [
            642.0,
            451.0,
            831.0,
            604.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:10.500000",
        "id": 1,
        "className": "Person",
        coords: [
            311.0,
            530.0,
            447.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:10.500000",
        "id": 9,
        "className": "Person",
        coords: [
            510.0,
            237.0,
            565.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:10.500000",
        "id": 13,
        "className": "Person",
        coords: [
            500.0,
            183.0,
            542.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:10.600000",
        "id": 14,
        "className": "Person",
        coords: [
            265.0,
            280.0,
            338.0,
            438.0
        ],
        "status": "Moving",
        "speed": 100.61,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:10.600000",
        "id": 15,
        "className": "Person",
        coords: [
            642.0,
            451.0,
            831.0,
            604.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:10.600000",
        "id": 1,
        "className": "Person",
        coords: [
            311.0,
            530.0,
            447.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:10.700000",
        "id": 9,
        "className": "Person",
        coords: [
            509.0,
            237.0,
            563.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:10.700000",
        "id": 13,
        "className": "Person",
        coords: [
            500.0,
            184.0,
            542.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:10.700000",
        "id": 14,
        "className": "Person",
        coords: [
            269.0,
            281.0,
            342.0,
            442.0
        ],
        "status": "Moving",
        "speed": 67.08,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:10.800000",
        "id": 15,
        "className": "Person",
        coords: [
            642.0,
            451.0,
            831.0,
            604.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:10.800000",
        "id": 1,
        "className": "Person",
        coords: [
            311.0,
            530.0,
            447.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:10.800000",
        "id": 9,
        "className": "Person",
        coords: [
            508.0,
            237.0,
            563.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:10.900000",
        "id": 13,
        "className": "Person",
        coords: [
            500.0,
            184.0,
            541.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:10.900000",
        "id": 14,
        "className": "Person",
        coords: [
            272.0,
            281.0,
            346.0,
            443.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:10.900000",
        "id": 15,
        "className": "Person",
        coords: [
            642.0,
            451.0,
            831.0,
            604.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:10.900000",
        "id": 1,
        "className": "Person",
        coords: [
            311.0,
            530.0,
            448.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:11",
        "id": 9,
        "className": "Person",
        coords: [
            508.0,
            237.0,
            563.0,
            341.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:11",
        "id": 13,
        "className": "Person",
        coords: [
            500.0,
            184.0,
            541.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:11",
        "id": 14,
        "className": "Person",
        coords: [
            275.0,
            282.0,
            349.0,
            443.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:11.100000",
        "id": 15,
        "className": "Person",
        coords: [
            642.0,
            451.0,
            831.0,
            604.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:11.100000",
        "id": 1,
        "className": "Person",
        coords: [
            315.0,
            530.0,
            451.0,
            716.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:11.200000",
        "id": 9,
        "className": "Person",
        coords: [
            508.0,
            237.0,
            563.0,
            341.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:11.200000",
        "id": 13,
        "className": "Person",
        coords: [
            500.0,
            184.0,
            541.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:11.200000",
        "id": 14,
        "className": "Person",
        coords: [
            277.0,
            282.0,
            351.0,
            444.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:11.200000",
        "id": 15,
        "className": "Person",
        coords: [
            642.0,
            451.0,
            831.0,
            604.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:11.300000",
        "id": 1,
        "className": "Person",
        coords: [
            313.0,
            530.0,
            450.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:11.300000",
        "id": 9,
        "className": "Person",
        coords: [
            508.0,
            237.0,
            563.0,
            341.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:11.300000",
        "id": 13,
        "className": "Person",
        coords: [
            500.0,
            184.0,
            541.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:11.400000",
        "id": 14,
        "className": "Person",
        coords: [
            279.0,
            283.0,
            353.0,
            444.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:11.400000",
        "id": 15,
        "className": "Person",
        coords: [
            642.0,
            451.0,
            831.0,
            604.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:11.400000",
        "id": 1,
        "className": "Person",
        coords: [
            321.0,
            531.0,
            456.0,
            718.0
        ],
        "status": "Moving",
        "speed": 106.06,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:11.500000",
        "id": 9,
        "className": "Person",
        coords: [
            508.0,
            237.0,
            563.0,
            341.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:11.500000",
        "id": 13,
        "className": "Person",
        coords: [
            500.0,
            183.0,
            541.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:11.500000",
        "id": 14,
        "className": "Person",
        coords: [
            281.0,
            285.0,
            355.0,
            445.0
        ],
        "status": "Moving",
        "speed": 42.42,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:11.500000",
        "id": 15,
        "className": "Person",
        coords: [
            642.0,
            451.0,
            831.0,
            604.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:11.600000",
        "id": 1,
        "className": "Person",
        coords: [
            324.0,
            532.0,
            457.0,
            718.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:11.600000",
        "id": 9,
        "className": "Person",
        coords: [
            509.0,
            238.0,
            562.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:11.700000",
        "id": 13,
        "className": "Person",
        coords: [
            500.0,
            183.0,
            541.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:11.700000",
        "id": 14,
        "className": "Person",
        coords: [
            283.0,
            289.0,
            357.0,
            446.0
        ],
        "status": "Moving",
        "speed": 42.42,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:11.700000",
        "id": 15,
        "className": "Person",
        coords: [
            641.0,
            451.0,
            832.0,
            605.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:11.700000",
        "id": 1,
        "className": "Person",
        coords: [
            327.0,
            534.0,
            458.0,
            718.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:11.800000",
        "id": 9,
        "className": "Person",
        coords: [
            509.0,
            238.0,
            562.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:11.800000",
        "id": 13,
        "className": "Person",
        coords: [
            499.0,
            183.0,
            541.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:11.800000",
        "id": 14,
        "className": "Person",
        coords: [
            284.0,
            291.0,
            357.0,
            447.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:11.900000",
        "id": 15,
        "className": "Person",
        coords: [
            641.0,
            451.0,
            833.0,
            605.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:11.900000",
        "id": 1,
        "className": "Person",
        coords: [
            330.0,
            535.0,
            459.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:12",
        "id": 9,
        "className": "Person",
        coords: [
            509.0,
            238.0,
            561.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:12",
        "id": 13,
        "className": "Person",
        coords: [
            500.0,
            183.0,
            541.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:12",
        "id": 14,
        "className": "Person",
        coords: [
            285.0,
            293.0,
            358.0,
            448.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:12",
        "id": 15,
        "className": "Person",
        coords: [
            641.0,
            451.0,
            833.0,
            606.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:12.100000",
        "id": 1,
        "className": "Person",
        coords: [
            332.0,
            536.0,
            459.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:12.100000",
        "id": 9,
        "className": "Person",
        coords: [
            509.0,
            238.0,
            561.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:12.200000",
        "id": 13,
        "className": "Person",
        coords: [
            500.0,
            183.0,
            541.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:12.200000",
        "id": 14,
        "className": "Person",
        coords: [
            285.0,
            295.0,
            358.0,
            451.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:12.200000",
        "id": 15,
        "className": "Person",
        coords: [
            641.0,
            451.0,
            833.0,
            606.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:12.200000",
        "id": 1,
        "className": "Person",
        coords: [
            335.0,
            538.0,
            460.0,
            718.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:12.300000",
        "id": 9,
        "className": "Person",
        coords: [
            510.0,
            238.0,
            561.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:12.300000",
        "id": 13,
        "className": "Person",
        coords: [
            500.0,
            182.0,
            541.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:12.400000",
        "id": 14,
        "className": "Person",
        coords: [
            284.0,
            298.0,
            358.0,
            455.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:12.400000",
        "id": 15,
        "className": "Person",
        coords: [
            641.0,
            451.0,
            832.0,
            606.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:12.400000",
        "id": 1,
        "className": "Person",
        coords: [
            337.0,
            539.0,
            461.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:12.500000",
        "id": 9,
        "className": "Person",
        coords: [
            509.0,
            239.0,
            561.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:12.500000",
        "id": 13,
        "className": "Person",
        coords: [
            500.0,
            183.0,
            541.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:12.500000",
        "id": 14,
        "className": "Person",
        coords: [
            284.0,
            300.0,
            358.0,
            458.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:12.600000",
        "id": 15,
        "className": "Person",
        coords: [
            641.0,
            451.0,
            832.0,
            606.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:12.600000",
        "id": 1,
        "className": "Person",
        coords: [
            340.0,
            540.0,
            462.0,
            718.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:12.700000",
        "id": 9,
        "className": "Person",
        coords: [
            508.0,
            239.0,
            560.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:12.700000",
        "id": 13,
        "className": "Person",
        coords: [
            500.0,
            183.0,
            541.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:12.700000",
        "id": 14,
        "className": "Person",
        coords: [
            284.0,
            301.0,
            358.0,
            460.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:12.700000",
        "id": 15,
        "className": "Person",
        coords: [
            641.0,
            451.0,
            832.0,
            606.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:12.800000",
        "id": 1,
        "className": "Person",
        coords: [
            343.0,
            541.0,
            465.0,
            718.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:12.800000",
        "id": 9,
        "className": "Person",
        coords: [
            509.0,
            239.0,
            561.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:12.800000",
        "id": 13,
        "className": "Person",
        coords: [
            501.0,
            183.0,
            542.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:12.900000",
        "id": 14,
        "className": "Person",
        coords: [
            285.0,
            302.0,
            359.0,
            462.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:12.900000",
        "id": 15,
        "className": "Person",
        coords: [
            641.0,
            451.0,
            832.0,
            606.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:12.900000",
        "id": 1,
        "className": "Person",
        coords: [
            346.0,
            542.0,
            469.0,
            718.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:13",
        "id": 9,
        "className": "Person",
        coords: [
            508.0,
            239.0,
            561.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:13",
        "id": 13,
        "className": "Person",
        coords: [
            501.0,
            183.0,
            542.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:13",
        "id": 14,
        "className": "Person",
        coords: [
            286.0,
            304.0,
            361.0,
            466.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:13.100000",
        "id": 15,
        "className": "Person",
        coords: [
            641.0,
            451.0,
            832.0,
            605.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:13.100000",
        "id": 1,
        "className": "Person",
        coords: [
            348.0,
            542.0,
            472.0,
            718.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:13.100000",
        "id": 9,
        "className": "Person",
        coords: [
            508.0,
            239.0,
            561.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:13.200000",
        "id": 13,
        "className": "Person",
        coords: [
            501.0,
            182.0,
            543.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:13.200000",
        "id": 14,
        "className": "Person",
        coords: [
            286.0,
            307.0,
            363.0,
            472.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:13.200000",
        "id": 15,
        "className": "Person",
        coords: [
            641.0,
            451.0,
            832.0,
            605.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:13.200000",
        "id": 9,
        "className": "Person",
        coords: [
            509.0,
            239.0,
            561.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:13.300000",
        "id": 13,
        "className": "Person",
        coords: [
            501.0,
            181.0,
            543.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:13.300000",
        "id": 14,
        "className": "Person",
        coords: [
            288.0,
            310.0,
            363.0,
            468.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:13.300000",
        "id": 15,
        "className": "Person",
        coords: [
            641.0,
            451.0,
            832.0,
            605.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:13.400000",
        "id": 9,
        "className": "Person",
        coords: [
            509.0,
            239.0,
            561.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:13.400000",
        "id": 13,
        "className": "Person",
        coords: [
            500.0,
            181.0,
            543.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:13.400000",
        "id": 14,
        "className": "Person",
        coords: [
            296.0,
            312.0,
            356.0,
            432.0
        ],
        "status": "Moving",
        "speed": 255.42,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:13.500000",
        "id": 15,
        "className": "Person",
        coords: [
            642.0,
            451.0,
            832.0,
            605.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:13.500000",
        "id": 9,
        "className": "Person",
        coords: [
            509.0,
            239.0,
            561.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:13.500000",
        "id": 13,
        "className": "Person",
        coords: [
            500.0,
            180.0,
            544.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:13.600000",
        "id": 15,
        "className": "Person",
        coords: [
            642.0,
            451.0,
            832.0,
            605.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:13.600000",
        "id": 9,
        "className": "Person",
        coords: [
            509.0,
            238.0,
            562.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:13.600000",
        "id": 13,
        "className": "Person",
        coords: [
            499.0,
            179.0,
            544.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:13.700000",
        "id": 15,
        "className": "Person",
        coords: [
            642.0,
            451.0,
            832.0,
            605.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:13.700000",
        "id": 9,
        "className": "Person",
        coords: [
            508.0,
            238.0,
            561.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:13.700000",
        "id": 13,
        "className": "Person",
        coords: [
            497.0,
            178.0,
            543.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:13.800000",
        "id": 15,
        "className": "Person",
        coords: [
            642.0,
            451.0,
            832.0,
            606.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:13.800000",
        "id": 16,
        "className": "Person",
        coords: [
            297.0,
            323.0,
            376.0,
            539.0
        ],
        "status": "First Seen",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:16:13.800000",
        "id": 9,
        "className": "Person",
        coords: [
            509.0,
            237.0,
            562.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:13.900000",
        "id": 13,
        "className": "Person",
        coords: [
            497.0,
            178.0,
            543.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:13.900000",
        "id": 15,
        "className": "Person",
        coords: [
            642.0,
            451.0,
            832.0,
            605.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:13.900000",
        "id": 16,
        "className": "Person",
        coords: [
            299.0,
            323.0,
            381.0,
            546.0
        ],
        "status": "Moving",
        "speed": 74.99,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:16:14",
        "id": 9,
        "className": "Person",
        coords: [
            509.0,
            238.0,
            561.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:14",
        "id": 13,
        "className": "Person",
        coords: [
            494.0,
            177.0,
            541.0,
            263.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:14",
        "id": 15,
        "className": "Person",
        coords: [
            642.0,
            450.0,
            832.0,
            605.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:14",
        "id": 16,
        "className": "Person",
        coords: [
            303.0,
            323.0,
            386.0,
            547.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:16:14.100000",
        "id": 1,
        "className": "Person",
        coords: [
            361.0,
            549.0,
            482.0,
            719.0
        ],
        "status": "Moving",
        "speed": 175.56,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:14.200000",
        "id": 9,
        "className": "Person",
        coords: [
            509.0,
            238.0,
            561.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:14.200000",
        "id": 13,
        "className": "Person",
        coords: [
            493.0,
            177.0,
            539.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:14.200000",
        "id": 15,
        "className": "Person",
        coords: [
            643.0,
            451.0,
            830.0,
            604.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:14.200000",
        "id": 16,
        "className": "Person",
        coords: [
            307.0,
            324.0,
            390.0,
            547.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:16:14.300000",
        "id": 1,
        "className": "Person",
        coords: [
            359.0,
            550.0,
            481.0,
            719.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:14.300000",
        "id": 9,
        "className": "Person",
        coords: [
            509.0,
            239.0,
            560.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:14.400000",
        "id": 13,
        "className": "Person",
        coords: [
            492.0,
            178.0,
            538.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:14.400000",
        "id": 15,
        "className": "Person",
        coords: [
            643.0,
            451.0,
            830.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:14.400000",
        "id": 16,
        "className": "Person",
        coords: [
            310.0,
            325.0,
            391.0,
            546.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:14.400000",
        "id": 1,
        "className": "Person",
        coords: [
            344.0,
            551.0,
            471.0,
            718.0
        ],
        "status": "Moving",
        "speed": 194.98,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:14.500000",
        "id": 9,
        "className": "Person",
        coords: [
            509.0,
            239.0,
            561.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:14.500000",
        "id": 13,
        "className": "Person",
        coords: [
            489.0,
            178.0,
            536.0,
            263.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:14.500000",
        "id": 15,
        "className": "Person",
        coords: [
            643.0,
            451.0,
            830.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:14.600000",
        "id": 16,
        "className": "Person",
        coords: [
            312.0,
            328.0,
            394.0,
            549.0
        ],
        "status": "Moving",
        "speed": 63.63,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:14.600000",
        "id": 1,
        "className": "Person",
        coords: [
            335.0,
            551.0,
            466.0,
            718.0
        ],
        "status": "Moving",
        "speed": 104.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:14.600000",
        "id": 9,
        "className": "Person",
        coords: [
            509.0,
            238.0,
            561.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:14.700000",
        "id": 13,
        "className": "Person",
        coords: [
            488.0,
            178.0,
            535.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:14.700000",
        "id": 15,
        "className": "Person",
        coords: [
            643.0,
            451.0,
            830.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:14.700000",
        "id": 16,
        "className": "Person",
        coords: [
            317.0,
            331.0,
            397.0,
            550.0
        ],
        "status": "Moving",
        "speed": 67.08,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:14.700000",
        "id": 1,
        "className": "Person",
        coords: [
            330.0,
            551.0,
            466.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:14.800000",
        "id": 9,
        "className": "Person",
        coords: [
            509.0,
            239.0,
            560.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:14.800000",
        "id": 13,
        "className": "Person",
        coords: [
            488.0,
            177.0,
            535.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:14.900000",
        "id": 15,
        "className": "Person",
        coords: [
            642.0,
            451.0,
            830.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:14.900000",
        "id": 16,
        "className": "Person",
        coords: [
            319.0,
            338.0,
            403.0,
            566.0
        ],
        "status": "Moving",
        "speed": 189.72,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:14.900000",
        "id": 1,
        "className": "Person",
        coords: [
            328.0,
            550.0,
            469.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:15",
        "id": 9,
        "className": "Person",
        coords: [
            508.0,
            238.0,
            561.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:15",
        "id": 13,
        "className": "Person",
        coords: [
            488.0,
            177.0,
            535.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:15.100000",
        "id": 15,
        "className": "Person",
        coords: [
            642.0,
            451.0,
            830.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:15.100000",
        "id": 16,
        "className": "Person",
        coords: [
            322.0,
            343.0,
            409.0,
            581.0
        ],
        "status": "Moving",
        "speed": 161.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:15.100000",
        "id": 1,
        "className": "Person",
        coords: [
            330.0,
            549.0,
            477.0,
            718.0
        ],
        "status": "Moving",
        "speed": 76.48,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:15.200000",
        "id": 9,
        "className": "Person",
        coords: [
            509.0,
            238.0,
            561.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:15.200000",
        "id": 13,
        "className": "Person",
        coords: [
            487.0,
            177.0,
            534.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:15.200000",
        "id": 15,
        "className": "Person",
        coords: [
            642.0,
            451.0,
            830.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:15.300000",
        "id": 16,
        "className": "Person",
        coords: [
            325.0,
            344.0,
            413.0,
            590.0
        ],
        "status": "Moving",
        "speed": 96.04,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:15.300000",
        "id": 1,
        "className": "Person",
        coords: [
            333.0,
            548.0,
            487.0,
            718.0
        ],
        "status": "Moving",
        "speed": 104.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:15.400000",
        "id": 9,
        "className": "Person",
        coords: [
            509.0,
            239.0,
            561.0,
            341.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:15.400000",
        "id": 13,
        "className": "Person",
        coords: [
            487.0,
            178.0,
            534.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:15.400000",
        "id": 15,
        "className": "Person",
        coords: [
            643.0,
            451.0,
            830.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:15.400000",
        "id": 16,
        "className": "Person",
        coords: [
            328.0,
            346.0,
            416.0,
            593.0
        ],
        "status": "Moving",
        "speed": 54.08,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:15.500000",
        "id": 1,
        "className": "Person",
        coords: [
            348.0,
            547.0,
            484.0,
            685.0
        ],
        "status": "Moving",
        "speed": 270.39,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:15.500000",
        "id": 9,
        "className": "Person",
        coords: [
            509.0,
            239.0,
            561.0,
            341.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:15.600000",
        "id": 13,
        "className": "Person",
        coords: [
            488.0,
            177.0,
            535.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:15.600000",
        "id": 15,
        "className": "Person",
        coords: [
            643.0,
            451.0,
            830.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:15.600000",
        "id": 16,
        "className": "Person",
        coords: [
            331.0,
            348.0,
            420.0,
            594.0
        ],
        "status": "Moving",
        "speed": 54.08,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:15.700000",
        "id": 1,
        "className": "Person",
        coords: [
            359.0,
            546.0,
            483.0,
            658.0
        ],
        "status": "Moving",
        "speed": 222.97,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:15.700000",
        "id": 9,
        "className": "Person",
        coords: [
            509.0,
            239.0,
            561.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:15.800000",
        "id": 13,
        "className": "Person",
        coords: [
            488.0,
            178.0,
            535.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:15.800000",
        "id": 15,
        "className": "Person",
        coords: [
            644.0,
            451.0,
            833.0,
            604.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:15.800000",
        "id": 16,
        "className": "Person",
        coords: [
            333.0,
            346.0,
            423.0,
            599.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:15.900000",
        "id": 9,
        "className": "Person",
        coords: [
            509.0,
            238.0,
            561.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:15.900000",
        "id": 13,
        "className": "Person",
        coords: [
            490.0,
            178.0,
            536.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:15.900000",
        "id": 15,
        "className": "Person",
        coords: [
            643.0,
            451.0,
            831.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:15.900000",
        "id": 16,
        "className": "Person",
        coords: [
            336.0,
            346.0,
            428.0,
            603.0
        ],
        "status": "Moving",
        "speed": 67.08,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:16",
        "id": 9,
        "className": "Person",
        coords: [
            509.0,
            238.0,
            561.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:16",
        "id": 13,
        "className": "Person",
        coords: [
            490.0,
            177.0,
            536.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:16",
        "id": 15,
        "className": "Person",
        coords: [
            643.0,
            451.0,
            830.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:16.100000",
        "id": 16,
        "className": "Person",
        coords: [
            341.0,
            352.0,
            431.0,
            602.0
        ],
        "status": "Moving",
        "speed": 74.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:16.100000",
        "id": 9,
        "className": "Person",
        coords: [
            509.0,
            238.0,
            561.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:16.200000",
        "id": 13,
        "className": "Person",
        coords: [
            490.0,
            177.0,
            536.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:16.200000",
        "id": 15,
        "className": "Person",
        coords: [
            643.0,
            451.0,
            830.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:16.200000",
        "id": 16,
        "className": "Person",
        coords: [
            347.0,
            355.0,
            435.0,
            599.0
        ],
        "status": "Moving",
        "speed": 74.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:16.300000",
        "id": 9,
        "className": "Person",
        coords: [
            510.0,
            238.0,
            562.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:16.300000",
        "id": 13,
        "className": "Person",
        coords: [
            490.0,
            177.0,
            535.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:16.300000",
        "id": 15,
        "className": "Person",
        coords: [
            644.0,
            451.0,
            834.0,
            605.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:16.400000",
        "id": 16,
        "className": "Person",
        coords: [
            349.0,
            357.0,
            437.0,
            599.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:16.400000",
        "id": 17,
        "className": "Person",
        coords: [
            311.0,
            542.0,
            488.0,
            718.0
        ],
        "status": "First Seen",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:16:16.400000",
        "id": 9,
        "className": "Person",
        coords: [
            511.0,
            238.0,
            563.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:16.500000",
        "id": 13,
        "className": "Person",
        coords: [
            491.0,
            177.0,
            535.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:16.500000",
        "id": 15,
        "className": "Person",
        coords: [
            643.0,
            451.0,
            831.0,
            604.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:16.500000",
        "id": 16,
        "className": "Person",
        coords: [
            352.0,
            361.0,
            439.0,
            599.0
        ],
        "status": "Moving",
        "speed": 42.42,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:16.600000",
        "id": 17,
        "className": "Person",
        coords: [
            307.0,
            541.0,
            484.0,
            718.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:16:16.600000",
        "id": 9,
        "className": "Person",
        coords: [
            511.0,
            238.0,
            563.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:16.600000",
        "id": 13,
        "className": "Person",
        coords: [
            491.0,
            177.0,
            535.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:16.600000",
        "id": 15,
        "className": "Person",
        coords: [
            643.0,
            451.0,
            831.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:16.700000",
        "id": 16,
        "className": "Person",
        coords: [
            354.0,
            362.0,
            444.0,
            602.0
        ],
        "status": "Moving",
        "speed": 67.08,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:16.700000",
        "id": 17,
        "className": "Person",
        coords: [
            305.0,
            540.0,
            481.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:16:16.800000",
        "id": 9,
        "className": "Person",
        coords: [
            511.0,
            238.0,
            563.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:16.800000",
        "id": 13,
        "className": "Person",
        coords: [
            492.0,
            178.0,
            534.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:16.800000",
        "id": 15,
        "className": "Person",
        coords: [
            642.0,
            451.0,
            830.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:16.900000",
        "id": 16,
        "className": "Person",
        coords: [
            370.0,
            366.0,
            465.0,
            610.0
        ],
        "status": "Moving",
        "speed": 284.58,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:16.900000",
        "id": 17,
        "className": "Person",
        coords: [
            304.0,
            539.0,
            481.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:16:16.900000",
        "id": 9,
        "className": "Person",
        coords: [
            511.0,
            238.0,
            563.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:17",
        "id": 13,
        "className": "Person",
        coords: [
            492.0,
            178.0,
            534.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:17",
        "id": 15,
        "className": "Person",
        coords: [
            642.0,
            451.0,
            830.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:17",
        "id": 16,
        "className": "Person",
        coords: [
            379.0,
            367.0,
            479.0,
            615.0
        ],
        "status": "Moving",
        "speed": 185.52,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:17",
        "id": 17,
        "className": "Person",
        coords: [
            304.0,
            538.0,
            482.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:17.100000",
        "id": 9,
        "className": "Person",
        coords: [
            511.0,
            238.0,
            563.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:17.100000",
        "id": 13,
        "className": "Person",
        coords: [
            492.0,
            177.0,
            534.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:17.200000",
        "id": 15,
        "className": "Person",
        coords: [
            642.0,
            451.0,
            830.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:17.200000",
        "id": 16,
        "className": "Person",
        coords: [
            391.0,
            371.0,
            490.0,
            618.0
        ],
        "status": "Moving",
        "speed": 171.01,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:17.200000",
        "id": 17,
        "className": "Person",
        coords: [
            304.0,
            538.0,
            480.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:17.300000",
        "id": 9,
        "className": "Person",
        coords: [
            512.0,
            238.0,
            563.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:17.300000",
        "id": 13,
        "className": "Person",
        coords: [
            492.0,
            177.0,
            534.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:17.400000",
        "id": 15,
        "className": "Person",
        coords: [
            642.0,
            451.0,
            831.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:17.400000",
        "id": 16,
        "className": "Person",
        coords: [
            399.0,
            374.0,
            497.0,
            618.0
        ],
        "status": "Moving",
        "speed": 123.68,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:17.500000",
        "id": 17,
        "className": "Person",
        coords: [
            304.0,
            538.0,
            479.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:17.500000",
        "id": 9,
        "className": "Person",
        coords: [
            512.0,
            238.0,
            563.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:17.600000",
        "id": 13,
        "className": "Person",
        coords: [
            492.0,
            178.0,
            533.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:17.600000",
        "id": 15,
        "className": "Person",
        coords: [
            642.0,
            451.0,
            831.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:17.600000",
        "id": 16,
        "className": "Person",
        coords: [
            407.0,
            373.0,
            505.0,
            617.0
        ],
        "status": "Moving",
        "speed": 120.92,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:17.600000",
        "id": 17,
        "className": "Person",
        coords: [
            305.0,
            538.0,
            478.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:17.700000",
        "id": 9,
        "className": "Person",
        coords: [
            512.0,
            238.0,
            563.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:17.800000",
        "id": 13,
        "className": "Person",
        coords: [
            492.0,
            178.0,
            533.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:17.800000",
        "id": 15,
        "className": "Person",
        coords: [
            642.0,
            451.0,
            831.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:17.800000",
        "id": 16,
        "className": "Person",
        coords: [
            415.0,
            377.0,
            511.0,
            617.0
        ],
        "status": "Moving",
        "speed": 109.19,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:17.900000",
        "id": 17,
        "className": "Person",
        coords: [
            304.0,
            538.0,
            476.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:17.900000",
        "id": 9,
        "className": "Person",
        coords: [
            512.0,
            238.0,
            563.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:17.900000",
        "id": 13,
        "className": "Person",
        coords: [
            492.0,
            178.0,
            532.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:18",
        "id": 15,
        "className": "Person",
        coords: [
            642.0,
            451.0,
            831.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:18",
        "id": 16,
        "className": "Person",
        coords: [
            425.0,
            380.0,
            519.0,
            617.0
        ],
        "status": "Moving",
        "speed": 135.82,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:18.100000",
        "id": 9,
        "className": "Person",
        coords: [
            512.0,
            238.0,
            563.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:18.100000",
        "id": 13,
        "className": "Person",
        coords: [
            491.0,
            178.0,
            532.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:18.100000",
        "id": 15,
        "className": "Person",
        coords: [
            642.0,
            451.0,
            831.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:18.100000",
        "id": 16,
        "className": "Person",
        coords: [
            434.0,
            382.0,
            532.0,
            628.0
        ],
        "status": "Moving",
        "speed": 195.56,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:18.200000",
        "id": 9,
        "className": "Person",
        coords: [
            512.0,
            238.0,
            563.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:18.200000",
        "id": 13,
        "className": "Person",
        coords: [
            491.0,
            177.0,
            532.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:18.200000",
        "id": 15,
        "className": "Person",
        coords: [
            642.0,
            451.0,
            831.0,
            604.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:18.300000",
        "id": 16,
        "className": "Person",
        coords: [
            440.0,
            384.0,
            541.0,
            642.0
        ],
        "status": "Moving",
        "speed": 159.44,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:18.300000",
        "id": 9,
        "className": "Person",
        coords: [
            512.0,
            239.0,
            563.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:18.300000",
        "id": 13,
        "className": "Person",
        coords: [
            491.0,
            177.0,
            532.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:18.400000",
        "id": 15,
        "className": "Person",
        coords: [
            642.0,
            451.0,
            831.0,
            604.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:18.400000",
        "id": 16,
        "className": "Person",
        coords: [
            447.0,
            388.0,
            550.0,
            648.0
        ],
        "status": "Moving",
        "speed": 141.5,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:18.400000",
        "id": 17,
        "className": "Person",
        coords: [
            301.0,
            541.0,
            468.0,
            717.0
        ],
        "status": "Moving",
        "speed": 91.23,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:18.500000",
        "id": 9,
        "className": "Person",
        coords: [
            513.0,
            239.0,
            563.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:18.500000",
        "id": 13,
        "className": "Person",
        coords: [
            491.0,
            177.0,
            532.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:18.600000",
        "id": 15,
        "className": "Person",
        coords: [
            643.0,
            451.0,
            832.0,
            604.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:18.600000",
        "id": 16,
        "className": "Person",
        coords: [
            455.0,
            393.0,
            558.0,
            651.0
        ],
        "status": "Moving",
        "speed": 134.15,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:18.600000",
        "id": 17,
        "className": "Person",
        coords: [
            301.0,
            541.0,
            467.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:18.700000",
        "id": 9,
        "className": "Person",
        coords: [
            513.0,
            239.0,
            563.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:18.700000",
        "id": 13,
        "className": "Person",
        coords: [
            491.0,
            177.0,
            531.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:18.700000",
        "id": 15,
        "className": "Person",
        coords: [
            641.0,
            451.0,
            831.0,
            604.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:18.700000",
        "id": 16,
        "className": "Person",
        coords: [
            459.0,
            398.0,
            564.0,
            653.0
        ],
        "status": "Moving",
        "speed": 87.46,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:18.800000",
        "id": 17,
        "className": "Person",
        coords: [
            301.0,
            541.0,
            466.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:18.900000",
        "id": 9,
        "className": "Person",
        coords: [
            512.0,
            238.0,
            563.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:18.900000",
        "id": 13,
        "className": "Person",
        coords: [
            492.0,
            177.0,
            532.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:18.900000",
        "id": 15,
        "className": "Person",
        coords: [
            646.0,
            451.0,
            835.0,
            604.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:18.900000",
        "id": 16,
        "className": "Person",
        coords: [
            476.0,
            402.0,
            577.0,
            653.0
        ],
        "status": "Moving",
        "speed": 226.97,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:19",
        "id": 17,
        "className": "Person",
        coords: [
            303.0,
            541.0,
            466.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:19.100000",
        "id": 9,
        "className": "Person",
        coords: [
            512.0,
            238.0,
            562.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:19.100000",
        "id": 13,
        "className": "Person",
        coords: [
            492.0,
            176.0,
            532.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:19.100000",
        "id": 15,
        "className": "Person",
        coords: [
            647.0,
            451.0,
            835.0,
            604.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:19.100000",
        "id": 16,
        "className": "Person",
        coords: [
            471.0,
            405.0,
            574.0,
            651.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:19.200000",
        "id": 17,
        "className": "Person",
        coords: [
            304.0,
            542.0,
            465.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:19.200000",
        "id": 9,
        "className": "Person",
        coords: [
            512.0,
            238.0,
            562.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:19.300000",
        "id": 13,
        "className": "Person",
        coords: [
            492.0,
            176.0,
            532.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:19.300000",
        "id": 15,
        "className": "Person",
        coords: [
            648.0,
            451.0,
            837.0,
            606.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:19.300000",
        "id": 16,
        "className": "Person",
        coords: [
            479.0,
            406.0,
            583.0,
            651.0
        ],
        "status": "Moving",
        "speed": 134.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:19.300000",
        "id": 17,
        "className": "Person",
        coords: [
            305.0,
            543.0,
            464.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:19.400000",
        "id": 9,
        "className": "Person",
        coords: [
            512.0,
            238.0,
            562.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:19.400000",
        "id": 13,
        "className": "Person",
        coords: [
            492.0,
            176.0,
            532.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:19.400000",
        "id": 15,
        "className": "Person",
        coords: [
            645.0,
            451.0,
            833.0,
            605.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:19.500000",
        "id": 16,
        "className": "Person",
        coords: [
            490.0,
            407.0,
            595.0,
            651.0
        ],
        "status": "Moving",
        "speed": 165.67,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:19.500000",
        "id": 17,
        "className": "Person",
        coords: [
            306.0,
            542.0,
            464.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:19.600000",
        "id": 9,
        "className": "Person",
        coords: [
            512.0,
            238.0,
            562.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:19.600000",
        "id": 13,
        "className": "Person",
        coords: [
            493.0,
            176.0,
            532.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:19.600000",
        "id": 15,
        "className": "Person",
        coords: [
            644.0,
            451.0,
            831.0,
            605.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:19.600000",
        "id": 16,
        "className": "Person",
        coords: [
            503.0,
            408.0,
            606.0,
            651.0
        ],
        "status": "Moving",
        "speed": 179.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:19.700000",
        "id": 17,
        "className": "Person",
        coords: [
            306.0,
            543.0,
            464.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:19.800000",
        "id": 9,
        "className": "Person",
        coords: [
            511.0,
            238.0,
            562.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:19.800000",
        "id": 13,
        "className": "Person",
        coords: [
            493.0,
            176.0,
            532.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:19.800000",
        "id": 15,
        "className": "Person",
        coords: [
            652.0,
            451.0,
            837.0,
            605.0
        ],
        "status": "Moving",
        "speed": 104.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:19.800000",
        "id": 16,
        "className": "Person",
        coords: [
            517.0,
            409.0,
            619.0,
            650.0
        ],
        "status": "Moving",
        "speed": 209.98,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:19.900000",
        "id": 17,
        "className": "Person",
        coords: [
            306.0,
            542.0,
            464.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:19.900000",
        "id": 9,
        "className": "Person",
        coords: [
            511.0,
            238.0,
            562.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:20",
        "id": 13,
        "className": "Person",
        coords: [
            493.0,
            176.0,
            532.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:20",
        "id": 15,
        "className": "Person",
        coords: [
            664.0,
            451.0,
            845.0,
            605.0
        ],
        "status": "Moving",
        "speed": 149.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:20.100000",
        "id": 16,
        "className": "Person",
        coords: [
            527.0,
            410.0,
            628.0,
            650.0
        ],
        "status": "Moving",
        "speed": 135.82,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:20.100000",
        "id": 17,
        "className": "Person",
        coords: [
            307.0,
            543.0,
            463.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:20.200000",
        "id": 9,
        "className": "Person",
        coords: [
            511.0,
            238.0,
            562.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:20.200000",
        "id": 13,
        "className": "Person",
        coords: [
            492.0,
            176.0,
            532.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:20.300000",
        "id": 15,
        "className": "Person",
        coords: [
            669.0,
            451.0,
            847.0,
            605.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:20.300000",
        "id": 16,
        "className": "Person",
        coords: [
            536.0,
            412.0,
            639.0,
            649.0
        ],
        "status": "Moving",
        "speed": 149.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:20.300000",
        "id": 17,
        "className": "Person",
        coords: [
            308.0,
            543.0,
            464.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:20.400000",
        "id": 9,
        "className": "Person",
        coords: [
            512.0,
            238.0,
            563.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:20.400000",
        "id": 13,
        "className": "Person",
        coords: [
            492.0,
            176.0,
            532.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:20.400000",
        "id": 15,
        "className": "Person",
        coords: [
            678.0,
            451.0,
            849.0,
            603.0
        ],
        "status": "Moving",
        "speed": 76.48,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:20.500000",
        "id": 16,
        "className": "Person",
        coords: [
            545.0,
            413.0,
            651.0,
            650.0
        ],
        "status": "Moving",
        "speed": 165.67,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:20.500000",
        "id": 17,
        "className": "Person",
        coords: [
            309.0,
            543.0,
            465.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:20.600000",
        "id": 9,
        "className": "Person",
        coords: [
            512.0,
            238.0,
            563.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:20.600000",
        "id": 13,
        "className": "Person",
        coords: [
            491.0,
            176.0,
            531.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:20.600000",
        "id": 15,
        "className": "Person",
        coords: [
            688.0,
            451.0,
            853.0,
            601.0
        ],
        "status": "Moving",
        "speed": 106.06,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:20.700000",
        "id": 16,
        "className": "Person",
        coords: [
            549.0,
            416.0,
            659.0,
            650.0
        ],
        "status": "Moving",
        "speed": 94.86,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:20.700000",
        "id": 17,
        "className": "Person",
        coords: [
            313.0,
            542.0,
            467.0,
            718.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:20.800000",
        "id": 9,
        "className": "Person",
        coords: [
            512.0,
            238.0,
            563.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:20.800000",
        "id": 13,
        "className": "Person",
        coords: [
            491.0,
            176.0,
            530.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:20.800000",
        "id": 15,
        "className": "Person",
        coords: [
            686.0,
            451.0,
            849.0,
            603.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:20.900000",
        "id": 16,
        "className": "Person",
        coords: [
            552.0,
            418.0,
            665.0,
            650.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:20.900000",
        "id": 17,
        "className": "Person",
        coords: [
            316.0,
            543.0,
            468.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:21",
        "id": 9,
        "className": "Person",
        coords: [
            512.0,
            238.0,
            563.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:21",
        "id": 13,
        "className": "Person",
        coords: [
            491.0,
            176.0,
            530.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:21",
        "id": 15,
        "className": "Person",
        coords: [
            693.0,
            451.0,
            850.0,
            602.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:21.100000",
        "id": 16,
        "className": "Person",
        coords: [
            556.0,
            418.0,
            673.0,
            653.0
        ],
        "status": "Moving",
        "speed": 91.23,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:21.100000",
        "id": 17,
        "className": "Person",
        coords: [
            317.0,
            543.0,
            468.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:21.200000",
        "id": 9,
        "className": "Person",
        coords: [
            512.0,
            238.0,
            563.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:21.200000",
        "id": 13,
        "className": "Person",
        coords: [
            491.0,
            176.0,
            530.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:21.200000",
        "id": 15,
        "className": "Person",
        coords: [
            698.0,
            452.0,
            850.0,
            600.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:21.200000",
        "id": 16,
        "className": "Person",
        coords: [
            571.0,
            418.0,
            688.0,
            652.0
        ],
        "status": "Moving",
        "speed": 224.98,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:21.300000",
        "id": 17,
        "className": "Person",
        coords: [
            318.0,
            543.0,
            467.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:21.300000",
        "id": 9,
        "className": "Person",
        coords: [
            512.0,
            238.0,
            563.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:21.300000",
        "id": 13,
        "className": "Person",
        coords: [
            491.0,
            176.0,
            531.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:21.400000",
        "id": 15,
        "className": "Person",
        coords: [
            702.0,
            452.0,
            849.0,
            600.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:21.400000",
        "id": 17,
        "className": "Person",
        coords: [
            320.0,
            543.0,
            467.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:21.500000",
        "id": 9,
        "className": "Person",
        coords: [
            512.0,
            238.0,
            563.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:21.500000",
        "id": 13,
        "className": "Person",
        coords: [
            491.0,
            176.0,
            531.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:21.500000",
        "id": 15,
        "className": "Person",
        coords: [
            705.0,
            452.0,
            848.0,
            599.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:21.600000",
        "id": 17,
        "className": "Person",
        coords: [
            322.0,
            543.0,
            468.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:21.600000",
        "id": 16,
        "className": "Person",
        coords: [
            599.0,
            417.0,
            722.0,
            668.0
        ],
        "status": "Moving",
        "speed": 476.67,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:21.700000",
        "id": 9,
        "className": "Person",
        coords: [
            512.0,
            237.0,
            562.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:21.700000",
        "id": 15,
        "className": "Person",
        coords: [
            704.0,
            452.0,
            845.0,
            600.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:21.700000",
        "id": 17,
        "className": "Person",
        coords: [
            323.0,
            543.0,
            467.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:21.700000",
        "id": 16,
        "className": "Person",
        coords: [
            613.0,
            419.0,
            738.0,
            679.0
        ],
        "status": "Moving",
        "speed": 248.27,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:21.800000",
        "id": 9,
        "className": "Person",
        coords: [
            512.0,
            237.0,
            562.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:21.800000",
        "id": 15,
        "className": "Person",
        coords: [
            702.0,
            452.0,
            842.0,
            601.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:21.900000",
        "id": 17,
        "className": "Person",
        coords: [
            325.0,
            543.0,
            468.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:21.900000",
        "id": 16,
        "className": "Person",
        coords: [
            620.0,
            419.0,
            747.0,
            688.0
        ],
        "status": "Moving",
        "speed": 134.15,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:21.900000",
        "id": 9,
        "className": "Person",
        coords: [
            511.0,
            237.0,
            562.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:22",
        "id": 15,
        "className": "Person",
        coords: [
            706.0,
            452.0,
            843.0,
            600.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:22",
        "id": 17,
        "className": "Person",
        coords: [
            327.0,
            543.0,
            468.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:22",
        "id": 16,
        "className": "Person",
        coords: [
            630.0,
            422.0,
            758.0,
            689.0
        ],
        "status": "Moving",
        "speed": 167.69,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:22",
        "id": 13,
        "className": "Person",
        coords: [
            490.0,
            177.0,
            529.0,
            263.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:22.100000",
        "id": 9,
        "className": "Person",
        coords: [
            511.0,
            237.0,
            562.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:22.200000",
        "id": 15,
        "className": "Person",
        coords: [
            711.0,
            451.0,
            845.0,
            600.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:22.200000",
        "id": 17,
        "className": "Person",
        coords: [
            322.0,
            543.0,
            462.0,
            718.0
        ],
        "status": "Moving",
        "speed": 74.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:22.200000",
        "id": 16,
        "className": "Person",
        coords: [
            642.0,
            425.0,
            769.0,
            687.0
        ],
        "status": "Moving",
        "speed": 165.67,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:22.200000",
        "id": 13,
        "className": "Person",
        coords: [
            489.0,
            177.0,
            528.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:22.300000",
        "id": 9,
        "className": "Person",
        coords: [
            511.0,
            237.0,
            562.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:22.300000",
        "id": 15,
        "className": "Person",
        coords: [
            719.0,
            451.0,
            848.0,
            599.0
        ],
        "status": "Moving",
        "speed": 74.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:22.300000",
        "id": 17,
        "className": "Person",
        coords: [
            327.0,
            543.0,
            466.0,
            718.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:22.400000",
        "id": 16,
        "className": "Person",
        coords: [
            644.0,
            429.0,
            774.0,
            688.0
        ],
        "status": "Moving",
        "speed": 67.08,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:22.400000",
        "id": 13,
        "className": "Person",
        coords: [
            491.0,
            177.0,
            531.0,
            263.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:22.400000",
        "id": 9,
        "className": "Person",
        coords: [
            512.0,
            237.0,
            563.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:22.500000",
        "id": 15,
        "className": "Person",
        coords: [
            729.0,
            451.0,
            853.0,
            598.0
        ],
        "status": "Moving",
        "speed": 120.92,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:22.500000",
        "id": 17,
        "className": "Person",
        coords: [
            320.0,
            541.0,
            461.0,
            718.0
        ],
        "status": "Moving",
        "speed": 91.23,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:22.500000",
        "id": 16,
        "className": "Person",
        coords: [
            647.0,
            432.0,
            778.0,
            688.0
        ],
        "status": "Moving",
        "speed": 54.08,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:22.500000",
        "id": 13,
        "className": "Person",
        coords: [
            492.0,
            177.0,
            533.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:22.600000",
        "id": 9,
        "className": "Person",
        coords: [
            512.0,
            237.0,
            563.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:22.600000",
        "id": 15,
        "className": "Person",
        coords: [
            738.0,
            450.0,
            855.0,
            596.0
        ],
        "status": "Moving",
        "speed": 76.48,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:22.700000",
        "id": 17,
        "className": "Person",
        coords: [
            318.0,
            540.0,
            459.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:22.700000",
        "id": 16,
        "className": "Person",
        coords: [
            656.0,
            434.0,
            786.0,
            686.0
        ],
        "status": "Moving",
        "speed": 134.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:22.700000",
        "id": 13,
        "className": "Person",
        coords: [
            493.0,
            178.0,
            534.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:22.800000",
        "id": 9,
        "className": "Person",
        coords: [
            511.0,
            237.0,
            562.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:22.800000",
        "id": 17,
        "className": "Person",
        coords: [
            326.0,
            538.0,
            466.0,
            718.0
        ],
        "status": "Moving",
        "speed": 120.92,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:22.800000",
        "id": 16,
        "className": "Person",
        coords: [
            686.0,
            434.0,
            811.0,
            687.0
        ],
        "status": "Moving",
        "speed": 404.97,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:22.800000",
        "id": 13,
        "className": "Person",
        coords: [
            491.0,
            177.0,
            532.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:22.900000",
        "id": 9,
        "className": "Person",
        coords: [
            512.0,
            237.0,
            563.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:22.900000",
        "id": 17,
        "className": "Person",
        coords: [
            317.0,
            537.0,
            458.0,
            718.0
        ],
        "status": "Moving",
        "speed": 135.82,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:22.900000",
        "id": 16,
        "className": "Person",
        coords: [
            687.0,
            433.0,
            814.0,
            690.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:23",
        "id": 13,
        "className": "Person",
        coords: [
            490.0,
            177.0,
            532.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:23",
        "id": 9,
        "className": "Person",
        coords: [
            511.0,
            238.0,
            562.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:23",
        "id": 16,
        "className": "Person",
        coords: [
            701.0,
            434.0,
            826.0,
            687.0
        ],
        "status": "Moving",
        "speed": 195.56,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:23",
        "id": 13,
        "className": "Person",
        coords: [
            491.0,
            178.0,
            532.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:23.100000",
        "id": 9,
        "className": "Person",
        coords: [
            511.0,
            238.0,
            562.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:23.100000",
        "id": 16,
        "className": "Person",
        coords: [
            716.0,
            434.0,
            838.0,
            686.0
        ],
        "status": "Moving",
        "speed": 209.98,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:23.100000",
        "id": 13,
        "className": "Person",
        coords: [
            491.0,
            178.0,
            532.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:23.200000",
        "id": 17,
        "className": "Person",
        coords: [
            311.0,
            533.0,
            455.0,
            718.0
        ],
        "status": "Moving",
        "speed": 67.08,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:23.200000",
        "id": 9,
        "className": "Person",
        coords: [
            511.0,
            238.0,
            562.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:23.300000",
        "id": 16,
        "className": "Person",
        coords: [
            725.0,
            436.0,
            844.0,
            685.0
        ],
        "status": "Moving",
        "speed": 104.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:23.300000",
        "id": 13,
        "className": "Person",
        coords: [
            490.0,
            178.0,
            531.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:23.300000",
        "id": 17,
        "className": "Person",
        coords: [
            310.0,
            532.0,
            454.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:23.400000",
        "id": 9,
        "className": "Person",
        coords: [
            511.0,
            238.0,
            562.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:23.400000",
        "id": 16,
        "className": "Person",
        coords: [
            732.0,
            437.0,
            852.0,
            686.0
        ],
        "status": "Moving",
        "speed": 120.92,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:23.400000",
        "id": 13,
        "className": "Person",
        coords: [
            491.0,
            178.0,
            533.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:23.400000",
        "id": 17,
        "className": "Person",
        coords: [
            309.0,
            532.0,
            453.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:23.500000",
        "id": 9,
        "className": "Person",
        coords: [
            511.0,
            238.0,
            562.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:23.500000",
        "id": 16,
        "className": "Person",
        coords: [
            737.0,
            439.0,
            858.0,
            687.0
        ],
        "status": "Moving",
        "speed": 80.77,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:23.500000",
        "id": 13,
        "className": "Person",
        coords: [
            493.0,
            178.0,
            535.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:23.600000",
        "id": 17,
        "className": "Person",
        coords: [
            310.0,
            531.0,
            454.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:23.600000",
        "id": 9,
        "className": "Person",
        coords: [
            511.0,
            238.0,
            563.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:23.600000",
        "id": 16,
        "className": "Person",
        coords: [
            740.0,
            440.0,
            862.0,
            687.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:23.700000",
        "id": 13,
        "className": "Person",
        coords: [
            493.0,
            178.0,
            536.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:23.700000",
        "id": 17,
        "className": "Person",
        coords: [
            321.0,
            532.0,
            461.0,
            718.0
        ],
        "status": "Moving",
        "speed": 135.82,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:23.700000",
        "id": 9,
        "className": "Person",
        coords: [
            512.0,
            238.0,
            563.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:23.800000",
        "id": 16,
        "className": "Person",
        coords: [
            745.0,
            440.0,
            871.0,
            687.0
        ],
        "status": "Moving",
        "speed": 104.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:23.800000",
        "id": 13,
        "className": "Person",
        coords: [
            492.0,
            178.0,
            535.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:23.800000",
        "id": 17,
        "className": "Person",
        coords: [
            326.0,
            532.0,
            463.0,
            718.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:23.900000",
        "id": 9,
        "className": "Person",
        coords: [
            512.0,
            237.0,
            564.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:23.900000",
        "id": 16,
        "className": "Person",
        coords: [
            755.0,
            439.0,
            882.0,
            688.0
        ],
        "status": "Moving",
        "speed": 149.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:23.900000",
        "id": 13,
        "className": "Person",
        coords: [
            493.0,
            178.0,
            536.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:23.900000",
        "id": 17,
        "className": "Person",
        coords: [
            329.0,
            532.0,
            463.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:24",
        "id": 9,
        "className": "Person",
        coords: [
            512.0,
            237.0,
            565.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:24",
        "id": 13,
        "className": "Person",
        coords: [
            493.0,
            178.0,
            537.0,
            265.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:24",
        "id": 17,
        "className": "Person",
        coords: [
            331.0,
            532.0,
            462.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:24.100000",
        "id": 9,
        "className": "Person",
        coords: [
            512.0,
            237.0,
            565.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:24.100000",
        "id": 13,
        "className": "Person",
        coords: [
            493.0,
            178.0,
            537.0,
            265.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:24.100000",
        "id": 17,
        "className": "Person",
        coords: [
            332.0,
            532.0,
            461.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:24.200000",
        "id": 16,
        "className": "Person",
        coords: [
            791.0,
            434.0,
            914.0,
            677.0
        ],
        "status": "Moving",
        "speed": 523.88,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:24.200000",
        "id": 9,
        "className": "Person",
        coords: [
            512.0,
            237.0,
            565.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:24.200000",
        "id": 13,
        "className": "Person",
        coords: [
            493.0,
            178.0,
            537.0,
            265.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:24.300000",
        "id": 17,
        "className": "Person",
        coords: [
            333.0,
            532.0,
            460.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:24.300000",
        "id": 16,
        "className": "Person",
        coords: [
            803.0,
            432.0,
            926.0,
            681.0
        ],
        "status": "Moving",
        "speed": 180.61,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:24.300000",
        "id": 9,
        "className": "Person",
        coords: [
            512.0,
            237.0,
            564.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:24.400000",
        "id": 13,
        "className": "Person",
        coords: [
            493.0,
            179.0,
            537.0,
            265.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:24.400000",
        "id": 17,
        "className": "Person",
        coords: [
            334.0,
            533.0,
            459.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:24.400000",
        "id": 16,
        "className": "Person",
        coords: [
            811.0,
            433.0,
            934.0,
            683.0
        ],
        "status": "Moving",
        "speed": 123.68,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:24.500000",
        "id": 9,
        "className": "Person",
        coords: [
            511.0,
            237.0,
            564.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:24.500000",
        "id": 13,
        "className": "Person",
        coords: [
            494.0,
            178.0,
            539.0,
            265.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:24.500000",
        "id": 17,
        "className": "Person",
        coords: [
            335.0,
            533.0,
            458.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:24.500000",
        "id": 16,
        "className": "Person",
        coords: [
            817.0,
            433.0,
            940.0,
            685.0
        ],
        "status": "Moving",
        "speed": 91.23,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:24.600000",
        "id": 9,
        "className": "Person",
        coords: [
            511.0,
            237.0,
            564.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:24.600000",
        "id": 13,
        "className": "Person",
        coords: [
            493.0,
            179.0,
            537.0,
            265.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:24.600000",
        "id": 17,
        "className": "Person",
        coords: [
            336.0,
            533.0,
            457.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:24.700000",
        "id": 16,
        "className": "Person",
        coords: [
            821.0,
            435.0,
            948.0,
            693.0
        ],
        "status": "Moving",
        "speed": 117.14,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:24.700000",
        "id": 9,
        "className": "Person",
        coords: [
            512.0,
            237.0,
            564.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:24.700000",
        "id": 13,
        "className": "Person",
        coords: [
            494.0,
            179.0,
            538.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:24.800000",
        "id": 17,
        "className": "Person",
        coords: [
            337.0,
            533.0,
            457.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:24.800000",
        "id": 16,
        "className": "Person",
        coords: [
            824.0,
            437.0,
            953.0,
            696.0
        ],
        "status": "Moving",
        "speed": 67.08,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:24.900000",
        "id": 9,
        "className": "Person",
        coords: [
            512.0,
            237.0,
            564.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:24.900000",
        "id": 13,
        "className": "Person",
        coords: [
            492.0,
            178.0,
            536.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:24.900000",
        "id": 17,
        "className": "Person",
        coords: [
            337.0,
            533.0,
            456.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:25",
        "id": 9,
        "className": "Person",
        coords: [
            513.0,
            237.0,
            564.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:25",
        "id": 13,
        "className": "Person",
        coords: [
            495.0,
            179.0,
            539.0,
            264.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:25",
        "id": 17,
        "className": "Person",
        coords: [
            338.0,
            534.0,
            455.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:25.100000",
        "id": 16,
        "className": "Person",
        coords: [
            838.0,
            440.0,
            961.0,
            677.0
        ],
        "status": "Moving",
        "speed": 204.01,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:25.100000",
        "id": 9,
        "className": "Person",
        coords: [
            513.0,
            237.0,
            565.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:25.200000",
        "id": 13,
        "className": "Person",
        coords: [
            495.0,
            179.0,
            540.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:25.200000",
        "id": 17,
        "className": "Person",
        coords: [
            338.0,
            534.0,
            455.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:25.200000",
        "id": 16,
        "className": "Person",
        coords: [
            871.0,
            441.0,
            988.0,
            673.0
        ],
        "status": "Moving",
        "speed": 450.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:25.200000",
        "id": 9,
        "className": "Person",
        coords: [
            513.0,
            237.0,
            565.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:25.300000",
        "id": 13,
        "className": "Person",
        coords: [
            496.0,
            179.0,
            541.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:25.300000",
        "id": 17,
        "className": "Person",
        coords: [
            339.0,
            534.0,
            455.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:25.300000",
        "id": 16,
        "className": "Person",
        coords: [
            862.0,
            441.0,
            985.0,
            680.0
        ],
        "status": "Moving",
        "speed": 100.61,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:25.400000",
        "id": 9,
        "className": "Person",
        coords: [
            513.0,
            237.0,
            565.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:25.400000",
        "id": 17,
        "className": "Person",
        coords: [
            339.0,
            534.0,
            454.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:25.400000",
        "id": 16,
        "className": "Person",
        coords: [
            872.0,
            440.0,
            992.0,
            668.0
        ],
        "status": "Moving",
        "speed": 162.24,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:25.500000",
        "id": 9,
        "className": "Person",
        coords: [
            514.0,
            237.0,
            565.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:25.500000",
        "id": 17,
        "className": "Person",
        coords: [
            340.0,
            534.0,
            454.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:25.500000",
        "id": 16,
        "className": "Person",
        coords: [
            885.0,
            438.0,
            1001.0,
            655.0
        ],
        "status": "Moving",
        "speed": 204.01,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:25.600000",
        "id": 9,
        "className": "Person",
        coords: [
            513.0,
            237.0,
            564.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:25.600000",
        "id": 17,
        "className": "Person",
        coords: [
            340.0,
            534.0,
            453.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:25.600000",
        "id": 16,
        "className": "Person",
        coords: [
            897.0,
            438.0,
            1016.0,
            662.0
        ],
        "status": "Moving",
        "speed": 204.01,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:25.600000",
        "id": 13,
        "className": "Person",
        coords: [
            489.0,
            180.0,
            532.0,
            264.0
        ],
        "status": "Moving",
        "speed": 120.92,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:25.700000",
        "id": 9,
        "className": "Person",
        coords: [
            512.0,
            237.0,
            564.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:25.700000",
        "id": 17,
        "className": "Person",
        coords: [
            340.0,
            533.0,
            452.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:25.800000",
        "id": 16,
        "className": "Person",
        coords: [
            910.0,
            438.0,
            1025.0,
            654.0
        ],
        "status": "Moving",
        "speed": 175.56,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:25.800000",
        "id": 13,
        "className": "Person",
        coords: [
            488.0,
            180.0,
            530.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:25.900000",
        "id": 9,
        "className": "Person",
        coords: [
            512.0,
            237.0,
            564.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:25.900000",
        "id": 17,
        "className": "Person",
        coords: [
            340.0,
            533.0,
            452.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:25.900000",
        "id": 16,
        "className": "Person",
        coords: [
            923.0,
            435.0,
            1037.0,
            650.0
        ],
        "status": "Moving",
        "speed": 204.01,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:25.900000",
        "id": 13,
        "className": "Person",
        coords: [
            488.0,
            180.0,
            529.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:26",
        "id": 9,
        "className": "Person",
        coords: [
            511.0,
            237.0,
            564.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:26",
        "id": 17,
        "className": "Person",
        coords: [
            340.0,
            533.0,
            452.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:26.100000",
        "id": 16,
        "className": "Person",
        coords: [
            931.0,
            435.0,
            1042.0,
            646.0
        ],
        "status": "Moving",
        "speed": 94.86,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:26.100000",
        "id": 13,
        "className": "Person",
        coords: [
            488.0,
            180.0,
            529.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:26.100000",
        "id": 9,
        "className": "Person",
        coords: [
            511.0,
            237.0,
            564.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:26.200000",
        "id": 17,
        "className": "Person",
        coords: [
            340.0,
            533.0,
            452.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:26.200000",
        "id": 16,
        "className": "Person",
        coords: [
            938.0,
            438.0,
            1046.0,
            646.0
        ],
        "status": "Moving",
        "speed": 94.86,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:26.200000",
        "id": 13,
        "className": "Person",
        coords: [
            489.0,
            180.0,
            528.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:26.300000",
        "id": 9,
        "className": "Person",
        coords: [
            511.0,
            237.0,
            564.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:26.300000",
        "id": 17,
        "className": "Person",
        coords: [
            340.0,
            534.0,
            452.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:26.300000",
        "id": 16,
        "className": "Person",
        coords: [
            931.0,
            438.0,
            1043.0,
            650.0
        ],
        "status": "Moving",
        "speed": 80.77,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:26.300000",
        "id": 13,
        "className": "Person",
        coords: [
            489.0,
            181.0,
            527.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:26.400000",
        "id": 9,
        "className": "Person",
        coords: [
            511.0,
            237.0,
            564.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:26.400000",
        "id": 17,
        "className": "Person",
        coords: [
            340.0,
            534.0,
            451.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:26.500000",
        "id": 16,
        "className": "Person",
        coords: [
            934.0,
            436.0,
            1045.0,
            644.0
        ],
        "status": "Moving",
        "speed": 67.08,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:26.500000",
        "id": 13,
        "className": "Person",
        coords: [
            489.0,
            182.0,
            526.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:26.600000",
        "id": 9,
        "className": "Person",
        coords: [
            510.0,
            236.0,
            564.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:26.600000",
        "id": 17,
        "className": "Person",
        coords: [
            341.0,
            534.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:26.600000",
        "id": 16,
        "className": "Person",
        coords: [
            944.0,
            433.0,
            1054.0,
            641.0
        ],
        "status": "Moving",
        "speed": 156.59,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:26.600000",
        "id": 13,
        "className": "Person",
        coords: [
            489.0,
            182.0,
            526.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:26.700000",
        "id": 9,
        "className": "Person",
        coords: [
            510.0,
            236.0,
            564.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:26.700000",
        "id": 17,
        "className": "Person",
        coords: [
            341.0,
            534.0,
            451.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:26.700000",
        "id": 16,
        "className": "Person",
        coords: [
            953.0,
            431.0,
            1062.0,
            642.0
        ],
        "status": "Moving",
        "speed": 120.92,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:26.800000",
        "id": 13,
        "className": "Person",
        coords: [
            490.0,
            181.0,
            526.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:26.800000",
        "id": 9,
        "className": "Person",
        coords: [
            510.0,
            236.0,
            564.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:26.900000",
        "id": 17,
        "className": "Person",
        coords: [
            342.0,
            534.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:26.900000",
        "id": 16,
        "className": "Person",
        coords: [
            961.0,
            430.0,
            1069.0,
            641.0
        ],
        "status": "Moving",
        "speed": 120.92,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:26.900000",
        "id": 13,
        "className": "Person",
        coords: [
            489.0,
            181.0,
            525.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:26.900000",
        "id": 9,
        "className": "Person",
        coords: [
            510.0,
            236.0,
            564.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:27",
        "id": 17,
        "className": "Person",
        coords: [
            342.0,
            534.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:27",
        "id": 16,
        "className": "Person",
        coords: [
            965.0,
            428.0,
            1074.0,
            642.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:27.100000",
        "id": 13,
        "className": "Person",
        coords: [
            489.0,
            182.0,
            525.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:27.300000",
        "id": 9,
        "className": "Person",
        coords: [
            510.0,
            237.0,
            565.0,
            341.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:27.400000",
        "id": 17,
        "className": "Person",
        coords: [
            339.0,
            534.0,
            450.0,
            717.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:27.500000",
        "id": 16,
        "className": "Person",
        coords: [
            969.0,
            429.0,
            1077.0,
            642.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:27.600000",
        "id": 13,
        "className": "Person",
        coords: [
            490.0,
            182.0,
            524.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:27.800000",
        "id": 9,
        "className": "Person",
        coords: [
            510.0,
            237.0,
            565.0,
            342.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:27.900000",
        "id": 17,
        "className": "Person",
        coords: [
            334.0,
            534.0,
            446.0,
            717.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:28",
        "id": 16,
        "className": "Person",
        coords: [
            971.0,
            429.0,
            1080.0,
            643.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:28",
        "id": 13,
        "className": "Person",
        coords: [
            490.0,
            182.0,
            524.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:28.300000",
        "id": 9,
        "className": "Person",
        coords: [
            509.0,
            236.0,
            564.0,
            342.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:28.300000",
        "id": 17,
        "className": "Person",
        coords: [
            335.0,
            534.0,
            447.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:28.400000",
        "id": 16,
        "className": "Person",
        coords: [
            972.0,
            428.0,
            1082.0,
            643.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:28.500000",
        "id": 13,
        "className": "Person",
        coords: [
            490.0,
            182.0,
            524.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:28.700000",
        "id": 9,
        "className": "Person",
        coords: [
            510.0,
            236.0,
            565.0,
            342.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:28.800000",
        "id": 17,
        "className": "Person",
        coords: [
            331.0,
            534.0,
            444.0,
            717.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:28.900000",
        "id": 16,
        "className": "Person",
        coords: [
            976.0,
            429.0,
            1087.0,
            641.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:29",
        "id": 13,
        "className": "Person",
        coords: [
            490.0,
            181.0,
            524.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:29.200000",
        "id": 9,
        "className": "Person",
        coords: [
            511.0,
            236.0,
            565.0,
            341.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:29.300000",
        "id": 16,
        "className": "Person",
        coords: [
            978.0,
            430.0,
            1091.0,
            642.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:29.500000",
        "id": 9,
        "className": "Person",
        coords: [
            511.0,
            236.0,
            565.0,
            341.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:29.600000",
        "id": 16,
        "className": "Person",
        coords: [
            983.0,
            430.0,
            1098.0,
            641.0
        ],
        "status": "Moving",
        "speed": 91.23,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:29.800000",
        "id": 18,
        "className": "Person",
        coords: [
            636.0,
            452.0,
            829.0,
            602.0
        ],
        "status": "First Seen",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:16:30",
        "id": 9,
        "className": "Person",
        coords: [
            512.0,
            236.0,
            565.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:30.100000",
        "id": 16,
        "className": "Person",
        coords: [
            990.0,
            428.0,
            1108.0,
            640.0
        ],
        "status": "Moving",
        "speed": 135.82,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:30.200000",
        "id": 18,
        "className": "Person",
        coords: [
            645.0,
            453.0,
            838.0,
            604.0
        ],
        "status": "Moving",
        "speed": 135.82,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:16:30.400000",
        "id": 9,
        "className": "Person",
        coords: [
            512.0,
            236.0,
            565.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:30.500000",
        "id": 16,
        "className": "Person",
        coords: [
            1000.0,
            427.0,
            1119.0,
            639.0
        ],
        "status": "Moving",
        "speed": 150.74,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:30.600000",
        "id": 18,
        "className": "Person",
        coords: [
            657.0,
            455.0,
            842.0,
            601.0
        ],
        "status": "Moving",
        "speed": 119.99,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:16:30.800000",
        "id": 9,
        "className": "Person",
        coords: [
            513.0,
            236.0,
            566.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:30.900000",
        "id": 16,
        "className": "Person",
        coords: [
            1014.0,
            424.0,
            1129.0,
            631.0
        ],
        "status": "Moving",
        "speed": 201.23,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:31",
        "id": 18,
        "className": "Person",
        coords: [
            659.0,
            458.0,
            837.0,
            598.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:16:31.200000",
        "id": 9,
        "className": "Person",
        coords: [
            515.0,
            236.0,
            568.0,
            341.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:31.300000",
        "id": 16,
        "className": "Person",
        coords: [
            1024.0,
            423.0,
            1137.0,
            627.0
        ],
        "status": "Moving",
        "speed": 138.28,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:31.400000",
        "id": 18,
        "className": "Person",
        coords: [
            659.0,
            461.0,
            836.0,
            601.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:16:31.600000",
        "id": 9,
        "className": "Person",
        coords: [
            516.0,
            235.0,
            571.0,
            341.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:31.700000",
        "id": 16,
        "className": "Person",
        coords: [
            1028.0,
            422.0,
            1141.0,
            627.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:31.800000",
        "id": 18,
        "className": "Person",
        coords: [
            660.0,
            464.0,
            834.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:32",
        "id": 9,
        "className": "Person",
        coords: [
            518.0,
            235.0,
            574.0,
            341.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:32.100000",
        "id": 16,
        "className": "Person",
        coords: [
            1032.0,
            421.0,
            1144.0,
            627.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:32.200000",
        "id": 18,
        "className": "Person",
        coords: [
            662.0,
            465.0,
            834.0,
            604.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:32.400000",
        "id": 9,
        "className": "Person",
        coords: [
            517.0,
            234.0,
            574.0,
            341.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:32.500000",
        "id": 16,
        "className": "Person",
        coords: [
            1035.0,
            421.0,
            1145.0,
            625.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:32.600000",
        "id": 18,
        "className": "Person",
        coords: [
            660.0,
            469.0,
            836.0,
            613.0
        ],
        "status": "Moving",
        "speed": 104.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:32.800000",
        "id": 9,
        "className": "Person",
        coords: [
            517.0,
            234.0,
            575.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:32.900000",
        "id": 16,
        "className": "Person",
        coords: [
            1037.0,
            421.0,
            1146.0,
            625.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:33",
        "id": 18,
        "className": "Person",
        coords: [
            661.0,
            472.0,
            831.0,
            613.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:33.200000",
        "id": 9,
        "className": "Person",
        coords: [
            517.0,
            234.0,
            576.0,
            341.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:33.300000",
        "id": 16,
        "className": "Person",
        coords: [
            1037.0,
            420.0,
            1146.0,
            625.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:33.400000",
        "id": 18,
        "className": "Person",
        coords: [
            664.0,
            474.0,
            831.0,
            614.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:33.600000",
        "id": 9,
        "className": "Person",
        coords: [
            518.0,
            236.0,
            576.0,
            341.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:33.700000",
        "id": 16,
        "className": "Person",
        coords: [
            1039.0,
            418.0,
            1147.0,
            624.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:33.800000",
        "id": 18,
        "className": "Person",
        coords: [
            670.0,
            475.0,
            831.0,
            613.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:34",
        "id": 9,
        "className": "Person",
        coords: [
            517.0,
            236.0,
            576.0,
            341.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:34.100000",
        "id": 16,
        "className": "Person",
        coords: [
            1045.0,
            415.0,
            1151.0,
            619.0
        ],
        "status": "Moving",
        "speed": 96.04,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:34.100000",
        "id": 18,
        "className": "Person",
        coords: [
            675.0,
            475.0,
            833.0,
            613.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:34.400000",
        "id": 9,
        "className": "Person",
        coords: [
            517.0,
            236.0,
            575.0,
            341.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:34.500000",
        "id": 16,
        "className": "Person",
        coords: [
            1048.0,
            413.0,
            1151.0,
            615.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:34.600000",
        "id": 18,
        "className": "Person",
        coords: [
            685.0,
            474.0,
            835.0,
            609.0
        ],
        "status": "Moving",
        "speed": 100.61,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:34.900000",
        "id": 9,
        "className": "Person",
        coords: [
            516.0,
            237.0,
            575.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:35",
        "id": 16,
        "className": "Person",
        coords: [
            1049.0,
            410.0,
            1152.0,
            613.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:35.300000",
        "id": 9,
        "className": "Person",
        coords: [
            517.0,
            236.0,
            577.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:35.400000",
        "id": 16,
        "className": "Person",
        coords: [
            1050.0,
            408.0,
            1152.0,
            611.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:35.500000",
        "id": 18,
        "className": "Person",
        coords: [
            689.0,
            475.0,
            839.0,
            615.0
        ],
        "status": "Moving",
        "speed": 84.85,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:35.700000",
        "id": 9,
        "className": "Person",
        coords: [
            517.0,
            235.0,
            578.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:35.700000",
        "id": 16,
        "className": "Person",
        coords: [
            1051.0,
            407.0,
            1153.0,
            611.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:35.800000",
        "id": 18,
        "className": "Person",
        coords: [
            692.0,
            474.0,
            839.0,
            616.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:36",
        "id": 9,
        "className": "Person",
        coords: [
            516.0,
            235.0,
            579.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:36.100000",
        "id": 16,
        "className": "Person",
        coords: [
            1052.0,
            407.0,
            1153.0,
            608.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:36.200000",
        "id": 18,
        "className": "Person",
        coords: [
            696.0,
            472.0,
            840.0,
            617.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:36.400000",
        "id": 9,
        "className": "Person",
        coords: [
            516.0,
            235.0,
            579.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:36.500000",
        "id": 16,
        "className": "Person",
        coords: [
            1052.0,
            407.0,
            1152.0,
            607.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:36.600000",
        "id": 18,
        "className": "Person",
        coords: [
            699.0,
            469.0,
            844.0,
            619.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:36.800000",
        "id": 9,
        "className": "Person",
        coords: [
            515.0,
            235.0,
            580.0,
            341.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:36.900000",
        "id": 16,
        "className": "Person",
        coords: [
            1059.0,
            408.0,
            1159.0,
            606.0
        ],
        "status": "Moving",
        "speed": 104.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:37",
        "id": 18,
        "className": "Person",
        coords: [
            695.0,
            466.0,
            842.0,
            624.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:37.200000",
        "id": 9,
        "className": "Person",
        coords: [
            515.0,
            235.0,
            580.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:37.300000",
        "id": 16,
        "className": "Person",
        coords: [
            1066.0,
            426.0,
            1160.0,
            606.0
        ],
        "status": "Moving",
        "speed": 147.72,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:37.300000",
        "id": 18,
        "className": "Person",
        coords: [
            698.0,
            464.0,
            837.0,
            617.0
        ],
        "status": "Moving",
        "speed": 76.48,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:37.600000",
        "id": 9,
        "className": "Person",
        coords: [
            515.0,
            235.0,
            580.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:37.800000",
        "id": 9,
        "className": "Person",
        coords: [
            514.0,
            235.0,
            580.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:37.900000",
        "id": 18,
        "className": "Person",
        coords: [
            701.0,
            462.0,
            835.0,
            612.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:38.100000",
        "id": 9,
        "className": "Person",
        coords: [
            513.0,
            234.0,
            580.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:38.200000",
        "id": 18,
        "className": "Person",
        coords: [
            701.0,
            461.0,
            836.0,
            616.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:38.400000",
        "id": 9,
        "className": "Person",
        coords: [
            513.0,
            234.0,
            580.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:38.500000",
        "id": 18,
        "className": "Person",
        coords: [
            702.0,
            460.0,
            837.0,
            619.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:38.700000",
        "id": 9,
        "className": "Person",
        coords: [
            513.0,
            232.0,
            580.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:38.800000",
        "id": 18,
        "className": "Person",
        coords: [
            704.0,
            459.0,
            837.0,
            621.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:38.900000",
        "id": 16,
        "className": "Person",
        coords: [
            1084.0,
            406.0,
            1182.0,
            592.0
        ],
        "status": "Moving",
        "speed": 393.7,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:39.100000",
        "id": 9,
        "className": "Person",
        coords: [
            513.0,
            232.0,
            580.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:39.200000",
        "id": 18,
        "className": "Person",
        coords: [
            705.0,
            459.0,
            835.0,
            621.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:39.300000",
        "id": 16,
        "className": "Person",
        coords: [
            1085.0,
            402.0,
            1184.0,
            590.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:39.500000",
        "id": 9,
        "className": "Person",
        coords: [
            513.0,
            232.0,
            580.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:39.600000",
        "id": 18,
        "className": "Person",
        coords: [
            706.0,
            460.0,
            833.0,
            619.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:39.700000",
        "id": 16,
        "className": "Person",
        coords: [
            1087.0,
            401.0,
            1186.0,
            589.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:39.700000",
        "id": 13,
        "className": "Person",
        coords: [
            494.0,
            180.0,
            528.0,
            263.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:40",
        "id": 9,
        "className": "Person",
        coords: [
            513.0,
            233.0,
            580.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:40",
        "id": 18,
        "className": "Person",
        coords: [
            709.0,
            462.0,
            830.0,
            616.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:40.100000",
        "id": 16,
        "className": "Person",
        coords: [
            1089.0,
            400.0,
            1188.0,
            589.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:40.200000",
        "id": 13,
        "className": "Person",
        coords: [
            493.0,
            180.0,
            528.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:40.300000",
        "id": 17,
        "className": "Person",
        coords: [
            339.0,
            531.0,
            453.0,
            718.0
        ],
        "status": "Moving",
        "speed": 135.82,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:40.500000",
        "id": 9,
        "className": "Person",
        coords: [
            512.0,
            234.0,
            579.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:40.600000",
        "id": 18,
        "className": "Person",
        coords: [
            710.0,
            463.0,
            829.0,
            616.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:40.700000",
        "id": 16,
        "className": "Person",
        coords: [
            1090.0,
            400.0,
            1189.0,
            590.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:40.700000",
        "id": 13,
        "className": "Person",
        coords: [
            493.0,
            180.0,
            528.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:40.800000",
        "id": 17,
        "className": "Person",
        coords: [
            340.0,
            532.0,
            453.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:41.100000",
        "id": 9,
        "className": "Person",
        coords: [
            513.0,
            236.0,
            577.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:41.100000",
        "id": 18,
        "className": "Person",
        coords: [
            701.0,
            464.0,
            828.0,
            629.0
        ],
        "status": "Moving",
        "speed": 129.02,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:41.200000",
        "id": 16,
        "className": "Person",
        coords: [
            1092.0,
            399.0,
            1187.0,
            581.0
        ],
        "status": "Moving",
        "speed": 74.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:41.300000",
        "id": 13,
        "className": "Person",
        coords: [
            493.0,
            181.0,
            527.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:41.400000",
        "id": 17,
        "className": "Person",
        coords: [
            341.0,
            532.0,
            453.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:41.600000",
        "id": 9,
        "className": "Person",
        coords: [
            512.0,
            237.0,
            576.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:41.700000",
        "id": 18,
        "className": "Person",
        coords: [
            720.0,
            464.0,
            838.0,
            623.0
        ],
        "status": "Moving",
        "speed": 229.44,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:41.800000",
        "id": 16,
        "className": "Person",
        coords: [
            1094.0,
            398.0,
            1186.0,
            574.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:41.900000",
        "id": 13,
        "className": "Person",
        coords: [
            493.0,
            181.0,
            527.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:42",
        "id": 17,
        "className": "Person",
        coords: [
            341.0,
            532.0,
            453.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:42.200000",
        "id": 9,
        "className": "Person",
        coords: [
            512.0,
            237.0,
            576.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:42.300000",
        "id": 18,
        "className": "Person",
        coords: [
            719.0,
            464.0,
            832.0,
            619.0
        ],
        "status": "Moving",
        "speed": 67.08,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:42.400000",
        "id": 16,
        "className": "Person",
        coords: [
            1094.0,
            398.0,
            1186.0,
            572.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:42.400000",
        "id": 13,
        "className": "Person",
        coords: [
            493.0,
            181.0,
            527.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:42.500000",
        "id": 17,
        "className": "Person",
        coords: [
            341.0,
            534.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:42.800000",
        "id": 9,
        "className": "Person",
        coords: [
            513.0,
            237.0,
            576.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:42.900000",
        "id": 18,
        "className": "Person",
        coords: [
            725.0,
            464.0,
            834.0,
            617.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:42.900000",
        "id": 16,
        "className": "Person",
        coords: [
            1093.0,
            396.0,
            1186.0,
            571.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:43",
        "id": 13,
        "className": "Person",
        coords: [
            493.0,
            181.0,
            527.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:43.100000",
        "id": 17,
        "className": "Person",
        coords: [
            341.0,
            535.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:43.300000",
        "id": 9,
        "className": "Person",
        coords: [
            512.0,
            237.0,
            576.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:43.400000",
        "id": 18,
        "className": "Person",
        coords: [
            727.0,
            464.0,
            833.0,
            616.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:43.500000",
        "id": 16,
        "className": "Person",
        coords: [
            1092.0,
            395.0,
            1185.0,
            572.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:43.600000",
        "id": 13,
        "className": "Person",
        coords: [
            493.0,
            181.0,
            527.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:43.700000",
        "id": 17,
        "className": "Person",
        coords: [
            341.0,
            535.0,
            453.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:43.900000",
        "id": 9,
        "className": "Person",
        coords: [
            512.0,
            236.0,
            577.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:44",
        "id": 18,
        "className": "Person",
        coords: [
            730.0,
            464.0,
            833.0,
            616.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:44.100000",
        "id": 16,
        "className": "Person",
        coords: [
            1092.0,
            395.0,
            1186.0,
            572.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:44.200000",
        "id": 13,
        "className": "Person",
        coords: [
            494.0,
            181.0,
            528.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:44.300000",
        "id": 17,
        "className": "Person",
        coords: [
            342.0,
            535.0,
            453.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:44.500000",
        "id": 9,
        "className": "Person",
        coords: [
            512.0,
            236.0,
            577.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:44.600000",
        "id": 16,
        "className": "Person",
        coords: [
            1091.0,
            395.0,
            1186.0,
            573.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:44.600000",
        "id": 13,
        "className": "Person",
        coords: [
            494.0,
            180.0,
            528.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:44.700000",
        "id": 17,
        "className": "Person",
        coords: [
            342.0,
            535.0,
            453.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:45",
        "id": 9,
        "className": "Person",
        coords: [
            512.0,
            236.0,
            577.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:45",
        "id": 13,
        "className": "Person",
        coords: [
            493.0,
            181.0,
            527.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:45.100000",
        "id": 18,
        "className": "Person",
        coords: [
            719.0,
            461.0,
            826.0,
            618.0
        ],
        "status": "Moving",
        "speed": 135.82,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:45.300000",
        "id": 9,
        "className": "Person",
        coords: [
            512.0,
            235.0,
            578.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:45.400000",
        "id": 13,
        "className": "Person",
        coords: [
            494.0,
            180.0,
            528.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:45.500000",
        "id": 18,
        "className": "Person",
        coords: [
            727.0,
            460.0,
            832.0,
            621.0
        ],
        "status": "Moving",
        "speed": 106.06,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:45.700000",
        "id": 9,
        "className": "Person",
        coords: [
            512.0,
            235.0,
            579.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:45.800000",
        "id": 13,
        "className": "Person",
        coords: [
            493.0,
            181.0,
            527.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:45.900000",
        "id": 18,
        "className": "Person",
        coords: [
            730.0,
            460.0,
            834.0,
            622.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:46.100000",
        "id": 9,
        "className": "Person",
        coords: [
            512.0,
            234.0,
            579.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:46.200000",
        "id": 13,
        "className": "Person",
        coords: [
            493.0,
            181.0,
            527.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:46.300000",
        "id": 18,
        "className": "Person",
        coords: [
            731.0,
            460.0,
            833.0,
            622.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:46.600000",
        "id": 9,
        "className": "Person",
        coords: [
            512.0,
            235.0,
            579.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:46.700000",
        "id": 13,
        "className": "Person",
        coords: [
            493.0,
            180.0,
            527.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:46.800000",
        "id": 18,
        "className": "Person",
        coords: [
            733.0,
            460.0,
            833.0,
            623.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:47",
        "id": 9,
        "className": "Person",
        coords: [
            513.0,
            236.0,
            579.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:47.100000",
        "id": 13,
        "className": "Person",
        coords: [
            493.0,
            181.0,
            526.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:47.100000",
        "id": 18,
        "className": "Person",
        coords: [
            735.0,
            459.0,
            832.0,
            623.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:47.400000",
        "id": 9,
        "className": "Person",
        coords: [
            513.0,
            236.0,
            579.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:47.400000",
        "id": 13,
        "className": "Person",
        coords: [
            493.0,
            181.0,
            527.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:47.500000",
        "id": 18,
        "className": "Person",
        coords: [
            736.0,
            459.0,
            831.0,
            623.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:47.700000",
        "id": 9,
        "className": "Person",
        coords: [
            513.0,
            236.0,
            579.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:47.800000",
        "id": 13,
        "className": "Person",
        coords: [
            493.0,
            180.0,
            527.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:47.900000",
        "id": 18,
        "className": "Person",
        coords: [
            736.0,
            459.0,
            830.0,
            625.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:48.100000",
        "id": 9,
        "className": "Person",
        coords: [
            513.0,
            236.0,
            579.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:48.200000",
        "id": 13,
        "className": "Person",
        coords: [
            493.0,
            180.0,
            527.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:48.300000",
        "id": 18,
        "className": "Person",
        coords: [
            738.0,
            459.0,
            829.0,
            624.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:48.500000",
        "id": 9,
        "className": "Person",
        coords: [
            514.0,
            236.0,
            580.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:48.600000",
        "id": 13,
        "className": "Person",
        coords: [
            493.0,
            180.0,
            527.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:48.600000",
        "id": 18,
        "className": "Person",
        coords: [
            738.0,
            460.0,
            827.0,
            623.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:48.800000",
        "id": 9,
        "className": "Person",
        coords: [
            514.0,
            237.0,
            580.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:48.900000",
        "id": 13,
        "className": "Person",
        coords: [
            493.0,
            180.0,
            528.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:49",
        "id": 18,
        "className": "Person",
        coords: [
            738.0,
            459.0,
            826.0,
            622.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:49.200000",
        "id": 9,
        "className": "Person",
        coords: [
            514.0,
            237.0,
            579.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:49.300000",
        "id": 13,
        "className": "Person",
        coords: [
            493.0,
            181.0,
            527.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:49.400000",
        "id": 18,
        "className": "Person",
        coords: [
            740.0,
            459.0,
            826.0,
            621.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:49.600000",
        "id": 9,
        "className": "Person",
        coords: [
            514.0,
            238.0,
            579.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:49.600000",
        "id": 13,
        "className": "Person",
        coords: [
            493.0,
            181.0,
            527.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:49.700000",
        "id": 18,
        "className": "Person",
        coords: [
            740.0,
            459.0,
            824.0,
            620.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:49.900000",
        "id": 9,
        "className": "Person",
        coords: [
            515.0,
            240.0,
            579.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:50",
        "id": 13,
        "className": "Person",
        coords: [
            493.0,
            181.0,
            527.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:50.100000",
        "id": 18,
        "className": "Person",
        coords: [
            740.0,
            460.0,
            823.0,
            619.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:50.300000",
        "id": 9,
        "className": "Person",
        coords: [
            512.0,
            236.0,
            580.0,
            341.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:50.400000",
        "id": 13,
        "className": "Person",
        coords: [
            494.0,
            179.0,
            528.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:50.400000",
        "id": 16,
        "className": "Person",
        coords: [
            1093.0,
            394.0,
            1189.0,
            574.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:50.700000",
        "id": 9,
        "className": "Person",
        coords: [
            512.0,
            235.0,
            580.0,
            342.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:50.700000",
        "id": 13,
        "className": "Person",
        coords: [
            494.0,
            178.0,
            529.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:50.800000",
        "id": 16,
        "className": "Person",
        coords: [
            1093.0,
            395.0,
            1189.0,
            574.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:51",
        "id": 9,
        "className": "Person",
        coords: [
            512.0,
            235.0,
            579.0,
            343.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:51.100000",
        "id": 13,
        "className": "Person",
        coords: [
            494.0,
            178.0,
            529.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:51.300000",
        "id": 9,
        "className": "Person",
        coords: [
            512.0,
            235.0,
            578.0,
            343.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:51.400000",
        "id": 13,
        "className": "Person",
        coords: [
            494.0,
            178.0,
            529.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:51.600000",
        "id": 9,
        "className": "Person",
        coords: [
            513.0,
            234.0,
            578.0,
            343.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:51.700000",
        "id": 13,
        "className": "Person",
        coords: [
            494.0,
            178.0,
            529.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:51.900000",
        "id": 9,
        "className": "Person",
        coords: [
            513.0,
            235.0,
            576.0,
            343.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:52",
        "id": 13,
        "className": "Person",
        coords: [
            494.0,
            179.0,
            528.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:52.200000",
        "id": 9,
        "className": "Person",
        coords: [
            513.0,
            236.0,
            575.0,
            343.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:52.200000",
        "id": 13,
        "className": "Person",
        coords: [
            494.0,
            179.0,
            528.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:52.500000",
        "id": 13,
        "className": "Person",
        coords: [
            494.0,
            179.0,
            528.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:52.700000",
        "id": 13,
        "className": "Person",
        coords: [
            493.0,
            179.0,
            528.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:52.900000",
        "id": 13,
        "className": "Person",
        coords: [
            493.0,
            179.0,
            527.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:53",
        "id": 9,
        "className": "Person",
        coords: [
            514.0,
            237.0,
            573.0,
            342.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:53.200000",
        "id": 13,
        "className": "Person",
        coords: [
            493.0,
            179.0,
            527.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:53.300000",
        "id": 9,
        "className": "Person",
        coords: [
            514.0,
            235.0,
            574.0,
            343.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:53.500000",
        "id": 13,
        "className": "Person",
        coords: [
            493.0,
            180.0,
            526.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:53.600000",
        "id": 9,
        "className": "Person",
        coords: [
            515.0,
            234.0,
            575.0,
            343.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:53.800000",
        "id": 13,
        "className": "Person",
        coords: [
            493.0,
            180.0,
            526.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:53.800000",
        "id": 9,
        "className": "Person",
        coords: [
            516.0,
            234.0,
            575.0,
            343.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:54.100000",
        "id": 13,
        "className": "Person",
        coords: [
            493.0,
            180.0,
            526.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:54.100000",
        "id": 9,
        "className": "Person",
        coords: [
            516.0,
            234.0,
            575.0,
            343.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:54.300000",
        "id": 13,
        "className": "Person",
        coords: [
            493.0,
            180.0,
            526.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:54.400000",
        "id": 9,
        "className": "Person",
        coords: [
            516.0,
            234.0,
            575.0,
            343.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:54.800000",
        "id": 13,
        "className": "Person",
        coords: [
            494.0,
            180.0,
            526.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:54.900000",
        "id": 9,
        "className": "Person",
        coords: [
            515.0,
            234.0,
            573.0,
            343.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:55.100000",
        "id": 13,
        "className": "Person",
        coords: [
            494.0,
            180.0,
            527.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:55.200000",
        "id": 9,
        "className": "Person",
        coords: [
            515.0,
            234.0,
            573.0,
            342.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:55.400000",
        "id": 13,
        "className": "Person",
        coords: [
            494.0,
            180.0,
            527.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:55.500000",
        "id": 9,
        "className": "Person",
        coords: [
            515.0,
            234.0,
            572.0,
            342.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:55.700000",
        "id": 13,
        "className": "Person",
        coords: [
            494.0,
            180.0,
            527.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:55.800000",
        "id": 9,
        "className": "Person",
        coords: [
            515.0,
            235.0,
            572.0,
            342.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:56",
        "id": 13,
        "className": "Person",
        coords: [
            494.0,
            180.0,
            527.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:56.100000",
        "id": 9,
        "className": "Person",
        coords: [
            515.0,
            235.0,
            572.0,
            342.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:56.300000",
        "id": 13,
        "className": "Person",
        coords: [
            494.0,
            180.0,
            526.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:56.300000",
        "id": 9,
        "className": "Person",
        coords: [
            515.0,
            234.0,
            572.0,
            342.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:56.600000",
        "id": 13,
        "className": "Person",
        coords: [
            494.0,
            180.0,
            527.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:56.600000",
        "id": 9,
        "className": "Person",
        coords: [
            515.0,
            236.0,
            570.0,
            342.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:56.800000",
        "id": 13,
        "className": "Person",
        coords: [
            493.0,
            180.0,
            527.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:57",
        "id": 13,
        "className": "Person",
        coords: [
            493.0,
            179.0,
            527.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:57.100000",
        "id": 15,
        "className": "Person",
        coords: [
            1070.0,
            414.0,
            1202.0,
            605.0
        ],
        "status": "Moving",
        "speed": 5103.9,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:57.200000",
        "id": 13,
        "className": "Person",
        coords: [
            493.0,
            179.0,
            528.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:57.400000",
        "id": 13,
        "className": "Person",
        coords: [
            493.0,
            179.0,
            527.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:57.600000",
        "id": 13,
        "className": "Person",
        coords: [
            493.0,
            179.0,
            527.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:57.700000",
        "id": 13,
        "className": "Person",
        coords: [
            493.0,
            179.0,
            527.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:57.900000",
        "id": 13,
        "className": "Person",
        coords: [
            493.0,
            179.0,
            527.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:58",
        "id": 13,
        "className": "Person",
        coords: [
            492.0,
            179.0,
            527.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:58.200000",
        "id": 13,
        "className": "Person",
        coords: [
            493.0,
            179.0,
            527.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:58.300000",
        "id": 15,
        "className": "Person",
        coords: [
            1051.0,
            415.0,
            1185.0,
            625.0
        ],
        "status": "Moving",
        "speed": 316.4,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:58.400000",
        "id": 13,
        "className": "Person",
        coords: [
            493.0,
            179.0,
            527.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:58.500000",
        "id": 15,
        "className": "Person",
        coords: [
            1052.0,
            415.0,
            1180.0,
            625.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:58.600000",
        "id": 13,
        "className": "Person",
        coords: [
            493.0,
            179.0,
            528.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:58.700000",
        "id": 15,
        "className": "Person",
        coords: [
            1052.0,
            417.0,
            1177.0,
            627.0
        ],
        "status": "Moving",
        "speed": 42.42,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:58.800000",
        "id": 13,
        "className": "Person",
        coords: [
            494.0,
            180.0,
            528.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:58.800000",
        "id": 15,
        "className": "Person",
        coords: [
            1048.0,
            418.0,
            1167.0,
            627.0
        ],
        "status": "Moving",
        "speed": 104.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:58.800000",
        "id": 17,
        "className": "Person",
        coords: [
            318.0,
            531.0,
            442.0,
            718.0
        ],
        "status": "Moving",
        "speed": 256.74,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:58.900000",
        "id": 13,
        "className": "Person",
        coords: [
            493.0,
            180.0,
            528.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:58.900000",
        "id": 15,
        "className": "Person",
        coords: [
            1047.0,
            419.0,
            1161.0,
            627.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:59",
        "id": 17,
        "className": "Person",
        coords: [
            318.0,
            531.0,
            445.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:59",
        "id": 13,
        "className": "Person",
        coords: [
            493.0,
            180.0,
            528.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:59",
        "id": 15,
        "className": "Person",
        coords: [
            1048.0,
            422.0,
            1156.0,
            626.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:59.200000",
        "id": 13,
        "className": "Person",
        coords: [
            492.0,
            180.0,
            528.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:59.200000",
        "id": 15,
        "className": "Person",
        coords: [
            1049.0,
            425.0,
            1154.0,
            624.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:59.300000",
        "id": 17,
        "className": "Person",
        coords: [
            316.0,
            532.0,
            445.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:59.400000",
        "id": 13,
        "className": "Person",
        coords: [
            493.0,
            180.0,
            528.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:59.400000",
        "id": 15,
        "className": "Person",
        coords: [
            1051.0,
            428.0,
            1153.0,
            627.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:59.400000",
        "id": 17,
        "className": "Person",
        coords: [
            314.0,
            532.0,
            445.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:59.600000",
        "id": 13,
        "className": "Person",
        coords: [
            492.0,
            180.0,
            527.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:59.600000",
        "id": 15,
        "className": "Person",
        coords: [
            1051.0,
            429.0,
            1152.0,
            627.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:59.600000",
        "id": 17,
        "className": "Person",
        coords: [
            313.0,
            532.0,
            446.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:16:59.800000",
        "id": 13,
        "className": "Person",
        coords: [
            492.0,
            180.0,
            528.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:59.800000",
        "id": 15,
        "className": "Person",
        coords: [
            1049.0,
            429.0,
            1149.0,
            628.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:16:59.900000",
        "id": 17,
        "className": "Person",
        coords: [
            312.0,
            532.0,
            446.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:00",
        "id": 13,
        "className": "Person",
        coords: [
            492.0,
            180.0,
            527.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:00",
        "id": 15,
        "className": "Person",
        coords: [
            1046.0,
            429.0,
            1148.0,
            630.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:00.100000",
        "id": 17,
        "className": "Person",
        coords: [
            314.0,
            533.0,
            448.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:00.200000",
        "id": 13,
        "className": "Person",
        coords: [
            492.0,
            180.0,
            527.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:00.300000",
        "id": 15,
        "className": "Person",
        coords: [
            1043.0,
            429.0,
            1145.0,
            631.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:00.300000",
        "id": 17,
        "className": "Person",
        coords: [
            313.0,
            534.0,
            447.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:00.400000",
        "id": 13,
        "className": "Person",
        coords: [
            492.0,
            180.0,
            527.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:00.500000",
        "id": 15,
        "className": "Person",
        coords: [
            1035.0,
            429.0,
            1140.0,
            633.0
        ],
        "status": "Moving",
        "speed": 106.06,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:00.600000",
        "id": 13,
        "className": "Person",
        coords: [
            492.0,
            180.0,
            527.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:00.700000",
        "id": 15,
        "className": "Person",
        coords: [
            1028.0,
            430.0,
            1135.0,
            634.0
        ],
        "status": "Moving",
        "speed": 91.23,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:00.800000",
        "id": 13,
        "className": "Person",
        coords: [
            492.0,
            180.0,
            527.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:00.900000",
        "id": 15,
        "className": "Person",
        coords: [
            1015.0,
            430.0,
            1127.0,
            641.0
        ],
        "status": "Moving",
        "speed": 156.59,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:01",
        "id": 13,
        "className": "Person",
        coords: [
            492.0,
            180.0,
            527.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:01",
        "id": 15,
        "className": "Person",
        coords: [
            1005.0,
            430.0,
            1120.0,
            642.0
        ],
        "status": "Moving",
        "speed": 135.82,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:01.200000",
        "id": 13,
        "className": "Person",
        coords: [
            492.0,
            180.0,
            527.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:01.200000",
        "id": 15,
        "className": "Person",
        coords: [
            993.0,
            435.0,
            1111.0,
            642.0
        ],
        "status": "Moving",
        "speed": 152.96,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:01.300000",
        "id": 13,
        "className": "Person",
        coords: [
            493.0,
            179.0,
            527.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:01.400000",
        "id": 15,
        "className": "Person",
        coords: [
            983.0,
            438.0,
            1103.0,
            640.0
        ],
        "status": "Moving",
        "speed": 135.82,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:01.500000",
        "id": 13,
        "className": "Person",
        coords: [
            493.0,
            179.0,
            528.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:01.600000",
        "id": 15,
        "className": "Person",
        coords: [
            975.0,
            435.0,
            1098.0,
            640.0
        ],
        "status": "Moving",
        "speed": 109.19,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:01.700000",
        "id": 13,
        "className": "Person",
        coords: [
            493.0,
            181.0,
            526.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:01.800000",
        "id": 15,
        "className": "Person",
        coords: [
            968.0,
            434.0,
            1093.0,
            640.0
        ],
        "status": "Moving",
        "speed": 89.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:01.900000",
        "id": 13,
        "className": "Person",
        coords: [
            493.0,
            180.0,
            528.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:01.900000",
        "id": 15,
        "className": "Person",
        coords: [
            964.0,
            433.0,
            1090.0,
            640.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:02",
        "id": 17,
        "className": "Person",
        coords: [
            312.0,
            534.0,
            447.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:02.100000",
        "id": 13,
        "className": "Person",
        coords: [
            493.0,
            179.0,
            528.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:02.200000",
        "id": 15,
        "className": "Person",
        coords: [
            960.0,
            432.0,
            1087.0,
            640.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:02.300000",
        "id": 13,
        "className": "Person",
        coords: [
            493.0,
            179.0,
            528.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:02.300000",
        "id": 15,
        "className": "Person",
        coords: [
            957.0,
            431.0,
            1083.0,
            638.0
        ],
        "status": "Moving",
        "speed": 54.08,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:02.400000",
        "id": 18,
        "className": "Person",
        coords: [
            731.0,
            449.0,
            819.0,
            602.0
        ],
        "status": "Moving",
        "speed": 228.45,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:02.500000",
        "id": 13,
        "className": "Person",
        coords: [
            493.0,
            179.0,
            528.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:02.500000",
        "id": 15,
        "className": "Person",
        coords: [
            954.0,
            429.0,
            1081.0,
            640.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:02.600000",
        "id": 18,
        "className": "Person",
        coords: [
            729.0,
            448.0,
            822.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:02.700000",
        "id": 13,
        "className": "Person",
        coords: [
            493.0,
            179.0,
            528.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:02.800000",
        "id": 15,
        "className": "Person",
        coords: [
            956.0,
            429.0,
            1072.0,
            621.0
        ],
        "status": "Moving",
        "speed": 142.29,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:02.800000",
        "id": 18,
        "className": "Person",
        coords: [
            728.0,
            448.0,
            824.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:03",
        "id": 13,
        "className": "Person",
        coords: [
            493.0,
            179.0,
            528.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:03",
        "id": 15,
        "className": "Person",
        coords: [
            948.0,
            429.0,
            1071.0,
            637.0
        ],
        "status": "Moving",
        "speed": 141.5,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:03.100000",
        "id": 18,
        "className": "Person",
        coords: [
            728.0,
            448.0,
            825.0,
            601.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:03.200000",
        "id": 13,
        "className": "Person",
        coords: [
            493.0,
            179.0,
            528.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:03.200000",
        "id": 15,
        "className": "Person",
        coords: [
            943.0,
            429.0,
            1067.0,
            640.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:03.300000",
        "id": 18,
        "className": "Person",
        coords: [
            727.0,
            448.0,
            826.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:03.400000",
        "id": 13,
        "className": "Person",
        coords: [
            493.0,
            179.0,
            528.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:03.400000",
        "id": 15,
        "className": "Person",
        coords: [
            940.0,
            432.0,
            1061.0,
            642.0
        ],
        "status": "Moving",
        "speed": 87.46,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:03.500000",
        "id": 18,
        "className": "Person",
        coords: [
            727.0,
            448.0,
            827.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:03.600000",
        "id": 13,
        "className": "Person",
        coords: [
            493.0,
            179.0,
            528.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:03.700000",
        "id": 15,
        "className": "Person",
        coords: [
            938.0,
            435.0,
            1052.0,
            634.0
        ],
        "status": "Moving",
        "speed": 87.46,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:03.700000",
        "id": 18,
        "className": "Person",
        coords: [
            727.0,
            448.0,
            828.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:03.800000",
        "id": 15,
        "className": "Person",
        coords: [
            936.0,
            436.0,
            1041.0,
            619.0
        ],
        "status": "Moving",
        "speed": 148.48,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:03.900000",
        "id": 18,
        "className": "Person",
        coords: [
            726.0,
            448.0,
            828.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:04",
        "id": 15,
        "className": "Person",
        coords: [
            921.0,
            437.0,
            1034.0,
            633.0
        ],
        "status": "Moving",
        "speed": 204.01,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:04.100000",
        "id": 18,
        "className": "Person",
        coords: [
            727.0,
            448.0,
            828.0,
            601.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:04.200000",
        "id": 15,
        "className": "Person",
        coords: [
            918.0,
            438.0,
            1034.0,
            641.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:04.200000",
        "id": 18,
        "className": "Person",
        coords: [
            725.0,
            448.0,
            827.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:04.400000",
        "id": 15,
        "className": "Person",
        coords: [
            913.0,
            437.0,
            1030.0,
            646.0
        ],
        "status": "Moving",
        "speed": 80.77,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:04.400000",
        "id": 18,
        "className": "Person",
        coords: [
            723.0,
            448.0,
            827.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:04.500000",
        "id": 19,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            176.0,
            272.0
        ],
        "status": "First Seen",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:17:04.600000",
        "id": 15,
        "className": "Person",
        coords: [
            905.0,
            436.0,
            1022.0,
            646.0
        ],
        "status": "Moving",
        "speed": 119.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:04.600000",
        "id": 18,
        "className": "Person",
        coords: [
            724.0,
            448.0,
            828.0,
            601.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:04.700000",
        "id": 19,
        "className": "Person",
        coords: [
            139.0,
            192.0,
            175.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:17:04.800000",
        "id": 15,
        "className": "Person",
        coords: [
            903.0,
            437.0,
            1008.0,
            623.0
        ],
        "status": "Moving",
        "speed": 204.01,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:04.900000",
        "id": 18,
        "className": "Person",
        coords: [
            725.0,
            448.0,
            829.0,
            601.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:04.900000",
        "id": 19,
        "className": "Person",
        coords: [
            138.0,
            192.0,
            174.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:17:05",
        "id": 15,
        "className": "Person",
        coords: [
            883.0,
            438.0,
            1007.0,
            656.0
        ],
        "status": "Moving",
        "speed": 295.82,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:05.100000",
        "id": 18,
        "className": "Person",
        coords: [
            724.0,
            448.0,
            828.0,
            601.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:05.100000",
        "id": 19,
        "className": "Person",
        coords: [
            138.0,
            192.0,
            175.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:17:05.200000",
        "id": 15,
        "className": "Person",
        coords: [
            860.0,
            440.0,
            993.0,
            670.0
        ],
        "status": "Moving",
        "speed": 309.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:05.300000",
        "id": 18,
        "className": "Person",
        coords: [
            724.0,
            448.0,
            828.0,
            600.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:05.300000",
        "id": 19,
        "className": "Person",
        coords: [
            138.0,
            192.0,
            175.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:05.400000",
        "id": 15,
        "className": "Person",
        coords: [
            847.0,
            443.0,
            984.0,
            676.0
        ],
        "status": "Moving",
        "speed": 175.56,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:05.500000",
        "id": 18,
        "className": "Person",
        coords: [
            724.0,
            448.0,
            829.0,
            600.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:05.500000",
        "id": 19,
        "className": "Person",
        coords: [
            139.0,
            192.0,
            175.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Analysing",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:05.600000",
        "id": 15,
        "className": "Person",
        coords: [
            833.0,
            444.0,
            973.0,
            681.0
        ],
        "status": "Moving",
        "speed": 185.52,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:05.700000",
        "id": 18,
        "className": "Person",
        coords: [
            724.0,
            449.0,
            828.0,
            600.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:05.800000",
        "id": 19,
        "className": "Person",
        coords: [
            138.0,
            192.0,
            175.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Analysing",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:05.900000",
        "id": 15,
        "className": "Person",
        coords: [
            823.0,
            444.0,
            967.0,
            682.0
        ],
        "status": "Moving",
        "speed": 120.92,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:05.900000",
        "id": 18,
        "className": "Person",
        coords: [
            725.0,
            449.0,
            828.0,
            598.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:06",
        "id": 19,
        "className": "Person",
        coords: [
            139.0,
            193.0,
            175.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Analysing",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:06.100000",
        "id": 15,
        "className": "Person",
        coords: [
            817.0,
            445.0,
            960.0,
            683.0
        ],
        "status": "Moving",
        "speed": 106.06,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:06.200000",
        "id": 18,
        "className": "Person",
        coords: [
            702.0,
            448.0,
            813.0,
            602.0
        ],
        "status": "Moving",
        "speed": 286.55,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:06.200000",
        "id": 19,
        "className": "Person",
        coords: [
            139.0,
            193.0,
            175.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:06.200000",
        "id": 13,
        "className": "Person",
        coords: [
            491.0,
            181.0,
            525.0,
            264.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:06.400000",
        "id": 15,
        "className": "Person",
        coords: [
            812.0,
            445.0,
            956.0,
            683.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:06.500000",
        "id": 19,
        "className": "Person",
        coords: [
            138.0,
            193.0,
            175.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:06.500000",
        "id": 13,
        "className": "Person",
        coords: [
            491.0,
            181.0,
            524.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:06.700000",
        "id": 15,
        "className": "Person",
        coords: [
            810.0,
            444.0,
            953.0,
            684.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:06.700000",
        "id": 19,
        "className": "Person",
        coords: [
            138.0,
            192.0,
            175.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:06.800000",
        "id": 13,
        "className": "Person",
        coords: [
            492.0,
            181.0,
            526.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:06.900000",
        "id": 17,
        "className": "Person",
        coords: [
            310.0,
            532.0,
            449.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:07",
        "id": 15,
        "className": "Person",
        coords: [
            804.0,
            444.0,
            953.0,
            697.0
        ],
        "status": "Moving",
        "speed": 100.61,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:07.100000",
        "id": 19,
        "className": "Person",
        coords: [
            139.0,
            193.0,
            175.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:07.100000",
        "id": 13,
        "className": "Person",
        coords: [
            492.0,
            181.0,
            525.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:07.200000",
        "id": 17,
        "className": "Person",
        coords: [
            310.0,
            532.0,
            449.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:07.300000",
        "id": 15,
        "className": "Person",
        coords: [
            800.0,
            444.0,
            947.0,
            695.0
        ],
        "status": "Moving",
        "speed": 76.48,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:07.400000",
        "id": 19,
        "className": "Person",
        coords: [
            139.0,
            193.0,
            176.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:07.400000",
        "id": 13,
        "className": "Person",
        coords: [
            492.0,
            181.0,
            525.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:07.500000",
        "id": 17,
        "className": "Person",
        coords: [
            309.0,
            531.0,
            450.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:07.600000",
        "id": 15,
        "className": "Person",
        coords: [
            794.0,
            444.0,
            943.0,
            705.0
        ],
        "status": "Moving",
        "speed": 106.06,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:07.700000",
        "id": 19,
        "className": "Person",
        coords: [
            139.0,
            193.0,
            176.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:07.700000",
        "id": 17,
        "className": "Person",
        coords: [
            309.0,
            531.0,
            450.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:07.900000",
        "id": 15,
        "className": "Person",
        coords: [
            782.0,
            445.0,
            935.0,
            715.0
        ],
        "status": "Moving",
        "speed": 174.91,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:07.900000",
        "id": 19,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            176.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:08",
        "id": 17,
        "className": "Person",
        coords: [
            309.0,
            531.0,
            450.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:08.100000",
        "id": 15,
        "className": "Person",
        coords: [
            778.0,
            449.0,
            927.0,
            714.0
        ],
        "status": "Moving",
        "speed": 91.23,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:08.200000",
        "id": 19,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            176.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:08.300000",
        "id": 17,
        "className": "Person",
        coords: [
            308.0,
            531.0,
            450.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:08.400000",
        "id": 15,
        "className": "Person",
        coords: [
            772.0,
            453.0,
            917.0,
            715.0
        ],
        "status": "Moving",
        "speed": 128.15,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:08.400000",
        "id": 19,
        "className": "Person",
        coords: [
            139.0,
            193.0,
            176.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:08.500000",
        "id": 17,
        "className": "Person",
        coords: [
            308.0,
            531.0,
            450.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:08.600000",
        "id": 15,
        "className": "Person",
        coords: [
            766.0,
            457.0,
            909.0,
            717.0
        ],
        "status": "Moving",
        "speed": 114.23,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:08.700000",
        "id": 19,
        "className": "Person",
        coords: [
            139.0,
            193.0,
            176.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:08.700000",
        "id": 17,
        "className": "Person",
        coords: [
            308.0,
            531.0,
            450.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:08.900000",
        "id": 15,
        "className": "Person",
        coords: [
            762.0,
            459.0,
            903.0,
            718.0
        ],
        "status": "Moving",
        "speed": 76.48,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:08.900000",
        "id": 19,
        "className": "Person",
        coords: [
            139.0,
            193.0,
            176.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:09",
        "id": 17,
        "className": "Person",
        coords: [
            308.0,
            531.0,
            450.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:09.100000",
        "id": 15,
        "className": "Person",
        coords: [
            760.0,
            461.0,
            898.0,
            719.0
        ],
        "status": "Moving",
        "speed": 54.08,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:09.200000",
        "id": 19,
        "className": "Person",
        coords: [
            138.0,
            193.0,
            175.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:09.200000",
        "id": 17,
        "className": "Person",
        coords: [
            308.0,
            531.0,
            450.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:09.300000",
        "id": 18,
        "className": "Person",
        coords: [
            719.0,
            450.0,
            827.0,
            600.0
        ],
        "status": "Moving",
        "speed": 239.98,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:09.400000",
        "id": 15,
        "className": "Person",
        coords: [
            755.0,
            462.0,
            892.0,
            719.0
        ],
        "status": "Moving",
        "speed": 89.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:09.400000",
        "id": 19,
        "className": "Person",
        coords: [
            139.0,
            193.0,
            176.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:09.500000",
        "id": 17,
        "className": "Person",
        coords: [
            308.0,
            530.0,
            450.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:09.500000",
        "id": 18,
        "className": "Person",
        coords: [
            723.0,
            450.0,
            827.0,
            596.0
        ],
        "status": "Moving",
        "speed": 42.42,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:09.700000",
        "id": 15,
        "className": "Person",
        coords: [
            749.0,
            463.0,
            883.0,
            719.0
        ],
        "status": "Moving",
        "speed": 106.06,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:09.700000",
        "id": 19,
        "className": "Person",
        coords: [
            139.0,
            193.0,
            176.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:09.800000",
        "id": 17,
        "className": "Person",
        coords: [
            308.0,
            530.0,
            450.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:09.800000",
        "id": 18,
        "className": "Person",
        coords: [
            724.0,
            450.0,
            823.0,
            590.0
        ],
        "status": "Moving",
        "speed": 54.08,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:10",
        "id": 15,
        "className": "Person",
        coords: [
            739.0,
            464.0,
            872.0,
            718.0
        ],
        "status": "Moving",
        "speed": 164.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:10",
        "id": 19,
        "className": "Person",
        coords: [
            139.0,
            193.0,
            176.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:10.100000",
        "id": 17,
        "className": "Person",
        coords: [
            308.0,
            530.0,
            450.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:10.100000",
        "id": 18,
        "className": "Person",
        coords: [
            722.0,
            450.0,
            820.0,
            592.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:10.200000",
        "id": 13,
        "className": "Person",
        coords: [
            492.0,
            182.0,
            523.0,
            259.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:10.300000",
        "id": 15,
        "className": "Person",
        coords: [
            725.0,
            468.0,
            858.0,
            719.0
        ],
        "status": "Moving",
        "speed": 212.11,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:10.300000",
        "id": 19,
        "className": "Person",
        coords: [
            139.0,
            193.0,
            176.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:10.400000",
        "id": 17,
        "className": "Person",
        coords: [
            307.0,
            530.0,
            450.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:10.500000",
        "id": 18,
        "className": "Person",
        coords: [
            720.0,
            450.0,
            815.0,
            589.0
        ],
        "status": "Moving",
        "speed": 67.08,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:10.500000",
        "id": 13,
        "className": "Person",
        coords: [
            492.0,
            180.0,
            524.0,
            258.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:10.600000",
        "id": 15,
        "className": "Person",
        coords: [
            706.0,
            470.0,
            842.0,
            720.0
        ],
        "status": "Moving",
        "speed": 256.74,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:10.700000",
        "id": 19,
        "className": "Person",
        coords: [
            139.0,
            193.0,
            176.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:10.700000",
        "id": 17,
        "className": "Person",
        coords: [
            307.0,
            530.0,
            450.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:10.800000",
        "id": 18,
        "className": "Person",
        coords: [
            720.0,
            451.0,
            814.0,
            592.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:10.900000",
        "id": 15,
        "className": "Person",
        coords: [
            695.0,
            474.0,
            832.0,
            720.0
        ],
        "status": "Moving",
        "speed": 167.69,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:10.900000",
        "id": 19,
        "className": "Person",
        coords: [
            139.0,
            193.0,
            176.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:11",
        "id": 17,
        "className": "Person",
        coords: [
            307.0,
            530.0,
            450.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:11",
        "id": 18,
        "className": "Person",
        coords: [
            709.0,
            453.0,
            806.0,
            597.0
        ],
        "status": "Moving",
        "speed": 161.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:11.200000",
        "id": 15,
        "className": "Person",
        coords: [
            690.0,
            476.0,
            827.0,
            720.0
        ],
        "status": "Moving",
        "speed": 76.48,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:11.200000",
        "id": 19,
        "className": "Person",
        coords: [
            139.0,
            193.0,
            176.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:11.300000",
        "id": 17,
        "className": "Person",
        coords: [
            307.0,
            530.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:11.300000",
        "id": 13,
        "className": "Person",
        coords: [
            494.0,
            179.0,
            526.0,
            254.0
        ],
        "status": "Moving",
        "speed": 54.08,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:11.400000",
        "id": 15,
        "className": "Person",
        coords: [
            681.0,
            464.0,
            824.0,
            720.0
        ],
        "status": "Moving",
        "speed": 127.27,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:11.500000",
        "id": 19,
        "className": "Person",
        coords: [
            139.0,
            193.0,
            176.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:11.500000",
        "id": 17,
        "className": "Person",
        coords: [
            307.0,
            530.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:11.600000",
        "id": 13,
        "className": "Person",
        coords: [
            495.0,
            178.0,
            527.0,
            252.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:11.700000",
        "id": 15,
        "className": "Person",
        coords: [
            677.0,
            474.0,
            814.0,
            720.0
        ],
        "status": "Moving",
        "speed": 129.02,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:11.800000",
        "id": 19,
        "className": "Person",
        coords: [
            139.0,
            193.0,
            176.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:11.800000",
        "id": 17,
        "className": "Person",
        coords: [
            307.0,
            530.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:12",
        "id": 15,
        "className": "Person",
        coords: [
            673.0,
            476.0,
            808.0,
            720.0
        ],
        "status": "Moving",
        "speed": 76.48,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:12",
        "id": 19,
        "className": "Person",
        coords: [
            139.0,
            193.0,
            176.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:12.100000",
        "id": 17,
        "className": "Person",
        coords: [
            307.0,
            530.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:12.200000",
        "id": 15,
        "className": "Person",
        coords: [
            668.0,
            475.0,
            802.0,
            720.0
        ],
        "status": "Moving",
        "speed": 76.48,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:12.300000",
        "id": 19,
        "className": "Person",
        coords: [
            139.0,
            193.0,
            176.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:12.300000",
        "id": 17,
        "className": "Person",
        coords: [
            307.0,
            530.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:12.400000",
        "id": 20,
        "className": "Person",
        coords: [
            764.0,
            450.0,
            829.0,
            596.0
        ],
        "status": "First Seen",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:17:12.500000",
        "id": 15,
        "className": "Person",
        coords: [
            660.0,
            475.0,
            794.0,
            720.0
        ],
        "status": "Moving",
        "speed": 119.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:12.600000",
        "id": 19,
        "className": "Person",
        coords: [
            139.0,
            193.0,
            176.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:12.600000",
        "id": 17,
        "className": "Person",
        coords: [
            307.0,
            530.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:12.600000",
        "id": 20,
        "className": "Person",
        coords: [
            761.0,
            449.0,
            832.0,
            610.0
        ],
        "status": "Moving",
        "speed": 89.99,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:17:12.800000",
        "id": 15,
        "className": "Person",
        coords: [
            650.0,
            475.0,
            784.0,
            719.0
        ],
        "status": "Moving",
        "speed": 149.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:12.800000",
        "id": 19,
        "className": "Person",
        coords: [
            138.0,
            193.0,
            175.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:12.900000",
        "id": 17,
        "className": "Person",
        coords: [
            307.0,
            530.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:12.900000",
        "id": 20,
        "className": "Person",
        coords: [
            760.0,
            449.0,
            832.0,
            612.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:17:13",
        "id": 13,
        "className": "Person",
        coords: [
            495.0,
            176.0,
            530.0,
            252.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:13.100000",
        "id": 15,
        "className": "Person",
        coords: [
            641.0,
            478.0,
            775.0,
            718.0
        ],
        "status": "Moving",
        "speed": 135.82,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:13.200000",
        "id": 19,
        "className": "Person",
        coords: [
            138.0,
            193.0,
            175.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:13.200000",
        "id": 17,
        "className": "Person",
        coords: [
            307.0,
            530.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:13.300000",
        "id": 20,
        "className": "Person",
        coords: [
            759.0,
            449.0,
            828.0,
            605.0
        ],
        "status": "Moving",
        "speed": 63.63,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:17:13.300000",
        "id": 13,
        "className": "Person",
        coords: [
            494.0,
            175.0,
            531.0,
            253.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:13.400000",
        "id": 15,
        "className": "Person",
        coords: [
            631.0,
            479.0,
            764.0,
            718.0
        ],
        "status": "Moving",
        "speed": 164.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:13.500000",
        "id": 19,
        "className": "Person",
        coords: [
            138.0,
            193.0,
            175.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:13.500000",
        "id": 17,
        "className": "Person",
        coords: [
            307.0,
            530.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:13.600000",
        "id": 20,
        "className": "Person",
        coords: [
            750.0,
            449.0,
            831.0,
            633.0
        ],
        "status": "Moving",
        "speed": 214.75,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:17:13.600000",
        "id": 13,
        "className": "Person",
        coords: [
            493.0,
            176.0,
            532.0,
            253.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:13.800000",
        "id": 15,
        "className": "Person",
        coords: [
            623.0,
            482.0,
            755.0,
            718.0
        ],
        "status": "Moving",
        "speed": 123.68,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:13.800000",
        "id": 19,
        "className": "Person",
        coords: [
            138.0,
            193.0,
            175.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:13.900000",
        "id": 17,
        "className": "Person",
        coords: [
            307.0,
            529.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:13.900000",
        "id": 20,
        "className": "Person",
        coords: [
            750.0,
            449.0,
            824.0,
            613.0
        ],
        "status": "Moving",
        "speed": 156.59,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:14",
        "id": 13,
        "className": "Person",
        coords: [
            493.0,
            176.0,
            532.0,
            252.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:14.100000",
        "id": 15,
        "className": "Person",
        coords: [
            614.0,
            486.0,
            745.0,
            719.0
        ],
        "status": "Moving",
        "speed": 152.96,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:14.200000",
        "id": 19,
        "className": "Person",
        coords: [
            139.0,
            193.0,
            175.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:14.200000",
        "id": 17,
        "className": "Person",
        coords: [
            307.0,
            529.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:14.300000",
        "id": 20,
        "className": "Person",
        coords: [
            749.0,
            450.0,
            820.0,
            604.0
        ],
        "status": "Moving",
        "speed": 74.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:14.300000",
        "id": 13,
        "className": "Person",
        coords: [
            494.0,
            176.0,
            533.0,
            253.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:14.400000",
        "id": 15,
        "className": "Person",
        coords: [
            609.0,
            492.0,
            736.0,
            719.0
        ],
        "status": "Moving",
        "speed": 114.23,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:14.500000",
        "id": 19,
        "className": "Person",
        coords: [
            139.0,
            193.0,
            176.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:14.500000",
        "id": 17,
        "className": "Person",
        coords: [
            307.0,
            528.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:14.600000",
        "id": 20,
        "className": "Person",
        coords: [
            746.0,
            450.0,
            817.0,
            600.0
        ],
        "status": "Moving",
        "speed": 54.08,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:14.600000",
        "id": 13,
        "className": "Person",
        coords: [
            493.0,
            176.0,
            533.0,
            254.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:14.800000",
        "id": 15,
        "className": "Person",
        coords: [
            604.0,
            495.0,
            730.0,
            719.0
        ],
        "status": "Moving",
        "speed": 80.77,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:14.800000",
        "id": 19,
        "className": "Person",
        coords: [
            139.0,
            193.0,
            176.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:14.900000",
        "id": 17,
        "className": "Person",
        coords: [
            307.0,
            528.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:14.900000",
        "id": 20,
        "className": "Person",
        coords: [
            742.0,
            450.0,
            815.0,
            598.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:15",
        "id": 13,
        "className": "Person",
        coords: [
            494.0,
            176.0,
            534.0,
            253.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:15.100000",
        "id": 15,
        "className": "Person",
        coords: [
            600.0,
            496.0,
            724.0,
            720.0
        ],
        "status": "Moving",
        "speed": 76.48,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:15.100000",
        "id": 19,
        "className": "Person",
        coords: [
            139.0,
            193.0,
            176.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:15.200000",
        "id": 17,
        "className": "Person",
        coords: [
            307.0,
            528.0,
            453.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:15.300000",
        "id": 20,
        "className": "Person",
        coords: [
            737.0,
            450.0,
            814.0,
            602.0
        ],
        "status": "Moving",
        "speed": 54.08,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:15.300000",
        "id": 13,
        "className": "Person",
        coords: [
            495.0,
            177.0,
            534.0,
            253.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:15.400000",
        "id": 15,
        "className": "Person",
        coords: [
            594.0,
            498.0,
            716.0,
            719.0
        ],
        "status": "Moving",
        "speed": 104.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:15.500000",
        "id": 19,
        "className": "Person",
        coords: [
            139.0,
            193.0,
            175.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:15.500000",
        "id": 17,
        "className": "Person",
        coords: [
            314.0,
            528.0,
            457.0,
            718.0
        ],
        "status": "Moving",
        "speed": 74.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:15.600000",
        "id": 20,
        "className": "Person",
        coords: [
            731.0,
            450.0,
            812.0,
            604.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:15.600000",
        "id": 13,
        "className": "Person",
        coords: [
            495.0,
            177.0,
            534.0,
            253.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:15.800000",
        "id": 15,
        "className": "Person",
        coords: [
            584.0,
            501.0,
            704.0,
            719.0
        ],
        "status": "Moving",
        "speed": 167.69,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:15.800000",
        "id": 19,
        "className": "Person",
        coords: [
            139.0,
            193.0,
            175.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:15.900000",
        "id": 17,
        "className": "Person",
        coords: [
            312.0,
            527.0,
            455.0,
            718.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:15.900000",
        "id": 20,
        "className": "Person",
        coords: [
            724.0,
            450.0,
            810.0,
            606.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:15.900000",
        "id": 13,
        "className": "Person",
        coords: [
            495.0,
            177.0,
            534.0,
            252.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:16.100000",
        "id": 15,
        "className": "Person",
        coords: [
            574.0,
            503.0,
            693.0,
            719.0
        ],
        "status": "Moving",
        "speed": 165.67,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:16.100000",
        "id": 19,
        "className": "Person",
        coords: [
            139.0,
            193.0,
            175.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:16.200000",
        "id": 17,
        "className": "Person",
        coords: [
            312.0,
            527.0,
            454.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:16.200000",
        "id": 20,
        "className": "Person",
        coords: [
            725.0,
            450.0,
            812.0,
            604.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:16.300000",
        "id": 13,
        "className": "Person",
        coords: [
            495.0,
            177.0,
            534.0,
            253.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:16.400000",
        "id": 15,
        "className": "Person",
        coords: [
            562.0,
            504.0,
            681.0,
            719.0
        ],
        "status": "Moving",
        "speed": 179.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:16.500000",
        "id": 19,
        "className": "Person",
        coords: [
            139.0,
            193.0,
            175.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:16.500000",
        "id": 17,
        "className": "Person",
        coords: [
            311.0,
            527.0,
            453.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:16.600000",
        "id": 20,
        "className": "Person",
        coords: [
            714.0,
            450.0,
            816.0,
            626.0
        ],
        "status": "Moving",
        "speed": 171.01,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:16.600000",
        "id": 13,
        "className": "Person",
        coords: [
            495.0,
            177.0,
            533.0,
            252.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:16.700000",
        "id": 15,
        "className": "Person",
        coords: [
            553.0,
            506.0,
            672.0,
            719.0
        ],
        "status": "Moving",
        "speed": 135.82,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:16.800000",
        "id": 19,
        "className": "Person",
        coords: [
            139.0,
            193.0,
            176.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:16.800000",
        "id": 17,
        "className": "Person",
        coords: [
            310.0,
            528.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:16.900000",
        "id": 20,
        "className": "Person",
        coords: [
            712.0,
            450.0,
            819.0,
            633.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:16.900000",
        "id": 13,
        "className": "Person",
        coords: [
            494.0,
            177.0,
            533.0,
            251.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:17.100000",
        "id": 15,
        "className": "Person",
        coords: [
            544.0,
            509.0,
            662.0,
            720.0
        ],
        "status": "Moving",
        "speed": 138.28,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:17.100000",
        "id": 19,
        "className": "Person",
        coords: [
            139.0,
            193.0,
            176.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:17.100000",
        "id": 17,
        "className": "Person",
        coords: [
            312.0,
            528.0,
            453.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:17.100000",
        "id": 20,
        "className": "Person",
        coords: [
            715.0,
            449.0,
            820.0,
            627.0
        ],
        "status": "Moving",
        "speed": 54.08,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:17.200000",
        "id": 13,
        "className": "Person",
        coords: [
            493.0,
            177.0,
            533.0,
            251.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:17.300000",
        "id": 15,
        "className": "Person",
        coords: [
            541.0,
            510.0,
            659.0,
            720.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:17.400000",
        "id": 19,
        "className": "Person",
        coords: [
            139.0,
            193.0,
            176.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:17.400000",
        "id": 17,
        "className": "Person",
        coords: [
            313.0,
            529.0,
            454.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:17.400000",
        "id": 20,
        "className": "Person",
        coords: [
            714.0,
            449.0,
            820.0,
            626.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:17.500000",
        "id": 13,
        "className": "Person",
        coords: [
            493.0,
            177.0,
            533.0,
            251.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:17.600000",
        "id": 15,
        "className": "Person",
        coords: [
            528.0,
            515.0,
            644.0,
            719.0
        ],
        "status": "Moving",
        "speed": 212.11,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:17.700000",
        "id": 19,
        "className": "Person",
        coords: [
            138.0,
            193.0,
            175.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:17.700000",
        "id": 17,
        "className": "Person",
        coords: [
            322.0,
            529.0,
            460.0,
            718.0
        ],
        "status": "Moving",
        "speed": 119.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:17.800000",
        "id": 20,
        "className": "Person",
        coords: [
            713.0,
            449.0,
            821.0,
            626.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:17.800000",
        "id": 13,
        "className": "Person",
        coords: [
            493.0,
            177.0,
            533.0,
            251.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:18",
        "id": 15,
        "className": "Person",
        coords: [
            514.0,
            517.0,
            629.0,
            719.0
        ],
        "status": "Moving",
        "speed": 225.48,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:18",
        "id": 19,
        "className": "Person",
        coords: [
            138.0,
            193.0,
            175.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:18",
        "id": 17,
        "className": "Person",
        coords: [
            325.0,
            529.0,
            461.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:18.100000",
        "id": 20,
        "className": "Person",
        coords: [
            713.0,
            449.0,
            823.0,
            628.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:18.100000",
        "id": 13,
        "className": "Person",
        coords: [
            494.0,
            177.0,
            534.0,
            251.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:18.300000",
        "id": 15,
        "className": "Person",
        coords: [
            501.0,
            517.0,
            616.0,
            719.0
        ],
        "status": "Moving",
        "speed": 194.98,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:18.300000",
        "id": 19,
        "className": "Person",
        coords: [
            138.0,
            193.0,
            175.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:18.400000",
        "id": 17,
        "className": "Person",
        coords: [
            327.0,
            529.0,
            461.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:18.400000",
        "id": 20,
        "className": "Person",
        coords: [
            711.0,
            450.0,
            823.0,
            629.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:18.400000",
        "id": 13,
        "className": "Person",
        coords: [
            494.0,
            177.0,
            534.0,
            251.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:18.600000",
        "id": 15,
        "className": "Person",
        coords: [
            489.0,
            514.0,
            604.0,
            719.0
        ],
        "status": "Moving",
        "speed": 182.47,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:18.600000",
        "id": 19,
        "className": "Person",
        coords: [
            139.0,
            193.0,
            176.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:18.700000",
        "id": 17,
        "className": "Person",
        coords: [
            328.0,
            529.0,
            462.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:18.700000",
        "id": 20,
        "className": "Person",
        coords: [
            714.0,
            450.0,
            825.0,
            628.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:18.800000",
        "id": 13,
        "className": "Person",
        coords: [
            494.0,
            177.0,
            534.0,
            251.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:18.900000",
        "id": 15,
        "className": "Person",
        coords: [
            476.0,
            515.0,
            592.0,
            719.0
        ],
        "status": "Moving",
        "speed": 180.61,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:18.900000",
        "id": 19,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            176.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:19",
        "id": 17,
        "className": "Person",
        coords: [
            331.0,
            529.0,
            463.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:19",
        "id": 20,
        "className": "Person",
        coords: [
            716.0,
            450.0,
            825.0,
            622.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:19.100000",
        "id": 13,
        "className": "Person",
        coords: [
            494.0,
            177.0,
            534.0,
            251.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:19.200000",
        "id": 15,
        "className": "Person",
        coords: [
            463.0,
            515.0,
            581.0,
            719.0
        ],
        "status": "Moving",
        "speed": 179.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:19.200000",
        "id": 19,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            176.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:19.300000",
        "id": 17,
        "className": "Person",
        coords: [
            334.0,
            529.0,
            464.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:19.300000",
        "id": 20,
        "className": "Person",
        coords: [
            719.0,
            450.0,
            825.0,
            616.0
        ],
        "status": "Moving",
        "speed": 54.08,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:19.400000",
        "id": 13,
        "className": "Person",
        coords: [
            494.0,
            177.0,
            534.0,
            251.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:19.500000",
        "id": 15,
        "className": "Person",
        coords: [
            458.0,
            517.0,
            575.0,
            719.0
        ],
        "status": "Moving",
        "speed": 91.23,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:19.600000",
        "id": 19,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            176.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:19.600000",
        "id": 17,
        "className": "Person",
        coords: [
            338.0,
            529.0,
            466.0,
            718.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:19.600000",
        "id": 20,
        "className": "Person",
        coords: [
            720.0,
            450.0,
            825.0,
            613.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:19.700000",
        "id": 13,
        "className": "Person",
        coords: [
            494.0,
            177.0,
            534.0,
            251.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:19.800000",
        "id": 15,
        "className": "Person",
        coords: [
            452.0,
            519.0,
            568.0,
            719.0
        ],
        "status": "Moving",
        "speed": 91.23,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:19.900000",
        "id": 19,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            176.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:19.900000",
        "id": 17,
        "className": "Person",
        coords: [
            336.0,
            529.0,
            462.0,
            718.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:20",
        "id": 20,
        "className": "Person",
        coords: [
            720.0,
            450.0,
            825.0,
            611.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:20",
        "id": 13,
        "className": "Person",
        coords: [
            494.0,
            177.0,
            534.0,
            251.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:20.100000",
        "id": 15,
        "className": "Person",
        coords: [
            443.0,
            523.0,
            555.0,
            719.0
        ],
        "status": "Moving",
        "speed": 167.69,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:20.200000",
        "id": 19,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            176.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:20.200000",
        "id": 17,
        "className": "Person",
        coords: [
            337.0,
            529.0,
            461.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:20.300000",
        "id": 20,
        "className": "Person",
        coords: [
            721.0,
            450.0,
            825.0,
            609.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:20.300000",
        "id": 13,
        "className": "Person",
        coords: [
            494.0,
            177.0,
            534.0,
            251.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:20.500000",
        "id": 15,
        "className": "Person",
        coords: [
            434.0,
            528.0,
            544.0,
            719.0
        ],
        "status": "Moving",
        "speed": 152.96,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:20.500000",
        "id": 19,
        "className": "Person",
        coords: [
            139.0,
            193.0,
            176.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:20.600000",
        "id": 17,
        "className": "Person",
        coords: [
            338.0,
            530.0,
            459.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:20.600000",
        "id": 20,
        "className": "Person",
        coords: [
            721.0,
            449.0,
            825.0,
            609.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:20.600000",
        "id": 13,
        "className": "Person",
        coords: [
            495.0,
            177.0,
            534.0,
            251.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:20.800000",
        "id": 15,
        "className": "Person",
        coords: [
            428.0,
            535.0,
            535.0,
            719.0
        ],
        "status": "Moving",
        "speed": 134.15,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:20.800000",
        "id": 19,
        "className": "Person",
        coords: [
            139.0,
            193.0,
            175.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:20.900000",
        "id": 17,
        "className": "Person",
        coords: [
            338.0,
            530.0,
            458.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:20.900000",
        "id": 20,
        "className": "Person",
        coords: [
            721.0,
            449.0,
            826.0,
            608.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:21",
        "id": 13,
        "className": "Person",
        coords: [
            495.0,
            177.0,
            535.0,
            251.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:21.100000",
        "id": 15,
        "className": "Person",
        coords: [
            422.0,
            542.0,
            525.0,
            718.0
        ],
        "status": "Moving",
        "speed": 128.15,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:21.100000",
        "id": 19,
        "className": "Person",
        coords: [
            138.0,
            193.0,
            175.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:21.200000",
        "id": 17,
        "className": "Person",
        coords: [
            337.0,
            531.0,
            454.0,
            717.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:21.200000",
        "id": 13,
        "className": "Person",
        coords: [
            496.0,
            177.0,
            535.0,
            252.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:21.400000",
        "id": 15,
        "className": "Person",
        coords: [
            414.0,
            546.0,
            513.0,
            719.0
        ],
        "status": "Moving",
        "speed": 152.96,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:21.400000",
        "id": 19,
        "className": "Person",
        coords: [
            138.0,
            192.0,
            175.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:21.400000",
        "id": 17,
        "className": "Person",
        coords: [
            333.0,
            530.0,
            448.0,
            717.0
        ],
        "status": "Moving",
        "speed": 76.48,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:21.500000",
        "id": 13,
        "className": "Person",
        coords: [
            496.0,
            177.0,
            536.0,
            252.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:21.600000",
        "id": 15,
        "className": "Person",
        coords: [
            397.0,
            550.0,
            495.0,
            719.0
        ],
        "status": "Moving",
        "speed": 256.74,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:21.700000",
        "id": 19,
        "className": "Person",
        coords: [
            137.0,
            193.0,
            174.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:21.700000",
        "id": 17,
        "className": "Person",
        coords: [
            318.0,
            531.0,
            431.0,
            715.0
        ],
        "status": "Moving",
        "speed": 239.98,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:21.800000",
        "id": 13,
        "className": "Person",
        coords: [
            496.0,
            177.0,
            536.0,
            252.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:21.900000",
        "id": 15,
        "className": "Person",
        coords: [
            390.0,
            555.0,
            486.0,
            718.0
        ],
        "status": "Moving",
        "speed": 123.68,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:21.900000",
        "id": 19,
        "className": "Person",
        coords: [
            137.0,
            193.0,
            173.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:22",
        "id": 17,
        "className": "Person",
        coords: [
            311.0,
            530.0,
            421.0,
            711.0
        ],
        "status": "Moving",
        "speed": 128.15,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:22",
        "id": 13,
        "className": "Person",
        coords: [
            496.0,
            177.0,
            535.0,
            252.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:22.100000",
        "id": 15,
        "className": "Person",
        coords: [
            377.0,
            558.0,
            474.0,
            718.0
        ],
        "status": "Moving",
        "speed": 197.28,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:22.200000",
        "id": 19,
        "className": "Person",
        coords: [
            136.0,
            193.0,
            172.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:22.300000",
        "id": 17,
        "className": "Person",
        coords: [
            312.0,
            530.0,
            410.0,
            687.0
        ],
        "status": "Moving",
        "speed": 194.98,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:22.300000",
        "id": 13,
        "className": "Person",
        coords: [
            496.0,
            177.0,
            535.0,
            252.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:22.400000",
        "id": 15,
        "className": "Person",
        coords: [
            358.0,
            541.0,
            465.0,
            717.0
        ],
        "status": "Moving",
        "speed": 249.63,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:22.500000",
        "id": 19,
        "className": "Person",
        coords: [
            136.0,
            193.0,
            172.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:22.500000",
        "id": 13,
        "className": "Person",
        coords: [
            496.0,
            177.0,
            535.0,
            252.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:22.600000",
        "id": 15,
        "className": "Person",
        coords: [
            356.0,
            554.0,
            456.0,
            718.0
        ],
        "status": "Moving",
        "speed": 129.02,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:22.700000",
        "id": 19,
        "className": "Person",
        coords: [
            136.0,
            194.0,
            170.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:22.700000",
        "id": 13,
        "className": "Person",
        coords: [
            496.0,
            177.0,
            535.0,
            252.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:22.900000",
        "id": 19,
        "className": "Person",
        coords: [
            136.0,
            194.0,
            170.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:22.900000",
        "id": 13,
        "className": "Person",
        coords: [
            496.0,
            177.0,
            535.0,
            252.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:23.100000",
        "id": 19,
        "className": "Person",
        coords: [
            136.0,
            194.0,
            169.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:23.100000",
        "id": 13,
        "className": "Person",
        coords: [
            496.0,
            177.0,
            535.0,
            252.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:23.100000",
        "id": 15,
        "className": "Person",
        coords: [
            322.0,
            537.0,
            436.0,
            719.0
        ],
        "status": "Moving",
        "speed": 422.37,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:23.300000",
        "id": 19,
        "className": "Person",
        coords: [
            136.0,
            194.0,
            169.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:23.300000",
        "id": 13,
        "className": "Person",
        coords: [
            495.0,
            177.0,
            534.0,
            252.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:23.400000",
        "id": 15,
        "className": "Person",
        coords: [
            311.0,
            554.0,
            419.0,
            719.0
        ],
        "status": "Moving",
        "speed": 241.85,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:23.500000",
        "id": 19,
        "className": "Person",
        coords: [
            136.0,
            195.0,
            168.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:23.500000",
        "id": 13,
        "className": "Person",
        coords: [
            494.0,
            177.0,
            533.0,
            252.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:23.600000",
        "id": 15,
        "className": "Person",
        coords: [
            298.0,
            562.0,
            405.0,
            719.0
        ],
        "status": "Moving",
        "speed": 218.39,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:23.700000",
        "id": 19,
        "className": "Person",
        coords: [
            136.0,
            196.0,
            168.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:23.700000",
        "id": 13,
        "className": "Person",
        coords: [
            494.0,
            177.0,
            534.0,
            252.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:23.800000",
        "id": 15,
        "className": "Person",
        coords: [
            285.0,
            565.0,
            393.0,
            719.0
        ],
        "status": "Moving",
        "speed": 182.47,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:23.900000",
        "id": 19,
        "className": "Person",
        coords: [
            136.0,
            196.0,
            168.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:24",
        "id": 13,
        "className": "Person",
        coords: [
            494.0,
            177.0,
            534.0,
            252.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:24",
        "id": 15,
        "className": "Person",
        coords: [
            276.0,
            565.0,
            387.0,
            719.0
        ],
        "status": "Moving",
        "speed": 119.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:24.200000",
        "id": 19,
        "className": "Person",
        coords: [
            136.0,
            196.0,
            168.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:24.200000",
        "id": 13,
        "className": "Person",
        coords: [
            493.0,
            177.0,
            534.0,
            252.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:24.300000",
        "id": 15,
        "className": "Person",
        coords: [
            269.0,
            566.0,
            381.0,
            719.0
        ],
        "status": "Moving",
        "speed": 89.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:24.300000",
        "id": 21,
        "className": "Person",
        coords: [
            350.0,
            532.0,
            455.0,
            714.0
        ],
        "status": "First Seen",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:17:24.500000",
        "id": 19,
        "className": "Person",
        coords: [
            137.0,
            196.0,
            167.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:24.500000",
        "id": 13,
        "className": "Person",
        coords: [
            494.0,
            177.0,
            534.0,
            252.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:24.600000",
        "id": 15,
        "className": "Person",
        coords: [
            264.0,
            565.0,
            377.0,
            719.0
        ],
        "status": "Moving",
        "speed": 74.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:24.600000",
        "id": 21,
        "className": "Person",
        coords: [
            352.0,
            531.0,
            450.0,
            702.0
        ],
        "status": "Moving",
        "speed": 106.06,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:17:24.800000",
        "id": 19,
        "className": "Person",
        coords: [
            137.0,
            198.0,
            167.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:24.800000",
        "id": 13,
        "className": "Person",
        coords: [
            494.0,
            177.0,
            535.0,
            253.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:24.900000",
        "id": 15,
        "className": "Person",
        coords: [
            260.0,
            566.0,
            372.0,
            719.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:24.900000",
        "id": 21,
        "className": "Person",
        coords: [
            349.0,
            531.0,
            453.0,
            714.0
        ],
        "status": "Moving",
        "speed": 89.99,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:17:25.100000",
        "id": 19,
        "className": "Person",
        coords: [
            137.0,
            199.0,
            166.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:25.100000",
        "id": 13,
        "className": "Person",
        coords: [
            493.0,
            178.0,
            535.0,
            254.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:25.100000",
        "id": 15,
        "className": "Person",
        coords: [
            254.0,
            567.0,
            366.0,
            719.0
        ],
        "status": "Moving",
        "speed": 91.23,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:25.200000",
        "id": 21,
        "className": "Person",
        coords: [
            347.0,
            532.0,
            453.0,
            717.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:17:25.300000",
        "id": 19,
        "className": "Person",
        coords: [
            137.0,
            199.0,
            166.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:25.400000",
        "id": 13,
        "className": "Person",
        coords: [
            493.0,
            178.0,
            535.0,
            254.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:25.400000",
        "id": 15,
        "className": "Person",
        coords: [
            247.0,
            569.0,
            357.0,
            718.0
        ],
        "status": "Moving",
        "speed": 119.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:25.500000",
        "id": 21,
        "className": "Person",
        coords: [
            346.0,
            532.0,
            453.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:17:25.600000",
        "id": 19,
        "className": "Person",
        coords: [
            137.0,
            200.0,
            166.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:25.600000",
        "id": 13,
        "className": "Person",
        coords: [
            493.0,
            178.0,
            536.0,
            254.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:25.700000",
        "id": 15,
        "className": "Person",
        coords: [
            241.0,
            570.0,
            350.0,
            718.0
        ],
        "status": "Moving",
        "speed": 106.06,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:25.700000",
        "id": 21,
        "className": "Person",
        coords: [
            345.0,
            532.0,
            452.0,
            719.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:17:25.900000",
        "id": 19,
        "className": "Person",
        coords: [
            137.0,
            201.0,
            166.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:25.900000",
        "id": 13,
        "className": "Person",
        coords: [
            494.0,
            178.0,
            536.0,
            254.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:26",
        "id": 15,
        "className": "Person",
        coords: [
            236.0,
            570.0,
            345.0,
            718.0
        ],
        "status": "Moving",
        "speed": 74.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:26",
        "id": 21,
        "className": "Person",
        coords: [
            344.0,
            532.0,
            451.0,
            719.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:17:26.200000",
        "id": 19,
        "className": "Person",
        coords: [
            137.0,
            200.0,
            166.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:26.200000",
        "id": 13,
        "className": "Person",
        coords: [
            494.0,
            178.0,
            536.0,
            254.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:26.300000",
        "id": 15,
        "className": "Person",
        coords: [
            231.0,
            570.0,
            341.0,
            718.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:26.300000",
        "id": 21,
        "className": "Person",
        coords: [
            344.0,
            532.0,
            451.0,
            719.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:17:26.500000",
        "id": 19,
        "className": "Person",
        coords: [
            137.0,
            200.0,
            166.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:26.500000",
        "id": 13,
        "className": "Person",
        coords: [
            494.0,
            178.0,
            536.0,
            254.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:26.500000",
        "id": 15,
        "className": "Person",
        coords: [
            227.0,
            568.0,
            339.0,
            718.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:26.600000",
        "id": 21,
        "className": "Person",
        coords: [
            344.0,
            532.0,
            451.0,
            719.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:26.700000",
        "id": 19,
        "className": "Person",
        coords: [
            137.0,
            201.0,
            166.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:26.800000",
        "id": 13,
        "className": "Person",
        coords: [
            493.0,
            178.0,
            536.0,
            255.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:26.900000",
        "id": 15,
        "className": "Person",
        coords: [
            221.0,
            566.0,
            337.0,
            718.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:26.900000",
        "id": 21,
        "className": "Person",
        coords: [
            344.0,
            532.0,
            451.0,
            719.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:27.100000",
        "id": 19,
        "className": "Person",
        coords: [
            136.0,
            200.0,
            166.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:27.100000",
        "id": 13,
        "className": "Person",
        coords: [
            494.0,
            178.0,
            537.0,
            255.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:27.200000",
        "id": 15,
        "className": "Person",
        coords: [
            219.0,
            565.0,
            336.0,
            718.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:27.200000",
        "id": 21,
        "className": "Person",
        coords: [
            344.0,
            532.0,
            451.0,
            719.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:27.300000",
        "id": 19,
        "className": "Person",
        coords: [
            136.0,
            199.0,
            166.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:27.400000",
        "id": 13,
        "className": "Person",
        coords: [
            495.0,
            179.0,
            537.0,
            254.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:27.400000",
        "id": 15,
        "className": "Person",
        coords: [
            214.0,
            563.0,
            335.0,
            718.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:27.500000",
        "id": 21,
        "className": "Person",
        coords: [
            344.0,
            532.0,
            451.0,
            719.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:27.600000",
        "id": 19,
        "className": "Person",
        coords: [
            136.0,
            198.0,
            166.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:27.600000",
        "id": 13,
        "className": "Person",
        coords: [
            495.0,
            180.0,
            537.0,
            255.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:27.700000",
        "id": 15,
        "className": "Person",
        coords: [
            207.0,
            561.0,
            331.0,
            719.0
        ],
        "status": "Moving",
        "speed": 74.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:27.700000",
        "id": 21,
        "className": "Person",
        coords: [
            344.0,
            533.0,
            452.0,
            719.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:27.900000",
        "id": 19,
        "className": "Person",
        coords: [
            136.0,
            199.0,
            166.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:27.900000",
        "id": 13,
        "className": "Person",
        coords: [
            495.0,
            180.0,
            537.0,
            255.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:28",
        "id": 15,
        "className": "Person",
        coords: [
            201.0,
            559.0,
            329.0,
            719.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:28",
        "id": 21,
        "className": "Person",
        coords: [
            344.0,
            533.0,
            452.0,
            719.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:28.100000",
        "id": 19,
        "className": "Person",
        coords: [
            136.0,
            199.0,
            166.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:28.200000",
        "id": 13,
        "className": "Person",
        coords: [
            496.0,
            181.0,
            537.0,
            253.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:28.200000",
        "id": 15,
        "className": "Person",
        coords: [
            197.0,
            556.0,
            330.0,
            719.0
        ],
        "status": "Moving",
        "speed": 42.42,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:28.300000",
        "id": 21,
        "className": "Person",
        coords: [
            344.0,
            533.0,
            452.0,
            719.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:28.400000",
        "id": 19,
        "className": "Person",
        coords: [
            136.0,
            200.0,
            166.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:28.400000",
        "id": 13,
        "className": "Person",
        coords: [
            496.0,
            181.0,
            537.0,
            253.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:28.500000",
        "id": 15,
        "className": "Person",
        coords: [
            194.0,
            553.0,
            330.0,
            718.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:28.500000",
        "id": 21,
        "className": "Person",
        coords: [
            344.0,
            533.0,
            451.0,
            719.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:28.700000",
        "id": 19,
        "className": "Person",
        coords: [
            136.0,
            200.0,
            166.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:28.700000",
        "id": 13,
        "className": "Person",
        coords: [
            496.0,
            183.0,
            536.0,
            254.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:28.700000",
        "id": 15,
        "className": "Person",
        coords: [
            192.0,
            550.0,
            331.0,
            717.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:28.800000",
        "id": 21,
        "className": "Person",
        coords: [
            344.0,
            533.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:28.900000",
        "id": 19,
        "className": "Person",
        coords: [
            136.0,
            198.0,
            167.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:28.900000",
        "id": 13,
        "className": "Person",
        coords: [
            496.0,
            185.0,
            536.0,
            255.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:29",
        "id": 15,
        "className": "Person",
        coords: [
            191.0,
            546.0,
            333.0,
            716.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:29.100000",
        "id": 21,
        "className": "Person",
        coords: [
            343.0,
            532.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:29.100000",
        "id": 20,
        "className": "Person",
        coords: [
            671.0,
            449.0,
            798.0,
            603.0
        ],
        "status": "Moving",
        "speed": 585.72,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:29.200000",
        "id": 19,
        "className": "Person",
        coords: [
            135.0,
            197.0,
            167.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:29.300000",
        "id": 13,
        "className": "Person",
        coords: [
            496.0,
            184.0,
            536.0,
            255.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:29.300000",
        "id": 15,
        "className": "Person",
        coords: [
            190.0,
            543.0,
            334.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:29.400000",
        "id": 21,
        "className": "Person",
        coords: [
            343.0,
            532.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:29.400000",
        "id": 20,
        "className": "Person",
        coords: [
            664.0,
            449.0,
            804.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:29.500000",
        "id": 19,
        "className": "Person",
        coords: [
            135.0,
            194.0,
            167.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:29.600000",
        "id": 15,
        "className": "Person",
        coords: [
            189.0,
            540.0,
            335.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:29.600000",
        "id": 21,
        "className": "Person",
        coords: [
            342.0,
            532.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:29.700000",
        "id": 20,
        "className": "Person",
        coords: [
            659.0,
            449.0,
            809.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:29.800000",
        "id": 19,
        "className": "Person",
        coords: [
            135.0,
            193.0,
            167.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:29.900000",
        "id": 15,
        "className": "Person",
        coords: [
            188.0,
            538.0,
            336.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:29.900000",
        "id": 21,
        "className": "Person",
        coords: [
            342.0,
            532.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:30",
        "id": 20,
        "className": "Person",
        coords: [
            656.0,
            449.0,
            812.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:30.100000",
        "id": 19,
        "className": "Person",
        coords: [
            134.0,
            193.0,
            167.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:30.200000",
        "id": 15,
        "className": "Person",
        coords: [
            187.0,
            536.0,
            336.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:30.200000",
        "id": 21,
        "className": "Person",
        coords: [
            343.0,
            531.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:30.300000",
        "id": 20,
        "className": "Person",
        coords: [
            654.0,
            449.0,
            815.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:30.400000",
        "id": 19,
        "className": "Person",
        coords: [
            135.0,
            194.0,
            167.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:30.400000",
        "id": 15,
        "className": "Person",
        coords: [
            187.0,
            534.0,
            338.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:30.500000",
        "id": 21,
        "className": "Person",
        coords: [
            342.0,
            532.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:30.500000",
        "id": 20,
        "className": "Person",
        coords: [
            652.0,
            449.0,
            817.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:30.700000",
        "id": 19,
        "className": "Person",
        coords: [
            135.0,
            194.0,
            167.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:30.700000",
        "id": 15,
        "className": "Person",
        coords: [
            186.0,
            532.0,
            339.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:30.800000",
        "id": 21,
        "className": "Person",
        coords: [
            341.0,
            531.0,
            450.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:30.800000",
        "id": 20,
        "className": "Person",
        coords: [
            650.0,
            449.0,
            818.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:31",
        "id": 19,
        "className": "Person",
        coords: [
            134.0,
            193.0,
            167.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:31",
        "id": 15,
        "className": "Person",
        coords: [
            185.0,
            531.0,
            338.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:31.100000",
        "id": 21,
        "className": "Person",
        coords: [
            333.0,
            532.0,
            445.0,
            718.0
        ],
        "status": "Moving",
        "speed": 91.23,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:31.100000",
        "id": 20,
        "className": "Person",
        coords: [
            649.0,
            449.0,
            819.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:31.200000",
        "id": 19,
        "className": "Person",
        coords: [
            133.0,
            193.0,
            166.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:31.300000",
        "id": 15,
        "className": "Person",
        coords: [
            184.0,
            530.0,
            338.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:31.300000",
        "id": 21,
        "className": "Person",
        coords: [
            328.0,
            531.0,
            442.0,
            718.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:31.400000",
        "id": 20,
        "className": "Person",
        coords: [
            648.0,
            448.0,
            820.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:31.600000",
        "id": 19,
        "className": "Person",
        coords: [
            134.0,
            195.0,
            166.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:31.600000",
        "id": 15,
        "className": "Person",
        coords: [
            182.0,
            529.0,
            335.0,
            717.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:31.600000",
        "id": 21,
        "className": "Person",
        coords: [
            325.0,
            531.0,
            441.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:31.700000",
        "id": 20,
        "className": "Person",
        coords: [
            647.0,
            448.0,
            821.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:31.800000",
        "id": 19,
        "className": "Person",
        coords: [
            132.0,
            194.0,
            165.0,
            267.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:31.900000",
        "id": 15,
        "className": "Person",
        coords: [
            182.0,
            527.0,
            334.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:31.900000",
        "id": 21,
        "className": "Person",
        coords: [
            323.0,
            531.0,
            442.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:32",
        "id": 20,
        "className": "Person",
        coords: [
            646.0,
            449.0,
            822.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:32.100000",
        "id": 19,
        "className": "Person",
        coords: [
            131.0,
            195.0,
            164.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:32.200000",
        "id": 15,
        "className": "Person",
        coords: [
            179.0,
            524.0,
            333.0,
            718.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:32.200000",
        "id": 21,
        "className": "Person",
        coords: [
            322.0,
            531.0,
            443.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:32.300000",
        "id": 20,
        "className": "Person",
        coords: [
            646.0,
            449.0,
            823.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:32.400000",
        "id": 19,
        "className": "Person",
        coords: [
            130.0,
            196.0,
            163.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:32.500000",
        "id": 15,
        "className": "Person",
        coords: [
            173.0,
            520.0,
            329.0,
            718.0
        ],
        "status": "Moving",
        "speed": 80.77,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:32.500000",
        "id": 21,
        "className": "Person",
        coords: [
            321.0,
            531.0,
            443.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:32.500000",
        "id": 20,
        "className": "Person",
        coords: [
            645.0,
            449.0,
            823.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:32.700000",
        "id": 19,
        "className": "Person",
        coords: [
            121.0,
            199.0,
            156.0,
            266.0
        ],
        "status": "Moving",
        "speed": 120.92,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:32.700000",
        "id": 15,
        "className": "Person",
        coords: [
            164.0,
            515.0,
            325.0,
            718.0
        ],
        "status": "Moving",
        "speed": 114.23,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:32.800000",
        "id": 21,
        "className": "Person",
        coords: [
            320.0,
            531.0,
            443.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:32.800000",
        "id": 20,
        "className": "Person",
        coords: [
            645.0,
            449.0,
            824.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:33",
        "id": 19,
        "className": "Person",
        coords: [
            118.0,
            202.0,
            154.0,
            266.0
        ],
        "status": "Moving",
        "speed": 42.42,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:33",
        "id": 15,
        "className": "Person",
        coords: [
            155.0,
            508.0,
            321.0,
            719.0
        ],
        "status": "Moving",
        "speed": 100.61,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:33.100000",
        "id": 21,
        "className": "Person",
        coords: [
            319.0,
            531.0,
            444.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:33.100000",
        "id": 20,
        "className": "Person",
        coords: [
            644.0,
            449.0,
            824.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:33.200000",
        "id": 19,
        "className": "Person",
        coords: [
            117.0,
            204.0,
            155.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:33.300000",
        "id": 15,
        "className": "Person",
        coords: [
            148.0,
            502.0,
            318.0,
            718.0
        ],
        "status": "Moving",
        "speed": 87.46,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:33.300000",
        "id": 21,
        "className": "Person",
        coords: [
            319.0,
            531.0,
            445.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:33.400000",
        "id": 20,
        "className": "Person",
        coords: [
            643.0,
            449.0,
            825.0,
            604.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:33.500000",
        "id": 15,
        "className": "Person",
        coords: [
            144.0,
            497.0,
            318.0,
            718.0
        ],
        "status": "Moving",
        "speed": 54.08,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:33.600000",
        "id": 21,
        "className": "Person",
        coords: [
            318.0,
            531.0,
            445.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:33.700000",
        "id": 20,
        "className": "Person",
        coords: [
            644.0,
            449.0,
            825.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:33.800000",
        "id": 15,
        "className": "Person",
        coords: [
            142.0,
            494.0,
            317.0,
            718.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:33.900000",
        "id": 21,
        "className": "Person",
        coords: [
            317.0,
            531.0,
            446.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:33.900000",
        "id": 20,
        "className": "Person",
        coords: [
            643.0,
            449.0,
            825.0,
            604.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:34.100000",
        "id": 15,
        "className": "Person",
        coords: [
            141.0,
            492.0,
            317.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:34.100000",
        "id": 21,
        "className": "Person",
        coords: [
            317.0,
            531.0,
            446.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:34.200000",
        "id": 20,
        "className": "Person",
        coords: [
            642.0,
            449.0,
            826.0,
            604.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:34.300000",
        "id": 15,
        "className": "Person",
        coords: [
            140.0,
            489.0,
            319.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:34.400000",
        "id": 21,
        "className": "Person",
        coords: [
            316.0,
            531.0,
            447.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:34.400000",
        "id": 20,
        "className": "Person",
        coords: [
            642.0,
            449.0,
            826.0,
            604.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:34.600000",
        "id": 15,
        "className": "Person",
        coords: [
            140.0,
            486.0,
            320.0,
            717.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:34.700000",
        "id": 21,
        "className": "Person",
        coords: [
            316.0,
            531.0,
            448.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:34.700000",
        "id": 20,
        "className": "Person",
        coords: [
            641.0,
            449.0,
            826.0,
            604.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:34.900000",
        "id": 15,
        "className": "Person",
        coords: [
            141.0,
            485.0,
            321.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:34.900000",
        "id": 21,
        "className": "Person",
        coords: [
            316.0,
            531.0,
            448.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:35",
        "id": 20,
        "className": "Person",
        coords: [
            641.0,
            448.0,
            826.0,
            604.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:35.200000",
        "id": 15,
        "className": "Person",
        coords: [
            141.0,
            485.0,
            322.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:35.200000",
        "id": 21,
        "className": "Person",
        coords: [
            316.0,
            531.0,
            449.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:35.300000",
        "id": 20,
        "className": "Person",
        coords: [
            641.0,
            449.0,
            826.0,
            604.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:35.400000",
        "id": 15,
        "className": "Person",
        coords: [
            141.0,
            484.0,
            323.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:35.500000",
        "id": 21,
        "className": "Person",
        coords: [
            316.0,
            531.0,
            449.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:35.500000",
        "id": 20,
        "className": "Person",
        coords: [
            641.0,
            449.0,
            826.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:35.700000",
        "id": 15,
        "className": "Person",
        coords: [
            142.0,
            484.0,
            324.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:35.700000",
        "id": 21,
        "className": "Person",
        coords: [
            315.0,
            531.0,
            449.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:35.800000",
        "id": 20,
        "className": "Person",
        coords: [
            641.0,
            449.0,
            826.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:35.900000",
        "id": 15,
        "className": "Person",
        coords: [
            142.0,
            484.0,
            324.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:36",
        "id": 21,
        "className": "Person",
        coords: [
            315.0,
            531.0,
            449.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:36",
        "id": 20,
        "className": "Person",
        coords: [
            640.0,
            448.0,
            827.0,
            604.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:36.200000",
        "id": 15,
        "className": "Person",
        coords: [
            141.0,
            485.0,
            322.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:36.200000",
        "id": 21,
        "className": "Person",
        coords: [
            315.0,
            531.0,
            450.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:36.300000",
        "id": 20,
        "className": "Person",
        coords: [
            640.0,
            448.0,
            827.0,
            604.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:36.400000",
        "id": 15,
        "className": "Person",
        coords: [
            140.0,
            485.0,
            321.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:36.500000",
        "id": 21,
        "className": "Person",
        coords: [
            314.0,
            531.0,
            449.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:36.500000",
        "id": 20,
        "className": "Person",
        coords: [
            639.0,
            448.0,
            827.0,
            604.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:36.700000",
        "id": 15,
        "className": "Person",
        coords: [
            140.0,
            485.0,
            320.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:36.700000",
        "id": 21,
        "className": "Person",
        coords: [
            314.0,
            531.0,
            449.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:36.800000",
        "id": 20,
        "className": "Person",
        coords: [
            639.0,
            448.0,
            827.0,
            604.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:36.900000",
        "id": 15,
        "className": "Person",
        coords: [
            140.0,
            485.0,
            318.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:37",
        "id": 21,
        "className": "Person",
        coords: [
            313.0,
            531.0,
            449.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:37",
        "id": 20,
        "className": "Person",
        coords: [
            639.0,
            448.0,
            828.0,
            604.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:37.200000",
        "id": 15,
        "className": "Person",
        coords: [
            138.0,
            485.0,
            316.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:37.300000",
        "id": 21,
        "className": "Person",
        coords: [
            324.0,
            531.0,
            458.0,
            717.0
        ],
        "status": "Moving",
        "speed": 150.74,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:37.300000",
        "id": 20,
        "className": "Person",
        coords: [
            644.0,
            448.0,
            831.0,
            603.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:37.500000",
        "id": 15,
        "className": "Person",
        coords: [
            138.0,
            484.0,
            316.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:37.500000",
        "id": 21,
        "className": "Person",
        coords: [
            321.0,
            531.0,
            455.0,
            717.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:37.500000",
        "id": 20,
        "className": "Person",
        coords: [
            647.0,
            448.0,
            832.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:37.700000",
        "id": 15,
        "className": "Person",
        coords: [
            138.0,
            482.0,
            316.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:37.700000",
        "id": 21,
        "className": "Person",
        coords: [
            321.0,
            531.0,
            454.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:37.800000",
        "id": 20,
        "className": "Person",
        coords: [
            648.0,
            448.0,
            833.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:37.900000",
        "id": 15,
        "className": "Person",
        coords: [
            139.0,
            479.0,
            317.0,
            715.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:38",
        "id": 21,
        "className": "Person",
        coords: [
            318.0,
            531.0,
            452.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:38",
        "id": 20,
        "className": "Person",
        coords: [
            649.0,
            448.0,
            832.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:38.200000",
        "id": 15,
        "className": "Person",
        coords: [
            137.0,
            477.0,
            315.0,
            715.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:38.300000",
        "id": 21,
        "className": "Person",
        coords: [
            316.0,
            531.0,
            450.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:38.300000",
        "id": 20,
        "className": "Person",
        coords: [
            650.0,
            448.0,
            832.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:38.500000",
        "id": 15,
        "className": "Person",
        coords: [
            137.0,
            474.0,
            313.0,
            711.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:38.600000",
        "id": 21,
        "className": "Person",
        coords: [
            316.0,
            531.0,
            451.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:38.600000",
        "id": 20,
        "className": "Person",
        coords: [
            652.0,
            448.0,
            833.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:38.800000",
        "id": 15,
        "className": "Person",
        coords: [
            128.0,
            469.0,
            306.0,
            714.0
        ],
        "status": "Moving",
        "speed": 120.92,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:38.800000",
        "id": 21,
        "className": "Person",
        coords: [
            315.0,
            531.0,
            450.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:38.900000",
        "id": 20,
        "className": "Person",
        coords: [
            652.0,
            448.0,
            833.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:39",
        "id": 15,
        "className": "Person",
        coords: [
            121.0,
            466.0,
            298.0,
            716.0
        ],
        "status": "Moving",
        "speed": 119.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:39.100000",
        "id": 21,
        "className": "Person",
        coords: [
            314.0,
            531.0,
            450.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:39.100000",
        "id": 20,
        "className": "Person",
        coords: [
            653.0,
            448.0,
            833.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:39.300000",
        "id": 15,
        "className": "Person",
        coords: [
            129.0,
            462.0,
            279.0,
            672.0
        ],
        "status": "Moving",
        "speed": 367.7,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:39.300000",
        "id": 21,
        "className": "Person",
        coords: [
            314.0,
            531.0,
            450.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:39.400000",
        "id": 20,
        "className": "Person",
        coords: [
            654.0,
            448.0,
            833.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:39.500000",
        "id": 15,
        "className": "Person",
        coords: [
            129.0,
            459.0,
            270.0,
            655.0
        ],
        "status": "Moving",
        "speed": 167.69,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:39.600000",
        "id": 21,
        "className": "Person",
        coords: [
            313.0,
            531.0,
            450.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:39.700000",
        "id": 20,
        "className": "Person",
        coords: [
            653.0,
            448.0,
            832.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:39.800000",
        "id": 15,
        "className": "Person",
        coords: [
            111.0,
            457.0,
            277.0,
            695.0
        ],
        "status": "Moving",
        "speed": 294.68,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:39.800000",
        "id": 21,
        "className": "Person",
        coords: [
            315.0,
            531.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:39.900000",
        "id": 20,
        "className": "Person",
        coords: [
            655.0,
            448.0,
            832.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:40",
        "id": 15,
        "className": "Person",
        coords: [
            106.0,
            454.0,
            278.0,
            708.0
        ],
        "status": "Moving",
        "speed": 80.77,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:40",
        "id": 21,
        "className": "Person",
        coords: [
            321.0,
            531.0,
            456.0,
            718.0
        ],
        "status": "Moving",
        "speed": 74.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:40.100000",
        "id": 20,
        "className": "Person",
        coords: [
            656.0,
            448.0,
            833.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:40.200000",
        "id": 15,
        "className": "Person",
        coords: [
            104.0,
            452.0,
            277.0,
            714.0
        ],
        "status": "Moving",
        "speed": 42.42,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:40.300000",
        "id": 21,
        "className": "Person",
        coords: [
            327.0,
            531.0,
            460.0,
            718.0
        ],
        "status": "Moving",
        "speed": 74.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:40.300000",
        "id": 20,
        "className": "Person",
        coords: [
            657.0,
            448.0,
            833.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:40.500000",
        "id": 15,
        "className": "Person",
        coords: [
            104.0,
            451.0,
            276.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:40.500000",
        "id": 21,
        "className": "Person",
        coords: [
            330.0,
            531.0,
            461.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:40.600000",
        "id": 20,
        "className": "Person",
        coords: [
            658.0,
            448.0,
            833.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:40.700000",
        "id": 15,
        "className": "Person",
        coords: [
            106.0,
            450.0,
            272.0,
            714.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:40.800000",
        "id": 21,
        "className": "Person",
        coords: [
            329.0,
            531.0,
            459.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:40.800000",
        "id": 20,
        "className": "Person",
        coords: [
            658.0,
            448.0,
            832.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:41",
        "id": 15,
        "className": "Person",
        coords: [
            106.0,
            450.0,
            271.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:41",
        "id": 21,
        "className": "Person",
        coords: [
            321.0,
            531.0,
            451.0,
            718.0
        ],
        "status": "Moving",
        "speed": 119.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:41.100000",
        "id": 20,
        "className": "Person",
        coords: [
            654.0,
            448.0,
            829.0,
            603.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:41.200000",
        "id": 15,
        "className": "Person",
        coords: [
            108.0,
            449.0,
            269.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:41.300000",
        "id": 21,
        "className": "Person",
        coords: [
            317.0,
            531.0,
            449.0,
            718.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:41.300000",
        "id": 20,
        "className": "Person",
        coords: [
            647.0,
            448.0,
            825.0,
            604.0
        ],
        "status": "Moving",
        "speed": 76.48,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:41.500000",
        "id": 15,
        "className": "Person",
        coords: [
            109.0,
            449.0,
            268.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:41.500000",
        "id": 21,
        "className": "Person",
        coords: [
            315.0,
            531.0,
            448.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:41.600000",
        "id": 20,
        "className": "Person",
        coords: [
            645.0,
            448.0,
            823.0,
            604.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:41.700000",
        "id": 15,
        "className": "Person",
        coords: [
            110.0,
            449.0,
            266.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:41.800000",
        "id": 21,
        "className": "Person",
        coords: [
            314.0,
            531.0,
            448.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:41.800000",
        "id": 20,
        "className": "Person",
        coords: [
            643.0,
            447.0,
            823.0,
            604.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:42",
        "id": 15,
        "className": "Person",
        coords: [
            110.0,
            448.0,
            263.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:42",
        "id": 21,
        "className": "Person",
        coords: [
            314.0,
            531.0,
            448.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:42.100000",
        "id": 20,
        "className": "Person",
        coords: [
            643.0,
            447.0,
            824.0,
            604.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:42.200000",
        "id": 15,
        "className": "Person",
        coords: [
            110.0,
            447.0,
            262.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:42.200000",
        "id": 21,
        "className": "Person",
        coords: [
            314.0,
            531.0,
            448.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:42.300000",
        "id": 20,
        "className": "Person",
        coords: [
            642.0,
            447.0,
            824.0,
            604.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:42.400000",
        "id": 15,
        "className": "Person",
        coords: [
            104.0,
            444.0,
            256.0,
            718.0
        ],
        "status": "Moving",
        "speed": 91.23,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:42.500000",
        "id": 21,
        "className": "Person",
        coords: [
            313.0,
            531.0,
            449.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:42.500000",
        "id": 20,
        "className": "Person",
        coords: [
            642.0,
            447.0,
            824.0,
            604.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:42.700000",
        "id": 15,
        "className": "Person",
        coords: [
            100.0,
            441.0,
            253.0,
            717.0
        ],
        "status": "Moving",
        "speed": 67.08,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:42.700000",
        "id": 21,
        "className": "Person",
        coords: [
            313.0,
            531.0,
            449.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:42.800000",
        "id": 20,
        "className": "Person",
        coords: [
            641.0,
            447.0,
            825.0,
            604.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:42.900000",
        "id": 15,
        "className": "Person",
        coords: [
            97.0,
            440.0,
            250.0,
            717.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:43",
        "id": 21,
        "className": "Person",
        coords: [
            314.0,
            531.0,
            450.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:43",
        "id": 20,
        "className": "Person",
        coords: [
            642.0,
            447.0,
            825.0,
            604.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:43.200000",
        "id": 15,
        "className": "Person",
        coords: [
            94.0,
            440.0,
            248.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:43.200000",
        "id": 21,
        "className": "Person",
        coords: [
            314.0,
            531.0,
            450.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:43.300000",
        "id": 20,
        "className": "Person",
        coords: [
            641.0,
            447.0,
            825.0,
            604.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:43.400000",
        "id": 21,
        "className": "Person",
        coords: [
            313.0,
            531.0,
            450.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:43.500000",
        "id": 20,
        "className": "Person",
        coords: [
            641.0,
            447.0,
            825.0,
            604.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:43.600000",
        "id": 21,
        "className": "Person",
        coords: [
            313.0,
            531.0,
            450.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:43.700000",
        "id": 20,
        "className": "Person",
        coords: [
            641.0,
            447.0,
            826.0,
            604.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:43.700000",
        "id": 15,
        "className": "Person",
        coords: [
            83.0,
            433.0,
            215.0,
            669.0
        ],
        "status": "Moving",
        "speed": 522.38,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:43.800000",
        "id": 21,
        "className": "Person",
        coords: [
            322.0,
            531.0,
            457.0,
            717.0
        ],
        "status": "Moving",
        "speed": 119.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:43.900000",
        "id": 20,
        "className": "Person",
        coords: [
            640.0,
            448.0,
            826.0,
            604.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:43.900000",
        "id": 22,
        "className": "Person",
        coords: [
            127.0,
            191.0,
            167.0,
            268.0
        ],
        "status": "First Seen",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:17:44",
        "id": 15,
        "className": "Person",
        coords: [
            73.0,
            430.0,
            202.0,
            660.0
        ],
        "status": "Moving",
        "speed": 201.23,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:44.100000",
        "id": 21,
        "className": "Person",
        coords: [
            318.0,
            531.0,
            453.0,
            717.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:44.100000",
        "id": 20,
        "className": "Person",
        coords: [
            640.0,
            448.0,
            826.0,
            604.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:44.200000",
        "id": 22,
        "className": "Person",
        coords: [
            127.0,
            192.0,
            167.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:17:44.200000",
        "id": 15,
        "className": "Person",
        coords: [
            64.0,
            427.0,
            194.0,
            657.0
        ],
        "status": "Moving",
        "speed": 128.15,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:44.300000",
        "id": 21,
        "className": "Person",
        coords: [
            327.0,
            531.0,
            460.0,
            717.0
        ],
        "status": "Moving",
        "speed": 119.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:44.400000",
        "id": 20,
        "className": "Person",
        coords: [
            640.0,
            448.0,
            826.0,
            604.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:44.400000",
        "id": 22,
        "className": "Person",
        coords: [
            127.0,
            192.0,
            167.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:17:44.500000",
        "id": 15,
        "className": "Person",
        coords: [
            58.0,
            424.0,
            188.0,
            654.0
        ],
        "status": "Moving",
        "speed": 100.61,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:44.600000",
        "id": 21,
        "className": "Person",
        coords: [
            319.0,
            531.0,
            452.0,
            717.0
        ],
        "status": "Moving",
        "speed": 119.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:44.600000",
        "id": 20,
        "className": "Person",
        coords: [
            641.0,
            447.0,
            827.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:44.700000",
        "id": 22,
        "className": "Person",
        coords: [
            127.0,
            190.0,
            169.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:17:44.800000",
        "id": 15,
        "className": "Person",
        coords: [
            53.0,
            422.0,
            183.0,
            652.0
        ],
        "status": "Moving",
        "speed": 80.77,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:44.900000",
        "id": 21,
        "className": "Person",
        coords: [
            315.0,
            531.0,
            450.0,
            717.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:45",
        "id": 20,
        "className": "Person",
        coords: [
            642.0,
            447.0,
            827.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:45",
        "id": 22,
        "className": "Person",
        coords: [
            127.0,
            189.0,
            169.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:45",
        "id": 15,
        "className": "Person",
        coords: [
            50.0,
            421.0,
            182.0,
            653.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:45",
        "id": 23,
        "className": "Person",
        coords: [
            497.0,
            246.0,
            554.0,
            332.0
        ],
        "status": "First Seen",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:17:45.200000",
        "id": 21,
        "className": "Person",
        coords: [
            313.0,
            530.0,
            449.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:45.300000",
        "id": 20,
        "className": "Person",
        coords: [
            642.0,
            447.0,
            827.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:45.400000",
        "id": 22,
        "className": "Person",
        coords: [
            127.0,
            189.0,
            169.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:45.400000",
        "id": 15,
        "className": "Person",
        coords: [
            48.0,
            419.0,
            181.0,
            653.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:45.500000",
        "id": 23,
        "className": "Person",
        coords: [
            497.0,
            246.0,
            554.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:17:45.700000",
        "id": 21,
        "className": "Person",
        coords: [
            313.0,
            530.0,
            449.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:45.800000",
        "id": 20,
        "className": "Person",
        coords: [
            643.0,
            447.0,
            828.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:45.900000",
        "id": 22,
        "className": "Person",
        coords: [
            127.0,
            190.0,
            169.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:45.900000",
        "id": 15,
        "className": "Person",
        coords: [
            47.0,
            416.0,
            182.0,
            654.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:46",
        "id": 23,
        "className": "Person",
        coords: [
            496.0,
            246.0,
            554.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:17:46.100000",
        "id": 21,
        "className": "Person",
        coords: [
            312.0,
            530.0,
            449.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:46.200000",
        "id": 20,
        "className": "Person",
        coords: [
            643.0,
            448.0,
            828.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:46.200000",
        "id": 22,
        "className": "Person",
        coords: [
            128.0,
            189.0,
            169.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:46.300000",
        "id": 15,
        "className": "Person",
        coords: [
            48.0,
            413.0,
            183.0,
            651.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:46.400000",
        "id": 23,
        "className": "Person",
        coords: [
            496.0,
            246.0,
            554.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:17:46.500000",
        "id": 21,
        "className": "Person",
        coords: [
            312.0,
            530.0,
            449.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:46.600000",
        "id": 20,
        "className": "Person",
        coords: [
            648.0,
            448.0,
            832.0,
            603.0
        ],
        "status": "Moving",
        "speed": 74.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:46.700000",
        "id": 22,
        "className": "Person",
        coords: [
            128.0,
            190.0,
            170.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:46.700000",
        "id": 15,
        "className": "Person",
        coords: [
            50.0,
            411.0,
            186.0,
            651.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:46.800000",
        "id": 23,
        "className": "Person",
        coords: [
            497.0,
            247.0,
            554.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:47",
        "id": 21,
        "className": "Person",
        coords: [
            312.0,
            531.0,
            449.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:47",
        "id": 20,
        "className": "Person",
        coords: [
            650.0,
            448.0,
            833.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:47.100000",
        "id": 22,
        "className": "Person",
        coords: [
            129.0,
            190.0,
            170.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:47.200000",
        "id": 15,
        "className": "Person",
        coords: [
            50.0,
            408.0,
            189.0,
            654.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:47.200000",
        "id": 23,
        "className": "Person",
        coords: [
            497.0,
            247.0,
            554.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:47.400000",
        "id": 21,
        "className": "Person",
        coords: [
            311.0,
            531.0,
            449.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:47.500000",
        "id": 20,
        "className": "Person",
        coords: [
            652.0,
            448.0,
            833.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:47.600000",
        "id": 22,
        "className": "Person",
        coords: [
            129.0,
            190.0,
            170.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:47.700000",
        "id": 15,
        "className": "Person",
        coords: [
            48.0,
            404.0,
            190.0,
            655.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:47.800000",
        "id": 23,
        "className": "Person",
        coords: [
            497.0,
            247.0,
            553.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:48.100000",
        "id": 21,
        "className": "Person",
        coords: [
            311.0,
            531.0,
            450.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:48.200000",
        "id": 20,
        "className": "Person",
        coords: [
            650.0,
            448.0,
            831.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:48.300000",
        "id": 22,
        "className": "Person",
        coords: [
            131.0,
            191.0,
            171.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:48.300000",
        "id": 15,
        "className": "Person",
        coords: [
            48.0,
            398.0,
            193.0,
            656.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:48.400000",
        "id": 23,
        "className": "Person",
        coords: [
            498.0,
            247.0,
            553.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:48.500000",
        "id": 21,
        "className": "Person",
        coords: [
            312.0,
            531.0,
            450.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:48.600000",
        "id": 20,
        "className": "Person",
        coords: [
            652.0,
            448.0,
            833.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:48.600000",
        "id": 22,
        "className": "Person",
        coords: [
            132.0,
            192.0,
            172.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:48.700000",
        "id": 15,
        "className": "Person",
        coords: [
            48.0,
            394.0,
            193.0,
            655.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:48.700000",
        "id": 23,
        "className": "Person",
        coords: [
            498.0,
            247.0,
            553.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:48.900000",
        "id": 21,
        "className": "Person",
        coords: [
            311.0,
            531.0,
            450.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:48.900000",
        "id": 20,
        "className": "Person",
        coords: [
            654.0,
            448.0,
            833.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:49",
        "id": 22,
        "className": "Person",
        coords: [
            133.0,
            191.0,
            172.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:49",
        "id": 15,
        "className": "Person",
        coords: [
            48.0,
            390.0,
            194.0,
            655.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:49.100000",
        "id": 23,
        "className": "Person",
        coords: [
            498.0,
            247.0,
            553.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:49.200000",
        "id": 21,
        "className": "Person",
        coords: [
            311.0,
            531.0,
            450.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:49.300000",
        "id": 20,
        "className": "Person",
        coords: [
            657.0,
            448.0,
            835.0,
            602.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:49.400000",
        "id": 22,
        "className": "Person",
        coords: [
            134.0,
            193.0,
            172.0,
            269.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:49.400000",
        "id": 15,
        "className": "Person",
        coords: [
            43.0,
            387.0,
            195.0,
            665.0
        ],
        "status": "Moving",
        "speed": 67.08,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:49.500000",
        "id": 23,
        "className": "Person",
        coords: [
            497.0,
            246.0,
            553.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:49.600000",
        "id": 21,
        "className": "Person",
        coords: [
            311.0,
            531.0,
            450.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:49.700000",
        "id": 20,
        "className": "Person",
        coords: [
            659.0,
            448.0,
            835.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:49.700000",
        "id": 22,
        "className": "Person",
        coords: [
            135.0,
            194.0,
            172.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:49.800000",
        "id": 15,
        "className": "Person",
        coords: [
            42.0,
            383.0,
            194.0,
            667.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:49.800000",
        "id": 23,
        "className": "Person",
        coords: [
            497.0,
            246.0,
            552.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:50",
        "id": 21,
        "className": "Person",
        coords: [
            312.0,
            531.0,
            451.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:50.100000",
        "id": 20,
        "className": "Person",
        coords: [
            660.0,
            448.0,
            835.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:50.100000",
        "id": 22,
        "className": "Person",
        coords: [
            136.0,
            195.0,
            172.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:50.200000",
        "id": 15,
        "className": "Person",
        coords: [
            45.0,
            381.0,
            192.0,
            656.0
        ],
        "status": "Moving",
        "speed": 104.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:50.200000",
        "id": 23,
        "className": "Person",
        coords: [
            498.0,
            247.0,
            552.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:50.400000",
        "id": 21,
        "className": "Person",
        coords: [
            312.0,
            531.0,
            451.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:50.500000",
        "id": 20,
        "className": "Person",
        coords: [
            661.0,
            448.0,
            835.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:50.600000",
        "id": 22,
        "className": "Person",
        coords: [
            136.0,
            195.0,
            173.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:50.600000",
        "id": 15,
        "className": "Person",
        coords: [
            46.0,
            379.0,
            193.0,
            657.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:50.700000",
        "id": 23,
        "className": "Person",
        coords: [
            498.0,
            247.0,
            552.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:50.900000",
        "id": 21,
        "className": "Person",
        coords: [
            312.0,
            531.0,
            451.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:50.900000",
        "id": 20,
        "className": "Person",
        coords: [
            653.0,
            448.0,
            828.0,
            603.0
        ],
        "status": "Moving",
        "speed": 119.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:51",
        "id": 22,
        "className": "Person",
        coords: [
            136.0,
            192.0,
            173.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:51.100000",
        "id": 15,
        "className": "Person",
        coords: [
            48.0,
            377.0,
            188.0,
            646.0
        ],
        "status": "Moving",
        "speed": 106.06,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:51.100000",
        "id": 23,
        "className": "Person",
        coords: [
            496.0,
            248.0,
            551.0,
            333.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:51.300000",
        "id": 21,
        "className": "Person",
        coords: [
            312.0,
            531.0,
            451.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:51.400000",
        "id": 20,
        "className": "Person",
        coords: [
            653.0,
            448.0,
            828.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:51.400000",
        "id": 22,
        "className": "Person",
        coords: [
            136.0,
            192.0,
            174.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:51.500000",
        "id": 15,
        "className": "Person",
        coords: [
            46.0,
            376.0,
            190.0,
            653.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:51.600000",
        "id": 23,
        "className": "Person",
        coords: [
            497.0,
            248.0,
            551.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:51.800000",
        "id": 21,
        "className": "Person",
        coords: [
            313.0,
            531.0,
            451.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:51.900000",
        "id": 20,
        "className": "Person",
        coords: [
            653.0,
            448.0,
            828.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:51.900000",
        "id": 22,
        "className": "Person",
        coords: [
            136.0,
            191.0,
            174.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:52",
        "id": 15,
        "className": "Person",
        coords: [
            43.0,
            374.0,
            189.0,
            656.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:52.100000",
        "id": 23,
        "className": "Person",
        coords: [
            497.0,
            249.0,
            551.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:52.200000",
        "id": 21,
        "className": "Person",
        coords: [
            323.0,
            531.0,
            458.0,
            715.0
        ],
        "status": "Moving",
        "speed": 119.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:52.300000",
        "id": 20,
        "className": "Person",
        coords: [
            653.0,
            448.0,
            828.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:52.400000",
        "id": 22,
        "className": "Person",
        coords: [
            136.0,
            191.0,
            174.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:52.400000",
        "id": 15,
        "className": "Person",
        coords: [
            40.0,
            371.0,
            186.0,
            653.0
        ],
        "status": "Moving",
        "speed": 63.63,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:52.500000",
        "id": 23,
        "className": "Person",
        coords: [
            497.0,
            249.0,
            551.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:52.700000",
        "id": 20,
        "className": "Person",
        coords: [
            652.0,
            448.0,
            828.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:52.700000",
        "id": 22,
        "className": "Person",
        coords: [
            137.0,
            191.0,
            174.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:52.800000",
        "id": 15,
        "className": "Person",
        coords: [
            37.0,
            366.0,
            186.0,
            654.0
        ],
        "status": "Moving",
        "speed": 42.42,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:52.900000",
        "id": 23,
        "className": "Person",
        coords: [
            497.0,
            249.0,
            550.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:53.100000",
        "id": 20,
        "className": "Person",
        coords: [
            653.0,
            448.0,
            828.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:53.100000",
        "id": 22,
        "className": "Person",
        coords: [
            137.0,
            191.0,
            174.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:53.200000",
        "id": 15,
        "className": "Person",
        coords: [
            35.0,
            360.0,
            186.0,
            654.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:53.200000",
        "id": 23,
        "className": "Person",
        coords: [
            497.0,
            249.0,
            551.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:53.300000",
        "id": 21,
        "className": "Person",
        coords: [
            315.0,
            530.0,
            452.0,
            716.0
        ],
        "status": "Moving",
        "speed": 104.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:53.500000",
        "id": 20,
        "className": "Person",
        coords: [
            652.0,
            448.0,
            828.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:53.500000",
        "id": 22,
        "className": "Person",
        coords: [
            138.0,
            191.0,
            174.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:53.600000",
        "id": 15,
        "className": "Person",
        coords: [
            32.0,
            358.0,
            185.0,
            653.0
        ],
        "status": "Moving",
        "speed": 42.42,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:53.600000",
        "id": 23,
        "className": "Person",
        coords: [
            497.0,
            250.0,
            550.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:53.700000",
        "id": 21,
        "className": "Person",
        coords: [
            312.0,
            529.0,
            451.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:53.900000",
        "id": 20,
        "className": "Person",
        coords: [
            651.0,
            448.0,
            827.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:53.900000",
        "id": 22,
        "className": "Person",
        coords: [
            138.0,
            192.0,
            175.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:54",
        "id": 15,
        "className": "Person",
        coords: [
            30.0,
            355.0,
            185.0,
            654.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:54.100000",
        "id": 23,
        "className": "Person",
        coords: [
            497.0,
            250.0,
            550.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:54.100000",
        "id": 21,
        "className": "Person",
        coords: [
            311.0,
            529.0,
            451.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:54.300000",
        "id": 20,
        "className": "Person",
        coords: [
            654.0,
            448.0,
            829.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:54.400000",
        "id": 22,
        "className": "Person",
        coords: [
            138.0,
            192.0,
            175.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:54.400000",
        "id": 23,
        "className": "Person",
        coords: [
            497.0,
            250.0,
            550.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:54.500000",
        "id": 21,
        "className": "Person",
        coords: [
            311.0,
            529.0,
            451.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:54.600000",
        "id": 20,
        "className": "Person",
        coords: [
            659.0,
            448.0,
            833.0,
            602.0
        ],
        "status": "Moving",
        "speed": 74.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:54.700000",
        "id": 22,
        "className": "Person",
        coords: [
            138.0,
            191.0,
            175.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:54.700000",
        "id": 23,
        "className": "Person",
        coords: [
            497.0,
            250.0,
            550.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:54.800000",
        "id": 21,
        "className": "Person",
        coords: [
            310.0,
            529.0,
            451.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:54.800000",
        "id": 15,
        "className": "Person",
        coords: [
            18.0,
            350.0,
            150.0,
            611.0
        ],
        "status": "Moving",
        "speed": 498.58,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:55",
        "id": 20,
        "className": "Person",
        coords: [
            661.0,
            448.0,
            834.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:55",
        "id": 22,
        "className": "Person",
        coords: [
            138.0,
            191.0,
            176.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:55.100000",
        "id": 23,
        "className": "Person",
        coords: [
            498.0,
            250.0,
            550.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:55.200000",
        "id": 21,
        "className": "Person",
        coords: [
            310.0,
            529.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:55.300000",
        "id": 15,
        "className": "Person",
        coords: [
            17.0,
            349.0,
            140.0,
            599.0
        ],
        "status": "Moving",
        "speed": 127.27,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:55.500000",
        "id": 20,
        "className": "Person",
        coords: [
            660.0,
            448.0,
            833.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:55.600000",
        "id": 22,
        "className": "Person",
        coords: [
            138.0,
            191.0,
            176.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:55.700000",
        "id": 23,
        "className": "Person",
        coords: [
            498.0,
            251.0,
            550.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:55.700000",
        "id": 21,
        "className": "Person",
        coords: [
            310.0,
            529.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:55.800000",
        "id": 15,
        "className": "Person",
        coords: [
            18.0,
            347.0,
            137.0,
            594.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:56",
        "id": 20,
        "className": "Person",
        coords: [
            660.0,
            448.0,
            832.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:56.100000",
        "id": 22,
        "className": "Person",
        coords: [
            138.0,
            191.0,
            175.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:56.100000",
        "id": 23,
        "className": "Person",
        coords: [
            499.0,
            251.0,
            550.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:56.200000",
        "id": 21,
        "className": "Person",
        coords: [
            310.0,
            530.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:56.300000",
        "id": 15,
        "className": "Person",
        coords: [
            19.0,
            343.0,
            135.0,
            591.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:56.500000",
        "id": 20,
        "className": "Person",
        coords: [
            661.0,
            448.0,
            832.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:56.600000",
        "id": 22,
        "className": "Person",
        coords: [
            139.0,
            192.0,
            176.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:56.600000",
        "id": 23,
        "className": "Person",
        coords: [
            499.0,
            250.0,
            551.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:56.700000",
        "id": 21,
        "className": "Person",
        coords: [
            310.0,
            530.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:56.800000",
        "id": 15,
        "className": "Person",
        coords: [
            21.0,
            340.0,
            132.0,
            581.0
        ],
        "status": "Moving",
        "speed": 106.06,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:57.100000",
        "id": 20,
        "className": "Person",
        coords: [
            665.0,
            448.0,
            834.0,
            602.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:57.200000",
        "id": 22,
        "className": "Person",
        coords: [
            138.0,
            191.0,
            175.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:57.300000",
        "id": 23,
        "className": "Person",
        coords: [
            499.0,
            251.0,
            550.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:57.300000",
        "id": 21,
        "className": "Person",
        coords: [
            311.0,
            530.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:57.400000",
        "id": 15,
        "className": "Person",
        coords: [
            23.0,
            336.0,
            130.0,
            571.0
        ],
        "status": "Moving",
        "speed": 104.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:57.600000",
        "id": 22,
        "className": "Person",
        coords: [
            138.0,
            192.0,
            176.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:57.700000",
        "id": 23,
        "className": "Person",
        coords: [
            498.0,
            249.0,
            550.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:57.800000",
        "id": 21,
        "className": "Person",
        coords: [
            310.0,
            530.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:57.800000",
        "id": 15,
        "className": "Person",
        coords: [
            27.0,
            333.0,
            127.0,
            557.0
        ],
        "status": "Moving",
        "speed": 120.92,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:58",
        "id": 22,
        "className": "Person",
        coords: [
            139.0,
            192.0,
            176.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:58.100000",
        "id": 23,
        "className": "Person",
        coords: [
            498.0,
            248.0,
            551.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:58.100000",
        "id": 21,
        "className": "Person",
        coords: [
            311.0,
            530.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:58.200000",
        "id": 15,
        "className": "Person",
        coords: [
            29.0,
            331.0,
            126.0,
            551.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:58.400000",
        "id": 22,
        "className": "Person",
        coords: [
            139.0,
            192.0,
            176.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:58.400000",
        "id": 23,
        "className": "Person",
        coords: [
            498.0,
            248.0,
            551.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:58.500000",
        "id": 21,
        "className": "Person",
        coords: [
            311.0,
            530.0,
            453.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:58.500000",
        "id": 15,
        "className": "Person",
        coords: [
            30.0,
            328.0,
            125.0,
            545.0
        ],
        "status": "Moving",
        "speed": 74.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:58.700000",
        "id": 22,
        "className": "Person",
        coords: [
            139.0,
            192.0,
            176.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:58.800000",
        "id": 23,
        "className": "Person",
        coords: [
            497.0,
            248.0,
            550.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:58.800000",
        "id": 21,
        "className": "Person",
        coords: [
            316.0,
            530.0,
            456.0,
            716.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:58.900000",
        "id": 15,
        "className": "Person",
        coords: [
            32.0,
            325.0,
            124.0,
            536.0
        ],
        "status": "Moving",
        "speed": 91.23,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:59",
        "id": 22,
        "className": "Person",
        coords: [
            139.0,
            192.0,
            176.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:59.100000",
        "id": 23,
        "className": "Person",
        coords: [
            497.0,
            248.0,
            550.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:59.200000",
        "id": 21,
        "className": "Person",
        coords: [
            315.0,
            531.0,
            454.0,
            717.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:59.200000",
        "id": 15,
        "className": "Person",
        coords: [
            33.0,
            324.0,
            123.0,
            531.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:59.400000",
        "id": 22,
        "className": "Person",
        coords: [
            139.0,
            192.0,
            176.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:59.400000",
        "id": 23,
        "className": "Person",
        coords: [
            497.0,
            248.0,
            551.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:59.500000",
        "id": 21,
        "className": "Person",
        coords: [
            316.0,
            532.0,
            455.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:59.500000",
        "id": 15,
        "className": "Person",
        coords: [
            33.0,
            323.0,
            120.0,
            526.0
        ],
        "status": "Moving",
        "speed": 54.08,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:59.700000",
        "id": 22,
        "className": "Person",
        coords: [
            139.0,
            192.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:17:59.700000",
        "id": 23,
        "className": "Person",
        coords: [
            497.0,
            248.0,
            550.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:59.800000",
        "id": 15,
        "className": "Person",
        coords: [
            33.0,
            322.0,
            117.0,
            516.0
        ],
        "status": "Moving",
        "speed": 76.48,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:17:59.900000",
        "id": 22,
        "className": "Person",
        coords: [
            138.0,
            192.0,
            176.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:00",
        "id": 23,
        "className": "Person",
        coords: [
            497.0,
            248.0,
            550.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:00",
        "id": 15,
        "className": "Person",
        coords: [
            29.0,
            319.0,
            113.0,
            511.0
        ],
        "status": "Moving",
        "speed": 84.85,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:00.200000",
        "id": 22,
        "className": "Person",
        coords: [
            138.0,
            192.0,
            176.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:00.200000",
        "id": 23,
        "className": "Person",
        coords: [
            497.0,
            248.0,
            550.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:00.300000",
        "id": 15,
        "className": "Person",
        coords: [
            27.0,
            316.0,
            111.0,
            505.0
        ],
        "status": "Moving",
        "speed": 80.77,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:00.400000",
        "id": 22,
        "className": "Person",
        coords: [
            139.0,
            192.0,
            176.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:00.500000",
        "id": 23,
        "className": "Person",
        coords: [
            496.0,
            248.0,
            550.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:00.500000",
        "id": 15,
        "className": "Person",
        coords: [
            25.0,
            314.0,
            109.0,
            501.0
        ],
        "status": "Moving",
        "speed": 54.08,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:00.700000",
        "id": 22,
        "className": "Person",
        coords: [
            139.0,
            192.0,
            176.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:00.700000",
        "id": 23,
        "className": "Person",
        coords: [
            496.0,
            248.0,
            550.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:00.800000",
        "id": 15,
        "className": "Person",
        coords: [
            23.0,
            311.0,
            109.0,
            501.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:00.900000",
        "id": 22,
        "className": "Person",
        coords: [
            139.0,
            192.0,
            176.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:01",
        "id": 23,
        "className": "Person",
        coords: [
            496.0,
            248.0,
            550.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:01.100000",
        "id": 15,
        "className": "Person",
        coords: [
            22.0,
            309.0,
            109.0,
            500.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:01.300000",
        "id": 22,
        "className": "Person",
        coords: [
            139.0,
            193.0,
            176.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:01.300000",
        "id": 23,
        "className": "Person",
        coords: [
            496.0,
            248.0,
            550.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:01.400000",
        "id": 15,
        "className": "Person",
        coords: [
            21.0,
            308.0,
            110.0,
            500.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:01.600000",
        "id": 22,
        "className": "Person",
        coords: [
            139.0,
            193.0,
            176.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:01.600000",
        "id": 23,
        "className": "Person",
        coords: [
            496.0,
            248.0,
            550.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:01.700000",
        "id": 15,
        "className": "Person",
        coords: [
            20.0,
            308.0,
            110.0,
            500.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:01.900000",
        "id": 22,
        "className": "Person",
        coords: [
            139.0,
            193.0,
            176.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:01.900000",
        "id": 23,
        "className": "Person",
        coords: [
            496.0,
            248.0,
            550.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:02",
        "id": 15,
        "className": "Person",
        coords: [
            20.0,
            308.0,
            111.0,
            500.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:02.100000",
        "id": 22,
        "className": "Person",
        coords: [
            138.0,
            193.0,
            176.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:02.200000",
        "id": 23,
        "className": "Person",
        coords: [
            495.0,
            248.0,
            549.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:02.200000",
        "id": 15,
        "className": "Person",
        coords: [
            15.0,
            303.0,
            113.0,
            511.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:02.300000",
        "id": 21,
        "className": "Person",
        coords: [
            335.0,
            536.0,
            465.0,
            718.0
        ],
        "status": "Moving",
        "speed": 229.44,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:02.500000",
        "id": 22,
        "className": "Person",
        coords: [
            138.0,
            193.0,
            176.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:02.500000",
        "id": 23,
        "className": "Person",
        coords: [
            495.0,
            248.0,
            549.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:02.600000",
        "id": 15,
        "className": "Person",
        coords: [
            14.0,
            301.0,
            114.0,
            516.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:02.700000",
        "id": 21,
        "className": "Person",
        coords: [
            338.0,
            536.0,
            464.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:02.800000",
        "id": 22,
        "className": "Person",
        coords: [
            138.0,
            193.0,
            176.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:02.900000",
        "id": 23,
        "className": "Person",
        coords: [
            495.0,
            248.0,
            549.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:03",
        "id": 15,
        "className": "Person",
        coords: [
            13.0,
            301.0,
            114.0,
            518.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:03.100000",
        "id": 21,
        "className": "Person",
        coords: [
            339.0,
            536.0,
            463.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:03.200000",
        "id": 22,
        "className": "Person",
        coords: [
            138.0,
            193.0,
            176.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:03.400000",
        "id": 23,
        "className": "Person",
        coords: [
            494.0,
            248.0,
            549.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:03.400000",
        "id": 15,
        "className": "Person",
        coords: [
            13.0,
            300.0,
            114.0,
            518.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:03.500000",
        "id": 21,
        "className": "Person",
        coords: [
            341.0,
            536.0,
            462.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:03.700000",
        "id": 22,
        "className": "Person",
        coords: [
            139.0,
            193.0,
            176.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:03.700000",
        "id": 23,
        "className": "Person",
        coords: [
            494.0,
            248.0,
            549.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:03.800000",
        "id": 15,
        "className": "Person",
        coords: [
            14.0,
            299.0,
            115.0,
            519.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:03.900000",
        "id": 21,
        "className": "Person",
        coords: [
            342.0,
            537.0,
            461.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:04",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:04.100000",
        "id": 23,
        "className": "Person",
        coords: [
            497.0,
            249.0,
            550.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:04.100000",
        "id": 15,
        "className": "Person",
        coords: [
            13.0,
            294.0,
            108.0,
            503.0
        ],
        "status": "Moving",
        "speed": 175.56,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:04.300000",
        "id": 21,
        "className": "Person",
        coords: [
            342.0,
            537.0,
            459.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:04.500000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            178.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:04.600000",
        "id": 23,
        "className": "Person",
        coords: [
            498.0,
            250.0,
            550.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:04.600000",
        "id": 15,
        "className": "Person",
        coords: [
            13.0,
            291.0,
            106.0,
            499.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:04.700000",
        "id": 21,
        "className": "Person",
        coords: [
            343.0,
            537.0,
            459.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:04.900000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:05",
        "id": 23,
        "className": "Person",
        coords: [
            498.0,
            250.0,
            550.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:05",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            289.0,
            105.0,
            498.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:05.100000",
        "id": 21,
        "className": "Person",
        coords: [
            343.0,
            537.0,
            458.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:05.300000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:05.300000",
        "id": 23,
        "className": "Person",
        coords: [
            498.0,
            250.0,
            550.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:05.400000",
        "id": 15,
        "className": "Person",
        coords: [
            13.0,
            287.0,
            103.0,
            493.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:05.500000",
        "id": 21,
        "className": "Person",
        coords: [
            344.0,
            537.0,
            457.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:05.600000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:05.700000",
        "id": 23,
        "className": "Person",
        coords: [
            498.0,
            250.0,
            550.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:05.700000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            286.0,
            102.0,
            496.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:05.900000",
        "id": 21,
        "className": "Person",
        coords: [
            344.0,
            537.0,
            457.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:06",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:06.100000",
        "id": 23,
        "className": "Person",
        coords: [
            499.0,
            250.0,
            550.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:06.100000",
        "id": 15,
        "className": "Person",
        coords: [
            13.0,
            285.0,
            101.0,
            493.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:06.200000",
        "id": 21,
        "className": "Person",
        coords: [
            345.0,
            537.0,
            456.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:06.400000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:06.400000",
        "id": 23,
        "className": "Person",
        coords: [
            499.0,
            250.0,
            550.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:06.500000",
        "id": 15,
        "className": "Person",
        coords: [
            14.0,
            285.0,
            99.0,
            490.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:06.500000",
        "id": 21,
        "className": "Person",
        coords: [
            345.0,
            537.0,
            456.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:06.700000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:06.700000",
        "id": 23,
        "className": "Person",
        coords: [
            499.0,
            250.0,
            550.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:06.800000",
        "id": 15,
        "className": "Person",
        coords: [
            13.0,
            284.0,
            99.0,
            490.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:06.900000",
        "id": 21,
        "className": "Person",
        coords: [
            345.0,
            537.0,
            455.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:07",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:07.100000",
        "id": 23,
        "className": "Person",
        coords: [
            499.0,
            250.0,
            550.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:07.100000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            282.0,
            98.0,
            494.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:07.200000",
        "id": 21,
        "className": "Person",
        coords: [
            345.0,
            537.0,
            455.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:07.300000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            176.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:07.400000",
        "id": 23,
        "className": "Person",
        coords: [
            499.0,
            250.0,
            550.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:07.400000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            280.0,
            98.0,
            495.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:07.500000",
        "id": 21,
        "className": "Person",
        coords: [
            345.0,
            537.0,
            455.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:07.600000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            176.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:07.700000",
        "id": 23,
        "className": "Person",
        coords: [
            501.0,
            250.0,
            550.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:07.700000",
        "id": 15,
        "className": "Person",
        coords: [
            8.0,
            278.0,
            89.0,
            475.0
        ],
        "status": "Moving",
        "speed": 187.93,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:07.800000",
        "id": 21,
        "className": "Person",
        coords: [
            332.0,
            537.0,
            444.0,
            717.0
        ],
        "status": "Moving",
        "speed": 179.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:08",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            176.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:08",
        "id": 23,
        "className": "Person",
        coords: [
            502.0,
            251.0,
            550.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:08.100000",
        "id": 15,
        "className": "Person",
        coords: [
            7.0,
            277.0,
            85.0,
            467.0
        ],
        "status": "Moving",
        "speed": 67.08,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:08.100000",
        "id": 21,
        "className": "Person",
        coords: [
            326.0,
            536.0,
            441.0,
            717.0
        ],
        "status": "Moving",
        "speed": 76.48,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:08.300000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            176.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:08.300000",
        "id": 23,
        "className": "Person",
        coords: [
            502.0,
            251.0,
            550.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:08.400000",
        "id": 15,
        "className": "Person",
        coords: [
            5.0,
            275.0,
            84.0,
            464.0
        ],
        "status": "Moving",
        "speed": 54.08,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:08.500000",
        "id": 21,
        "className": "Person",
        coords: [
            323.0,
            536.0,
            441.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:08.600000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            175.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:08.600000",
        "id": 23,
        "className": "Person",
        coords: [
            502.0,
            250.0,
            550.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:08.700000",
        "id": 15,
        "className": "Person",
        coords: [
            4.0,
            274.0,
            83.0,
            463.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:08.800000",
        "id": 21,
        "className": "Person",
        coords: [
            321.0,
            536.0,
            442.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:08.900000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            175.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:09",
        "id": 23,
        "className": "Person",
        coords: [
            502.0,
            250.0,
            551.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:09",
        "id": 15,
        "className": "Person",
        coords: [
            4.0,
            273.0,
            83.0,
            462.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:09.100000",
        "id": 21,
        "className": "Person",
        coords: [
            320.0,
            536.0,
            442.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:09.200000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            176.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:09.300000",
        "id": 23,
        "className": "Person",
        coords: [
            502.0,
            250.0,
            551.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:09.300000",
        "id": 15,
        "className": "Person",
        coords: [
            4.0,
            273.0,
            83.0,
            462.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:09.400000",
        "id": 21,
        "className": "Person",
        coords: [
            319.0,
            536.0,
            443.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:09.500000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            176.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:09.600000",
        "id": 23,
        "className": "Person",
        coords: [
            502.0,
            250.0,
            551.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:09.600000",
        "id": 15,
        "className": "Person",
        coords: [
            4.0,
            273.0,
            83.0,
            462.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:09.700000",
        "id": 21,
        "className": "Person",
        coords: [
            319.0,
            536.0,
            444.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:09.800000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            176.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:09.900000",
        "id": 23,
        "className": "Person",
        coords: [
            501.0,
            250.0,
            551.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:09.900000",
        "id": 15,
        "className": "Person",
        coords: [
            4.0,
            271.0,
            84.0,
            462.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:10",
        "id": 21,
        "className": "Person",
        coords: [
            318.0,
            536.0,
            445.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:10.100000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            176.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:10.200000",
        "id": 23,
        "className": "Person",
        coords: [
            502.0,
            249.0,
            551.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:10.200000",
        "id": 15,
        "className": "Person",
        coords: [
            3.0,
            269.0,
            84.0,
            462.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:10.300000",
        "id": 21,
        "className": "Person",
        coords: [
            317.0,
            536.0,
            446.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:10.400000",
        "id": 22,
        "className": "Person",
        coords: [
            139.0,
            193.0,
            175.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:10.500000",
        "id": 23,
        "className": "Person",
        coords: [
            502.0,
            250.0,
            551.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:10.500000",
        "id": 15,
        "className": "Person",
        coords: [
            5.0,
            267.0,
            85.0,
            460.0
        ],
        "status": "Moving",
        "speed": 42.42,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:10.600000",
        "id": 21,
        "className": "Person",
        coords: [
            317.0,
            536.0,
            446.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:10.800000",
        "id": 22,
        "className": "Person",
        coords: [
            139.0,
            193.0,
            175.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:10.800000",
        "id": 23,
        "className": "Person",
        coords: [
            502.0,
            250.0,
            550.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:10.800000",
        "id": 15,
        "className": "Person",
        coords: [
            5.0,
            263.0,
            84.0,
            458.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:10.900000",
        "id": 21,
        "className": "Person",
        coords: [
            316.0,
            536.0,
            447.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:11",
        "id": 22,
        "className": "Person",
        coords: [
            139.0,
            193.0,
            175.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:11.100000",
        "id": 23,
        "className": "Person",
        coords: [
            502.0,
            250.0,
            550.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:11.200000",
        "id": 21,
        "className": "Person",
        coords: [
            316.0,
            536.0,
            447.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:11.300000",
        "id": 22,
        "className": "Person",
        coords: [
            139.0,
            193.0,
            176.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:11.400000",
        "id": 23,
        "className": "Person",
        coords: [
            502.0,
            250.0,
            550.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:11.400000",
        "id": 21,
        "className": "Person",
        coords: [
            315.0,
            536.0,
            448.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:11.500000",
        "id": 15,
        "className": "Person",
        coords: [
            0.0,
            259.0,
            81.0,
            458.0
        ],
        "status": "Moving",
        "speed": 67.08,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:11.700000",
        "id": 22,
        "className": "Person",
        coords: [
            139.0,
            193.0,
            176.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:11.700000",
        "id": 23,
        "className": "Person",
        coords: [
            502.0,
            250.0,
            550.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:11.800000",
        "id": 21,
        "className": "Person",
        coords: [
            315.0,
            536.0,
            449.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:11.800000",
        "id": 15,
        "className": "Person",
        coords: [
            1.0,
            258.0,
            80.0,
            453.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:12",
        "id": 22,
        "className": "Person",
        coords: [
            139.0,
            193.0,
            176.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:12",
        "id": 23,
        "className": "Person",
        coords: [
            502.0,
            251.0,
            550.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:12.100000",
        "id": 21,
        "className": "Person",
        coords: [
            315.0,
            536.0,
            449.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:12.100000",
        "id": 15,
        "className": "Person",
        coords: [
            5.0,
            257.0,
            80.0,
            442.0
        ],
        "status": "Moving",
        "speed": 94.86,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:12.300000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:12.300000",
        "id": 23,
        "className": "Person",
        coords: [
            501.0,
            252.0,
            549.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:12.400000",
        "id": 21,
        "className": "Person",
        coords: [
            314.0,
            536.0,
            449.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:12.400000",
        "id": 15,
        "className": "Person",
        coords: [
            9.0,
            256.0,
            81.0,
            438.0
        ],
        "status": "Moving",
        "speed": 54.08,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:12.600000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:12.600000",
        "id": 23,
        "className": "Person",
        coords: [
            501.0,
            252.0,
            549.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:12.700000",
        "id": 21,
        "className": "Person",
        coords: [
            314.0,
            536.0,
            450.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:12.700000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            256.0,
            81.0,
            435.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:12.900000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:12.900000",
        "id": 23,
        "className": "Person",
        coords: [
            501.0,
            253.0,
            549.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:13",
        "id": 21,
        "className": "Person",
        coords: [
            314.0,
            536.0,
            450.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:13",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            256.0,
            80.0,
            435.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:13.200000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:13.200000",
        "id": 23,
        "className": "Person",
        coords: [
            501.0,
            253.0,
            549.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:13.300000",
        "id": 21,
        "className": "Person",
        coords: [
            314.0,
            536.0,
            450.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:13.400000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            256.0,
            80.0,
            435.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:13.500000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:13.500000",
        "id": 23,
        "className": "Person",
        coords: [
            501.0,
            253.0,
            549.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:13.600000",
        "id": 21,
        "className": "Person",
        coords: [
            314.0,
            536.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:13.600000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            255.0,
            79.0,
            432.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:13.800000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:13.800000",
        "id": 23,
        "className": "Person",
        coords: [
            501.0,
            253.0,
            549.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:13.900000",
        "id": 21,
        "className": "Person",
        coords: [
            314.0,
            536.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:13.900000",
        "id": 15,
        "className": "Person",
        coords: [
            14.0,
            254.0,
            80.0,
            426.0
        ],
        "status": "Moving",
        "speed": 54.08,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:14.100000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:14.100000",
        "id": 23,
        "className": "Person",
        coords: [
            501.0,
            253.0,
            549.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:14.200000",
        "id": 21,
        "className": "Person",
        coords: [
            313.0,
            536.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:14.200000",
        "id": 15,
        "className": "Person",
        coords: [
            14.0,
            253.0,
            81.0,
            426.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:14.400000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:14.400000",
        "id": 23,
        "className": "Person",
        coords: [
            500.0,
            253.0,
            550.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:14.500000",
        "id": 21,
        "className": "Person",
        coords: [
            312.0,
            536.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:14.500000",
        "id": 15,
        "className": "Person",
        coords: [
            15.0,
            252.0,
            80.0,
            421.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:14.700000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:14.700000",
        "id": 23,
        "className": "Person",
        coords: [
            500.0,
            252.0,
            550.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:14.800000",
        "id": 21,
        "className": "Person",
        coords: [
            312.0,
            536.0,
            450.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:14.800000",
        "id": 15,
        "className": "Person",
        coords: [
            16.0,
            251.0,
            80.0,
            419.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:15",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:15",
        "id": 23,
        "className": "Person",
        coords: [
            498.0,
            251.0,
            549.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:15.100000",
        "id": 21,
        "className": "Person",
        coords: [
            312.0,
            536.0,
            450.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:15.100000",
        "id": 15,
        "className": "Person",
        coords: [
            16.0,
            250.0,
            81.0,
            419.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:15.300000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:15.300000",
        "id": 23,
        "className": "Person",
        coords: [
            497.0,
            251.0,
            549.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:15.400000",
        "id": 21,
        "className": "Person",
        coords: [
            311.0,
            536.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:15.400000",
        "id": 15,
        "className": "Person",
        coords: [
            16.0,
            249.0,
            81.0,
            418.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:15.600000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:15.600000",
        "id": 23,
        "className": "Person",
        coords: [
            497.0,
            251.0,
            549.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:15.700000",
        "id": 21,
        "className": "Person",
        coords: [
            311.0,
            535.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:15.800000",
        "id": 15,
        "className": "Person",
        coords: [
            16.0,
            248.0,
            80.0,
            417.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:15.900000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            275.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:15.900000",
        "id": 23,
        "className": "Person",
        coords: [
            497.0,
            251.0,
            549.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:16",
        "id": 21,
        "className": "Person",
        coords: [
            310.0,
            535.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:16.100000",
        "id": 15,
        "className": "Person",
        coords: [
            17.0,
            248.0,
            80.0,
            417.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:16.200000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            275.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:16.200000",
        "id": 23,
        "className": "Person",
        coords: [
            496.0,
            250.0,
            549.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:16.300000",
        "id": 21,
        "className": "Person",
        coords: [
            310.0,
            535.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:16.300000",
        "id": 15,
        "className": "Person",
        coords: [
            16.0,
            247.0,
            80.0,
            417.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:16.500000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            194.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:16.500000",
        "id": 23,
        "className": "Person",
        coords: [
            496.0,
            251.0,
            549.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:16.600000",
        "id": 21,
        "className": "Person",
        coords: [
            310.0,
            535.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:16.600000",
        "id": 15,
        "className": "Person",
        coords: [
            16.0,
            244.0,
            80.0,
            417.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:16.800000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            193.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:16.800000",
        "id": 23,
        "className": "Person",
        coords: [
            494.0,
            250.0,
            549.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:16.900000",
        "id": 21,
        "className": "Person",
        coords: [
            312.0,
            534.0,
            452.0,
            717.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:16.900000",
        "id": 15,
        "className": "Person",
        coords: [
            14.0,
            242.0,
            78.0,
            414.0
        ],
        "status": "Moving",
        "speed": 42.42,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:17.100000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:17.100000",
        "id": 23,
        "className": "Person",
        coords: [
            493.0,
            250.0,
            549.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:17.200000",
        "id": 21,
        "className": "Person",
        coords: [
            311.0,
            534.0,
            452.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:17.200000",
        "id": 15,
        "className": "Person",
        coords: [
            14.0,
            240.0,
            76.0,
            407.0
        ],
        "status": "Moving",
        "speed": 76.48,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:17.400000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:17.400000",
        "id": 23,
        "className": "Person",
        coords: [
            493.0,
            250.0,
            549.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:17.500000",
        "id": 15,
        "className": "Person",
        coords: [
            15.0,
            240.0,
            74.0,
            400.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:17.600000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:17.700000",
        "id": 23,
        "className": "Person",
        coords: [
            493.0,
            250.0,
            549.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:17.700000",
        "id": 15,
        "className": "Person",
        coords: [
            15.0,
            239.0,
            73.0,
            397.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:17.900000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:17.900000",
        "id": 23,
        "className": "Person",
        coords: [
            493.0,
            250.0,
            549.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:18",
        "id": 15,
        "className": "Person",
        coords: [
            14.0,
            239.0,
            73.0,
            396.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:18.100000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            176.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:18.200000",
        "id": 23,
        "className": "Person",
        coords: [
            493.0,
            250.0,
            549.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:18.200000",
        "id": 15,
        "className": "Person",
        coords: [
            14.0,
            238.0,
            73.0,
            397.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:18.300000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:18.400000",
        "id": 23,
        "className": "Person",
        coords: [
            493.0,
            250.0,
            549.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:18.400000",
        "id": 15,
        "className": "Person",
        coords: [
            14.0,
            238.0,
            73.0,
            397.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:18.600000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            176.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:18.600000",
        "id": 23,
        "className": "Person",
        coords: [
            493.0,
            250.0,
            550.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:18.700000",
        "id": 15,
        "className": "Person",
        coords: [
            15.0,
            241.0,
            72.0,
            396.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:18.800000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            176.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:18.900000",
        "id": 23,
        "className": "Person",
        coords: [
            493.0,
            250.0,
            550.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:18.900000",
        "id": 15,
        "className": "Person",
        coords: [
            14.0,
            240.0,
            72.0,
            396.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:19",
        "id": 21,
        "className": "Person",
        coords: [
            310.0,
            532.0,
            452.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:19.100000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            176.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:19.200000",
        "id": 23,
        "className": "Person",
        coords: [
            493.0,
            249.0,
            550.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:19.200000",
        "id": 15,
        "className": "Person",
        coords: [
            14.0,
            241.0,
            72.0,
            396.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:19.300000",
        "id": 21,
        "className": "Person",
        coords: [
            309.0,
            532.0,
            452.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:19.500000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            176.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:19.500000",
        "id": 23,
        "className": "Person",
        coords: [
            493.0,
            248.0,
            550.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:19.500000",
        "id": 15,
        "className": "Person",
        coords: [
            15.0,
            245.0,
            71.0,
            396.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:19.600000",
        "id": 21,
        "className": "Person",
        coords: [
            311.0,
            532.0,
            453.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:19.700000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            176.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:19.800000",
        "id": 23,
        "className": "Person",
        coords: [
            492.0,
            249.0,
            550.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:19.800000",
        "id": 15,
        "className": "Person",
        coords: [
            13.0,
            239.0,
            71.0,
            393.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:19.900000",
        "id": 21,
        "className": "Person",
        coords: [
            312.0,
            533.0,
            453.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:20",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:20.100000",
        "id": 23,
        "className": "Person",
        coords: [
            493.0,
            248.0,
            550.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:20.100000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            235.0,
            71.0,
            392.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:20.200000",
        "id": 21,
        "className": "Person",
        coords: [
            325.0,
            534.0,
            462.0,
            717.0
        ],
        "status": "Moving",
        "speed": 164.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:20.300000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:20.400000",
        "id": 23,
        "className": "Person",
        coords: [
            493.0,
            248.0,
            551.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:20.400000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            235.0,
            70.0,
            390.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:20.500000",
        "id": 21,
        "className": "Person",
        coords: [
            321.0,
            535.0,
            458.0,
            718.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:20.600000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:20.700000",
        "id": 23,
        "className": "Person",
        coords: [
            494.0,
            248.0,
            551.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:20.700000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            232.0,
            69.0,
            384.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:20.800000",
        "id": 21,
        "className": "Person",
        coords: [
            329.0,
            537.0,
            462.0,
            718.0
        ],
        "status": "Moving",
        "speed": 91.23,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:20.900000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:21",
        "id": 23,
        "className": "Person",
        coords: [
            494.0,
            249.0,
            551.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:21",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            230.0,
            69.0,
            383.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:21.100000",
        "id": 21,
        "className": "Person",
        coords: [
            322.0,
            539.0,
            456.0,
            718.0
        ],
        "status": "Moving",
        "speed": 91.23,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:21.200000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            178.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:21.300000",
        "id": 23,
        "className": "Person",
        coords: [
            494.0,
            249.0,
            550.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:21.300000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            230.0,
            70.0,
            384.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:21.400000",
        "id": 21,
        "className": "Person",
        coords: [
            319.0,
            540.0,
            454.0,
            718.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:21.600000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            192.0,
            178.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:21.600000",
        "id": 23,
        "className": "Person",
        coords: [
            493.0,
            249.0,
            549.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:21.700000",
        "id": 15,
        "className": "Person",
        coords: [
            13.0,
            230.0,
            70.0,
            384.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:21.700000",
        "id": 21,
        "className": "Person",
        coords: [
            319.0,
            542.0,
            454.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:21.900000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            192.0,
            178.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:21.900000",
        "id": 23,
        "className": "Person",
        coords: [
            492.0,
            249.0,
            549.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:22",
        "id": 15,
        "className": "Person",
        coords: [
            13.0,
            230.0,
            70.0,
            384.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:22",
        "id": 21,
        "className": "Person",
        coords: [
            319.0,
            543.0,
            456.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:22.200000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            192.0,
            178.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:22.200000",
        "id": 23,
        "className": "Person",
        coords: [
            492.0,
            249.0,
            549.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:22.300000",
        "id": 15,
        "className": "Person",
        coords: [
            13.0,
            230.0,
            71.0,
            385.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:22.400000",
        "id": 21,
        "className": "Person",
        coords: [
            320.0,
            544.0,
            459.0,
            718.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:22.500000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            193.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:22.600000",
        "id": 23,
        "className": "Person",
        coords: [
            492.0,
            249.0,
            549.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:22.600000",
        "id": 15,
        "className": "Person",
        coords: [
            13.0,
            229.0,
            71.0,
            384.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:22.700000",
        "id": 21,
        "className": "Person",
        coords: [
            321.0,
            545.0,
            461.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:22.700000",
        "id": 24,
        "className": "Person",
        coords: [
            182.0,
            183.0,
            223.0,
            282.0
        ],
        "status": "First Seen",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:18:22.900000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            193.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:22.900000",
        "id": 23,
        "className": "Person",
        coords: [
            492.0,
            249.0,
            549.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:23",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            228.0,
            70.0,
            383.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:23.100000",
        "id": 21,
        "className": "Person",
        coords: [
            322.0,
            545.0,
            464.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:23.100000",
        "id": 24,
        "className": "Person",
        coords: [
            182.0,
            184.0,
            221.0,
            279.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:18:23.200000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            193.0,
            176.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:23.300000",
        "id": 23,
        "className": "Person",
        coords: [
            492.0,
            249.0,
            549.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:23.300000",
        "id": 15,
        "className": "Person",
        coords: [
            14.0,
            227.0,
            70.0,
            377.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:23.400000",
        "id": 24,
        "className": "Person",
        coords: [
            181.0,
            186.0,
            220.0,
            280.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:18:23.500000",
        "id": 23,
        "className": "Person",
        coords: [
            492.0,
            249.0,
            550.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:23.600000",
        "id": 15,
        "className": "Person",
        coords: [
            13.0,
            225.0,
            69.0,
            375.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:23.600000",
        "id": 24,
        "className": "Person",
        coords: [
            185.0,
            191.0,
            221.0,
            279.0
        ],
        "status": "Moving",
        "speed": 54.08,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:18:23.800000",
        "id": 23,
        "className": "Person",
        coords: [
            494.0,
            250.0,
            551.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:23.800000",
        "id": 15,
        "className": "Person",
        coords: [
            13.0,
            226.0,
            68.0,
            371.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:23.900000",
        "id": 23,
        "className": "Person",
        coords: [
            493.0,
            249.0,
            550.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:24",
        "id": 15,
        "className": "Person",
        coords: [
            14.0,
            226.0,
            66.0,
            367.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:24.100000",
        "id": 23,
        "className": "Person",
        coords: [
            492.0,
            249.0,
            550.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:24.200000",
        "id": 15,
        "className": "Person",
        coords: [
            13.0,
            225.0,
            66.0,
            366.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:24.300000",
        "id": 23,
        "className": "Person",
        coords: [
            492.0,
            250.0,
            550.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:24.400000",
        "id": 15,
        "className": "Person",
        coords: [
            13.0,
            224.0,
            66.0,
            366.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:24.400000",
        "id": 21,
        "className": "Person",
        coords: [
            352.0,
            547.0,
            491.0,
            718.0
        ],
        "status": "Moving",
        "speed": 420.23,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:24.600000",
        "id": 23,
        "className": "Person",
        coords: [
            494.0,
            250.0,
            551.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:24.600000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            221.0,
            67.0,
            368.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:24.700000",
        "id": 21,
        "className": "Person",
        coords: [
            340.0,
            547.0,
            483.0,
            718.0
        ],
        "status": "Moving",
        "speed": 149.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:24.800000",
        "id": 23,
        "className": "Person",
        coords: [
            496.0,
            251.0,
            551.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:24.900000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            221.0,
            66.0,
            366.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:24.900000",
        "id": 21,
        "className": "Person",
        coords: [
            335.0,
            547.0,
            479.0,
            717.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:25.100000",
        "id": 23,
        "className": "Person",
        coords: [
            494.0,
            250.0,
            551.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:25.100000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            220.0,
            64.0,
            364.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:25.200000",
        "id": 21,
        "className": "Person",
        coords: [
            330.0,
            546.0,
            477.0,
            717.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:25.200000",
        "id": 22,
        "className": "Person",
        coords: [
            138.0,
            190.0,
            174.0,
            274.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:25.400000",
        "id": 23,
        "className": "Person",
        coords: [
            494.0,
            250.0,
            551.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:25.400000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            221.0,
            63.0,
            364.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:25.500000",
        "id": 21,
        "className": "Person",
        coords: [
            330.0,
            546.0,
            481.0,
            718.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:25.500000",
        "id": 22,
        "className": "Person",
        coords: [
            138.0,
            190.0,
            174.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:25.700000",
        "id": 23,
        "className": "Person",
        coords: [
            494.0,
            249.0,
            551.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:25.700000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            224.0,
            62.0,
            362.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:25.700000",
        "id": 21,
        "className": "Person",
        coords: [
            333.0,
            546.0,
            489.0,
            717.0
        ],
        "status": "Moving",
        "speed": 91.23,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:25.800000",
        "id": 22,
        "className": "Person",
        coords: [
            139.0,
            190.0,
            174.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:25.900000",
        "id": 23,
        "className": "Person",
        coords: [
            494.0,
            249.0,
            551.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:26",
        "id": 15,
        "className": "Person",
        coords: [
            9.0,
            227.0,
            59.0,
            362.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:26",
        "id": 21,
        "className": "Person",
        coords: [
            339.0,
            545.0,
            500.0,
            715.0
        ],
        "status": "Moving",
        "speed": 120.92,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:26.100000",
        "id": 22,
        "className": "Person",
        coords: [
            138.0,
            190.0,
            173.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:26.200000",
        "id": 23,
        "className": "Person",
        coords: [
            494.0,
            249.0,
            550.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:26.300000",
        "id": 21,
        "className": "Person",
        coords: [
            341.0,
            544.0,
            511.0,
            717.0
        ],
        "status": "Moving",
        "speed": 104.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:26.400000",
        "id": 23,
        "className": "Person",
        coords: [
            494.0,
            250.0,
            550.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:26.500000",
        "id": 21,
        "className": "Person",
        coords: [
            341.0,
            544.0,
            519.0,
            717.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:26.600000",
        "id": 23,
        "className": "Person",
        coords: [
            493.0,
            250.0,
            550.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:26.700000",
        "id": 21,
        "className": "Person",
        coords: [
            335.0,
            544.0,
            518.0,
            717.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:26.700000",
        "id": 15,
        "className": "Person",
        coords: [
            3.0,
            221.0,
            56.0,
            361.0
        ],
        "status": "Moving",
        "speed": 87.46,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:26.900000",
        "id": 23,
        "className": "Person",
        coords: [
            493.0,
            250.0,
            550.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:26.900000",
        "id": 21,
        "className": "Person",
        coords: [
            331.0,
            544.0,
            517.0,
            718.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:27",
        "id": 15,
        "className": "Person",
        coords: [
            3.0,
            228.0,
            52.0,
            356.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:27.100000",
        "id": 23,
        "className": "Person",
        coords: [
            493.0,
            250.0,
            550.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:27.200000",
        "id": 21,
        "className": "Person",
        coords: [
            326.0,
            543.0,
            515.0,
            719.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:27.300000",
        "id": 21,
        "className": "Person",
        coords: [
            321.0,
            543.0,
            509.0,
            717.0
        ],
        "status": "Moving",
        "speed": 76.48,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:27.400000",
        "id": 15,
        "className": "Person",
        coords: [
            3.0,
            226.0,
            52.0,
            353.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:27.500000",
        "id": 21,
        "className": "Person",
        coords: [
            314.0,
            542.0,
            501.0,
            717.0
        ],
        "status": "Moving",
        "speed": 120.92,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:27.600000",
        "id": 15,
        "className": "Person",
        coords: [
            4.0,
            228.0,
            51.0,
            348.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:27.600000",
        "id": 23,
        "className": "Person",
        coords: [
            496.0,
            256.0,
            549.0,
            331.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:27.800000",
        "id": 21,
        "className": "Person",
        coords: [
            309.0,
            542.0,
            494.0,
            718.0
        ],
        "status": "Moving",
        "speed": 91.23,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:27.800000",
        "id": 15,
        "className": "Person",
        coords: [
            4.0,
            221.0,
            52.0,
            344.0
        ],
        "status": "Moving",
        "speed": 91.23,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:27.900000",
        "id": 23,
        "className": "Person",
        coords: [
            497.0,
            257.0,
            549.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:28.100000",
        "id": 21,
        "className": "Person",
        coords: [
            307.0,
            541.0,
            491.0,
            718.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:28.100000",
        "id": 15,
        "className": "Person",
        coords: [
            3.0,
            219.0,
            53.0,
            344.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:28.100000",
        "id": 23,
        "className": "Person",
        coords: [
            497.0,
            257.0,
            549.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:28.300000",
        "id": 21,
        "className": "Person",
        coords: [
            308.0,
            540.0,
            490.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:28.400000",
        "id": 23,
        "className": "Person",
        coords: [
            497.0,
            257.0,
            549.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:28.600000",
        "id": 21,
        "className": "Person",
        coords: [
            309.0,
            539.0,
            488.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:28.600000",
        "id": 23,
        "className": "Person",
        coords: [
            497.0,
            257.0,
            549.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:28.700000",
        "id": 15,
        "className": "Person",
        coords: [
            2.0,
            211.0,
            55.0,
            345.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:28.800000",
        "id": 21,
        "className": "Person",
        coords: [
            312.0,
            539.0,
            489.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:28.900000",
        "id": 23,
        "className": "Person",
        coords: [
            496.0,
            254.0,
            550.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:28.900000",
        "id": 15,
        "className": "Person",
        coords: [
            2.0,
            211.0,
            56.0,
            347.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:29",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            191.0,
            176.0,
            273.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:29.100000",
        "id": 21,
        "className": "Person",
        coords: [
            310.0,
            539.0,
            484.0,
            718.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:29.200000",
        "id": 23,
        "className": "Person",
        coords: [
            496.0,
            254.0,
            551.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:29.300000",
        "id": 15,
        "className": "Person",
        coords: [
            2.0,
            213.0,
            55.0,
            349.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:29.300000",
        "id": 22,
        "className": "Person",
        coords: [
            143.0,
            192.0,
            176.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:29.500000",
        "id": 21,
        "className": "Person",
        coords: [
            307.0,
            538.0,
            480.0,
            718.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:29.500000",
        "id": 23,
        "className": "Person",
        coords: [
            496.0,
            253.0,
            551.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:29.600000",
        "id": 15,
        "className": "Person",
        coords: [
            3.0,
            217.0,
            54.0,
            349.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:29.600000",
        "id": 22,
        "className": "Person",
        coords: [
            143.0,
            192.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:29.800000",
        "id": 21,
        "className": "Person",
        coords: [
            306.0,
            538.0,
            478.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:29.800000",
        "id": 23,
        "className": "Person",
        coords: [
            496.0,
            253.0,
            551.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:29.900000",
        "id": 15,
        "className": "Person",
        coords: [
            5.0,
            223.0,
            53.0,
            347.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:29.900000",
        "id": 22,
        "className": "Person",
        coords: [
            143.0,
            192.0,
            176.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:30.100000",
        "id": 21,
        "className": "Person",
        coords: [
            306.0,
            538.0,
            477.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:30.100000",
        "id": 23,
        "className": "Person",
        coords: [
            496.0,
            253.0,
            551.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:30.200000",
        "id": 22,
        "className": "Person",
        coords: [
            143.0,
            192.0,
            176.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:30.300000",
        "id": 21,
        "className": "Person",
        coords: [
            307.0,
            538.0,
            476.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:30.400000",
        "id": 23,
        "className": "Person",
        coords: [
            496.0,
            253.0,
            551.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:30.400000",
        "id": 22,
        "className": "Person",
        coords: [
            143.0,
            192.0,
            176.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:30.500000",
        "id": 15,
        "className": "Person",
        coords: [
            6.0,
            226.0,
            52.0,
            343.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:30.700000",
        "id": 21,
        "className": "Person",
        coords: [
            308.0,
            538.0,
            475.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:30.800000",
        "id": 23,
        "className": "Person",
        coords: [
            497.0,
            253.0,
            551.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:30.800000",
        "id": 22,
        "className": "Person",
        coords: [
            143.0,
            191.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:31",
        "id": 21,
        "className": "Person",
        coords: [
            308.0,
            538.0,
            474.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:31",
        "id": 23,
        "className": "Person",
        coords: [
            497.0,
            254.0,
            551.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:31.100000",
        "id": 22,
        "className": "Person",
        coords: [
            143.0,
            191.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:31.100000",
        "id": 15,
        "className": "Person",
        coords: [
            8.0,
            226.0,
            53.0,
            342.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:31.300000",
        "id": 21,
        "className": "Person",
        coords: [
            308.0,
            538.0,
            473.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:31.300000",
        "id": 23,
        "className": "Person",
        coords: [
            498.0,
            255.0,
            550.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:31.400000",
        "id": 22,
        "className": "Person",
        coords: [
            143.0,
            191.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:31.500000",
        "id": 15,
        "className": "Person",
        coords: [
            8.0,
            224.0,
            54.0,
            341.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:31.700000",
        "id": 21,
        "className": "Person",
        coords: [
            309.0,
            538.0,
            473.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:31.700000",
        "id": 23,
        "className": "Person",
        coords: [
            498.0,
            255.0,
            550.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:31.800000",
        "id": 22,
        "className": "Person",
        coords: [
            143.0,
            191.0,
            176.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:31.900000",
        "id": 15,
        "className": "Person",
        coords: [
            8.0,
            222.0,
            54.0,
            341.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:32",
        "id": 21,
        "className": "Person",
        coords: [
            310.0,
            539.0,
            474.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:32.100000",
        "id": 23,
        "className": "Person",
        coords: [
            497.0,
            254.0,
            550.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:32.100000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            192.0,
            176.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:32.200000",
        "id": 15,
        "className": "Person",
        coords: [
            8.0,
            220.0,
            55.0,
            342.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:32.300000",
        "id": 21,
        "className": "Person",
        coords: [
            311.0,
            539.0,
            474.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:32.400000",
        "id": 23,
        "className": "Person",
        coords: [
            496.0,
            253.0,
            550.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:32.400000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            192.0,
            176.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:32.500000",
        "id": 15,
        "className": "Person",
        coords: [
            8.0,
            218.0,
            55.0,
            341.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:32.600000",
        "id": 21,
        "className": "Person",
        coords: [
            312.0,
            539.0,
            474.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:32.600000",
        "id": 23,
        "className": "Person",
        coords: [
            496.0,
            253.0,
            550.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:32.700000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            192.0,
            176.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:32.700000",
        "id": 15,
        "className": "Person",
        coords: [
            9.0,
            218.0,
            55.0,
            341.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:32.900000",
        "id": 21,
        "className": "Person",
        coords: [
            312.0,
            539.0,
            474.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:32.900000",
        "id": 23,
        "className": "Person",
        coords: [
            496.0,
            253.0,
            550.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:33",
        "id": 22,
        "className": "Person",
        coords: [
            143.0,
            192.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:33",
        "id": 15,
        "className": "Person",
        coords: [
            9.0,
            215.0,
            56.0,
            341.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:33.200000",
        "id": 21,
        "className": "Person",
        coords: [
            313.0,
            540.0,
            475.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:33.200000",
        "id": 23,
        "className": "Person",
        coords: [
            494.0,
            251.0,
            550.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:33.300000",
        "id": 22,
        "className": "Person",
        coords: [
            143.0,
            192.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:33.300000",
        "id": 15,
        "className": "Person",
        coords: [
            9.0,
            210.0,
            57.0,
            342.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:33.500000",
        "id": 21,
        "className": "Person",
        coords: [
            314.0,
            540.0,
            476.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:33.500000",
        "id": 23,
        "className": "Person",
        coords: [
            496.0,
            252.0,
            551.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:33.600000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            192.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:33.600000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            208.0,
            59.0,
            342.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:33.800000",
        "id": 21,
        "className": "Person",
        coords: [
            315.0,
            541.0,
            476.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:33.800000",
        "id": 23,
        "className": "Person",
        coords: [
            497.0,
            252.0,
            551.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:33.800000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            192.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:33.900000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            207.0,
            59.0,
            342.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:34.100000",
        "id": 21,
        "className": "Person",
        coords: [
            316.0,
            541.0,
            476.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:34.100000",
        "id": 23,
        "className": "Person",
        coords: [
            498.0,
            252.0,
            552.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:34.100000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            193.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:34.200000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            206.0,
            60.0,
            342.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:34.300000",
        "id": 21,
        "className": "Person",
        coords: [
            317.0,
            541.0,
            477.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:34.400000",
        "id": 23,
        "className": "Person",
        coords: [
            498.0,
            253.0,
            551.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:34.400000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            193.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:34.500000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            207.0,
            60.0,
            342.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:34.600000",
        "id": 21,
        "className": "Person",
        coords: [
            318.0,
            541.0,
            477.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:34.700000",
        "id": 23,
        "className": "Person",
        coords: [
            498.0,
            253.0,
            551.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:34.700000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            192.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:34.800000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            207.0,
            59.0,
            341.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:34.900000",
        "id": 21,
        "className": "Person",
        coords: [
            319.0,
            542.0,
            477.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:35",
        "id": 23,
        "className": "Person",
        coords: [
            498.0,
            253.0,
            551.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:35",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            192.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:35.100000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            205.0,
            60.0,
            341.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:35.200000",
        "id": 21,
        "className": "Person",
        coords: [
            319.0,
            542.0,
            477.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:35.300000",
        "id": 23,
        "className": "Person",
        coords: [
            498.0,
            252.0,
            551.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:35.300000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            192.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:35.300000",
        "id": 15,
        "className": "Person",
        coords: [
            13.0,
            206.0,
            62.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:35.500000",
        "id": 21,
        "className": "Person",
        coords: [
            319.0,
            543.0,
            477.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:35.500000",
        "id": 23,
        "className": "Person",
        coords: [
            498.0,
            251.0,
            551.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:35.600000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            192.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:35.600000",
        "id": 15,
        "className": "Person",
        coords: [
            14.0,
            206.0,
            62.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:35.800000",
        "id": 21,
        "className": "Person",
        coords: [
            318.0,
            543.0,
            475.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:35.900000",
        "id": 23,
        "className": "Person",
        coords: [
            498.0,
            251.0,
            551.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:35.900000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            192.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:36",
        "id": 15,
        "className": "Person",
        coords: [
            15.0,
            206.0,
            63.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:36.100000",
        "id": 21,
        "className": "Person",
        coords: [
            321.0,
            543.0,
            478.0,
            718.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:36.200000",
        "id": 23,
        "className": "Person",
        coords: [
            498.0,
            251.0,
            551.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:36.200000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            192.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:36.300000",
        "id": 15,
        "className": "Person",
        coords: [
            15.0,
            206.0,
            64.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:36.500000",
        "id": 21,
        "className": "Person",
        coords: [
            324.0,
            543.0,
            480.0,
            718.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:36.500000",
        "id": 23,
        "className": "Person",
        coords: [
            496.0,
            250.0,
            550.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:36.600000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            192.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:36.600000",
        "id": 15,
        "className": "Person",
        coords: [
            14.0,
            207.0,
            63.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:36.800000",
        "id": 21,
        "className": "Person",
        coords: [
            322.0,
            543.0,
            478.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:36.800000",
        "id": 23,
        "className": "Person",
        coords: [
            495.0,
            250.0,
            550.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:36.800000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            192.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:36.900000",
        "id": 15,
        "className": "Person",
        coords: [
            14.0,
            206.0,
            64.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:37",
        "id": 21,
        "className": "Person",
        coords: [
            319.0,
            543.0,
            476.0,
            718.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:37.100000",
        "id": 23,
        "className": "Person",
        coords: [
            495.0,
            250.0,
            549.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:37.100000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            192.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:37.200000",
        "id": 15,
        "className": "Person",
        coords: [
            14.0,
            205.0,
            64.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:37.300000",
        "id": 21,
        "className": "Person",
        coords: [
            318.0,
            543.0,
            475.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:37.400000",
        "id": 23,
        "className": "Person",
        coords: [
            495.0,
            250.0,
            549.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:37.400000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            192.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:37.500000",
        "id": 15,
        "className": "Person",
        coords: [
            14.0,
            205.0,
            64.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:37.600000",
        "id": 21,
        "className": "Person",
        coords: [
            317.0,
            543.0,
            475.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:37.700000",
        "id": 23,
        "className": "Person",
        coords: [
            495.0,
            250.0,
            549.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:37.700000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            192.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:37.800000",
        "id": 15,
        "className": "Person",
        coords: [
            14.0,
            204.0,
            64.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:37.900000",
        "id": 21,
        "className": "Person",
        coords: [
            315.0,
            542.0,
            473.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:38",
        "id": 23,
        "className": "Person",
        coords: [
            497.0,
            250.0,
            551.0,
            331.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:38",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            192.0,
            176.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:38",
        "id": 15,
        "className": "Person",
        coords: [
            14.0,
            204.0,
            65.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:38.200000",
        "id": 21,
        "className": "Person",
        coords: [
            312.0,
            542.0,
            470.0,
            718.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:38.200000",
        "id": 23,
        "className": "Person",
        coords: [
            498.0,
            250.0,
            551.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:38.300000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            192.0,
            176.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:38.300000",
        "id": 15,
        "className": "Person",
        coords: [
            15.0,
            204.0,
            65.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:38.500000",
        "id": 21,
        "className": "Person",
        coords: [
            311.0,
            542.0,
            468.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:38.500000",
        "id": 23,
        "className": "Person",
        coords: [
            499.0,
            251.0,
            551.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:38.600000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            192.0,
            176.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:38.600000",
        "id": 15,
        "className": "Person",
        coords: [
            15.0,
            203.0,
            65.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:38.800000",
        "id": 21,
        "className": "Person",
        coords: [
            310.0,
            541.0,
            468.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:38.800000",
        "id": 23,
        "className": "Person",
        coords: [
            499.0,
            251.0,
            551.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:38.900000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            192.0,
            176.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:38.900000",
        "id": 15,
        "className": "Person",
        coords: [
            15.0,
            205.0,
            64.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:39.100000",
        "id": 21,
        "className": "Person",
        coords: [
            310.0,
            541.0,
            467.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:39.100000",
        "id": 23,
        "className": "Person",
        coords: [
            499.0,
            251.0,
            551.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:39.200000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            192.0,
            176.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:39.200000",
        "id": 15,
        "className": "Person",
        coords: [
            14.0,
            205.0,
            64.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:39.400000",
        "id": 21,
        "className": "Person",
        coords: [
            310.0,
            540.0,
            467.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:39.400000",
        "id": 23,
        "className": "Person",
        coords: [
            499.0,
            250.0,
            551.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:39.500000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            192.0,
            176.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:39.500000",
        "id": 15,
        "className": "Person",
        coords: [
            14.0,
            206.0,
            63.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:39.700000",
        "id": 21,
        "className": "Person",
        coords: [
            310.0,
            540.0,
            466.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:39.700000",
        "id": 23,
        "className": "Person",
        coords: [
            500.0,
            250.0,
            551.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:39.700000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            192.0,
            176.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:39.800000",
        "id": 15,
        "className": "Person",
        coords: [
            14.0,
            205.0,
            61.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:39.900000",
        "id": 21,
        "className": "Person",
        coords: [
            311.0,
            540.0,
            466.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:40",
        "id": 23,
        "className": "Person",
        coords: [
            499.0,
            250.0,
            551.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:40",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            192.0,
            176.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:40.100000",
        "id": 15,
        "className": "Person",
        coords: [
            13.0,
            205.0,
            61.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:40.200000",
        "id": 21,
        "className": "Person",
        coords: [
            311.0,
            540.0,
            466.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:40.300000",
        "id": 23,
        "className": "Person",
        coords: [
            499.0,
            250.0,
            551.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:40.300000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            192.0,
            176.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:40.300000",
        "id": 15,
        "className": "Person",
        coords: [
            14.0,
            205.0,
            61.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:40.500000",
        "id": 21,
        "className": "Person",
        coords: [
            312.0,
            540.0,
            466.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:40.600000",
        "id": 23,
        "className": "Person",
        coords: [
            500.0,
            250.0,
            551.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:40.600000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            192.0,
            176.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:40.600000",
        "id": 15,
        "className": "Person",
        coords: [
            15.0,
            205.0,
            61.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:40.800000",
        "id": 21,
        "className": "Person",
        coords: [
            313.0,
            540.0,
            467.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:40.800000",
        "id": 23,
        "className": "Person",
        coords: [
            500.0,
            250.0,
            551.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:40.900000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            192.0,
            176.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:40.900000",
        "id": 15,
        "className": "Person",
        coords: [
            14.0,
            205.0,
            61.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:41.100000",
        "id": 21,
        "className": "Person",
        coords: [
            313.0,
            540.0,
            467.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:41.100000",
        "id": 23,
        "className": "Person",
        coords: [
            499.0,
            250.0,
            551.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:41.200000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            192.0,
            176.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:41.200000",
        "id": 15,
        "className": "Person",
        coords: [
            15.0,
            205.0,
            62.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:41.400000",
        "id": 21,
        "className": "Person",
        coords: [
            314.0,
            540.0,
            467.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:41.400000",
        "id": 23,
        "className": "Person",
        coords: [
            500.0,
            250.0,
            551.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:41.500000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            192.0,
            176.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:41.500000",
        "id": 15,
        "className": "Person",
        coords: [
            16.0,
            204.0,
            63.0,
            335.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:41.700000",
        "id": 21,
        "className": "Person",
        coords: [
            314.0,
            540.0,
            468.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:41.700000",
        "id": 23,
        "className": "Person",
        coords: [
            500.0,
            250.0,
            550.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:41.800000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            193.0,
            176.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:41.800000",
        "id": 15,
        "className": "Person",
        coords: [
            16.0,
            204.0,
            63.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:42",
        "id": 21,
        "className": "Person",
        coords: [
            314.0,
            540.0,
            468.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:42",
        "id": 23,
        "className": "Person",
        coords: [
            500.0,
            250.0,
            550.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:42.100000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            193.0,
            176.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:42.100000",
        "id": 15,
        "className": "Person",
        coords: [
            16.0,
            204.0,
            64.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:42.300000",
        "id": 21,
        "className": "Person",
        coords: [
            315.0,
            540.0,
            468.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:42.300000",
        "id": 23,
        "className": "Person",
        coords: [
            499.0,
            251.0,
            550.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:42.400000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            193.0,
            176.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:42.400000",
        "id": 15,
        "className": "Person",
        coords: [
            14.0,
            204.0,
            62.0,
            338.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:42.600000",
        "id": 21,
        "className": "Person",
        coords: [
            315.0,
            540.0,
            468.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:42.600000",
        "id": 23,
        "className": "Person",
        coords: [
            500.0,
            251.0,
            550.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:42.700000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            176.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:42.700000",
        "id": 15,
        "className": "Person",
        coords: [
            13.0,
            204.0,
            62.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:42.900000",
        "id": 21,
        "className": "Person",
        coords: [
            315.0,
            540.0,
            468.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:42.900000",
        "id": 23,
        "className": "Person",
        coords: [
            500.0,
            251.0,
            550.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:43",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            176.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:43",
        "id": 15,
        "className": "Person",
        coords: [
            13.0,
            204.0,
            62.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:43.200000",
        "id": 21,
        "className": "Person",
        coords: [
            315.0,
            540.0,
            468.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:43.200000",
        "id": 23,
        "className": "Person",
        coords: [
            500.0,
            251.0,
            550.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:43.200000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            176.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:43.300000",
        "id": 15,
        "className": "Person",
        coords: [
            13.0,
            204.0,
            62.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:43.400000",
        "id": 21,
        "className": "Person",
        coords: [
            315.0,
            541.0,
            468.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:43.500000",
        "id": 23,
        "className": "Person",
        coords: [
            500.0,
            251.0,
            550.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:43.500000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            193.0,
            176.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:43.600000",
        "id": 15,
        "className": "Person",
        coords: [
            13.0,
            204.0,
            62.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:43.700000",
        "id": 21,
        "className": "Person",
        coords: [
            315.0,
            541.0,
            468.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:43.800000",
        "id": 23,
        "className": "Person",
        coords: [
            500.0,
            251.0,
            550.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:43.800000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            193.0,
            176.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:43.900000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            204.0,
            61.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:44",
        "id": 21,
        "className": "Person",
        coords: [
            316.0,
            541.0,
            469.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:44",
        "id": 23,
        "className": "Person",
        coords: [
            500.0,
            251.0,
            550.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:44.100000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            193.0,
            176.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:44.100000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            204.0,
            62.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:44.300000",
        "id": 21,
        "className": "Person",
        coords: [
            316.0,
            542.0,
            468.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:44.300000",
        "id": 23,
        "className": "Person",
        coords: [
            500.0,
            251.0,
            550.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:44.400000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            193.0,
            176.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:44.400000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            204.0,
            61.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:44.600000",
        "id": 21,
        "className": "Person",
        coords: [
            316.0,
            542.0,
            468.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:44.600000",
        "id": 23,
        "className": "Person",
        coords: [
            500.0,
            250.0,
            550.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:44.700000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            176.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:44.700000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            204.0,
            61.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:44.900000",
        "id": 21,
        "className": "Person",
        coords: [
            316.0,
            542.0,
            468.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:45",
        "id": 23,
        "className": "Person",
        coords: [
            500.0,
            250.0,
            550.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:45",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            176.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:45.100000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            204.0,
            61.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:45.200000",
        "id": 21,
        "className": "Person",
        coords: [
            316.0,
            542.0,
            468.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:45.300000",
        "id": 23,
        "className": "Person",
        coords: [
            499.0,
            250.0,
            550.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:45.300000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            194.0,
            176.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:45.400000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            204.0,
            61.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:45.500000",
        "id": 21,
        "className": "Person",
        coords: [
            315.0,
            541.0,
            467.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:45.600000",
        "id": 23,
        "className": "Person",
        coords: [
            499.0,
            249.0,
            550.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:45.600000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            194.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:45.700000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            204.0,
            61.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:45.800000",
        "id": 21,
        "className": "Person",
        coords: [
            315.0,
            541.0,
            467.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:45.900000",
        "id": 23,
        "className": "Person",
        coords: [
            498.0,
            248.0,
            550.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:45.900000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            193.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:46",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            204.0,
            61.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:46.100000",
        "id": 21,
        "className": "Person",
        coords: [
            315.0,
            541.0,
            467.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:46.200000",
        "id": 23,
        "className": "Person",
        coords: [
            498.0,
            248.0,
            550.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:46.300000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            193.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:46.300000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            204.0,
            61.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:46.500000",
        "id": 21,
        "className": "Person",
        coords: [
            315.0,
            541.0,
            467.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:46.500000",
        "id": 23,
        "className": "Person",
        coords: [
            498.0,
            249.0,
            550.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:46.600000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            193.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:46.600000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            204.0,
            61.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:46.800000",
        "id": 21,
        "className": "Person",
        coords: [
            314.0,
            540.0,
            467.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:46.800000",
        "id": 23,
        "className": "Person",
        coords: [
            497.0,
            249.0,
            549.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:46.900000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            176.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:46.900000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            204.0,
            61.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:47.100000",
        "id": 21,
        "className": "Person",
        coords: [
            314.0,
            540.0,
            467.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:47.100000",
        "id": 23,
        "className": "Person",
        coords: [
            496.0,
            249.0,
            548.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:47.200000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            176.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:47.200000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            204.0,
            60.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:47.400000",
        "id": 21,
        "className": "Person",
        coords: [
            314.0,
            540.0,
            467.0,
            719.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:47.400000",
        "id": 23,
        "className": "Person",
        coords: [
            496.0,
            250.0,
            548.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:47.400000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            176.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:47.500000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            204.0,
            60.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:47.600000",
        "id": 21,
        "className": "Person",
        coords: [
            313.0,
            539.0,
            467.0,
            719.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:47.700000",
        "id": 23,
        "className": "Person",
        coords: [
            495.0,
            250.0,
            548.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:47.700000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:47.800000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            205.0,
            60.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:47.900000",
        "id": 21,
        "className": "Person",
        coords: [
            313.0,
            539.0,
            467.0,
            719.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:48",
        "id": 23,
        "className": "Person",
        coords: [
            496.0,
            250.0,
            548.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:48",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:48.100000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            205.0,
            60.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:48.200000",
        "id": 21,
        "className": "Person",
        coords: [
            313.0,
            539.0,
            467.0,
            719.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:48.300000",
        "id": 23,
        "className": "Person",
        coords: [
            497.0,
            254.0,
            548.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:48.300000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:48.300000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            205.0,
            60.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:48.500000",
        "id": 21,
        "className": "Person",
        coords: [
            313.0,
            539.0,
            466.0,
            719.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:48.500000",
        "id": 23,
        "className": "Person",
        coords: [
            498.0,
            255.0,
            548.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:48.600000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:48.600000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            205.0,
            60.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:48.800000",
        "id": 21,
        "className": "Person",
        coords: [
            312.0,
            539.0,
            466.0,
            719.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:48.800000",
        "id": 23,
        "className": "Person",
        coords: [
            496.0,
            253.0,
            548.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:48.900000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:49",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            205.0,
            60.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:49.100000",
        "id": 21,
        "className": "Person",
        coords: [
            312.0,
            539.0,
            465.0,
            719.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:49.200000",
        "id": 23,
        "className": "Person",
        coords: [
            495.0,
            252.0,
            549.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:49.200000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:49.300000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            205.0,
            60.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:49.500000",
        "id": 21,
        "className": "Person",
        coords: [
            312.0,
            539.0,
            465.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:49.500000",
        "id": 23,
        "className": "Person",
        coords: [
            495.0,
            250.0,
            549.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:49.600000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:49.600000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            205.0,
            59.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:49.800000",
        "id": 21,
        "className": "Person",
        coords: [
            312.0,
            539.0,
            465.0,
            719.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:49.800000",
        "id": 23,
        "className": "Person",
        coords: [
            494.0,
            249.0,
            549.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:49.900000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:49.900000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            205.0,
            59.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:50.100000",
        "id": 21,
        "className": "Person",
        coords: [
            312.0,
            539.0,
            465.0,
            719.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:50.100000",
        "id": 23,
        "className": "Person",
        coords: [
            494.0,
            249.0,
            550.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:50.200000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            193.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:50.200000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            204.0,
            59.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:50.400000",
        "id": 21,
        "className": "Person",
        coords: [
            313.0,
            539.0,
            464.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:50.400000",
        "id": 23,
        "className": "Person",
        coords: [
            495.0,
            248.0,
            550.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:50.400000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            194.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:50.500000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            204.0,
            59.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:50.600000",
        "id": 21,
        "className": "Person",
        coords: [
            313.0,
            539.0,
            464.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:50.700000",
        "id": 23,
        "className": "Person",
        coords: [
            495.0,
            248.0,
            550.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:50.700000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:50.800000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            204.0,
            59.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:50.900000",
        "id": 21,
        "className": "Person",
        coords: [
            313.0,
            539.0,
            464.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:51",
        "id": 23,
        "className": "Person",
        coords: [
            495.0,
            248.0,
            550.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:51",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            193.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:51.100000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            204.0,
            59.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:51.200000",
        "id": 21,
        "className": "Person",
        coords: [
            313.0,
            539.0,
            463.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:51.200000",
        "id": 23,
        "className": "Person",
        coords: [
            495.0,
            247.0,
            550.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:51.200000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:51.200000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            204.0,
            59.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:51.400000",
        "id": 21,
        "className": "Person",
        coords: [
            313.0,
            539.0,
            463.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:51.500000",
        "id": 23,
        "className": "Person",
        coords: [
            496.0,
            247.0,
            551.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:51.500000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:51.600000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            204.0,
            59.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:51.700000",
        "id": 21,
        "className": "Person",
        coords: [
            313.0,
            539.0,
            463.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:51.800000",
        "id": 23,
        "className": "Person",
        coords: [
            497.0,
            247.0,
            551.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:51.800000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:51.900000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            205.0,
            59.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:52",
        "id": 21,
        "className": "Person",
        coords: [
            313.0,
            539.0,
            463.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:52.100000",
        "id": 23,
        "className": "Person",
        coords: [
            497.0,
            247.0,
            551.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:52.100000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:52.200000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            205.0,
            59.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:52.300000",
        "id": 21,
        "className": "Person",
        coords: [
            313.0,
            539.0,
            463.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:52.400000",
        "id": 23,
        "className": "Person",
        coords: [
            497.0,
            247.0,
            551.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:52.400000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:52.500000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            205.0,
            59.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:52.600000",
        "id": 21,
        "className": "Person",
        coords: [
            313.0,
            539.0,
            463.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:52.600000",
        "id": 23,
        "className": "Person",
        coords: [
            497.0,
            247.0,
            551.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:52.700000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            192.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:52.700000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            205.0,
            60.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:52.900000",
        "id": 21,
        "className": "Person",
        coords: [
            313.0,
            539.0,
            463.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:52.900000",
        "id": 23,
        "className": "Person",
        coords: [
            497.0,
            246.0,
            551.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:53",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:53",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            205.0,
            60.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:53.200000",
        "id": 21,
        "className": "Person",
        coords: [
            313.0,
            540.0,
            463.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:53.200000",
        "id": 23,
        "className": "Person",
        coords: [
            498.0,
            247.0,
            551.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:53.200000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            192.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:53.300000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            205.0,
            60.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:53.400000",
        "id": 21,
        "className": "Person",
        coords: [
            314.0,
            540.0,
            463.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:53.500000",
        "id": 23,
        "className": "Person",
        coords: [
            498.0,
            247.0,
            551.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:53.500000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            192.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:53.600000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            205.0,
            60.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:53.700000",
        "id": 21,
        "className": "Person",
        coords: [
            314.0,
            540.0,
            464.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:53.800000",
        "id": 23,
        "className": "Person",
        coords: [
            498.0,
            247.0,
            551.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:53.800000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:53.900000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            205.0,
            60.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:54",
        "id": 21,
        "className": "Person",
        coords: [
            315.0,
            540.0,
            464.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:54.100000",
        "id": 23,
        "className": "Person",
        coords: [
            498.0,
            247.0,
            550.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:54.100000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:54.200000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            205.0,
            60.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:54.400000",
        "id": 21,
        "className": "Person",
        coords: [
            315.0,
            540.0,
            464.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:54.400000",
        "id": 23,
        "className": "Person",
        coords: [
            498.0,
            247.0,
            550.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:54.500000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:54.500000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            205.0,
            60.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:54.700000",
        "id": 21,
        "className": "Person",
        coords: [
            315.0,
            540.0,
            464.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:54.700000",
        "id": 23,
        "className": "Person",
        coords: [
            498.0,
            247.0,
            550.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:54.700000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            193.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:54.800000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            205.0,
            60.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:54.900000",
        "id": 21,
        "className": "Person",
        coords: [
            320.0,
            540.0,
            469.0,
            718.0
        ],
        "status": "Moving",
        "speed": 74.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:55",
        "id": 23,
        "className": "Person",
        coords: [
            498.0,
            247.0,
            550.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:55",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:55.100000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            205.0,
            60.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:55.200000",
        "id": 21,
        "className": "Person",
        coords: [
            327.0,
            540.0,
            473.0,
            718.0
        ],
        "status": "Moving",
        "speed": 89.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:55.300000",
        "id": 23,
        "className": "Person",
        coords: [
            498.0,
            247.0,
            550.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:55.300000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            176.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:55.400000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            205.0,
            60.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:55.600000",
        "id": 21,
        "className": "Person",
        coords: [
            323.0,
            540.0,
            469.0,
            718.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:55.600000",
        "id": 23,
        "className": "Person",
        coords: [
            495.0,
            247.0,
            548.0,
            330.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:55.700000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            175.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:55.700000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            205.0,
            60.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:55.800000",
        "id": 21,
        "className": "Person",
        coords: [
            322.0,
            540.0,
            468.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:55.900000",
        "id": 23,
        "className": "Person",
        coords: [
            494.0,
            247.0,
            548.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:55.900000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            175.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:56",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            205.0,
            61.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:56.200000",
        "id": 21,
        "className": "Person",
        coords: [
            323.0,
            539.0,
            468.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:56.200000",
        "id": 23,
        "className": "Person",
        coords: [
            494.0,
            247.0,
            548.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:56.300000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            175.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:56.300000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            205.0,
            61.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:56.500000",
        "id": 21,
        "className": "Person",
        coords: [
            325.0,
            538.0,
            470.0,
            717.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:56.500000",
        "id": 23,
        "className": "Person",
        coords: [
            494.0,
            247.0,
            548.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:56.600000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            176.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:56.600000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            205.0,
            61.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:56.800000",
        "id": 21,
        "className": "Person",
        coords: [
            321.0,
            537.0,
            466.0,
            717.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:56.900000",
        "id": 23,
        "className": "Person",
        coords: [
            493.0,
            247.0,
            549.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:56.900000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            176.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:57",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            205.0,
            60.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:57.100000",
        "id": 21,
        "className": "Person",
        coords: [
            317.0,
            536.0,
            463.0,
            718.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:57.300000",
        "id": 23,
        "className": "Person",
        coords: [
            494.0,
            247.0,
            549.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:57.300000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            176.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:57.400000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            205.0,
            60.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:57.600000",
        "id": 21,
        "className": "Person",
        coords: [
            320.0,
            534.0,
            465.0,
            717.0
        ],
        "status": "Moving",
        "speed": 42.42,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:57.600000",
        "id": 23,
        "className": "Person",
        coords: [
            495.0,
            247.0,
            550.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:57.700000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            176.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:57.800000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            205.0,
            60.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:58.100000",
        "id": 21,
        "className": "Person",
        coords: [
            321.0,
            532.0,
            465.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:58.200000",
        "id": 23,
        "className": "Person",
        coords: [
            496.0,
            247.0,
            550.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:58.300000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            176.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:58.300000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            205.0,
            60.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:58.600000",
        "id": 21,
        "className": "Person",
        coords: [
            317.0,
            530.0,
            460.0,
            715.0
        ],
        "status": "Moving",
        "speed": 80.77,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:58.700000",
        "id": 23,
        "className": "Person",
        coords: [
            496.0,
            247.0,
            550.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:58.800000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            176.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:58.800000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            205.0,
            60.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:59.100000",
        "id": 21,
        "className": "Person",
        coords: [
            313.0,
            528.0,
            454.0,
            711.0
        ],
        "status": "Moving",
        "speed": 87.46,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:59.200000",
        "id": 23,
        "className": "Person",
        coords: [
            496.0,
            247.0,
            550.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:59.300000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            176.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:59.400000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            205.0,
            60.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:59.600000",
        "id": 21,
        "className": "Person",
        coords: [
            309.0,
            527.0,
            453.0,
            714.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:59.800000",
        "id": 23,
        "className": "Person",
        coords: [
            497.0,
            247.0,
            551.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:18:59.800000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            176.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:18:59.900000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            205.0,
            60.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:00.200000",
        "id": 21,
        "className": "Person",
        coords: [
            311.0,
            525.0,
            448.0,
            704.0
        ],
        "status": "Moving",
        "speed": 94.86,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:00.300000",
        "id": 23,
        "className": "Person",
        coords: [
            497.0,
            247.0,
            551.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:00.400000",
        "id": 22,
        "className": "Person",
        coords: [
            139.0,
            193.0,
            176.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:00.500000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            205.0,
            60.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:00.700000",
        "id": 23,
        "className": "Person",
        coords: [
            497.0,
            247.0,
            551.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:00.800000",
        "id": 22,
        "className": "Person",
        coords: [
            139.0,
            192.0,
            176.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:00.900000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            205.0,
            60.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:01.100000",
        "id": 23,
        "className": "Person",
        coords: [
            497.0,
            247.0,
            550.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:01.200000",
        "id": 22,
        "className": "Person",
        coords: [
            139.0,
            192.0,
            176.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:01.300000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            205.0,
            60.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:01.600000",
        "id": 23,
        "className": "Person",
        coords: [
            497.0,
            247.0,
            551.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:01.700000",
        "id": 22,
        "className": "Person",
        coords: [
            139.0,
            192.0,
            176.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:01.700000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            205.0,
            60.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:02",
        "id": 23,
        "className": "Person",
        coords: [
            498.0,
            248.0,
            551.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:02.100000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            192.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:02.200000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            205.0,
            59.0,
            330.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:02.400000",
        "id": 23,
        "className": "Person",
        coords: [
            499.0,
            248.0,
            551.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:02.500000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            192.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:02.600000",
        "id": 15,
        "className": "Person",
        coords: [
            13.0,
            206.0,
            59.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:02.800000",
        "id": 23,
        "className": "Person",
        coords: [
            499.0,
            248.0,
            552.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:02.900000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            192.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:03",
        "id": 15,
        "className": "Person",
        coords: [
            13.0,
            206.0,
            59.0,
            325.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:03.200000",
        "id": 23,
        "className": "Person",
        coords: [
            499.0,
            248.0,
            551.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:03.300000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            192.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:03.400000",
        "id": 15,
        "className": "Person",
        coords: [
            13.0,
            206.0,
            59.0,
            325.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:03.600000",
        "id": 23,
        "className": "Person",
        coords: [
            499.0,
            248.0,
            552.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:03.700000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            192.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:03.800000",
        "id": 15,
        "className": "Person",
        coords: [
            13.0,
            206.0,
            59.0,
            325.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:04.100000",
        "id": 23,
        "className": "Person",
        coords: [
            499.0,
            248.0,
            551.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:04.100000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            192.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:04.200000",
        "id": 15,
        "className": "Person",
        coords: [
            13.0,
            206.0,
            59.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:04.500000",
        "id": 23,
        "className": "Person",
        coords: [
            498.0,
            247.0,
            551.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:04.500000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            192.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:04.600000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            206.0,
            60.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:04.900000",
        "id": 23,
        "className": "Person",
        coords: [
            499.0,
            247.0,
            551.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:04.900000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            192.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:05",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            206.0,
            60.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:05.300000",
        "id": 23,
        "className": "Person",
        coords: [
            499.0,
            247.0,
            551.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:05.300000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            192.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:05.400000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            206.0,
            60.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:05.600000",
        "id": 23,
        "className": "Person",
        coords: [
            499.0,
            247.0,
            551.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:05.700000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            192.0,
            176.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:05.800000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            206.0,
            60.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:06.100000",
        "id": 23,
        "className": "Person",
        coords: [
            499.0,
            247.0,
            551.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:06.100000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            192.0,
            176.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:06.200000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            206.0,
            60.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:06.400000",
        "id": 23,
        "className": "Person",
        coords: [
            500.0,
            247.0,
            551.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:06.500000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            192.0,
            176.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:06.600000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            206.0,
            60.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:06.700000",
        "id": 21,
        "className": "Person",
        coords: [
            304.0,
            522.0,
            450.0,
            717.0
        ],
        "status": "Moving",
        "speed": 80.77,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:06.900000",
        "id": 23,
        "className": "Person",
        coords: [
            500.0,
            247.0,
            551.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:07",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            192.0,
            176.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:07.100000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            206.0,
            60.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:07.200000",
        "id": 21,
        "className": "Person",
        coords: [
            305.0,
            523.0,
            449.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:07.400000",
        "id": 23,
        "className": "Person",
        coords: [
            500.0,
            247.0,
            551.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:07.500000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            192.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:07.600000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            206.0,
            60.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:07.700000",
        "id": 21,
        "className": "Person",
        coords: [
            305.0,
            522.0,
            449.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:08",
        "id": 23,
        "className": "Person",
        coords: [
            500.0,
            248.0,
            551.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:08.100000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:08.100000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            206.0,
            60.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:08.200000",
        "id": 21,
        "className": "Person",
        coords: [
            306.0,
            523.0,
            449.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:08.500000",
        "id": 23,
        "className": "Person",
        coords: [
            497.0,
            248.0,
            549.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:08.600000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:08.700000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            206.0,
            61.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:08.800000",
        "id": 21,
        "className": "Person",
        coords: [
            306.0,
            522.0,
            450.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:09",
        "id": 23,
        "className": "Person",
        coords: [
            496.0,
            247.0,
            548.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:09.100000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            178.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:09.200000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            206.0,
            62.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:09.300000",
        "id": 21,
        "className": "Person",
        coords: [
            307.0,
            523.0,
            450.0,
            719.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:09.500000",
        "id": 23,
        "className": "Person",
        coords: [
            496.0,
            248.0,
            548.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:09.600000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            178.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:09.700000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            206.0,
            62.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:09.800000",
        "id": 21,
        "className": "Person",
        coords: [
            309.0,
            523.0,
            451.0,
            718.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:10",
        "id": 23,
        "className": "Person",
        coords: [
            496.0,
            248.0,
            548.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:10.100000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:10.200000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            206.0,
            61.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:10.300000",
        "id": 21,
        "className": "Person",
        coords: [
            310.0,
            524.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:10.500000",
        "id": 23,
        "className": "Person",
        coords: [
            496.0,
            249.0,
            548.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:10.500000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            178.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:10.600000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            206.0,
            61.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:10.700000",
        "id": 21,
        "className": "Person",
        coords: [
            311.0,
            526.0,
            452.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:10.900000",
        "id": 23,
        "className": "Person",
        coords: [
            496.0,
            250.0,
            548.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:11",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            178.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:11.100000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            206.0,
            61.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:11.200000",
        "id": 21,
        "className": "Person",
        coords: [
            312.0,
            528.0,
            452.0,
            718.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:11.500000",
        "id": 23,
        "className": "Person",
        coords: [
            497.0,
            250.0,
            549.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:11.600000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:11.700000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            206.0,
            61.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:11.800000",
        "id": 21,
        "className": "Person",
        coords: [
            312.0,
            530.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:12",
        "id": 23,
        "className": "Person",
        coords: [
            499.0,
            252.0,
            549.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:12.100000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:12.200000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            206.0,
            61.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:12.200000",
        "id": 21,
        "className": "Person",
        coords: [
            317.0,
            531.0,
            455.0,
            718.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:12.400000",
        "id": 23,
        "className": "Person",
        coords: [
            497.0,
            249.0,
            550.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:12.400000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            193.0,
            178.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:12.400000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            206.0,
            61.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:12.500000",
        "id": 21,
        "className": "Person",
        coords: [
            314.0,
            533.0,
            452.0,
            718.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:12.600000",
        "id": 23,
        "className": "Person",
        coords: [
            497.0,
            248.0,
            550.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:12.700000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:12.700000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            206.0,
            61.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:12.800000",
        "id": 21,
        "className": "Person",
        coords: [
            328.0,
            534.0,
            462.0,
            718.0
        ],
        "status": "Moving",
        "speed": 180.61,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:12.900000",
        "id": 23,
        "className": "Person",
        coords: [
            496.0,
            247.0,
            550.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:13",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:13",
        "id": 15,
        "className": "Person",
        coords: [
            13.0,
            206.0,
            61.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:13.100000",
        "id": 21,
        "className": "Person",
        coords: [
            335.0,
            535.0,
            466.0,
            718.0
        ],
        "status": "Moving",
        "speed": 74.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:13.200000",
        "id": 23,
        "className": "Person",
        coords: [
            497.0,
            246.0,
            551.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:13.300000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:13.300000",
        "id": 15,
        "className": "Person",
        coords: [
            13.0,
            206.0,
            61.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:13.400000",
        "id": 21,
        "className": "Person",
        coords: [
            337.0,
            535.0,
            466.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:13.500000",
        "id": 23,
        "className": "Person",
        coords: [
            498.0,
            248.0,
            551.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:13.600000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:13.600000",
        "id": 15,
        "className": "Person",
        coords: [
            13.0,
            206.0,
            61.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:13.700000",
        "id": 21,
        "className": "Person",
        coords: [
            339.0,
            535.0,
            465.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:13.800000",
        "id": 23,
        "className": "Person",
        coords: [
            498.0,
            248.0,
            551.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:13.900000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:13.900000",
        "id": 15,
        "className": "Person",
        coords: [
            13.0,
            206.0,
            61.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:14",
        "id": 21,
        "className": "Person",
        coords: [
            341.0,
            535.0,
            465.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:14.100000",
        "id": 23,
        "className": "Person",
        coords: [
            498.0,
            248.0,
            551.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:14.200000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:14.200000",
        "id": 15,
        "className": "Person",
        coords: [
            13.0,
            206.0,
            61.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:14.300000",
        "id": 21,
        "className": "Person",
        coords: [
            329.0,
            535.0,
            454.0,
            718.0
        ],
        "status": "Moving",
        "speed": 179.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:14.400000",
        "id": 23,
        "className": "Person",
        coords: [
            497.0,
            247.0,
            550.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:14.500000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            192.0,
            176.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:14.500000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            206.0,
            61.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:14.500000",
        "id": 21,
        "className": "Person",
        coords: [
            337.0,
            535.0,
            460.0,
            718.0
        ],
        "status": "Moving",
        "speed": 104.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:14.700000",
        "id": 23,
        "className": "Person",
        coords: [
            496.0,
            248.0,
            549.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:14.700000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            192.0,
            176.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:14.800000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            206.0,
            60.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:14.800000",
        "id": 21,
        "className": "Person",
        coords: [
            340.0,
            534.0,
            461.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:15",
        "id": 23,
        "className": "Person",
        coords: [
            496.0,
            248.0,
            549.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:15",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            192.0,
            176.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:15.100000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            206.0,
            60.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:15.100000",
        "id": 21,
        "className": "Person",
        coords: [
            341.0,
            534.0,
            461.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:15.300000",
        "id": 23,
        "className": "Person",
        coords: [
            496.0,
            248.0,
            549.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:15.300000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            192.0,
            176.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:15.400000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            206.0,
            60.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:15.400000",
        "id": 21,
        "className": "Person",
        coords: [
            342.0,
            534.0,
            460.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:15.600000",
        "id": 23,
        "className": "Person",
        coords: [
            497.0,
            248.0,
            549.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:15.600000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            192.0,
            176.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:15.700000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            206.0,
            60.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:15.700000",
        "id": 21,
        "className": "Person",
        coords: [
            343.0,
            534.0,
            458.0,
            714.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:15.900000",
        "id": 23,
        "className": "Person",
        coords: [
            496.0,
            248.0,
            549.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:15.900000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            192.0,
            175.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:16",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            206.0,
            60.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:16.100000",
        "id": 23,
        "className": "Person",
        coords: [
            497.0,
            248.0,
            550.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:16.200000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            192.0,
            176.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:16.200000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            206.0,
            60.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:16.300000",
        "id": 21,
        "className": "Person",
        coords: [
            341.0,
            534.0,
            456.0,
            717.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:16.400000",
        "id": 23,
        "className": "Person",
        coords: [
            497.0,
            248.0,
            550.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:16.500000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            192.0,
            176.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:16.500000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            206.0,
            60.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:16.700000",
        "id": 23,
        "className": "Person",
        coords: [
            496.0,
            247.0,
            550.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:16.700000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            192.0,
            176.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:16.800000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            206.0,
            60.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:16.900000",
        "id": 23,
        "className": "Person",
        coords: [
            496.0,
            247.0,
            550.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:17",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            192.0,
            176.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:17",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            206.0,
            60.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:17.100000",
        "id": 21,
        "className": "Person",
        coords: [
            341.0,
            535.0,
            452.0,
            712.0
        ],
        "status": "Moving",
        "speed": 42.42,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:17.100000",
        "id": 23,
        "className": "Person",
        coords: [
            496.0,
            247.0,
            550.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:17.200000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            192.0,
            176.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:17.200000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            206.0,
            60.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:17.200000",
        "id": 21,
        "className": "Person",
        coords: [
            342.0,
            535.0,
            451.0,
            710.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:17.400000",
        "id": 23,
        "className": "Person",
        coords: [
            496.0,
            247.0,
            550.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:17.400000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            192.0,
            176.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:17.500000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            206.0,
            61.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:17.500000",
        "id": 21,
        "className": "Person",
        coords: [
            344.0,
            535.0,
            448.0,
            699.0
        ],
        "status": "Moving",
        "speed": 74.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:17.700000",
        "id": 23,
        "className": "Person",
        coords: [
            496.0,
            247.0,
            550.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:17.700000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            192.0,
            176.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:17.700000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            206.0,
            61.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:17.900000",
        "id": 23,
        "className": "Person",
        coords: [
            496.0,
            247.0,
            550.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:17.900000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            192.0,
            176.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:18",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            206.0,
            61.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:18.100000",
        "id": 23,
        "className": "Person",
        coords: [
            496.0,
            247.0,
            550.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:18.200000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            192.0,
            176.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:18.200000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            206.0,
            61.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:18.400000",
        "id": 23,
        "className": "Person",
        coords: [
            496.0,
            247.0,
            550.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:18.500000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            176.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:18.500000",
        "id": 15,
        "className": "Person",
        coords: [
            13.0,
            206.0,
            61.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:18.600000",
        "id": 23,
        "className": "Person",
        coords: [
            495.0,
            247.0,
            550.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:18.600000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            176.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:18.600000",
        "id": 15,
        "className": "Person",
        coords: [
            13.0,
            206.0,
            61.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:18.800000",
        "id": 23,
        "className": "Person",
        coords: [
            496.0,
            247.0,
            550.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:18.900000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            176.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:18.900000",
        "id": 15,
        "className": "Person",
        coords: [
            13.0,
            206.0,
            61.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:19",
        "id": 23,
        "className": "Person",
        coords: [
            495.0,
            247.0,
            550.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:19.100000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            176.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:19.100000",
        "id": 15,
        "className": "Person",
        coords: [
            13.0,
            206.0,
            60.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:19.300000",
        "id": 23,
        "className": "Person",
        coords: [
            496.0,
            247.0,
            550.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:19.400000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            176.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:19.400000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            206.0,
            60.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:19.600000",
        "id": 23,
        "className": "Person",
        coords: [
            495.0,
            246.0,
            550.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:19.600000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            176.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:19.700000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            206.0,
            60.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:19.800000",
        "id": 23,
        "className": "Person",
        coords: [
            495.0,
            246.0,
            550.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:19.900000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            176.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:19.900000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            207.0,
            59.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:20.100000",
        "id": 23,
        "className": "Person",
        coords: [
            495.0,
            246.0,
            550.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:20.100000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            192.0,
            176.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:20.200000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            207.0,
            59.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:20.300000",
        "id": 23,
        "className": "Person",
        coords: [
            495.0,
            246.0,
            550.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:20.400000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            192.0,
            176.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:20.400000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            207.0,
            59.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:20.500000",
        "id": 23,
        "className": "Person",
        coords: [
            495.0,
            246.0,
            550.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:20.600000",
        "id": 22,
        "className": "Person",
        coords: [
            139.0,
            192.0,
            176.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:20.600000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            207.0,
            60.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:20.800000",
        "id": 23,
        "className": "Person",
        coords: [
            495.0,
            246.0,
            550.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:20.800000",
        "id": 22,
        "className": "Person",
        coords: [
            139.0,
            192.0,
            176.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:20.900000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            207.0,
            59.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:21",
        "id": 23,
        "className": "Person",
        coords: [
            495.0,
            246.0,
            550.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:21",
        "id": 22,
        "className": "Person",
        coords: [
            139.0,
            191.0,
            176.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:21.100000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            207.0,
            59.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:21.200000",
        "id": 23,
        "className": "Person",
        coords: [
            496.0,
            246.0,
            550.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:21.300000",
        "id": 22,
        "className": "Person",
        coords: [
            138.0,
            191.0,
            175.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:21.300000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            207.0,
            59.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:21.500000",
        "id": 23,
        "className": "Person",
        coords: [
            496.0,
            246.0,
            550.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:21.500000",
        "id": 22,
        "className": "Person",
        coords: [
            138.0,
            191.0,
            175.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:21.600000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            206.0,
            59.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:21.700000",
        "id": 23,
        "className": "Person",
        coords: [
            496.0,
            246.0,
            550.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:21.800000",
        "id": 22,
        "className": "Person",
        coords: [
            137.0,
            192.0,
            175.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:21.800000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            206.0,
            58.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:22",
        "id": 23,
        "className": "Person",
        coords: [
            497.0,
            246.0,
            551.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:22",
        "id": 22,
        "className": "Person",
        coords: [
            138.0,
            192.0,
            175.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:22.100000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            206.0,
            59.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:22.200000",
        "id": 23,
        "className": "Person",
        coords: [
            497.0,
            246.0,
            551.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:22.200000",
        "id": 22,
        "className": "Person",
        coords: [
            138.0,
            193.0,
            175.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:22.200000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            206.0,
            59.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:22.300000",
        "id": 23,
        "className": "Person",
        coords: [
            497.0,
            246.0,
            551.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:22.400000",
        "id": 22,
        "className": "Person",
        coords: [
            137.0,
            193.0,
            174.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:22.500000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            206.0,
            58.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:22.600000",
        "id": 23,
        "className": "Person",
        coords: [
            497.0,
            246.0,
            550.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:22.700000",
        "id": 22,
        "className": "Person",
        coords: [
            136.0,
            192.0,
            174.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:22.700000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            207.0,
            58.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:22.900000",
        "id": 23,
        "className": "Person",
        coords: [
            497.0,
            246.0,
            550.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:22.900000",
        "id": 22,
        "className": "Person",
        coords: [
            136.0,
            192.0,
            173.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:23",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            209.0,
            58.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:23.100000",
        "id": 23,
        "className": "Person",
        coords: [
            497.0,
            246.0,
            550.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:23.200000",
        "id": 22,
        "className": "Person",
        coords: [
            135.0,
            192.0,
            172.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:23.200000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            212.0,
            58.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:23.400000",
        "id": 23,
        "className": "Person",
        coords: [
            497.0,
            246.0,
            550.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:23.400000",
        "id": 22,
        "className": "Person",
        coords: [
            135.0,
            191.0,
            171.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:23.500000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            213.0,
            58.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:23.600000",
        "id": 23,
        "className": "Person",
        coords: [
            497.0,
            246.0,
            550.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:23.600000",
        "id": 22,
        "className": "Person",
        coords: [
            135.0,
            192.0,
            170.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:23.600000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            212.0,
            58.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:23.700000",
        "id": 23,
        "className": "Person",
        coords: [
            497.0,
            246.0,
            550.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:23.800000",
        "id": 22,
        "className": "Person",
        coords: [
            134.0,
            192.0,
            170.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:23.800000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            210.0,
            58.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:23.900000",
        "id": 25,
        "className": "Person",
        coords: [
            183.0,
            188.0,
            224.0,
            277.0
        ],
        "status": "First Seen",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:19:24",
        "id": 23,
        "className": "Person",
        coords: [
            497.0,
            246.0,
            551.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:24.100000",
        "id": 22,
        "className": "Person",
        coords: [
            134.0,
            192.0,
            169.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:24.100000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            208.0,
            58.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:24.200000",
        "id": 25,
        "className": "Person",
        coords: [
            183.0,
            187.0,
            224.0,
            276.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:19:24.300000",
        "id": 23,
        "className": "Person",
        coords: [
            497.0,
            246.0,
            551.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:24.400000",
        "id": 22,
        "className": "Person",
        coords: [
            135.0,
            193.0,
            168.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:24.400000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            210.0,
            58.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:24.500000",
        "id": 25,
        "className": "Person",
        coords: [
            183.0,
            189.0,
            223.0,
            276.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:19:24.600000",
        "id": 23,
        "className": "Person",
        coords: [
            497.0,
            245.0,
            552.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:24.600000",
        "id": 22,
        "className": "Person",
        coords: [
            135.0,
            193.0,
            168.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:24.600000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            210.0,
            58.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:24.700000",
        "id": 25,
        "className": "Person",
        coords: [
            184.0,
            191.0,
            223.0,
            276.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:19:24.800000",
        "id": 23,
        "className": "Person",
        coords: [
            498.0,
            245.0,
            552.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:24.900000",
        "id": 22,
        "className": "Person",
        coords: [
            135.0,
            194.0,
            168.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:24.900000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            209.0,
            59.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:25",
        "id": 25,
        "className": "Person",
        coords: [
            184.0,
            196.0,
            221.0,
            276.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:25.100000",
        "id": 23,
        "className": "Person",
        coords: [
            496.0,
            245.0,
            551.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:25.200000",
        "id": 22,
        "className": "Person",
        coords: [
            136.0,
            195.0,
            168.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:25.200000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            209.0,
            59.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:25.300000",
        "id": 25,
        "className": "Person",
        coords: [
            183.0,
            195.0,
            221.0,
            276.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:25.400000",
        "id": 23,
        "className": "Person",
        coords: [
            497.0,
            244.0,
            552.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:25.400000",
        "id": 22,
        "className": "Person",
        coords: [
            135.0,
            195.0,
            167.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:25.500000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            208.0,
            59.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:25.500000",
        "id": 25,
        "className": "Person",
        coords: [
            184.0,
            199.0,
            220.0,
            275.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:25.700000",
        "id": 23,
        "className": "Person",
        coords: [
            495.0,
            244.0,
            550.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:25.700000",
        "id": 22,
        "className": "Person",
        coords: [
            135.0,
            192.0,
            167.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:25.800000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            208.0,
            59.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:25.800000",
        "id": 25,
        "className": "Person",
        coords: [
            183.0,
            199.0,
            219.0,
            275.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:26",
        "id": 23,
        "className": "Person",
        coords: [
            494.0,
            244.0,
            549.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:26",
        "id": 22,
        "className": "Person",
        coords: [
            134.0,
            191.0,
            167.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:26.100000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            208.0,
            59.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:26.100000",
        "id": 25,
        "className": "Person",
        coords: [
            182.0,
            199.0,
            219.0,
            275.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:26.200000",
        "id": 23,
        "className": "Person",
        coords: [
            494.0,
            243.0,
            549.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:26.200000",
        "id": 22,
        "className": "Person",
        coords: [
            134.0,
            191.0,
            167.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:26.200000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            209.0,
            59.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:26.300000",
        "id": 25,
        "className": "Person",
        coords: [
            180.0,
            198.0,
            218.0,
            275.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:26.400000",
        "id": 23,
        "className": "Person",
        coords: [
            491.0,
            243.0,
            547.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:26.500000",
        "id": 22,
        "className": "Person",
        coords: [
            133.0,
            190.0,
            166.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:26.500000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            209.0,
            59.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:26.600000",
        "id": 25,
        "className": "Person",
        coords: [
            176.0,
            191.0,
            217.0,
            275.0
        ],
        "status": "Moving",
        "speed": 63.63,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:26.700000",
        "id": 23,
        "className": "Person",
        coords: [
            490.0,
            243.0,
            546.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:26.800000",
        "id": 22,
        "className": "Person",
        coords: [
            133.0,
            190.0,
            167.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:26.800000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            210.0,
            58.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:26.900000",
        "id": 25,
        "className": "Person",
        coords: [
            174.0,
            190.0,
            215.0,
            275.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:27",
        "id": 23,
        "className": "Person",
        coords: [
            490.0,
            244.0,
            546.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:27.100000",
        "id": 22,
        "className": "Person",
        coords: [
            133.0,
            190.0,
            166.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:27.100000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            209.0,
            58.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:27.200000",
        "id": 25,
        "className": "Person",
        coords: [
            171.0,
            186.0,
            213.0,
            276.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:27.400000",
        "id": 23,
        "className": "Person",
        coords: [
            489.0,
            243.0,
            546.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:27.400000",
        "id": 22,
        "className": "Person",
        coords: [
            133.0,
            191.0,
            166.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:27.500000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            209.0,
            58.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:27.500000",
        "id": 25,
        "className": "Person",
        coords: [
            171.0,
            187.0,
            212.0,
            275.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:27.600000",
        "id": 21,
        "className": "Person",
        coords: [
            340.0,
            532.0,
            453.0,
            717.0
        ],
        "status": "Moving",
        "speed": 104.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:27.700000",
        "id": 23,
        "className": "Person",
        coords: [
            489.0,
            243.0,
            547.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:27.700000",
        "id": 22,
        "className": "Person",
        coords: [
            133.0,
            193.0,
            165.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:27.800000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            209.0,
            59.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:27.800000",
        "id": 25,
        "className": "Person",
        coords: [
            171.0,
            184.0,
            213.0,
            275.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:27.900000",
        "id": 21,
        "className": "Person",
        coords: [
            341.0,
            531.0,
            452.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:28",
        "id": 23,
        "className": "Person",
        coords: [
            489.0,
            243.0,
            547.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:28",
        "id": 22,
        "className": "Person",
        coords: [
            133.0,
            195.0,
            164.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:28",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            210.0,
            59.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:28",
        "id": 25,
        "className": "Person",
        coords: [
            171.0,
            183.0,
            213.0,
            275.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:28.100000",
        "id": 21,
        "className": "Person",
        coords: [
            341.0,
            531.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:28.200000",
        "id": 23,
        "className": "Person",
        coords: [
            489.0,
            243.0,
            547.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:28.200000",
        "id": 22,
        "className": "Person",
        coords: [
            132.0,
            196.0,
            164.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:28.200000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            210.0,
            59.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:28.300000",
        "id": 25,
        "className": "Person",
        coords: [
            173.0,
            183.0,
            214.0,
            275.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:28.400000",
        "id": 21,
        "className": "Person",
        coords: [
            341.0,
            530.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:28.500000",
        "id": 23,
        "className": "Person",
        coords: [
            489.0,
            243.0,
            547.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:28.600000",
        "id": 22,
        "className": "Person",
        coords: [
            131.0,
            197.0,
            163.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:28.600000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            210.0,
            59.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:28.700000",
        "id": 25,
        "className": "Person",
        coords: [
            175.0,
            190.0,
            213.0,
            274.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:28.700000",
        "id": 21,
        "className": "Person",
        coords: [
            341.0,
            529.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:28.900000",
        "id": 23,
        "className": "Person",
        coords: [
            488.0,
            243.0,
            547.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:28.900000",
        "id": 22,
        "className": "Person",
        coords: [
            130.0,
            195.0,
            163.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:29",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            209.0,
            59.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:29",
        "id": 25,
        "className": "Person",
        coords: [
            176.0,
            190.0,
            214.0,
            275.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:29.100000",
        "id": 21,
        "className": "Person",
        coords: [
            342.0,
            530.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:29.200000",
        "id": 23,
        "className": "Person",
        coords: [
            488.0,
            243.0,
            546.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:29.300000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            209.0,
            60.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:29.300000",
        "id": 25,
        "className": "Person",
        coords: [
            177.0,
            194.0,
            213.0,
            276.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:29.400000",
        "id": 21,
        "className": "Person",
        coords: [
            343.0,
            531.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:29.500000",
        "id": 23,
        "className": "Person",
        coords: [
            488.0,
            243.0,
            547.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:29.500000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            209.0,
            60.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:29.600000",
        "id": 25,
        "className": "Person",
        coords: [
            177.0,
            197.0,
            213.0,
            277.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:29.600000",
        "id": 21,
        "className": "Person",
        coords: [
            343.0,
            531.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:29.800000",
        "id": 23,
        "className": "Person",
        coords: [
            487.0,
            243.0,
            547.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:29.800000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            208.0,
            60.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:29.900000",
        "id": 25,
        "className": "Person",
        coords: [
            178.0,
            199.0,
            213.0,
            278.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:29.900000",
        "id": 21,
        "className": "Person",
        coords: [
            344.0,
            532.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:30.100000",
        "id": 23,
        "className": "Person",
        coords: [
            487.0,
            243.0,
            546.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:30.100000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            209.0,
            60.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:30.200000",
        "id": 25,
        "className": "Person",
        coords: [
            179.0,
            199.0,
            213.0,
            276.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:30.200000",
        "id": 21,
        "className": "Person",
        coords: [
            346.0,
            533.0,
            453.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:30.300000",
        "id": 22,
        "className": "Person",
        coords: [
            128.0,
            197.0,
            163.0,
            269.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:30.400000",
        "id": 23,
        "className": "Person",
        coords: [
            486.0,
            243.0,
            545.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:30.500000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            209.0,
            60.0,
            334.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:30.600000",
        "id": 25,
        "className": "Person",
        coords: [
            180.0,
            200.0,
            213.0,
            275.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:30.600000",
        "id": 21,
        "className": "Person",
        coords: [
            347.0,
            533.0,
            454.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:30.800000",
        "id": 23,
        "className": "Person",
        coords: [
            485.0,
            243.0,
            545.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:30.800000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            208.0,
            60.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:30.900000",
        "id": 25,
        "className": "Person",
        coords: [
            179.0,
            199.0,
            213.0,
            275.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:31",
        "id": 21,
        "className": "Person",
        coords: [
            348.0,
            533.0,
            454.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:31.100000",
        "id": 23,
        "className": "Person",
        coords: [
            485.0,
            243.0,
            545.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:31.200000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            208.0,
            60.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:31.200000",
        "id": 25,
        "className": "Person",
        coords: [
            179.0,
            199.0,
            213.0,
            275.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:31.300000",
        "id": 21,
        "className": "Person",
        coords: [
            348.0,
            534.0,
            454.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:31.400000",
        "id": 23,
        "className": "Person",
        coords: [
            485.0,
            243.0,
            546.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:31.500000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            208.0,
            61.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:31.600000",
        "id": 25,
        "className": "Person",
        coords: [
            180.0,
            199.0,
            214.0,
            275.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:31.600000",
        "id": 21,
        "className": "Person",
        coords: [
            349.0,
            534.0,
            454.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:31.800000",
        "id": 23,
        "className": "Person",
        coords: [
            485.0,
            244.0,
            546.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:31.800000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            208.0,
            61.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:31.900000",
        "id": 25,
        "className": "Person",
        coords: [
            180.0,
            198.0,
            214.0,
            275.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:31.900000",
        "id": 21,
        "className": "Person",
        coords: [
            349.0,
            534.0,
            454.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:32.100000",
        "id": 23,
        "className": "Person",
        coords: [
            485.0,
            244.0,
            546.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:32.100000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            208.0,
            61.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:32.200000",
        "id": 25,
        "className": "Person",
        coords: [
            180.0,
            199.0,
            213.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:32.300000",
        "id": 21,
        "className": "Person",
        coords: [
            349.0,
            534.0,
            454.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:32.300000",
        "id": 22,
        "className": "Person",
        coords: [
            127.0,
            195.0,
            164.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:32.500000",
        "id": 23,
        "className": "Person",
        coords: [
            484.0,
            244.0,
            545.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:32.500000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            208.0,
            61.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:32.600000",
        "id": 25,
        "className": "Person",
        coords: [
            180.0,
            199.0,
            214.0,
            275.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:32.600000",
        "id": 21,
        "className": "Person",
        coords: [
            350.0,
            534.0,
            455.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:32.700000",
        "id": 22,
        "className": "Person",
        coords: [
            128.0,
            195.0,
            165.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:32.800000",
        "id": 23,
        "className": "Person",
        coords: [
            484.0,
            244.0,
            546.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:32.900000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            207.0,
            61.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:33",
        "id": 25,
        "className": "Person",
        coords: [
            181.0,
            199.0,
            214.0,
            275.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:33",
        "id": 21,
        "className": "Person",
        coords: [
            350.0,
            535.0,
            455.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:33.100000",
        "id": 22,
        "className": "Person",
        coords: [
            128.0,
            196.0,
            165.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:33.200000",
        "id": 23,
        "className": "Person",
        coords: [
            485.0,
            244.0,
            546.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:33.300000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            207.0,
            61.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:33.300000",
        "id": 25,
        "className": "Person",
        coords: [
            180.0,
            199.0,
            214.0,
            275.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:33.400000",
        "id": 21,
        "className": "Person",
        coords: [
            350.0,
            535.0,
            455.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:33.400000",
        "id": 22,
        "className": "Person",
        coords: [
            128.0,
            194.0,
            166.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:33.600000",
        "id": 23,
        "className": "Person",
        coords: [
            492.0,
            244.0,
            551.0,
            332.0
        ],
        "status": "Moving",
        "speed": 91.23,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:33.700000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            208.0,
            61.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:33.700000",
        "id": 25,
        "className": "Person",
        coords: [
            181.0,
            199.0,
            215.0,
            275.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:33.800000",
        "id": 21,
        "className": "Person",
        coords: [
            335.0,
            535.0,
            444.0,
            718.0
        ],
        "status": "Moving",
        "speed": 194.98,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:33.800000",
        "id": 22,
        "className": "Person",
        coords: [
            128.0,
            194.0,
            167.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:34",
        "id": 23,
        "className": "Person",
        coords: [
            494.0,
            244.0,
            553.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:34",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            208.0,
            61.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:34.100000",
        "id": 25,
        "className": "Person",
        coords: [
            181.0,
            199.0,
            215.0,
            275.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:34.200000",
        "id": 21,
        "className": "Person",
        coords: [
            328.0,
            535.0,
            440.0,
            718.0
        ],
        "status": "Moving",
        "speed": 74.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:34.200000",
        "id": 22,
        "className": "Person",
        coords: [
            128.0,
            194.0,
            167.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:34.400000",
        "id": 23,
        "className": "Person",
        coords: [
            484.0,
            244.0,
            545.0,
            332.0
        ],
        "status": "Moving",
        "speed": 134.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:34.400000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            208.0,
            61.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:34.400000",
        "id": 25,
        "className": "Person",
        coords: [
            182.0,
            199.0,
            216.0,
            276.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:34.500000",
        "id": 21,
        "className": "Person",
        coords: [
            324.0,
            535.0,
            440.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:34.500000",
        "id": 22,
        "className": "Person",
        coords: [
            128.0,
            194.0,
            167.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:34.700000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            208.0,
            61.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:34.700000",
        "id": 25,
        "className": "Person",
        coords: [
            181.0,
            198.0,
            216.0,
            277.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:34.800000",
        "id": 21,
        "className": "Person",
        coords: [
            322.0,
            535.0,
            440.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:34.800000",
        "id": 22,
        "className": "Person",
        coords: [
            129.0,
            194.0,
            167.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:35",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            208.0,
            61.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:35",
        "id": 25,
        "className": "Person",
        coords: [
            181.0,
            196.0,
            216.0,
            277.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:35.100000",
        "id": 21,
        "className": "Person",
        coords: [
            321.0,
            535.0,
            442.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:35.100000",
        "id": 22,
        "className": "Person",
        coords: [
            130.0,
            195.0,
            167.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:35.200000",
        "id": 23,
        "className": "Person",
        coords: [
            481.0,
            244.0,
            542.0,
            331.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:35.300000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            207.0,
            62.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:35.400000",
        "id": 25,
        "className": "Person",
        coords: [
            182.0,
            197.0,
            217.0,
            278.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:35.400000",
        "id": 21,
        "className": "Person",
        coords: [
            336.0,
            535.0,
            455.0,
            718.0
        ],
        "status": "Moving",
        "speed": 209.98,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:35.500000",
        "id": 22,
        "className": "Person",
        coords: [
            130.0,
            194.0,
            167.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:35.500000",
        "id": 23,
        "className": "Person",
        coords: [
            479.0,
            243.0,
            542.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:35.600000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            207.0,
            62.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:35.700000",
        "id": 25,
        "className": "Person",
        coords: [
            182.0,
            197.0,
            217.0,
            279.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:35.700000",
        "id": 21,
        "className": "Person",
        coords: [
            342.0,
            535.0,
            459.0,
            718.0
        ],
        "status": "Moving",
        "speed": 74.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:35.800000",
        "id": 22,
        "className": "Person",
        coords: [
            130.0,
            193.0,
            167.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:35.800000",
        "id": 23,
        "className": "Person",
        coords: [
            478.0,
            243.0,
            541.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:35.900000",
        "id": 26,
        "className": "Person",
        coords: [
            228.0,
            204.0,
            267.0,
            298.0
        ],
        "status": "First Seen",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:19:36",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            207.0,
            62.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:36",
        "id": 25,
        "className": "Person",
        coords: [
            183.0,
            198.0,
            217.0,
            279.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:36.100000",
        "id": 21,
        "className": "Person",
        coords: [
            344.0,
            535.0,
            460.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:36.100000",
        "id": 22,
        "className": "Person",
        coords: [
            130.0,
            192.0,
            167.0,
            266.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:36.200000",
        "id": 23,
        "className": "Person",
        coords: [
            476.0,
            243.0,
            541.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:36.200000",
        "id": 26,
        "className": "Person",
        coords: [
            228.0,
            204.0,
            266.0,
            298.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:19:36.400000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            207.0,
            62.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:36.400000",
        "id": 25,
        "className": "Person",
        coords: [
            183.0,
            197.0,
            218.0,
            279.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:36.500000",
        "id": 21,
        "className": "Person",
        coords: [
            345.0,
            535.0,
            460.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:36.500000",
        "id": 22,
        "className": "Person",
        coords: [
            129.0,
            191.0,
            167.0,
            266.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:36.600000",
        "id": 23,
        "className": "Person",
        coords: [
            472.0,
            243.0,
            540.0,
            332.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:36.600000",
        "id": 26,
        "className": "Person",
        coords: [
            228.0,
            205.0,
            266.0,
            298.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:19:36.800000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            207.0,
            62.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:36.800000",
        "id": 25,
        "className": "Person",
        coords: [
            183.0,
            198.0,
            218.0,
            280.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:36.900000",
        "id": 21,
        "className": "Person",
        coords: [
            346.0,
            535.0,
            460.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:36.900000",
        "id": 22,
        "className": "Person",
        coords: [
            129.0,
            193.0,
            166.0,
            266.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:36.900000",
        "id": 23,
        "className": "Person",
        coords: [
            469.0,
            243.0,
            539.0,
            333.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:37",
        "id": 26,
        "className": "Person",
        coords: [
            228.0,
            205.0,
            266.0,
            298.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:19:37.100000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            207.0,
            61.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:37.200000",
        "id": 25,
        "className": "Person",
        coords: [
            183.0,
            198.0,
            218.0,
            280.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:37.200000",
        "id": 21,
        "className": "Person",
        coords: [
            346.0,
            535.0,
            459.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:37.300000",
        "id": 22,
        "className": "Person",
        coords: [
            129.0,
            193.0,
            166.0,
            266.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:37.300000",
        "id": 23,
        "className": "Person",
        coords: [
            467.0,
            243.0,
            539.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:37.400000",
        "id": 26,
        "className": "Person",
        coords: [
            228.0,
            206.0,
            266.0,
            298.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:37.500000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            207.0,
            61.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:37.600000",
        "id": 25,
        "className": "Person",
        coords: [
            184.0,
            197.0,
            219.0,
            281.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:37.600000",
        "id": 21,
        "className": "Person",
        coords: [
            346.0,
            535.0,
            459.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:37.700000",
        "id": 22,
        "className": "Person",
        coords: [
            130.0,
            195.0,
            165.0,
            266.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:37.700000",
        "id": 23,
        "className": "Person",
        coords: [
            467.0,
            243.0,
            541.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:37.800000",
        "id": 26,
        "className": "Person",
        coords: [
            229.0,
            208.0,
            266.0,
            298.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:37.900000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            207.0,
            61.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:38",
        "id": 25,
        "className": "Person",
        coords: [
            184.0,
            197.0,
            220.0,
            281.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:38",
        "id": 21,
        "className": "Person",
        coords: [
            347.0,
            536.0,
            458.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:38.100000",
        "id": 22,
        "className": "Person",
        coords: [
            130.0,
            196.0,
            165.0,
            266.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:38.100000",
        "id": 23,
        "className": "Person",
        coords: [
            466.0,
            243.0,
            541.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:38.200000",
        "id": 26,
        "className": "Person",
        coords: [
            229.0,
            210.0,
            266.0,
            298.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:38.200000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            207.0,
            61.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:38.200000",
        "id": 25,
        "className": "Person",
        coords: [
            185.0,
            199.0,
            220.0,
            281.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:38.300000",
        "id": 21,
        "className": "Person",
        coords: [
            348.0,
            536.0,
            458.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:38.300000",
        "id": 22,
        "className": "Person",
        coords: [
            129.0,
            194.0,
            166.0,
            266.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:38.300000",
        "id": 23,
        "className": "Person",
        coords: [
            463.0,
            242.0,
            540.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:38.400000",
        "id": 26,
        "className": "Person",
        coords: [
            229.0,
            211.0,
            265.0,
            298.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:38.500000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            207.0,
            61.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:38.500000",
        "id": 25,
        "className": "Person",
        coords: [
            185.0,
            198.0,
            221.0,
            281.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:38.600000",
        "id": 21,
        "className": "Person",
        coords: [
            349.0,
            536.0,
            458.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:38.600000",
        "id": 22,
        "className": "Person",
        coords: [
            130.0,
            198.0,
            165.0,
            266.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:38.700000",
        "id": 23,
        "className": "Person",
        coords: [
            459.0,
            242.0,
            538.0,
            333.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:38.700000",
        "id": 26,
        "className": "Person",
        coords: [
            229.0,
            211.0,
            266.0,
            298.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:38.800000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            207.0,
            61.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:38.800000",
        "id": 25,
        "className": "Person",
        coords: [
            186.0,
            198.0,
            221.0,
            281.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:38.800000",
        "id": 21,
        "className": "Person",
        coords: [
            349.0,
            537.0,
            457.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:38.800000",
        "id": 22,
        "className": "Person",
        coords: [
            130.0,
            200.0,
            165.0,
            266.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:38.900000",
        "id": 23,
        "className": "Person",
        coords: [
            458.0,
            242.0,
            537.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:38.900000",
        "id": 26,
        "className": "Person",
        coords: [
            229.0,
            213.0,
            265.0,
            298.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:39.100000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            207.0,
            61.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:39.100000",
        "id": 25,
        "className": "Person",
        coords: [
            186.0,
            199.0,
            222.0,
            281.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:39.200000",
        "id": 21,
        "className": "Person",
        coords: [
            349.0,
            537.0,
            456.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:39.200000",
        "id": 22,
        "className": "Person",
        coords: [
            130.0,
            199.0,
            165.0,
            266.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:39.300000",
        "id": 23,
        "className": "Person",
        coords: [
            455.0,
            241.0,
            537.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:39.300000",
        "id": 26,
        "className": "Person",
        coords: [
            229.0,
            215.0,
            264.0,
            298.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:39.500000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            207.0,
            61.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:39.500000",
        "id": 25,
        "className": "Person",
        coords: [
            186.0,
            199.0,
            222.0,
            281.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:39.600000",
        "id": 21,
        "className": "Person",
        coords: [
            349.0,
            537.0,
            456.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:39.600000",
        "id": 22,
        "className": "Person",
        coords: [
            130.0,
            199.0,
            165.0,
            266.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:39.700000",
        "id": 23,
        "className": "Person",
        coords: [
            452.0,
            241.0,
            534.0,
            330.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:39.700000",
        "id": 26,
        "className": "Person",
        coords: [
            229.0,
            213.0,
            265.0,
            298.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:39.900000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            207.0,
            61.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:39.900000",
        "id": 25,
        "className": "Person",
        coords: [
            188.0,
            198.0,
            225.0,
            282.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:39.900000",
        "id": 21,
        "className": "Person",
        coords: [
            349.0,
            537.0,
            456.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:40",
        "id": 22,
        "className": "Person",
        coords: [
            129.0,
            198.0,
            165.0,
            266.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:40",
        "id": 23,
        "className": "Person",
        coords: [
            448.0,
            240.0,
            533.0,
            329.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:40",
        "id": 26,
        "className": "Person",
        coords: [
            230.0,
            215.0,
            265.0,
            298.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:40.200000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            207.0,
            61.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:40.200000",
        "id": 25,
        "className": "Person",
        coords: [
            188.0,
            198.0,
            226.0,
            282.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:40.300000",
        "id": 21,
        "className": "Person",
        coords: [
            349.0,
            537.0,
            455.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:40.400000",
        "id": 22,
        "className": "Person",
        coords: [
            130.0,
            202.0,
            164.0,
            266.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:40.400000",
        "id": 23,
        "className": "Person",
        coords: [
            451.0,
            239.0,
            538.0,
            330.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:40.400000",
        "id": 26,
        "className": "Person",
        coords: [
            229.0,
            215.0,
            265.0,
            298.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:40.600000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            207.0,
            61.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:40.600000",
        "id": 25,
        "className": "Person",
        coords: [
            190.0,
            197.0,
            227.0,
            281.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:40.700000",
        "id": 21,
        "className": "Person",
        coords: [
            349.0,
            538.0,
            455.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:40.700000",
        "id": 22,
        "className": "Person",
        coords: [
            127.0,
            198.0,
            164.0,
            265.0
        ],
        "status": "Moving",
        "speed": 54.08,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:40.800000",
        "id": 23,
        "className": "Person",
        coords: [
            457.0,
            239.0,
            543.0,
            330.0
        ],
        "status": "Moving",
        "speed": 89.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:40.800000",
        "id": 26,
        "className": "Person",
        coords: [
            229.0,
            211.0,
            268.0,
            298.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:40.900000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            208.0,
            61.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:40.900000",
        "id": 25,
        "className": "Person",
        coords: [
            191.0,
            196.0,
            229.0,
            280.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:40.900000",
        "id": 21,
        "className": "Person",
        coords: [
            350.0,
            538.0,
            455.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:41",
        "id": 22,
        "className": "Person",
        coords: [
            126.0,
            196.0,
            164.0,
            265.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:41",
        "id": 23,
        "className": "Person",
        coords: [
            459.0,
            239.0,
            543.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:41.100000",
        "id": 26,
        "className": "Person",
        coords: [
            229.0,
            211.0,
            268.0,
            298.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:41.200000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            207.0,
            61.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:41.200000",
        "id": 25,
        "className": "Person",
        coords: [
            192.0,
            196.0,
            230.0,
            279.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:41.300000",
        "id": 21,
        "className": "Person",
        coords: [
            350.0,
            538.0,
            455.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:41.300000",
        "id": 22,
        "className": "Person",
        coords: [
            126.0,
            195.0,
            164.0,
            265.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:41.400000",
        "id": 23,
        "className": "Person",
        coords: [
            461.0,
            239.0,
            544.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:41.400000",
        "id": 26,
        "className": "Person",
        coords: [
            229.0,
            210.0,
            268.0,
            298.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:41.500000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            207.0,
            61.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:41.500000",
        "id": 25,
        "className": "Person",
        coords: [
            191.0,
            196.0,
            228.0,
            278.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:41.500000",
        "id": 21,
        "className": "Person",
        coords: [
            350.0,
            538.0,
            455.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:41.600000",
        "id": 22,
        "className": "Person",
        coords: [
            126.0,
            195.0,
            164.0,
            265.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:41.600000",
        "id": 23,
        "className": "Person",
        coords: [
            461.0,
            239.0,
            543.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:41.700000",
        "id": 26,
        "className": "Person",
        coords: [
            227.0,
            208.0,
            268.0,
            299.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:41.800000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            207.0,
            61.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:41.900000",
        "id": 25,
        "className": "Person",
        coords: [
            191.0,
            196.0,
            229.0,
            279.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:41.900000",
        "id": 21,
        "className": "Person",
        coords: [
            350.0,
            538.0,
            455.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:42",
        "id": 22,
        "className": "Person",
        coords: [
            126.0,
            195.0,
            164.0,
            266.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:42",
        "id": 23,
        "className": "Person",
        coords: [
            461.0,
            239.0,
            544.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:42.100000",
        "id": 26,
        "className": "Person",
        coords: [
            227.0,
            208.0,
            268.0,
            299.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:42.100000",
        "id": 27,
        "className": "Person",
        coords: [
            838.0,
            229.0,
            871.0,
            311.0
        ],
        "status": "First Seen",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:19:42.200000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            208.0,
            61.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:42.200000",
        "id": 25,
        "className": "Person",
        coords: [
            191.0,
            196.0,
            229.0,
            279.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:42.200000",
        "id": 21,
        "className": "Person",
        coords: [
            350.0,
            539.0,
            454.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:42.300000",
        "id": 22,
        "className": "Person",
        coords: [
            125.0,
            195.0,
            164.0,
            265.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:42.300000",
        "id": 23,
        "className": "Person",
        coords: [
            461.0,
            238.0,
            544.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:42.400000",
        "id": 26,
        "className": "Person",
        coords: [
            227.0,
            209.0,
            268.0,
            298.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:42.400000",
        "id": 27,
        "className": "Person",
        coords: [
            841.0,
            229.0,
            874.0,
            311.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:19:42.500000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            207.0,
            61.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:42.600000",
        "id": 25,
        "className": "Person",
        coords: [
            191.0,
            196.0,
            229.0,
            279.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:42.600000",
        "id": 21,
        "className": "Person",
        coords: [
            350.0,
            539.0,
            454.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:42.700000",
        "id": 22,
        "className": "Person",
        coords: [
            125.0,
            195.0,
            164.0,
            265.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:42.700000",
        "id": 23,
        "className": "Person",
        coords: [
            460.0,
            238.0,
            543.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:42.800000",
        "id": 26,
        "className": "Person",
        coords: [
            225.0,
            210.0,
            266.0,
            298.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:42.800000",
        "id": 27,
        "className": "Person",
        coords: [
            842.0,
            228.0,
            876.0,
            312.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:19:42.900000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            208.0,
            60.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:43",
        "id": 25,
        "className": "Person",
        coords: [
            189.0,
            196.0,
            228.0,
            278.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:43",
        "id": 21,
        "className": "Person",
        coords: [
            350.0,
            540.0,
            454.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:43.100000",
        "id": 22,
        "className": "Person",
        coords: [
            125.0,
            196.0,
            164.0,
            265.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:43.100000",
        "id": 23,
        "className": "Person",
        coords: [
            454.0,
            236.0,
            540.0,
            329.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:43.200000",
        "id": 26,
        "className": "Person",
        coords: [
            227.0,
            210.0,
            268.0,
            298.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:43.200000",
        "id": 27,
        "className": "Person",
        coords: [
            844.0,
            227.0,
            878.0,
            314.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:19:43.400000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            207.0,
            61.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:43.400000",
        "id": 25,
        "className": "Person",
        coords: [
            188.0,
            196.0,
            226.0,
            279.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:43.500000",
        "id": 21,
        "className": "Person",
        coords: [
            350.0,
            540.0,
            454.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:43.500000",
        "id": 22,
        "className": "Person",
        coords: [
            125.0,
            196.0,
            164.0,
            265.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:43.600000",
        "id": 23,
        "className": "Person",
        coords: [
            452.0,
            235.0,
            539.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:43.600000",
        "id": 26,
        "className": "Person",
        coords: [
            227.0,
            210.0,
            268.0,
            298.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:43.700000",
        "id": 27,
        "className": "Person",
        coords: [
            846.0,
            229.0,
            881.0,
            317.0
        ],
        "status": "Moving",
        "speed": 54.08,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:43.800000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            207.0,
            61.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:43.900000",
        "id": 25,
        "className": "Person",
        coords: [
            185.0,
            197.0,
            224.0,
            280.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:43.900000",
        "id": 21,
        "className": "Person",
        coords: [
            349.0,
            540.0,
            453.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:44",
        "id": 22,
        "className": "Person",
        coords: [
            126.0,
            197.0,
            165.0,
            266.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:44",
        "id": 23,
        "className": "Person",
        coords: [
            450.0,
            235.0,
            539.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:44",
        "id": 26,
        "className": "Person",
        coords: [
            226.0,
            206.0,
            269.0,
            298.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:44.100000",
        "id": 27,
        "className": "Person",
        coords: [
            847.0,
            230.0,
            883.0,
            319.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:44.200000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            207.0,
            62.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:44.300000",
        "id": 25,
        "className": "Person",
        coords: [
            185.0,
            198.0,
            222.0,
            280.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:44.300000",
        "id": 21,
        "className": "Person",
        coords: [
            349.0,
            540.0,
            453.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:44.400000",
        "id": 22,
        "className": "Person",
        coords: [
            126.0,
            197.0,
            165.0,
            266.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:44.400000",
        "id": 23,
        "className": "Person",
        coords: [
            449.0,
            234.0,
            538.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:44.500000",
        "id": 26,
        "className": "Person",
        coords: [
            228.0,
            205.0,
            271.0,
            299.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:44.500000",
        "id": 27,
        "className": "Person",
        coords: [
            848.0,
            231.0,
            885.0,
            324.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:44.600000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            207.0,
            62.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:44.700000",
        "id": 25,
        "className": "Person",
        coords: [
            185.0,
            198.0,
            222.0,
            281.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:44.700000",
        "id": 21,
        "className": "Person",
        coords: [
            349.0,
            540.0,
            453.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:44.800000",
        "id": 22,
        "className": "Person",
        coords: [
            126.0,
            196.0,
            165.0,
            266.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:44.800000",
        "id": 23,
        "className": "Person",
        coords: [
            448.0,
            234.0,
            538.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:44.900000",
        "id": 26,
        "className": "Person",
        coords: [
            228.0,
            204.0,
            272.0,
            299.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:44.900000",
        "id": 27,
        "className": "Person",
        coords: [
            849.0,
            232.0,
            888.0,
            329.0
        ],
        "status": "Moving",
        "speed": 54.08,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:45",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            207.0,
            62.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:45.100000",
        "id": 25,
        "className": "Person",
        coords: [
            182.0,
            194.0,
            221.0,
            282.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:45.100000",
        "id": 21,
        "className": "Person",
        coords: [
            349.0,
            540.0,
            453.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:45.200000",
        "id": 22,
        "className": "Person",
        coords: [
            127.0,
            196.0,
            166.0,
            266.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:45.200000",
        "id": 23,
        "className": "Person",
        coords: [
            447.0,
            233.0,
            538.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:45.300000",
        "id": 26,
        "className": "Person",
        coords: [
            228.0,
            203.0,
            272.0,
            299.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:45.300000",
        "id": 27,
        "className": "Person",
        coords: [
            854.0,
            233.0,
            892.0,
            328.0
        ],
        "status": "Moving",
        "speed": 74.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:45.400000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            207.0,
            62.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:45.500000",
        "id": 25,
        "className": "Person",
        coords: [
            180.0,
            189.0,
            221.0,
            283.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:45.500000",
        "id": 21,
        "className": "Person",
        coords: [
            349.0,
            540.0,
            453.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:45.600000",
        "id": 22,
        "className": "Person",
        coords: [
            128.0,
            197.0,
            166.0,
            266.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:45.600000",
        "id": 23,
        "className": "Person",
        coords: [
            444.0,
            233.0,
            537.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:45.700000",
        "id": 26,
        "className": "Person",
        coords: [
            228.0,
            203.0,
            272.0,
            299.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:45.700000",
        "id": 27,
        "className": "Person",
        coords: [
            857.0,
            235.0,
            896.0,
            331.0
        ],
        "status": "Moving",
        "speed": 63.63,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:45.900000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            207.0,
            62.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:45.900000",
        "id": 25,
        "className": "Person",
        coords: [
            178.0,
            187.0,
            220.0,
            282.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:46",
        "id": 21,
        "className": "Person",
        coords: [
            348.0,
            540.0,
            453.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:46",
        "id": 22,
        "className": "Person",
        coords: [
            129.0,
            197.0,
            166.0,
            266.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:46.100000",
        "id": 23,
        "className": "Person",
        coords: [
            441.0,
            232.0,
            536.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:46.100000",
        "id": 26,
        "className": "Person",
        coords: [
            228.0,
            203.0,
            272.0,
            299.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:46.100000",
        "id": 27,
        "className": "Person",
        coords: [
            860.0,
            235.0,
            900.0,
            331.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:46.300000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            207.0,
            61.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:46.300000",
        "id": 25,
        "className": "Person",
        coords: [
            177.0,
            184.0,
            220.0,
            282.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:46.400000",
        "id": 21,
        "className": "Person",
        coords: [
            348.0,
            540.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:46.400000",
        "id": 22,
        "className": "Person",
        coords: [
            129.0,
            196.0,
            167.0,
            266.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:46.500000",
        "id": 23,
        "className": "Person",
        coords: [
            439.0,
            236.0,
            533.0,
            330.0
        ],
        "status": "Moving",
        "speed": 42.42,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:46.500000",
        "id": 26,
        "className": "Person",
        coords: [
            226.0,
            202.0,
            270.0,
            300.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:46.600000",
        "id": 27,
        "className": "Person",
        coords: [
            860.0,
            236.0,
            905.0,
            346.0
        ],
        "status": "Moving",
        "speed": 123.68,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:46.700000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            207.0,
            60.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:46.700000",
        "id": 25,
        "className": "Person",
        coords: [
            176.0,
            183.0,
            219.0,
            281.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:46.800000",
        "id": 21,
        "className": "Person",
        coords: [
            348.0,
            540.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:46.800000",
        "id": 22,
        "className": "Person",
        coords: [
            130.0,
            195.0,
            168.0,
            266.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:46.900000",
        "id": 23,
        "className": "Person",
        coords: [
            437.0,
            237.0,
            532.0,
            331.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:46.900000",
        "id": 26,
        "className": "Person",
        coords: [
            225.0,
            202.0,
            269.0,
            300.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:47",
        "id": 27,
        "className": "Person",
        coords: [
            862.0,
            238.0,
            904.0,
            339.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:47.100000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            207.0,
            60.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:47.200000",
        "id": 25,
        "className": "Person",
        coords: [
            175.0,
            183.0,
            218.0,
            281.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:47.200000",
        "id": 21,
        "className": "Person",
        coords: [
            348.0,
            540.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:47.300000",
        "id": 22,
        "className": "Person",
        coords: [
            131.0,
            196.0,
            168.0,
            266.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:47.300000",
        "id": 23,
        "className": "Person",
        coords: [
            437.0,
            238.0,
            533.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:47.400000",
        "id": 26,
        "className": "Person",
        coords: [
            225.0,
            202.0,
            269.0,
            299.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:47.400000",
        "id": 27,
        "className": "Person",
        coords: [
            866.0,
            240.0,
            906.0,
            334.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:47.500000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            207.0,
            60.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:47.500000",
        "id": 25,
        "className": "Person",
        coords: [
            175.0,
            183.0,
            217.0,
            281.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:47.500000",
        "id": 21,
        "className": "Person",
        coords: [
            348.0,
            540.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:47.600000",
        "id": 23,
        "className": "Person",
        coords: [
            434.0,
            238.0,
            532.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:47.600000",
        "id": 26,
        "className": "Person",
        coords: [
            225.0,
            202.0,
            269.0,
            298.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:47.600000",
        "id": 27,
        "className": "Person",
        coords: [
            870.0,
            243.0,
            909.0,
            332.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:47.800000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            207.0,
            59.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:47.800000",
        "id": 25,
        "className": "Person",
        coords: [
            173.0,
            183.0,
            217.0,
            281.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:47.900000",
        "id": 21,
        "className": "Person",
        coords: [
            348.0,
            540.0,
            453.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:47.900000",
        "id": 23,
        "className": "Person",
        coords: [
            433.0,
            238.0,
            533.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:48",
        "id": 26,
        "className": "Person",
        coords: [
            225.0,
            202.0,
            269.0,
            298.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:48.100000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            207.0,
            59.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:48.200000",
        "id": 25,
        "className": "Person",
        coords: [
            170.0,
            182.0,
            215.0,
            283.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:48.200000",
        "id": 21,
        "className": "Person",
        coords: [
            348.0,
            540.0,
            453.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:48.300000",
        "id": 23,
        "className": "Person",
        coords: [
            432.0,
            239.0,
            533.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:48.300000",
        "id": 26,
        "className": "Person",
        coords: [
            224.0,
            202.0,
            268.0,
            299.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:48.400000",
        "id": 22,
        "className": "Person",
        coords: [
            130.0,
            193.0,
            169.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:48.500000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            207.0,
            60.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:48.600000",
        "id": 25,
        "className": "Person",
        coords: [
            167.0,
            181.0,
            215.0,
            287.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:48.600000",
        "id": 21,
        "className": "Person",
        coords: [
            348.0,
            540.0,
            453.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:48.700000",
        "id": 23,
        "className": "Person",
        coords: [
            433.0,
            239.0,
            535.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:48.700000",
        "id": 26,
        "className": "Person",
        coords: [
            224.0,
            202.0,
            269.0,
            300.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:48.700000",
        "id": 22,
        "className": "Person",
        coords: [
            130.0,
            191.0,
            170.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:48.800000",
        "id": 27,
        "className": "Person",
        coords: [
            875.0,
            248.0,
            910.0,
            330.0
        ],
        "status": "Moving",
        "speed": 54.08,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:48.900000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            207.0,
            60.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:49",
        "id": 25,
        "className": "Person",
        coords: [
            164.0,
            182.0,
            215.0,
            295.0
        ],
        "status": "Moving",
        "speed": 67.08,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:49",
        "id": 21,
        "className": "Person",
        coords: [
            348.0,
            540.0,
            453.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:49.100000",
        "id": 23,
        "className": "Person",
        coords: [
            436.0,
            239.0,
            538.0,
            333.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:49.100000",
        "id": 26,
        "className": "Person",
        coords: [
            224.0,
            202.0,
            268.0,
            299.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:49.100000",
        "id": 22,
        "className": "Person",
        coords: [
            129.0,
            191.0,
            169.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:49.200000",
        "id": 27,
        "className": "Person",
        coords: [
            878.0,
            248.0,
            913.0,
            330.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:49.300000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            207.0,
            60.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:49.400000",
        "id": 25,
        "className": "Person",
        coords: [
            165.0,
            183.0,
            213.0,
            288.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:49.400000",
        "id": 21,
        "className": "Person",
        coords: [
            348.0,
            540.0,
            453.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:49.500000",
        "id": 23,
        "className": "Person",
        coords: [
            446.0,
            239.0,
            545.0,
            333.0
        ],
        "status": "Moving",
        "speed": 119.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:49.500000",
        "id": 26,
        "className": "Person",
        coords: [
            224.0,
            202.0,
            269.0,
            299.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:49.600000",
        "id": 22,
        "className": "Person",
        coords: [
            130.0,
            192.0,
            169.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:49.600000",
        "id": 27,
        "className": "Person",
        coords: [
            879.0,
            249.0,
            914.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:49.800000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            207.0,
            59.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:49.800000",
        "id": 25,
        "className": "Person",
        coords: [
            165.0,
            184.0,
            213.0,
            286.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:49.900000",
        "id": 21,
        "className": "Person",
        coords: [
            348.0,
            540.0,
            453.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:49.900000",
        "id": 23,
        "className": "Person",
        coords: [
            451.0,
            239.0,
            548.0,
            333.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:50",
        "id": 26,
        "className": "Person",
        coords: [
            224.0,
            202.0,
            269.0,
            299.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:50",
        "id": 22,
        "className": "Person",
        coords: [
            131.0,
            192.0,
            168.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:50.100000",
        "id": 27,
        "className": "Person",
        coords: [
            879.0,
            250.0,
            915.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:50.200000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            207.0,
            59.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:50.200000",
        "id": 25,
        "className": "Person",
        coords: [
            161.0,
            183.0,
            217.0,
            304.0
        ],
        "status": "Moving",
        "speed": 119.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:50.300000",
        "id": 21,
        "className": "Person",
        coords: [
            348.0,
            540.0,
            453.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:50.300000",
        "id": 23,
        "className": "Person",
        coords: [
            453.0,
            238.0,
            550.0,
            332.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:50.400000",
        "id": 26,
        "className": "Person",
        coords: [
            224.0,
            202.0,
            269.0,
            299.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:50.400000",
        "id": 22,
        "className": "Person",
        coords: [
            131.0,
            192.0,
            168.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:50.500000",
        "id": 27,
        "className": "Person",
        coords: [
            882.0,
            255.0,
            917.0,
            334.0
        ],
        "status": "Moving",
        "speed": 67.08,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:50.600000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            206.0,
            60.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:50.700000",
        "id": 25,
        "className": "Person",
        coords: [
            164.0,
            184.0,
            215.0,
            293.0
        ],
        "status": "Moving",
        "speed": 74.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:50.700000",
        "id": 21,
        "className": "Person",
        coords: [
            348.0,
            540.0,
            453.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:50.800000",
        "id": 23,
        "className": "Person",
        coords: [
            455.0,
            237.0,
            550.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:50.800000",
        "id": 26,
        "className": "Person",
        coords: [
            224.0,
            202.0,
            270.0,
            300.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:50.900000",
        "id": 22,
        "className": "Person",
        coords: [
            132.0,
            193.0,
            168.0,
            266.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:50.900000",
        "id": 27,
        "className": "Person",
        coords: [
            883.0,
            258.0,
            919.0,
            335.0
        ],
        "status": "Moving",
        "speed": 42.42,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:51.100000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            206.0,
            60.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:51.100000",
        "id": 25,
        "className": "Person",
        coords: [
            165.0,
            184.0,
            215.0,
            289.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:51.200000",
        "id": 21,
        "className": "Person",
        coords: [
            348.0,
            539.0,
            453.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:51.200000",
        "id": 23,
        "className": "Person",
        coords: [
            457.0,
            237.0,
            550.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:51.300000",
        "id": 26,
        "className": "Person",
        coords: [
            224.0,
            202.0,
            270.0,
            302.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:51.300000",
        "id": 22,
        "className": "Person",
        coords: [
            132.0,
            193.0,
            168.0,
            266.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:51.300000",
        "id": 27,
        "className": "Person",
        coords: [
            882.0,
            256.0,
            921.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:51.400000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            206.0,
            60.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:51.400000",
        "id": 25,
        "className": "Person",
        coords: [
            165.0,
            185.0,
            215.0,
            287.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:51.500000",
        "id": 21,
        "className": "Person",
        coords: [
            348.0,
            538.0,
            453.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:51.500000",
        "id": 23,
        "className": "Person",
        coords: [
            460.0,
            237.0,
            551.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:51.500000",
        "id": 26,
        "className": "Person",
        coords: [
            225.0,
            202.0,
            270.0,
            299.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:51.600000",
        "id": 22,
        "className": "Person",
        coords: [
            132.0,
            193.0,
            168.0,
            266.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:51.600000",
        "id": 27,
        "className": "Person",
        coords: [
            883.0,
            255.0,
            922.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:51.800000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            206.0,
            60.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:51.800000",
        "id": 25,
        "className": "Person",
        coords: [
            165.0,
            186.0,
            215.0,
            287.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:51.900000",
        "id": 21,
        "className": "Person",
        coords: [
            348.0,
            537.0,
            453.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:51.900000",
        "id": 23,
        "className": "Person",
        coords: [
            462.0,
            238.0,
            551.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:52",
        "id": 26,
        "className": "Person",
        coords: [
            224.0,
            202.0,
            271.0,
            303.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:52",
        "id": 22,
        "className": "Person",
        coords: [
            133.0,
            193.0,
            169.0,
            266.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:52",
        "id": 27,
        "className": "Person",
        coords: [
            885.0,
            257.0,
            924.0,
            337.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:52.100000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            207.0,
            60.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:52.200000",
        "id": 25,
        "className": "Person",
        coords: [
            165.0,
            186.0,
            215.0,
            286.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:52.300000",
        "id": 21,
        "className": "Person",
        coords: [
            332.0,
            535.0,
            442.0,
            717.0
        ],
        "status": "Moving",
        "speed": 195.56,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:52.300000",
        "id": 23,
        "className": "Person",
        coords: [
            463.0,
            240.0,
            549.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:52.400000",
        "id": 26,
        "className": "Person",
        coords: [
            225.0,
            202.0,
            272.0,
            305.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:52.400000",
        "id": 22,
        "className": "Person",
        coords: [
            133.0,
            193.0,
            169.0,
            266.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:52.400000",
        "id": 27,
        "className": "Person",
        coords: [
            889.0,
            257.0,
            931.0,
            344.0
        ],
        "status": "Moving",
        "speed": 100.61,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:52.600000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            208.0,
            59.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:52.600000",
        "id": 25,
        "className": "Person",
        coords: [
            165.0,
            186.0,
            215.0,
            285.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:52.700000",
        "id": 21,
        "className": "Person",
        coords: [
            324.0,
            533.0,
            439.0,
            717.0
        ],
        "status": "Moving",
        "speed": 91.23,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:52.800000",
        "id": 23,
        "className": "Person",
        coords: [
            464.0,
            241.0,
            547.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:52.800000",
        "id": 26,
        "className": "Person",
        coords: [
            227.0,
            202.0,
            272.0,
            302.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:52.800000",
        "id": 22,
        "className": "Person",
        coords: [
            134.0,
            193.0,
            169.0,
            266.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:52.900000",
        "id": 27,
        "className": "Person",
        coords: [
            893.0,
            259.0,
            938.0,
            350.0
        ],
        "status": "Moving",
        "speed": 96.04,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:53",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            208.0,
            59.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:53.100000",
        "id": 25,
        "className": "Person",
        coords: [
            164.0,
            186.0,
            216.0,
            285.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:53.100000",
        "id": 21,
        "className": "Person",
        coords: [
            320.0,
            531.0,
            438.0,
            717.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:53.200000",
        "id": 23,
        "className": "Person",
        coords: [
            465.0,
            241.0,
            546.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:53.200000",
        "id": 26,
        "className": "Person",
        coords: [
            228.0,
            202.0,
            272.0,
            301.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:53.300000",
        "id": 22,
        "className": "Person",
        coords: [
            134.0,
            193.0,
            169.0,
            266.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:53.300000",
        "id": 27,
        "className": "Person",
        coords: [
            896.0,
            260.0,
            942.0,
            354.0
        ],
        "status": "Moving",
        "speed": 74.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:53.400000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            208.0,
            59.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:53.500000",
        "id": 25,
        "className": "Person",
        coords: [
            164.0,
            186.0,
            216.0,
            285.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:53.500000",
        "id": 21,
        "className": "Person",
        coords: [
            319.0,
            531.0,
            439.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:53.600000",
        "id": 23,
        "className": "Person",
        coords: [
            466.0,
            241.0,
            546.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:53.600000",
        "id": 26,
        "className": "Person",
        coords: [
            228.0,
            202.0,
            272.0,
            300.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:53.700000",
        "id": 22,
        "className": "Person",
        coords: [
            134.0,
            193.0,
            169.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:53.700000",
        "id": 27,
        "className": "Person",
        coords: [
            898.0,
            260.0,
            945.0,
            357.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:53.800000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            208.0,
            59.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:53.800000",
        "id": 25,
        "className": "Person",
        coords: [
            164.0,
            186.0,
            217.0,
            285.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:53.800000",
        "id": 21,
        "className": "Person",
        coords: [
            318.0,
            530.0,
            440.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:53.800000",
        "id": 23,
        "className": "Person",
        coords: [
            466.0,
            241.0,
            545.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:53.900000",
        "id": 26,
        "className": "Person",
        coords: [
            228.0,
            202.0,
            272.0,
            300.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:53.900000",
        "id": 22,
        "className": "Person",
        coords: [
            134.0,
            193.0,
            170.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:53.900000",
        "id": 27,
        "className": "Person",
        coords: [
            900.0,
            262.0,
            947.0,
            360.0
        ],
        "status": "Moving",
        "speed": 54.08,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:54",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            208.0,
            59.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:54.100000",
        "id": 25,
        "className": "Person",
        coords: [
            163.0,
            186.0,
            216.0,
            285.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:54.100000",
        "id": 21,
        "className": "Person",
        coords: [
            318.0,
            530.0,
            442.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:54.200000",
        "id": 23,
        "className": "Person",
        coords: [
            467.0,
            241.0,
            544.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:54.200000",
        "id": 26,
        "className": "Person",
        coords: [
            228.0,
            202.0,
            272.0,
            301.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:54.200000",
        "id": 22,
        "className": "Person",
        coords: [
            134.0,
            193.0,
            169.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:54.300000",
        "id": 27,
        "className": "Person",
        coords: [
            902.0,
            262.0,
            950.0,
            361.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:54.400000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            208.0,
            59.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:54.400000",
        "id": 25,
        "className": "Person",
        coords: [
            163.0,
            186.0,
            216.0,
            284.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:54.500000",
        "id": 21,
        "className": "Person",
        coords: [
            316.0,
            530.0,
            442.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:54.500000",
        "id": 23,
        "className": "Person",
        coords: [
            467.0,
            241.0,
            544.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:54.600000",
        "id": 26,
        "className": "Person",
        coords: [
            228.0,
            202.0,
            271.0,
            299.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:54.600000",
        "id": 22,
        "className": "Person",
        coords: [
            134.0,
            193.0,
            169.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:54.700000",
        "id": 27,
        "className": "Person",
        coords: [
            904.0,
            262.0,
            952.0,
            362.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:54.800000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            208.0,
            59.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:54.900000",
        "id": 25,
        "className": "Person",
        coords: [
            162.0,
            186.0,
            215.0,
            284.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:54.900000",
        "id": 21,
        "className": "Person",
        coords: [
            314.0,
            530.0,
            442.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:55",
        "id": 23,
        "className": "Person",
        coords: [
            469.0,
            241.0,
            544.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:55",
        "id": 26,
        "className": "Person",
        coords: [
            227.0,
            202.0,
            270.0,
            299.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:55.100000",
        "id": 22,
        "className": "Person",
        coords: [
            134.0,
            193.0,
            169.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:55.100000",
        "id": 27,
        "className": "Person",
        coords: [
            903.0,
            264.0,
            954.0,
            374.0
        ],
        "status": "Moving",
        "speed": 104.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:55.200000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            208.0,
            59.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:55.300000",
        "id": 25,
        "className": "Person",
        coords: [
            162.0,
            186.0,
            214.0,
            284.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:55.400000",
        "id": 21,
        "className": "Person",
        coords: [
            314.0,
            530.0,
            443.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:55.400000",
        "id": 23,
        "className": "Person",
        coords: [
            469.0,
            242.0,
            543.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:55.400000",
        "id": 26,
        "className": "Person",
        coords: [
            226.0,
            201.0,
            269.0,
            299.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:55.500000",
        "id": 22,
        "className": "Person",
        coords: [
            135.0,
            193.0,
            170.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:55.500000",
        "id": 27,
        "className": "Person",
        coords: [
            903.0,
            265.0,
            956.0,
            380.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:55.700000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            208.0,
            59.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:55.700000",
        "id": 25,
        "className": "Person",
        coords: [
            161.0,
            186.0,
            214.0,
            284.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:55.700000",
        "id": 21,
        "className": "Person",
        coords: [
            314.0,
            530.0,
            444.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:55.800000",
        "id": 23,
        "className": "Person",
        coords: [
            470.0,
            242.0,
            543.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:55.800000",
        "id": 26,
        "className": "Person",
        coords: [
            226.0,
            202.0,
            269.0,
            298.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:55.900000",
        "id": 22,
        "className": "Person",
        coords: [
            135.0,
            193.0,
            170.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:55.900000",
        "id": 27,
        "className": "Person",
        coords: [
            903.0,
            267.0,
            957.0,
            387.0
        ],
        "status": "Moving",
        "speed": 76.48,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:56",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            208.0,
            59.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:56.100000",
        "id": 25,
        "className": "Person",
        coords: [
            161.0,
            186.0,
            214.0,
            284.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:56.100000",
        "id": 21,
        "className": "Person",
        coords: [
            313.0,
            531.0,
            444.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:56.200000",
        "id": 23,
        "className": "Person",
        coords: [
            472.0,
            242.0,
            543.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:56.200000",
        "id": 26,
        "className": "Person",
        coords: [
            227.0,
            202.0,
            270.0,
            298.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:56.300000",
        "id": 22,
        "className": "Person",
        coords: [
            136.0,
            193.0,
            170.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:56.300000",
        "id": 27,
        "className": "Person",
        coords: [
            904.0,
            269.0,
            958.0,
            391.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:56.400000",
        "id": 15,
        "className": "Person",
        coords: [
            13.0,
            207.0,
            60.0,
            334.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:56.500000",
        "id": 25,
        "className": "Person",
        coords: [
            161.0,
            186.0,
            214.0,
            286.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:56.500000",
        "id": 21,
        "className": "Person",
        coords: [
            313.0,
            531.0,
            444.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:56.600000",
        "id": 23,
        "className": "Person",
        coords: [
            472.0,
            242.0,
            543.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:56.600000",
        "id": 26,
        "className": "Person",
        coords: [
            227.0,
            202.0,
            271.0,
            301.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:56.600000",
        "id": 22,
        "className": "Person",
        coords: [
            137.0,
            193.0,
            170.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:56.700000",
        "id": 27,
        "className": "Person",
        coords: [
            905.0,
            269.0,
            960.0,
            394.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:56.800000",
        "id": 15,
        "className": "Person",
        coords: [
            13.0,
            207.0,
            60.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:56.900000",
        "id": 25,
        "className": "Person",
        coords: [
            161.0,
            185.0,
            214.0,
            285.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:56.900000",
        "id": 21,
        "className": "Person",
        coords: [
            312.0,
            532.0,
            444.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:57",
        "id": 23,
        "className": "Person",
        coords: [
            472.0,
            241.0,
            543.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:57",
        "id": 26,
        "className": "Person",
        coords: [
            228.0,
            202.0,
            272.0,
            302.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:57",
        "id": 22,
        "className": "Person",
        coords: [
            137.0,
            193.0,
            170.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:57.100000",
        "id": 27,
        "className": "Person",
        coords: [
            909.0,
            269.0,
            964.0,
            396.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:57.200000",
        "id": 15,
        "className": "Person",
        coords: [
            13.0,
            207.0,
            60.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:57.300000",
        "id": 25,
        "className": "Person",
        coords: [
            161.0,
            185.0,
            214.0,
            285.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:57.300000",
        "id": 21,
        "className": "Person",
        coords: [
            311.0,
            532.0,
            444.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:57.400000",
        "id": 23,
        "className": "Person",
        coords: [
            472.0,
            241.0,
            542.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:57.400000",
        "id": 26,
        "className": "Person",
        coords: [
            228.0,
            203.0,
            272.0,
            303.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:57.500000",
        "id": 22,
        "className": "Person",
        coords: [
            137.0,
            193.0,
            170.0,
            266.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:57.500000",
        "id": 27,
        "className": "Person",
        coords: [
            911.0,
            270.0,
            965.0,
            396.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:57.700000",
        "id": 15,
        "className": "Person",
        coords: [
            13.0,
            207.0,
            60.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:57.700000",
        "id": 25,
        "className": "Person",
        coords: [
            160.0,
            185.0,
            214.0,
            286.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:57.800000",
        "id": 21,
        "className": "Person",
        coords: [
            314.0,
            532.0,
            447.0,
            716.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:57.800000",
        "id": 23,
        "className": "Person",
        coords: [
            472.0,
            241.0,
            542.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:57.900000",
        "id": 26,
        "className": "Person",
        coords: [
            228.0,
            203.0,
            272.0,
            302.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:57.900000",
        "id": 22,
        "className": "Person",
        coords: [
            137.0,
            192.0,
            169.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:58",
        "id": 27,
        "className": "Person",
        coords: [
            913.0,
            270.0,
            966.0,
            394.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:58.100000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            207.0,
            58.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:58.200000",
        "id": 25,
        "className": "Person",
        coords: [
            161.0,
            185.0,
            213.0,
            284.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:58.200000",
        "id": 21,
        "className": "Person",
        coords: [
            312.0,
            532.0,
            446.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:58.300000",
        "id": 23,
        "className": "Person",
        coords: [
            471.0,
            241.0,
            541.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:58.300000",
        "id": 26,
        "className": "Person",
        coords: [
            228.0,
            204.0,
            270.0,
            299.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:58.400000",
        "id": 22,
        "className": "Person",
        coords: [
            138.0,
            192.0,
            170.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:58.400000",
        "id": 27,
        "className": "Person",
        coords: [
            914.0,
            271.0,
            967.0,
            396.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:58.600000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            207.0,
            58.0,
            335.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:58.600000",
        "id": 25,
        "className": "Person",
        coords: [
            161.0,
            185.0,
            212.0,
            282.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:58.700000",
        "id": 21,
        "className": "Person",
        coords: [
            317.0,
            532.0,
            451.0,
            717.0
        ],
        "status": "Moving",
        "speed": 74.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:58.700000",
        "id": 23,
        "className": "Person",
        coords: [
            471.0,
            240.0,
            541.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:58.700000",
        "id": 26,
        "className": "Person",
        coords: [
            228.0,
            204.0,
            269.0,
            297.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:58.800000",
        "id": 22,
        "className": "Person",
        coords: [
            139.0,
            192.0,
            170.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:58.800000",
        "id": 27,
        "className": "Person",
        coords: [
            915.0,
            272.0,
            967.0,
            396.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:59",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            207.0,
            59.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:59",
        "id": 25,
        "className": "Person",
        coords: [
            161.0,
            185.0,
            212.0,
            282.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:59.100000",
        "id": 21,
        "className": "Person",
        coords: [
            314.0,
            532.0,
            448.0,
            717.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:59.100000",
        "id": 23,
        "className": "Person",
        coords: [
            471.0,
            240.0,
            540.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:59.200000",
        "id": 26,
        "className": "Person",
        coords: [
            227.0,
            204.0,
            269.0,
            297.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:59.200000",
        "id": 22,
        "className": "Person",
        coords: [
            139.0,
            192.0,
            170.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:59.300000",
        "id": 27,
        "className": "Person",
        coords: [
            916.0,
            274.0,
            967.0,
            397.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:59.400000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            207.0,
            59.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:59.400000",
        "id": 25,
        "className": "Person",
        coords: [
            161.0,
            185.0,
            212.0,
            282.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:59.500000",
        "id": 21,
        "className": "Person",
        coords: [
            312.0,
            532.0,
            447.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:59.500000",
        "id": 23,
        "className": "Person",
        coords: [
            469.0,
            239.0,
            538.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:59.600000",
        "id": 26,
        "className": "Person",
        coords: [
            227.0,
            204.0,
            269.0,
            296.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:59.600000",
        "id": 22,
        "className": "Person",
        coords: [
            139.0,
            192.0,
            170.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:19:59.700000",
        "id": 27,
        "className": "Person",
        coords: [
            917.0,
            274.0,
            967.0,
            396.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:59.900000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            207.0,
            59.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:19:59.900000",
        "id": 25,
        "className": "Person",
        coords: [
            161.0,
            185.0,
            213.0,
            283.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:00",
        "id": 21,
        "className": "Person",
        coords: [
            311.0,
            532.0,
            447.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:00",
        "id": 23,
        "className": "Person",
        coords: [
            467.0,
            240.0,
            537.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:00.100000",
        "id": 26,
        "className": "Person",
        coords: [
            227.0,
            204.0,
            269.0,
            297.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:00.100000",
        "id": 22,
        "className": "Person",
        coords: [
            139.0,
            192.0,
            170.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:00.200000",
        "id": 27,
        "className": "Person",
        coords: [
            919.0,
            276.0,
            969.0,
            396.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:00.300000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            207.0,
            58.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:00.400000",
        "id": 25,
        "className": "Person",
        coords: [
            161.0,
            185.0,
            213.0,
            283.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:00.400000",
        "id": 21,
        "className": "Person",
        coords: [
            311.0,
            532.0,
            446.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:00.500000",
        "id": 23,
        "className": "Person",
        coords: [
            466.0,
            240.0,
            537.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:00.500000",
        "id": 26,
        "className": "Person",
        coords: [
            228.0,
            205.0,
            269.0,
            297.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:00.500000",
        "id": 22,
        "className": "Person",
        coords: [
            139.0,
            192.0,
            170.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:00.600000",
        "id": 27,
        "className": "Person",
        coords: [
            920.0,
            279.0,
            969.0,
            395.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:00.700000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            207.0,
            59.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:00.800000",
        "id": 25,
        "className": "Person",
        coords: [
            160.0,
            185.0,
            212.0,
            283.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:00.800000",
        "id": 21,
        "className": "Person",
        coords: [
            310.0,
            532.0,
            447.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:00.900000",
        "id": 23,
        "className": "Person",
        coords: [
            464.0,
            239.0,
            537.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:00.900000",
        "id": 26,
        "className": "Person",
        coords: [
            228.0,
            207.0,
            269.0,
            297.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:01",
        "id": 22,
        "className": "Person",
        coords: [
            139.0,
            192.0,
            169.0,
            266.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:01",
        "id": 27,
        "className": "Person",
        coords: [
            921.0,
            279.0,
            970.0,
            396.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:01.200000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            207.0,
            58.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:01.200000",
        "id": 25,
        "className": "Person",
        coords: [
            160.0,
            185.0,
            212.0,
            283.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:01.300000",
        "id": 21,
        "className": "Person",
        coords: [
            310.0,
            533.0,
            447.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:01.300000",
        "id": 23,
        "className": "Person",
        coords: [
            463.0,
            238.0,
            536.0,
            329.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:01.400000",
        "id": 22,
        "className": "Person",
        coords: [
            139.0,
            192.0,
            169.0,
            266.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:01.400000",
        "id": 27,
        "className": "Person",
        coords: [
            925.0,
            279.0,
            973.0,
            393.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:01.500000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            207.0,
            58.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:01.600000",
        "id": 25,
        "className": "Person",
        coords: [
            160.0,
            185.0,
            212.0,
            283.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:01.600000",
        "id": 21,
        "className": "Person",
        coords: [
            309.0,
            533.0,
            446.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:01.700000",
        "id": 23,
        "className": "Person",
        coords: [
            452.0,
            237.0,
            529.0,
            330.0
        ],
        "status": "Moving",
        "speed": 134.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:01.700000",
        "id": 27,
        "className": "Person",
        coords: [
            930.0,
            280.0,
            976.0,
            387.0
        ],
        "status": "Moving",
        "speed": 74.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:01.800000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            207.0,
            58.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:01.900000",
        "id": 25,
        "className": "Person",
        coords: [
            161.0,
            185.0,
            212.0,
            282.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:01.900000",
        "id": 21,
        "className": "Person",
        coords: [
            309.0,
            533.0,
            446.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:02",
        "id": 23,
        "className": "Person",
        coords: [
            448.0,
            236.0,
            529.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:02",
        "id": 26,
        "className": "Person",
        coords: [
            228.0,
            210.0,
            269.0,
            298.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:02.100000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            207.0,
            59.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:02.100000",
        "id": 25,
        "className": "Person",
        coords: [
            161.0,
            185.0,
            212.0,
            281.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:02.200000",
        "id": 23,
        "className": "Person",
        coords: [
            445.0,
            236.0,
            528.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:02.200000",
        "id": 26,
        "className": "Person",
        coords: [
            227.0,
            210.0,
            267.0,
            298.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:02.200000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            192.0,
            169.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:02.200000",
        "id": 27,
        "className": "Person",
        coords: [
            938.0,
            280.0,
            977.0,
            369.0
        ],
        "status": "Moving",
        "speed": 147.72,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:02.300000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            207.0,
            59.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:02.400000",
        "id": 25,
        "className": "Person",
        coords: [
            161.0,
            185.0,
            212.0,
            281.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:02.400000",
        "id": 23,
        "className": "Person",
        coords: [
            446.0,
            236.0,
            530.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:02.400000",
        "id": 26,
        "className": "Person",
        coords: [
            227.0,
            210.0,
            266.0,
            297.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:02.500000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            169.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:02.500000",
        "id": 21,
        "className": "Person",
        coords: [
            308.0,
            533.0,
            446.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:02.600000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            207.0,
            59.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:02.700000",
        "id": 25,
        "className": "Person",
        coords: [
            161.0,
            184.0,
            212.0,
            281.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:02.700000",
        "id": 23,
        "className": "Person",
        coords: [
            447.0,
            236.0,
            532.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:02.800000",
        "id": 26,
        "className": "Person",
        coords: [
            227.0,
            209.0,
            266.0,
            297.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:02.800000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            170.0,
            266.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:02.800000",
        "id": 21,
        "className": "Person",
        coords: [
            311.0,
            533.0,
            449.0,
            717.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:03",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            207.0,
            59.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:03",
        "id": 25,
        "className": "Person",
        coords: [
            162.0,
            184.0,
            213.0,
            281.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:03.100000",
        "id": 23,
        "className": "Person",
        coords: [
            441.0,
            237.0,
            529.0,
            331.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:03.100000",
        "id": 26,
        "className": "Person",
        coords: [
            226.0,
            208.0,
            266.0,
            297.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:03.100000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            170.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:03.200000",
        "id": 21,
        "className": "Person",
        coords: [
            309.0,
            533.0,
            448.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:03.300000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            207.0,
            59.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:03.400000",
        "id": 25,
        "className": "Person",
        coords: [
            162.0,
            184.0,
            214.0,
            280.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:03.400000",
        "id": 23,
        "className": "Person",
        coords: [
            454.0,
            238.0,
            539.0,
            332.0
        ],
        "status": "Moving",
        "speed": 165.67,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:03.400000",
        "id": 26,
        "className": "Person",
        coords: [
            225.0,
            207.0,
            265.0,
            297.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:03.500000",
        "id": 21,
        "className": "Person",
        coords: [
            309.0,
            533.0,
            448.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:03.600000",
        "id": 15,
        "className": "Person",
        coords: [
            14.0,
            207.0,
            59.0,
            333.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:03.600000",
        "id": 25,
        "className": "Person",
        coords: [
            164.0,
            184.0,
            217.0,
            281.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:03.700000",
        "id": 23,
        "className": "Person",
        coords: [
            460.0,
            238.0,
            545.0,
            333.0
        ],
        "status": "Moving",
        "speed": 89.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:03.700000",
        "id": 21,
        "className": "Person",
        coords: [
            308.0,
            533.0,
            449.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:03.700000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            194.0,
            169.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:03.900000",
        "id": 15,
        "className": "Person",
        coords: [
            14.0,
            207.0,
            59.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:03.900000",
        "id": 25,
        "className": "Person",
        coords: [
            164.0,
            184.0,
            218.0,
            281.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:03.900000",
        "id": 23,
        "className": "Person",
        coords: [
            464.0,
            239.0,
            546.0,
            333.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:04",
        "id": 21,
        "className": "Person",
        coords: [
            308.0,
            533.0,
            449.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:04",
        "id": 28,
        "className": "Person",
        coords: [
            639.0,
            447.0,
            828.0,
            603.0
        ],
        "status": "First Seen",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:20:04.100000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            194.0,
            170.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:04.200000",
        "id": 15,
        "className": "Person",
        coords: [
            14.0,
            207.0,
            59.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:04.300000",
        "id": 25,
        "className": "Person",
        coords: [
            165.0,
            184.0,
            220.0,
            283.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:04.300000",
        "id": 23,
        "className": "Person",
        coords: [
            466.0,
            239.0,
            547.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:04.400000",
        "id": 21,
        "className": "Person",
        coords: [
            308.0,
            533.0,
            449.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:04.400000",
        "id": 28,
        "className": "Person",
        coords: [
            639.0,
            447.0,
            827.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:20:04.500000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            194.0,
            170.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:04.600000",
        "id": 15,
        "className": "Person",
        coords: [
            14.0,
            207.0,
            60.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:04.600000",
        "id": 25,
        "className": "Person",
        coords: [
            165.0,
            183.0,
            222.0,
            284.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:04.700000",
        "id": 23,
        "className": "Person",
        coords: [
            467.0,
            239.0,
            546.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:04.700000",
        "id": 21,
        "className": "Person",
        coords: [
            308.0,
            533.0,
            449.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:04.800000",
        "id": 28,
        "className": "Person",
        coords: [
            639.0,
            447.0,
            828.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:20:04.800000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            194.0,
            170.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:04.900000",
        "id": 15,
        "className": "Person",
        coords: [
            14.0,
            207.0,
            60.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:05",
        "id": 25,
        "className": "Person",
        coords: [
            166.0,
            184.0,
            223.0,
            283.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:05",
        "id": 23,
        "className": "Person",
        coords: [
            467.0,
            239.0,
            545.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:05.100000",
        "id": 21,
        "className": "Person",
        coords: [
            308.0,
            533.0,
            449.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:05.100000",
        "id": 28,
        "className": "Person",
        coords: [
            639.0,
            447.0,
            828.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:20:05.200000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            194.0,
            170.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:05.300000",
        "id": 15,
        "className": "Person",
        coords: [
            14.0,
            207.0,
            60.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:05.300000",
        "id": 25,
        "className": "Person",
        coords: [
            160.0,
            186.0,
            214.0,
            280.0
        ],
        "status": "Moving",
        "speed": 104.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:05.400000",
        "id": 23,
        "className": "Person",
        coords: [
            467.0,
            238.0,
            545.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:05.400000",
        "id": 21,
        "className": "Person",
        coords: [
            308.0,
            533.0,
            449.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:05.500000",
        "id": 28,
        "className": "Person",
        coords: [
            640.0,
            447.0,
            828.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:20:05.500000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            194.0,
            171.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:05.500000",
        "id": 26,
        "className": "Person",
        coords: [
            229.0,
            208.0,
            266.0,
            294.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:05.700000",
        "id": 15,
        "className": "Person",
        coords: [
            14.0,
            207.0,
            60.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:05.700000",
        "id": 23,
        "className": "Person",
        coords: [
            467.0,
            237.0,
            545.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:05.800000",
        "id": 21,
        "className": "Person",
        coords: [
            308.0,
            533.0,
            449.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:05.800000",
        "id": 28,
        "className": "Person",
        coords: [
            639.0,
            447.0,
            828.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:20:05.900000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            195.0,
            171.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:05.900000",
        "id": 26,
        "className": "Person",
        coords: [
            227.0,
            207.0,
            265.0,
            293.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:06.100000",
        "id": 15,
        "className": "Person",
        coords: [
            14.0,
            207.0,
            60.0,
            325.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:06.100000",
        "id": 23,
        "className": "Person",
        coords: [
            468.0,
            237.0,
            545.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:06.200000",
        "id": 21,
        "className": "Person",
        coords: [
            308.0,
            533.0,
            449.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:06.200000",
        "id": 28,
        "className": "Person",
        coords: [
            639.0,
            447.0,
            827.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:06.300000",
        "id": 26,
        "className": "Person",
        coords: [
            229.0,
            209.0,
            266.0,
            292.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:06.400000",
        "id": 15,
        "className": "Person",
        coords: [
            14.0,
            207.0,
            61.0,
            325.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:06.400000",
        "id": 23,
        "className": "Person",
        coords: [
            468.0,
            236.0,
            544.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:06.500000",
        "id": 21,
        "className": "Person",
        coords: [
            308.0,
            533.0,
            449.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:06.500000",
        "id": 28,
        "className": "Person",
        coords: [
            639.0,
            448.0,
            827.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:06.600000",
        "id": 26,
        "className": "Person",
        coords: [
            228.0,
            208.0,
            265.0,
            292.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:06.600000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            195.0,
            171.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:06.700000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            207.0,
            61.0,
            334.0
        ],
        "status": "Moving",
        "speed": 67.08,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:06.800000",
        "id": 23,
        "className": "Person",
        coords: [
            469.0,
            238.0,
            544.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:06.800000",
        "id": 21,
        "className": "Person",
        coords: [
            307.0,
            533.0,
            448.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:06.900000",
        "id": 28,
        "className": "Person",
        coords: [
            642.0,
            449.0,
            844.0,
            618.0
        ],
        "status": "Moving",
        "speed": 192.08,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:06.900000",
        "id": 26,
        "className": "Person",
        coords: [
            230.0,
            212.0,
            266.0,
            293.0
        ],
        "status": "Moving",
        "speed": 42.42,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:07.100000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            207.0,
            60.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:07.100000",
        "id": 23,
        "className": "Person",
        coords: [
            470.0,
            238.0,
            545.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:07.300000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            206.0,
            60.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:07.300000",
        "id": 23,
        "className": "Person",
        coords: [
            469.0,
            237.0,
            545.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:07.400000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            194.0,
            172.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:07.400000",
        "id": 21,
        "className": "Person",
        coords: [
            307.0,
            533.0,
            449.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:07.500000",
        "id": 26,
        "className": "Person",
        coords: [
            231.0,
            213.0,
            267.0,
            294.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:07.600000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            206.0,
            60.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:07.700000",
        "id": 23,
        "className": "Person",
        coords: [
            469.0,
            236.0,
            545.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:07.700000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            194.0,
            173.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:07.800000",
        "id": 21,
        "className": "Person",
        coords: [
            308.0,
            533.0,
            449.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:07.800000",
        "id": 26,
        "className": "Person",
        coords: [
            231.0,
            214.0,
            267.0,
            294.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:08",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            206.0,
            60.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:08",
        "id": 23,
        "className": "Person",
        coords: [
            469.0,
            236.0,
            544.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:08.100000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            194.0,
            173.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:08.100000",
        "id": 21,
        "className": "Person",
        coords: [
            308.0,
            533.0,
            449.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:08.100000",
        "id": 26,
        "className": "Person",
        coords: [
            231.0,
            214.0,
            267.0,
            295.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:08.300000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            205.0,
            60.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:08.300000",
        "id": 23,
        "className": "Person",
        coords: [
            469.0,
            236.0,
            543.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:08.400000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            194.0,
            173.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:08.500000",
        "id": 21,
        "className": "Person",
        coords: [
            307.0,
            533.0,
            449.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:08.500000",
        "id": 26,
        "className": "Person",
        coords: [
            231.0,
            214.0,
            267.0,
            295.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:08.600000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            205.0,
            60.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:08.600000",
        "id": 23,
        "className": "Person",
        coords: [
            469.0,
            236.0,
            543.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:08.700000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            194.0,
            174.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:08.700000",
        "id": 21,
        "className": "Person",
        coords: [
            307.0,
            533.0,
            449.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:08.900000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            206.0,
            60.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:09",
        "id": 23,
        "className": "Person",
        coords: [
            469.0,
            236.0,
            542.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:09",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            175.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:09.100000",
        "id": 21,
        "className": "Person",
        coords: [
            307.0,
            534.0,
            448.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:09.100000",
        "id": 26,
        "className": "Person",
        coords: [
            231.0,
            215.0,
            267.0,
            296.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:09.300000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            206.0,
            60.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:09.300000",
        "id": 23,
        "className": "Person",
        coords: [
            469.0,
            237.0,
            541.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:09.300000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            175.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:09.400000",
        "id": 21,
        "className": "Person",
        coords: [
            306.0,
            534.0,
            448.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:09.500000",
        "id": 26,
        "className": "Person",
        coords: [
            231.0,
            216.0,
            267.0,
            296.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:09.600000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            206.0,
            60.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:09.700000",
        "id": 23,
        "className": "Person",
        coords: [
            469.0,
            236.0,
            542.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:09.800000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            175.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:09.800000",
        "id": 21,
        "className": "Person",
        coords: [
            306.0,
            534.0,
            448.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:09.900000",
        "id": 26,
        "className": "Person",
        coords: [
            231.0,
            216.0,
            267.0,
            296.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:10.100000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            206.0,
            60.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:10.100000",
        "id": 23,
        "className": "Person",
        coords: [
            469.0,
            236.0,
            542.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:10.200000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            194.0,
            176.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:10.300000",
        "id": 21,
        "className": "Person",
        coords: [
            306.0,
            534.0,
            448.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:10.300000",
        "id": 26,
        "className": "Person",
        coords: [
            231.0,
            216.0,
            267.0,
            295.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:10.500000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            206.0,
            60.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:10.500000",
        "id": 23,
        "className": "Person",
        coords: [
            469.0,
            235.0,
            542.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:10.600000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            194.0,
            176.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:10.600000",
        "id": 21,
        "className": "Person",
        coords: [
            306.0,
            534.0,
            448.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:10.700000",
        "id": 26,
        "className": "Person",
        coords: [
            231.0,
            216.0,
            267.0,
            295.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:10.800000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            206.0,
            60.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:10.900000",
        "id": 23,
        "className": "Person",
        coords: [
            469.0,
            235.0,
            542.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:10.900000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            194.0,
            176.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:11",
        "id": 21,
        "className": "Person",
        coords: [
            306.0,
            534.0,
            448.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:11",
        "id": 26,
        "className": "Person",
        coords: [
            231.0,
            216.0,
            267.0,
            295.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:11.200000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            206.0,
            60.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:11.200000",
        "id": 23,
        "className": "Person",
        coords: [
            469.0,
            234.0,
            543.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:11.300000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            194.0,
            176.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:11.300000",
        "id": 21,
        "className": "Person",
        coords: [
            305.0,
            534.0,
            448.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:11.400000",
        "id": 26,
        "className": "Person",
        coords: [
            231.0,
            216.0,
            267.0,
            295.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:11.500000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            207.0,
            60.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:11.600000",
        "id": 23,
        "className": "Person",
        coords: [
            466.0,
            235.0,
            540.0,
            334.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:11.600000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            194.0,
            177.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:11.700000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            207.0,
            60.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:11.700000",
        "id": 23,
        "className": "Person",
        coords: [
            464.0,
            235.0,
            539.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:11.800000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            194.0,
            177.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:11.900000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            208.0,
            60.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:12",
        "id": 23,
        "className": "Person",
        coords: [
            459.0,
            234.0,
            536.0,
            335.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:12",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            194.0,
            177.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:12.200000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            208.0,
            60.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:12.200000",
        "id": 23,
        "className": "Person",
        coords: [
            452.0,
            234.0,
            531.0,
            335.0
        ],
        "status": "Moving",
        "speed": 89.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:12.300000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            194.0,
            177.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:12.300000",
        "id": 21,
        "className": "Person",
        coords: [
            307.0,
            534.0,
            450.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:12.500000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            207.0,
            60.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:12.500000",
        "id": 23,
        "className": "Person",
        coords: [
            443.0,
            235.0,
            526.0,
            336.0
        ],
        "status": "Moving",
        "speed": 106.06,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:12.600000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            194.0,
            177.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:12.600000",
        "id": 21,
        "className": "Person",
        coords: [
            307.0,
            534.0,
            450.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:12.800000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            206.0,
            60.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:12.900000",
        "id": 23,
        "className": "Person",
        coords: [
            439.0,
            236.0,
            526.0,
            336.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:12.900000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            194.0,
            177.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:13.100000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            206.0,
            60.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:13.100000",
        "id": 23,
        "className": "Person",
        coords: [
            438.0,
            236.0,
            528.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:13.200000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            194.0,
            177.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:13.300000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            206.0,
            60.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:13.400000",
        "id": 23,
        "className": "Person",
        coords: [
            452.0,
            238.0,
            537.0,
            333.0
        ],
        "status": "Moving",
        "speed": 165.67,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:13.400000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:13.600000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            207.0,
            60.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:13.600000",
        "id": 23,
        "className": "Person",
        coords: [
            460.0,
            239.0,
            542.0,
            331.0
        ],
        "status": "Moving",
        "speed": 104.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:13.700000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:13.800000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            207.0,
            60.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:13.900000",
        "id": 23,
        "className": "Person",
        coords: [
            464.0,
            239.0,
            544.0,
            331.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:13.900000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:14.100000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            207.0,
            59.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:14.100000",
        "id": 23,
        "className": "Person",
        coords: [
            467.0,
            239.0,
            544.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:14.200000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:14.400000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            207.0,
            60.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:14.400000",
        "id": 23,
        "className": "Person",
        coords: [
            469.0,
            239.0,
            545.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:14.400000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:14.600000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            208.0,
            60.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:14.700000",
        "id": 23,
        "className": "Person",
        coords: [
            469.0,
            239.0,
            544.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:14.700000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            193.0,
            178.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:14.900000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            208.0,
            60.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:14.900000",
        "id": 23,
        "className": "Person",
        coords: [
            469.0,
            239.0,
            544.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:15",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            193.0,
            178.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:15.100000",
        "id": 21,
        "className": "Person",
        coords: [
            327.0,
            534.0,
            463.0,
            716.0
        ],
        "status": "Moving",
        "speed": 254.98,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:15.200000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            207.0,
            59.0,
            332.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:15.300000",
        "id": 23,
        "className": "Person",
        coords: [
            470.0,
            239.0,
            543.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:15.300000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            193.0,
            178.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:15.500000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            206.0,
            60.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:15.500000",
        "id": 23,
        "className": "Person",
        coords: [
            469.0,
            239.0,
            541.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:15.600000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            193.0,
            177.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:15.800000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            206.0,
            60.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:15.800000",
        "id": 23,
        "className": "Person",
        coords: [
            467.0,
            238.0,
            539.0,
            325.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:15.900000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:16",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            206.0,
            60.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:16.100000",
        "id": 23,
        "className": "Person",
        coords: [
            469.0,
            239.0,
            540.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:16.100000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:16.300000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            205.0,
            60.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:16.300000",
        "id": 23,
        "className": "Person",
        coords: [
            470.0,
            239.0,
            541.0,
            325.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:16.400000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:16.500000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            205.0,
            60.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:16.600000",
        "id": 23,
        "className": "Person",
        coords: [
            469.0,
            238.0,
            541.0,
            325.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:16.600000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:16.700000",
        "id": 29,
        "className": "Person",
        coords: [
            920.0,
            278.0,
            983.0,
            424.0
        ],
        "status": "First Seen",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:20:16.800000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            205.0,
            60.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:16.900000",
        "id": 23,
        "className": "Person",
        coords: [
            468.0,
            237.0,
            541.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:16.900000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:17",
        "id": 29,
        "className": "Person",
        coords: [
            920.0,
            278.0,
            982.0,
            422.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:20:17.100000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            205.0,
            60.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:17.100000",
        "id": 23,
        "className": "Person",
        coords: [
            468.0,
            237.0,
            542.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:17.200000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            193.0,
            177.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:17.300000",
        "id": 29,
        "className": "Person",
        coords: [
            921.0,
            277.0,
            981.0,
            416.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:20:17.400000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            207.0,
            60.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:17.500000",
        "id": 23,
        "className": "Person",
        coords: [
            471.0,
            239.0,
            544.0,
            329.0
        ],
        "status": "Moving",
        "speed": 42.42,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:17.500000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            193.0,
            178.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:17.600000",
        "id": 29,
        "className": "Person",
        coords: [
            921.0,
            276.0,
            978.0,
            408.0
        ],
        "status": "Moving",
        "speed": 67.08,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:20:17.700000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            208.0,
            60.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:17.800000",
        "id": 23,
        "className": "Person",
        coords: [
            472.0,
            240.0,
            544.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:17.900000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            194.0,
            178.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:17.900000",
        "id": 29,
        "className": "Person",
        coords: [
            924.0,
            276.0,
            971.0,
            383.0
        ],
        "status": "Moving",
        "speed": 197.28,
        "hardhat": "Analysing",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:18.100000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            209.0,
            59.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:18.200000",
        "id": 23,
        "className": "Person",
        coords: [
            473.0,
            240.0,
            544.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:18.300000",
        "id": 22,
        "className": "Person",
        coords: [
            143.0,
            194.0,
            178.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:18.300000",
        "id": 29,
        "className": "Person",
        coords: [
            926.0,
            275.0,
            970.0,
            375.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "Analysing",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:18.500000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            209.0,
            59.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:18.500000",
        "id": 23,
        "className": "Person",
        coords: [
            473.0,
            240.0,
            544.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:18.600000",
        "id": 22,
        "className": "Person",
        coords: [
            143.0,
            194.0,
            178.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:18.700000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            210.0,
            59.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:18.800000",
        "id": 23,
        "className": "Person",
        coords: [
            473.0,
            240.0,
            543.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:18.800000",
        "id": 22,
        "className": "Person",
        coords: [
            143.0,
            194.0,
            178.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:18.900000",
        "id": 29,
        "className": "Person",
        coords: [
            928.0,
            274.0,
            972.0,
            374.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:19.100000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            210.0,
            59.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:19.100000",
        "id": 23,
        "className": "Person",
        coords: [
            472.0,
            240.0,
            542.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:19.200000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            194.0,
            177.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:19.300000",
        "id": 29,
        "className": "Person",
        coords: [
            927.0,
            273.0,
            972.0,
            373.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:19.300000",
        "id": 21,
        "className": "Person",
        coords: [
            331.0,
            532.0,
            462.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:19.500000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            210.0,
            58.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:19.600000",
        "id": 23,
        "className": "Person",
        coords: [
            473.0,
            240.0,
            543.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:19.600000",
        "id": 22,
        "className": "Person",
        coords: [
            143.0,
            194.0,
            178.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:19.700000",
        "id": 21,
        "className": "Person",
        coords: [
            334.0,
            532.0,
            460.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:19.900000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            209.0,
            58.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:19.900000",
        "id": 23,
        "className": "Person",
        coords: [
            473.0,
            238.0,
            544.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:20",
        "id": 22,
        "className": "Person",
        coords: [
            143.0,
            194.0,
            178.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:20.100000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            209.0,
            58.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:20.200000",
        "id": 23,
        "className": "Person",
        coords: [
            476.0,
            237.0,
            546.0,
            328.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:20.300000",
        "id": 22,
        "className": "Person",
        coords: [
            143.0,
            194.0,
            178.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:20.300000",
        "id": 29,
        "className": "Person",
        coords: [
            914.0,
            269.0,
            982.0,
            423.0
        ],
        "status": "Moving",
        "speed": 345.3,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:20.500000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            209.0,
            58.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:20.600000",
        "id": 23,
        "className": "Person",
        coords: [
            478.0,
            237.0,
            547.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:20.600000",
        "id": 22,
        "className": "Person",
        coords: [
            143.0,
            194.0,
            178.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:20.700000",
        "id": 29,
        "className": "Person",
        coords: [
            913.0,
            268.0,
            982.0,
            429.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:20.800000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            209.0,
            58.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:20.900000",
        "id": 23,
        "className": "Person",
        coords: [
            481.0,
            236.0,
            551.0,
            330.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:20.900000",
        "id": 22,
        "className": "Person",
        coords: [
            143.0,
            194.0,
            178.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:21.100000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            209.0,
            58.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:21.200000",
        "id": 23,
        "className": "Person",
        coords: [
            485.0,
            236.0,
            554.0,
            331.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:21.200000",
        "id": 22,
        "className": "Person",
        coords: [
            143.0,
            194.0,
            178.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:21.300000",
        "id": 21,
        "className": "Person",
        coords: [
            337.0,
            532.0,
            458.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:21.400000",
        "id": 29,
        "className": "Person",
        coords: [
            915.0,
            268.0,
            973.0,
            400.0
        ],
        "status": "Moving",
        "speed": 214.75,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:21.600000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            209.0,
            57.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:21.600000",
        "id": 23,
        "className": "Person",
        coords: [
            487.0,
            237.0,
            554.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:21.700000",
        "id": 22,
        "className": "Person",
        coords: [
            143.0,
            194.0,
            177.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:21.800000",
        "id": 21,
        "className": "Person",
        coords: [
            338.0,
            532.0,
            457.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:21.800000",
        "id": 29,
        "className": "Person",
        coords: [
            915.0,
            267.0,
            969.0,
            390.0
        ],
        "status": "Moving",
        "speed": 94.86,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:22",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            209.0,
            57.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:22",
        "id": 23,
        "className": "Person",
        coords: [
            489.0,
            239.0,
            555.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:22.100000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            194.0,
            177.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:22.200000",
        "id": 21,
        "className": "Person",
        coords: [
            339.0,
            533.0,
            456.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:22.200000",
        "id": 29,
        "className": "Person",
        coords: [
            913.0,
            268.0,
            966.0,
            388.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:22.400000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            209.0,
            57.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:22.400000",
        "id": 23,
        "className": "Person",
        coords: [
            490.0,
            238.0,
            556.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:22.500000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            194.0,
            177.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:22.600000",
        "id": 21,
        "className": "Person",
        coords: [
            340.0,
            533.0,
            455.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:22.600000",
        "id": 29,
        "className": "Person",
        coords: [
            917.0,
            267.0,
            963.0,
            371.0
        ],
        "status": "Moving",
        "speed": 135.82,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:22.700000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            208.0,
            58.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:22.800000",
        "id": 23,
        "className": "Person",
        coords: [
            486.0,
            237.0,
            551.0,
            325.0
        ],
        "status": "Moving",
        "speed": 80.77,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:22.800000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            194.0,
            177.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:22.900000",
        "id": 21,
        "className": "Person",
        coords: [
            341.0,
            533.0,
            454.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:23",
        "id": 29,
        "className": "Person",
        coords: [
            917.0,
            267.0,
            959.0,
            363.0
        ],
        "status": "Moving",
        "speed": 67.08,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:23.300000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            207.0,
            59.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:23.300000",
        "id": 23,
        "className": "Person",
        coords: [
            485.0,
            236.0,
            550.0,
            323.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:23.400000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            194.0,
            177.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:23.500000",
        "id": 21,
        "className": "Person",
        coords: [
            342.0,
            533.0,
            454.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:23.500000",
        "id": 29,
        "className": "Person",
        coords: [
            911.0,
            267.0,
            959.0,
            378.0
        ],
        "status": "Moving",
        "speed": 114.23,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:23.700000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            207.0,
            59.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:23.800000",
        "id": 23,
        "className": "Person",
        coords: [
            483.0,
            236.0,
            550.0,
            325.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:23.900000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            194.0,
            177.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:24",
        "id": 21,
        "className": "Person",
        coords: [
            343.0,
            533.0,
            454.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:24.200000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            207.0,
            59.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:24.200000",
        "id": 23,
        "className": "Person",
        coords: [
            483.0,
            235.0,
            550.0,
            324.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:24.300000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            194.0,
            177.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:24.400000",
        "id": 21,
        "className": "Person",
        coords: [
            344.0,
            533.0,
            454.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:24.600000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            207.0,
            59.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:24.600000",
        "id": 23,
        "className": "Person",
        coords: [
            480.0,
            235.0,
            551.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:24.700000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            194.0,
            177.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:24.800000",
        "id": 21,
        "className": "Person",
        coords: [
            344.0,
            533.0,
            454.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:24.800000",
        "id": 29,
        "className": "Person",
        coords: [
            904.0,
            269.0,
            948.0,
            375.0
        ],
        "status": "Moving",
        "speed": 134.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:25",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            206.0,
            59.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:25.100000",
        "id": 23,
        "className": "Person",
        coords: [
            480.0,
            234.0,
            553.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:25.200000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            194.0,
            177.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:25.200000",
        "id": 21,
        "className": "Person",
        coords: [
            344.0,
            533.0,
            453.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:25.400000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            207.0,
            59.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:25.400000",
        "id": 23,
        "className": "Person",
        coords: [
            482.0,
            235.0,
            556.0,
            329.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:25.500000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            194.0,
            177.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:25.600000",
        "id": 21,
        "className": "Person",
        coords: [
            344.0,
            533.0,
            452.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:25.800000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            207.0,
            59.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:25.800000",
        "id": 23,
        "className": "Person",
        coords: [
            484.0,
            235.0,
            557.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:25.900000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            194.0,
            177.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:26",
        "id": 21,
        "className": "Person",
        coords: [
            344.0,
            533.0,
            452.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:26.100000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            207.0,
            59.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:26.200000",
        "id": 23,
        "className": "Person",
        coords: [
            484.0,
            235.0,
            557.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:26.300000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            194.0,
            178.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:26.300000",
        "id": 21,
        "className": "Person",
        coords: [
            344.0,
            533.0,
            452.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:26.500000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            207.0,
            59.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:26.600000",
        "id": 23,
        "className": "Person",
        coords: [
            489.0,
            239.0,
            559.0,
            327.0
        ],
        "status": "Moving",
        "speed": 67.08,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:26.600000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            194.0,
            178.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:26.800000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            207.0,
            59.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:26.900000",
        "id": 23,
        "className": "Person",
        coords: [
            492.0,
            242.0,
            561.0,
            328.0
        ],
        "status": "Moving",
        "speed": 42.42,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:26.900000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            194.0,
            178.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:27",
        "id": 21,
        "className": "Person",
        coords: [
            345.0,
            532.0,
            453.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:27.100000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            207.0,
            59.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:27.100000",
        "id": 23,
        "className": "Person",
        coords: [
            494.0,
            242.0,
            565.0,
            330.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:27.200000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            194.0,
            178.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:27.300000",
        "id": 21,
        "className": "Person",
        coords: [
            345.0,
            531.0,
            453.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:27.400000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            207.0,
            59.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:27.400000",
        "id": 23,
        "className": "Person",
        coords: [
            504.0,
            242.0,
            573.0,
            331.0
        ],
        "status": "Moving",
        "speed": 134.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:27.500000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            194.0,
            178.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:27.500000",
        "id": 21,
        "className": "Person",
        coords: [
            345.0,
            531.0,
            453.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:27.700000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            207.0,
            59.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:27.700000",
        "id": 23,
        "className": "Person",
        coords: [
            508.0,
            242.0,
            579.0,
            335.0
        ],
        "status": "Moving",
        "speed": 80.77,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:27.800000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            194.0,
            178.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:27.800000",
        "id": 21,
        "className": "Person",
        coords: [
            345.0,
            531.0,
            453.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:27.800000",
        "id": 26,
        "className": "Person",
        coords: [
            229.0,
            215.0,
            267.0,
            298.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:28",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            207.0,
            59.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:28",
        "id": 23,
        "className": "Person",
        coords: [
            510.0,
            242.0,
            582.0,
            336.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:28.100000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            194.0,
            178.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:28.100000",
        "id": 21,
        "className": "Person",
        coords: [
            345.0,
            531.0,
            453.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:28.100000",
        "id": 26,
        "className": "Person",
        coords: [
            230.0,
            215.0,
            268.0,
            298.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:28.300000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            207.0,
            59.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:28.300000",
        "id": 23,
        "className": "Person",
        coords: [
            511.0,
            242.0,
            585.0,
            339.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:28.400000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            194.0,
            177.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:28.400000",
        "id": 21,
        "className": "Person",
        coords: [
            345.0,
            531.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:28.500000",
        "id": 26,
        "className": "Person",
        coords: [
            231.0,
            217.0,
            267.0,
            295.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:28.600000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            208.0,
            59.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:28.600000",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            242.0,
            586.0,
            341.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:28.700000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            193.0,
            177.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:28.800000",
        "id": 21,
        "className": "Person",
        coords: [
            345.0,
            531.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:28.800000",
        "id": 26,
        "className": "Person",
        coords: [
            231.0,
            218.0,
            267.0,
            294.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:28.900000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            208.0,
            59.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:29",
        "id": 23,
        "className": "Person",
        coords: [
            513.0,
            242.0,
            586.0,
            341.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:29",
        "id": 22,
        "className": "Person",
        coords: [
            143.0,
            193.0,
            178.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:29.100000",
        "id": 21,
        "className": "Person",
        coords: [
            345.0,
            531.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:29.100000",
        "id": 26,
        "className": "Person",
        coords: [
            232.0,
            219.0,
            267.0,
            294.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:29.200000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            208.0,
            59.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:29.300000",
        "id": 23,
        "className": "Person",
        coords: [
            514.0,
            243.0,
            587.0,
            341.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:29.300000",
        "id": 22,
        "className": "Person",
        coords: [
            143.0,
            193.0,
            178.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:29.400000",
        "id": 21,
        "className": "Person",
        coords: [
            345.0,
            531.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:29.500000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            207.0,
            60.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:29.600000",
        "id": 23,
        "className": "Person",
        coords: [
            515.0,
            243.0,
            587.0,
            342.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:29.700000",
        "id": 22,
        "className": "Person",
        coords: [
            143.0,
            193.0,
            178.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:29.700000",
        "id": 21,
        "className": "Person",
        coords: [
            345.0,
            530.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:29.800000",
        "id": 26,
        "className": "Person",
        coords: [
            232.0,
            219.0,
            268.0,
            294.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:30",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            207.0,
            59.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:30",
        "id": 23,
        "className": "Person",
        coords: [
            515.0,
            243.0,
            586.0,
            341.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:30.100000",
        "id": 22,
        "className": "Person",
        coords: [
            143.0,
            194.0,
            177.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:30.200000",
        "id": 21,
        "className": "Person",
        coords: [
            345.0,
            530.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:30.300000",
        "id": 26,
        "className": "Person",
        coords: [
            232.0,
            219.0,
            268.0,
            294.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:30.400000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            207.0,
            60.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:30.500000",
        "id": 23,
        "className": "Person",
        coords: [
            517.0,
            243.0,
            586.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:30.500000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            194.0,
            177.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:30.600000",
        "id": 21,
        "className": "Person",
        coords: [
            345.0,
            530.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:30.800000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            207.0,
            60.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:30.800000",
        "id": 23,
        "className": "Person",
        coords: [
            519.0,
            244.0,
            585.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:30.900000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            194.0,
            176.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:31",
        "id": 21,
        "className": "Person",
        coords: [
            345.0,
            530.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:31",
        "id": 26,
        "className": "Person",
        coords: [
            232.0,
            219.0,
            268.0,
            294.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:31.200000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            207.0,
            60.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:31.300000",
        "id": 23,
        "className": "Person",
        coords: [
            520.0,
            244.0,
            585.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:31.300000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            194.0,
            175.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:31.400000",
        "id": 21,
        "className": "Person",
        coords: [
            345.0,
            531.0,
            451.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:31.400000",
        "id": 26,
        "className": "Person",
        coords: [
            232.0,
            218.0,
            268.0,
            295.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:31.600000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            206.0,
            60.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:31.700000",
        "id": 23,
        "className": "Person",
        coords: [
            521.0,
            244.0,
            585.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:31.700000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            194.0,
            176.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:31.800000",
        "id": 21,
        "className": "Person",
        coords: [
            345.0,
            531.0,
            451.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:31.900000",
        "id": 26,
        "className": "Person",
        coords: [
            227.0,
            211.0,
            267.0,
            296.0
        ],
        "status": "Moving",
        "speed": 63.63,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:32",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            207.0,
            60.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:32.100000",
        "id": 23,
        "className": "Person",
        coords: [
            520.0,
            244.0,
            584.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:32.100000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            194.0,
            176.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:32.200000",
        "id": 21,
        "className": "Person",
        coords: [
            347.0,
            531.0,
            449.0,
            710.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:32.300000",
        "id": 26,
        "className": "Person",
        coords: [
            228.0,
            210.0,
            268.0,
            297.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:32.400000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            207.0,
            60.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:32.500000",
        "id": 23,
        "className": "Person",
        coords: [
            520.0,
            245.0,
            584.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:32.600000",
        "id": 22,
        "className": "Person",
        coords: [
            143.0,
            195.0,
            177.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:32.600000",
        "id": 21,
        "className": "Person",
        coords: [
            349.0,
            531.0,
            447.0,
            702.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:32.700000",
        "id": 26,
        "className": "Person",
        coords: [
            228.0,
            210.0,
            269.0,
            297.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:32.800000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            207.0,
            59.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:32.900000",
        "id": 23,
        "className": "Person",
        coords: [
            518.0,
            245.0,
            582.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:32.900000",
        "id": 22,
        "className": "Person",
        coords: [
            143.0,
            194.0,
            177.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:33",
        "id": 26,
        "className": "Person",
        coords: [
            228.0,
            209.0,
            269.0,
            297.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:33",
        "id": 30,
        "className": "Person",
        coords: [
            821.0,
            253.0,
            869.0,
            364.0
        ],
        "status": "First Seen",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:20:33.200000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            207.0,
            59.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:33.300000",
        "id": 23,
        "className": "Person",
        coords: [
            516.0,
            245.0,
            581.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:33.300000",
        "id": 22,
        "className": "Person",
        coords: [
            143.0,
            194.0,
            177.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:33.400000",
        "id": 26,
        "className": "Person",
        coords: [
            228.0,
            209.0,
            269.0,
            297.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:33.500000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            207.0,
            59.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:33.500000",
        "id": 23,
        "className": "Person",
        coords: [
            515.0,
            245.0,
            580.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:33.600000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            194.0,
            177.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:33.700000",
        "id": 26,
        "className": "Person",
        coords: [
            228.0,
            208.0,
            268.0,
            297.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:33.800000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            207.0,
            58.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:33.800000",
        "id": 23,
        "className": "Person",
        coords: [
            514.0,
            245.0,
            580.0,
            342.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:33.900000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            194.0,
            176.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:33.900000",
        "id": 26,
        "className": "Person",
        coords: [
            229.0,
            212.0,
            267.0,
            298.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:34",
        "id": 21,
        "className": "Person",
        coords: [
            344.0,
            532.0,
            449.0,
            714.0
        ],
        "status": "Moving",
        "speed": 109.19,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:34.200000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            207.0,
            57.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:34.200000",
        "id": 23,
        "className": "Person",
        coords: [
            514.0,
            246.0,
            581.0,
            342.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:34.300000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            194.0,
            176.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:34.300000",
        "id": 26,
        "className": "Person",
        coords: [
            230.0,
            214.0,
            267.0,
            297.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:34.400000",
        "id": 21,
        "className": "Person",
        coords: [
            344.0,
            532.0,
            450.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:34.600000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            207.0,
            57.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:34.600000",
        "id": 23,
        "className": "Person",
        coords: [
            514.0,
            246.0,
            581.0,
            342.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:34.700000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            194.0,
            176.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:34.800000",
        "id": 26,
        "className": "Person",
        coords: [
            230.0,
            216.0,
            267.0,
            297.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:34.900000",
        "id": 21,
        "className": "Person",
        coords: [
            344.0,
            532.0,
            450.0,
            715.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:35.100000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            206.0,
            58.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:35.100000",
        "id": 23,
        "className": "Person",
        coords: [
            514.0,
            246.0,
            581.0,
            342.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:35.200000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            176.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:35.300000",
        "id": 21,
        "className": "Person",
        coords: [
            344.0,
            531.0,
            448.0,
            710.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:35.400000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            206.0,
            58.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:35.400000",
        "id": 23,
        "className": "Person",
        coords: [
            515.0,
            247.0,
            581.0,
            342.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:35.500000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:35.600000",
        "id": 21,
        "className": "Person",
        coords: [
            340.0,
            531.0,
            447.0,
            713.0
        ],
        "status": "Moving",
        "speed": 54.08,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:35.600000",
        "id": 26,
        "className": "Person",
        coords: [
            230.0,
            216.0,
            267.0,
            297.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:35.700000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            206.0,
            58.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:35.800000",
        "id": 23,
        "className": "Person",
        coords: [
            516.0,
            247.0,
            583.0,
            342.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:35.800000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:35.900000",
        "id": 21,
        "className": "Person",
        coords: [
            340.0,
            531.0,
            448.0,
            715.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:36",
        "id": 26,
        "className": "Person",
        coords: [
            231.0,
            216.0,
            267.0,
            296.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:36.100000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            206.0,
            58.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:36.100000",
        "id": 23,
        "className": "Person",
        coords: [
            517.0,
            247.0,
            585.0,
            344.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:36.200000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:36.300000",
        "id": 21,
        "className": "Person",
        coords: [
            330.0,
            531.0,
            441.0,
            715.0
        ],
        "status": "Moving",
        "speed": 134.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:36.300000",
        "id": 26,
        "className": "Person",
        coords: [
            230.0,
            215.0,
            267.0,
            296.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:36.500000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            206.0,
            58.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:36.500000",
        "id": 23,
        "className": "Person",
        coords: [
            518.0,
            247.0,
            586.0,
            343.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:36.600000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:36.600000",
        "id": 21,
        "className": "Person",
        coords: [
            331.0,
            532.0,
            443.0,
            714.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:36.700000",
        "id": 26,
        "className": "Person",
        coords: [
            230.0,
            214.0,
            267.0,
            296.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:36.700000",
        "id": 31,
        "className": "Person",
        coords: [
            674.0,
            450.0,
            827.0,
            600.0
        ],
        "status": "First Seen",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:20:36.900000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            206.0,
            58.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:36.900000",
        "id": 23,
        "className": "Person",
        coords: [
            520.0,
            248.0,
            588.0,
            344.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:37",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:37.100000",
        "id": 21,
        "className": "Person",
        coords: [
            336.0,
            532.0,
            449.0,
            717.0
        ],
        "status": "Moving",
        "speed": 76.48,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:37.100000",
        "id": 26,
        "className": "Person",
        coords: [
            230.0,
            213.0,
            268.0,
            297.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:37.200000",
        "id": 31,
        "className": "Person",
        coords: [
            674.0,
            450.0,
            829.0,
            601.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:20:37.300000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            206.0,
            58.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:37.400000",
        "id": 23,
        "className": "Person",
        coords: [
            525.0,
            248.0,
            592.0,
            344.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:37.500000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:37.500000",
        "id": 21,
        "className": "Person",
        coords: [
            339.0,
            533.0,
            451.0,
            717.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:37.600000",
        "id": 26,
        "className": "Person",
        coords: [
            229.0,
            211.0,
            268.0,
            296.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:37.700000",
        "id": 31,
        "className": "Person",
        coords: [
            674.0,
            449.0,
            830.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:20:37.800000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            207.0,
            58.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:37.900000",
        "id": 23,
        "className": "Person",
        coords: [
            523.0,
            249.0,
            590.0,
            344.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:38",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:38",
        "id": 21,
        "className": "Person",
        coords: [
            341.0,
            534.0,
            452.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:38.100000",
        "id": 26,
        "className": "Person",
        coords: [
            222.0,
            207.0,
            264.0,
            298.0
        ],
        "status": "Moving",
        "speed": 76.48,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:38.200000",
        "id": 31,
        "className": "Person",
        coords: [
            674.0,
            450.0,
            829.0,
            601.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:20:38.300000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            207.0,
            58.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:38.400000",
        "id": 23,
        "className": "Person",
        coords: [
            524.0,
            250.0,
            592.0,
            345.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:38.500000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:38.500000",
        "id": 21,
        "className": "Person",
        coords: [
            341.0,
            536.0,
            452.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:38.600000",
        "id": 31,
        "className": "Person",
        coords: [
            675.0,
            450.0,
            829.0,
            600.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:38.700000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            207.0,
            58.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:38.800000",
        "id": 23,
        "className": "Person",
        coords: [
            525.0,
            250.0,
            594.0,
            346.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:38.800000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            177.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:38.900000",
        "id": 21,
        "className": "Person",
        coords: [
            342.0,
            536.0,
            453.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:38.900000",
        "id": 31,
        "className": "Person",
        coords: [
            676.0,
            450.0,
            830.0,
            601.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:39.100000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            207.0,
            58.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:39.100000",
        "id": 23,
        "className": "Person",
        coords: [
            523.0,
            250.0,
            594.0,
            346.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:39.200000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            177.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:39.200000",
        "id": 21,
        "className": "Person",
        coords: [
            342.0,
            537.0,
            453.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:39.300000",
        "id": 31,
        "className": "Person",
        coords: [
            659.0,
            450.0,
            817.0,
            602.0
        ],
        "status": "Moving",
        "speed": 225.48,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:39.400000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            207.0,
            58.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:39.500000",
        "id": 23,
        "className": "Person",
        coords: [
            524.0,
            252.0,
            594.0,
            346.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:39.500000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            176.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:39.600000",
        "id": 21,
        "className": "Person",
        coords: [
            342.0,
            537.0,
            453.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:39.600000",
        "id": 31,
        "className": "Person",
        coords: [
            653.0,
            449.0,
            813.0,
            602.0
        ],
        "status": "Moving",
        "speed": 76.48,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:39.700000",
        "id": 32,
        "className": "Person",
        coords: [
            747.0,
            252.0,
            794.0,
            355.0
        ],
        "status": "First Seen",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:20:39.800000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            208.0,
            58.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:39.900000",
        "id": 23,
        "className": "Person",
        coords: [
            524.0,
            254.0,
            594.0,
            346.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:39.900000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:40",
        "id": 21,
        "className": "Person",
        coords: [
            332.0,
            537.0,
            446.0,
            716.0
        ],
        "status": "Moving",
        "speed": 119.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:40",
        "id": 32,
        "className": "Person",
        coords: [
            742.0,
            248.0,
            791.0,
            356.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:20:40.100000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            208.0,
            58.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:40.200000",
        "id": 23,
        "className": "Person",
        coords: [
            524.0,
            255.0,
            594.0,
            346.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:40.200000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:40.300000",
        "id": 21,
        "className": "Person",
        coords: [
            333.0,
            537.0,
            448.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:40.400000",
        "id": 32,
        "className": "Person",
        coords: [
            737.0,
            246.0,
            787.0,
            354.0
        ],
        "status": "Moving",
        "speed": 67.08,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:20:40.400000",
        "id": 31,
        "className": "Person",
        coords: [
            664.0,
            449.0,
            825.0,
            602.0
        ],
        "status": "Moving",
        "speed": 164.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:40.500000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            209.0,
            57.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:40.600000",
        "id": 23,
        "className": "Person",
        coords: [
            523.0,
            256.0,
            594.0,
            346.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:40.600000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            193.0,
            177.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:40.700000",
        "id": 21,
        "className": "Person",
        coords: [
            332.0,
            537.0,
            448.0,
            715.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:40.800000",
        "id": 32,
        "className": "Person",
        coords: [
            732.0,
            245.0,
            782.0,
            354.0
        ],
        "status": "Moving",
        "speed": 76.48,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:20:40.800000",
        "id": 31,
        "className": "Person",
        coords: [
            664.0,
            449.0,
            826.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:41",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            209.0,
            57.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:41",
        "id": 23,
        "className": "Person",
        coords: [
            523.0,
            256.0,
            595.0,
            346.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:41.100000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            193.0,
            177.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:41.100000",
        "id": 21,
        "className": "Person",
        coords: [
            331.0,
            537.0,
            449.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:41.200000",
        "id": 32,
        "className": "Person",
        coords: [
            727.0,
            245.0,
            778.0,
            353.0
        ],
        "status": "Moving",
        "speed": 74.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:41.200000",
        "id": 31,
        "className": "Person",
        coords: [
            663.0,
            449.0,
            825.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:41.400000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            209.0,
            58.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:41.400000",
        "id": 23,
        "className": "Person",
        coords: [
            522.0,
            256.0,
            595.0,
            346.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:41.500000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            193.0,
            177.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:41.500000",
        "id": 21,
        "className": "Person",
        coords: [
            330.0,
            537.0,
            450.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:41.600000",
        "id": 32,
        "className": "Person",
        coords: [
            722.0,
            245.0,
            773.0,
            354.0
        ],
        "status": "Moving",
        "speed": 74.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:41.600000",
        "id": 31,
        "className": "Person",
        coords: [
            662.0,
            449.0,
            825.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:41.800000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            209.0,
            58.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:41.900000",
        "id": 23,
        "className": "Person",
        coords: [
            524.0,
            256.0,
            597.0,
            345.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:41.900000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            193.0,
            177.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:42",
        "id": 21,
        "className": "Person",
        coords: [
            333.0,
            537.0,
            453.0,
            716.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:42",
        "id": 32,
        "className": "Person",
        coords: [
            717.0,
            246.0,
            768.0,
            354.0
        ],
        "status": "Moving",
        "speed": 76.48,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:42.100000",
        "id": 31,
        "className": "Person",
        coords: [
            663.0,
            449.0,
            827.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:42.200000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            209.0,
            58.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:42.300000",
        "id": 23,
        "className": "Person",
        coords: [
            524.0,
            256.0,
            598.0,
            345.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:42.400000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            193.0,
            177.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:42.400000",
        "id": 21,
        "className": "Person",
        coords: [
            336.0,
            538.0,
            455.0,
            717.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:42.500000",
        "id": 32,
        "className": "Person",
        coords: [
            706.0,
            247.0,
            765.0,
            371.0
        ],
        "status": "Moving",
        "speed": 171.01,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:42.500000",
        "id": 31,
        "className": "Person",
        coords: [
            661.0,
            448.0,
            826.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:42.700000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            209.0,
            58.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:42.700000",
        "id": 23,
        "className": "Person",
        coords: [
            523.0,
            255.0,
            598.0,
            345.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:42.800000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            193.0,
            177.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:42.800000",
        "id": 21,
        "className": "Person",
        coords: [
            341.0,
            538.0,
            458.0,
            716.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:42.900000",
        "id": 32,
        "className": "Person",
        coords: [
            704.0,
            249.0,
            758.0,
            363.0
        ],
        "status": "Moving",
        "speed": 74.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:43",
        "id": 31,
        "className": "Person",
        coords: [
            662.0,
            448.0,
            827.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:43.100000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            209.0,
            58.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:43.200000",
        "id": 23,
        "className": "Person",
        coords: [
            522.0,
            254.0,
            598.0,
            346.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:43.200000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            193.0,
            177.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:43.300000",
        "id": 21,
        "className": "Person",
        coords: [
            342.0,
            538.0,
            459.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:43.300000",
        "id": 32,
        "className": "Person",
        coords: [
            701.0,
            255.0,
            756.0,
            370.0
        ],
        "status": "Moving",
        "speed": 100.61,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:43.400000",
        "id": 31,
        "className": "Person",
        coords: [
            659.0,
            448.0,
            825.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:43.500000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            209.0,
            58.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:43.600000",
        "id": 23,
        "className": "Person",
        coords: [
            521.0,
            254.0,
            597.0,
            346.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:43.600000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            193.0,
            177.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:43.700000",
        "id": 21,
        "className": "Person",
        coords: [
            343.0,
            538.0,
            459.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:43.700000",
        "id": 32,
        "className": "Person",
        coords: [
            701.0,
            258.0,
            751.0,
            361.0
        ],
        "status": "Moving",
        "speed": 54.08,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:43.800000",
        "id": 31,
        "className": "Person",
        coords: [
            656.0,
            448.0,
            824.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:43.900000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            209.0,
            58.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:44",
        "id": 23,
        "className": "Person",
        coords: [
            519.0,
            253.0,
            597.0,
            346.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:44",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            193.0,
            177.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:44.100000",
        "id": 21,
        "className": "Person",
        coords: [
            343.0,
            537.0,
            458.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:44.100000",
        "id": 32,
        "className": "Person",
        coords: [
            693.0,
            253.0,
            752.0,
            377.0
        ],
        "status": "Moving",
        "speed": 108.16,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:44.200000",
        "id": 31,
        "className": "Person",
        coords: [
            657.0,
            448.0,
            826.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:44.300000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            209.0,
            59.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:44.400000",
        "id": 23,
        "className": "Person",
        coords: [
            518.0,
            252.0,
            596.0,
            346.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:44.400000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            193.0,
            177.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:44.500000",
        "id": 21,
        "className": "Person",
        coords: [
            343.0,
            536.0,
            459.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:44.500000",
        "id": 32,
        "className": "Person",
        coords: [
            689.0,
            248.0,
            751.0,
            381.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:44.600000",
        "id": 31,
        "className": "Person",
        coords: [
            652.0,
            448.0,
            824.0,
            603.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:44.700000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            209.0,
            59.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:44.800000",
        "id": 23,
        "className": "Person",
        coords: [
            516.0,
            251.0,
            595.0,
            346.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:44.800000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            193.0,
            176.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:44.900000",
        "id": 21,
        "className": "Person",
        coords: [
            345.0,
            535.0,
            460.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:45",
        "id": 31,
        "className": "Person",
        coords: [
            650.0,
            447.0,
            824.0,
            604.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:45.100000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            209.0,
            59.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:45.200000",
        "id": 23,
        "className": "Person",
        coords: [
            515.0,
            251.0,
            593.0,
            346.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:45.200000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            193.0,
            176.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:45.300000",
        "id": 21,
        "className": "Person",
        coords: [
            346.0,
            535.0,
            460.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:45.300000",
        "id": 31,
        "className": "Person",
        coords: [
            649.0,
            447.0,
            824.0,
            604.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:45.500000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            209.0,
            59.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:45.500000",
        "id": 23,
        "className": "Person",
        coords: [
            514.0,
            250.0,
            592.0,
            345.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:45.600000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            194.0,
            176.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:45.600000",
        "id": 21,
        "className": "Person",
        coords: [
            347.0,
            535.0,
            460.0,
            715.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:45.700000",
        "id": 31,
        "className": "Person",
        coords: [
            648.0,
            447.0,
            825.0,
            604.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:45.700000",
        "id": 32,
        "className": "Person",
        coords: [
            679.0,
            247.0,
            733.0,
            362.0
        ],
        "status": "Moving",
        "speed": 258.05,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:45.900000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            210.0,
            59.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:45.900000",
        "id": 23,
        "className": "Person",
        coords: [
            513.0,
            251.0,
            590.0,
            345.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:46",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            176.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:46",
        "id": 21,
        "className": "Person",
        coords: [
            331.0,
            534.0,
            449.0,
            717.0
        ],
        "status": "Moving",
        "speed": 194.98,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:46.100000",
        "id": 31,
        "className": "Person",
        coords: [
            647.0,
            447.0,
            825.0,
            604.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:46.100000",
        "id": 32,
        "className": "Person",
        coords: [
            675.0,
            247.0,
            729.0,
            360.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:46.300000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            210.0,
            59.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:46.300000",
        "id": 23,
        "className": "Person",
        coords: [
            513.0,
            251.0,
            589.0,
            345.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:46.400000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            175.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:46.400000",
        "id": 21,
        "className": "Person",
        coords: [
            340.0,
            534.0,
            457.0,
            717.0
        ],
        "status": "Moving",
        "speed": 119.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:46.500000",
        "id": 31,
        "className": "Person",
        coords: [
            646.0,
            447.0,
            825.0,
            604.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:46.500000",
        "id": 32,
        "className": "Person",
        coords: [
            671.0,
            248.0,
            725.0,
            358.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:46.700000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            209.0,
            59.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:46.700000",
        "id": 23,
        "className": "Person",
        coords: [
            513.0,
            251.0,
            589.0,
            345.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:46.800000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            176.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:46.800000",
        "id": 21,
        "className": "Person",
        coords: [
            344.0,
            533.0,
            460.0,
            718.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:46.900000",
        "id": 31,
        "className": "Person",
        coords: [
            646.0,
            447.0,
            826.0,
            604.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:47",
        "id": 32,
        "className": "Person",
        coords: [
            672.0,
            250.0,
            724.0,
            359.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:47.100000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            210.0,
            59.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:47.200000",
        "id": 23,
        "className": "Person",
        coords: [
            513.0,
            251.0,
            589.0,
            345.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:47.200000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            176.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:47.300000",
        "id": 21,
        "className": "Person",
        coords: [
            345.0,
            533.0,
            460.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:47.400000",
        "id": 31,
        "className": "Person",
        coords: [
            645.0,
            447.0,
            826.0,
            604.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:47.400000",
        "id": 32,
        "className": "Person",
        coords: [
            669.0,
            249.0,
            722.0,
            360.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:47.600000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            209.0,
            59.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:47.600000",
        "id": 23,
        "className": "Person",
        coords: [
            513.0,
            251.0,
            588.0,
            345.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:47.700000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            176.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:47.700000",
        "id": 21,
        "className": "Person",
        coords: [
            345.0,
            532.0,
            459.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:47.800000",
        "id": 31,
        "className": "Person",
        coords: [
            645.0,
            447.0,
            827.0,
            604.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:47.800000",
        "id": 32,
        "className": "Person",
        coords: [
            666.0,
            249.0,
            719.0,
            361.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:48",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            210.0,
            59.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:48",
        "id": 23,
        "className": "Person",
        coords: [
            513.0,
            251.0,
            588.0,
            345.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:48.100000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            176.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:48.100000",
        "id": 21,
        "className": "Person",
        coords: [
            345.0,
            532.0,
            458.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:48.200000",
        "id": 31,
        "className": "Person",
        coords: [
            644.0,
            447.0,
            827.0,
            604.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:48.200000",
        "id": 32,
        "className": "Person",
        coords: [
            662.0,
            247.0,
            716.0,
            363.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:48.400000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            209.0,
            59.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:48.400000",
        "id": 23,
        "className": "Person",
        coords: [
            513.0,
            251.0,
            587.0,
            344.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:48.500000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            176.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:48.500000",
        "id": 21,
        "className": "Person",
        coords: [
            345.0,
            532.0,
            457.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:48.600000",
        "id": 31,
        "className": "Person",
        coords: [
            644.0,
            447.0,
            827.0,
            604.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:48.600000",
        "id": 32,
        "className": "Person",
        coords: [
            658.0,
            246.0,
            712.0,
            366.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:48.800000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            210.0,
            59.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:48.900000",
        "id": 23,
        "className": "Person",
        coords: [
            513.0,
            251.0,
            587.0,
            344.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:48.900000",
        "id": 22,
        "className": "Person",
        coords: [
            139.0,
            193.0,
            176.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:49",
        "id": 21,
        "className": "Person",
        coords: [
            346.0,
            532.0,
            456.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:49",
        "id": 31,
        "className": "Person",
        coords: [
            644.0,
            447.0,
            828.0,
            604.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:49.100000",
        "id": 32,
        "className": "Person",
        coords: [
            655.0,
            248.0,
            709.0,
            366.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:49.200000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            209.0,
            59.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:49.300000",
        "id": 23,
        "className": "Person",
        coords: [
            513.0,
            251.0,
            587.0,
            345.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:49.300000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            176.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:49.400000",
        "id": 21,
        "className": "Person",
        coords: [
            346.0,
            532.0,
            456.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:49.500000",
        "id": 31,
        "className": "Person",
        coords: [
            644.0,
            447.0,
            829.0,
            604.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:49.500000",
        "id": 32,
        "className": "Person",
        coords: [
            649.0,
            248.0,
            703.0,
            366.0
        ],
        "status": "Moving",
        "speed": 89.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:49.700000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            209.0,
            59.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:49.800000",
        "id": 23,
        "className": "Person",
        coords: [
            513.0,
            250.0,
            588.0,
            345.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:49.800000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            176.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:49.900000",
        "id": 21,
        "className": "Person",
        coords: [
            346.0,
            532.0,
            455.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:49.900000",
        "id": 31,
        "className": "Person",
        coords: [
            644.0,
            447.0,
            829.0,
            604.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:50",
        "id": 32,
        "className": "Person",
        coords: [
            643.0,
            247.0,
            699.0,
            369.0
        ],
        "status": "Moving",
        "speed": 76.48,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:50.200000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            209.0,
            59.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:50.200000",
        "id": 23,
        "className": "Person",
        coords: [
            513.0,
            249.0,
            588.0,
            345.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:50.300000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            176.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:50.300000",
        "id": 21,
        "className": "Person",
        coords: [
            345.0,
            533.0,
            454.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:50.400000",
        "id": 31,
        "className": "Person",
        coords: [
            645.0,
            447.0,
            830.0,
            604.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:50.400000",
        "id": 32,
        "className": "Person",
        coords: [
            638.0,
            249.0,
            691.0,
            367.0
        ],
        "status": "Moving",
        "speed": 104.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:50.600000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            209.0,
            59.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:50.600000",
        "id": 23,
        "className": "Person",
        coords: [
            514.0,
            249.0,
            588.0,
            345.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:50.700000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            176.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:50.700000",
        "id": 21,
        "className": "Person",
        coords: [
            345.0,
            533.0,
            454.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:50.800000",
        "id": 31,
        "className": "Person",
        coords: [
            646.0,
            447.0,
            830.0,
            604.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:50.800000",
        "id": 32,
        "className": "Person",
        coords: [
            634.0,
            250.0,
            685.0,
            365.0
        ],
        "status": "Moving",
        "speed": 76.48,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:51",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            208.0,
            59.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:51.100000",
        "id": 23,
        "className": "Person",
        coords: [
            514.0,
            249.0,
            587.0,
            345.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:51.100000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            176.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:51.200000",
        "id": 21,
        "className": "Person",
        coords: [
            345.0,
            533.0,
            453.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:51.200000",
        "id": 31,
        "className": "Person",
        coords: [
            646.0,
            447.0,
            831.0,
            604.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:51.300000",
        "id": 32,
        "className": "Person",
        coords: [
            628.0,
            250.0,
            679.0,
            364.0
        ],
        "status": "Moving",
        "speed": 89.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:51.400000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            208.0,
            59.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:51.500000",
        "id": 23,
        "className": "Person",
        coords: [
            514.0,
            250.0,
            587.0,
            345.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:51.500000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            176.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:51.600000",
        "id": 21,
        "className": "Person",
        coords: [
            345.0,
            533.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:51.600000",
        "id": 31,
        "className": "Person",
        coords: [
            647.0,
            447.0,
            831.0,
            604.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:51.700000",
        "id": 32,
        "className": "Person",
        coords: [
            623.0,
            256.0,
            672.0,
            365.0
        ],
        "status": "Moving",
        "speed": 100.61,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:51.700000",
        "id": 33,
        "className": "Person",
        coords: [
            1094.0,
            421.0,
            1184.0,
            624.0
        ],
        "status": "First Seen",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:20:51.900000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            207.0,
            59.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:51.900000",
        "id": 23,
        "className": "Person",
        coords: [
            516.0,
            250.0,
            587.0,
            345.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:52",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            176.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:52",
        "id": 21,
        "className": "Person",
        coords: [
            345.0,
            533.0,
            451.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:52.100000",
        "id": 31,
        "className": "Person",
        coords: [
            648.0,
            447.0,
            832.0,
            604.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:52.100000",
        "id": 32,
        "className": "Person",
        coords: [
            616.0,
            252.0,
            667.0,
            363.0
        ],
        "status": "Moving",
        "speed": 100.61,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:52.200000",
        "id": 33,
        "className": "Person",
        coords: [
            1092.0,
            420.0,
            1180.0,
            619.0
        ],
        "status": "Moving",
        "speed": 63.63,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:20:52.300000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            207.0,
            60.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:52.400000",
        "id": 23,
        "className": "Person",
        coords: [
            513.0,
            249.0,
            585.0,
            344.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:52.400000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            176.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:52.500000",
        "id": 21,
        "className": "Person",
        coords: [
            344.0,
            533.0,
            451.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:52.600000",
        "id": 31,
        "className": "Person",
        coords: [
            645.0,
            448.0,
            828.0,
            603.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:52.600000",
        "id": 32,
        "className": "Person",
        coords: [
            613.0,
            248.0,
            663.0,
            360.0
        ],
        "status": "Moving",
        "speed": 63.63,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:52.700000",
        "id": 33,
        "className": "Person",
        coords: [
            1083.0,
            420.0,
            1171.0,
            617.0
        ],
        "status": "Moving",
        "speed": 135.82,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:20:52.800000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            207.0,
            60.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:52.900000",
        "id": 23,
        "className": "Person",
        coords: [
            513.0,
            249.0,
            584.0,
            344.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:52.900000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            176.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:53",
        "id": 21,
        "className": "Person",
        coords: [
            344.0,
            533.0,
            451.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:53",
        "id": 31,
        "className": "Person",
        coords: [
            645.0,
            447.0,
            829.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:53.100000",
        "id": 32,
        "className": "Person",
        coords: [
            610.0,
            245.0,
            659.0,
            358.0
        ],
        "status": "Moving",
        "speed": 74.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:53.300000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            206.0,
            60.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:53.300000",
        "id": 23,
        "className": "Person",
        coords: [
            513.0,
            249.0,
            584.0,
            344.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:53.400000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            176.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:53.400000",
        "id": 21,
        "className": "Person",
        coords: [
            344.0,
            533.0,
            450.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:53.500000",
        "id": 31,
        "className": "Person",
        coords: [
            644.0,
            447.0,
            830.0,
            604.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:53.600000",
        "id": 32,
        "className": "Person",
        coords: [
            607.0,
            243.0,
            654.0,
            353.0
        ],
        "status": "Moving",
        "speed": 74.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:53.700000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            206.0,
            60.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:53.800000",
        "id": 23,
        "className": "Person",
        coords: [
            513.0,
            249.0,
            584.0,
            344.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:53.800000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            176.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:53.900000",
        "id": 21,
        "className": "Person",
        coords: [
            344.0,
            533.0,
            450.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:54",
        "id": 31,
        "className": "Person",
        coords: [
            644.0,
            447.0,
            830.0,
            604.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:54",
        "id": 32,
        "className": "Person",
        coords: [
            600.0,
            243.0,
            649.0,
            355.0
        ],
        "status": "Moving",
        "speed": 91.23,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:54.100000",
        "id": 33,
        "className": "Person",
        coords: [
            1054.0,
            425.0,
            1143.0,
            622.0
        ],
        "status": "Moving",
        "speed": 441.38,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:20:54.200000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            206.0,
            60.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:54.300000",
        "id": 23,
        "className": "Person",
        coords: [
            514.0,
            249.0,
            584.0,
            344.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:54.300000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            176.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:54.400000",
        "id": 21,
        "className": "Person",
        coords: [
            344.0,
            533.0,
            450.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:54.400000",
        "id": 31,
        "className": "Person",
        coords: [
            645.0,
            447.0,
            830.0,
            604.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:54.500000",
        "id": 32,
        "className": "Person",
        coords: [
            597.0,
            242.0,
            647.0,
            356.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:54.500000",
        "id": 33,
        "className": "Person",
        coords: [
            1047.0,
            425.0,
            1138.0,
            625.0
        ],
        "status": "Moving",
        "speed": 94.86,
        "hardhat": "No",
        "mask": "Analysing",
        "vest": "No"
    },
    {
        "timestamp": "00:20:54.700000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            206.0,
            60.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:54.700000",
        "id": 23,
        "className": "Person",
        coords: [
            516.0,
            249.0,
            585.0,
            344.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:54.800000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            176.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:54.800000",
        "id": 21,
        "className": "Person",
        coords: [
            344.0,
            533.0,
            450.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:54.900000",
        "id": 31,
        "className": "Person",
        coords: [
            645.0,
            447.0,
            830.0,
            604.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:55",
        "id": 32,
        "className": "Person",
        coords: [
            592.0,
            243.0,
            642.0,
            355.0
        ],
        "status": "Moving",
        "speed": 74.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:55",
        "id": 33,
        "className": "Person",
        coords: [
            1044.0,
            426.0,
            1136.0,
            624.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "Analysing",
        "vest": "No"
    },
    {
        "timestamp": "00:20:55.200000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            206.0,
            60.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:55.200000",
        "id": 23,
        "className": "Person",
        coords: [
            515.0,
            250.0,
            584.0,
            344.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:55.300000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            176.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:55.300000",
        "id": 21,
        "className": "Person",
        coords: [
            344.0,
            533.0,
            450.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:55.400000",
        "id": 31,
        "className": "Person",
        coords: [
            645.0,
            447.0,
            830.0,
            604.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:55.400000",
        "id": 32,
        "className": "Person",
        coords: [
            589.0,
            243.0,
            640.0,
            354.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:55.500000",
        "id": 33,
        "className": "Person",
        coords: [
            1042.0,
            425.0,
            1136.0,
            626.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:55.600000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            206.0,
            60.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:55.700000",
        "id": 23,
        "className": "Person",
        coords: [
            515.0,
            249.0,
            583.0,
            345.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:55.700000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            176.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:55.800000",
        "id": 21,
        "className": "Person",
        coords: [
            344.0,
            533.0,
            450.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:55.800000",
        "id": 31,
        "className": "Person",
        coords: [
            644.0,
            447.0,
            828.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:55.900000",
        "id": 32,
        "className": "Person",
        coords: [
            588.0,
            243.0,
            639.0,
            354.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:55.900000",
        "id": 33,
        "className": "Person",
        coords: [
            1040.0,
            424.0,
            1137.0,
            626.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:56.100000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            206.0,
            60.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:56.100000",
        "id": 23,
        "className": "Person",
        coords: [
            514.0,
            249.0,
            582.0,
            345.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:56.200000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            176.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:56.200000",
        "id": 21,
        "className": "Person",
        coords: [
            344.0,
            533.0,
            450.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:56.300000",
        "id": 31,
        "className": "Person",
        coords: [
            643.0,
            448.0,
            827.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:56.400000",
        "id": 32,
        "className": "Person",
        coords: [
            585.0,
            243.0,
            635.0,
            352.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:56.400000",
        "id": 33,
        "className": "Person",
        coords: [
            1040.0,
            424.0,
            1137.0,
            625.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:56.600000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            206.0,
            60.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:56.600000",
        "id": 23,
        "className": "Person",
        coords: [
            514.0,
            250.0,
            581.0,
            345.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:56.700000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            176.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:56.700000",
        "id": 21,
        "className": "Person",
        coords: [
            344.0,
            533.0,
            450.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:56.800000",
        "id": 31,
        "className": "Person",
        coords: [
            643.0,
            448.0,
            827.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:56.800000",
        "id": 32,
        "className": "Person",
        coords: [
            585.0,
            243.0,
            635.0,
            351.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:56.900000",
        "id": 33,
        "className": "Person",
        coords: [
            1038.0,
            424.0,
            1135.0,
            623.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:57.100000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            207.0,
            60.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:57.100000",
        "id": 23,
        "className": "Person",
        coords: [
            514.0,
            250.0,
            581.0,
            345.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:57.200000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            176.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:57.300000",
        "id": 21,
        "className": "Person",
        coords: [
            345.0,
            533.0,
            451.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:57.300000",
        "id": 31,
        "className": "Person",
        coords: [
            643.0,
            447.0,
            828.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:57.400000",
        "id": 32,
        "className": "Person",
        coords: [
            580.0,
            242.0,
            629.0,
            348.0
        ],
        "status": "Moving",
        "speed": 94.86,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:57.400000",
        "id": 33,
        "className": "Person",
        coords: [
            1036.0,
            425.0,
            1134.0,
            626.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:57.600000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            208.0,
            60.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:57.700000",
        "id": 23,
        "className": "Person",
        coords: [
            515.0,
            250.0,
            581.0,
            344.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:57.700000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            176.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:57.800000",
        "id": 21,
        "className": "Person",
        coords: [
            345.0,
            533.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:57.800000",
        "id": 31,
        "className": "Person",
        coords: [
            642.0,
            447.0,
            828.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:57.900000",
        "id": 32,
        "className": "Person",
        coords: [
            577.0,
            241.0,
            626.0,
            347.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:58",
        "id": 33,
        "className": "Person",
        coords: [
            1034.0,
            427.0,
            1131.0,
            627.0
        ],
        "status": "Moving",
        "speed": 54.08,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:58.100000",
        "id": 15,
        "className": "Person",
        coords: [
            13.0,
            208.0,
            60.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:58.200000",
        "id": 23,
        "className": "Person",
        coords: [
            514.0,
            250.0,
            579.0,
            344.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:58.200000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            176.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:58.300000",
        "id": 21,
        "className": "Person",
        coords: [
            345.0,
            533.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:58.400000",
        "id": 31,
        "className": "Person",
        coords: [
            642.0,
            447.0,
            828.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:58.400000",
        "id": 32,
        "className": "Person",
        coords: [
            574.0,
            242.0,
            623.0,
            346.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:58.500000",
        "id": 33,
        "className": "Person",
        coords: [
            1026.0,
            428.0,
            1126.0,
            632.0
        ],
        "status": "Moving",
        "speed": 100.61,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:58.600000",
        "id": 15,
        "className": "Person",
        coords: [
            13.0,
            208.0,
            60.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:58.700000",
        "id": 23,
        "className": "Person",
        coords: [
            515.0,
            249.0,
            580.0,
            343.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:58.800000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            176.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:58.900000",
        "id": 21,
        "className": "Person",
        coords: [
            345.0,
            533.0,
            450.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:58.900000",
        "id": 31,
        "className": "Person",
        coords: [
            642.0,
            447.0,
            828.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:59",
        "id": 32,
        "className": "Person",
        coords: [
            568.0,
            240.0,
            617.0,
            346.0
        ],
        "status": "Moving",
        "speed": 91.23,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:59.100000",
        "id": 33,
        "className": "Person",
        coords: [
            1013.0,
            431.0,
            1118.0,
            641.0
        ],
        "status": "Moving",
        "speed": 187.93,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:59.300000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            208.0,
            60.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:59.300000",
        "id": 23,
        "className": "Person",
        coords: [
            515.0,
            250.0,
            579.0,
            343.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:59.400000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            176.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:59.400000",
        "id": 21,
        "className": "Person",
        coords: [
            345.0,
            533.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:20:59.500000",
        "id": 31,
        "className": "Person",
        coords: [
            642.0,
            447.0,
            829.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:59.600000",
        "id": 32,
        "className": "Person",
        coords: [
            565.0,
            238.0,
            615.0,
            345.0
        ],
        "status": "Moving",
        "speed": 42.42,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:59.700000",
        "id": 33,
        "className": "Person",
        coords: [
            1007.0,
            436.0,
            1111.0,
            642.0
        ],
        "status": "Moving",
        "speed": 100.61,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:59.800000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            209.0,
            60.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:59.900000",
        "id": 23,
        "className": "Person",
        coords: [
            515.0,
            251.0,
            579.0,
            342.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:20:59.900000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            176.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:00",
        "id": 21,
        "className": "Person",
        coords: [
            345.0,
            533.0,
            450.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:00.100000",
        "id": 31,
        "className": "Person",
        coords: [
            641.0,
            447.0,
            828.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:00.100000",
        "id": 32,
        "className": "Person",
        coords: [
            564.0,
            238.0,
            614.0,
            345.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:00.200000",
        "id": 33,
        "className": "Person",
        coords: [
            1004.0,
            437.0,
            1108.0,
            643.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:00.200000",
        "id": 26,
        "className": "Person",
        coords: [
            182.0,
            191.0,
            226.0,
            276.0
        ],
        "status": "Moving",
        "speed": 650.68,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:00.400000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            208.0,
            61.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:00.500000",
        "id": 23,
        "className": "Person",
        coords: [
            515.0,
            251.0,
            579.0,
            343.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:00.600000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            176.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:00.600000",
        "id": 21,
        "className": "Person",
        coords: [
            340.0,
            533.0,
            447.0,
            717.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:00.700000",
        "id": 31,
        "className": "Person",
        coords: [
            659.0,
            448.0,
            840.0,
            602.0
        ],
        "status": "Moving",
        "speed": 224.98,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:00.800000",
        "id": 32,
        "className": "Person",
        coords: [
            564.0,
            238.0,
            614.0,
            345.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:00.800000",
        "id": 33,
        "className": "Person",
        coords: [
            1000.0,
            437.0,
            1107.0,
            645.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:00.900000",
        "id": 26,
        "className": "Person",
        coords: [
            182.0,
            196.0,
            225.0,
            277.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:01",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            208.0,
            61.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:01.100000",
        "id": 23,
        "className": "Person",
        coords: [
            515.0,
            252.0,
            580.0,
            343.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:01.100000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            176.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:01.200000",
        "id": 21,
        "className": "Person",
        coords: [
            343.0,
            533.0,
            450.0,
            717.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:01.300000",
        "id": 31,
        "className": "Person",
        coords: [
            664.0,
            448.0,
            842.0,
            602.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:01.300000",
        "id": 32,
        "className": "Person",
        coords: [
            564.0,
            238.0,
            614.0,
            345.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:01.400000",
        "id": 33,
        "className": "Person",
        coords: [
            995.0,
            437.0,
            1102.0,
            646.0
        ],
        "status": "Moving",
        "speed": 74.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:01.400000",
        "id": 26,
        "className": "Person",
        coords: [
            181.0,
            197.0,
            225.0,
            277.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:01.500000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            208.0,
            61.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:01.600000",
        "id": 23,
        "className": "Person",
        coords: [
            515.0,
            252.0,
            581.0,
            342.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:01.700000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            193.0,
            176.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:01.700000",
        "id": 21,
        "className": "Person",
        coords: [
            345.0,
            533.0,
            451.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:01.800000",
        "id": 31,
        "className": "Person",
        coords: [
            666.0,
            448.0,
            842.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:01.800000",
        "id": 32,
        "className": "Person",
        coords: [
            566.0,
            241.0,
            613.0,
            343.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:01.900000",
        "id": 33,
        "className": "Person",
        coords: [
            991.0,
            436.0,
            1097.0,
            646.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:01.900000",
        "id": 26,
        "className": "Person",
        coords: [
            181.0,
            197.0,
            225.0,
            277.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:02.100000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            207.0,
            61.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:02.200000",
        "id": 23,
        "className": "Person",
        coords: [
            514.0,
            252.0,
            580.0,
            342.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:02.200000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            194.0,
            176.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:02.400000",
        "id": 21,
        "className": "Person",
        coords: [
            345.0,
            533.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:02.400000",
        "id": 31,
        "className": "Person",
        coords: [
            668.0,
            448.0,
            841.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:02.500000",
        "id": 33,
        "className": "Person",
        coords: [
            987.0,
            436.0,
            1093.0,
            645.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:02.500000",
        "id": 26,
        "className": "Person",
        coords: [
            181.0,
            198.0,
            225.0,
            277.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:02.600000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            207.0,
            61.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:02.700000",
        "id": 23,
        "className": "Person",
        coords: [
            516.0,
            253.0,
            582.0,
            341.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:02.800000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            194.0,
            176.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:02.800000",
        "id": 21,
        "className": "Person",
        coords: [
            346.0,
            533.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:02.900000",
        "id": 31,
        "className": "Person",
        coords: [
            669.0,
            448.0,
            841.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:02.900000",
        "id": 33,
        "className": "Person",
        coords: [
            975.0,
            436.0,
            1081.0,
            643.0
        ],
        "status": "Moving",
        "speed": 180.61,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:03",
        "id": 26,
        "className": "Person",
        coords: [
            180.0,
            199.0,
            224.0,
            277.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:03.200000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            208.0,
            61.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:03.300000",
        "id": 23,
        "className": "Person",
        coords: [
            518.0,
            253.0,
            583.0,
            341.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:03.400000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            194.0,
            176.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:03.500000",
        "id": 21,
        "className": "Person",
        coords: [
            346.0,
            533.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:03.500000",
        "id": 31,
        "className": "Person",
        coords: [
            670.0,
            448.0,
            840.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:03.600000",
        "id": 33,
        "className": "Person",
        coords: [
            964.0,
            436.0,
            1073.0,
            645.0
        ],
        "status": "Moving",
        "speed": 150.74,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:03.700000",
        "id": 26,
        "className": "Person",
        coords: [
            181.0,
            200.0,
            224.0,
            277.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:04",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            208.0,
            61.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:04.100000",
        "id": 23,
        "className": "Person",
        coords: [
            519.0,
            252.0,
            586.0,
            342.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:04.100000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            194.0,
            176.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:04.200000",
        "id": 21,
        "className": "Person",
        coords: [
            346.0,
            533.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:04.200000",
        "id": 31,
        "className": "Person",
        coords: [
            671.0,
            447.0,
            839.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:04.300000",
        "id": 33,
        "className": "Person",
        coords: [
            949.0,
            440.0,
            1061.0,
            646.0
        ],
        "status": "Moving",
        "speed": 200.11,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:04.400000",
        "id": 26,
        "className": "Person",
        coords: [
            181.0,
            199.0,
            225.0,
            277.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:04.600000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            208.0,
            61.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:04.700000",
        "id": 23,
        "className": "Person",
        coords: [
            522.0,
            252.0,
            589.0,
            343.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:04.800000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            194.0,
            176.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:04.900000",
        "id": 21,
        "className": "Person",
        coords: [
            341.0,
            533.0,
            447.0,
            717.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:04.900000",
        "id": 31,
        "className": "Person",
        coords: [
            672.0,
            447.0,
            838.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:05",
        "id": 33,
        "className": "Person",
        coords: [
            940.0,
            440.0,
            1054.0,
            645.0
        ],
        "status": "Moving",
        "speed": 120.92,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:05.200000",
        "id": 26,
        "className": "Person",
        coords: [
            181.0,
            199.0,
            225.0,
            277.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:05.400000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            208.0,
            60.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:05.500000",
        "id": 23,
        "className": "Person",
        coords: [
            524.0,
            252.0,
            592.0,
            344.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:05.600000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            194.0,
            176.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:05.700000",
        "id": 21,
        "className": "Person",
        coords: [
            344.0,
            533.0,
            450.0,
            718.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:05.800000",
        "id": 31,
        "className": "Person",
        coords: [
            672.0,
            447.0,
            837.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:06",
        "id": 33,
        "className": "Person",
        coords: [
            945.0,
            444.0,
            1055.0,
            644.0
        ],
        "status": "Moving",
        "speed": 54.08,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:06.100000",
        "id": 26,
        "className": "Person",
        coords: [
            181.0,
            200.0,
            225.0,
            277.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:06.300000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            207.0,
            61.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:06.400000",
        "id": 23,
        "className": "Person",
        coords: [
            525.0,
            250.0,
            595.0,
            344.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:06.500000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            194.0,
            176.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:06.600000",
        "id": 21,
        "className": "Person",
        coords: [
            345.0,
            533.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:06.700000",
        "id": 31,
        "className": "Person",
        coords: [
            673.0,
            448.0,
            836.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:06.800000",
        "id": 33,
        "className": "Person",
        coords: [
            936.0,
            442.0,
            1045.0,
            639.0
        ],
        "status": "Moving",
        "speed": 161.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:06.900000",
        "id": 26,
        "className": "Person",
        coords: [
            181.0,
            200.0,
            225.0,
            277.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:07.100000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            208.0,
            61.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:07.100000",
        "id": 23,
        "className": "Person",
        coords: [
            523.0,
            250.0,
            595.0,
            345.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:07.200000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            194.0,
            175.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:07.300000",
        "id": 21,
        "className": "Person",
        coords: [
            346.0,
            533.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:07.400000",
        "id": 31,
        "className": "Person",
        coords: [
            674.0,
            448.0,
            836.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:07.500000",
        "id": 33,
        "className": "Person",
        coords: [
            926.0,
            440.0,
            1039.0,
            644.0
        ],
        "status": "Moving",
        "speed": 123.68,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:07.600000",
        "id": 26,
        "className": "Person",
        coords: [
            181.0,
            200.0,
            226.0,
            277.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:07.700000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            208.0,
            61.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:07.800000",
        "id": 23,
        "className": "Person",
        coords: [
            520.0,
            249.0,
            595.0,
            346.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:07.800000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            194.0,
            175.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:07.900000",
        "id": 21,
        "className": "Person",
        coords: [
            340.0,
            533.0,
            446.0,
            717.0
        ],
        "status": "Moving",
        "speed": 74.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:08",
        "id": 31,
        "className": "Person",
        coords: [
            674.0,
            448.0,
            835.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:08",
        "id": 33,
        "className": "Person",
        coords: [
            921.0,
            439.0,
            1036.0,
            646.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:08.100000",
        "id": 26,
        "className": "Person",
        coords: [
            181.0,
            200.0,
            226.0,
            277.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:08.300000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            208.0,
            61.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:08.300000",
        "id": 23,
        "className": "Person",
        coords: [
            518.0,
            247.0,
            594.0,
            346.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:08.400000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            194.0,
            175.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:08.500000",
        "id": 21,
        "className": "Person",
        coords: [
            333.0,
            533.0,
            441.0,
            717.0
        ],
        "status": "Moving",
        "speed": 89.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:08.500000",
        "id": 31,
        "className": "Person",
        coords: [
            681.0,
            448.0,
            839.0,
            602.0
        ],
        "status": "Moving",
        "speed": 89.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:08.600000",
        "id": 33,
        "className": "Person",
        coords: [
            917.0,
            438.0,
            1032.0,
            648.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:08.700000",
        "id": 26,
        "className": "Person",
        coords: [
            180.0,
            199.0,
            225.0,
            277.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:08.800000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            208.0,
            61.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:08.900000",
        "id": 23,
        "className": "Person",
        coords: [
            517.0,
            247.0,
            594.0,
            345.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:09",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            194.0,
            175.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:09",
        "id": 21,
        "className": "Person",
        coords: [
            325.0,
            533.0,
            437.0,
            717.0
        ],
        "status": "Moving",
        "speed": 89.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:09.100000",
        "id": 31,
        "className": "Person",
        coords: [
            678.0,
            448.0,
            836.0,
            602.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:09.200000",
        "id": 33,
        "className": "Person",
        coords: [
            913.0,
            439.0,
            1027.0,
            648.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:09.300000",
        "id": 26,
        "className": "Person",
        coords: [
            180.0,
            197.0,
            226.0,
            277.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:09.400000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            206.0,
            61.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:09.500000",
        "id": 23,
        "className": "Person",
        coords: [
            516.0,
            247.0,
            594.0,
            346.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:09.600000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            194.0,
            176.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:09.600000",
        "id": 21,
        "className": "Person",
        coords: [
            336.0,
            533.0,
            447.0,
            717.0
        ],
        "status": "Moving",
        "speed": 149.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:09.700000",
        "id": 31,
        "className": "Person",
        coords: [
            665.0,
            448.0,
            825.0,
            602.0
        ],
        "status": "Moving",
        "speed": 179.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:09.800000",
        "id": 33,
        "className": "Person",
        coords: [
            902.0,
            438.0,
            1022.0,
            659.0
        ],
        "status": "Moving",
        "speed": 141.5,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:09.800000",
        "id": 26,
        "className": "Person",
        coords: [
            180.0,
            198.0,
            227.0,
            278.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:10",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            205.0,
            61.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:10.100000",
        "id": 23,
        "className": "Person",
        coords: [
            515.0,
            247.0,
            595.0,
            346.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:10.100000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            194.0,
            176.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:10.200000",
        "id": 21,
        "className": "Person",
        coords: [
            341.0,
            533.0,
            451.0,
            718.0
        ],
        "status": "Moving",
        "speed": 74.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:10.300000",
        "id": 31,
        "className": "Person",
        coords: [
            665.0,
            448.0,
            825.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:10.300000",
        "id": 33,
        "className": "Person",
        coords: [
            888.0,
            439.0,
            1017.0,
            679.0
        ],
        "status": "Moving",
        "speed": 222.97,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:10.400000",
        "id": 26,
        "className": "Person",
        coords: [
            180.0,
            198.0,
            227.0,
            279.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:10.600000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            206.0,
            61.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:10.600000",
        "id": 23,
        "className": "Person",
        coords: [
            514.0,
            247.0,
            595.0,
            346.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:10.700000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            194.0,
            176.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:10.700000",
        "id": 21,
        "className": "Person",
        coords: [
            343.0,
            533.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:10.800000",
        "id": 31,
        "className": "Person",
        coords: [
            663.0,
            448.0,
            824.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:10.900000",
        "id": 33,
        "className": "Person",
        coords: [
            877.0,
            438.0,
            1012.0,
            689.0
        ],
        "status": "Moving",
        "speed": 134.15,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:10.900000",
        "id": 26,
        "className": "Person",
        coords: [
            180.0,
            198.0,
            228.0,
            279.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:11.100000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            205.0,
            61.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:11.100000",
        "id": 23,
        "className": "Person",
        coords: [
            513.0,
            247.0,
            595.0,
            346.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:11.200000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            194.0,
            176.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:11.200000",
        "id": 21,
        "className": "Person",
        coords: [
            344.0,
            533.0,
            453.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:11.300000",
        "id": 31,
        "className": "Person",
        coords: [
            665.0,
            448.0,
            827.0,
            602.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:11.300000",
        "id": 33,
        "className": "Person",
        coords: [
            868.0,
            446.0,
            1003.0,
            697.0
        ],
        "status": "Moving",
        "speed": 180.61,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:11.400000",
        "id": 26,
        "className": "Person",
        coords: [
            180.0,
            199.0,
            227.0,
            279.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:11.500000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            205.0,
            61.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:11.600000",
        "id": 23,
        "className": "Person",
        coords: [
            510.0,
            248.0,
            593.0,
            346.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:11.600000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            194.0,
            175.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:11.700000",
        "id": 21,
        "className": "Person",
        coords: [
            344.0,
            533.0,
            453.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:11.700000",
        "id": 31,
        "className": "Person",
        coords: [
            665.0,
            448.0,
            827.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:11.800000",
        "id": 33,
        "className": "Person",
        coords: [
            862.0,
            451.0,
            994.0,
            696.0
        ],
        "status": "Moving",
        "speed": 109.19,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:11.800000",
        "id": 26,
        "className": "Person",
        coords: [
            180.0,
            199.0,
            227.0,
            279.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:12",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            204.0,
            61.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:12",
        "id": 23,
        "className": "Person",
        coords: [
            504.0,
            248.0,
            589.0,
            345.0
        ],
        "status": "Moving",
        "speed": 76.48,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:12.100000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            175.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:12.100000",
        "id": 21,
        "className": "Person",
        coords: [
            345.0,
            533.0,
            453.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:12.200000",
        "id": 31,
        "className": "Person",
        coords: [
            662.0,
            448.0,
            826.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:12.200000",
        "id": 33,
        "className": "Person",
        coords: [
            859.0,
            453.0,
            989.0,
            695.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:12.300000",
        "id": 26,
        "className": "Person",
        coords: [
            180.0,
            199.0,
            227.0,
            279.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:12.400000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            204.0,
            61.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:12.500000",
        "id": 23,
        "className": "Person",
        coords: [
            500.0,
            247.0,
            587.0,
            345.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:12.500000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            194.0,
            175.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:12.600000",
        "id": 21,
        "className": "Person",
        coords: [
            345.0,
            533.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:12.600000",
        "id": 31,
        "className": "Person",
        coords: [
            662.0,
            448.0,
            826.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:12.700000",
        "id": 33,
        "className": "Person",
        coords: [
            857.0,
            455.0,
            984.0,
            694.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:12.700000",
        "id": 26,
        "className": "Person",
        coords: [
            180.0,
            199.0,
            227.0,
            279.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:12.900000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            203.0,
            62.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:12.900000",
        "id": 23,
        "className": "Person",
        coords: [
            497.0,
            247.0,
            585.0,
            344.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:13",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            194.0,
            176.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:13",
        "id": 21,
        "className": "Person",
        coords: [
            332.0,
            533.0,
            442.0,
            718.0
        ],
        "status": "Moving",
        "speed": 164.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:13.100000",
        "id": 31,
        "className": "Person",
        coords: [
            664.0,
            448.0,
            828.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:13.100000",
        "id": 33,
        "className": "Person",
        coords: [
            855.0,
            455.0,
            982.0,
            693.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:13.200000",
        "id": 26,
        "className": "Person",
        coords: [
            179.0,
            198.0,
            227.0,
            279.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:13.300000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            204.0,
            62.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:13.400000",
        "id": 23,
        "className": "Person",
        coords: [
            495.0,
            247.0,
            583.0,
            344.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:13.400000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            194.0,
            176.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:13.500000",
        "id": 21,
        "className": "Person",
        coords: [
            325.0,
            533.0,
            438.0,
            717.0
        ],
        "status": "Moving",
        "speed": 89.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:13.500000",
        "id": 31,
        "className": "Person",
        coords: [
            663.0,
            448.0,
            828.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:13.600000",
        "id": 33,
        "className": "Person",
        coords: [
            853.0,
            455.0,
            977.0,
            693.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:13.600000",
        "id": 26,
        "className": "Person",
        coords: [
            179.0,
            198.0,
            228.0,
            279.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:13.800000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            204.0,
            61.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:13.800000",
        "id": 23,
        "className": "Person",
        coords: [
            493.0,
            248.0,
            582.0,
            344.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:13.900000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            194.0,
            176.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:13.900000",
        "id": 21,
        "className": "Person",
        coords: [
            336.0,
            533.0,
            448.0,
            718.0
        ],
        "status": "Moving",
        "speed": 164.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:14",
        "id": 31,
        "className": "Person",
        coords: [
            666.0,
            448.0,
            831.0,
            603.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:14.100000",
        "id": 33,
        "className": "Person",
        coords: [
            846.0,
            458.0,
            969.0,
            694.0
        ],
        "status": "Moving",
        "speed": 123.68,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:14.100000",
        "id": 26,
        "className": "Person",
        coords: [
            180.0,
            199.0,
            227.0,
            278.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:14.300000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            204.0,
            61.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:14.300000",
        "id": 23,
        "className": "Person",
        coords: [
            491.0,
            248.0,
            581.0,
            344.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:14.400000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            194.0,
            176.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:14.400000",
        "id": 21,
        "className": "Person",
        coords: [
            340.0,
            534.0,
            452.0,
            718.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:14.500000",
        "id": 31,
        "className": "Person",
        coords: [
            671.0,
            448.0,
            835.0,
            604.0
        ],
        "status": "Moving",
        "speed": 76.48,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:14.500000",
        "id": 33,
        "className": "Person",
        coords: [
            832.0,
            459.0,
            955.0,
            692.0
        ],
        "status": "Moving",
        "speed": 210.52,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:14.600000",
        "id": 26,
        "className": "Person",
        coords: [
            179.0,
            199.0,
            226.0,
            277.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:14.700000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            204.0,
            61.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:14.800000",
        "id": 23,
        "className": "Person",
        coords: [
            491.0,
            249.0,
            581.0,
            343.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:14.800000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            194.0,
            176.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:14.900000",
        "id": 21,
        "className": "Person",
        coords: [
            342.0,
            534.0,
            453.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:15",
        "id": 31,
        "className": "Person",
        coords: [
            670.0,
            448.0,
            835.0,
            606.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:15",
        "id": 33,
        "className": "Person",
        coords: [
            816.0,
            462.0,
            941.0,
            696.0
        ],
        "status": "Moving",
        "speed": 232.84,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:15.100000",
        "id": 26,
        "className": "Person",
        coords: [
            179.0,
            200.0,
            226.0,
            277.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:15.200000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            204.0,
            61.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:15.200000",
        "id": 23,
        "className": "Person",
        coords: [
            491.0,
            248.0,
            581.0,
            343.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:15.300000",
        "id": 22,
        "className": "Person",
        coords: [
            143.0,
            194.0,
            176.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:15.300000",
        "id": 21,
        "className": "Person",
        coords: [
            343.0,
            534.0,
            453.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:15.400000",
        "id": 33,
        "className": "Person",
        coords: [
            802.0,
            464.0,
            932.0,
            701.0
        ],
        "status": "Moving",
        "speed": 171.01,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:15.400000",
        "id": 26,
        "className": "Person",
        coords: [
            179.0,
            200.0,
            225.0,
            277.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:15.600000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            204.0,
            61.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:15.600000",
        "id": 23,
        "className": "Person",
        coords: [
            491.0,
            248.0,
            581.0,
            342.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:15.700000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            194.0,
            176.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:15.700000",
        "id": 21,
        "className": "Person",
        coords: [
            344.0,
            534.0,
            453.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:15.700000",
        "id": 33,
        "className": "Person",
        coords: [
            793.0,
            466.0,
            925.0,
            704.0
        ],
        "status": "Moving",
        "speed": 128.15,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:15.800000",
        "id": 26,
        "className": "Person",
        coords: [
            178.0,
            201.0,
            224.0,
            277.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:15.900000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            205.0,
            61.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:16",
        "id": 23,
        "className": "Person",
        coords: [
            491.0,
            248.0,
            582.0,
            342.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:16",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            194.0,
            176.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:16.100000",
        "id": 21,
        "className": "Person",
        coords: [
            344.0,
            534.0,
            453.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:16.100000",
        "id": 33,
        "className": "Person",
        coords: [
            787.0,
            463.0,
            922.0,
            705.0
        ],
        "status": "Moving",
        "speed": 76.48,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:16.200000",
        "id": 26,
        "className": "Person",
        coords: [
            177.0,
            201.0,
            223.0,
            277.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:16.300000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            205.0,
            61.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:16.400000",
        "id": 23,
        "className": "Person",
        coords: [
            488.0,
            250.0,
            579.0,
            342.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:16.400000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            194.0,
            176.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:16.500000",
        "id": 21,
        "className": "Person",
        coords: [
            345.0,
            533.0,
            453.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:16.500000",
        "id": 33,
        "className": "Person",
        coords: [
            782.0,
            466.0,
            916.0,
            706.0
        ],
        "status": "Moving",
        "speed": 80.77,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:16.600000",
        "id": 26,
        "className": "Person",
        coords: [
            177.0,
            200.0,
            222.0,
            276.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:16.700000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            205.0,
            61.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:16.800000",
        "id": 23,
        "className": "Person",
        coords: [
            485.0,
            251.0,
            577.0,
            342.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:16.800000",
        "id": 22,
        "className": "Person",
        coords: [
            143.0,
            194.0,
            176.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:16.900000",
        "id": 21,
        "className": "Person",
        coords: [
            345.0,
            533.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:16.900000",
        "id": 33,
        "className": "Person",
        coords: [
            774.0,
            464.0,
            910.0,
            706.0
        ],
        "status": "Moving",
        "speed": 106.06,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:17",
        "id": 26,
        "className": "Person",
        coords: [
            176.0,
            200.0,
            222.0,
            277.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:17.100000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            205.0,
            61.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:17.200000",
        "id": 23,
        "className": "Person",
        coords: [
            482.0,
            251.0,
            575.0,
            342.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:17.200000",
        "id": 22,
        "className": "Person",
        coords: [
            143.0,
            194.0,
            177.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:17.300000",
        "id": 21,
        "className": "Person",
        coords: [
            345.0,
            533.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:17.300000",
        "id": 33,
        "className": "Person",
        coords: [
            769.0,
            466.0,
            904.0,
            709.0
        ],
        "status": "Moving",
        "speed": 94.86,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:17.400000",
        "id": 26,
        "className": "Person",
        coords: [
            177.0,
            200.0,
            222.0,
            277.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:17.500000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            205.0,
            61.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:17.600000",
        "id": 23,
        "className": "Person",
        coords: [
            481.0,
            252.0,
            574.0,
            342.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:17.600000",
        "id": 22,
        "className": "Person",
        coords: [
            143.0,
            194.0,
            177.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:17.700000",
        "id": 21,
        "className": "Person",
        coords: [
            345.0,
            533.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:17.700000",
        "id": 33,
        "className": "Person",
        coords: [
            767.0,
            471.0,
            899.0,
            710.0
        ],
        "status": "Moving",
        "speed": 63.63,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:17.800000",
        "id": 26,
        "className": "Person",
        coords: [
            177.0,
            199.0,
            222.0,
            276.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:17.800000",
        "id": 31,
        "className": "Person",
        coords: [
            694.0,
            448.0,
            845.0,
            598.0
        ],
        "status": "Moving",
        "speed": 261.94,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:18",
        "id": 15,
        "className": "Person",
        coords: [
            13.0,
            205.0,
            62.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:18",
        "id": 23,
        "className": "Person",
        coords: [
            480.0,
            252.0,
            573.0,
            341.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:18.100000",
        "id": 22,
        "className": "Person",
        coords: [
            143.0,
            194.0,
            177.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:18.100000",
        "id": 21,
        "className": "Person",
        coords: [
            345.0,
            532.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:18.200000",
        "id": 33,
        "className": "Person",
        coords: [
            762.0,
            473.0,
            894.0,
            713.0
        ],
        "status": "Moving",
        "speed": 87.46,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:18.300000",
        "id": 26,
        "className": "Person",
        coords: [
            177.0,
            199.0,
            222.0,
            276.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:18.400000",
        "id": 15,
        "className": "Person",
        coords: [
            13.0,
            204.0,
            62.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:18.400000",
        "id": 23,
        "className": "Person",
        coords: [
            479.0,
            253.0,
            572.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:18.500000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            194.0,
            176.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:18.500000",
        "id": 21,
        "className": "Person",
        coords: [
            345.0,
            532.0,
            451.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:18.600000",
        "id": 33,
        "className": "Person",
        coords: [
            755.0,
            475.0,
            887.0,
            715.0
        ],
        "status": "Moving",
        "speed": 109.19,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:18.600000",
        "id": 26,
        "className": "Person",
        coords: [
            175.0,
            198.0,
            221.0,
            276.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:18.700000",
        "id": 31,
        "className": "Person",
        coords: [
            697.0,
            447.0,
            836.0,
            589.0
        ],
        "status": "Moving",
        "speed": 87.46,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:18.800000",
        "id": 15,
        "className": "Person",
        coords: [
            13.0,
            204.0,
            62.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:18.900000",
        "id": 23,
        "className": "Person",
        coords: [
            479.0,
            253.0,
            571.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:18.900000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            193.0,
            176.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:19",
        "id": 21,
        "className": "Person",
        coords: [
            345.0,
            532.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:19",
        "id": 33,
        "className": "Person",
        coords: [
            744.0,
            479.0,
            875.0,
            717.0
        ],
        "status": "Moving",
        "speed": 185.52,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:19.100000",
        "id": 26,
        "className": "Person",
        coords: [
            174.0,
            197.0,
            221.0,
            276.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:19.100000",
        "id": 31,
        "className": "Person",
        coords: [
            682.0,
            447.0,
            825.0,
            593.0
        ],
        "status": "Moving",
        "speed": 197.28,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:19.300000",
        "id": 15,
        "className": "Person",
        coords: [
            13.0,
            205.0,
            62.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:19.400000",
        "id": 23,
        "className": "Person",
        coords: [
            477.0,
            252.0,
            572.0,
            341.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:19.400000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            194.0,
            176.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:19.500000",
        "id": 21,
        "className": "Person",
        coords: [
            345.0,
            531.0,
            451.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:19.500000",
        "id": 33,
        "className": "Person",
        coords: [
            735.0,
            484.0,
            864.0,
            719.0
        ],
        "status": "Moving",
        "speed": 156.59,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:19.600000",
        "id": 26,
        "className": "Person",
        coords: [
            172.0,
            197.0,
            218.0,
            274.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:19.600000",
        "id": 31,
        "className": "Person",
        coords: [
            696.0,
            447.0,
            836.0,
            597.0
        ],
        "status": "Moving",
        "speed": 197.28,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:19.800000",
        "id": 15,
        "className": "Person",
        coords: [
            13.0,
            205.0,
            62.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:19.800000",
        "id": 23,
        "className": "Person",
        coords: [
            476.0,
            252.0,
            573.0,
            342.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:19.900000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            194.0,
            175.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:19.900000",
        "id": 21,
        "className": "Person",
        coords: [
            345.0,
            531.0,
            451.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:20",
        "id": 33,
        "className": "Person",
        coords: [
            729.0,
            491.0,
            855.0,
            719.0
        ],
        "status": "Moving",
        "speed": 120.92,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:20",
        "id": 26,
        "className": "Person",
        coords: [
            170.0,
            197.0,
            215.0,
            274.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:20.100000",
        "id": 31,
        "className": "Person",
        coords: [
            686.0,
            447.0,
            826.0,
            595.0
        ],
        "status": "Moving",
        "speed": 150.74,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:20.200000",
        "id": 15,
        "className": "Person",
        coords: [
            13.0,
            205.0,
            61.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:20.300000",
        "id": 23,
        "className": "Person",
        coords: [
            476.0,
            252.0,
            574.0,
            342.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:20.300000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            194.0,
            174.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:20.400000",
        "id": 21,
        "className": "Person",
        coords: [
            345.0,
            531.0,
            450.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:20.400000",
        "id": 33,
        "className": "Person",
        coords: [
            725.0,
            495.0,
            846.0,
            717.0
        ],
        "status": "Moving",
        "speed": 106.06,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:20.500000",
        "id": 26,
        "className": "Person",
        coords: [
            168.0,
            198.0,
            212.0,
            274.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:20.600000",
        "id": 15,
        "className": "Person",
        coords: [
            13.0,
            205.0,
            61.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:20.700000",
        "id": 23,
        "className": "Person",
        coords: [
            476.0,
            252.0,
            575.0,
            343.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:20.700000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            194.0,
            174.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:20.800000",
        "id": 21,
        "className": "Person",
        coords: [
            345.0,
            532.0,
            451.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:20.800000",
        "id": 33,
        "className": "Person",
        coords: [
            720.0,
            498.0,
            841.0,
            719.0
        ],
        "status": "Moving",
        "speed": 80.77,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:20.900000",
        "id": 26,
        "className": "Person",
        coords: [
            166.0,
            197.0,
            210.0,
            274.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:21",
        "id": 15,
        "className": "Person",
        coords: [
            14.0,
            205.0,
            62.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:21.100000",
        "id": 23,
        "className": "Person",
        coords: [
            476.0,
            252.0,
            575.0,
            343.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:21.100000",
        "id": 22,
        "className": "Person",
        coords: [
            143.0,
            194.0,
            175.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:21.200000",
        "id": 21,
        "className": "Person",
        coords: [
            346.0,
            532.0,
            450.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:21.300000",
        "id": 33,
        "className": "Person",
        coords: [
            714.0,
            500.0,
            833.0,
            718.0
        ],
        "status": "Moving",
        "speed": 106.06,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:21.300000",
        "id": 26,
        "className": "Person",
        coords: [
            165.0,
            195.0,
            214.0,
            286.0
        ],
        "status": "Moving",
        "speed": 76.48,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:21.400000",
        "id": 15,
        "className": "Person",
        coords: [
            13.0,
            205.0,
            61.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:21.500000",
        "id": 23,
        "className": "Person",
        coords: [
            476.0,
            252.0,
            576.0,
            342.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:21.500000",
        "id": 22,
        "className": "Person",
        coords: [
            143.0,
            194.0,
            176.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:21.600000",
        "id": 21,
        "className": "Person",
        coords: [
            346.0,
            533.0,
            450.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:21.700000",
        "id": 33,
        "className": "Person",
        coords: [
            706.0,
            501.0,
            823.0,
            719.0
        ],
        "status": "Moving",
        "speed": 135.82,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:21.700000",
        "id": 26,
        "className": "Person",
        coords: [
            165.0,
            194.0,
            221.0,
            299.0
        ],
        "status": "Moving",
        "speed": 108.16,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:21.900000",
        "id": 15,
        "className": "Person",
        coords: [
            14.0,
            205.0,
            62.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:21.900000",
        "id": 23,
        "className": "Person",
        coords: [
            477.0,
            253.0,
            575.0,
            342.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:21.900000",
        "id": 22,
        "className": "Person",
        coords: [
            144.0,
            194.0,
            177.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:22",
        "id": 21,
        "className": "Person",
        coords: [
            346.0,
            533.0,
            450.0,
            715.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:22.100000",
        "id": 33,
        "className": "Person",
        coords: [
            697.0,
            501.0,
            814.0,
            719.0
        ],
        "status": "Moving",
        "speed": 134.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:22.200000",
        "id": 15,
        "className": "Person",
        coords: [
            14.0,
            205.0,
            62.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:22.300000",
        "id": 23,
        "className": "Person",
        coords: [
            480.0,
            254.0,
            577.0,
            342.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:22.300000",
        "id": 22,
        "className": "Person",
        coords: [
            143.0,
            194.0,
            177.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:22.400000",
        "id": 21,
        "className": "Person",
        coords: [
            346.0,
            533.0,
            450.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:22.400000",
        "id": 33,
        "className": "Person",
        coords: [
            685.0,
            503.0,
            802.0,
            720.0
        ],
        "status": "Moving",
        "speed": 180.61,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:22.600000",
        "id": 15,
        "className": "Person",
        coords: [
            14.0,
            206.0,
            62.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:22.600000",
        "id": 23,
        "className": "Person",
        coords: [
            480.0,
            255.0,
            576.0,
            342.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:22.700000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            194.0,
            175.0,
            271.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:22.700000",
        "id": 33,
        "className": "Person",
        coords: [
            662.0,
            502.0,
            783.0,
            720.0
        ],
        "status": "Moving",
        "speed": 314.97,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:22.900000",
        "id": 15,
        "className": "Person",
        coords: [
            14.0,
            206.0,
            61.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:22.900000",
        "id": 23,
        "className": "Person",
        coords: [
            482.0,
            255.0,
            576.0,
            342.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:23",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            194.0,
            175.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:23",
        "id": 33,
        "className": "Person",
        coords: [
            653.0,
            502.0,
            775.0,
            720.0
        ],
        "status": "Moving",
        "speed": 119.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:23.100000",
        "id": 31,
        "className": "Person",
        coords: [
            715.0,
            448.0,
            864.0,
            621.0
        ],
        "status": "Moving",
        "speed": 531.98,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:23.100000",
        "id": 21,
        "className": "Person",
        coords: [
            347.0,
            534.0,
            449.0,
            713.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:23.300000",
        "id": 15,
        "className": "Person",
        coords: [
            14.0,
            207.0,
            61.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:23.400000",
        "id": 23,
        "className": "Person",
        coords: [
            488.0,
            256.0,
            579.0,
            342.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:23.400000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            194.0,
            175.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:23.500000",
        "id": 33,
        "className": "Person",
        coords: [
            647.0,
            503.0,
            768.0,
            720.0
        ],
        "status": "Moving",
        "speed": 104.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:23.500000",
        "id": 31,
        "className": "Person",
        coords: [
            722.0,
            448.0,
            852.0,
            606.0
        ],
        "status": "Moving",
        "speed": 109.19,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:23.600000",
        "id": 21,
        "className": "Person",
        coords: [
            346.0,
            534.0,
            449.0,
            714.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:23.700000",
        "id": 15,
        "className": "Person",
        coords: [
            13.0,
            207.0,
            60.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:23.800000",
        "id": 23,
        "className": "Person",
        coords: [
            495.0,
            256.0,
            582.0,
            342.0
        ],
        "status": "Moving",
        "speed": 74.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:23.800000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            193.0,
            176.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:23.900000",
        "id": 33,
        "className": "Person",
        coords: [
            638.0,
            512.0,
            754.0,
            720.0
        ],
        "status": "Moving",
        "speed": 181.23,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:24",
        "id": 31,
        "className": "Person",
        coords: [
            715.0,
            448.0,
            853.0,
            626.0
        ],
        "status": "Moving",
        "speed": 156.59,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:24",
        "id": 21,
        "className": "Person",
        coords: [
            345.0,
            534.0,
            449.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:24.100000",
        "id": 32,
        "className": "Person",
        coords: [
            456.0,
            238.0,
            500.0,
            310.0
        ],
        "status": "Moving",
        "speed": 1686.61,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:24.200000",
        "id": 15,
        "className": "Person",
        coords: [
            14.0,
            207.0,
            61.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:24.300000",
        "id": 23,
        "className": "Person",
        coords: [
            496.0,
            256.0,
            582.0,
            342.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:24.300000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            193.0,
            176.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:24.400000",
        "id": 33,
        "className": "Person",
        coords: [
            628.0,
            515.0,
            743.0,
            719.0
        ],
        "status": "Moving",
        "speed": 165.67,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:24.400000",
        "id": 21,
        "className": "Person",
        coords: [
            345.0,
            534.0,
            450.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:24.500000",
        "id": 32,
        "className": "Person",
        coords: [
            451.0,
            239.0,
            501.0,
            310.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:24.700000",
        "id": 15,
        "className": "Person",
        coords: [
            14.0,
            207.0,
            61.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:24.700000",
        "id": 23,
        "className": "Person",
        coords: [
            496.0,
            255.0,
            581.0,
            342.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:24.800000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            193.0,
            177.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:24.800000",
        "id": 33,
        "className": "Person",
        coords: [
            617.0,
            516.0,
            730.0,
            720.0
        ],
        "status": "Moving",
        "speed": 180.61,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:24.900000",
        "id": 21,
        "className": "Person",
        coords: [
            345.0,
            534.0,
            450.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:24.900000",
        "id": 32,
        "className": "Person",
        coords: [
            449.0,
            239.0,
            502.0,
            311.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:24.900000",
        "id": 31,
        "className": "Person",
        coords: [
            707.0,
            449.0,
            850.0,
            640.0
        ],
        "status": "Moving",
        "speed": 138.28,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:25.100000",
        "id": 15,
        "className": "Person",
        coords: [
            13.0,
            206.0,
            61.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:25.100000",
        "id": 23,
        "className": "Person",
        coords: [
            497.0,
            255.0,
            581.0,
            342.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:25.200000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            194.0,
            177.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:25.200000",
        "id": 33,
        "className": "Person",
        coords: [
            604.0,
            518.0,
            717.0,
            719.0
        ],
        "status": "Moving",
        "speed": 194.98,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:25.300000",
        "id": 21,
        "className": "Person",
        coords: [
            345.0,
            534.0,
            450.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:25.300000",
        "id": 32,
        "className": "Person",
        coords: [
            448.0,
            239.0,
            503.0,
            310.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:25.400000",
        "id": 31,
        "className": "Person",
        coords: [
            712.0,
            449.0,
            837.0,
            614.0
        ],
        "status": "Moving",
        "speed": 204.01,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:25.500000",
        "id": 15,
        "className": "Person",
        coords: [
            13.0,
            206.0,
            61.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:25.600000",
        "id": 23,
        "className": "Person",
        coords: [
            499.0,
            254.0,
            581.0,
            342.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:25.600000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            194.0,
            177.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:25.700000",
        "id": 33,
        "className": "Person",
        coords: [
            589.0,
            519.0,
            704.0,
            719.0
        ],
        "status": "Moving",
        "speed": 210.52,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:25.700000",
        "id": 21,
        "className": "Person",
        coords: [
            345.0,
            534.0,
            450.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:25.800000",
        "id": 32,
        "className": "Person",
        coords: [
            447.0,
            239.0,
            504.0,
            309.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:25.800000",
        "id": 31,
        "className": "Person",
        coords: [
            710.0,
            449.0,
            829.0,
            606.0
        ],
        "status": "Moving",
        "speed": 96.04,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:26",
        "id": 15,
        "className": "Person",
        coords: [
            13.0,
            206.0,
            60.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:26",
        "id": 23,
        "className": "Person",
        coords: [
            500.0,
            253.0,
            582.0,
            342.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:26.100000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            194.0,
            177.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:26.100000",
        "id": 33,
        "className": "Person",
        coords: [
            574.0,
            522.0,
            689.0,
            719.0
        ],
        "status": "Moving",
        "speed": 225.48,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:26.200000",
        "id": 21,
        "className": "Person",
        coords: [
            345.0,
            533.0,
            450.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:26.200000",
        "id": 32,
        "className": "Person",
        coords: [
            446.0,
            239.0,
            504.0,
            309.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:26.300000",
        "id": 31,
        "className": "Person",
        coords: [
            708.0,
            448.0,
            827.0,
            603.0
        ],
        "status": "Moving",
        "speed": 42.42,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:26.500000",
        "id": 15,
        "className": "Person",
        coords: [
            13.0,
            206.0,
            60.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:26.500000",
        "id": 23,
        "className": "Person",
        coords: [
            503.0,
            253.0,
            583.0,
            342.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:26.600000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            194.0,
            176.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:26.600000",
        "id": 33,
        "className": "Person",
        coords: [
            560.0,
            528.0,
            675.0,
            719.0
        ],
        "status": "Moving",
        "speed": 214.75,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:26.700000",
        "id": 21,
        "className": "Person",
        coords: [
            345.0,
            533.0,
            450.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:26.700000",
        "id": 31,
        "className": "Person",
        coords: [
            710.0,
            448.0,
            829.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:26.900000",
        "id": 15,
        "className": "Person",
        coords: [
            13.0,
            206.0,
            60.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:26.900000",
        "id": 23,
        "className": "Person",
        coords: [
            504.0,
            253.0,
            582.0,
            342.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:27",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            194.0,
            176.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:27",
        "id": 33,
        "className": "Person",
        coords: [
            547.0,
            535.0,
            661.0,
            719.0
        ],
        "status": "Moving",
        "speed": 204.01,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:27.100000",
        "id": 21,
        "className": "Person",
        coords: [
            346.0,
            533.0,
            450.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:27.100000",
        "id": 31,
        "className": "Person",
        coords: [
            708.0,
            448.0,
            827.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:27.300000",
        "id": 15,
        "className": "Person",
        coords: [
            13.0,
            207.0,
            60.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:27.300000",
        "id": 23,
        "className": "Person",
        coords: [
            505.0,
            253.0,
            582.0,
            342.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:27.400000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            194.0,
            176.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:27.400000",
        "id": 33,
        "className": "Person",
        coords: [
            538.0,
            542.0,
            650.0,
            719.0
        ],
        "status": "Moving",
        "speed": 156.59,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:27.500000",
        "id": 21,
        "className": "Person",
        coords: [
            346.0,
            533.0,
            451.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:27.500000",
        "id": 31,
        "className": "Person",
        coords: [
            707.0,
            448.0,
            826.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:27.700000",
        "id": 15,
        "className": "Person",
        coords: [
            13.0,
            207.0,
            60.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:27.800000",
        "id": 23,
        "className": "Person",
        coords: [
            507.0,
            253.0,
            582.0,
            342.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:27.800000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            194.0,
            176.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:27.900000",
        "id": 33,
        "className": "Person",
        coords: [
            527.0,
            547.0,
            638.0,
            719.0
        ],
        "status": "Moving",
        "speed": 185.52,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:27.900000",
        "id": 21,
        "className": "Person",
        coords: [
            346.0,
            533.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:28",
        "id": 31,
        "className": "Person",
        coords: [
            708.0,
            448.0,
            828.0,
            604.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:28.100000",
        "id": 15,
        "className": "Person",
        coords: [
            13.0,
            208.0,
            60.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:28.200000",
        "id": 23,
        "className": "Person",
        coords: [
            509.0,
            253.0,
            583.0,
            344.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:28.200000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            194.0,
            176.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:28.300000",
        "id": 33,
        "className": "Person",
        coords: [
            517.0,
            549.0,
            627.0,
            719.0
        ],
        "status": "Moving",
        "speed": 150.74,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:28.300000",
        "id": 21,
        "className": "Person",
        coords: [
            346.0,
            533.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:28.400000",
        "id": 31,
        "className": "Person",
        coords: [
            708.0,
            449.0,
            828.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:28.500000",
        "id": 15,
        "className": "Person",
        coords: [
            13.0,
            208.0,
            60.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:28.600000",
        "id": 23,
        "className": "Person",
        coords: [
            509.0,
            254.0,
            583.0,
            345.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:28.600000",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            194.0,
            176.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:28.600000",
        "id": 33,
        "className": "Person",
        coords: [
            506.0,
            551.0,
            615.0,
            719.0
        ],
        "status": "Moving",
        "speed": 180.61,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:28.700000",
        "id": 21,
        "className": "Person",
        coords: [
            346.0,
            533.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:28.700000",
        "id": 31,
        "className": "Person",
        coords: [
            708.0,
            449.0,
            828.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:28.900000",
        "id": 15,
        "className": "Person",
        coords: [
            14.0,
            208.0,
            59.0,
            333.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:28.900000",
        "id": 23,
        "className": "Person",
        coords: [
            514.0,
            254.0,
            586.0,
            346.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:29",
        "id": 22,
        "className": "Person",
        coords: [
            142.0,
            194.0,
            177.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:29",
        "id": 33,
        "className": "Person",
        coords: [
            494.0,
            551.0,
            603.0,
            719.0
        ],
        "status": "Moving",
        "speed": 179.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:29.100000",
        "id": 21,
        "className": "Person",
        coords: [
            346.0,
            533.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:29.100000",
        "id": 31,
        "className": "Person",
        coords: [
            683.0,
            448.0,
            810.0,
            602.0
        ],
        "status": "Moving",
        "speed": 329.97,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:29.200000",
        "id": 32,
        "className": "Person",
        coords: [
            447.0,
            238.0,
            504.0,
            303.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:29.300000",
        "id": 15,
        "className": "Person",
        coords: [
            14.0,
            207.0,
            60.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:29.400000",
        "id": 23,
        "className": "Person",
        coords: [
            517.0,
            254.0,
            587.0,
            347.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:29.400000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            176.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:29.500000",
        "id": 33,
        "className": "Person",
        coords: [
            480.0,
            554.0,
            588.0,
            719.0
        ],
        "status": "Moving",
        "speed": 210.52,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:29.500000",
        "id": 21,
        "className": "Person",
        coords: [
            346.0,
            533.0,
            451.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:29.600000",
        "id": 31,
        "className": "Person",
        coords: [
            671.0,
            448.0,
            804.0,
            603.0
        ],
        "status": "Moving",
        "speed": 134.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:29.700000",
        "id": 15,
        "className": "Person",
        coords: [
            14.0,
            206.0,
            60.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:29.800000",
        "id": 23,
        "className": "Person",
        coords: [
            518.0,
            254.0,
            587.0,
            348.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:29.800000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            176.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:29.800000",
        "id": 33,
        "className": "Person",
        coords: [
            466.0,
            556.0,
            573.0,
            719.0
        ],
        "status": "Moving",
        "speed": 225.48,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:29.900000",
        "id": 21,
        "className": "Person",
        coords: [
            346.0,
            533.0,
            451.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:29.900000",
        "id": 31,
        "className": "Person",
        coords: [
            664.0,
            448.0,
            803.0,
            603.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:30.100000",
        "id": 15,
        "className": "Person",
        coords: [
            14.0,
            207.0,
            60.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:30.200000",
        "id": 23,
        "className": "Person",
        coords: [
            519.0,
            254.0,
            586.0,
            348.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:30.200000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            176.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:30.300000",
        "id": 33,
        "className": "Person",
        coords: [
            451.0,
            558.0,
            557.0,
            719.0
        ],
        "status": "Moving",
        "speed": 225.48,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:30.300000",
        "id": 21,
        "className": "Person",
        coords: [
            346.0,
            533.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:30.400000",
        "id": 31,
        "className": "Person",
        coords: [
            661.0,
            448.0,
            804.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:30.500000",
        "id": 15,
        "className": "Person",
        coords: [
            14.0,
            208.0,
            61.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:30.600000",
        "id": 23,
        "className": "Person",
        coords: [
            520.0,
            254.0,
            585.0,
            349.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:30.600000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            176.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:30.700000",
        "id": 33,
        "className": "Person",
        coords: [
            440.0,
            561.0,
            544.0,
            718.0
        ],
        "status": "Moving",
        "speed": 180.61,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:30.700000",
        "id": 21,
        "className": "Person",
        coords: [
            345.0,
            533.0,
            450.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:30.800000",
        "id": 31,
        "className": "Person",
        coords: [
            658.0,
            448.0,
            806.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:30.900000",
        "id": 15,
        "className": "Person",
        coords: [
            14.0,
            209.0,
            61.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:31",
        "id": 23,
        "className": "Person",
        coords: [
            520.0,
            254.0,
            584.0,
            348.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:31",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            176.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:31",
        "id": 33,
        "className": "Person",
        coords: [
            431.0,
            564.0,
            530.0,
            718.0
        ],
        "status": "Moving",
        "speed": 182.47,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:31",
        "id": 31,
        "className": "Person",
        coords: [
            656.0,
            448.0,
            808.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:31.100000",
        "id": 15,
        "className": "Person",
        coords: [
            14.0,
            208.0,
            61.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:31.100000",
        "id": 23,
        "className": "Person",
        coords: [
            521.0,
            254.0,
            583.0,
            348.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:31.100000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:31.200000",
        "id": 33,
        "className": "Person",
        coords: [
            415.0,
            564.0,
            513.0,
            718.0
        ],
        "status": "Moving",
        "speed": 239.98,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:31.200000",
        "id": 31,
        "className": "Person",
        coords: [
            670.0,
            448.0,
            821.0,
            602.0
        ],
        "status": "Moving",
        "speed": 194.98,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:31.200000",
        "id": 15,
        "className": "Person",
        coords: [
            14.0,
            207.0,
            61.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:31.300000",
        "id": 23,
        "className": "Person",
        coords: [
            521.0,
            254.0,
            581.0,
            347.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:31.300000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:31.300000",
        "id": 33,
        "className": "Person",
        coords: [
            386.0,
            561.0,
            488.0,
            718.0
        ],
        "status": "Moving",
        "speed": 406.08,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:31.300000",
        "id": 31,
        "className": "Person",
        coords: [
            676.0,
            448.0,
            826.0,
            602.0
        ],
        "status": "Moving",
        "speed": 89.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:31.400000",
        "id": 15,
        "className": "Person",
        coords: [
            13.0,
            207.0,
            61.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:31.400000",
        "id": 23,
        "className": "Person",
        coords: [
            522.0,
            253.0,
            581.0,
            345.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:31.400000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:31.400000",
        "id": 33,
        "className": "Person",
        coords: [
            377.0,
            561.0,
            477.0,
            718.0
        ],
        "status": "Moving",
        "speed": 149.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:31.400000",
        "id": 31,
        "className": "Person",
        coords: [
            676.0,
            448.0,
            827.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:31.500000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            207.0,
            61.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:31.500000",
        "id": 23,
        "className": "Person",
        coords: [
            523.0,
            253.0,
            579.0,
            343.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:31.500000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:31.500000",
        "id": 31,
        "className": "Person",
        coords: [
            677.0,
            448.0,
            828.0,
            601.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:31.600000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            206.0,
            61.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:31.600000",
        "id": 23,
        "className": "Person",
        coords: [
            524.0,
            253.0,
            579.0,
            341.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:31.600000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            177.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:31.600000",
        "id": 31,
        "className": "Person",
        coords: [
            679.0,
            448.0,
            829.0,
            602.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:31.700000",
        "id": 21,
        "className": "Person",
        coords: [
            330.0,
            550.0,
            432.0,
            718.0
        ],
        "status": "Moving",
        "speed": 275.34,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:31.700000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            205.0,
            62.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:31.700000",
        "id": 23,
        "className": "Person",
        coords: [
            525.0,
            253.0,
            579.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:31.700000",
        "id": 22,
        "className": "Person",
        coords: [
            139.0,
            193.0,
            176.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:31.700000",
        "id": 31,
        "className": "Person",
        coords: [
            679.0,
            448.0,
            830.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:31.800000",
        "id": 21,
        "className": "Person",
        coords: [
            319.0,
            553.0,
            423.0,
            718.0
        ],
        "status": "Moving",
        "speed": 150.74,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:31.800000",
        "id": 15,
        "className": "Person",
        coords: [
            9.0,
            205.0,
            61.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:31.800000",
        "id": 23,
        "className": "Person",
        coords: [
            526.0,
            253.0,
            578.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:31.800000",
        "id": 22,
        "className": "Person",
        coords: [
            139.0,
            193.0,
            177.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:31.900000",
        "id": 31,
        "className": "Person",
        coords: [
            679.0,
            448.0,
            830.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:31.900000",
        "id": 21,
        "className": "Person",
        coords: [
            311.0,
            553.0,
            415.0,
            718.0
        ],
        "status": "Moving",
        "speed": 119.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:31.900000",
        "id": 15,
        "className": "Person",
        coords: [
            8.0,
            204.0,
            61.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:32",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            177.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:32",
        "id": 31,
        "className": "Person",
        coords: [
            679.0,
            448.0,
            830.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:32",
        "id": 21,
        "className": "Person",
        coords: [
            303.0,
            555.0,
            406.0,
            717.0
        ],
        "status": "Moving",
        "speed": 135.82,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:32",
        "id": 15,
        "className": "Person",
        coords: [
            8.0,
            204.0,
            61.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:32.100000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            177.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:32.100000",
        "id": 31,
        "className": "Person",
        coords: [
            678.0,
            448.0,
            829.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:32.100000",
        "id": 21,
        "className": "Person",
        coords: [
            296.0,
            556.0,
            397.0,
            718.0
        ],
        "status": "Moving",
        "speed": 120.92,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:32.100000",
        "id": 23,
        "className": "Person",
        coords: [
            528.0,
            253.0,
            577.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:32.200000",
        "id": 15,
        "className": "Person",
        coords: [
            8.0,
            205.0,
            61.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:32.200000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:32.200000",
        "id": 31,
        "className": "Person",
        coords: [
            679.0,
            448.0,
            831.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:32.200000",
        "id": 21,
        "className": "Person",
        coords: [
            278.0,
            557.0,
            380.0,
            718.0
        ],
        "status": "Moving",
        "speed": 254.98,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:32.200000",
        "id": 34,
        "className": "Person",
        coords: [
            352.0,
            532.0,
            450.0,
            718.0
        ],
        "status": "First Seen",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:21:32.300000",
        "id": 23,
        "className": "Person",
        coords: [
            515.0,
            253.0,
            566.0,
            332.0
        ],
        "status": "Moving",
        "speed": 180.61,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:32.300000",
        "id": 15,
        "className": "Person",
        coords: [
            8.0,
            206.0,
            61.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:32.300000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:32.300000",
        "id": 31,
        "className": "Person",
        coords: [
            679.0,
            448.0,
            830.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:32.300000",
        "id": 21,
        "className": "Person",
        coords: [
            267.0,
            559.0,
            368.0,
            718.0
        ],
        "status": "Moving",
        "speed": 180.61,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:32.400000",
        "id": 34,
        "className": "Person",
        coords: [
            349.0,
            532.0,
            448.0,
            718.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:21:32.400000",
        "id": 23,
        "className": "Person",
        coords: [
            509.0,
            253.0,
            563.0,
            332.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:32.400000",
        "id": 15,
        "className": "Person",
        coords: [
            9.0,
            207.0,
            61.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:32.400000",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:32.500000",
        "id": 31,
        "className": "Person",
        coords: [
            680.0,
            448.0,
            831.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:32.500000",
        "id": 21,
        "className": "Person",
        coords: [
            260.0,
            560.0,
            360.0,
            718.0
        ],
        "status": "Moving",
        "speed": 106.06,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:32.500000",
        "id": 34,
        "className": "Person",
        coords: [
            347.0,
            533.0,
            446.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:21:32.500000",
        "id": 23,
        "className": "Person",
        coords: [
            507.0,
            253.0,
            564.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:32.600000",
        "id": 15,
        "className": "Person",
        coords: [
            9.0,
            207.0,
            61.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:32.600000",
        "id": 22,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            176.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:32.600000",
        "id": 31,
        "className": "Person",
        coords: [
            680.0,
            448.0,
            831.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:32.600000",
        "id": 21,
        "className": "Person",
        coords: [
            247.0,
            560.0,
            345.0,
            718.0
        ],
        "status": "Moving",
        "speed": 209.98,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:32.600000",
        "id": 34,
        "className": "Person",
        coords: [
            345.0,
            533.0,
            444.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:21:32.700000",
        "id": 23,
        "className": "Person",
        coords: [
            513.0,
            254.0,
            571.0,
            333.0
        ],
        "status": "Moving",
        "speed": 104.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:32.700000",
        "id": 15,
        "className": "Person",
        coords: [
            9.0,
            207.0,
            61.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:32.700000",
        "id": 31,
        "className": "Person",
        coords: [
            679.0,
            448.0,
            830.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:32.700000",
        "id": 21,
        "className": "Person",
        coords: [
            237.0,
            558.0,
            335.0,
            719.0
        ],
        "status": "Moving",
        "speed": 150.74,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:32.800000",
        "id": 34,
        "className": "Person",
        coords: [
            347.0,
            533.0,
            446.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:21:32.800000",
        "id": 23,
        "className": "Person",
        coords: [
            510.0,
            254.0,
            570.0,
            334.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:32.800000",
        "id": 15,
        "className": "Person",
        coords: [
            9.0,
            207.0,
            61.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:32.800000",
        "id": 31,
        "className": "Person",
        coords: [
            679.0,
            448.0,
            830.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:32.900000",
        "id": 21,
        "className": "Person",
        coords: [
            227.0,
            556.0,
            325.0,
            719.0
        ],
        "status": "Moving",
        "speed": 150.74,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:32.900000",
        "id": 34,
        "className": "Person",
        coords: [
            347.0,
            533.0,
            447.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:21:32.900000",
        "id": 23,
        "className": "Person",
        coords: [
            509.0,
            254.0,
            570.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:32.900000",
        "id": 15,
        "className": "Person",
        coords: [
            9.0,
            208.0,
            61.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:33",
        "id": 31,
        "className": "Person",
        coords: [
            679.0,
            448.0,
            830.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:33",
        "id": 21,
        "className": "Person",
        coords: [
            220.0,
            554.0,
            318.0,
            718.0
        ],
        "status": "Moving",
        "speed": 106.06,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:33",
        "id": 34,
        "className": "Person",
        coords: [
            347.0,
            533.0,
            447.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:33",
        "id": 23,
        "className": "Person",
        coords: [
            508.0,
            253.0,
            572.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:33.100000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            209.0,
            61.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:33.100000",
        "id": 31,
        "className": "Person",
        coords: [
            679.0,
            448.0,
            830.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:33.100000",
        "id": 21,
        "className": "Person",
        coords: [
            217.0,
            552.0,
            316.0,
            718.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:33.100000",
        "id": 34,
        "className": "Person",
        coords: [
            347.0,
            533.0,
            447.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:33.100000",
        "id": 23,
        "className": "Person",
        coords: [
            510.0,
            253.0,
            576.0,
            334.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:33.200000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            209.0,
            61.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:33.200000",
        "id": 31,
        "className": "Person",
        coords: [
            679.0,
            448.0,
            831.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:33.200000",
        "id": 21,
        "className": "Person",
        coords: [
            214.0,
            550.0,
            316.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:33.300000",
        "id": 34,
        "className": "Person",
        coords: [
            347.0,
            533.0,
            447.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:33.300000",
        "id": 23,
        "className": "Person",
        coords: [
            510.0,
            253.0,
            578.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:33.300000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            208.0,
            61.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:33.300000",
        "id": 31,
        "className": "Person",
        coords: [
            680.0,
            448.0,
            831.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:33.400000",
        "id": 34,
        "className": "Person",
        coords: [
            347.0,
            533.0,
            448.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:33.400000",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            252.0,
            581.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:33.400000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            209.0,
            61.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:33.400000",
        "id": 31,
        "className": "Person",
        coords: [
            680.0,
            448.0,
            831.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:33.500000",
        "id": 34,
        "className": "Person",
        coords: [
            348.0,
            534.0,
            449.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:33.500000",
        "id": 23,
        "className": "Person",
        coords: [
            513.0,
            251.0,
            584.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:33.500000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            209.0,
            61.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:33.500000",
        "id": 31,
        "className": "Person",
        coords: [
            681.0,
            448.0,
            831.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:33.600000",
        "id": 34,
        "className": "Person",
        coords: [
            347.0,
            533.0,
            449.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:33.600000",
        "id": 23,
        "className": "Person",
        coords: [
            518.0,
            250.0,
            589.0,
            338.0
        ],
        "status": "Moving",
        "speed": 74.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:33.600000",
        "id": 21,
        "className": "Person",
        coords: [
            190.0,
            545.0,
            295.0,
            717.0
        ],
        "status": "Moving",
        "speed": 347.89,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:33.700000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            209.0,
            61.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:33.700000",
        "id": 31,
        "className": "Person",
        coords: [
            682.0,
            448.0,
            832.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:33.700000",
        "id": 34,
        "className": "Person",
        coords: [
            347.0,
            533.0,
            449.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:33.700000",
        "id": 23,
        "className": "Person",
        coords: [
            518.0,
            249.0,
            589.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:33.700000",
        "id": 21,
        "className": "Person",
        coords: [
            183.0,
            542.0,
            289.0,
            717.0
        ],
        "status": "Moving",
        "speed": 94.86,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:33.800000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            209.0,
            61.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:33.800000",
        "id": 31,
        "className": "Person",
        coords: [
            682.0,
            448.0,
            832.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:33.800000",
        "id": 34,
        "className": "Person",
        coords: [
            345.0,
            533.0,
            447.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:33.800000",
        "id": 23,
        "className": "Person",
        coords: [
            517.0,
            248.0,
            589.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:33.900000",
        "id": 21,
        "className": "Person",
        coords: [
            174.0,
            538.0,
            281.0,
            718.0
        ],
        "status": "Moving",
        "speed": 135.82,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:33.900000",
        "id": 22,
        "className": "Person",
        coords: [
            138.0,
            193.0,
            172.0,
            267.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:33.900000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            209.0,
            61.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:33.900000",
        "id": 34,
        "className": "Person",
        coords: [
            341.0,
            533.0,
            445.0,
            717.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:34",
        "id": 23,
        "className": "Person",
        coords: [
            517.0,
            248.0,
            589.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:34",
        "id": 21,
        "className": "Person",
        coords: [
            167.0,
            532.0,
            276.0,
            719.0
        ],
        "status": "Moving",
        "speed": 100.61,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:34",
        "id": 22,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            168.0,
            248.0
        ],
        "status": "Moving",
        "speed": 150.74,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:34",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            209.0,
            60.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:34",
        "id": 34,
        "className": "Person",
        coords: [
            345.0,
            533.0,
            449.0,
            718.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:34.100000",
        "id": 23,
        "className": "Person",
        coords: [
            516.0,
            247.0,
            589.0,
            341.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:34.100000",
        "id": 21,
        "className": "Person",
        coords: [
            161.0,
            526.0,
            273.0,
            719.0
        ],
        "status": "Moving",
        "speed": 74.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:34.100000",
        "id": 31,
        "className": "Person",
        coords: [
            681.0,
            448.0,
            832.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:34.200000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            208.0,
            60.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:34.200000",
        "id": 34,
        "className": "Person",
        coords: [
            346.0,
            533.0,
            450.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:34.200000",
        "id": 23,
        "className": "Person",
        coords: [
            521.0,
            246.0,
            592.0,
            342.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:34.200000",
        "id": 21,
        "className": "Person",
        coords: [
            159.0,
            519.0,
            273.0,
            719.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:34.200000",
        "id": 31,
        "className": "Person",
        coords: [
            679.0,
            448.0,
            831.0,
            605.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:34.300000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            208.0,
            60.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:34.300000",
        "id": 34,
        "className": "Person",
        coords: [
            346.0,
            534.0,
            450.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:34.300000",
        "id": 23,
        "className": "Person",
        coords: [
            523.0,
            246.0,
            593.0,
            342.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:34.300000",
        "id": 21,
        "className": "Person",
        coords: [
            156.0,
            515.0,
            271.0,
            718.0
        ],
        "status": "Moving",
        "speed": 63.63,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:34.400000",
        "id": 31,
        "className": "Person",
        coords: [
            678.0,
            448.0,
            830.0,
            605.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:34.400000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            210.0,
            60.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:34.400000",
        "id": 34,
        "className": "Person",
        coords: [
            347.0,
            534.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:34.400000",
        "id": 23,
        "className": "Person",
        coords: [
            525.0,
            246.0,
            594.0,
            343.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:34.500000",
        "id": 21,
        "className": "Person",
        coords: [
            155.0,
            511.0,
            270.0,
            717.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:34.500000",
        "id": 31,
        "className": "Person",
        coords: [
            678.0,
            448.0,
            830.0,
            606.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:34.500000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            210.0,
            60.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:34.500000",
        "id": 34,
        "className": "Person",
        coords: [
            347.0,
            534.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:34.600000",
        "id": 23,
        "className": "Person",
        coords: [
            526.0,
            246.0,
            593.0,
            343.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:34.600000",
        "id": 21,
        "className": "Person",
        coords: [
            154.0,
            508.0,
            270.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:34.600000",
        "id": 31,
        "className": "Person",
        coords: [
            678.0,
            448.0,
            831.0,
            607.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:34.600000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            210.0,
            60.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:34.700000",
        "id": 34,
        "className": "Person",
        coords: [
            347.0,
            533.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:34.700000",
        "id": 23,
        "className": "Person",
        coords: [
            525.0,
            245.0,
            592.0,
            343.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:34.700000",
        "id": 21,
        "className": "Person",
        coords: [
            154.0,
            506.0,
            269.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:34.700000",
        "id": 31,
        "className": "Person",
        coords: [
            679.0,
            448.0,
            831.0,
            606.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:34.800000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            210.0,
            60.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:34.800000",
        "id": 34,
        "className": "Person",
        coords: [
            347.0,
            534.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:34.800000",
        "id": 23,
        "className": "Person",
        coords: [
            526.0,
            244.0,
            592.0,
            343.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:34.800000",
        "id": 21,
        "className": "Person",
        coords: [
            154.0,
            505.0,
            269.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:34.800000",
        "id": 31,
        "className": "Person",
        coords: [
            678.0,
            448.0,
            831.0,
            607.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:34.900000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            210.0,
            60.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:34.900000",
        "id": 34,
        "className": "Person",
        coords: [
            347.0,
            534.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:34.900000",
        "id": 23,
        "className": "Person",
        coords: [
            522.0,
            244.0,
            588.0,
            342.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:34.900000",
        "id": 31,
        "className": "Person",
        coords: [
            678.0,
            448.0,
            830.0,
            607.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:35",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            210.0,
            60.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:35",
        "id": 34,
        "className": "Person",
        coords: [
            347.0,
            534.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:35",
        "id": 23,
        "className": "Person",
        coords: [
            526.0,
            244.0,
            590.0,
            342.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:35",
        "id": 31,
        "className": "Person",
        coords: [
            678.0,
            448.0,
            831.0,
            608.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:35.100000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            209.0,
            60.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:35.100000",
        "id": 34,
        "className": "Person",
        coords: [
            345.0,
            534.0,
            450.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:35.100000",
        "id": 23,
        "className": "Person",
        coords: [
            523.0,
            244.0,
            588.0,
            342.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:35.200000",
        "id": 31,
        "className": "Person",
        coords: [
            676.0,
            447.0,
            830.0,
            608.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:35.200000",
        "id": 21,
        "className": "Person",
        coords: [
            155.0,
            506.0,
            268.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:35.200000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            211.0,
            60.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:35.200000",
        "id": 34,
        "className": "Person",
        coords: [
            346.0,
            534.0,
            450.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:35.200000",
        "id": 23,
        "className": "Person",
        coords: [
            521.0,
            245.0,
            587.0,
            342.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:35.300000",
        "id": 31,
        "className": "Person",
        coords: [
            674.0,
            447.0,
            831.0,
            612.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:35.300000",
        "id": 21,
        "className": "Person",
        coords: [
            150.0,
            502.0,
            266.0,
            718.0
        ],
        "status": "Moving",
        "speed": 54.08,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:35.300000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            212.0,
            59.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:35.300000",
        "id": 34,
        "className": "Person",
        coords: [
            347.0,
            534.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:35.400000",
        "id": 23,
        "className": "Person",
        coords: [
            527.0,
            246.0,
            591.0,
            343.0
        ],
        "status": "Moving",
        "speed": 76.48,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:35.400000",
        "id": 31,
        "className": "Person",
        coords: [
            673.0,
            448.0,
            832.0,
            615.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:35.400000",
        "id": 21,
        "className": "Person",
        coords: [
            148.0,
            499.0,
            266.0,
            718.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:35.500000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            213.0,
            59.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:35.500000",
        "id": 34,
        "className": "Person",
        coords: [
            347.0,
            534.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:35.500000",
        "id": 23,
        "className": "Person",
        coords: [
            523.0,
            245.0,
            589.0,
            343.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:35.500000",
        "id": 31,
        "className": "Person",
        coords: [
            673.0,
            447.0,
            830.0,
            612.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:35.500000",
        "id": 21,
        "className": "Person",
        coords: [
            148.0,
            498.0,
            267.0,
            719.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:35.600000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            213.0,
            59.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:35.600000",
        "id": 34,
        "className": "Person",
        coords: [
            347.0,
            534.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:35.600000",
        "id": 23,
        "className": "Person",
        coords: [
            520.0,
            245.0,
            588.0,
            344.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:35.600000",
        "id": 31,
        "className": "Person",
        coords: [
            673.0,
            447.0,
            830.0,
            613.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:35.700000",
        "id": 21,
        "className": "Person",
        coords: [
            147.0,
            496.0,
            268.0,
            719.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:35.700000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            214.0,
            59.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:35.700000",
        "id": 34,
        "className": "Person",
        coords: [
            346.0,
            534.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:35.700000",
        "id": 23,
        "className": "Person",
        coords: [
            520.0,
            243.0,
            589.0,
            344.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:35.800000",
        "id": 31,
        "className": "Person",
        coords: [
            675.0,
            447.0,
            829.0,
            610.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:35.800000",
        "id": 21,
        "className": "Person",
        coords: [
            141.0,
            489.0,
            266.0,
            719.0
        ],
        "status": "Moving",
        "speed": 74.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:35.800000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            212.0,
            60.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:35.800000",
        "id": 34,
        "className": "Person",
        coords: [
            347.0,
            534.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:35.900000",
        "id": 23,
        "className": "Person",
        coords: [
            520.0,
            242.0,
            590.0,
            343.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:35.900000",
        "id": 31,
        "className": "Person",
        coords: [
            675.0,
            447.0,
            828.0,
            609.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:35.900000",
        "id": 21,
        "className": "Person",
        coords: [
            132.0,
            480.0,
            261.0,
            718.0
        ],
        "status": "Moving",
        "speed": 129.02,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:35.900000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            209.0,
            60.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:36",
        "id": 34,
        "className": "Person",
        coords: [
            347.0,
            534.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:36",
        "id": 23,
        "className": "Person",
        coords: [
            520.0,
            242.0,
            590.0,
            343.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:36",
        "id": 31,
        "className": "Person",
        coords: [
            675.0,
            447.0,
            829.0,
            609.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:36",
        "id": 21,
        "className": "Person",
        coords: [
            126.0,
            473.0,
            258.0,
            718.0
        ],
        "status": "Moving",
        "speed": 84.85,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:36",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            209.0,
            60.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:36.100000",
        "id": 34,
        "className": "Person",
        coords: [
            347.0,
            534.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:36.100000",
        "id": 23,
        "className": "Person",
        coords: [
            520.0,
            242.0,
            592.0,
            345.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:36.100000",
        "id": 31,
        "className": "Person",
        coords: [
            675.0,
            447.0,
            829.0,
            609.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:36.100000",
        "id": 21,
        "className": "Person",
        coords: [
            124.0,
            469.0,
            256.0,
            718.0
        ],
        "status": "Moving",
        "speed": 42.42,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:36.200000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            209.0,
            60.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:36.200000",
        "id": 34,
        "className": "Person",
        coords: [
            348.0,
            534.0,
            451.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:36.200000",
        "id": 23,
        "className": "Person",
        coords: [
            520.0,
            242.0,
            591.0,
            345.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:36.200000",
        "id": 21,
        "className": "Person",
        coords: [
            119.0,
            461.0,
            254.0,
            717.0
        ],
        "status": "Moving",
        "speed": 84.85,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:36.300000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            208.0,
            60.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:36.300000",
        "id": 34,
        "className": "Person",
        coords: [
            348.0,
            534.0,
            451.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:36.300000",
        "id": 23,
        "className": "Person",
        coords: [
            525.0,
            242.0,
            595.0,
            343.0
        ],
        "status": "Moving",
        "speed": 76.48,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:36.300000",
        "id": 21,
        "className": "Person",
        coords: [
            115.0,
            457.0,
            246.0,
            712.0
        ],
        "status": "Moving",
        "speed": 117.14,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:36.400000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            209.0,
            60.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:36.400000",
        "id": 34,
        "className": "Person",
        coords: [
            347.0,
            534.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:36.400000",
        "id": 23,
        "className": "Person",
        coords: [
            521.0,
            241.0,
            592.0,
            343.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:36.400000",
        "id": 21,
        "className": "Person",
        coords: [
            115.0,
            454.0,
            246.0,
            713.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:36.500000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            210.0,
            60.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:36.500000",
        "id": 34,
        "className": "Person",
        coords: [
            346.0,
            534.0,
            450.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:36.500000",
        "id": 23,
        "className": "Person",
        coords: [
            521.0,
            239.0,
            591.0,
            341.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:36.500000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            210.0,
            60.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:36.500000",
        "id": 34,
        "className": "Person",
        coords: [
            332.0,
            534.0,
            440.0,
            718.0
        ],
        "status": "Moving",
        "speed": 179.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:36.600000",
        "id": 23,
        "className": "Person",
        coords: [
            520.0,
            235.0,
            590.0,
            340.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:36.600000",
        "id": 31,
        "className": "Person",
        coords: [
            659.0,
            447.0,
            814.0,
            605.0
        ],
        "status": "Moving",
        "speed": 241.85,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:36.600000",
        "id": 21,
        "className": "Person",
        coords: [
            119.0,
            449.0,
            228.0,
            664.0
        ],
        "status": "Moving",
        "speed": 418.36,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:36.700000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            211.0,
            59.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:36.700000",
        "id": 34,
        "className": "Person",
        coords: [
            341.0,
            534.0,
            448.0,
            718.0
        ],
        "status": "Moving",
        "speed": 119.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:36.700000",
        "id": 23,
        "className": "Person",
        coords: [
            519.0,
            232.0,
            590.0,
            339.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:36.700000",
        "id": 31,
        "className": "Person",
        coords: [
            656.0,
            447.0,
            814.0,
            605.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:36.700000",
        "id": 21,
        "className": "Person",
        coords: [
            122.0,
            464.0,
            216.0,
            652.0
        ],
        "status": "Moving",
        "speed": 67.08,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:36.800000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            210.0,
            60.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:36.800000",
        "id": 34,
        "className": "Person",
        coords: [
            344.0,
            534.0,
            451.0,
            718.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:36.800000",
        "id": 23,
        "className": "Person",
        coords: [
            520.0,
            230.0,
            589.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:36.800000",
        "id": 31,
        "className": "Person",
        coords: [
            655.0,
            447.0,
            814.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:36.900000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            210.0,
            60.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:36.900000",
        "id": 34,
        "className": "Person",
        coords: [
            345.0,
            534.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:36.900000",
        "id": 23,
        "className": "Person",
        coords: [
            517.0,
            234.0,
            582.0,
            338.0
        ],
        "status": "Moving",
        "speed": 80.77,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:37",
        "id": 31,
        "className": "Person",
        coords: [
            653.0,
            447.0,
            815.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:37",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            210.0,
            60.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:37",
        "id": 34,
        "className": "Person",
        coords: [
            346.0,
            534.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:37",
        "id": 23,
        "className": "Person",
        coords: [
            516.0,
            236.0,
            578.0,
            338.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:37",
        "id": 31,
        "className": "Person",
        coords: [
            651.0,
            447.0,
            816.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:37.100000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            209.0,
            59.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:37.100000",
        "id": 34,
        "className": "Person",
        coords: [
            346.0,
            534.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:37.100000",
        "id": 23,
        "className": "Person",
        coords: [
            515.0,
            238.0,
            575.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:37.100000",
        "id": 31,
        "className": "Person",
        coords: [
            650.0,
            448.0,
            817.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:37.200000",
        "id": 15,
        "className": "Person",
        coords: [
            9.0,
            209.0,
            59.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:37.200000",
        "id": 34,
        "className": "Person",
        coords: [
            346.0,
            534.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:37.200000",
        "id": 23,
        "className": "Person",
        coords: [
            511.0,
            237.0,
            571.0,
            336.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:37.200000",
        "id": 31,
        "className": "Person",
        coords: [
            650.0,
            447.0,
            819.0,
            604.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:37.300000",
        "id": 21,
        "className": "Person",
        coords: [
            87.0,
            435.0,
            195.0,
            651.0
        ],
        "status": "Moving",
        "speed": 476.43,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:37.300000",
        "id": 15,
        "className": "Person",
        coords: [
            9.0,
            208.0,
            59.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:37.300000",
        "id": 34,
        "className": "Person",
        coords: [
            346.0,
            534.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:37.300000",
        "id": 23,
        "className": "Person",
        coords: [
            508.0,
            234.0,
            568.0,
            335.0
        ],
        "status": "Moving",
        "speed": 54.08,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:37.400000",
        "id": 21,
        "className": "Person",
        coords: [
            80.0,
            427.0,
            193.0,
            651.0
        ],
        "status": "Moving",
        "speed": 96.04,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:37.400000",
        "id": 15,
        "className": "Person",
        coords: [
            9.0,
            206.0,
            60.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:37.400000",
        "id": 34,
        "className": "Person",
        coords: [
            347.0,
            534.0,
            453.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:37.400000",
        "id": 23,
        "className": "Person",
        coords: [
            505.0,
            233.0,
            566.0,
            334.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:37.500000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            204.0,
            61.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:37.500000",
        "id": 34,
        "className": "Person",
        coords: [
            347.0,
            533.0,
            452.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:37.500000",
        "id": 23,
        "className": "Person",
        coords: [
            503.0,
            233.0,
            564.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:37.500000",
        "id": 21,
        "className": "Person",
        coords: [
            69.0,
            416.0,
            187.0,
            650.0
        ],
        "status": "Moving",
        "speed": 149.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:37.600000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            204.0,
            61.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:37.600000",
        "id": 34,
        "className": "Person",
        coords: [
            347.0,
            533.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:37.600000",
        "id": 23,
        "className": "Person",
        coords: [
            503.0,
            232.0,
            564.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:37.600000",
        "id": 21,
        "className": "Person",
        coords: [
            64.0,
            412.0,
            186.0,
            650.0
        ],
        "status": "Moving",
        "speed": 54.08,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:37.700000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            204.0,
            61.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:37.700000",
        "id": 34,
        "className": "Person",
        coords: [
            347.0,
            533.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:37.700000",
        "id": 23,
        "className": "Person",
        coords: [
            505.0,
            230.0,
            566.0,
            334.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:37.700000",
        "id": 21,
        "className": "Person",
        coords: [
            61.0,
            409.0,
            186.0,
            649.0
        ],
        "status": "Moving",
        "speed": 42.42,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:37.700000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            204.0,
            61.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:37.800000",
        "id": 34,
        "className": "Person",
        coords: [
            348.0,
            533.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:37.800000",
        "id": 23,
        "className": "Person",
        coords: [
            507.0,
            234.0,
            564.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:37.800000",
        "id": 21,
        "className": "Person",
        coords: [
            59.0,
            407.0,
            186.0,
            648.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:37.800000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            204.0,
            61.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:37.900000",
        "id": 34,
        "className": "Person",
        coords: [
            348.0,
            533.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:37.900000",
        "id": 23,
        "className": "Person",
        coords: [
            507.0,
            236.0,
            562.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:37.900000",
        "id": 21,
        "className": "Person",
        coords: [
            58.0,
            404.0,
            186.0,
            647.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:37.900000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            207.0,
            60.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:38",
        "id": 34,
        "className": "Person",
        coords: [
            347.0,
            534.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:38",
        "id": 23,
        "className": "Person",
        coords: [
            508.0,
            238.0,
            561.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:38",
        "id": 21,
        "className": "Person",
        coords: [
            57.0,
            403.0,
            185.0,
            643.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:38",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            208.0,
            60.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:38",
        "id": 34,
        "className": "Person",
        coords: [
            348.0,
            534.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:38.100000",
        "id": 23,
        "className": "Person",
        coords: [
            509.0,
            239.0,
            559.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:38.100000",
        "id": 21,
        "className": "Person",
        coords: [
            55.0,
            399.0,
            186.0,
            645.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:38.100000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            209.0,
            60.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:38.100000",
        "id": 34,
        "className": "Person",
        coords: [
            348.0,
            534.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:38.200000",
        "id": 23,
        "className": "Person",
        coords: [
            509.0,
            240.0,
            558.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:38.200000",
        "id": 21,
        "className": "Person",
        coords: [
            55.0,
            394.0,
            187.0,
            643.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:38.200000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            209.0,
            59.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:38.200000",
        "id": 34,
        "className": "Person",
        coords: [
            348.0,
            534.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:38.200000",
        "id": 23,
        "className": "Person",
        coords: [
            509.0,
            240.0,
            556.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:38.300000",
        "id": 21,
        "className": "Person",
        coords: [
            52.0,
            389.0,
            188.0,
            647.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:38.300000",
        "id": 15,
        "className": "Person",
        coords: [
            9.0,
            210.0,
            58.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:38.300000",
        "id": 34,
        "className": "Person",
        coords: [
            348.0,
            534.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:38.300000",
        "id": 23,
        "className": "Person",
        coords: [
            509.0,
            240.0,
            555.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:38.300000",
        "id": 21,
        "className": "Person",
        coords: [
            50.0,
            388.0,
            190.0,
            653.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:38.400000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            212.0,
            58.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:38.400000",
        "id": 34,
        "className": "Person",
        coords: [
            348.0,
            534.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:38.400000",
        "id": 23,
        "className": "Person",
        coords: [
            509.0,
            240.0,
            554.0,
            325.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:38.400000",
        "id": 21,
        "className": "Person",
        coords: [
            48.0,
            385.0,
            189.0,
            655.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:38.500000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            212.0,
            59.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:38.500000",
        "id": 34,
        "className": "Person",
        coords: [
            349.0,
            535.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:38.500000",
        "id": 23,
        "className": "Person",
        coords: [
            509.0,
            240.0,
            553.0,
            324.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:38.500000",
        "id": 21,
        "className": "Person",
        coords: [
            46.0,
            384.0,
            190.0,
            659.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:38.600000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            212.0,
            59.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:38.600000",
        "id": 34,
        "className": "Person",
        coords: [
            349.0,
            535.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:38.600000",
        "id": 23,
        "className": "Person",
        coords: [
            509.0,
            240.0,
            552.0,
            323.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:38.600000",
        "id": 21,
        "className": "Person",
        coords: [
            45.0,
            378.0,
            191.0,
            660.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:38.700000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            212.0,
            59.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:38.700000",
        "id": 34,
        "className": "Person",
        coords: [
            349.0,
            535.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:38.700000",
        "id": 23,
        "className": "Person",
        coords: [
            509.0,
            240.0,
            551.0,
            323.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:38.800000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            211.0,
            60.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:38.800000",
        "id": 34,
        "className": "Person",
        coords: [
            349.0,
            535.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:38.800000",
        "id": 23,
        "className": "Person",
        coords: [
            507.0,
            241.0,
            550.0,
            324.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:38.800000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            211.0,
            60.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:38.900000",
        "id": 34,
        "className": "Person",
        coords: [
            349.0,
            535.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:38.900000",
        "id": 23,
        "className": "Person",
        coords: [
            507.0,
            242.0,
            549.0,
            325.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:38.900000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            212.0,
            60.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:38.900000",
        "id": 34,
        "className": "Person",
        coords: [
            349.0,
            536.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:38.900000",
        "id": 23,
        "className": "Person",
        coords: [
            507.0,
            242.0,
            549.0,
            325.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:39",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            213.0,
            60.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:39",
        "id": 34,
        "className": "Person",
        coords: [
            349.0,
            536.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:39",
        "id": 23,
        "className": "Person",
        coords: [
            507.0,
            243.0,
            549.0,
            325.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:39.100000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            214.0,
            59.0,
            338.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:39.100000",
        "id": 34,
        "className": "Person",
        coords: [
            349.0,
            536.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:39.100000",
        "id": 23,
        "className": "Person",
        coords: [
            507.0,
            243.0,
            549.0,
            325.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:39.100000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            211.0,
            61.0,
            337.0
        ],
        "status": "Moving",
        "speed": 42.42,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:39.200000",
        "id": 34,
        "className": "Person",
        coords: [
            349.0,
            536.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:39.200000",
        "id": 23,
        "className": "Person",
        coords: [
            506.0,
            242.0,
            549.0,
            325.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:39.200000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            212.0,
            61.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:39.200000",
        "id": 34,
        "className": "Person",
        coords: [
            349.0,
            536.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:39.300000",
        "id": 23,
        "className": "Person",
        coords: [
            506.0,
            242.0,
            549.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:39.300000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            210.0,
            61.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:39.300000",
        "id": 34,
        "className": "Person",
        coords: [
            349.0,
            536.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:39.300000",
        "id": 23,
        "className": "Person",
        coords: [
            507.0,
            243.0,
            549.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:39.400000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            209.0,
            61.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:39.400000",
        "id": 34,
        "className": "Person",
        coords: [
            349.0,
            536.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:39.400000",
        "id": 23,
        "className": "Person",
        coords: [
            507.0,
            242.0,
            549.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:39.500000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            210.0,
            61.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:39.500000",
        "id": 34,
        "className": "Person",
        coords: [
            349.0,
            537.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:39.500000",
        "id": 23,
        "className": "Person",
        coords: [
            507.0,
            241.0,
            550.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:39.500000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            210.0,
            60.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:39.600000",
        "id": 34,
        "className": "Person",
        coords: [
            349.0,
            537.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:39.600000",
        "id": 23,
        "className": "Person",
        coords: [
            507.0,
            240.0,
            549.0,
            325.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:39.600000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            209.0,
            61.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:39.600000",
        "id": 34,
        "className": "Person",
        coords: [
            349.0,
            537.0,
            452.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:39.700000",
        "id": 23,
        "className": "Person",
        coords: [
            506.0,
            240.0,
            549.0,
            325.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:39.700000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            209.0,
            60.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:39.700000",
        "id": 34,
        "className": "Person",
        coords: [
            349.0,
            537.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:39.700000",
        "id": 23,
        "className": "Person",
        coords: [
            506.0,
            238.0,
            549.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:39.700000",
        "id": 21,
        "className": "Person",
        coords: [
            22.0,
            344.0,
            133.0,
            570.0
        ],
        "status": "Moving",
        "speed": 1114.86,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:39.800000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            209.0,
            60.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:39.800000",
        "id": 34,
        "className": "Person",
        coords: [
            349.0,
            537.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:39.800000",
        "id": 23,
        "className": "Person",
        coords: [
            505.0,
            236.0,
            550.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:39.800000",
        "id": 21,
        "className": "Person",
        coords: [
            23.0,
            338.0,
            129.0,
            563.0
        ],
        "status": "Moving",
        "speed": 106.06,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:39.900000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            209.0,
            60.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:39.900000",
        "id": 34,
        "className": "Person",
        coords: [
            349.0,
            537.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:39.900000",
        "id": 23,
        "className": "Person",
        coords: [
            505.0,
            236.0,
            550.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:39.900000",
        "id": 21,
        "className": "Person",
        coords: [
            27.0,
            337.0,
            125.0,
            550.0
        ],
        "status": "Moving",
        "speed": 104.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:40",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            211.0,
            60.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:40",
        "id": 34,
        "className": "Person",
        coords: [
            349.0,
            537.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:40",
        "id": 23,
        "className": "Person",
        coords: [
            505.0,
            235.0,
            549.0,
            325.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:40",
        "id": 21,
        "className": "Person",
        coords: [
            30.0,
            331.0,
            122.0,
            534.0
        ],
        "status": "Moving",
        "speed": 164.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:40.100000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            211.0,
            59.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:40.100000",
        "id": 34,
        "className": "Person",
        coords: [
            349.0,
            538.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:40.100000",
        "id": 23,
        "className": "Person",
        coords: [
            505.0,
            235.0,
            548.0,
            325.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:40.100000",
        "id": 21,
        "className": "Person",
        coords: [
            32.0,
            328.0,
            121.0,
            526.0
        ],
        "status": "Moving",
        "speed": 74.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:40.200000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            212.0,
            58.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:40.200000",
        "id": 34,
        "className": "Person",
        coords: [
            349.0,
            538.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:40.200000",
        "id": 23,
        "className": "Person",
        coords: [
            506.0,
            234.0,
            548.0,
            324.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:40.200000",
        "id": 21,
        "className": "Person",
        coords: [
            33.0,
            327.0,
            121.0,
            524.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:40.300000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            211.0,
            58.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:40.300000",
        "id": 34,
        "className": "Person",
        coords: [
            349.0,
            538.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:40.300000",
        "id": 23,
        "className": "Person",
        coords: [
            506.0,
            234.0,
            549.0,
            324.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:40.300000",
        "id": 21,
        "className": "Person",
        coords: [
            33.0,
            327.0,
            120.0,
            524.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:40.300000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            211.0,
            58.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:40.400000",
        "id": 34,
        "className": "Person",
        coords: [
            349.0,
            538.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:40.400000",
        "id": 23,
        "className": "Person",
        coords: [
            506.0,
            234.0,
            548.0,
            324.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:40.400000",
        "id": 21,
        "className": "Person",
        coords: [
            33.0,
            325.0,
            120.0,
            524.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:40.400000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            211.0,
            58.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:40.500000",
        "id": 34,
        "className": "Person",
        coords: [
            350.0,
            538.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:40.500000",
        "id": 23,
        "className": "Person",
        coords: [
            506.0,
            234.0,
            549.0,
            324.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:40.500000",
        "id": 21,
        "className": "Person",
        coords: [
            32.0,
            323.0,
            119.0,
            524.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:40.500000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            211.0,
            58.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:40.500000",
        "id": 34,
        "className": "Person",
        coords: [
            350.0,
            538.0,
            452.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:40.600000",
        "id": 23,
        "className": "Person",
        coords: [
            506.0,
            235.0,
            549.0,
            324.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:40.600000",
        "id": 21,
        "className": "Person",
        coords: [
            33.0,
            330.0,
            117.0,
            524.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:40.600000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            210.0,
            59.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:40.600000",
        "id": 34,
        "className": "Person",
        coords: [
            349.0,
            538.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:40.600000",
        "id": 23,
        "className": "Person",
        coords: [
            506.0,
            235.0,
            549.0,
            324.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:40.700000",
        "id": 21,
        "className": "Person",
        coords: [
            30.0,
            324.0,
            115.0,
            524.0
        ],
        "status": "Moving",
        "speed": 63.63,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:40.700000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            211.0,
            59.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:40.700000",
        "id": 34,
        "className": "Person",
        coords: [
            349.0,
            538.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:40.700000",
        "id": 21,
        "className": "Person",
        coords: [
            33.0,
            330.0,
            112.0,
            512.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:40.800000",
        "id": 15,
        "className": "Person",
        coords: [
            14.0,
            209.0,
            57.0,
            321.0
        ],
        "status": "Moving",
        "speed": 119.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:40.800000",
        "id": 34,
        "className": "Person",
        coords: [
            349.0,
            538.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:40.800000",
        "id": 21,
        "className": "Person",
        coords: [
            32.0,
            328.0,
            109.0,
            503.0
        ],
        "status": "Moving",
        "speed": 94.86,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:40.800000",
        "id": 15,
        "className": "Person",
        coords: [
            15.0,
            208.0,
            57.0,
            314.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:40.900000",
        "id": 34,
        "className": "Person",
        coords: [
            349.0,
            538.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:40.900000",
        "id": 21,
        "className": "Person",
        coords: [
            26.0,
            313.0,
            108.0,
            500.0
        ],
        "status": "Moving",
        "speed": 142.29,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:40.900000",
        "id": 23,
        "className": "Person",
        coords: [
            506.0,
            235.0,
            551.0,
            325.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:40.900000",
        "id": 34,
        "className": "Person",
        coords: [
            349.0,
            538.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:40.900000",
        "id": 21,
        "className": "Person",
        coords: [
            21.0,
            304.0,
            106.0,
            499.0
        ],
        "status": "Moving",
        "speed": 96.04,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:41",
        "id": 23,
        "className": "Person",
        coords: [
            507.0,
            235.0,
            551.0,
            323.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:41",
        "id": 34,
        "className": "Person",
        coords: [
            349.0,
            538.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:41",
        "id": 21,
        "className": "Person",
        coords: [
            19.0,
            299.0,
            105.0,
            498.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:41",
        "id": 23,
        "className": "Person",
        coords: [
            507.0,
            235.0,
            551.0,
            321.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:41.100000",
        "id": 34,
        "className": "Person",
        coords: [
            349.0,
            538.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:41.100000",
        "id": 21,
        "className": "Person",
        coords: [
            18.0,
            296.0,
            105.0,
            498.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:41.100000",
        "id": 23,
        "className": "Person",
        coords: [
            506.0,
            235.0,
            552.0,
            324.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:41.200000",
        "id": 34,
        "className": "Person",
        coords: [
            349.0,
            538.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:41.200000",
        "id": 21,
        "className": "Person",
        coords: [
            18.0,
            294.0,
            106.0,
            498.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:41.200000",
        "id": 23,
        "className": "Person",
        coords: [
            506.0,
            235.0,
            553.0,
            325.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:41.200000",
        "id": 34,
        "className": "Person",
        coords: [
            349.0,
            538.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:41.300000",
        "id": 21,
        "className": "Person",
        coords: [
            18.0,
            293.0,
            105.0,
            498.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:41.300000",
        "id": 23,
        "className": "Person",
        coords: [
            506.0,
            235.0,
            552.0,
            325.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:41.300000",
        "id": 15,
        "className": "Person",
        coords: [
            14.0,
            209.0,
            55.0,
            311.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:41.300000",
        "id": 21,
        "className": "Person",
        coords: [
            17.0,
            293.0,
            104.0,
            499.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:41.300000",
        "id": 23,
        "className": "Person",
        coords: [
            506.0,
            235.0,
            551.0,
            323.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:41.400000",
        "id": 15,
        "className": "Person",
        coords: [
            14.0,
            209.0,
            55.0,
            311.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:41.400000",
        "id": 21,
        "className": "Person",
        coords: [
            17.0,
            293.0,
            103.0,
            499.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:41.400000",
        "id": 23,
        "className": "Person",
        coords: [
            506.0,
            236.0,
            551.0,
            323.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:41.400000",
        "id": 15,
        "className": "Person",
        coords: [
            13.0,
            209.0,
            55.0,
            311.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:41.500000",
        "id": 21,
        "className": "Person",
        coords: [
            21.0,
            292.0,
            108.0,
            499.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:41.500000",
        "id": 23,
        "className": "Person",
        coords: [
            506.0,
            236.0,
            551.0,
            323.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:41.500000",
        "id": 15,
        "className": "Person",
        coords: [
            13.0,
            209.0,
            57.0,
            313.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:41.600000",
        "id": 21,
        "className": "Person",
        coords: [
            22.0,
            292.0,
            109.0,
            499.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:41.600000",
        "id": 23,
        "className": "Person",
        coords: [
            506.0,
            236.0,
            551.0,
            323.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:41.600000",
        "id": 15,
        "className": "Person",
        coords: [
            13.0,
            209.0,
            57.0,
            314.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:41.600000",
        "id": 34,
        "className": "Person",
        coords: [
            349.0,
            539.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:41.700000",
        "id": 23,
        "className": "Person",
        coords: [
            507.0,
            236.0,
            551.0,
            319.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:41.700000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            209.0,
            58.0,
            315.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:41.700000",
        "id": 34,
        "className": "Person",
        coords: [
            349.0,
            538.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:41.700000",
        "id": 32,
        "className": "Person",
        coords: [
            412.0,
            201.0,
            481.0,
            285.0
        ],
        "status": "Moving",
        "speed": 594.3,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:41.800000",
        "id": 23,
        "className": "Person",
        coords: [
            508.0,
            236.0,
            550.0,
            318.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:41.800000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            208.0,
            57.0,
            315.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:41.800000",
        "id": 34,
        "className": "Person",
        coords: [
            348.0,
            537.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:41.800000",
        "id": 32,
        "className": "Person",
        coords: [
            409.0,
            199.0,
            472.0,
            282.0
        ],
        "status": "Moving",
        "speed": 100.61,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:41.800000",
        "id": 23,
        "className": "Person",
        coords: [
            508.0,
            236.0,
            551.0,
            317.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:41.900000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            208.0,
            56.0,
            309.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:41.900000",
        "id": 34,
        "className": "Person",
        coords: [
            347.0,
            536.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:41.900000",
        "id": 32,
        "className": "Person",
        coords: [
            405.0,
            197.0,
            468.0,
            279.0
        ],
        "status": "Moving",
        "speed": 67.08,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:41.900000",
        "id": 23,
        "className": "Person",
        coords: [
            507.0,
            236.0,
            551.0,
            320.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:42",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            208.0,
            57.0,
            310.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:42",
        "id": 34,
        "className": "Person",
        coords: [
            345.0,
            535.0,
            450.0,
            718.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:42",
        "id": 32,
        "className": "Person",
        coords: [
            399.0,
            197.0,
            462.0,
            279.0
        ],
        "status": "Moving",
        "speed": 89.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:42",
        "id": 23,
        "className": "Person",
        coords: [
            506.0,
            235.0,
            552.0,
            323.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:42.100000",
        "id": 15,
        "className": "Person",
        coords: [
            10.0,
            209.0,
            56.0,
            307.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:42.100000",
        "id": 34,
        "className": "Person",
        coords: [
            344.0,
            534.0,
            450.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:42.100000",
        "id": 32,
        "className": "Person",
        coords: [
            406.0,
            192.0,
            481.0,
            281.0
        ],
        "status": "Moving",
        "speed": 197.28,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:42.200000",
        "id": 23,
        "className": "Person",
        coords: [
            506.0,
            235.0,
            552.0,
            324.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:42.200000",
        "id": 15,
        "className": "Person",
        coords: [
            8.0,
            211.0,
            52.0,
            305.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:42.200000",
        "id": 34,
        "className": "Person",
        coords: [
            343.0,
            533.0,
            449.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:42.200000",
        "id": 21,
        "className": "Person",
        coords: [
            23.0,
            283.0,
            115.0,
            500.0
        ],
        "status": "Moving",
        "speed": 84.85,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:42.200000",
        "id": 23,
        "className": "Person",
        coords: [
            506.0,
            235.0,
            552.0,
            324.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:42.300000",
        "id": 15,
        "className": "Person",
        coords: [
            9.0,
            210.0,
            52.0,
            303.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:42.300000",
        "id": 34,
        "className": "Person",
        coords: [
            343.0,
            532.0,
            450.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:42.300000",
        "id": 23,
        "className": "Person",
        coords: [
            503.0,
            234.0,
            550.0,
            326.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:42.300000",
        "id": 15,
        "className": "Person",
        coords: [
            8.0,
            210.0,
            50.0,
            301.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:42.400000",
        "id": 34,
        "className": "Person",
        coords: [
            342.0,
            530.0,
            450.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:42.400000",
        "id": 23,
        "className": "Person",
        coords: [
            501.0,
            234.0,
            549.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:42.400000",
        "id": 15,
        "className": "Person",
        coords: [
            12.0,
            213.0,
            45.0,
            282.0
        ],
        "status": "Moving",
        "speed": 120.92,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:42.400000",
        "id": 34,
        "className": "Person",
        coords: [
            336.0,
            530.0,
            446.0,
            717.0
        ],
        "status": "Moving",
        "speed": 74.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:42.500000",
        "id": 23,
        "className": "Person",
        coords: [
            497.0,
            234.0,
            545.0,
            327.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:42.500000",
        "id": 15,
        "className": "Person",
        coords: [
            9.0,
            214.0,
            46.0,
            292.0
        ],
        "status": "Moving",
        "speed": 91.23,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:42.500000",
        "id": 34,
        "className": "Person",
        coords: [
            327.0,
            530.0,
            440.0,
            717.0
        ],
        "status": "Moving",
        "speed": 119.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:42.600000",
        "id": 23,
        "className": "Person",
        coords: [
            491.0,
            234.0,
            542.0,
            326.0
        ],
        "status": "Moving",
        "speed": 74.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:42.600000",
        "id": 15,
        "className": "Person",
        coords: [
            11.0,
            211.0,
            47.0,
            287.0
        ],
        "status": "Moving",
        "speed": 67.08,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:42.600000",
        "id": 34,
        "className": "Person",
        coords: [
            323.0,
            530.0,
            439.0,
            718.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:42.700000",
        "id": 23,
        "className": "Person",
        coords: [
            488.0,
            234.0,
            541.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:42.700000",
        "id": 34,
        "className": "Person",
        coords: [
            321.0,
            529.0,
            439.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:42.700000",
        "id": 23,
        "className": "Person",
        coords: [
            486.0,
            234.0,
            540.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:42.700000",
        "id": 34,
        "className": "Person",
        coords: [
            320.0,
            529.0,
            440.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:42.800000",
        "id": 23,
        "className": "Person",
        coords: [
            484.0,
            234.0,
            541.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:42.800000",
        "id": 34,
        "className": "Person",
        coords: [
            319.0,
            530.0,
            441.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:42.900000",
        "id": 23,
        "className": "Person",
        coords: [
            483.0,
            234.0,
            541.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:42.900000",
        "id": 34,
        "className": "Person",
        coords: [
            331.0,
            532.0,
            450.0,
            718.0
        ],
        "status": "Moving",
        "speed": 150.74,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:42.900000",
        "id": 23,
        "className": "Person",
        coords: [
            482.0,
            234.0,
            542.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:42.900000",
        "id": 34,
        "className": "Person",
        coords: [
            326.0,
            534.0,
            446.0,
            718.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:43",
        "id": 23,
        "className": "Person",
        coords: [
            482.0,
            233.0,
            542.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:43",
        "id": 34,
        "className": "Person",
        coords: [
            334.0,
            536.0,
            452.0,
            718.0
        ],
        "status": "Moving",
        "speed": 106.06,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:43.100000",
        "id": 23,
        "className": "Person",
        coords: [
            481.0,
            233.0,
            543.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:43.100000",
        "id": 34,
        "className": "Person",
        coords: [
            337.0,
            537.0,
            454.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:43.100000",
        "id": 23,
        "className": "Person",
        coords: [
            481.0,
            234.0,
            543.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:43.100000",
        "id": 34,
        "className": "Person",
        coords: [
            339.0,
            538.0,
            454.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:43.200000",
        "id": 23,
        "className": "Person",
        coords: [
            481.0,
            234.0,
            544.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:43.200000",
        "id": 34,
        "className": "Person",
        coords: [
            340.0,
            538.0,
            454.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:43.300000",
        "id": 23,
        "className": "Person",
        coords: [
            480.0,
            233.0,
            544.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:43.300000",
        "id": 34,
        "className": "Person",
        coords: [
            340.0,
            539.0,
            454.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:43.300000",
        "id": 23,
        "className": "Person",
        coords: [
            480.0,
            234.0,
            545.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:43.400000",
        "id": 34,
        "className": "Person",
        coords: [
            342.0,
            540.0,
            454.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:43.400000",
        "id": 23,
        "className": "Person",
        coords: [
            479.0,
            234.0,
            545.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:43.400000",
        "id": 34,
        "className": "Person",
        coords: [
            342.0,
            542.0,
            454.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:43.500000",
        "id": 23,
        "className": "Person",
        coords: [
            479.0,
            233.0,
            545.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:43.500000",
        "id": 34,
        "className": "Person",
        coords: [
            335.0,
            543.0,
            448.0,
            718.0
        ],
        "status": "Moving",
        "speed": 104.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:43.600000",
        "id": 23,
        "className": "Person",
        coords: [
            477.0,
            234.0,
            545.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:43.600000",
        "id": 34,
        "className": "Person",
        coords: [
            341.0,
            544.0,
            454.0,
            718.0
        ],
        "status": "Moving",
        "speed": 91.23,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:43.600000",
        "id": 23,
        "className": "Person",
        coords: [
            472.0,
            233.0,
            542.0,
            326.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:43.700000",
        "id": 34,
        "className": "Person",
        coords: [
            344.0,
            544.0,
            456.0,
            718.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:43.700000",
        "id": 23,
        "className": "Person",
        coords: [
            472.0,
            233.0,
            543.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:43.700000",
        "id": 34,
        "className": "Person",
        coords: [
            334.0,
            545.0,
            449.0,
            718.0
        ],
        "status": "Moving",
        "speed": 134.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:43.800000",
        "id": 35,
        "className": "Person",
        coords: [
            11.0,
            252.0,
            72.0,
            412.0
        ],
        "status": "First Seen",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:21:43.800000",
        "id": 23,
        "className": "Person",
        coords: [
            470.0,
            233.0,
            542.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:43.800000",
        "id": 34,
        "className": "Person",
        coords: [
            328.0,
            546.0,
            447.0,
            717.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:43.900000",
        "id": 35,
        "className": "Person",
        coords: [
            12.0,
            253.0,
            71.0,
            410.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:21:43.900000",
        "id": 23,
        "className": "Person",
        coords: [
            467.0,
            233.0,
            541.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:43.900000",
        "id": 34,
        "className": "Person",
        coords: [
            330.0,
            546.0,
            450.0,
            717.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:43.900000",
        "id": 35,
        "className": "Person",
        coords: [
            11.0,
            252.0,
            73.0,
            414.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:21:44",
        "id": 23,
        "className": "Person",
        coords: [
            464.0,
            234.0,
            539.0,
            326.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:44",
        "id": 35,
        "className": "Person",
        coords: [
            12.0,
            252.0,
            72.0,
            412.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:21:44.100000",
        "id": 23,
        "className": "Person",
        coords: [
            459.0,
            234.0,
            537.0,
            326.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:44.100000",
        "id": 35,
        "className": "Person",
        coords: [
            12.0,
            251.0,
            72.0,
            408.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:44.100000",
        "id": 23,
        "className": "Person",
        coords: [
            449.0,
            235.0,
            531.0,
            325.0
        ],
        "status": "Moving",
        "speed": 119.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:44.100000",
        "id": 35,
        "className": "Person",
        coords: [
            13.0,
            249.0,
            72.0,
            404.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:44.200000",
        "id": 23,
        "className": "Person",
        coords: [
            444.0,
            235.0,
            530.0,
            325.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:44.200000",
        "id": 35,
        "className": "Person",
        coords: [
            13.0,
            246.0,
            71.0,
            399.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:44.300000",
        "id": 23,
        "className": "Person",
        coords: [
            450.0,
            235.0,
            537.0,
            325.0
        ],
        "status": "Moving",
        "speed": 89.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:44.300000",
        "id": 35,
        "className": "Person",
        coords: [
            13.0,
            245.0,
            72.0,
            399.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:44.300000",
        "id": 23,
        "className": "Person",
        coords: [
            445.0,
            235.0,
            535.0,
            325.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:44.400000",
        "id": 35,
        "className": "Person",
        coords: [
            15.0,
            245.0,
            74.0,
            398.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:44.400000",
        "id": 23,
        "className": "Person",
        coords: [
            440.0,
            235.0,
            534.0,
            325.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:44.400000",
        "id": 35,
        "className": "Person",
        coords: [
            18.0,
            245.0,
            77.0,
            397.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:44.500000",
        "id": 23,
        "className": "Person",
        coords: [
            437.0,
            235.0,
            534.0,
            325.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:44.500000",
        "id": 35,
        "className": "Person",
        coords: [
            19.0,
            246.0,
            79.0,
            397.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:44.500000",
        "id": 23,
        "className": "Person",
        coords: [
            436.0,
            235.0,
            536.0,
            325.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:44.600000",
        "id": 35,
        "className": "Person",
        coords: [
            23.0,
            247.0,
            83.0,
            398.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:44.600000",
        "id": 23,
        "className": "Person",
        coords: [
            436.0,
            235.0,
            539.0,
            325.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:44.600000",
        "id": 35,
        "className": "Person",
        coords: [
            27.0,
            246.0,
            90.0,
            397.0
        ],
        "status": "Moving",
        "speed": 76.48,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:44.600000",
        "id": 34,
        "className": "Person",
        coords: [
            334.0,
            545.0,
            462.0,
            718.0
        ],
        "status": "Moving",
        "speed": 119.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:44.700000",
        "id": 23,
        "className": "Person",
        coords: [
            433.0,
            235.0,
            538.0,
            325.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:44.700000",
        "id": 35,
        "className": "Person",
        coords: [
            29.0,
            245.0,
            93.0,
            396.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:44.800000",
        "id": 23,
        "className": "Person",
        coords: [
            432.0,
            236.0,
            539.0,
            325.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:44.800000",
        "id": 35,
        "className": "Person",
        coords: [
            30.0,
            243.0,
            94.0,
            393.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:44.800000",
        "id": 34,
        "className": "Person",
        coords: [
            331.0,
            545.0,
            465.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:44.900000",
        "id": 35,
        "className": "Person",
        coords: [
            31.0,
            240.0,
            97.0,
            391.0
        ],
        "status": "Moving",
        "speed": 54.08,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:44.900000",
        "id": 34,
        "className": "Person",
        coords: [
            330.0,
            545.0,
            466.0,
            714.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:44.900000",
        "id": 35,
        "className": "Person",
        coords: [
            33.0,
            241.0,
            99.0,
            387.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:44.900000",
        "id": 34,
        "className": "Person",
        coords: [
            328.0,
            545.0,
            469.0,
            715.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:45",
        "id": 23,
        "className": "Person",
        coords: [
            454.0,
            235.0,
            559.0,
            325.0
        ],
        "status": "Moving",
        "speed": 314.97,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:45",
        "id": 35,
        "className": "Person",
        coords: [
            34.0,
            241.0,
            101.0,
            384.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:45",
        "id": 23,
        "className": "Person",
        coords: [
            460.0,
            235.0,
            562.0,
            326.0
        ],
        "status": "Moving",
        "speed": 74.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:45.100000",
        "id": 35,
        "className": "Person",
        coords: [
            31.0,
            239.0,
            99.0,
            384.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:45.100000",
        "id": 23,
        "className": "Person",
        coords: [
            462.0,
            234.0,
            562.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:45.100000",
        "id": 34,
        "className": "Person",
        coords: [
            327.0,
            545.0,
            470.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:45.200000",
        "id": 35,
        "className": "Person",
        coords: [
            30.0,
            239.0,
            99.0,
            383.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:45.200000",
        "id": 23,
        "className": "Person",
        coords: [
            464.0,
            234.0,
            562.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:45.200000",
        "id": 34,
        "className": "Person",
        coords: [
            326.0,
            545.0,
            472.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:45.300000",
        "id": 35,
        "className": "Person",
        coords: [
            24.0,
            239.0,
            91.0,
            383.0
        ],
        "status": "Moving",
        "speed": 104.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:45.300000",
        "id": 23,
        "className": "Person",
        coords: [
            465.0,
            234.0,
            561.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:45.300000",
        "id": 34,
        "className": "Person",
        coords: [
            326.0,
            545.0,
            472.0,
            714.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:45.400000",
        "id": 35,
        "className": "Person",
        coords: [
            23.0,
            239.0,
            90.0,
            383.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:45.400000",
        "id": 23,
        "className": "Person",
        coords: [
            466.0,
            234.0,
            561.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:45.400000",
        "id": 34,
        "className": "Person",
        coords: [
            325.0,
            545.0,
            473.0,
            715.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:45.500000",
        "id": 35,
        "className": "Person",
        coords: [
            27.0,
            238.0,
            94.0,
            383.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:45.500000",
        "id": 23,
        "className": "Person",
        coords: [
            468.0,
            234.0,
            560.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:45.500000",
        "id": 34,
        "className": "Person",
        coords: [
            324.0,
            545.0,
            474.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:45.600000",
        "id": 35,
        "className": "Person",
        coords: [
            28.0,
            239.0,
            95.0,
            383.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:45.600000",
        "id": 23,
        "className": "Person",
        coords: [
            470.0,
            234.0,
            560.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:45.600000",
        "id": 34,
        "className": "Person",
        coords: [
            324.0,
            545.0,
            474.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:45.700000",
        "id": 35,
        "className": "Person",
        coords: [
            23.0,
            239.0,
            88.0,
            383.0
        ],
        "status": "Moving",
        "speed": 89.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:45.700000",
        "id": 23,
        "className": "Person",
        coords: [
            471.0,
            235.0,
            559.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:45.700000",
        "id": 34,
        "className": "Person",
        coords: [
            323.0,
            545.0,
            475.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:45.800000",
        "id": 35,
        "className": "Person",
        coords: [
            21.0,
            239.0,
            86.0,
            383.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:45.800000",
        "id": 23,
        "className": "Person",
        coords: [
            472.0,
            234.0,
            559.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:45.800000",
        "id": 34,
        "className": "Person",
        coords: [
            323.0,
            546.0,
            475.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:45.900000",
        "id": 35,
        "className": "Person",
        coords: [
            21.0,
            238.0,
            84.0,
            383.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:45.900000",
        "id": 23,
        "className": "Person",
        coords: [
            474.0,
            234.0,
            559.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:45.900000",
        "id": 34,
        "className": "Person",
        coords: [
            322.0,
            546.0,
            475.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:46",
        "id": 35,
        "className": "Person",
        coords: [
            21.0,
            238.0,
            84.0,
            383.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:46",
        "id": 23,
        "className": "Person",
        coords: [
            478.0,
            234.0,
            560.0,
            326.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:46",
        "id": 34,
        "className": "Person",
        coords: [
            322.0,
            546.0,
            476.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:46.100000",
        "id": 35,
        "className": "Person",
        coords: [
            20.0,
            238.0,
            81.0,
            383.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:46.100000",
        "id": 23,
        "className": "Person",
        coords: [
            479.0,
            234.0,
            559.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:46.100000",
        "id": 34,
        "className": "Person",
        coords: [
            322.0,
            546.0,
            476.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:46.200000",
        "id": 35,
        "className": "Person",
        coords: [
            20.0,
            235.0,
            81.0,
            383.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:46.200000",
        "id": 23,
        "className": "Person",
        coords: [
            479.0,
            234.0,
            558.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:46.200000",
        "id": 34,
        "className": "Person",
        coords: [
            322.0,
            546.0,
            477.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:46.300000",
        "id": 35,
        "className": "Person",
        coords: [
            18.0,
            233.0,
            79.0,
            382.0
        ],
        "status": "Moving",
        "speed": 42.42,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:46.300000",
        "id": 23,
        "className": "Person",
        coords: [
            481.0,
            234.0,
            557.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:46.300000",
        "id": 34,
        "className": "Person",
        coords: [
            323.0,
            546.0,
            481.0,
            717.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:46.300000",
        "id": 35,
        "className": "Person",
        coords: [
            18.0,
            232.0,
            79.0,
            383.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:46.400000",
        "id": 23,
        "className": "Person",
        coords: [
            481.0,
            234.0,
            556.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:46.400000",
        "id": 34,
        "className": "Person",
        coords: [
            328.0,
            545.0,
            490.0,
            717.0
        ],
        "status": "Moving",
        "speed": 104.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:46.400000",
        "id": 35,
        "className": "Person",
        coords: [
            19.0,
            234.0,
            79.0,
            384.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:46.400000",
        "id": 23,
        "className": "Person",
        coords: [
            482.0,
            234.0,
            555.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:46.500000",
        "id": 34,
        "className": "Person",
        coords: [
            332.0,
            545.0,
            498.0,
            718.0
        ],
        "status": "Moving",
        "speed": 89.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:46.500000",
        "id": 23,
        "className": "Person",
        coords: [
            482.0,
            234.0,
            554.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:46.600000",
        "id": 23,
        "className": "Person",
        coords: [
            481.0,
            234.0,
            553.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:46.600000",
        "id": 35,
        "className": "Person",
        coords: [
            15.0,
            214.0,
            82.0,
            384.0
        ],
        "status": "Moving",
        "speed": 150.74,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:46.600000",
        "id": 23,
        "className": "Person",
        coords: [
            481.0,
            234.0,
            552.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:46.600000",
        "id": 35,
        "className": "Person",
        coords: [
            14.0,
            209.0,
            82.0,
            384.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:46.700000",
        "id": 23,
        "className": "Person",
        coords: [
            481.0,
            235.0,
            552.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:46.700000",
        "id": 34,
        "className": "Person",
        coords: [
            332.0,
            543.0,
            501.0,
            714.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:46.700000",
        "id": 23,
        "className": "Person",
        coords: [
            482.0,
            235.0,
            552.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:46.800000",
        "id": 34,
        "className": "Person",
        coords: [
            325.0,
            543.0,
            496.0,
            715.0
        ],
        "status": "Moving",
        "speed": 91.23,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:46.800000",
        "id": 23,
        "className": "Person",
        coords: [
            485.0,
            236.0,
            554.0,
            327.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:46.800000",
        "id": 34,
        "className": "Person",
        coords: [
            318.0,
            543.0,
            491.0,
            717.0
        ],
        "status": "Moving",
        "speed": 91.23,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:46.900000",
        "id": 23,
        "className": "Person",
        coords: [
            487.0,
            236.0,
            554.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:46.900000",
        "id": 34,
        "className": "Person",
        coords: [
            313.0,
            543.0,
            485.0,
            717.0
        ],
        "status": "Moving",
        "speed": 74.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:46.900000",
        "id": 35,
        "className": "Person",
        coords: [
            13.0,
            226.0,
            73.0,
            382.0
        ],
        "status": "Moving",
        "speed": 141.5,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:47",
        "id": 23,
        "className": "Person",
        coords: [
            489.0,
            236.0,
            555.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:47",
        "id": 34,
        "className": "Person",
        coords: [
            311.0,
            542.0,
            481.0,
            717.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:47",
        "id": 35,
        "className": "Person",
        coords: [
            14.0,
            230.0,
            72.0,
            381.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:47.100000",
        "id": 23,
        "className": "Person",
        coords: [
            488.0,
            236.0,
            553.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:47.100000",
        "id": 34,
        "className": "Person",
        coords: [
            309.0,
            542.0,
            478.0,
            717.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:47.100000",
        "id": 35,
        "className": "Person",
        coords: [
            15.0,
            233.0,
            71.0,
            380.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:47.200000",
        "id": 23,
        "className": "Person",
        coords: [
            487.0,
            236.0,
            552.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:47.200000",
        "id": 34,
        "className": "Person",
        coords: [
            307.0,
            541.0,
            477.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:47.200000",
        "id": 35,
        "className": "Person",
        coords: [
            13.0,
            235.0,
            69.0,
            380.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:47.200000",
        "id": 23,
        "className": "Person",
        coords: [
            491.0,
            237.0,
            555.0,
            326.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:47.300000",
        "id": 34,
        "className": "Person",
        coords: [
            307.0,
            541.0,
            476.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:47.300000",
        "id": 35,
        "className": "Person",
        coords: [
            12.0,
            234.0,
            68.0,
            380.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:47.300000",
        "id": 23,
        "className": "Person",
        coords: [
            495.0,
            237.0,
            557.0,
            327.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:47.400000",
        "id": 34,
        "className": "Person",
        coords: [
            309.0,
            540.0,
            478.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:47.400000",
        "id": 35,
        "className": "Person",
        coords: [
            9.0,
            234.0,
            65.0,
            378.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:47.400000",
        "id": 23,
        "className": "Person",
        coords: [
            497.0,
            238.0,
            556.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:47.400000",
        "id": 34,
        "className": "Person",
        coords: [
            310.0,
            539.0,
            479.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:47.400000",
        "id": 35,
        "className": "Person",
        coords: [
            8.0,
            233.0,
            64.0,
            378.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:47.500000",
        "id": 23,
        "className": "Person",
        coords: [
            498.0,
            238.0,
            556.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:47.500000",
        "id": 34,
        "className": "Person",
        coords: [
            312.0,
            539.0,
            480.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:47.500000",
        "id": 35,
        "className": "Person",
        coords: [
            9.0,
            243.0,
            61.0,
            373.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:47.600000",
        "id": 23,
        "className": "Person",
        coords: [
            499.0,
            238.0,
            556.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:47.600000",
        "id": 34,
        "className": "Person",
        coords: [
            313.0,
            539.0,
            480.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:47.600000",
        "id": 23,
        "className": "Person",
        coords: [
            499.0,
            237.0,
            556.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:47.700000",
        "id": 34,
        "className": "Person",
        coords: [
            314.0,
            539.0,
            480.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:47.700000",
        "id": 23,
        "className": "Person",
        coords: [
            500.0,
            238.0,
            555.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:47.700000",
        "id": 34,
        "className": "Person",
        coords: [
            314.0,
            539.0,
            478.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:47.800000",
        "id": 23,
        "className": "Person",
        coords: [
            500.0,
            238.0,
            554.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:47.800000",
        "id": 34,
        "className": "Person",
        coords: [
            314.0,
            540.0,
            477.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:47.800000",
        "id": 23,
        "className": "Person",
        coords: [
            499.0,
            238.0,
            553.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:47.900000",
        "id": 34,
        "className": "Person",
        coords: [
            315.0,
            540.0,
            478.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:47.900000",
        "id": 23,
        "className": "Person",
        coords: [
            498.0,
            238.0,
            552.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:47.900000",
        "id": 34,
        "className": "Person",
        coords: [
            315.0,
            540.0,
            478.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:48",
        "id": 23,
        "className": "Person",
        coords: [
            497.0,
            237.0,
            552.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:48",
        "id": 34,
        "className": "Person",
        coords: [
            315.0,
            540.0,
            478.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:48.100000",
        "id": 23,
        "className": "Person",
        coords: [
            498.0,
            237.0,
            552.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:48.100000",
        "id": 34,
        "className": "Person",
        coords: [
            314.0,
            540.0,
            476.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:48.100000",
        "id": 23,
        "className": "Person",
        coords: [
            498.0,
            238.0,
            552.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:48.200000",
        "id": 34,
        "className": "Person",
        coords: [
            314.0,
            539.0,
            476.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:48.200000",
        "id": 23,
        "className": "Person",
        coords: [
            499.0,
            238.0,
            552.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:48.200000",
        "id": 34,
        "className": "Person",
        coords: [
            315.0,
            540.0,
            475.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:48.300000",
        "id": 23,
        "className": "Person",
        coords: [
            499.0,
            239.0,
            551.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:48.300000",
        "id": 34,
        "className": "Person",
        coords: [
            315.0,
            541.0,
            475.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:48.300000",
        "id": 23,
        "className": "Person",
        coords: [
            499.0,
            240.0,
            551.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:48.400000",
        "id": 34,
        "className": "Person",
        coords: [
            315.0,
            542.0,
            474.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:48.400000",
        "id": 23,
        "className": "Person",
        coords: [
            502.0,
            240.0,
            552.0,
            325.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:48.400000",
        "id": 34,
        "className": "Person",
        coords: [
            314.0,
            543.0,
            472.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:48.500000",
        "id": 23,
        "className": "Person",
        coords: [
            501.0,
            240.0,
            551.0,
            325.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:48.500000",
        "id": 34,
        "className": "Person",
        coords: [
            312.0,
            542.0,
            469.0,
            718.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:48.600000",
        "id": 23,
        "className": "Person",
        coords: [
            500.0,
            241.0,
            550.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:48.600000",
        "id": 34,
        "className": "Person",
        coords: [
            309.0,
            541.0,
            466.0,
            718.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:48.600000",
        "id": 23,
        "className": "Person",
        coords: [
            500.0,
            242.0,
            550.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:48.700000",
        "id": 34,
        "className": "Person",
        coords: [
            308.0,
            540.0,
            465.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:48.700000",
        "id": 23,
        "className": "Person",
        coords: [
            499.0,
            244.0,
            549.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:48.700000",
        "id": 34,
        "className": "Person",
        coords: [
            307.0,
            539.0,
            464.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:48.800000",
        "id": 23,
        "className": "Person",
        coords: [
            501.0,
            245.0,
            551.0,
            327.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:48.800000",
        "id": 34,
        "className": "Person",
        coords: [
            307.0,
            538.0,
            463.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:48.800000",
        "id": 23,
        "className": "Person",
        coords: [
            501.0,
            245.0,
            551.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:48.900000",
        "id": 34,
        "className": "Person",
        coords: [
            307.0,
            537.0,
            462.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:48.900000",
        "id": 23,
        "className": "Person",
        coords: [
            502.0,
            245.0,
            552.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:48.900000",
        "id": 34,
        "className": "Person",
        coords: [
            307.0,
            536.0,
            462.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:49",
        "id": 23,
        "className": "Person",
        coords: [
            503.0,
            245.0,
            554.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:49",
        "id": 34,
        "className": "Person",
        coords: [
            307.0,
            536.0,
            462.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:49.100000",
        "id": 23,
        "className": "Person",
        coords: [
            504.0,
            245.0,
            555.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:49.100000",
        "id": 34,
        "className": "Person",
        coords: [
            308.0,
            535.0,
            462.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:49.100000",
        "id": 23,
        "className": "Person",
        coords: [
            505.0,
            245.0,
            557.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:49.100000",
        "id": 34,
        "className": "Person",
        coords: [
            309.0,
            535.0,
            463.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:49.200000",
        "id": 23,
        "className": "Person",
        coords: [
            506.0,
            246.0,
            558.0,
            325.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:49.200000",
        "id": 34,
        "className": "Person",
        coords: [
            311.0,
            535.0,
            463.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:49.300000",
        "id": 23,
        "className": "Person",
        coords: [
            507.0,
            247.0,
            559.0,
            327.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:49.300000",
        "id": 34,
        "className": "Person",
        coords: [
            312.0,
            535.0,
            463.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:49.300000",
        "id": 23,
        "className": "Person",
        coords: [
            508.0,
            248.0,
            564.0,
            332.0
        ],
        "status": "Moving",
        "speed": 63.63,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:49.300000",
        "id": 34,
        "className": "Person",
        coords: [
            314.0,
            535.0,
            464.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:49.400000",
        "id": 23,
        "className": "Person",
        coords: [
            510.0,
            248.0,
            570.0,
            336.0
        ],
        "status": "Moving",
        "speed": 67.08,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:49.400000",
        "id": 34,
        "className": "Person",
        coords: [
            314.0,
            536.0,
            463.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:49.500000",
        "id": 23,
        "className": "Person",
        coords: [
            511.0,
            248.0,
            572.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:49.500000",
        "id": 34,
        "className": "Person",
        coords: [
            318.0,
            536.0,
            464.0,
            718.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:49.500000",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            248.0,
            574.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:49.600000",
        "id": 34,
        "className": "Person",
        coords: [
            320.0,
            536.0,
            464.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:49.600000",
        "id": 36,
        "className": "Person",
        coords: [
            247.0,
            247.0,
            310.0,
            407.0
        ],
        "status": "First Seen",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:21:49.600000",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            248.0,
            576.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:49.600000",
        "id": 34,
        "className": "Person",
        coords: [
            320.0,
            536.0,
            463.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:49.600000",
        "id": 36,
        "className": "Person",
        coords: [
            247.0,
            248.0,
            309.0,
            407.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:21:49.700000",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            248.0,
            577.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:49.700000",
        "id": 34,
        "className": "Person",
        coords: [
            320.0,
            536.0,
            462.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:49.700000",
        "id": 36,
        "className": "Person",
        coords: [
            246.0,
            251.0,
            307.0,
            406.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:21:49.800000",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            248.0,
            578.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:49.800000",
        "id": 34,
        "className": "Person",
        coords: [
            319.0,
            536.0,
            460.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:49.800000",
        "id": 36,
        "className": "Person",
        coords: [
            251.0,
            256.0,
            310.0,
            407.0
        ],
        "status": "Moving",
        "speed": 74.99,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:21:49.900000",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            248.0,
            580.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:49.900000",
        "id": 34,
        "className": "Person",
        coords: [
            318.0,
            536.0,
            458.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:49.900000",
        "id": 36,
        "className": "Person",
        coords: [
            253.0,
            258.0,
            312.0,
            407.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:49.900000",
        "id": 23,
        "className": "Person",
        coords: [
            511.0,
            248.0,
            580.0,
            341.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:50",
        "id": 34,
        "className": "Person",
        coords: [
            316.0,
            537.0,
            456.0,
            717.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:50",
        "id": 36,
        "className": "Person",
        coords: [
            253.0,
            258.0,
            313.0,
            408.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:50",
        "id": 23,
        "className": "Person",
        coords: [
            511.0,
            248.0,
            581.0,
            341.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:50",
        "id": 34,
        "className": "Person",
        coords: [
            320.0,
            537.0,
            459.0,
            717.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:50.100000",
        "id": 36,
        "className": "Person",
        coords: [
            253.0,
            258.0,
            314.0,
            410.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:50.100000",
        "id": 23,
        "className": "Person",
        coords: [
            510.0,
            248.0,
            581.0,
            341.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:50.100000",
        "id": 34,
        "className": "Person",
        coords: [
            315.0,
            537.0,
            454.0,
            717.0
        ],
        "status": "Moving",
        "speed": 74.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:50.100000",
        "id": 36,
        "className": "Person",
        coords: [
            255.0,
            259.0,
            315.0,
            408.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:50.200000",
        "id": 23,
        "className": "Person",
        coords: [
            510.0,
            248.0,
            581.0,
            341.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:50.200000",
        "id": 34,
        "className": "Person",
        coords: [
            325.0,
            537.0,
            461.0,
            716.0
        ],
        "status": "Moving",
        "speed": 135.82,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:50.200000",
        "id": 36,
        "className": "Person",
        coords: [
            257.0,
            264.0,
            315.0,
            408.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:50.300000",
        "id": 23,
        "className": "Person",
        coords: [
            509.0,
            248.0,
            581.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:50.300000",
        "id": 34,
        "className": "Person",
        coords: [
            329.0,
            536.0,
            463.0,
            715.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:50.300000",
        "id": 36,
        "className": "Person",
        coords: [
            258.0,
            270.0,
            315.0,
            409.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:50.300000",
        "id": 23,
        "className": "Person",
        coords: [
            510.0,
            249.0,
            581.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:50.400000",
        "id": 34,
        "className": "Person",
        coords: [
            331.0,
            536.0,
            463.0,
            715.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:50.400000",
        "id": 36,
        "className": "Person",
        coords: [
            257.0,
            271.0,
            314.0,
            410.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:50.400000",
        "id": 23,
        "className": "Person",
        coords: [
            510.0,
            249.0,
            582.0,
            340.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:50.400000",
        "id": 36,
        "className": "Person",
        coords: [
            256.0,
            271.0,
            314.0,
            411.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:50.500000",
        "id": 23,
        "className": "Person",
        coords: [
            509.0,
            249.0,
            582.0,
            341.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:50.500000",
        "id": 36,
        "className": "Person",
        coords: [
            254.0,
            272.0,
            313.0,
            414.0
        ],
        "status": "Moving",
        "speed": 42.42,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:50.500000",
        "id": 34,
        "className": "Person",
        coords: [
            332.0,
            534.0,
            463.0,
            714.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:50.600000",
        "id": 23,
        "className": "Person",
        coords: [
            509.0,
            250.0,
            583.0,
            342.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:50.600000",
        "id": 34,
        "className": "Person",
        coords: [
            333.0,
            533.0,
            462.0,
            714.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:50.600000",
        "id": 23,
        "className": "Person",
        coords: [
            510.0,
            252.0,
            583.0,
            343.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:50.700000",
        "id": 34,
        "className": "Person",
        coords: [
            334.0,
            532.0,
            462.0,
            715.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:50.700000",
        "id": 36,
        "className": "Person",
        coords: [
            250.0,
            272.0,
            309.0,
            410.0
        ],
        "status": "Moving",
        "speed": 67.08,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:50.700000",
        "id": 23,
        "className": "Person",
        coords: [
            509.0,
            252.0,
            583.0,
            343.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:50.700000",
        "id": 34,
        "className": "Person",
        coords: [
            334.0,
            532.0,
            461.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:50.800000",
        "id": 36,
        "className": "Person",
        coords: [
            249.0,
            273.0,
            308.0,
            411.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:50.800000",
        "id": 23,
        "className": "Person",
        coords: [
            509.0,
            253.0,
            583.0,
            344.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:50.800000",
        "id": 34,
        "className": "Person",
        coords: [
            335.0,
            532.0,
            460.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:50.800000",
        "id": 36,
        "className": "Person",
        coords: [
            248.0,
            273.0,
            307.0,
            410.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:50.900000",
        "id": 23,
        "className": "Person",
        coords: [
            509.0,
            253.0,
            584.0,
            344.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:50.900000",
        "id": 34,
        "className": "Person",
        coords: [
            336.0,
            531.0,
            459.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:50.900000",
        "id": 36,
        "className": "Person",
        coords: [
            246.0,
            274.0,
            306.0,
            412.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:51",
        "id": 23,
        "className": "Person",
        coords: [
            508.0,
            252.0,
            584.0,
            343.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:51",
        "id": 34,
        "className": "Person",
        coords: [
            336.0,
            531.0,
            457.0,
            715.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:51",
        "id": 36,
        "className": "Person",
        coords: [
            246.0,
            275.0,
            306.0,
            411.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:51",
        "id": 23,
        "className": "Person",
        coords: [
            508.0,
            252.0,
            585.0,
            344.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:51.100000",
        "id": 34,
        "className": "Person",
        coords: [
            337.0,
            531.0,
            456.0,
            715.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:51.100000",
        "id": 23,
        "className": "Person",
        coords: [
            510.0,
            255.0,
            586.0,
            344.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:51.100000",
        "id": 34,
        "className": "Person",
        coords: [
            336.0,
            531.0,
            456.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:51.200000",
        "id": 36,
        "className": "Person",
        coords: [
            246.0,
            279.0,
            303.0,
            408.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:51.200000",
        "id": 23,
        "className": "Person",
        coords: [
            511.0,
            257.0,
            586.0,
            345.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:51.200000",
        "id": 34,
        "className": "Person",
        coords: [
            337.0,
            531.0,
            455.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:51.200000",
        "id": 36,
        "className": "Person",
        coords: [
            245.0,
            281.0,
            301.0,
            407.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:51.300000",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            259.0,
            586.0,
            345.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:51.300000",
        "id": 34,
        "className": "Person",
        coords: [
            337.0,
            532.0,
            454.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:51.300000",
        "id": 36,
        "className": "Person",
        coords: [
            245.0,
            283.0,
            301.0,
            406.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:51.400000",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            260.0,
            587.0,
            345.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:51.400000",
        "id": 34,
        "className": "Person",
        coords: [
            337.0,
            532.0,
            454.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:51.400000",
        "id": 36,
        "className": "Person",
        coords: [
            245.0,
            285.0,
            301.0,
            405.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:51.500000",
        "id": 23,
        "className": "Person",
        coords: [
            513.0,
            260.0,
            589.0,
            345.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:51.500000",
        "id": 34,
        "className": "Person",
        coords: [
            338.0,
            533.0,
            453.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:51.500000",
        "id": 36,
        "className": "Person",
        coords: [
            244.0,
            285.0,
            301.0,
            405.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:51.600000",
        "id": 23,
        "className": "Person",
        coords: [
            513.0,
            261.0,
            589.0,
            345.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:51.600000",
        "id": 34,
        "className": "Person",
        coords: [
            338.0,
            532.0,
            453.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:51.600000",
        "id": 36,
        "className": "Person",
        coords: [
            244.0,
            286.0,
            301.0,
            406.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:51.600000",
        "id": 23,
        "className": "Person",
        coords: [
            513.0,
            261.0,
            590.0,
            346.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:51.700000",
        "id": 34,
        "className": "Person",
        coords: [
            339.0,
            532.0,
            453.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:51.700000",
        "id": 36,
        "className": "Person",
        coords: [
            243.0,
            286.0,
            301.0,
            407.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:51.700000",
        "id": 23,
        "className": "Person",
        coords: [
            513.0,
            261.0,
            591.0,
            346.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:51.700000",
        "id": 34,
        "className": "Person",
        coords: [
            339.0,
            532.0,
            453.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:51.800000",
        "id": 36,
        "className": "Person",
        coords: [
            243.0,
            287.0,
            300.0,
            406.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:51.800000",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            261.0,
            591.0,
            346.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:51.800000",
        "id": 34,
        "className": "Person",
        coords: [
            339.0,
            532.0,
            453.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:51.900000",
        "id": 36,
        "className": "Person",
        coords: [
            242.0,
            288.0,
            299.0,
            407.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:51.900000",
        "id": 23,
        "className": "Person",
        coords: [
            511.0,
            260.0,
            594.0,
            348.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:51.900000",
        "id": 34,
        "className": "Person",
        coords: [
            340.0,
            532.0,
            453.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:51.900000",
        "id": 36,
        "className": "Person",
        coords: [
            241.0,
            290.0,
            298.0,
            407.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:52",
        "id": 23,
        "className": "Person",
        coords: [
            511.0,
            260.0,
            595.0,
            349.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:52",
        "id": 34,
        "className": "Person",
        coords: [
            340.0,
            532.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:52",
        "id": 36,
        "className": "Person",
        coords: [
            241.0,
            291.0,
            299.0,
            407.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:52.100000",
        "id": 23,
        "className": "Person",
        coords: [
            510.0,
            260.0,
            595.0,
            349.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:52.100000",
        "id": 34,
        "className": "Person",
        coords: [
            341.0,
            532.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:52.100000",
        "id": 36,
        "className": "Person",
        coords: [
            241.0,
            292.0,
            298.0,
            407.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:52.200000",
        "id": 23,
        "className": "Person",
        coords: [
            510.0,
            260.0,
            596.0,
            349.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:52.200000",
        "id": 34,
        "className": "Person",
        coords: [
            341.0,
            532.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:52.200000",
        "id": 36,
        "className": "Person",
        coords: [
            240.0,
            293.0,
            298.0,
            407.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:52.300000",
        "id": 23,
        "className": "Person",
        coords: [
            509.0,
            260.0,
            596.0,
            349.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:52.300000",
        "id": 34,
        "className": "Person",
        coords: [
            341.0,
            532.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:52.300000",
        "id": 36,
        "className": "Person",
        coords: [
            240.0,
            293.0,
            299.0,
            407.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:52.300000",
        "id": 23,
        "className": "Person",
        coords: [
            509.0,
            260.0,
            596.0,
            349.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:52.400000",
        "id": 34,
        "className": "Person",
        coords: [
            342.0,
            533.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:52.400000",
        "id": 36,
        "className": "Person",
        coords: [
            239.0,
            293.0,
            298.0,
            407.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:52.400000",
        "id": 23,
        "className": "Person",
        coords: [
            509.0,
            259.0,
            597.0,
            349.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:52.400000",
        "id": 34,
        "className": "Person",
        coords: [
            342.0,
            533.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:52.500000",
        "id": 36,
        "className": "Person",
        coords: [
            240.0,
            294.0,
            300.0,
            407.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:52.500000",
        "id": 23,
        "className": "Person",
        coords: [
            507.0,
            256.0,
            598.0,
            349.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:52.500000",
        "id": 34,
        "className": "Person",
        coords: [
            342.0,
            534.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:52.500000",
        "id": 36,
        "className": "Person",
        coords: [
            241.0,
            296.0,
            300.0,
            406.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:52.600000",
        "id": 23,
        "className": "Person",
        coords: [
            507.0,
            255.0,
            598.0,
            348.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:52.600000",
        "id": 34,
        "className": "Person",
        coords: [
            342.0,
            534.0,
            450.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:52.600000",
        "id": 36,
        "className": "Person",
        coords: [
            240.0,
            296.0,
            300.0,
            406.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:52.700000",
        "id": 23,
        "className": "Person",
        coords: [
            507.0,
            256.0,
            597.0,
            348.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:52.700000",
        "id": 34,
        "className": "Person",
        coords: [
            342.0,
            534.0,
            450.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:52.700000",
        "id": 36,
        "className": "Person",
        coords: [
            238.0,
            295.0,
            299.0,
            406.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:52.800000",
        "id": 23,
        "className": "Person",
        coords: [
            506.0,
            256.0,
            596.0,
            348.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:52.800000",
        "id": 34,
        "className": "Person",
        coords: [
            342.0,
            534.0,
            450.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:52.800000",
        "id": 36,
        "className": "Person",
        coords: [
            237.0,
            296.0,
            299.0,
            406.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:52.800000",
        "id": 23,
        "className": "Person",
        coords: [
            505.0,
            255.0,
            597.0,
            348.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:52.900000",
        "id": 34,
        "className": "Person",
        coords: [
            342.0,
            534.0,
            450.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:52.900000",
        "id": 36,
        "className": "Person",
        coords: [
            237.0,
            296.0,
            300.0,
            406.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:52.900000",
        "id": 23,
        "className": "Person",
        coords: [
            505.0,
            254.0,
            597.0,
            348.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:53",
        "id": 34,
        "className": "Person",
        coords: [
            344.0,
            534.0,
            448.0,
            709.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:53",
        "id": 36,
        "className": "Person",
        coords: [
            237.0,
            296.0,
            301.0,
            405.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:53",
        "id": 23,
        "className": "Person",
        coords: [
            504.0,
            255.0,
            596.0,
            347.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:53",
        "id": 34,
        "className": "Person",
        coords: [
            344.0,
            534.0,
            448.0,
            706.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:53.100000",
        "id": 36,
        "className": "Person",
        coords: [
            236.0,
            294.0,
            302.0,
            405.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:53.100000",
        "id": 23,
        "className": "Person",
        coords: [
            505.0,
            256.0,
            596.0,
            347.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:53.100000",
        "id": 34,
        "className": "Person",
        coords: [
            344.0,
            534.0,
            447.0,
            705.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:53.100000",
        "id": 36,
        "className": "Person",
        coords: [
            238.0,
            293.0,
            304.0,
            405.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:53.200000",
        "id": 23,
        "className": "Person",
        coords: [
            505.0,
            256.0,
            594.0,
            346.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:53.200000",
        "id": 36,
        "className": "Person",
        coords: [
            238.0,
            291.0,
            307.0,
            409.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:53.300000",
        "id": 23,
        "className": "Person",
        coords: [
            505.0,
            256.0,
            594.0,
            346.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:53.300000",
        "id": 36,
        "className": "Person",
        coords: [
            238.0,
            290.0,
            308.0,
            410.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:53.300000",
        "id": 23,
        "className": "Person",
        coords: [
            505.0,
            256.0,
            593.0,
            346.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:53.400000",
        "id": 36,
        "className": "Person",
        coords: [
            239.0,
            288.0,
            309.0,
            411.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:53.400000",
        "id": 23,
        "className": "Person",
        coords: [
            505.0,
            256.0,
            594.0,
            346.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:53.400000",
        "id": 36,
        "className": "Person",
        coords: [
            240.0,
            286.0,
            311.0,
            412.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:53.500000",
        "id": 23,
        "className": "Person",
        coords: [
            505.0,
            256.0,
            593.0,
            346.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:53.500000",
        "id": 36,
        "className": "Person",
        coords: [
            238.0,
            283.0,
            310.0,
            413.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:53.500000",
        "id": 23,
        "className": "Person",
        coords: [
            506.0,
            257.0,
            593.0,
            346.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:53.600000",
        "id": 36,
        "className": "Person",
        coords: [
            237.0,
            281.0,
            310.0,
            414.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:53.600000",
        "id": 23,
        "className": "Person",
        coords: [
            506.0,
            257.0,
            593.0,
            346.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:53.600000",
        "id": 36,
        "className": "Person",
        coords: [
            236.0,
            278.0,
            309.0,
            413.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:53.700000",
        "id": 23,
        "className": "Person",
        coords: [
            506.0,
            257.0,
            593.0,
            346.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:53.700000",
        "id": 36,
        "className": "Person",
        coords: [
            237.0,
            277.0,
            310.0,
            413.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:53.700000",
        "id": 23,
        "className": "Person",
        coords: [
            506.0,
            257.0,
            593.0,
            346.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:53.800000",
        "id": 36,
        "className": "Person",
        coords: [
            246.0,
            276.0,
            316.0,
            413.0
        ],
        "status": "Moving",
        "speed": 120.92,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:53.800000",
        "id": 23,
        "className": "Person",
        coords: [
            506.0,
            257.0,
            593.0,
            346.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:53.800000",
        "id": 36,
        "className": "Person",
        coords: [
            249.0,
            276.0,
            317.0,
            412.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:53.900000",
        "id": 23,
        "className": "Person",
        coords: [
            505.0,
            257.0,
            592.0,
            346.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:53.900000",
        "id": 36,
        "className": "Person",
        coords: [
            245.0,
            275.0,
            313.0,
            411.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:53.900000",
        "id": 23,
        "className": "Person",
        coords: [
            505.0,
            257.0,
            592.0,
            346.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:54",
        "id": 36,
        "className": "Person",
        coords: [
            244.0,
            275.0,
            312.0,
            411.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:54",
        "id": 23,
        "className": "Person",
        coords: [
            506.0,
            258.0,
            591.0,
            345.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:54",
        "id": 36,
        "className": "Person",
        coords: [
            246.0,
            274.0,
            313.0,
            408.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:54.100000",
        "id": 23,
        "className": "Person",
        coords: [
            507.0,
            259.0,
            591.0,
            345.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:54.100000",
        "id": 36,
        "className": "Person",
        coords: [
            246.0,
            272.0,
            312.0,
            407.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:54.100000",
        "id": 23,
        "className": "Person",
        coords: [
            508.0,
            259.0,
            591.0,
            345.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:54.200000",
        "id": 36,
        "className": "Person",
        coords: [
            246.0,
            271.0,
            311.0,
            404.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:54.200000",
        "id": 23,
        "className": "Person",
        coords: [
            509.0,
            259.0,
            593.0,
            346.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:54.200000",
        "id": 36,
        "className": "Person",
        coords: [
            243.0,
            270.0,
            312.0,
            411.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:54.300000",
        "id": 34,
        "className": "Person",
        coords: [
            342.0,
            534.0,
            451.0,
            718.0
        ],
        "status": "Moving",
        "speed": 106.06,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:54.300000",
        "id": 23,
        "className": "Person",
        coords: [
            510.0,
            259.0,
            595.0,
            347.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:54.300000",
        "id": 36,
        "className": "Person",
        coords: [
            241.0,
            267.0,
            312.0,
            413.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:54.300000",
        "id": 34,
        "className": "Person",
        coords: [
            342.0,
            534.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:54.400000",
        "id": 23,
        "className": "Person",
        coords: [
            510.0,
            259.0,
            595.0,
            347.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:54.400000",
        "id": 36,
        "className": "Person",
        coords: [
            240.0,
            264.0,
            313.0,
            413.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:54.400000",
        "id": 34,
        "className": "Person",
        coords: [
            342.0,
            534.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:54.500000",
        "id": 23,
        "className": "Person",
        coords: [
            510.0,
            259.0,
            596.0,
            347.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:54.500000",
        "id": 36,
        "className": "Person",
        coords: [
            240.0,
            262.0,
            312.0,
            413.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:54.500000",
        "id": 34,
        "className": "Person",
        coords: [
            342.0,
            534.0,
            450.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:54.500000",
        "id": 23,
        "className": "Person",
        coords: [
            510.0,
            259.0,
            596.0,
            347.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:54.600000",
        "id": 36,
        "className": "Person",
        coords: [
            239.0,
            262.0,
            313.0,
            413.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:54.600000",
        "id": 34,
        "className": "Person",
        coords: [
            342.0,
            534.0,
            450.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:54.600000",
        "id": 23,
        "className": "Person",
        coords: [
            510.0,
            258.0,
            596.0,
            347.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:54.700000",
        "id": 36,
        "className": "Person",
        coords: [
            240.0,
            262.0,
            313.0,
            413.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:54.700000",
        "id": 34,
        "className": "Person",
        coords: [
            342.0,
            534.0,
            450.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:54.700000",
        "id": 23,
        "className": "Person",
        coords: [
            511.0,
            258.0,
            596.0,
            347.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:54.700000",
        "id": 36,
        "className": "Person",
        coords: [
            241.0,
            261.0,
            312.0,
            411.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:54.800000",
        "id": 34,
        "className": "Person",
        coords: [
            343.0,
            534.0,
            450.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:54.800000",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            260.0,
            596.0,
            347.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:54.800000",
        "id": 36,
        "className": "Person",
        coords: [
            241.0,
            262.0,
            312.0,
            410.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:54.800000",
        "id": 34,
        "className": "Person",
        coords: [
            343.0,
            534.0,
            450.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:54.900000",
        "id": 23,
        "className": "Person",
        coords: [
            511.0,
            259.0,
            595.0,
            347.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:54.900000",
        "id": 36,
        "className": "Person",
        coords: [
            243.0,
            259.0,
            314.0,
            410.0
        ],
        "status": "Moving",
        "speed": 42.42,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:54.900000",
        "id": 34,
        "className": "Person",
        coords: [
            343.0,
            534.0,
            450.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:55",
        "id": 23,
        "className": "Person",
        coords: [
            511.0,
            259.0,
            595.0,
            346.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:55",
        "id": 36,
        "className": "Person",
        coords: [
            243.0,
            258.0,
            315.0,
            409.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:55",
        "id": 34,
        "className": "Person",
        coords: [
            343.0,
            534.0,
            450.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:55.100000",
        "id": 23,
        "className": "Person",
        coords: [
            510.0,
            256.0,
            597.0,
            346.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:55.100000",
        "id": 36,
        "className": "Person",
        coords: [
            242.0,
            257.0,
            315.0,
            409.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:55.100000",
        "id": 34,
        "className": "Person",
        coords: [
            343.0,
            534.0,
            450.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:55.100000",
        "id": 23,
        "className": "Person",
        coords: [
            510.0,
            255.0,
            597.0,
            346.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:55.200000",
        "id": 36,
        "className": "Person",
        coords: [
            241.0,
            254.0,
            314.0,
            410.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:55.200000",
        "id": 34,
        "className": "Person",
        coords: [
            343.0,
            534.0,
            450.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:55.200000",
        "id": 23,
        "className": "Person",
        coords: [
            508.0,
            253.0,
            597.0,
            346.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:55.200000",
        "id": 36,
        "className": "Person",
        coords: [
            241.0,
            253.0,
            313.0,
            409.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:55.300000",
        "id": 34,
        "className": "Person",
        coords: [
            343.0,
            534.0,
            450.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:55.300000",
        "id": 23,
        "className": "Person",
        coords: [
            508.0,
            252.0,
            597.0,
            346.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:55.300000",
        "id": 36,
        "className": "Person",
        coords: [
            241.0,
            253.0,
            313.0,
            409.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:55.300000",
        "id": 34,
        "className": "Person",
        coords: [
            343.0,
            534.0,
            450.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:55.400000",
        "id": 23,
        "className": "Person",
        coords: [
            508.0,
            251.0,
            597.0,
            346.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:55.400000",
        "id": 36,
        "className": "Person",
        coords: [
            240.0,
            251.0,
            312.0,
            409.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:55.400000",
        "id": 34,
        "className": "Person",
        coords: [
            343.0,
            534.0,
            450.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:55.500000",
        "id": 23,
        "className": "Person",
        coords: [
            507.0,
            251.0,
            594.0,
            345.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:55.500000",
        "id": 36,
        "className": "Person",
        coords: [
            238.0,
            248.0,
            310.0,
            406.0
        ],
        "status": "Moving",
        "speed": 54.08,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:55.500000",
        "id": 34,
        "className": "Person",
        coords: [
            345.0,
            534.0,
            448.0,
            710.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:55.600000",
        "id": 23,
        "className": "Person",
        coords: [
            507.0,
            251.0,
            594.0,
            345.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:55.600000",
        "id": 36,
        "className": "Person",
        coords: [
            238.0,
            248.0,
            309.0,
            405.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:55.600000",
        "id": 23,
        "className": "Person",
        coords: [
            506.0,
            250.0,
            593.0,
            345.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:55.700000",
        "id": 36,
        "className": "Person",
        coords: [
            239.0,
            251.0,
            307.0,
            403.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:55.700000",
        "id": 23,
        "className": "Person",
        coords: [
            506.0,
            249.0,
            593.0,
            345.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:55.700000",
        "id": 36,
        "className": "Person",
        coords: [
            239.0,
            256.0,
            303.0,
            398.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:55.800000",
        "id": 23,
        "className": "Person",
        coords: [
            506.0,
            248.0,
            594.0,
            345.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:55.800000",
        "id": 36,
        "className": "Person",
        coords: [
            237.0,
            254.0,
            300.0,
            395.0
        ],
        "status": "Moving",
        "speed": 63.63,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:55.800000",
        "id": 23,
        "className": "Person",
        coords: [
            506.0,
            247.0,
            593.0,
            345.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:55.800000",
        "id": 36,
        "className": "Person",
        coords: [
            238.0,
            253.0,
            292.0,
            372.0
        ],
        "status": "Moving",
        "speed": 185.52,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:55.900000",
        "id": 23,
        "className": "Person",
        coords: [
            506.0,
            246.0,
            593.0,
            345.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:55.900000",
        "id": 36,
        "className": "Person",
        coords: [
            235.0,
            250.0,
            292.0,
            377.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:56",
        "id": 23,
        "className": "Person",
        coords: [
            506.0,
            245.0,
            592.0,
            344.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:56",
        "id": 36,
        "className": "Person",
        coords: [
            238.0,
            250.0,
            290.0,
            364.0
        ],
        "status": "Moving",
        "speed": 91.23,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:56",
        "id": 23,
        "className": "Person",
        coords: [
            507.0,
            245.0,
            591.0,
            343.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:56",
        "id": 36,
        "className": "Person",
        coords: [
            238.0,
            251.0,
            288.0,
            359.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:56.100000",
        "id": 23,
        "className": "Person",
        coords: [
            508.0,
            245.0,
            589.0,
            341.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:56.100000",
        "id": 36,
        "className": "Person",
        coords: [
            237.0,
            251.0,
            287.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:56.100000",
        "id": 23,
        "className": "Person",
        coords: [
            509.0,
            246.0,
            588.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:56.200000",
        "id": 36,
        "className": "Person",
        coords: [
            236.0,
            248.0,
            287.0,
            359.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:56.200000",
        "id": 23,
        "className": "Person",
        coords: [
            510.0,
            246.0,
            585.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:56.200000",
        "id": 36,
        "className": "Person",
        coords: [
            235.0,
            242.0,
            286.0,
            350.0
        ],
        "status": "Moving",
        "speed": 106.06,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:56.300000",
        "id": 23,
        "className": "Person",
        coords: [
            509.0,
            247.0,
            583.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:56.300000",
        "id": 36,
        "className": "Person",
        coords: [
            230.0,
            237.0,
            288.0,
            362.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:56.300000",
        "id": 23,
        "className": "Person",
        coords: [
            509.0,
            247.0,
            580.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:56.300000",
        "id": 36,
        "className": "Person",
        coords: [
            233.0,
            235.0,
            287.0,
            352.0
        ],
        "status": "Moving",
        "speed": 91.23,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:56.400000",
        "id": 34,
        "className": "Person",
        coords: [
            343.0,
            533.0,
            449.0,
            714.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:56.400000",
        "id": 23,
        "className": "Person",
        coords: [
            508.0,
            247.0,
            578.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:56.400000",
        "id": 36,
        "className": "Person",
        coords: [
            230.0,
            233.0,
            288.0,
            363.0
        ],
        "status": "Moving",
        "speed": 76.48,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:56.400000",
        "id": 34,
        "className": "Person",
        coords: [
            343.0,
            533.0,
            449.0,
            714.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:56.500000",
        "id": 23,
        "className": "Person",
        coords: [
            504.0,
            245.0,
            570.0,
            332.0
        ],
        "status": "Moving",
        "speed": 108.16,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:56.500000",
        "id": 36,
        "className": "Person",
        coords: [
            228.0,
            231.0,
            287.0,
            367.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:56.500000",
        "id": 23,
        "className": "Person",
        coords: [
            503.0,
            245.0,
            566.0,
            329.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:56.600000",
        "id": 36,
        "className": "Person",
        coords: [
            226.0,
            230.0,
            285.0,
            369.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:56.600000",
        "id": 23,
        "className": "Person",
        coords: [
            500.0,
            245.0,
            561.0,
            326.0
        ],
        "status": "Moving",
        "speed": 67.08,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:56.600000",
        "id": 36,
        "className": "Person",
        coords: [
            226.0,
            229.0,
            285.0,
            369.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:56.700000",
        "id": 23,
        "className": "Person",
        coords: [
            497.0,
            245.0,
            557.0,
            325.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:56.700000",
        "id": 23,
        "className": "Person",
        coords: [
            495.0,
            245.0,
            553.0,
            324.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:56.800000",
        "id": 23,
        "className": "Person",
        coords: [
            494.0,
            243.0,
            552.0,
            323.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:56.800000",
        "id": 34,
        "className": "Person",
        coords: [
            344.0,
            532.0,
            449.0,
            712.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:56.800000",
        "id": 36,
        "className": "Person",
        coords: [
            219.0,
            227.0,
            278.0,
            369.0
        ],
        "status": "Moving",
        "speed": 106.06,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:56.800000",
        "id": 23,
        "className": "Person",
        coords: [
            493.0,
            243.0,
            551.0,
            324.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:56.900000",
        "id": 34,
        "className": "Person",
        coords: [
            344.0,
            532.0,
            449.0,
            713.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:56.900000",
        "id": 36,
        "className": "Person",
        coords: [
            219.0,
            225.0,
            277.0,
            369.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:56.900000",
        "id": 23,
        "className": "Person",
        coords: [
            484.0,
            243.0,
            544.0,
            324.0
        ],
        "status": "Moving",
        "speed": 119.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:56.900000",
        "id": 34,
        "className": "Person",
        coords: [
            344.0,
            532.0,
            449.0,
            713.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:56.900000",
        "id": 36,
        "className": "Person",
        coords: [
            219.0,
            224.0,
            277.0,
            368.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:57",
        "id": 23,
        "className": "Person",
        coords: [
            479.0,
            244.0,
            541.0,
            324.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:57",
        "id": 34,
        "className": "Person",
        coords: [
            343.0,
            532.0,
            450.0,
            713.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:57",
        "id": 36,
        "className": "Person",
        coords: [
            219.0,
            222.0,
            275.0,
            366.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:57.100000",
        "id": 23,
        "className": "Person",
        coords: [
            478.0,
            244.0,
            540.0,
            323.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:57.100000",
        "id": 34,
        "className": "Person",
        coords: [
            343.0,
            532.0,
            450.0,
            715.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:57.200000",
        "id": 23,
        "className": "Person",
        coords: [
            477.0,
            244.0,
            540.0,
            323.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:57.200000",
        "id": 34,
        "className": "Person",
        coords: [
            342.0,
            532.0,
            450.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:57.200000",
        "id": 23,
        "className": "Person",
        coords: [
            476.0,
            243.0,
            539.0,
            320.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:57.200000",
        "id": 34,
        "className": "Person",
        coords: [
            343.0,
            532.0,
            450.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:57.300000",
        "id": 36,
        "className": "Person",
        coords: [
            218.0,
            220.0,
            272.0,
            361.0
        ],
        "status": "Moving",
        "speed": 67.08,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:57.300000",
        "id": 23,
        "className": "Person",
        coords: [
            476.0,
            244.0,
            538.0,
            320.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:57.300000",
        "id": 34,
        "className": "Person",
        coords: [
            343.0,
            532.0,
            450.0,
            715.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:57.300000",
        "id": 36,
        "className": "Person",
        coords: [
            221.0,
            224.0,
            271.0,
            357.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:57.400000",
        "id": 34,
        "className": "Person",
        coords: [
            343.0,
            532.0,
            450.0,
            715.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:57.400000",
        "id": 36,
        "className": "Person",
        coords: [
            223.0,
            227.0,
            270.0,
            353.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:57.500000",
        "id": 34,
        "className": "Person",
        coords: [
            343.0,
            532.0,
            450.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:57.500000",
        "id": 36,
        "className": "Person",
        coords: [
            224.0,
            227.0,
            271.0,
            351.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:57.500000",
        "id": 23,
        "className": "Person",
        coords: [
            470.0,
            240.0,
            536.0,
            319.0
        ],
        "status": "Moving",
        "speed": 74.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:57.500000",
        "id": 34,
        "className": "Person",
        coords: [
            344.0,
            532.0,
            451.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:57.600000",
        "id": 36,
        "className": "Person",
        coords: [
            225.0,
            224.0,
            273.0,
            349.0
        ],
        "status": "Moving",
        "speed": 54.08,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:57.600000",
        "id": 23,
        "className": "Person",
        coords: [
            467.0,
            236.0,
            538.0,
            321.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:57.600000",
        "id": 34,
        "className": "Person",
        coords: [
            344.0,
            532.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:57.600000",
        "id": 36,
        "className": "Person",
        coords: [
            227.0,
            223.0,
            275.0,
            349.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:57.700000",
        "id": 23,
        "className": "Person",
        coords: [
            460.0,
            235.0,
            534.0,
            322.0
        ],
        "status": "Moving",
        "speed": 74.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:57.700000",
        "id": 34,
        "className": "Person",
        coords: [
            344.0,
            532.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:57.700000",
        "id": 36,
        "className": "Person",
        coords: [
            228.0,
            223.0,
            277.0,
            347.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:57.700000",
        "id": 23,
        "className": "Person",
        coords: [
            458.0,
            235.0,
            533.0,
            322.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:57.800000",
        "id": 34,
        "className": "Person",
        coords: [
            344.0,
            532.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:57.800000",
        "id": 36,
        "className": "Person",
        coords: [
            229.0,
            222.0,
            278.0,
            347.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:57.800000",
        "id": 23,
        "className": "Person",
        coords: [
            458.0,
            234.0,
            533.0,
            322.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:57.900000",
        "id": 34,
        "className": "Person",
        coords: [
            345.0,
            532.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:57.900000",
        "id": 36,
        "className": "Person",
        coords: [
            229.0,
            221.0,
            279.0,
            346.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:57.900000",
        "id": 23,
        "className": "Person",
        coords: [
            455.0,
            234.0,
            531.0,
            321.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:57.900000",
        "id": 34,
        "className": "Person",
        coords: [
            345.0,
            532.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:58",
        "id": 36,
        "className": "Person",
        coords: [
            229.0,
            221.0,
            279.0,
            345.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:58",
        "id": 23,
        "className": "Person",
        coords: [
            456.0,
            234.0,
            532.0,
            321.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:58",
        "id": 34,
        "className": "Person",
        coords: [
            345.0,
            532.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:58",
        "id": 36,
        "className": "Person",
        coords: [
            232.0,
            222.0,
            276.0,
            325.0
        ],
        "status": "Moving",
        "speed": 149.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:58.100000",
        "id": 23,
        "className": "Person",
        coords: [
            455.0,
            234.0,
            532.0,
            321.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:58.100000",
        "id": 34,
        "className": "Person",
        coords: [
            345.0,
            532.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:58.100000",
        "id": 36,
        "className": "Person",
        coords: [
            229.0,
            221.0,
            278.0,
            336.0
        ],
        "status": "Moving",
        "speed": 76.48,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:58.100000",
        "id": 23,
        "className": "Person",
        coords: [
            460.0,
            233.0,
            536.0,
            321.0
        ],
        "status": "Moving",
        "speed": 74.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:58.200000",
        "id": 34,
        "className": "Person",
        coords: [
            345.0,
            532.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:58.200000",
        "id": 36,
        "className": "Person",
        coords: [
            228.0,
            221.0,
            279.0,
            341.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:58.200000",
        "id": 23,
        "className": "Person",
        coords: [
            463.0,
            234.0,
            538.0,
            321.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:58.300000",
        "id": 34,
        "className": "Person",
        coords: [
            345.0,
            532.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:58.300000",
        "id": 36,
        "className": "Person",
        coords: [
            228.0,
            221.0,
            280.0,
            342.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:58.300000",
        "id": 23,
        "className": "Person",
        coords: [
            465.0,
            234.0,
            539.0,
            321.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:58.300000",
        "id": 34,
        "className": "Person",
        coords: [
            344.0,
            532.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:58.400000",
        "id": 36,
        "className": "Person",
        coords: [
            228.0,
            221.0,
            280.0,
            343.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:58.400000",
        "id": 23,
        "className": "Person",
        coords: [
            467.0,
            234.0,
            539.0,
            321.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:58.400000",
        "id": 34,
        "className": "Person",
        coords: [
            344.0,
            532.0,
            450.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:58.400000",
        "id": 36,
        "className": "Person",
        coords: [
            228.0,
            220.0,
            281.0,
            342.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:58.500000",
        "id": 23,
        "className": "Person",
        coords: [
            469.0,
            234.0,
            540.0,
            322.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:58.500000",
        "id": 34,
        "className": "Person",
        coords: [
            344.0,
            533.0,
            450.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:58.500000",
        "id": 36,
        "className": "Person",
        coords: [
            233.0,
            223.0,
            277.0,
            320.0
        ],
        "status": "Moving",
        "speed": 150.74,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:58.500000",
        "id": 23,
        "className": "Person",
        coords: [
            471.0,
            234.0,
            541.0,
            322.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:58.600000",
        "id": 34,
        "className": "Person",
        coords: [
            344.0,
            533.0,
            450.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:58.600000",
        "id": 23,
        "className": "Person",
        coords: [
            470.0,
            233.0,
            539.0,
            321.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:58.700000",
        "id": 34,
        "className": "Person",
        coords: [
            344.0,
            534.0,
            450.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:58.700000",
        "id": 23,
        "className": "Person",
        coords: [
            469.0,
            234.0,
            537.0,
            320.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:58.700000",
        "id": 34,
        "className": "Person",
        coords: [
            345.0,
            535.0,
            450.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:58.700000",
        "id": 23,
        "className": "Person",
        coords: [
            466.0,
            235.0,
            533.0,
            320.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:58.800000",
        "id": 34,
        "className": "Person",
        coords: [
            332.0,
            536.0,
            441.0,
            717.0
        ],
        "status": "Moving",
        "speed": 164.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:58.800000",
        "id": 23,
        "className": "Person",
        coords: [
            464.0,
            235.0,
            532.0,
            320.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:58.900000",
        "id": 34,
        "className": "Person",
        coords: [
            340.0,
            537.0,
            448.0,
            717.0
        ],
        "status": "Moving",
        "speed": 120.92,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:58.900000",
        "id": 23,
        "className": "Person",
        coords: [
            457.0,
            235.0,
            528.0,
            321.0
        ],
        "status": "Moving",
        "speed": 91.23,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:58.900000",
        "id": 34,
        "className": "Person",
        coords: [
            343.0,
            537.0,
            451.0,
            717.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:58.900000",
        "id": 23,
        "className": "Person",
        coords: [
            453.0,
            236.0,
            525.0,
            321.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:59",
        "id": 34,
        "className": "Person",
        coords: [
            344.0,
            538.0,
            452.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:59",
        "id": 23,
        "className": "Person",
        coords: [
            446.0,
            237.0,
            522.0,
            322.0
        ],
        "status": "Moving",
        "speed": 76.48,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:59",
        "id": 36,
        "className": "Person",
        coords: [
            232.0,
            218.0,
            277.0,
            314.0
        ],
        "status": "Moving",
        "speed": 76.48,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:59.100000",
        "id": 34,
        "className": "Person",
        coords: [
            344.0,
            538.0,
            452.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:59.100000",
        "id": 23,
        "className": "Person",
        coords: [
            444.0,
            237.0,
            523.0,
            323.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:59.100000",
        "id": 36,
        "className": "Person",
        coords: [
            228.0,
            218.0,
            272.0,
            313.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:21:59.100000",
        "id": 34,
        "className": "Person",
        coords: [
            344.0,
            538.0,
            452.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:21:59.200000",
        "id": 36,
        "className": "Person",
        coords: [
            226.0,
            218.0,
            271.0,
            317.0
        ],
        "status": "Moving",
        "speed": 42.42,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:00.300000",
        "id": 34,
        "className": "Person",
        coords: [
            344.0,
            538.0,
            452.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:00.400000",
        "id": 36,
        "className": "Person",
        coords: [
            227.0,
            219.0,
            272.0,
            316.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:00.400000",
        "id": 34,
        "className": "Person",
        coords: [
            345.0,
            539.0,
            453.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:00.500000",
        "id": 36,
        "className": "Person",
        coords: [
            230.0,
            217.0,
            277.0,
            315.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:00.500000",
        "id": 34,
        "className": "Person",
        coords: [
            345.0,
            538.0,
            453.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:00.500000",
        "id": 36,
        "className": "Person",
        coords: [
            229.0,
            215.0,
            277.0,
            316.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:00.600000",
        "id": 34,
        "className": "Person",
        coords: [
            344.0,
            537.0,
            453.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:00.600000",
        "id": 36,
        "className": "Person",
        coords: [
            230.0,
            216.0,
            278.0,
            314.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:00.700000",
        "id": 34,
        "className": "Person",
        coords: [
            341.0,
            536.0,
            451.0,
            717.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:00.700000",
        "id": 36,
        "className": "Person",
        coords: [
            228.0,
            217.0,
            277.0,
            314.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:00.800000",
        "id": 34,
        "className": "Person",
        coords: [
            331.0,
            535.0,
            445.0,
            718.0
        ],
        "status": "Moving",
        "speed": 119.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:00.800000",
        "id": 36,
        "className": "Person",
        coords: [
            230.0,
            217.0,
            280.0,
            315.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:00.900000",
        "id": 34,
        "className": "Person",
        coords: [
            324.0,
            535.0,
            441.0,
            718.0
        ],
        "status": "Moving",
        "speed": 89.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:00.900000",
        "id": 36,
        "className": "Person",
        coords: [
            232.0,
            217.0,
            281.0,
            313.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:01",
        "id": 34,
        "className": "Person",
        coords: [
            321.0,
            535.0,
            441.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:01",
        "id": 36,
        "className": "Person",
        coords: [
            232.0,
            218.0,
            283.0,
            314.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:01.100000",
        "id": 34,
        "className": "Person",
        coords: [
            333.0,
            534.0,
            452.0,
            718.0
        ],
        "status": "Moving",
        "speed": 164.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:01.100000",
        "id": 36,
        "className": "Person",
        coords: [
            233.0,
            217.0,
            286.0,
            317.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:01.100000",
        "id": 23,
        "className": "Person",
        coords: [
            447.0,
            244.0,
            520.0,
            321.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:01.200000",
        "id": 34,
        "className": "Person",
        coords: [
            338.0,
            534.0,
            456.0,
            718.0
        ],
        "status": "Moving",
        "speed": 74.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:01.200000",
        "id": 36,
        "className": "Person",
        coords: [
            234.0,
            217.0,
            287.0,
            315.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:01.200000",
        "id": 23,
        "className": "Person",
        coords: [
            447.0,
            244.0,
            522.0,
            321.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:01.300000",
        "id": 34,
        "className": "Person",
        coords: [
            339.0,
            533.0,
            457.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:01.300000",
        "id": 36,
        "className": "Person",
        coords: [
            234.0,
            217.0,
            287.0,
            313.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:01.300000",
        "id": 23,
        "className": "Person",
        coords: [
            447.0,
            244.0,
            523.0,
            321.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:01.400000",
        "id": 34,
        "className": "Person",
        coords: [
            339.0,
            532.0,
            457.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:01.400000",
        "id": 36,
        "className": "Person",
        coords: [
            233.0,
            217.0,
            286.0,
            311.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:01.400000",
        "id": 23,
        "className": "Person",
        coords: [
            447.0,
            245.0,
            523.0,
            320.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:01.500000",
        "id": 34,
        "className": "Person",
        coords: [
            339.0,
            532.0,
            456.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:01.500000",
        "id": 36,
        "className": "Person",
        coords: [
            234.0,
            217.0,
            287.0,
            310.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:01.500000",
        "id": 23,
        "className": "Person",
        coords: [
            444.0,
            245.0,
            522.0,
            320.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:01.600000",
        "id": 37,
        "className": "Person",
        coords: [
            32.0,
            212.0,
            92.0,
            346.0
        ],
        "status": "First Seen",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:22:01.600000",
        "id": 34,
        "className": "Person",
        coords: [
            339.0,
            532.0,
            455.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:01.600000",
        "id": 36,
        "className": "Person",
        coords: [
            233.0,
            217.0,
            287.0,
            309.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:01.700000",
        "id": 23,
        "className": "Person",
        coords: [
            442.0,
            244.0,
            523.0,
            321.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:01.700000",
        "id": 37,
        "className": "Person",
        coords: [
            33.0,
            213.0,
            93.0,
            346.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:22:01.700000",
        "id": 34,
        "className": "Person",
        coords: [
            339.0,
            531.0,
            455.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:01.800000",
        "id": 36,
        "className": "Person",
        coords: [
            233.0,
            217.0,
            288.0,
            313.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:01.800000",
        "id": 23,
        "className": "Person",
        coords: [
            440.0,
            243.0,
            522.0,
            321.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:01.800000",
        "id": 37,
        "className": "Person",
        coords: [
            32.0,
            212.0,
            93.0,
            346.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:22:01.900000",
        "id": 34,
        "className": "Person",
        coords: [
            339.0,
            532.0,
            454.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:01.900000",
        "id": 36,
        "className": "Person",
        coords: [
            233.0,
            218.0,
            289.0,
            314.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:01.900000",
        "id": 23,
        "className": "Person",
        coords: [
            437.0,
            243.0,
            522.0,
            321.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:01.900000",
        "id": 37,
        "className": "Person",
        coords: [
            32.0,
            211.0,
            93.0,
            346.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:22:02.300000",
        "id": 34,
        "className": "Person",
        coords: [
            329.0,
            531.0,
            446.0,
            716.0
        ],
        "status": "Moving",
        "speed": 135.82,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:02.400000",
        "id": 36,
        "className": "Person",
        coords: [
            231.0,
            218.0,
            293.0,
            325.0
        ],
        "status": "Moving",
        "speed": 76.48,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:02.400000",
        "id": 23,
        "className": "Person",
        coords: [
            436.0,
            241.0,
            523.0,
            320.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:02.400000",
        "id": 37,
        "className": "Person",
        coords: [
            31.0,
            212.0,
            92.0,
            347.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:02.500000",
        "id": 34,
        "className": "Person",
        coords: [
            333.0,
            531.0,
            450.0,
            717.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:02.500000",
        "id": 36,
        "className": "Person",
        coords: [
            231.0,
            218.0,
            294.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:02.500000",
        "id": 23,
        "className": "Person",
        coords: [
            430.0,
            239.0,
            522.0,
            321.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:02.500000",
        "id": 37,
        "className": "Person",
        coords: [
            31.0,
            212.0,
            92.0,
            346.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:02.600000",
        "id": 34,
        "className": "Person",
        coords: [
            335.0,
            531.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:02.600000",
        "id": 36,
        "className": "Person",
        coords: [
            231.0,
            217.0,
            295.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:02.600000",
        "id": 23,
        "className": "Person",
        coords: [
            428.0,
            239.0,
            521.0,
            321.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:02.700000",
        "id": 37,
        "className": "Person",
        coords: [
            31.0,
            211.0,
            92.0,
            347.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:02.700000",
        "id": 34,
        "className": "Person",
        coords: [
            336.0,
            531.0,
            452.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:02.700000",
        "id": 36,
        "className": "Person",
        coords: [
            231.0,
            217.0,
            295.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:02.800000",
        "id": 23,
        "className": "Person",
        coords: [
            428.0,
            239.0,
            522.0,
            320.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:02.800000",
        "id": 37,
        "className": "Person",
        coords: [
            33.0,
            210.0,
            94.0,
            347.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:02.800000",
        "id": 34,
        "className": "Person",
        coords: [
            335.0,
            531.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:02.800000",
        "id": 36,
        "className": "Person",
        coords: [
            232.0,
            217.0,
            294.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:02.900000",
        "id": 23,
        "className": "Person",
        coords: [
            427.0,
            239.0,
            523.0,
            320.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:02.900000",
        "id": 37,
        "className": "Person",
        coords: [
            32.0,
            210.0,
            94.0,
            347.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:02.900000",
        "id": 38,
        "className": "Person",
        coords: [
            195.0,
            207.0,
            245.0,
            311.0
        ],
        "status": "First Seen",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:22:02.900000",
        "id": 34,
        "className": "Person",
        coords: [
            326.0,
            531.0,
            444.0,
            717.0
        ],
        "status": "Moving",
        "speed": 119.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:03",
        "id": 36,
        "className": "Person",
        coords: [
            231.0,
            216.0,
            293.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:03",
        "id": 23,
        "className": "Person",
        coords: [
            439.0,
            239.0,
            533.0,
            321.0
        ],
        "status": "Moving",
        "speed": 165.67,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:03",
        "id": 37,
        "className": "Person",
        coords: [
            33.0,
            210.0,
            94.0,
            347.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:03",
        "id": 38,
        "className": "Person",
        coords: [
            194.0,
            207.0,
            244.0,
            313.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:22:03.100000",
        "id": 34,
        "className": "Person",
        coords: [
            331.0,
            531.0,
            449.0,
            717.0
        ],
        "status": "Moving",
        "speed": 74.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:03.100000",
        "id": 36,
        "className": "Person",
        coords: [
            231.0,
            217.0,
            293.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:03.100000",
        "id": 23,
        "className": "Person",
        coords: [
            444.0,
            239.0,
            536.0,
            321.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:03.100000",
        "id": 37,
        "className": "Person",
        coords: [
            34.0,
            212.0,
            94.0,
            347.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:03.100000",
        "id": 38,
        "className": "Person",
        coords: [
            193.0,
            207.0,
            243.0,
            312.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:22:03.200000",
        "id": 34,
        "className": "Person",
        coords: [
            323.0,
            531.0,
            443.0,
            718.0
        ],
        "status": "Moving",
        "speed": 104.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:03.200000",
        "id": 36,
        "className": "Person",
        coords: [
            233.0,
            219.0,
            286.0,
            319.0
        ],
        "status": "Moving",
        "speed": 100.61,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:03.200000",
        "id": 37,
        "className": "Person",
        coords: [
            32.0,
            208.0,
            95.0,
            348.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:03.200000",
        "id": 38,
        "className": "Person",
        coords: [
            192.0,
            207.0,
            244.0,
            315.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:22:03.300000",
        "id": 34,
        "className": "Person",
        coords: [
            320.0,
            531.0,
            442.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:03.300000",
        "id": 36,
        "className": "Person",
        coords: [
            233.0,
            220.0,
            283.0,
            314.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:03.300000",
        "id": 37,
        "className": "Person",
        coords: [
            31.0,
            206.0,
            95.0,
            348.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:03.400000",
        "id": 38,
        "className": "Person",
        coords: [
            192.0,
            208.0,
            244.0,
            316.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Analysing",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:03.400000",
        "id": 34,
        "className": "Person",
        coords: [
            317.0,
            532.0,
            441.0,
            718.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:03.400000",
        "id": 37,
        "className": "Person",
        coords: [
            30.0,
            206.0,
            94.0,
            349.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:03.500000",
        "id": 38,
        "className": "Person",
        coords: [
            191.0,
            208.0,
            244.0,
            317.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Analysing",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:03.500000",
        "id": 39,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            177.0,
            273.0
        ],
        "status": "First Seen",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:22:03.900000",
        "id": 34,
        "className": "Person",
        coords: [
            316.0,
            532.0,
            441.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:03.900000",
        "id": 37,
        "className": "Person",
        coords: [
            29.0,
            205.0,
            92.0,
            348.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:03.900000",
        "id": 38,
        "className": "Person",
        coords: [
            192.0,
            207.0,
            245.0,
            317.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Analysing",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:03.900000",
        "id": 39,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:22:04",
        "id": 23,
        "className": "Person",
        coords: [
            454.0,
            237.0,
            544.0,
            321.0
        ],
        "status": "Moving",
        "speed": 135.82,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:04",
        "id": 37,
        "className": "Person",
        coords: [
            30.0,
            206.0,
            93.0,
            348.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:04",
        "id": 38,
        "className": "Person",
        coords: [
            193.0,
            208.0,
            246.0,
            318.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Analysing",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:04.100000",
        "id": 39,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:22:04.100000",
        "id": 23,
        "className": "Person",
        coords: [
            454.0,
            236.0,
            545.0,
            321.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:04.100000",
        "id": 37,
        "className": "Person",
        coords: [
            31.0,
            206.0,
            93.0,
            348.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:04.200000",
        "id": 38,
        "className": "Person",
        coords: [
            194.0,
            209.0,
            248.0,
            320.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:04.200000",
        "id": 39,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:22:04.200000",
        "id": 23,
        "className": "Person",
        coords: [
            457.0,
            236.0,
            547.0,
            322.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:04.200000",
        "id": 37,
        "className": "Person",
        coords: [
            32.0,
            205.0,
            94.0,
            348.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:04.300000",
        "id": 38,
        "className": "Person",
        coords: [
            195.0,
            211.0,
            249.0,
            322.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:04.300000",
        "id": 39,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:04.300000",
        "id": 23,
        "className": "Person",
        coords: [
            464.0,
            237.0,
            552.0,
            323.0
        ],
        "status": "Moving",
        "speed": 91.23,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:04.400000",
        "id": 37,
        "className": "Person",
        coords: [
            31.0,
            205.0,
            94.0,
            348.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:04.400000",
        "id": 38,
        "className": "Person",
        coords: [
            191.0,
            213.0,
            258.0,
            351.0
        ],
        "status": "Moving",
        "speed": 241.85,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:04.400000",
        "id": 39,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:04.400000",
        "id": 23,
        "className": "Person",
        coords: [
            471.0,
            238.0,
            557.0,
            323.0
        ],
        "status": "Moving",
        "speed": 89.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:04.500000",
        "id": 37,
        "className": "Person",
        coords: [
            29.0,
            205.0,
            92.0,
            349.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:04.500000",
        "id": 38,
        "className": "Person",
        coords: [
            193.0,
            214.0,
            264.0,
            363.0
        ],
        "status": "Moving",
        "speed": 108.16,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:04.500000",
        "id": 39,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:04.600000",
        "id": 23,
        "className": "Person",
        coords: [
            482.0,
            241.0,
            561.0,
            323.0
        ],
        "status": "Moving",
        "speed": 109.19,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:04.600000",
        "id": 37,
        "className": "Person",
        coords: [
            29.0,
            204.0,
            91.0,
            350.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:04.600000",
        "id": 38,
        "className": "Person",
        coords: [
            195.0,
            215.0,
            268.0,
            368.0
        ],
        "status": "Moving",
        "speed": 63.63,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:04.600000",
        "id": 39,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:04.700000",
        "id": 23,
        "className": "Person",
        coords: [
            486.0,
            241.0,
            563.0,
            324.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:04.700000",
        "id": 37,
        "className": "Person",
        coords: [
            29.0,
            204.0,
            91.0,
            351.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:04.700000",
        "id": 38,
        "className": "Person",
        coords: [
            199.0,
            216.0,
            271.0,
            368.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:04.700000",
        "id": 39,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:04.800000",
        "id": 23,
        "className": "Person",
        coords: [
            489.0,
            240.0,
            564.0,
            324.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:04.800000",
        "id": 37,
        "className": "Person",
        coords: [
            29.0,
            204.0,
            90.0,
            350.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:04.800000",
        "id": 38,
        "className": "Person",
        coords: [
            207.0,
            215.0,
            269.0,
            346.0
        ],
        "status": "Moving",
        "speed": 185.52,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:04.900000",
        "id": 39,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:04.900000",
        "id": 23,
        "className": "Person",
        coords: [
            490.0,
            238.0,
            565.0,
            324.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:04.900000",
        "id": 37,
        "className": "Person",
        coords: [
            29.0,
            204.0,
            89.0,
            349.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:04.900000",
        "id": 38,
        "className": "Person",
        coords: [
            212.0,
            215.0,
            270.0,
            335.0
        ],
        "status": "Moving",
        "speed": 87.46,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:05",
        "id": 39,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:05",
        "id": 23,
        "className": "Person",
        coords: [
            491.0,
            238.0,
            564.0,
            324.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:05.400000",
        "id": 37,
        "className": "Person",
        coords: [
            30.0,
            204.0,
            91.0,
            349.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:05.400000",
        "id": 38,
        "className": "Person",
        coords: [
            216.0,
            216.0,
            272.0,
            330.0
        ],
        "status": "Moving",
        "speed": 54.08,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:05.500000",
        "id": 39,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:05.500000",
        "id": 23,
        "className": "Person",
        coords: [
            491.0,
            238.0,
            563.0,
            324.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:05.500000",
        "id": 37,
        "className": "Person",
        coords: [
            31.0,
            204.0,
            91.0,
            350.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:05.500000",
        "id": 38,
        "className": "Person",
        coords: [
            219.0,
            216.0,
            274.0,
            328.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:05.600000",
        "id": 39,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:05.600000",
        "id": 23,
        "className": "Person",
        coords: [
            491.0,
            238.0,
            562.0,
            325.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:05.600000",
        "id": 34,
        "className": "Person",
        coords: [
            315.0,
            537.0,
            439.0,
            716.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:05.700000",
        "id": 37,
        "className": "Person",
        coords: [
            32.0,
            209.0,
            90.0,
            350.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:05.700000",
        "id": 38,
        "className": "Person",
        coords: [
            220.0,
            217.0,
            276.0,
            329.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:05.700000",
        "id": 39,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            176.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:05.700000",
        "id": 23,
        "className": "Person",
        coords: [
            492.0,
            239.0,
            561.0,
            325.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:05.800000",
        "id": 34,
        "className": "Person",
        coords: [
            318.0,
            537.0,
            437.0,
            701.0
        ],
        "status": "Moving",
        "speed": 104.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:05.800000",
        "id": 37,
        "className": "Person",
        coords: [
            32.0,
            210.0,
            90.0,
            349.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:05.800000",
        "id": 38,
        "className": "Person",
        coords: [
            222.0,
            219.0,
            279.0,
            330.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:05.900000",
        "id": 39,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            177.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:05.900000",
        "id": 23,
        "className": "Person",
        coords: [
            492.0,
            238.0,
            561.0,
            325.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:05.900000",
        "id": 37,
        "className": "Person",
        coords: [
            33.0,
            210.0,
            91.0,
            349.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:05.900000",
        "id": 38,
        "className": "Person",
        coords: [
            224.0,
            220.0,
            281.0,
            332.0
        ],
        "status": "Moving",
        "speed": 42.42,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:06",
        "id": 39,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            177.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:06",
        "id": 23,
        "className": "Person",
        coords: [
            493.0,
            238.0,
            561.0,
            325.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:06",
        "id": 37,
        "className": "Person",
        coords: [
            33.0,
            210.0,
            91.0,
            351.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:06",
        "id": 38,
        "className": "Person",
        coords: [
            220.0,
            222.0,
            289.0,
            360.0
        ],
        "status": "Moving",
        "speed": 226.97,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:06",
        "id": 39,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            177.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:06.100000",
        "id": 23,
        "className": "Person",
        coords: [
            494.0,
            238.0,
            561.0,
            325.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:06.100000",
        "id": 37,
        "className": "Person",
        coords: [
            35.0,
            212.0,
            92.0,
            350.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:06.100000",
        "id": 38,
        "className": "Person",
        coords: [
            220.0,
            223.0,
            293.0,
            370.0
        ],
        "status": "Moving",
        "speed": 80.77,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:06.200000",
        "id": 39,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            177.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:06.200000",
        "id": 23,
        "className": "Person",
        coords: [
            495.0,
            236.0,
            562.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:06.200000",
        "id": 37,
        "className": "Person",
        coords: [
            35.0,
            215.0,
            92.0,
            350.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:06.300000",
        "id": 38,
        "className": "Person",
        coords: [
            226.0,
            223.0,
            290.0,
            352.0
        ],
        "status": "Moving",
        "speed": 138.28,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:06.300000",
        "id": 39,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            177.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:06.300000",
        "id": 23,
        "className": "Person",
        coords: [
            497.0,
            239.0,
            560.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:06.300000",
        "id": 37,
        "className": "Person",
        coords: [
            36.0,
            216.0,
            92.0,
            351.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:06.400000",
        "id": 38,
        "className": "Person",
        coords: [
            228.0,
            224.0,
            289.0,
            346.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:06.400000",
        "id": 39,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            177.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:06.400000",
        "id": 23,
        "className": "Person",
        coords: [
            497.0,
            240.0,
            559.0,
            325.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:06.400000",
        "id": 37,
        "className": "Person",
        coords: [
            36.0,
            217.0,
            92.0,
            351.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:06.500000",
        "id": 38,
        "className": "Person",
        coords: [
            228.0,
            224.0,
            289.0,
            345.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:06.500000",
        "id": 39,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            177.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:06.500000",
        "id": 23,
        "className": "Person",
        coords: [
            498.0,
            241.0,
            559.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:06.600000",
        "id": 37,
        "className": "Person",
        coords: [
            35.0,
            216.0,
            92.0,
            351.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:06.600000",
        "id": 38,
        "className": "Person",
        coords: [
            223.0,
            224.0,
            294.0,
            365.0
        ],
        "status": "Moving",
        "speed": 149.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:06.600000",
        "id": 39,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            176.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:06.600000",
        "id": 23,
        "className": "Person",
        coords: [
            498.0,
            241.0,
            558.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:06.700000",
        "id": 37,
        "className": "Person",
        coords: [
            34.0,
            216.0,
            92.0,
            351.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:06.700000",
        "id": 38,
        "className": "Person",
        coords: [
            222.0,
            224.0,
            297.0,
            374.0
        ],
        "status": "Moving",
        "speed": 76.48,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:06.700000",
        "id": 39,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            177.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:06.700000",
        "id": 23,
        "className": "Person",
        coords: [
            498.0,
            241.0,
            557.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:06.800000",
        "id": 37,
        "className": "Person",
        coords: [
            35.0,
            216.0,
            93.0,
            351.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:06.800000",
        "id": 38,
        "className": "Person",
        coords: [
            222.0,
            224.0,
            300.0,
            383.0
        ],
        "status": "Moving",
        "speed": 67.08,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:06.800000",
        "id": 39,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            177.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:06.800000",
        "id": 23,
        "className": "Person",
        coords: [
            498.0,
            239.0,
            557.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:06.900000",
        "id": 34,
        "className": "Person",
        coords: [
            314.0,
            537.0,
            442.0,
            709.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:06.900000",
        "id": 37,
        "className": "Person",
        coords: [
            35.0,
            216.0,
            93.0,
            351.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:06.900000",
        "id": 38,
        "className": "Person",
        coords: [
            223.0,
            225.0,
            305.0,
            392.0
        ],
        "status": "Moving",
        "speed": 87.46,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:06.900000",
        "id": 39,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:07",
        "id": 23,
        "className": "Person",
        coords: [
            499.0,
            239.0,
            557.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:07",
        "id": 34,
        "className": "Person",
        coords: [
            313.0,
            537.0,
            444.0,
            710.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:07",
        "id": 37,
        "className": "Person",
        coords: [
            35.0,
            217.0,
            93.0,
            351.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:07.100000",
        "id": 38,
        "className": "Person",
        coords: [
            227.0,
            229.0,
            310.0,
            399.0
        ],
        "status": "Moving",
        "speed": 108.16,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:07.100000",
        "id": 39,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:07.100000",
        "id": 23,
        "className": "Person",
        coords: [
            500.0,
            240.0,
            556.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:07.100000",
        "id": 34,
        "className": "Person",
        coords: [
            312.0,
            537.0,
            444.0,
            709.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:07.500000",
        "id": 37,
        "className": "Person",
        coords: [
            35.0,
            217.0,
            93.0,
            351.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:07.500000",
        "id": 38,
        "className": "Person",
        coords: [
            229.0,
            231.0,
            312.0,
            403.0
        ],
        "status": "Moving",
        "speed": 54.08,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:07.600000",
        "id": 39,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:07.600000",
        "id": 23,
        "className": "Person",
        coords: [
            501.0,
            241.0,
            555.0,
            325.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:07.600000",
        "id": 37,
        "className": "Person",
        coords: [
            35.0,
            217.0,
            94.0,
            351.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:07.700000",
        "id": 38,
        "className": "Person",
        coords: [
            230.0,
            233.0,
            313.0,
            407.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:07.700000",
        "id": 39,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            177.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:07.700000",
        "id": 23,
        "className": "Person",
        coords: [
            501.0,
            241.0,
            556.0,
            325.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:07.700000",
        "id": 34,
        "className": "Person",
        coords: [
            311.0,
            537.0,
            445.0,
            710.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:07.800000",
        "id": 37,
        "className": "Person",
        coords: [
            32.0,
            209.0,
            93.0,
            348.0
        ],
        "status": "Moving",
        "speed": 94.86,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:07.800000",
        "id": 38,
        "className": "Person",
        coords: [
            233.0,
            234.0,
            315.0,
            409.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:07.800000",
        "id": 39,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            176.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:07.900000",
        "id": 23,
        "className": "Person",
        coords: [
            501.0,
            240.0,
            556.0,
            325.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:07.900000",
        "id": 34,
        "className": "Person",
        coords: [
            312.0,
            537.0,
            442.0,
            701.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:07.900000",
        "id": 37,
        "className": "Person",
        coords: [
            31.0,
            207.0,
            92.0,
            347.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:07.900000",
        "id": 38,
        "className": "Person",
        coords: [
            236.0,
            234.0,
            317.0,
            409.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:08",
        "id": 39,
        "className": "Person",
        coords: [
            139.0,
            193.0,
            176.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:08",
        "id": 23,
        "className": "Person",
        coords: [
            501.0,
            240.0,
            556.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:08",
        "id": 34,
        "className": "Person",
        coords: [
            313.0,
            537.0,
            441.0,
            696.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:08",
        "id": 37,
        "className": "Person",
        coords: [
            31.0,
            206.0,
            92.0,
            347.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:08",
        "id": 38,
        "className": "Person",
        coords: [
            241.0,
            234.0,
            320.0,
            410.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:08.100000",
        "id": 39,
        "className": "Person",
        coords: [
            139.0,
            193.0,
            176.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:08.100000",
        "id": 23,
        "className": "Person",
        coords: [
            501.0,
            240.0,
            556.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:08.100000",
        "id": 34,
        "className": "Person",
        coords: [
            312.0,
            537.0,
            442.0,
            695.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:08.500000",
        "id": 37,
        "className": "Person",
        coords: [
            31.0,
            205.0,
            92.0,
            346.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:08.500000",
        "id": 38,
        "className": "Person",
        coords: [
            244.0,
            235.0,
            323.0,
            410.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:08.600000",
        "id": 39,
        "className": "Person",
        coords: [
            139.0,
            193.0,
            176.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:08.600000",
        "id": 23,
        "className": "Person",
        coords: [
            500.0,
            239.0,
            557.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:08.600000",
        "id": 37,
        "className": "Person",
        coords: [
            32.0,
            206.0,
            92.0,
            346.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:08.600000",
        "id": 38,
        "className": "Person",
        coords: [
            248.0,
            234.0,
            326.0,
            411.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:08.600000",
        "id": 39,
        "className": "Person",
        coords: [
            139.0,
            193.0,
            176.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:08.700000",
        "id": 23,
        "className": "Person",
        coords: [
            501.0,
            239.0,
            558.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:08.700000",
        "id": 37,
        "className": "Person",
        coords: [
            32.0,
            207.0,
            92.0,
            346.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:08.700000",
        "id": 38,
        "className": "Person",
        coords: [
            252.0,
            234.0,
            328.0,
            410.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:08.700000",
        "id": 39,
        "className": "Person",
        coords: [
            139.0,
            193.0,
            176.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:08.800000",
        "id": 23,
        "className": "Person",
        coords: [
            501.0,
            240.0,
            558.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:08.800000",
        "id": 37,
        "className": "Person",
        coords: [
            32.0,
            207.0,
            92.0,
            345.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:08.800000",
        "id": 38,
        "className": "Person",
        coords: [
            255.0,
            236.0,
            330.0,
            410.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:08.800000",
        "id": 39,
        "className": "Person",
        coords: [
            139.0,
            193.0,
            176.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:08.900000",
        "id": 23,
        "className": "Person",
        coords: [
            501.0,
            239.0,
            559.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:08.900000",
        "id": 37,
        "className": "Person",
        coords: [
            32.0,
            207.0,
            92.0,
            345.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:08.900000",
        "id": 38,
        "className": "Person",
        coords: [
            256.0,
            239.0,
            330.0,
            411.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:08.900000",
        "id": 39,
        "className": "Person",
        coords: [
            139.0,
            193.0,
            176.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:08.900000",
        "id": 23,
        "className": "Person",
        coords: [
            504.0,
            239.0,
            561.0,
            329.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:09",
        "id": 37,
        "className": "Person",
        coords: [
            32.0,
            207.0,
            92.0,
            345.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:09",
        "id": 38,
        "className": "Person",
        coords: [
            259.0,
            244.0,
            331.0,
            412.0
        ],
        "status": "Moving",
        "speed": 54.08,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:09",
        "id": 39,
        "className": "Person",
        coords: [
            139.0,
            193.0,
            176.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:09.100000",
        "id": 23,
        "className": "Person",
        coords: [
            505.0,
            239.0,
            562.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:09.100000",
        "id": 37,
        "className": "Person",
        coords: [
            30.0,
            207.0,
            90.0,
            346.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:09.100000",
        "id": 38,
        "className": "Person",
        coords: [
            261.0,
            248.0,
            331.0,
            411.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:09.100000",
        "id": 39,
        "className": "Person",
        coords: [
            139.0,
            192.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:09.100000",
        "id": 23,
        "className": "Person",
        coords: [
            508.0,
            242.0,
            563.0,
            329.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:09.200000",
        "id": 37,
        "className": "Person",
        coords: [
            30.0,
            210.0,
            89.0,
            346.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:09.200000",
        "id": 38,
        "className": "Person",
        coords: [
            264.0,
            253.0,
            331.0,
            408.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:09.200000",
        "id": 39,
        "className": "Person",
        coords: [
            139.0,
            192.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:09.200000",
        "id": 23,
        "className": "Person",
        coords: [
            510.0,
            243.0,
            563.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:09.300000",
        "id": 37,
        "className": "Person",
        coords: [
            31.0,
            209.0,
            89.0,
            346.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:09.300000",
        "id": 38,
        "className": "Person",
        coords: [
            263.0,
            256.0,
            333.0,
            414.0
        ],
        "status": "Moving",
        "speed": 76.48,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:09.300000",
        "id": 39,
        "className": "Person",
        coords: [
            139.0,
            192.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:09.300000",
        "id": 23,
        "className": "Person",
        coords: [
            510.0,
            244.0,
            562.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:09.400000",
        "id": 37,
        "className": "Person",
        coords: [
            31.0,
            209.0,
            89.0,
            346.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:09.400000",
        "id": 38,
        "className": "Person",
        coords: [
            265.0,
            260.0,
            332.0,
            409.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:09.400000",
        "id": 39,
        "className": "Person",
        coords: [
            139.0,
            192.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:09.400000",
        "id": 23,
        "className": "Person",
        coords: [
            511.0,
            244.0,
            562.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:09.500000",
        "id": 37,
        "className": "Person",
        coords: [
            31.0,
            209.0,
            88.0,
            346.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:09.500000",
        "id": 38,
        "className": "Person",
        coords: [
            265.0,
            261.0,
            333.0,
            410.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:09.500000",
        "id": 39,
        "className": "Person",
        coords: [
            139.0,
            192.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:09.500000",
        "id": 23,
        "className": "Person",
        coords: [
            511.0,
            244.0,
            562.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:09.600000",
        "id": 37,
        "className": "Person",
        coords: [
            31.0,
            209.0,
            88.0,
            346.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:09.600000",
        "id": 38,
        "className": "Person",
        coords: [
            268.0,
            263.0,
            334.0,
            407.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:09.600000",
        "id": 39,
        "className": "Person",
        coords: [
            138.0,
            191.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:09.600000",
        "id": 23,
        "className": "Person",
        coords: [
            511.0,
            244.0,
            562.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:10.100000",
        "id": 37,
        "className": "Person",
        coords: [
            32.0,
            209.0,
            89.0,
            346.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:10.100000",
        "id": 38,
        "className": "Person",
        coords: [
            265.0,
            264.0,
            338.0,
            422.0
        ],
        "status": "Moving",
        "speed": 119.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:10.100000",
        "id": 39,
        "className": "Person",
        coords: [
            138.0,
            191.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:10.100000",
        "id": 23,
        "className": "Person",
        coords: [
            511.0,
            245.0,
            561.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:10.100000",
        "id": 37,
        "className": "Person",
        coords: [
            33.0,
            209.0,
            90.0,
            346.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:10.200000",
        "id": 38,
        "className": "Person",
        coords: [
            266.0,
            264.0,
            340.0,
            426.0
        ],
        "status": "Moving",
        "speed": 42.42,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:10.200000",
        "id": 39,
        "className": "Person",
        coords: [
            138.0,
            191.0,
            176.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:10.200000",
        "id": 23,
        "className": "Person",
        coords: [
            510.0,
            245.0,
            561.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:10.200000",
        "id": 37,
        "className": "Person",
        coords: [
            33.0,
            209.0,
            90.0,
            346.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:10.200000",
        "id": 38,
        "className": "Person",
        coords: [
            265.0,
            265.0,
            344.0,
            435.0
        ],
        "status": "Moving",
        "speed": 76.48,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:10.300000",
        "id": 39,
        "className": "Person",
        coords: [
            138.0,
            191.0,
            176.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:10.300000",
        "id": 23,
        "className": "Person",
        coords: [
            510.0,
            245.0,
            561.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:10.300000",
        "id": 37,
        "className": "Person",
        coords: [
            33.0,
            209.0,
            90.0,
            346.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:10.300000",
        "id": 38,
        "className": "Person",
        coords: [
            268.0,
            264.0,
            349.0,
            442.0
        ],
        "status": "Moving",
        "speed": 74.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:10.400000",
        "id": 39,
        "className": "Person",
        coords: [
            138.0,
            192.0,
            176.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:10.400000",
        "id": 23,
        "className": "Person",
        coords: [
            510.0,
            245.0,
            561.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:10.400000",
        "id": 37,
        "className": "Person",
        coords: [
            33.0,
            209.0,
            90.0,
            346.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:10.400000",
        "id": 38,
        "className": "Person",
        coords: [
            269.0,
            264.0,
            353.0,
            445.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:10.400000",
        "id": 39,
        "className": "Person",
        coords: [
            137.0,
            192.0,
            175.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:10.500000",
        "id": 23,
        "className": "Person",
        coords: [
            511.0,
            245.0,
            561.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:10.500000",
        "id": 37,
        "className": "Person",
        coords: [
            33.0,
            210.0,
            89.0,
            346.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:10.500000",
        "id": 38,
        "className": "Person",
        coords: [
            270.0,
            264.0,
            355.0,
            449.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:10.500000",
        "id": 39,
        "className": "Person",
        coords: [
            135.0,
            191.0,
            173.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:10.500000",
        "id": 23,
        "className": "Person",
        coords: [
            511.0,
            245.0,
            561.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:10.600000",
        "id": 37,
        "className": "Person",
        coords: [
            32.0,
            210.0,
            89.0,
            346.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:10.600000",
        "id": 38,
        "className": "Person",
        coords: [
            271.0,
            264.0,
            357.0,
            453.0
        ],
        "status": "Moving",
        "speed": 42.42,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:10.600000",
        "id": 39,
        "className": "Person",
        coords: [
            134.0,
            192.0,
            173.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:10.600000",
        "id": 23,
        "className": "Person",
        coords: [
            511.0,
            245.0,
            561.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:11.100000",
        "id": 37,
        "className": "Person",
        coords: [
            32.0,
            210.0,
            89.0,
            347.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:11.100000",
        "id": 38,
        "className": "Person",
        coords: [
            273.0,
            264.0,
            358.0,
            454.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:11.100000",
        "id": 39,
        "className": "Person",
        coords: [
            134.0,
            192.0,
            173.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:11.100000",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            245.0,
            561.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:11.200000",
        "id": 37,
        "className": "Person",
        coords: [
            33.0,
            210.0,
            89.0,
            347.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:11.200000",
        "id": 38,
        "className": "Person",
        coords: [
            276.0,
            263.0,
            360.0,
            454.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:11.200000",
        "id": 39,
        "className": "Person",
        coords: [
            134.0,
            192.0,
            174.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:11.200000",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            245.0,
            561.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:11.300000",
        "id": 37,
        "className": "Person",
        coords: [
            32.0,
            208.0,
            89.0,
            347.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:11.300000",
        "id": 38,
        "className": "Person",
        coords: [
            279.0,
            264.0,
            362.0,
            454.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:11.300000",
        "id": 39,
        "className": "Person",
        coords: [
            134.0,
            192.0,
            173.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:11.300000",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            245.0,
            561.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:11.300000",
        "id": 40,
        "className": "Person",
        coords: [
            227.0,
            251.0,
            287.0,
            371.0
        ],
        "status": "First Seen",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:22:11.400000",
        "id": 37,
        "className": "Person",
        coords: [
            32.0,
            208.0,
            90.0,
            347.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:11.400000",
        "id": 38,
        "className": "Person",
        coords: [
            282.0,
            264.0,
            364.0,
            453.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:11.400000",
        "id": 39,
        "className": "Person",
        coords: [
            133.0,
            193.0,
            173.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:11.400000",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            245.0,
            561.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:11.400000",
        "id": 40,
        "className": "Person",
        coords: [
            229.0,
            255.0,
            287.0,
            371.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:22:11.500000",
        "id": 37,
        "className": "Person",
        coords: [
            33.0,
            207.0,
            91.0,
            347.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:11.500000",
        "id": 38,
        "className": "Person",
        coords: [
            285.0,
            263.0,
            366.0,
            452.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:11.500000",
        "id": 39,
        "className": "Person",
        coords: [
            132.0,
            193.0,
            171.0,
            268.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:11.500000",
        "id": 23,
        "className": "Person",
        coords: [
            513.0,
            245.0,
            561.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:11.500000",
        "id": 40,
        "className": "Person",
        coords: [
            231.0,
            255.0,
            289.0,
            372.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:22:11.600000",
        "id": 37,
        "className": "Person",
        coords: [
            33.0,
            207.0,
            92.0,
            347.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:11.600000",
        "id": 38,
        "className": "Person",
        coords: [
            288.0,
            263.0,
            367.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:11.600000",
        "id": 39,
        "className": "Person",
        coords: [
            130.0,
            193.0,
            169.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:11.600000",
        "id": 23,
        "className": "Person",
        coords: [
            513.0,
            245.0,
            562.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:11.600000",
        "id": 40,
        "className": "Person",
        coords: [
            232.0,
            254.0,
            291.0,
            373.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:22:11.700000",
        "id": 37,
        "className": "Person",
        coords: [
            35.0,
            207.0,
            94.0,
            347.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:11.700000",
        "id": 38,
        "className": "Person",
        coords: [
            290.0,
            264.0,
            368.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:11.700000",
        "id": 39,
        "className": "Person",
        coords: [
            129.0,
            193.0,
            168.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:11.700000",
        "id": 23,
        "className": "Person",
        coords: [
            513.0,
            245.0,
            562.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:11.700000",
        "id": 40,
        "className": "Person",
        coords: [
            232.0,
            252.0,
            292.0,
            373.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "Yes",
        "vest": "No"
    },
    {
        "timestamp": "00:22:12.200000",
        "id": 37,
        "className": "Person",
        coords: [
            35.0,
            207.0,
            95.0,
            347.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:12.200000",
        "id": 38,
        "className": "Person",
        coords: [
            291.0,
            265.0,
            368.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:12.200000",
        "id": 39,
        "className": "Person",
        coords: [
            128.0,
            192.0,
            167.0,
            266.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:12.300000",
        "id": 23,
        "className": "Person",
        coords: [
            514.0,
            245.0,
            562.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:12.300000",
        "id": 40,
        "className": "Person",
        coords: [
            232.0,
            251.0,
            293.0,
            373.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "Yes",
        "vest": "No"
    },
    {
        "timestamp": "00:22:12.800000",
        "id": 37,
        "className": "Person",
        coords: [
            34.0,
            206.0,
            96.0,
            349.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:12.800000",
        "id": 38,
        "className": "Person",
        coords: [
            293.0,
            267.0,
            367.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:12.900000",
        "id": 39,
        "className": "Person",
        coords: [
            128.0,
            192.0,
            167.0,
            266.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:12.900000",
        "id": 23,
        "className": "Person",
        coords: [
            514.0,
            245.0,
            562.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:12.900000",
        "id": 40,
        "className": "Person",
        coords: [
            233.0,
            253.0,
            293.0,
            374.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "Yes",
        "vest": "No"
    },
    {
        "timestamp": "00:22:13",
        "id": 37,
        "className": "Person",
        coords: [
            34.0,
            206.0,
            97.0,
            349.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:13",
        "id": 38,
        "className": "Person",
        coords: [
            293.0,
            268.0,
            366.0,
            449.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:13",
        "id": 39,
        "className": "Person",
        coords: [
            128.0,
            191.0,
            167.0,
            266.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:13",
        "id": 23,
        "className": "Person",
        coords: [
            514.0,
            245.0,
            562.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:13",
        "id": 40,
        "className": "Person",
        coords: [
            233.0,
            256.0,
            294.0,
            376.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "Yes",
        "vest": "No"
    },
    {
        "timestamp": "00:22:13.100000",
        "id": 37,
        "className": "Person",
        coords: [
            34.0,
            206.0,
            97.0,
            349.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:13.100000",
        "id": 38,
        "className": "Person",
        coords: [
            293.0,
            270.0,
            364.0,
            446.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:13.100000",
        "id": 39,
        "className": "Person",
        coords: [
            129.0,
            191.0,
            167.0,
            266.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:13.100000",
        "id": 23,
        "className": "Person",
        coords: [
            514.0,
            245.0,
            562.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:13.200000",
        "id": 40,
        "className": "Person",
        coords: [
            233.0,
            258.0,
            293.0,
            377.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "Yes",
        "vest": "No"
    },
    {
        "timestamp": "00:22:13.200000",
        "id": 37,
        "className": "Person",
        coords: [
            33.0,
            206.0,
            97.0,
            350.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:13.200000",
        "id": 38,
        "className": "Person",
        coords: [
            291.0,
            271.0,
            362.0,
            447.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:13.200000",
        "id": 39,
        "className": "Person",
        coords: [
            128.0,
            191.0,
            167.0,
            266.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:13.200000",
        "id": 23,
        "className": "Person",
        coords: [
            515.0,
            245.0,
            563.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:13.300000",
        "id": 40,
        "className": "Person",
        coords: [
            232.0,
            259.0,
            292.0,
            378.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "Yes",
        "vest": "No"
    },
    {
        "timestamp": "00:22:13.300000",
        "id": 37,
        "className": "Person",
        coords: [
            33.0,
            206.0,
            97.0,
            350.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:13.300000",
        "id": 38,
        "className": "Person",
        coords: [
            289.0,
            271.0,
            361.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:13.300000",
        "id": 39,
        "className": "Person",
        coords: [
            128.0,
            190.0,
            166.0,
            265.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:13.400000",
        "id": 23,
        "className": "Person",
        coords: [
            515.0,
            245.0,
            563.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:13.400000",
        "id": 40,
        "className": "Person",
        coords: [
            231.0,
            259.0,
            293.0,
            382.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "Yes",
        "vest": "No"
    },
    {
        "timestamp": "00:22:13.400000",
        "id": 37,
        "className": "Person",
        coords: [
            32.0,
            206.0,
            96.0,
            350.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:13.400000",
        "id": 38,
        "className": "Person",
        coords: [
            287.0,
            272.0,
            359.0,
            451.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:13.500000",
        "id": 39,
        "className": "Person",
        coords: [
            128.0,
            190.0,
            166.0,
            265.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:13.500000",
        "id": 23,
        "className": "Person",
        coords: [
            515.0,
            245.0,
            563.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:13.500000",
        "id": 40,
        "className": "Person",
        coords: [
            230.0,
            259.0,
            293.0,
            385.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "Yes",
        "vest": "No"
    },
    {
        "timestamp": "00:22:13.500000",
        "id": 37,
        "className": "Person",
        coords: [
            32.0,
            206.0,
            96.0,
            351.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:13.500000",
        "id": 38,
        "className": "Person",
        coords: [
            286.0,
            273.0,
            358.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:13.600000",
        "id": 39,
        "className": "Person",
        coords: [
            129.0,
            190.0,
            166.0,
            265.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:13.600000",
        "id": 23,
        "className": "Person",
        coords: [
            515.0,
            245.0,
            562.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:13.600000",
        "id": 40,
        "className": "Person",
        coords: [
            229.0,
            261.0,
            293.0,
            388.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "Yes",
        "vest": "No"
    },
    {
        "timestamp": "00:22:13.600000",
        "id": 37,
        "className": "Person",
        coords: [
            30.0,
            206.0,
            94.0,
            353.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:13.700000",
        "id": 38,
        "className": "Person",
        coords: [
            286.0,
            274.0,
            355.0,
            443.0
        ],
        "status": "Moving",
        "speed": 67.08,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:13.700000",
        "id": 39,
        "className": "Person",
        coords: [
            129.0,
            191.0,
            166.0,
            265.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:13.700000",
        "id": 23,
        "className": "Person",
        coords: [
            515.0,
            245.0,
            562.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:13.700000",
        "id": 40,
        "className": "Person",
        coords: [
            229.0,
            261.0,
            294.0,
            390.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "Yes",
        "vest": "No"
    },
    {
        "timestamp": "00:22:13.800000",
        "id": 37,
        "className": "Person",
        coords: [
            30.0,
            207.0,
            92.0,
            350.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:13.800000",
        "id": 38,
        "className": "Person",
        coords: [
            283.0,
            275.0,
            356.0,
            455.0
        ],
        "status": "Moving",
        "speed": 106.06,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:13.800000",
        "id": 39,
        "className": "Person",
        coords: [
            129.0,
            191.0,
            166.0,
            265.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:13.800000",
        "id": 23,
        "className": "Person",
        coords: [
            515.0,
            245.0,
            562.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:13.900000",
        "id": 40,
        "className": "Person",
        coords: [
            230.0,
            262.0,
            295.0,
            393.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "Yes",
        "vest": "No"
    },
    {
        "timestamp": "00:22:13.900000",
        "id": 37,
        "className": "Person",
        coords: [
            30.0,
            207.0,
            92.0,
            352.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:13.900000",
        "id": 38,
        "className": "Person",
        coords: [
            281.0,
            276.0,
            357.0,
            464.0
        ],
        "status": "Moving",
        "speed": 74.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:13.900000",
        "id": 39,
        "className": "Person",
        coords: [
            129.0,
            191.0,
            166.0,
            265.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:14",
        "id": 23,
        "className": "Person",
        coords: [
            514.0,
            245.0,
            562.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:14",
        "id": 40,
        "className": "Person",
        coords: [
            230.0,
            264.0,
            295.0,
            394.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "Yes",
        "vest": "No"
    },
    {
        "timestamp": "00:22:14",
        "id": 37,
        "className": "Person",
        coords: [
            31.0,
            206.0,
            92.0,
            352.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:14",
        "id": 38,
        "className": "Person",
        coords: [
            280.0,
            276.0,
            358.0,
            471.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:14",
        "id": 39,
        "className": "Person",
        coords: [
            129.0,
            191.0,
            166.0,
            266.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:14.100000",
        "id": 23,
        "className": "Person",
        coords: [
            514.0,
            245.0,
            562.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:14.100000",
        "id": 40,
        "className": "Person",
        coords: [
            231.0,
            266.0,
            296.0,
            398.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "Yes",
        "vest": "No"
    },
    {
        "timestamp": "00:22:14.100000",
        "id": 37,
        "className": "Person",
        coords: [
            31.0,
            206.0,
            95.0,
            355.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:14.100000",
        "id": 38,
        "className": "Person",
        coords: [
            280.0,
            277.0,
            360.0,
            478.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:14.100000",
        "id": 39,
        "className": "Person",
        coords: [
            128.0,
            190.0,
            166.0,
            266.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:14.200000",
        "id": 23,
        "className": "Person",
        coords: [
            514.0,
            246.0,
            562.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:14.200000",
        "id": 40,
        "className": "Person",
        coords: [
            235.0,
            270.0,
            298.0,
            401.0
        ],
        "status": "Moving",
        "speed": 63.63,
        "hardhat": "No",
        "mask": "Yes",
        "vest": "No"
    },
    {
        "timestamp": "00:22:14.200000",
        "id": 37,
        "className": "Person",
        coords: [
            30.0,
            206.0,
            93.0,
            356.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:14.200000",
        "id": 38,
        "className": "Person",
        coords: [
            279.0,
            277.0,
            361.0,
            484.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:14.300000",
        "id": 39,
        "className": "Person",
        coords: [
            129.0,
            191.0,
            166.0,
            266.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:14.300000",
        "id": 23,
        "className": "Person",
        coords: [
            510.0,
            245.0,
            559.0,
            331.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:14.300000",
        "id": 40,
        "className": "Person",
        coords: [
            236.0,
            273.0,
            298.0,
            403.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "Yes",
        "vest": "No"
    },
    {
        "timestamp": "00:22:14.300000",
        "id": 37,
        "className": "Person",
        coords: [
            29.0,
            206.0,
            90.0,
            354.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:14.300000",
        "id": 38,
        "className": "Person",
        coords: [
            279.0,
            278.0,
            361.0,
            487.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:14.400000",
        "id": 39,
        "className": "Person",
        coords: [
            128.0,
            191.0,
            166.0,
            266.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:14.400000",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            246.0,
            562.0,
            332.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:14.400000",
        "id": 40,
        "className": "Person",
        coords: [
            235.0,
            273.0,
            298.0,
            406.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "Yes",
        "vest": "No"
    },
    {
        "timestamp": "00:22:14.400000",
        "id": 37,
        "className": "Person",
        coords: [
            29.0,
            206.0,
            91.0,
            356.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:14.500000",
        "id": 38,
        "className": "Person",
        coords: [
            279.0,
            279.0,
            360.0,
            486.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:14.500000",
        "id": 39,
        "className": "Person",
        coords: [
            129.0,
            192.0,
            166.0,
            266.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:14.500000",
        "id": 23,
        "className": "Person",
        coords: [
            509.0,
            246.0,
            560.0,
            332.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:14.500000",
        "id": 40,
        "className": "Person",
        coords: [
            235.0,
            273.0,
            299.0,
            407.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "Yes",
        "vest": "No"
    },
    {
        "timestamp": "00:22:14.500000",
        "id": 37,
        "className": "Person",
        coords: [
            29.0,
            205.0,
            92.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:14.600000",
        "id": 38,
        "className": "Person",
        coords: [
            283.0,
            281.0,
            352.0,
            458.0
        ],
        "status": "Moving",
        "speed": 197.28,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:14.600000",
        "id": 39,
        "className": "Person",
        coords: [
            129.0,
            193.0,
            166.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:14.600000",
        "id": 23,
        "className": "Person",
        coords: [
            511.0,
            246.0,
            562.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:14.600000",
        "id": 40,
        "className": "Person",
        coords: [
            236.0,
            275.0,
            299.0,
            407.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "Yes",
        "vest": "No"
    },
    {
        "timestamp": "00:22:14.700000",
        "id": 37,
        "className": "Person",
        coords: [
            29.0,
            206.0,
            91.0,
            359.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:14.700000",
        "id": 38,
        "className": "Person",
        coords: [
            286.0,
            282.0,
            351.0,
            449.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:14.700000",
        "id": 39,
        "className": "Person",
        coords: [
            129.0,
            193.0,
            166.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:14.700000",
        "id": 23,
        "className": "Person",
        coords: [
            511.0,
            246.0,
            563.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:14.700000",
        "id": 40,
        "className": "Person",
        coords: [
            237.0,
            275.0,
            301.0,
            407.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "Yes",
        "vest": "No"
    },
    {
        "timestamp": "00:22:14.800000",
        "id": 37,
        "className": "Person",
        coords: [
            29.0,
            206.0,
            90.0,
            359.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:14.800000",
        "id": 38,
        "className": "Person",
        coords: [
            288.0,
            285.0,
            353.0,
            449.0
        ],
        "status": "Moving",
        "speed": 42.42,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:14.800000",
        "id": 39,
        "className": "Person",
        coords: [
            129.0,
            193.0,
            167.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:14.800000",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            246.0,
            563.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:14.800000",
        "id": 40,
        "className": "Person",
        coords: [
            238.0,
            274.0,
            303.0,
            407.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "Yes",
        "vest": "No"
    },
    {
        "timestamp": "00:22:14.900000",
        "id": 37,
        "className": "Person",
        coords: [
            29.0,
            205.0,
            90.0,
            359.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:14.900000",
        "id": 38,
        "className": "Person",
        coords: [
            291.0,
            286.0,
            354.0,
            448.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:14.900000",
        "id": 39,
        "className": "Person",
        coords: [
            128.0,
            193.0,
            166.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:14.900000",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            247.0,
            564.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:14.900000",
        "id": 40,
        "className": "Person",
        coords: [
            237.0,
            275.0,
            303.0,
            407.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "Yes",
        "vest": "No"
    },
    {
        "timestamp": "00:22:15",
        "id": 37,
        "className": "Person",
        coords: [
            29.0,
            205.0,
            90.0,
            359.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:15",
        "id": 38,
        "className": "Person",
        coords: [
            294.0,
            289.0,
            356.0,
            448.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:15",
        "id": 39,
        "className": "Person",
        coords: [
            127.0,
            197.0,
            163.0,
            267.0
        ],
        "status": "Moving",
        "speed": 42.42,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:15",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            247.0,
            564.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:15",
        "id": 40,
        "className": "Person",
        coords: [
            237.0,
            277.0,
            303.0,
            407.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "Yes",
        "vest": "No"
    },
    {
        "timestamp": "00:22:15.100000",
        "id": 37,
        "className": "Person",
        coords: [
            30.0,
            205.0,
            90.0,
            357.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:15.100000",
        "id": 38,
        "className": "Person",
        coords: [
            296.0,
            290.0,
            358.0,
            449.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:15.100000",
        "id": 39,
        "className": "Person",
        coords: [
            129.0,
            204.0,
            163.0,
            267.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:15.100000",
        "id": 23,
        "className": "Person",
        coords: [
            513.0,
            248.0,
            565.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:15.100000",
        "id": 40,
        "className": "Person",
        coords: [
            235.0,
            278.0,
            302.0,
            408.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "Yes",
        "vest": "No"
    },
    {
        "timestamp": "00:22:15.200000",
        "id": 37,
        "className": "Person",
        coords: [
            29.0,
            206.0,
            89.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:15.200000",
        "id": 38,
        "className": "Person",
        coords: [
            297.0,
            290.0,
            359.0,
            449.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:15.200000",
        "id": 39,
        "className": "Person",
        coords: [
            129.0,
            206.0,
            163.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:15.200000",
        "id": 23,
        "className": "Person",
        coords: [
            515.0,
            248.0,
            566.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:15.200000",
        "id": 40,
        "className": "Person",
        coords: [
            233.0,
            279.0,
            301.0,
            408.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "Yes",
        "vest": "No"
    },
    {
        "timestamp": "00:22:15.300000",
        "id": 37,
        "className": "Person",
        coords: [
            29.0,
            206.0,
            89.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:15.300000",
        "id": 38,
        "className": "Person",
        coords: [
            299.0,
            292.0,
            361.0,
            450.0
        ],
        "status": "Moving",
        "speed": 42.42,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:15.300000",
        "id": 39,
        "className": "Person",
        coords: [
            129.0,
            208.0,
            162.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:15.300000",
        "id": 23,
        "className": "Person",
        coords: [
            516.0,
            249.0,
            567.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:15.300000",
        "id": 40,
        "className": "Person",
        coords: [
            233.0,
            281.0,
            300.0,
            406.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "Yes",
        "vest": "No"
    },
    {
        "timestamp": "00:22:15.400000",
        "id": 37,
        "className": "Person",
        coords: [
            30.0,
            207.0,
            89.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:15.400000",
        "id": 38,
        "className": "Person",
        coords: [
            300.0,
            293.0,
            362.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:15.400000",
        "id": 23,
        "className": "Person",
        coords: [
            517.0,
            249.0,
            568.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:15.400000",
        "id": 40,
        "className": "Person",
        coords: [
            235.0,
            283.0,
            301.0,
            404.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "Yes",
        "vest": "No"
    },
    {
        "timestamp": "00:22:15.500000",
        "id": 37,
        "className": "Person",
        coords: [
            30.0,
            207.0,
            89.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:15.500000",
        "id": 38,
        "className": "Person",
        coords: [
            300.0,
            294.0,
            362.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:15.500000",
        "id": 23,
        "className": "Person",
        coords: [
            518.0,
            249.0,
            568.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:15.500000",
        "id": 40,
        "className": "Person",
        coords: [
            236.0,
            285.0,
            300.0,
            403.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "Yes",
        "vest": "No"
    },
    {
        "timestamp": "00:22:15.600000",
        "id": 37,
        "className": "Person",
        coords: [
            30.0,
            207.0,
            89.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:15.600000",
        "id": 38,
        "className": "Person",
        coords: [
            300.0,
            295.0,
            362.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:15.600000",
        "id": 23,
        "className": "Person",
        coords: [
            518.0,
            249.0,
            568.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:15.600000",
        "id": 40,
        "className": "Person",
        coords: [
            236.0,
            285.0,
            301.0,
            402.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "Yes",
        "vest": "No"
    },
    {
        "timestamp": "00:22:15.600000",
        "id": 37,
        "className": "Person",
        coords: [
            31.0,
            206.0,
            90.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:15.700000",
        "id": 38,
        "className": "Person",
        coords: [
            300.0,
            295.0,
            362.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:15.700000",
        "id": 23,
        "className": "Person",
        coords: [
            516.0,
            249.0,
            567.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:15.700000",
        "id": 40,
        "className": "Person",
        coords: [
            237.0,
            286.0,
            300.0,
            399.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "Yes",
        "vest": "No"
    },
    {
        "timestamp": "00:22:15.700000",
        "id": 37,
        "className": "Person",
        coords: [
            33.0,
            206.0,
            93.0,
            358.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:15.800000",
        "id": 38,
        "className": "Person",
        coords: [
            299.0,
            295.0,
            362.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:15.800000",
        "id": 23,
        "className": "Person",
        coords: [
            517.0,
            249.0,
            568.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:15.800000",
        "id": 40,
        "className": "Person",
        coords: [
            237.0,
            287.0,
            300.0,
            398.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "Yes",
        "vest": "No"
    },
    {
        "timestamp": "00:22:15.800000",
        "id": 37,
        "className": "Person",
        coords: [
            35.0,
            206.0,
            96.0,
            356.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:15.800000",
        "id": 38,
        "className": "Person",
        coords: [
            299.0,
            296.0,
            361.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:15.900000",
        "id": 23,
        "className": "Person",
        coords: [
            516.0,
            250.0,
            568.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:15.900000",
        "id": 40,
        "className": "Person",
        coords: [
            238.0,
            287.0,
            299.0,
            396.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "Yes",
        "vest": "No"
    },
    {
        "timestamp": "00:22:15.900000",
        "id": 38,
        "className": "Person",
        coords: [
            299.0,
            296.0,
            360.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:15.900000",
        "id": 23,
        "className": "Person",
        coords: [
            516.0,
            250.0,
            569.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:16",
        "id": 40,
        "className": "Person",
        coords: [
            238.0,
            287.0,
            300.0,
            396.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "Yes",
        "vest": "No"
    },
    {
        "timestamp": "00:22:16",
        "id": 38,
        "className": "Person",
        coords: [
            298.0,
            295.0,
            360.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:16",
        "id": 23,
        "className": "Person",
        coords: [
            517.0,
            250.0,
            570.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:16",
        "id": 40,
        "className": "Person",
        coords: [
            237.0,
            286.0,
            301.0,
            396.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "Yes",
        "vest": "No"
    },
    {
        "timestamp": "00:22:16",
        "id": 37,
        "className": "Person",
        coords: [
            30.0,
            206.0,
            87.0,
            350.0
        ],
        "status": "Moving",
        "speed": 114.23,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:16.100000",
        "id": 38,
        "className": "Person",
        coords: [
            298.0,
            294.0,
            360.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:16.100000",
        "id": 23,
        "className": "Person",
        coords: [
            517.0,
            250.0,
            571.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:16.100000",
        "id": 40,
        "className": "Person",
        coords: [
            238.0,
            285.0,
            302.0,
            397.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "Yes",
        "vest": "No"
    },
    {
        "timestamp": "00:22:16.100000",
        "id": 37,
        "className": "Person",
        coords: [
            27.0,
            206.0,
            84.0,
            351.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:16.200000",
        "id": 38,
        "className": "Person",
        coords: [
            298.0,
            293.0,
            360.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:16.200000",
        "id": 23,
        "className": "Person",
        coords: [
            517.0,
            250.0,
            571.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:16.200000",
        "id": 40,
        "className": "Person",
        coords: [
            237.0,
            284.0,
            303.0,
            397.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "Yes",
        "vest": "No"
    },
    {
        "timestamp": "00:22:16.200000",
        "id": 37,
        "className": "Person",
        coords: [
            27.0,
            205.0,
            83.0,
            352.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:16.300000",
        "id": 38,
        "className": "Person",
        coords: [
            298.0,
            291.0,
            360.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:16.300000",
        "id": 23,
        "className": "Person",
        coords: [
            517.0,
            250.0,
            571.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:16.300000",
        "id": 40,
        "className": "Person",
        coords: [
            238.0,
            284.0,
            304.0,
            396.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "Yes",
        "vest": "No"
    },
    {
        "timestamp": "00:22:16.300000",
        "id": 37,
        "className": "Person",
        coords: [
            28.0,
            205.0,
            85.0,
            353.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:16.400000",
        "id": 38,
        "className": "Person",
        coords: [
            298.0,
            290.0,
            360.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:16.400000",
        "id": 23,
        "className": "Person",
        coords: [
            517.0,
            250.0,
            572.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:16.400000",
        "id": 40,
        "className": "Person",
        coords: [
            238.0,
            283.0,
            304.0,
            395.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "Yes",
        "vest": "No"
    },
    {
        "timestamp": "00:22:16.400000",
        "id": 37,
        "className": "Person",
        coords: [
            29.0,
            205.0,
            85.0,
            352.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:16.400000",
        "id": 38,
        "className": "Person",
        coords: [
            298.0,
            289.0,
            360.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:16.500000",
        "id": 23,
        "className": "Person",
        coords: [
            518.0,
            250.0,
            574.0,
            334.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:16.500000",
        "id": 40,
        "className": "Person",
        coords: [
            240.0,
            282.0,
            305.0,
            395.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "Yes",
        "vest": "No"
    },
    {
        "timestamp": "00:22:16.500000",
        "id": 37,
        "className": "Person",
        coords: [
            30.0,
            205.0,
            85.0,
            352.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:16.500000",
        "id": 38,
        "className": "Person",
        coords: [
            298.0,
            288.0,
            360.0,
            453.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:16.600000",
        "id": 23,
        "className": "Person",
        coords: [
            518.0,
            249.0,
            574.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:16.600000",
        "id": 40,
        "className": "Person",
        coords: [
            242.0,
            282.0,
            307.0,
            395.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "Yes",
        "vest": "No"
    },
    {
        "timestamp": "00:22:16.600000",
        "id": 37,
        "className": "Person",
        coords: [
            30.0,
            206.0,
            85.0,
            353.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:16.600000",
        "id": 38,
        "className": "Person",
        coords: [
            298.0,
            288.0,
            359.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:16.600000",
        "id": 23,
        "className": "Person",
        coords: [
            519.0,
            250.0,
            574.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:16.700000",
        "id": 40,
        "className": "Person",
        coords: [
            244.0,
            279.0,
            309.0,
            395.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "Yes",
        "vest": "No"
    },
    {
        "timestamp": "00:22:16.700000",
        "id": 37,
        "className": "Person",
        coords: [
            30.0,
            205.0,
            85.0,
            353.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:16.700000",
        "id": 38,
        "className": "Person",
        coords: [
            298.0,
            289.0,
            357.0,
            448.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:16.700000",
        "id": 23,
        "className": "Person",
        coords: [
            519.0,
            250.0,
            575.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:16.700000",
        "id": 40,
        "className": "Person",
        coords: [
            245.0,
            278.0,
            310.0,
            396.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "Yes",
        "vest": "No"
    },
    {
        "timestamp": "00:22:16.800000",
        "id": 37,
        "className": "Person",
        coords: [
            31.0,
            205.0,
            85.0,
            352.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:16.800000",
        "id": 34,
        "className": "Person",
        coords: [
            309.0,
            531.0,
            455.0,
            716.0
        ],
        "status": "Moving",
        "speed": 129.02,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:16.800000",
        "id": 38,
        "className": "Person",
        coords: [
            301.0,
            293.0,
            358.0,
            446.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:16.800000",
        "id": 23,
        "className": "Person",
        coords: [
            520.0,
            250.0,
            575.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:16.900000",
        "id": 37,
        "className": "Person",
        coords: [
            31.0,
            205.0,
            85.0,
            352.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:16.900000",
        "id": 34,
        "className": "Person",
        coords: [
            309.0,
            531.0,
            455.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:16.900000",
        "id": 38,
        "className": "Person",
        coords: [
            305.0,
            297.0,
            358.0,
            445.0
        ],
        "status": "Moving",
        "speed": 42.42,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:16.900000",
        "id": 23,
        "className": "Person",
        coords: [
            520.0,
            250.0,
            575.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:17",
        "id": 37,
        "className": "Person",
        coords: [
            31.0,
            205.0,
            85.0,
            352.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:17",
        "id": 34,
        "className": "Person",
        coords: [
            312.0,
            532.0,
            455.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:17",
        "id": 38,
        "className": "Person",
        coords: [
            306.0,
            300.0,
            358.0,
            443.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:17",
        "id": 23,
        "className": "Person",
        coords: [
            521.0,
            250.0,
            576.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:17.100000",
        "id": 37,
        "className": "Person",
        coords: [
            31.0,
            205.0,
            85.0,
            352.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:17.100000",
        "id": 34,
        "className": "Person",
        coords: [
            318.0,
            533.0,
            457.0,
            717.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:17.100000",
        "id": 23,
        "className": "Person",
        coords: [
            521.0,
            250.0,
            576.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:17.200000",
        "id": 37,
        "className": "Person",
        coords: [
            31.0,
            205.0,
            85.0,
            352.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:17.200000",
        "id": 34,
        "className": "Person",
        coords: [
            325.0,
            534.0,
            460.0,
            717.0
        ],
        "status": "Moving",
        "speed": 74.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:17.200000",
        "id": 23,
        "className": "Person",
        coords: [
            521.0,
            250.0,
            575.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:17.300000",
        "id": 37,
        "className": "Person",
        coords: [
            31.0,
            205.0,
            85.0,
            351.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:17.300000",
        "id": 34,
        "className": "Person",
        coords: [
            330.0,
            535.0,
            461.0,
            717.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:18.400000",
        "id": 23,
        "className": "Person",
        coords: [
            521.0,
            250.0,
            575.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:18.400000",
        "id": 37,
        "className": "Person",
        coords: [
            31.0,
            205.0,
            85.0,
            351.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:18.500000",
        "id": 34,
        "className": "Person",
        coords: [
            332.0,
            536.0,
            461.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:18.500000",
        "id": 40,
        "className": "Person",
        coords: [
            255.0,
            272.0,
            329.0,
            412.0
        ],
        "status": "Moving",
        "speed": 237.15,
        "hardhat": "No",
        "mask": "Yes",
        "vest": "No"
    },
    {
        "timestamp": "00:22:18.500000",
        "id": 38,
        "className": "Person",
        coords: [
            306.0,
            301.0,
            358.0,
            446.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:18.500000",
        "id": 23,
        "className": "Person",
        coords: [
            520.0,
            250.0,
            576.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:18.600000",
        "id": 37,
        "className": "Person",
        coords: [
            30.0,
            205.0,
            84.0,
            354.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:18.600000",
        "id": 23,
        "className": "Person",
        coords: [
            520.0,
            249.0,
            577.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:18.600000",
        "id": 37,
        "className": "Person",
        coords: [
            31.0,
            212.0,
            82.0,
            352.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:18.700000",
        "id": 23,
        "className": "Person",
        coords: [
            519.0,
            249.0,
            576.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:18.700000",
        "id": 37,
        "className": "Person",
        coords: [
            31.0,
            217.0,
            81.0,
            352.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:18.700000",
        "id": 23,
        "className": "Person",
        coords: [
            517.0,
            250.0,
            574.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:18.700000",
        "id": 37,
        "className": "Person",
        coords: [
            30.0,
            219.0,
            80.0,
            353.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:18.800000",
        "id": 23,
        "className": "Person",
        coords: [
            518.0,
            250.0,
            575.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:18.800000",
        "id": 37,
        "className": "Person",
        coords: [
            29.0,
            218.0,
            79.0,
            354.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:18.800000",
        "id": 34,
        "className": "Person",
        coords: [
            344.0,
            536.0,
            452.0,
            683.0
        ],
        "status": "Moving",
        "speed": 256.74,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:18.900000",
        "id": 23,
        "className": "Person",
        coords: [
            520.0,
            250.0,
            577.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:18.900000",
        "id": 37,
        "className": "Person",
        coords: [
            29.0,
            216.0,
            79.0,
            353.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:18.900000",
        "id": 34,
        "className": "Person",
        coords: [
            347.0,
            538.0,
            453.0,
            679.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:18.900000",
        "id": 23,
        "className": "Person",
        coords: [
            519.0,
            250.0,
            576.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:19",
        "id": 23,
        "className": "Person",
        coords: [
            517.0,
            250.0,
            574.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:19",
        "id": 38,
        "className": "Person",
        coords: [
            291.0,
            290.0,
            350.0,
            448.0
        ],
        "status": "Moving",
        "speed": 189.72,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:19.100000",
        "id": 23,
        "className": "Person",
        coords: [
            517.0,
            251.0,
            574.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:19.100000",
        "id": 23,
        "className": "Person",
        coords: [
            520.0,
            252.0,
            576.0,
            335.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:19.100000",
        "id": 23,
        "className": "Person",
        coords: [
            518.0,
            252.0,
            574.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:19.200000",
        "id": 23,
        "className": "Person",
        coords: [
            517.0,
            252.0,
            573.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:19.200000",
        "id": 23,
        "className": "Person",
        coords: [
            516.0,
            252.0,
            573.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:19.300000",
        "id": 23,
        "className": "Person",
        coords: [
            515.0,
            252.0,
            570.0,
            331.0
        ],
        "status": "Moving",
        "speed": 42.42,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:19.300000",
        "id": 23,
        "className": "Person",
        coords: [
            514.0,
            252.0,
            569.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:19.400000",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            248.0,
            569.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:19.400000",
        "id": 37,
        "className": "Person",
        coords: [
            19.0,
            215.0,
            71.0,
            351.0
        ],
        "status": "Moving",
        "speed": 135.82,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:19.400000",
        "id": 38,
        "className": "Person",
        coords: [
            269.0,
            288.0,
            328.0,
            433.0
        ],
        "status": "Moving",
        "speed": 356.52,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:19.500000",
        "id": 23,
        "className": "Person",
        coords: [
            511.0,
            247.0,
            569.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:19.500000",
        "id": 37,
        "className": "Person",
        coords: [
            17.0,
            212.0,
            71.0,
            350.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:19.500000",
        "id": 38,
        "className": "Person",
        coords: [
            266.0,
            289.0,
            328.0,
            433.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:19.600000",
        "id": 23,
        "className": "Person",
        coords: [
            511.0,
            247.0,
            569.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:19.600000",
        "id": 37,
        "className": "Person",
        coords: [
            16.0,
            216.0,
            69.0,
            349.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:19.600000",
        "id": 38,
        "className": "Person",
        coords: [
            264.0,
            288.0,
            328.0,
            432.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:19.600000",
        "id": 41,
        "className": "Person",
        coords: [
            141.0,
            193.0,
            177.0,
            270.0
        ],
        "status": "First Seen",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:22:19.700000",
        "id": 23,
        "className": "Person",
        coords: [
            511.0,
            246.0,
            569.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:19.700000",
        "id": 37,
        "className": "Person",
        coords: [
            15.0,
            210.0,
            71.0,
            349.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:19.700000",
        "id": 38,
        "className": "Person",
        coords: [
            262.0,
            288.0,
            329.0,
            432.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:19.700000",
        "id": 41,
        "className": "Person",
        coords: [
            141.0,
            192.0,
            177.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:22:19.700000",
        "id": 42,
        "className": "Person",
        coords: [
            610.0,
            460.0,
            738.0,
            674.0
        ],
        "status": "First Seen",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:22:19.800000",
        "id": 43,
        "className": "Person",
        coords: [
            724.0,
            449.0,
            821.0,
            617.0
        ],
        "status": "First Seen",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:22:19.800000",
        "id": 23,
        "className": "Person",
        coords: [
            511.0,
            246.0,
            568.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:19.800000",
        "id": 37,
        "className": "Person",
        coords: [
            15.0,
            208.0,
            72.0,
            349.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:19.800000",
        "id": 38,
        "className": "Person",
        coords: [
            260.0,
            287.0,
            329.0,
            432.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:19.800000",
        "id": 41,
        "className": "Person",
        coords: [
            140.0,
            191.0,
            177.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:22:19.900000",
        "id": 42,
        "className": "Person",
        coords: [
            602.0,
            447.0,
            738.0,
            675.0
        ],
        "status": "Moving",
        "speed": 108.16,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:22:19.900000",
        "id": 43,
        "className": "Person",
        coords: [
            715.0,
            449.0,
            817.0,
            625.0
        ],
        "status": "Moving",
        "speed": 108.16,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:22:19.900000",
        "id": 23,
        "className": "Person",
        coords: [
            511.0,
            247.0,
            568.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:19.900000",
        "id": 37,
        "className": "Person",
        coords: [
            14.0,
            207.0,
            72.0,
            349.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:20",
        "id": 38,
        "className": "Person",
        coords: [
            258.0,
            287.0,
            329.0,
            432.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:20",
        "id": 41,
        "className": "Person",
        coords: [
            140.0,
            190.0,
            177.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:22:20",
        "id": 42,
        "className": "Person",
        coords: [
            596.0,
            440.0,
            734.0,
            671.0
        ],
        "status": "Moving",
        "speed": 117.14,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:22:20",
        "id": 43,
        "className": "Person",
        coords: [
            711.0,
            449.0,
            813.0,
            622.0
        ],
        "status": "Moving",
        "speed": 67.08,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:22:20.400000",
        "id": 23,
        "className": "Person",
        coords: [
            511.0,
            246.0,
            568.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:20.400000",
        "id": 37,
        "className": "Person",
        coords: [
            13.0,
            206.0,
            72.0,
            348.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:20.500000",
        "id": 38,
        "className": "Person",
        coords: [
            255.0,
            287.0,
            329.0,
            432.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:20.500000",
        "id": 41,
        "className": "Person",
        coords: [
            140.0,
            190.0,
            177.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:20.500000",
        "id": 42,
        "className": "Person",
        coords: [
            598.0,
            446.0,
            722.0,
            655.0
        ],
        "status": "Moving",
        "speed": 106.06,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:22:20.500000",
        "id": 43,
        "className": "Person",
        coords: [
            709.0,
            449.0,
            807.0,
            612.0
        ],
        "status": "Moving",
        "speed": 96.04,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:22:20.500000",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            246.0,
            568.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:20.600000",
        "id": 37,
        "className": "Person",
        coords: [
            13.0,
            205.0,
            72.0,
            348.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:20.600000",
        "id": 38,
        "className": "Person",
        coords: [
            254.0,
            287.0,
            329.0,
            432.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:20.600000",
        "id": 41,
        "className": "Person",
        coords: [
            140.0,
            190.0,
            177.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:20.600000",
        "id": 42,
        "className": "Person",
        coords: [
            600.0,
            451.0,
            718.0,
            649.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "Analysing",
        "vest": "No"
    },
    {
        "timestamp": "00:22:20.600000",
        "id": 43,
        "className": "Person",
        coords: [
            708.0,
            449.0,
            806.0,
            609.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:20.700000",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            246.0,
            568.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:20.700000",
        "id": 37,
        "className": "Person",
        coords: [
            13.0,
            209.0,
            73.0,
            353.0
        ],
        "status": "Moving",
        "speed": 76.48,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:20.700000",
        "id": 38,
        "className": "Person",
        coords: [
            248.0,
            287.0,
            326.0,
            432.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:20.700000",
        "id": 41,
        "className": "Person",
        coords: [
            141.0,
            191.0,
            177.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:20.700000",
        "id": 43,
        "className": "Person",
        coords: [
            703.0,
            449.0,
            805.0,
            610.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:20.800000",
        "id": 23,
        "className": "Person",
        coords: [
            511.0,
            246.0,
            567.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:20.800000",
        "id": 37,
        "className": "Person",
        coords: [
            12.0,
            210.0,
            71.0,
            351.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:20.800000",
        "id": 38,
        "className": "Person",
        coords: [
            243.0,
            287.0,
            324.0,
            432.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:20.800000",
        "id": 41,
        "className": "Person",
        coords: [
            141.0,
            191.0,
            177.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:20.800000",
        "id": 43,
        "className": "Person",
        coords: [
            701.0,
            449.0,
            803.0,
            608.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:20.900000",
        "id": 23,
        "className": "Person",
        coords: [
            511.0,
            246.0,
            567.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:20.900000",
        "id": 37,
        "className": "Person",
        coords: [
            14.0,
            214.0,
            72.0,
            351.0
        ],
        "status": "Moving",
        "speed": 42.42,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:20.900000",
        "id": 38,
        "className": "Person",
        coords: [
            239.0,
            287.0,
            323.0,
            430.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:20.900000",
        "id": 41,
        "className": "Person",
        coords: [
            141.0,
            191.0,
            177.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:20.900000",
        "id": 43,
        "className": "Person",
        coords: [
            700.0,
            449.0,
            806.0,
            608.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:21",
        "id": 23,
        "className": "Person",
        coords: [
            510.0,
            247.0,
            566.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:21",
        "id": 37,
        "className": "Person",
        coords: [
            17.0,
            217.0,
            73.0,
            350.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:21",
        "id": 38,
        "className": "Person",
        coords: [
            235.0,
            287.0,
            322.0,
            430.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:21",
        "id": 41,
        "className": "Person",
        coords: [
            140.0,
            190.0,
            177.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:21",
        "id": 43,
        "className": "Person",
        coords: [
            698.0,
            449.0,
            806.0,
            606.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:21.100000",
        "id": 23,
        "className": "Person",
        coords: [
            510.0,
            247.0,
            566.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:21.100000",
        "id": 37,
        "className": "Person",
        coords: [
            16.0,
            214.0,
            74.0,
            352.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:21.100000",
        "id": 38,
        "className": "Person",
        coords: [
            230.0,
            287.0,
            320.0,
            430.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:21.100000",
        "id": 41,
        "className": "Person",
        coords: [
            139.0,
            190.0,
            176.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:21.200000",
        "id": 43,
        "className": "Person",
        coords: [
            704.0,
            449.0,
            815.0,
            608.0
        ],
        "status": "Moving",
        "speed": 106.06,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:21.200000",
        "id": 44,
        "className": "Person",
        coords: [
            521.0,
            438.0,
            653.0,
            648.0
        ],
        "status": "First Seen",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:22:21.200000",
        "id": 23,
        "className": "Person",
        coords: [
            511.0,
            247.0,
            567.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:21.200000",
        "id": 37,
        "className": "Person",
        coords: [
            19.0,
            212.0,
            78.0,
            356.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:21.200000",
        "id": 38,
        "className": "Person",
        coords: [
            227.0,
            287.0,
            319.0,
            430.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:21.300000",
        "id": 41,
        "className": "Person",
        coords: [
            139.0,
            190.0,
            176.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:21.300000",
        "id": 43,
        "className": "Person",
        coords: [
            699.0,
            450.0,
            813.0,
            609.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:21.300000",
        "id": 44,
        "className": "Person",
        coords: [
            519.0,
            440.0,
            650.0,
            648.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:22:21.300000",
        "id": 23,
        "className": "Person",
        coords: [
            511.0,
            246.0,
            567.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:21.400000",
        "id": 38,
        "className": "Person",
        coords: [
            224.0,
            287.0,
            320.0,
            430.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:21.400000",
        "id": 41,
        "className": "Person",
        coords: [
            139.0,
            190.0,
            175.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:21.400000",
        "id": 43,
        "className": "Person",
        coords: [
            705.0,
            449.0,
            819.0,
            607.0
        ],
        "status": "Moving",
        "speed": 91.23,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:21.400000",
        "id": 44,
        "className": "Person",
        coords: [
            515.0,
            432.0,
            652.0,
            648.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:22:21.400000",
        "id": 23,
        "className": "Person",
        coords: [
            513.0,
            247.0,
            569.0,
            333.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:21.500000",
        "id": 38,
        "className": "Person",
        coords: [
            223.0,
            288.0,
            320.0,
            431.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:21.500000",
        "id": 41,
        "className": "Person",
        coords: [
            137.0,
            189.0,
            173.0,
            269.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:21.500000",
        "id": 43,
        "className": "Person",
        coords: [
            708.0,
            449.0,
            821.0,
            605.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:21.500000",
        "id": 44,
        "className": "Person",
        coords: [
            509.0,
            426.0,
            648.0,
            647.0
        ],
        "status": "Moving",
        "speed": 96.04,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:22:21.600000",
        "id": 23,
        "className": "Person",
        coords: [
            515.0,
            247.0,
            570.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:21.600000",
        "id": 38,
        "className": "Person",
        coords: [
            222.0,
            288.0,
            321.0,
            431.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:21.600000",
        "id": 41,
        "className": "Person",
        coords: [
            136.0,
            189.0,
            171.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:21.600000",
        "id": 43,
        "className": "Person",
        coords: [
            698.0,
            449.0,
            814.0,
            604.0
        ],
        "status": "Moving",
        "speed": 120.92,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:21.600000",
        "id": 44,
        "className": "Person",
        coords: [
            501.0,
            422.0,
            641.0,
            646.0
        ],
        "status": "Moving",
        "speed": 109.19,
        "hardhat": "No",
        "mask": "Analysing",
        "vest": "No"
    },
    {
        "timestamp": "00:22:21.700000",
        "id": 23,
        "className": "Person",
        coords: [
            515.0,
            247.0,
            570.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:21.700000",
        "id": 38,
        "className": "Person",
        coords: [
            221.0,
            289.0,
            322.0,
            431.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:21.700000",
        "id": 41,
        "className": "Person",
        coords: [
            135.0,
            189.0,
            170.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:21.700000",
        "id": 44,
        "className": "Person",
        coords: [
            492.0,
            416.0,
            631.0,
            645.0
        ],
        "status": "Moving",
        "speed": 161.54,
        "hardhat": "No",
        "mask": "Analysing",
        "vest": "No"
    },
    {
        "timestamp": "00:22:21.800000",
        "id": 23,
        "className": "Person",
        coords: [
            515.0,
            247.0,
            569.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:21.800000",
        "id": 38,
        "className": "Person",
        coords: [
            220.0,
            289.0,
            323.0,
            431.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:21.800000",
        "id": 41,
        "className": "Person",
        coords: [
            135.0,
            189.0,
            169.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:21.800000",
        "id": 44,
        "className": "Person",
        coords: [
            484.0,
            411.0,
            622.0,
            644.0
        ],
        "status": "Moving",
        "speed": 128.15,
        "hardhat": "No",
        "mask": "Analysing",
        "vest": "No"
    },
    {
        "timestamp": "00:22:21.900000",
        "id": 23,
        "className": "Person",
        coords: [
            516.0,
            247.0,
            569.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:21.900000",
        "id": 38,
        "className": "Person",
        coords: [
            220.0,
            289.0,
            323.0,
            430.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:21.900000",
        "id": 41,
        "className": "Person",
        coords: [
            135.0,
            190.0,
            169.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:21.900000",
        "id": 44,
        "className": "Person",
        coords: [
            478.0,
            408.0,
            614.0,
            643.0
        ],
        "status": "Moving",
        "speed": 109.19,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:22",
        "id": 23,
        "className": "Person",
        coords: [
            516.0,
            247.0,
            569.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:22",
        "id": 38,
        "className": "Person",
        coords: [
            219.0,
            289.0,
            324.0,
            430.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:22",
        "id": 41,
        "className": "Person",
        coords: [
            135.0,
            190.0,
            168.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:22",
        "id": 44,
        "className": "Person",
        coords: [
            466.0,
            411.0,
            597.0,
            644.0
        ],
        "status": "Moving",
        "speed": 226.97,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:22",
        "id": 43,
        "className": "Person",
        coords: [
            693.0,
            449.0,
            812.0,
            603.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:22.100000",
        "id": 23,
        "className": "Person",
        coords: [
            517.0,
            247.0,
            570.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:22.100000",
        "id": 38,
        "className": "Person",
        coords: [
            219.0,
            290.0,
            324.0,
            431.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:22.100000",
        "id": 41,
        "className": "Person",
        coords: [
            135.0,
            190.0,
            168.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:22.100000",
        "id": 44,
        "className": "Person",
        coords: [
            451.0,
            408.0,
            584.0,
            643.0
        ],
        "status": "Moving",
        "speed": 212.11,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:22.200000",
        "id": 23,
        "className": "Person",
        coords: [
            517.0,
            247.0,
            571.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:22.200000",
        "id": 38,
        "className": "Person",
        coords: [
            218.0,
            290.0,
            325.0,
            431.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:22.200000",
        "id": 41,
        "className": "Person",
        coords: [
            135.0,
            190.0,
            168.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:22.200000",
        "id": 44,
        "className": "Person",
        coords: [
            447.0,
            408.0,
            580.0,
            644.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:22.300000",
        "id": 23,
        "className": "Person",
        coords: [
            518.0,
            248.0,
            571.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:22.300000",
        "id": 38,
        "className": "Person",
        coords: [
            218.0,
            290.0,
            325.0,
            432.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:22.300000",
        "id": 41,
        "className": "Person",
        coords: [
            135.0,
            190.0,
            167.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:22.300000",
        "id": 44,
        "className": "Person",
        coords: [
            442.0,
            410.0,
            572.0,
            644.0
        ],
        "status": "Moving",
        "speed": 91.23,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:22.400000",
        "id": 23,
        "className": "Person",
        coords: [
            517.0,
            247.0,
            570.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:22.400000",
        "id": 38,
        "className": "Person",
        coords: [
            217.0,
            290.0,
            325.0,
            432.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:22.400000",
        "id": 41,
        "className": "Person",
        coords: [
            134.0,
            191.0,
            167.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:22.400000",
        "id": 44,
        "className": "Person",
        coords: [
            439.0,
            408.0,
            568.0,
            643.0
        ],
        "status": "Moving",
        "speed": 67.08,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:22.400000",
        "id": 23,
        "className": "Person",
        coords: [
            516.0,
            247.0,
            570.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:22.500000",
        "id": 38,
        "className": "Person",
        coords: [
            216.0,
            290.0,
            325.0,
            432.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:22.500000",
        "id": 41,
        "className": "Person",
        coords: [
            134.0,
            192.0,
            166.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:22.500000",
        "id": 44,
        "className": "Person",
        coords: [
            436.0,
            407.0,
            562.0,
            641.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:22.500000",
        "id": 23,
        "className": "Person",
        coords: [
            516.0,
            247.0,
            570.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:22.600000",
        "id": 38,
        "className": "Person",
        coords: [
            216.0,
            291.0,
            326.0,
            432.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:22.600000",
        "id": 41,
        "className": "Person",
        coords: [
            133.0,
            192.0,
            165.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:22.600000",
        "id": 44,
        "className": "Person",
        coords: [
            431.0,
            408.0,
            548.0,
            631.0
        ],
        "status": "Moving",
        "speed": 167.69,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:23",
        "id": 23,
        "className": "Person",
        coords: [
            517.0,
            248.0,
            571.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:23",
        "id": 38,
        "className": "Person",
        coords: [
            216.0,
            291.0,
            326.0,
            432.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:23",
        "id": 41,
        "className": "Person",
        coords: [
            131.0,
            192.0,
            164.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:23.100000",
        "id": 44,
        "className": "Person",
        coords: [
            429.0,
            400.0,
            529.0,
            593.0
        ],
        "status": "Moving",
        "speed": 376.17,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:23.100000",
        "id": 23,
        "className": "Person",
        coords: [
            516.0,
            248.0,
            570.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:23.100000",
        "id": 38,
        "className": "Person",
        coords: [
            214.0,
            291.0,
            325.0,
            433.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:23.100000",
        "id": 41,
        "className": "Person",
        coords: [
            130.0,
            192.0,
            164.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:23.100000",
        "id": 44,
        "className": "Person",
        coords: [
            420.0,
            398.0,
            521.0,
            598.0
        ],
        "status": "Moving",
        "speed": 138.28,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:23.200000",
        "id": 23,
        "className": "Person",
        coords: [
            517.0,
            248.0,
            571.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:23.200000",
        "id": 38,
        "className": "Person",
        coords: [
            214.0,
            291.0,
            325.0,
            433.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:23.200000",
        "id": 41,
        "className": "Person",
        coords: [
            130.0,
            193.0,
            164.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:23.200000",
        "id": 44,
        "className": "Person",
        coords: [
            413.0,
            397.0,
            513.0,
            601.0
        ],
        "status": "Moving",
        "speed": 106.06,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:23.300000",
        "id": 23,
        "className": "Person",
        coords: [
            518.0,
            249.0,
            573.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:23.300000",
        "id": 38,
        "className": "Person",
        coords: [
            216.0,
            291.0,
            327.0,
            432.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:23.300000",
        "id": 41,
        "className": "Person",
        coords: [
            129.0,
            192.0,
            163.0,
            267.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:23.300000",
        "id": 44,
        "className": "Person",
        coords: [
            409.0,
            395.0,
            508.0,
            603.0
        ],
        "status": "Moving",
        "speed": 74.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:23.400000",
        "id": 43,
        "className": "Person",
        coords: [
            718.0,
            448.0,
            833.0,
            600.0
        ],
        "status": "Moving",
        "speed": 346.27,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:23.400000",
        "id": 23,
        "className": "Person",
        coords: [
            517.0,
            249.0,
            572.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:23.400000",
        "id": 38,
        "className": "Person",
        coords: [
            216.0,
            291.0,
            328.0,
            432.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:23.400000",
        "id": 41,
        "className": "Person",
        coords: [
            128.0,
            191.0,
            162.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:23.500000",
        "id": 44,
        "className": "Person",
        coords: [
            401.0,
            396.0,
            501.0,
            608.0
        ],
        "status": "Moving",
        "speed": 114.23,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:23.500000",
        "id": 43,
        "className": "Person",
        coords: [
            719.0,
            448.0,
            834.0,
            601.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:23.500000",
        "id": 23,
        "className": "Person",
        coords: [
            516.0,
            249.0,
            571.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:23.500000",
        "id": 38,
        "className": "Person",
        coords: [
            217.0,
            291.0,
            330.0,
            433.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:23.600000",
        "id": 41,
        "className": "Person",
        coords: [
            127.0,
            191.0,
            162.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:23.600000",
        "id": 44,
        "className": "Person",
        coords: [
            394.0,
            395.0,
            495.0,
            613.0
        ],
        "status": "Moving",
        "speed": 109.19,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:23.600000",
        "id": 43,
        "className": "Person",
        coords: [
            721.0,
            448.0,
            833.0,
            600.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:23.600000",
        "id": 23,
        "className": "Person",
        coords: [
            516.0,
            249.0,
            571.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:23.700000",
        "id": 38,
        "className": "Person",
        coords: [
            218.0,
            289.0,
            332.0,
            433.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:23.700000",
        "id": 41,
        "className": "Person",
        coords: [
            127.0,
            191.0,
            163.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:23.700000",
        "id": 44,
        "className": "Person",
        coords: [
            390.0,
            391.0,
            492.0,
            616.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:23.700000",
        "id": 43,
        "className": "Person",
        coords: [
            721.0,
            449.0,
            832.0,
            600.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:23.800000",
        "id": 23,
        "className": "Person",
        coords: [
            517.0,
            249.0,
            572.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:23.800000",
        "id": 38,
        "className": "Person",
        coords: [
            219.0,
            289.0,
            333.0,
            433.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:23.800000",
        "id": 41,
        "className": "Person",
        coords: [
            127.0,
            192.0,
            163.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:23.800000",
        "id": 44,
        "className": "Person",
        coords: [
            384.0,
            388.0,
            486.0,
            616.0
        ],
        "status": "Moving",
        "speed": 91.23,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:23.800000",
        "id": 43,
        "className": "Person",
        coords: [
            722.0,
            449.0,
            832.0,
            600.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:23.900000",
        "id": 45,
        "className": "Person",
        coords: [
            316.0,
            543.0,
            482.0,
            715.0
        ],
        "status": "First Seen",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:22:23.900000",
        "id": 23,
        "className": "Person",
        coords: [
            518.0,
            249.0,
            573.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:23.900000",
        "id": 38,
        "className": "Person",
        coords: [
            220.0,
            288.0,
            334.0,
            433.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:23.900000",
        "id": 41,
        "className": "Person",
        coords: [
            128.0,
            192.0,
            163.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:24",
        "id": 44,
        "className": "Person",
        coords: [
            378.0,
            386.0,
            467.0,
            585.0
        ],
        "status": "Moving",
        "speed": 320.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:24",
        "id": 43,
        "className": "Person",
        coords: [
            723.0,
            449.0,
            831.0,
            599.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:24",
        "id": 45,
        "className": "Person",
        coords: [
            314.0,
            542.0,
            480.0,
            714.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:22:24",
        "id": 23,
        "className": "Person",
        coords: [
            518.0,
            249.0,
            573.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:24.100000",
        "id": 38,
        "className": "Person",
        coords: [
            222.0,
            287.0,
            337.0,
            433.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:24.100000",
        "id": 41,
        "className": "Person",
        coords: [
            128.0,
            192.0,
            163.0,
            266.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:24.100000",
        "id": 44,
        "className": "Person",
        coords: [
            367.0,
            386.0,
            452.0,
            572.0
        ],
        "status": "Moving",
        "speed": 214.75,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:24.100000",
        "id": 43,
        "className": "Person",
        coords: [
            722.0,
            449.0,
            831.0,
            601.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:24.200000",
        "id": 45,
        "className": "Person",
        coords: [
            313.0,
            543.0,
            481.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:22:24.600000",
        "id": 23,
        "className": "Person",
        coords: [
            517.0,
            249.0,
            572.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:24.600000",
        "id": 38,
        "className": "Person",
        coords: [
            225.0,
            287.0,
            338.0,
            432.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:24.600000",
        "id": 41,
        "className": "Person",
        coords: [
            128.0,
            192.0,
            163.0,
            266.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:24.600000",
        "id": 44,
        "className": "Person",
        coords: [
            360.0,
            388.0,
            442.0,
            565.0
        ],
        "status": "Moving",
        "speed": 128.15,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:24.600000",
        "id": 43,
        "className": "Person",
        coords: [
            721.0,
            448.0,
            831.0,
            602.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:24.700000",
        "id": 45,
        "className": "Person",
        coords: [
            313.0,
            543.0,
            480.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:22:24.700000",
        "id": 37,
        "className": "Person",
        coords: [
            18.0,
            209.0,
            77.0,
            349.0
        ],
        "status": "Moving",
        "speed": 76.48,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:24.700000",
        "id": 23,
        "className": "Person",
        coords: [
            517.0,
            249.0,
            572.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:24.800000",
        "id": 38,
        "className": "Person",
        coords: [
            228.0,
            288.0,
            339.0,
            431.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:24.800000",
        "id": 41,
        "className": "Person",
        coords: [
            129.0,
            192.0,
            164.0,
            266.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:24.800000",
        "id": 44,
        "className": "Person",
        coords: [
            357.0,
            387.0,
            438.0,
            559.0
        ],
        "status": "Moving",
        "speed": 74.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:24.800000",
        "id": 43,
        "className": "Person",
        coords: [
            721.0,
            448.0,
            831.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:24.900000",
        "id": 45,
        "className": "Person",
        coords: [
            316.0,
            543.0,
            484.0,
            718.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:22:24.900000",
        "id": 37,
        "className": "Person",
        coords: [
            15.0,
            213.0,
            70.0,
            348.0
        ],
        "status": "Moving",
        "speed": 76.48,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:24.900000",
        "id": 23,
        "className": "Person",
        coords: [
            518.0,
            249.0,
            573.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:25",
        "id": 38,
        "className": "Person",
        coords: [
            229.0,
            289.0,
            341.0,
            432.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:25",
        "id": 41,
        "className": "Person",
        coords: [
            130.0,
            191.0,
            166.0,
            266.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:25",
        "id": 44,
        "className": "Person",
        coords: [
            355.0,
            389.0,
            434.0,
            556.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:25",
        "id": 43,
        "className": "Person",
        coords: [
            721.0,
            448.0,
            831.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:25",
        "id": 45,
        "className": "Person",
        coords: [
            323.0,
            543.0,
            489.0,
            718.0
        ],
        "status": "Moving",
        "speed": 89.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:25",
        "id": 37,
        "className": "Person",
        coords: [
            14.0,
            214.0,
            66.0,
            347.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:25.100000",
        "id": 23,
        "className": "Person",
        coords: [
            516.0,
            248.0,
            571.0,
            337.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:25.100000",
        "id": 38,
        "className": "Person",
        coords: [
            231.0,
            290.0,
            342.0,
            433.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:25.100000",
        "id": 41,
        "className": "Person",
        coords: [
            131.0,
            191.0,
            166.0,
            266.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:25.200000",
        "id": 44,
        "className": "Person",
        coords: [
            353.0,
            389.0,
            431.0,
            552.0
        ],
        "status": "Moving",
        "speed": 42.42,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:25.200000",
        "id": 43,
        "className": "Person",
        coords: [
            721.0,
            448.0,
            831.0,
            604.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:25.200000",
        "id": 45,
        "className": "Person",
        coords: [
            326.0,
            543.0,
            490.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:25.200000",
        "id": 37,
        "className": "Person",
        coords: [
            13.0,
            214.0,
            63.0,
            347.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:25.600000",
        "id": 23,
        "className": "Person",
        coords: [
            515.0,
            248.0,
            571.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:25.600000",
        "id": 38,
        "className": "Person",
        coords: [
            233.0,
            290.0,
            346.0,
            436.0
        ],
        "status": "Moving",
        "speed": 54.08,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:25.600000",
        "id": 41,
        "className": "Person",
        coords: [
            132.0,
            191.0,
            167.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:25.700000",
        "id": 44,
        "className": "Person",
        coords: [
            349.0,
            387.0,
            428.0,
            551.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:25.700000",
        "id": 43,
        "className": "Person",
        coords: [
            722.0,
            447.0,
            830.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:25.700000",
        "id": 45,
        "className": "Person",
        coords: [
            321.0,
            544.0,
            484.0,
            717.0
        ],
        "status": "Moving",
        "speed": 89.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:25.700000",
        "id": 37,
        "className": "Person",
        coords: [
            14.0,
            215.0,
            64.0,
            347.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:25.800000",
        "id": 23,
        "className": "Person",
        coords: [
            516.0,
            248.0,
            571.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:25.800000",
        "id": 38,
        "className": "Person",
        coords: [
            232.0,
            290.0,
            346.0,
            439.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:25.800000",
        "id": 41,
        "className": "Person",
        coords: [
            133.0,
            191.0,
            168.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:25.900000",
        "id": 43,
        "className": "Person",
        coords: [
            722.0,
            447.0,
            830.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:25.900000",
        "id": 45,
        "className": "Person",
        coords: [
            317.0,
            544.0,
            480.0,
            718.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:25.900000",
        "id": 37,
        "className": "Person",
        coords: [
            18.0,
            215.0,
            69.0,
            349.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:26",
        "id": 23,
        "className": "Person",
        coords: [
            515.0,
            248.0,
            572.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:26",
        "id": 38,
        "className": "Person",
        coords: [
            236.0,
            290.0,
            350.0,
            441.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:26",
        "id": 41,
        "className": "Person",
        coords: [
            133.0,
            191.0,
            169.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:26",
        "id": 43,
        "className": "Person",
        coords: [
            723.0,
            448.0,
            830.0,
            603.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:26.100000",
        "id": 45,
        "className": "Person",
        coords: [
            316.0,
            544.0,
            478.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:26.100000",
        "id": 37,
        "className": "Person",
        coords: [
            20.0,
            216.0,
            72.0,
            349.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:26.200000",
        "id": 23,
        "className": "Person",
        coords: [
            514.0,
            248.0,
            571.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:26.200000",
        "id": 38,
        "className": "Person",
        coords: [
            237.0,
            290.0,
            351.0,
            442.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:26.200000",
        "id": 41,
        "className": "Person",
        coords: [
            133.0,
            191.0,
            168.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:26.200000",
        "id": 43,
        "className": "Person",
        coords: [
            724.0,
            448.0,
            829.0,
            600.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:26.300000",
        "id": 45,
        "className": "Person",
        coords: [
            315.0,
            544.0,
            476.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:26.700000",
        "id": 23,
        "className": "Person",
        coords: [
            514.0,
            248.0,
            571.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:26.700000",
        "id": 38,
        "className": "Person",
        coords: [
            238.0,
            290.0,
            351.0,
            443.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:26.700000",
        "id": 41,
        "className": "Person",
        coords: [
            133.0,
            191.0,
            168.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:26.700000",
        "id": 43,
        "className": "Person",
        coords: [
            724.0,
            448.0,
            829.0,
            599.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:26.700000",
        "id": 45,
        "className": "Person",
        coords: [
            315.0,
            545.0,
            476.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:26.800000",
        "id": 23,
        "className": "Person",
        coords: [
            513.0,
            248.0,
            571.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:26.800000",
        "id": 38,
        "className": "Person",
        coords: [
            239.0,
            290.0,
            351.0,
            443.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:26.800000",
        "id": 41,
        "className": "Person",
        coords: [
            133.0,
            191.0,
            169.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:26.900000",
        "id": 43,
        "className": "Person",
        coords: [
            724.0,
            448.0,
            829.0,
            599.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:26.900000",
        "id": 45,
        "className": "Person",
        coords: [
            315.0,
            545.0,
            475.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:26.900000",
        "id": 37,
        "className": "Person",
        coords: [
            21.0,
            218.0,
            73.0,
            350.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:26.900000",
        "id": 23,
        "className": "Person",
        coords: [
            513.0,
            248.0,
            571.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:27",
        "id": 38,
        "className": "Person",
        coords: [
            240.0,
            290.0,
            350.0,
            443.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:27",
        "id": 41,
        "className": "Person",
        coords: [
            133.0,
            191.0,
            169.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:27",
        "id": 43,
        "className": "Person",
        coords: [
            724.0,
            448.0,
            829.0,
            599.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:27",
        "id": 45,
        "className": "Person",
        coords: [
            316.0,
            545.0,
            475.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:27.100000",
        "id": 23,
        "className": "Person",
        coords: [
            513.0,
            248.0,
            571.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:27.100000",
        "id": 38,
        "className": "Person",
        coords: [
            240.0,
            290.0,
            350.0,
            443.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:27.100000",
        "id": 41,
        "className": "Person",
        coords: [
            133.0,
            191.0,
            169.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:27.100000",
        "id": 43,
        "className": "Person",
        coords: [
            724.0,
            448.0,
            828.0,
            599.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:27.200000",
        "id": 45,
        "className": "Person",
        coords: [
            316.0,
            545.0,
            475.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:27.200000",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            248.0,
            571.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:27.200000",
        "id": 38,
        "className": "Person",
        coords: [
            240.0,
            290.0,
            349.0,
            443.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:27.200000",
        "id": 41,
        "className": "Person",
        coords: [
            133.0,
            191.0,
            169.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:27.300000",
        "id": 43,
        "className": "Person",
        coords: [
            724.0,
            448.0,
            828.0,
            598.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:27.300000",
        "id": 45,
        "className": "Person",
        coords: [
            317.0,
            545.0,
            475.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:27.700000",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            248.0,
            571.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:27.700000",
        "id": 38,
        "className": "Person",
        coords: [
            242.0,
            290.0,
            351.0,
            444.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:27.700000",
        "id": 41,
        "className": "Person",
        coords: [
            133.0,
            191.0,
            170.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:27.700000",
        "id": 43,
        "className": "Person",
        coords: [
            723.0,
            448.0,
            827.0,
            599.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:27.800000",
        "id": 45,
        "className": "Person",
        coords: [
            316.0,
            545.0,
            474.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:27.800000",
        "id": 23,
        "className": "Person",
        coords: [
            511.0,
            247.0,
            571.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:27.800000",
        "id": 38,
        "className": "Person",
        coords: [
            258.0,
            300.0,
            359.0,
            447.0
        ],
        "status": "Moving",
        "speed": 201.23,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:27.900000",
        "id": 41,
        "className": "Person",
        coords: [
            137.0,
            192.0,
            174.0,
            269.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:27.900000",
        "id": 45,
        "className": "Person",
        coords: [
            309.0,
            543.0,
            466.0,
            718.0
        ],
        "status": "Moving",
        "speed": 120.92,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:27.900000",
        "id": 23,
        "className": "Person",
        coords: [
            511.0,
            246.0,
            572.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:28",
        "id": 38,
        "className": "Person",
        coords: [
            265.0,
            305.0,
            362.0,
            448.0
        ],
        "status": "Moving",
        "speed": 87.46,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:28",
        "id": 41,
        "className": "Person",
        coords: [
            138.0,
            192.0,
            175.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:28",
        "id": 45,
        "className": "Person",
        coords: [
            307.0,
            542.0,
            463.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:28",
        "id": 46,
        "className": "Person",
        coords: [
            341.0,
            360.0,
            412.0,
            546.0
        ],
        "status": "First Seen",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:22:28",
        "id": 37,
        "className": "Person",
        coords: [
            20.0,
            216.0,
            74.0,
            353.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:28.100000",
        "id": 23,
        "className": "Person",
        coords: [
            511.0,
            246.0,
            572.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:28.100000",
        "id": 38,
        "className": "Person",
        coords: [
            269.0,
            307.0,
            363.0,
            448.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:28.100000",
        "id": 41,
        "className": "Person",
        coords: [
            139.0,
            192.0,
            176.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:28.100000",
        "id": 45,
        "className": "Person",
        coords: [
            306.0,
            542.0,
            462.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:28.100000",
        "id": 46,
        "className": "Person",
        coords: [
            340.0,
            359.0,
            411.0,
            546.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:22:28.100000",
        "id": 37,
        "className": "Person",
        coords: [
            20.0,
            215.0,
            74.0,
            352.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:28.200000",
        "id": 23,
        "className": "Person",
        coords: [
            510.0,
            246.0,
            572.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:28.200000",
        "id": 38,
        "className": "Person",
        coords: [
            272.0,
            309.0,
            364.0,
            446.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:28.200000",
        "id": 41,
        "className": "Person",
        coords: [
            139.0,
            192.0,
            177.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:28.200000",
        "id": 45,
        "className": "Person",
        coords: [
            306.0,
            541.0,
            461.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:28.300000",
        "id": 46,
        "className": "Person",
        coords: [
            342.0,
            360.0,
            412.0,
            544.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:22:28.700000",
        "id": 23,
        "className": "Person",
        coords: [
            511.0,
            246.0,
            572.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:28.700000",
        "id": 38,
        "className": "Person",
        coords: [
            279.0,
            311.0,
            366.0,
            445.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:28.700000",
        "id": 41,
        "className": "Person",
        coords: [
            139.0,
            192.0,
            177.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:28.800000",
        "id": 45,
        "className": "Person",
        coords: [
            305.0,
            539.0,
            461.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:28.800000",
        "id": 46,
        "className": "Person",
        coords: [
            344.0,
            360.0,
            414.0,
            544.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:22:28.800000",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            246.0,
            573.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:28.900000",
        "id": 41,
        "className": "Person",
        coords: [
            139.0,
            192.0,
            177.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:28.900000",
        "id": 45,
        "className": "Person",
        coords: [
            305.0,
            538.0,
            461.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:28.900000",
        "id": 46,
        "className": "Person",
        coords: [
            346.0,
            360.0,
            415.0,
            539.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:28.900000",
        "id": 43,
        "className": "Person",
        coords: [
            675.0,
            447.0,
            794.0,
            603.0
        ],
        "status": "Moving",
        "speed": 615.68,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:28.900000",
        "id": 37,
        "className": "Person",
        coords: [
            21.0,
            208.0,
            78.0,
            351.0
        ],
        "status": "Moving",
        "speed": 67.08,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:29",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            246.0,
            573.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:29",
        "id": 41,
        "className": "Person",
        coords: [
            139.0,
            192.0,
            177.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:29",
        "id": 45,
        "className": "Person",
        coords: [
            305.0,
            537.0,
            460.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:29",
        "id": 46,
        "className": "Person",
        coords: [
            346.0,
            360.0,
            415.0,
            537.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:29.100000",
        "id": 43,
        "className": "Person",
        coords: [
            668.0,
            447.0,
            795.0,
            603.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:29.100000",
        "id": 37,
        "className": "Person",
        coords: [
            18.0,
            212.0,
            72.0,
            349.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:29.100000",
        "id": 38,
        "className": "Person",
        coords: [
            284.0,
            316.0,
            365.0,
            444.0
        ],
        "status": "Moving",
        "speed": 42.42,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:29.200000",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            246.0,
            573.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:29.200000",
        "id": 41,
        "className": "Person",
        coords: [
            139.0,
            192.0,
            177.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:29.200000",
        "id": 45,
        "className": "Person",
        coords: [
            305.0,
            536.0,
            459.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:29.200000",
        "id": 46,
        "className": "Person",
        coords: [
            346.0,
            360.0,
            415.0,
            536.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:29.200000",
        "id": 43,
        "className": "Person",
        coords: [
            663.0,
            447.0,
            799.0,
            605.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:29.300000",
        "id": 37,
        "className": "Person",
        coords: [
            17.0,
            214.0,
            69.0,
            348.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:29.300000",
        "id": 38,
        "className": "Person",
        coords: [
            286.0,
            319.0,
            363.0,
            442.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:29.300000",
        "id": 23,
        "className": "Person",
        coords: [
            514.0,
            246.0,
            574.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:29.300000",
        "id": 41,
        "className": "Person",
        coords: [
            139.0,
            192.0,
            178.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:29.400000",
        "id": 45,
        "className": "Person",
        coords: [
            306.0,
            536.0,
            459.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:29.400000",
        "id": 46,
        "className": "Person",
        coords: [
            344.0,
            358.0,
            414.0,
            537.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:29.700000",
        "id": 23,
        "className": "Person",
        coords: [
            513.0,
            245.0,
            573.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:29.800000",
        "id": 41,
        "className": "Person",
        coords: [
            138.0,
            192.0,
            178.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:29.800000",
        "id": 45,
        "className": "Person",
        coords: [
            305.0,
            534.0,
            459.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:29.800000",
        "id": 46,
        "className": "Person",
        coords: [
            342.0,
            357.0,
            415.0,
            543.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:29.800000",
        "id": 43,
        "className": "Person",
        coords: [
            660.0,
            447.0,
            801.0,
            605.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:29.900000",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            245.0,
            573.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:29.900000",
        "id": 41,
        "className": "Person",
        coords: [
            138.0,
            192.0,
            178.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:29.900000",
        "id": 45,
        "className": "Person",
        coords: [
            305.0,
            533.0,
            458.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:29.900000",
        "id": 46,
        "className": "Person",
        coords: [
            340.0,
            356.0,
            413.0,
            541.0
        ],
        "status": "Moving",
        "speed": 42.42,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:30",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            245.0,
            572.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:30",
        "id": 41,
        "className": "Person",
        coords: [
            138.0,
            192.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:30",
        "id": 45,
        "className": "Person",
        coords: [
            304.0,
            532.0,
            458.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:30",
        "id": 46,
        "className": "Person",
        coords: [
            335.0,
            356.0,
            414.0,
            552.0
        ],
        "status": "Moving",
        "speed": 94.86,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:30.100000",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            245.0,
            572.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:30.100000",
        "id": 41,
        "className": "Person",
        coords: [
            138.0,
            192.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:30.100000",
        "id": 45,
        "className": "Person",
        coords: [
            305.0,
            532.0,
            458.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:30.100000",
        "id": 46,
        "className": "Person",
        coords: [
            335.0,
            356.0,
            415.0,
            555.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:30.200000",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            245.0,
            572.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:30.200000",
        "id": 41,
        "className": "Person",
        coords: [
            138.0,
            192.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:30.200000",
        "id": 45,
        "className": "Person",
        coords: [
            306.0,
            532.0,
            458.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:30.200000",
        "id": 46,
        "className": "Person",
        coords: [
            334.0,
            356.0,
            414.0,
            554.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:30.200000",
        "id": 37,
        "className": "Person",
        coords: [
            21.0,
            208.0,
            77.0,
            353.0
        ],
        "status": "Moving",
        "speed": 91.23,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:30.300000",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            246.0,
            572.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:30.300000",
        "id": 41,
        "className": "Person",
        coords: [
            138.0,
            192.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:30.300000",
        "id": 45,
        "className": "Person",
        coords: [
            306.0,
            532.0,
            458.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:30.300000",
        "id": 46,
        "className": "Person",
        coords: [
            332.0,
            362.0,
            412.0,
            560.0
        ],
        "status": "Moving",
        "speed": 94.86,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:30.400000",
        "id": 37,
        "className": "Person",
        coords: [
            28.0,
            214.0,
            82.0,
            356.0
        ],
        "status": "Moving",
        "speed": 117.14,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:30.700000",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            245.0,
            573.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:30.800000",
        "id": 41,
        "className": "Person",
        coords: [
            138.0,
            192.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:30.800000",
        "id": 45,
        "className": "Person",
        coords: [
            308.0,
            532.0,
            460.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:30.800000",
        "id": 46,
        "className": "Person",
        coords: [
            329.0,
            363.0,
            411.0,
            565.0
        ],
        "status": "Moving",
        "speed": 54.08,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:30.800000",
        "id": 37,
        "className": "Person",
        coords: [
            31.0,
            217.0,
            83.0,
            357.0
        ],
        "status": "Moving",
        "speed": 42.42,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:30.900000",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            245.0,
            573.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:30.900000",
        "id": 41,
        "className": "Person",
        coords: [
            138.0,
            192.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:30.900000",
        "id": 45,
        "className": "Person",
        coords: [
            309.0,
            533.0,
            460.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:30.900000",
        "id": 46,
        "className": "Person",
        coords: [
            327.0,
            361.0,
            410.0,
            566.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:30.900000",
        "id": 37,
        "className": "Person",
        coords: [
            33.0,
            219.0,
            83.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:31",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            245.0,
            573.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:31",
        "id": 41,
        "className": "Person",
        coords: [
            138.0,
            192.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:31",
        "id": 45,
        "className": "Person",
        coords: [
            310.0,
            533.0,
            461.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:31",
        "id": 46,
        "className": "Person",
        coords: [
            322.0,
            362.0,
            406.0,
            566.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:31",
        "id": 37,
        "className": "Person",
        coords: [
            29.0,
            216.0,
            79.0,
            353.0
        ],
        "status": "Moving",
        "speed": 84.85,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:31.100000",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            245.0,
            573.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:31.100000",
        "id": 41,
        "className": "Person",
        coords: [
            139.0,
            192.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:31.100000",
        "id": 45,
        "className": "Person",
        coords: [
            311.0,
            534.0,
            462.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:31.200000",
        "id": 46,
        "className": "Person",
        coords: [
            319.0,
            369.0,
            402.0,
            565.0
        ],
        "status": "Moving",
        "speed": 74.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:31.200000",
        "id": 37,
        "className": "Person",
        coords: [
            27.0,
            214.0,
            77.0,
            351.0
        ],
        "status": "Moving",
        "speed": 42.42,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:31.200000",
        "id": 23,
        "className": "Person",
        coords: [
            514.0,
            246.0,
            574.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:31.200000",
        "id": 41,
        "className": "Person",
        coords: [
            139.0,
            192.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:31.300000",
        "id": 45,
        "className": "Person",
        coords: [
            312.0,
            535.0,
            463.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:31.300000",
        "id": 37,
        "className": "Person",
        coords: [
            27.0,
            214.0,
            77.0,
            351.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:31.300000",
        "id": 23,
        "className": "Person",
        coords: [
            515.0,
            246.0,
            574.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:31.300000",
        "id": 41,
        "className": "Person",
        coords: [
            139.0,
            192.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:31.400000",
        "id": 45,
        "className": "Person",
        coords: [
            314.0,
            536.0,
            464.0,
            718.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:31.400000",
        "id": 37,
        "className": "Person",
        coords: [
            33.0,
            215.0,
            82.0,
            352.0
        ],
        "status": "Moving",
        "speed": 76.48,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:31.800000",
        "id": 23,
        "className": "Person",
        coords: [
            516.0,
            246.0,
            575.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:31.800000",
        "id": 41,
        "className": "Person",
        coords: [
            140.0,
            192.0,
            178.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:31.800000",
        "id": 45,
        "className": "Person",
        coords: [
            316.0,
            537.0,
            466.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:31.800000",
        "id": 37,
        "className": "Person",
        coords: [
            33.0,
            216.0,
            82.0,
            352.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:31.900000",
        "id": 46,
        "className": "Person",
        coords: [
            309.0,
            352.0,
            399.0,
            568.0
        ],
        "status": "Moving",
        "speed": 138.28,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:31.900000",
        "id": 23,
        "className": "Person",
        coords: [
            518.0,
            246.0,
            575.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:31.900000",
        "id": 41,
        "className": "Person",
        coords: [
            140.0,
            192.0,
            178.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:31.900000",
        "id": 45,
        "className": "Person",
        coords: [
            314.0,
            538.0,
            465.0,
            718.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:32",
        "id": 46,
        "className": "Person",
        coords: [
            307.0,
            349.0,
            397.0,
            566.0
        ],
        "status": "Moving",
        "speed": 54.08,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:32",
        "id": 23,
        "className": "Person",
        coords: [
            519.0,
            246.0,
            576.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:32",
        "id": 41,
        "className": "Person",
        coords: [
            140.0,
            192.0,
            178.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:32.100000",
        "id": 45,
        "className": "Person",
        coords: [
            310.0,
            540.0,
            462.0,
            718.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:32.100000",
        "id": 46,
        "className": "Person",
        coords: [
            307.0,
            347.0,
            396.0,
            565.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:32.100000",
        "id": 23,
        "className": "Person",
        coords: [
            518.0,
            246.0,
            574.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:32.100000",
        "id": 41,
        "className": "Person",
        coords: [
            140.0,
            192.0,
            178.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:32.200000",
        "id": 45,
        "className": "Person",
        coords: [
            317.0,
            542.0,
            467.0,
            718.0
        ],
        "status": "Moving",
        "speed": 91.23,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:32.200000",
        "id": 23,
        "className": "Person",
        coords: [
            517.0,
            246.0,
            573.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:32.200000",
        "id": 41,
        "className": "Person",
        coords: [
            141.0,
            192.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:32.200000",
        "id": 45,
        "className": "Person",
        coords: [
            314.0,
            542.0,
            465.0,
            718.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:32.300000",
        "id": 23,
        "className": "Person",
        coords: [
            516.0,
            246.0,
            573.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:32.300000",
        "id": 41,
        "className": "Person",
        coords: [
            141.0,
            192.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:32.300000",
        "id": 45,
        "className": "Person",
        coords: [
            317.0,
            542.0,
            469.0,
            718.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:32.400000",
        "id": 23,
        "className": "Person",
        coords: [
            516.0,
            245.0,
            572.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:32.400000",
        "id": 41,
        "className": "Person",
        coords: [
            141.0,
            192.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:32.400000",
        "id": 45,
        "className": "Person",
        coords: [
            318.0,
            544.0,
            471.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:32.400000",
        "id": 37,
        "className": "Person",
        coords: [
            24.0,
            207.0,
            76.0,
            350.0
        ],
        "status": "Moving",
        "speed": 138.28,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:32.500000",
        "id": 23,
        "className": "Person",
        coords: [
            516.0,
            245.0,
            572.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:32.500000",
        "id": 41,
        "className": "Person",
        coords: [
            141.0,
            192.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:32.500000",
        "id": 45,
        "className": "Person",
        coords: [
            319.0,
            544.0,
            472.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:32.500000",
        "id": 37,
        "className": "Person",
        coords: [
            22.0,
            206.0,
            76.0,
            352.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:32.500000",
        "id": 46,
        "className": "Person",
        coords: [
            268.0,
            325.0,
            361.0,
            523.0
        ],
        "status": "Moving",
        "speed": 733.71,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:32.600000",
        "id": 23,
        "className": "Person",
        coords: [
            516.0,
            245.0,
            572.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:32.600000",
        "id": 41,
        "className": "Person",
        coords: [
            141.0,
            192.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:32.600000",
        "id": 45,
        "className": "Person",
        coords: [
            318.0,
            543.0,
            473.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:32.600000",
        "id": 37,
        "className": "Person",
        coords: [
            22.0,
            206.0,
            76.0,
            352.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:32.600000",
        "id": 46,
        "className": "Person",
        coords: [
            258.0,
            335.0,
            352.0,
            517.0
        ],
        "status": "Moving",
        "speed": 138.28,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:32.700000",
        "id": 23,
        "className": "Person",
        coords: [
            517.0,
            245.0,
            573.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:32.700000",
        "id": 41,
        "className": "Person",
        coords: [
            141.0,
            192.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:32.700000",
        "id": 45,
        "className": "Person",
        coords: [
            318.0,
            541.0,
            473.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:32.700000",
        "id": 37,
        "className": "Person",
        coords: [
            21.0,
            206.0,
            76.0,
            352.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:32.800000",
        "id": 23,
        "className": "Person",
        coords: [
            517.0,
            245.0,
            573.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:32.800000",
        "id": 41,
        "className": "Person",
        coords: [
            141.0,
            192.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:32.800000",
        "id": 45,
        "className": "Person",
        coords: [
            317.0,
            539.0,
            474.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:32.800000",
        "id": 37,
        "className": "Person",
        coords: [
            20.0,
            206.0,
            76.0,
            352.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:32.900000",
        "id": 46,
        "className": "Person",
        coords: [
            251.0,
            340.0,
            349.0,
            517.0
        ],
        "status": "Moving",
        "speed": 80.77,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:32.900000",
        "id": 23,
        "className": "Person",
        coords: [
            518.0,
            245.0,
            573.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:32.900000",
        "id": 41,
        "className": "Person",
        coords: [
            141.0,
            192.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:32.900000",
        "id": 45,
        "className": "Person",
        coords: [
            317.0,
            538.0,
            476.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:32.900000",
        "id": 37,
        "className": "Person",
        coords: [
            20.0,
            206.0,
            76.0,
            351.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:33",
        "id": 46,
        "className": "Person",
        coords: [
            250.0,
            345.0,
            354.0,
            520.0
        ],
        "status": "Moving",
        "speed": 67.08,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:33.400000",
        "id": 23,
        "className": "Person",
        coords: [
            518.0,
            245.0,
            573.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:33.400000",
        "id": 41,
        "className": "Person",
        coords: [
            141.0,
            192.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:33.400000",
        "id": 45,
        "className": "Person",
        coords: [
            317.0,
            537.0,
            476.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:33.400000",
        "id": 37,
        "className": "Person",
        coords: [
            19.0,
            205.0,
            75.0,
            352.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:33.400000",
        "id": 46,
        "className": "Person",
        coords: [
            247.0,
            350.0,
            358.0,
            529.0
        ],
        "status": "Moving",
        "speed": 104.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:33.500000",
        "id": 23,
        "className": "Person",
        coords: [
            519.0,
            245.0,
            574.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:33.500000",
        "id": 41,
        "className": "Person",
        coords: [
            141.0,
            192.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:33.500000",
        "id": 45,
        "className": "Person",
        coords: [
            316.0,
            536.0,
            476.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:33.500000",
        "id": 37,
        "className": "Person",
        coords: [
            18.0,
            206.0,
            75.0,
            352.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:33.600000",
        "id": 46,
        "className": "Person",
        coords: [
            243.0,
            356.0,
            358.0,
            535.0
        ],
        "status": "Moving",
        "speed": 94.86,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:33.600000",
        "id": 23,
        "className": "Person",
        coords: [
            519.0,
            245.0,
            574.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:33.600000",
        "id": 41,
        "className": "Person",
        coords: [
            141.0,
            192.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:33.600000",
        "id": 45,
        "className": "Person",
        coords: [
            316.0,
            537.0,
            475.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:33.700000",
        "id": 37,
        "className": "Person",
        coords: [
            18.0,
            207.0,
            74.0,
            350.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:33.700000",
        "id": 46,
        "className": "Person",
        coords: [
            253.0,
            355.0,
            349.0,
            490.0
        ],
        "status": "Moving",
        "speed": 345.3,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:33.700000",
        "id": 23,
        "className": "Person",
        coords: [
            519.0,
            245.0,
            574.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:33.700000",
        "id": 41,
        "className": "Person",
        coords: [
            141.0,
            192.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:33.800000",
        "id": 45,
        "className": "Person",
        coords: [
            315.0,
            537.0,
            474.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:33.800000",
        "id": 37,
        "className": "Person",
        coords: [
            17.0,
            207.0,
            73.0,
            349.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:33.800000",
        "id": 23,
        "className": "Person",
        coords: [
            519.0,
            245.0,
            574.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:33.900000",
        "id": 41,
        "className": "Person",
        coords: [
            141.0,
            192.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:33.900000",
        "id": 45,
        "className": "Person",
        coords: [
            313.0,
            538.0,
            472.0,
            718.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:33.900000",
        "id": 37,
        "className": "Person",
        coords: [
            17.0,
            207.0,
            74.0,
            351.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:33.900000",
        "id": 23,
        "className": "Person",
        coords: [
            519.0,
            246.0,
            573.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:33.900000",
        "id": 41,
        "className": "Person",
        coords: [
            141.0,
            192.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:34",
        "id": 45,
        "className": "Person",
        coords: [
            312.0,
            538.0,
            470.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:34",
        "id": 37,
        "className": "Person",
        coords: [
            18.0,
            209.0,
            74.0,
            350.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:34.400000",
        "id": 23,
        "className": "Person",
        coords: [
            515.0,
            246.0,
            571.0,
            337.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:34.400000",
        "id": 41,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            176.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:34.400000",
        "id": 45,
        "className": "Person",
        coords: [
            312.0,
            539.0,
            469.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:34.500000",
        "id": 37,
        "className": "Person",
        coords: [
            17.0,
            209.0,
            72.0,
            349.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:34.500000",
        "id": 23,
        "className": "Person",
        coords: [
            513.0,
            246.0,
            570.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:34.500000",
        "id": 41,
        "className": "Person",
        coords: [
            139.0,
            193.0,
            175.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:34.600000",
        "id": 45,
        "className": "Person",
        coords: [
            314.0,
            539.0,
            470.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:34.600000",
        "id": 37,
        "className": "Person",
        coords: [
            16.0,
            208.0,
            71.0,
            349.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:34.600000",
        "id": 47,
        "className": "Person",
        coords: [
            493.0,
            178.0,
            533.0,
            262.0
        ],
        "status": "First Seen",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:22:34.600000",
        "id": 23,
        "className": "Person",
        coords: [
            513.0,
            246.0,
            570.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:34.600000",
        "id": 41,
        "className": "Person",
        coords: [
            138.0,
            193.0,
            175.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:34.700000",
        "id": 45,
        "className": "Person",
        coords: [
            312.0,
            538.0,
            467.0,
            718.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:34.700000",
        "id": 37,
        "className": "Person",
        coords: [
            16.0,
            208.0,
            70.0,
            349.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:34.700000",
        "id": 47,
        "className": "Person",
        coords: [
            493.0,
            178.0,
            533.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:22:34.700000",
        "id": 46,
        "className": "Person",
        coords: [
            257.0,
            349.0,
            347.0,
            463.0
        ],
        "status": "Moving",
        "speed": 240.45,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:34.800000",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            246.0,
            570.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:34.800000",
        "id": 41,
        "className": "Person",
        coords: [
            139.0,
            193.0,
            176.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:34.800000",
        "id": 47,
        "className": "Person",
        coords: [
            492.0,
            179.0,
            532.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:22:34.800000",
        "id": 23,
        "className": "Person",
        coords: [
            511.0,
            246.0,
            570.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:34.800000",
        "id": 41,
        "className": "Person",
        coords: [
            138.0,
            193.0,
            175.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:34.900000",
        "id": 47,
        "className": "Person",
        coords: [
            492.0,
            179.0,
            532.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:22:34.900000",
        "id": 23,
        "className": "Person",
        coords: [
            511.0,
            246.0,
            571.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:34.900000",
        "id": 41,
        "className": "Person",
        coords: [
            138.0,
            193.0,
            175.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:34.900000",
        "id": 47,
        "className": "Person",
        coords: [
            493.0,
            179.0,
            533.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:35",
        "id": 23,
        "className": "Person",
        coords: [
            511.0,
            246.0,
            571.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:35",
        "id": 41,
        "className": "Person",
        coords: [
            138.0,
            193.0,
            175.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:35",
        "id": 47,
        "className": "Person",
        coords: [
            493.0,
            179.0,
            533.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:35",
        "id": 37,
        "className": "Person",
        coords: [
            11.0,
            211.0,
            62.0,
            347.0
        ],
        "status": "Moving",
        "speed": 106.06,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:35",
        "id": 46,
        "className": "Person",
        coords: [
            244.0,
            320.0,
            358.0,
            460.0
        ],
        "status": "Moving",
        "speed": 240.45,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:35.100000",
        "id": 23,
        "className": "Person",
        coords: [
            510.0,
            246.0,
            571.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:35.100000",
        "id": 41,
        "className": "Person",
        coords: [
            137.0,
            193.0,
            175.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:35.100000",
        "id": 47,
        "className": "Person",
        coords: [
            493.0,
            179.0,
            533.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:35.100000",
        "id": 37,
        "className": "Person",
        coords: [
            11.0,
            210.0,
            60.0,
            347.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:35.100000",
        "id": 46,
        "className": "Person",
        coords: [
            240.0,
            311.0,
            364.0,
            461.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:35.200000",
        "id": 23,
        "className": "Person",
        coords: [
            510.0,
            246.0,
            572.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:35.200000",
        "id": 41,
        "className": "Person",
        coords: [
            137.0,
            193.0,
            175.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:35.200000",
        "id": 47,
        "className": "Person",
        coords: [
            492.0,
            179.0,
            533.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:35.200000",
        "id": 37,
        "className": "Person",
        coords: [
            12.0,
            210.0,
            59.0,
            347.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:35.200000",
        "id": 46,
        "className": "Person",
        coords: [
            236.0,
            302.0,
            367.0,
            460.0
        ],
        "status": "Moving",
        "speed": 76.48,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:35.300000",
        "id": 23,
        "className": "Person",
        coords: [
            510.0,
            247.0,
            572.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:35.300000",
        "id": 41,
        "className": "Person",
        coords: [
            137.0,
            192.0,
            176.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:35.300000",
        "id": 47,
        "className": "Person",
        coords: [
            492.0,
            179.0,
            533.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:35.300000",
        "id": 37,
        "className": "Person",
        coords: [
            13.0,
            211.0,
            59.0,
            347.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:35.400000",
        "id": 46,
        "className": "Person",
        coords: [
            233.0,
            295.0,
            369.0,
            460.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:35.400000",
        "id": 23,
        "className": "Person",
        coords: [
            510.0,
            247.0,
            572.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:35.400000",
        "id": 41,
        "className": "Person",
        coords: [
            138.0,
            192.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:35.400000",
        "id": 47,
        "className": "Person",
        coords: [
            492.0,
            179.0,
            533.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:35.400000",
        "id": 37,
        "className": "Person",
        coords: [
            13.0,
            210.0,
            59.0,
            347.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:35.500000",
        "id": 46,
        "className": "Person",
        coords: [
            234.0,
            290.0,
            372.0,
            459.0
        ],
        "status": "Moving",
        "speed": 54.08,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:35.500000",
        "id": 23,
        "className": "Person",
        coords: [
            509.0,
            247.0,
            572.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:35.500000",
        "id": 41,
        "className": "Person",
        coords: [
            138.0,
            192.0,
            177.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:35.500000",
        "id": 47,
        "className": "Person",
        coords: [
            493.0,
            179.0,
            533.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:35.600000",
        "id": 37,
        "className": "Person",
        coords: [
            13.0,
            210.0,
            58.0,
            347.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:35.600000",
        "id": 46,
        "className": "Person",
        coords: [
            234.0,
            287.0,
            372.0,
            459.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:35.600000",
        "id": 23,
        "className": "Person",
        coords: [
            509.0,
            247.0,
            572.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:35.600000",
        "id": 41,
        "className": "Person",
        coords: [
            139.0,
            192.0,
            178.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:35.700000",
        "id": 47,
        "className": "Person",
        coords: [
            493.0,
            179.0,
            533.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:35.700000",
        "id": 37,
        "className": "Person",
        coords: [
            14.0,
            211.0,
            57.0,
            347.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:35.700000",
        "id": 46,
        "className": "Person",
        coords: [
            241.0,
            284.0,
            377.0,
            459.0
        ],
        "status": "Moving",
        "speed": 94.86,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:35.700000",
        "id": 23,
        "className": "Person",
        coords: [
            509.0,
            247.0,
            572.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:35.800000",
        "id": 41,
        "className": "Person",
        coords: [
            141.0,
            192.0,
            180.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:35.800000",
        "id": 47,
        "className": "Person",
        coords: [
            493.0,
            180.0,
            533.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:35.800000",
        "id": 37,
        "className": "Person",
        coords: [
            14.0,
            211.0,
            57.0,
            347.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:35.800000",
        "id": 45,
        "className": "Person",
        coords: [
            304.0,
            538.0,
            455.0,
            715.0
        ],
        "status": "Moving",
        "speed": 152.96,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:35.900000",
        "id": 23,
        "className": "Person",
        coords: [
            509.0,
            247.0,
            573.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:35.900000",
        "id": 41,
        "className": "Person",
        coords: [
            143.0,
            192.0,
            183.0,
            273.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:35.900000",
        "id": 47,
        "className": "Person",
        coords: [
            492.0,
            180.0,
            532.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:35.900000",
        "id": 37,
        "className": "Person",
        coords: [
            15.0,
            211.0,
            57.0,
            347.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:35.900000",
        "id": 45,
        "className": "Person",
        coords: [
            309.0,
            538.0,
            454.0,
            710.0
        ],
        "status": "Moving",
        "speed": 42.42,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:36",
        "id": 46,
        "className": "Person",
        coords: [
            259.0,
            283.0,
            388.0,
            457.0
        ],
        "status": "Moving",
        "speed": 210.52,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:36",
        "id": 23,
        "className": "Person",
        coords: [
            509.0,
            248.0,
            573.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:36",
        "id": 41,
        "className": "Person",
        coords: [
            140.0,
            192.0,
            180.0,
            273.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:36",
        "id": 47,
        "className": "Person",
        coords: [
            492.0,
            180.0,
            532.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:36.100000",
        "id": 46,
        "className": "Person",
        coords: [
            243.0,
            283.0,
            369.0,
            454.0
        ],
        "status": "Moving",
        "speed": 256.74,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:36.400000",
        "id": 23,
        "className": "Person",
        coords: [
            509.0,
            248.0,
            573.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:36.500000",
        "id": 41,
        "className": "Person",
        coords: [
            139.0,
            192.0,
            178.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:36.500000",
        "id": 47,
        "className": "Person",
        coords: [
            492.0,
            181.0,
            532.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:36.500000",
        "id": 46,
        "className": "Person",
        coords: [
            236.0,
            283.0,
            363.0,
            454.0
        ],
        "status": "Moving",
        "speed": 104.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:36.500000",
        "id": 23,
        "className": "Person",
        coords: [
            509.0,
            248.0,
            573.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:36.600000",
        "id": 41,
        "className": "Person",
        coords: [
            140.0,
            192.0,
            176.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:36.600000",
        "id": 47,
        "className": "Person",
        coords: [
            492.0,
            181.0,
            531.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:36.600000",
        "id": 46,
        "className": "Person",
        coords: [
            234.0,
            284.0,
            361.0,
            455.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:36.600000",
        "id": 23,
        "className": "Person",
        coords: [
            509.0,
            248.0,
            573.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:36.700000",
        "id": 41,
        "className": "Person",
        coords: [
            139.0,
            192.0,
            175.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:36.700000",
        "id": 47,
        "className": "Person",
        coords: [
            492.0,
            181.0,
            531.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:36.700000",
        "id": 46,
        "className": "Person",
        coords: [
            232.0,
            285.0,
            361.0,
            458.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:36.700000",
        "id": 23,
        "className": "Person",
        coords: [
            509.0,
            248.0,
            573.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:36.700000",
        "id": 41,
        "className": "Person",
        coords: [
            140.0,
            193.0,
            175.0,
            266.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:36.800000",
        "id": 47,
        "className": "Person",
        coords: [
            492.0,
            181.0,
            531.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:36.800000",
        "id": 46,
        "className": "Person",
        coords: [
            232.0,
            287.0,
            362.0,
            460.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:36.800000",
        "id": 23,
        "className": "Person",
        coords: [
            509.0,
            248.0,
            574.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:36.900000",
        "id": 41,
        "className": "Person",
        coords: [
            140.0,
            192.0,
            175.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:36.900000",
        "id": 47,
        "className": "Person",
        coords: [
            493.0,
            181.0,
            531.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:36.900000",
        "id": 46,
        "className": "Person",
        coords: [
            233.0,
            288.0,
            362.0,
            461.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:37",
        "id": 23,
        "className": "Person",
        coords: [
            509.0,
            248.0,
            574.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:37",
        "id": 41,
        "className": "Person",
        coords: [
            140.0,
            192.0,
            176.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:37",
        "id": 47,
        "className": "Person",
        coords: [
            493.0,
            181.0,
            530.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:37",
        "id": 46,
        "className": "Person",
        coords: [
            234.0,
            289.0,
            362.0,
            459.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:37.100000",
        "id": 23,
        "className": "Person",
        coords: [
            509.0,
            248.0,
            574.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:37.100000",
        "id": 41,
        "className": "Person",
        coords: [
            139.0,
            191.0,
            175.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:37.100000",
        "id": 47,
        "className": "Person",
        coords: [
            492.0,
            181.0,
            530.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:37.100000",
        "id": 46,
        "className": "Person",
        coords: [
            233.0,
            292.0,
            362.0,
            462.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:37.200000",
        "id": 23,
        "className": "Person",
        coords: [
            509.0,
            248.0,
            574.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:37.200000",
        "id": 41,
        "className": "Person",
        coords: [
            139.0,
            190.0,
            175.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:37.200000",
        "id": 47,
        "className": "Person",
        coords: [
            492.0,
            181.0,
            530.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:37.200000",
        "id": 46,
        "className": "Person",
        coords: [
            235.0,
            295.0,
            361.0,
            457.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:37.300000",
        "id": 23,
        "className": "Person",
        coords: [
            509.0,
            248.0,
            574.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:37.300000",
        "id": 41,
        "className": "Person",
        coords: [
            139.0,
            190.0,
            175.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:37.300000",
        "id": 47,
        "className": "Person",
        coords: [
            492.0,
            181.0,
            530.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:37.300000",
        "id": 46,
        "className": "Person",
        coords: [
            238.0,
            299.0,
            360.0,
            455.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:37.400000",
        "id": 23,
        "className": "Person",
        coords: [
            510.0,
            248.0,
            575.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:37.400000",
        "id": 41,
        "className": "Person",
        coords: [
            139.0,
            190.0,
            175.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:37.400000",
        "id": 47,
        "className": "Person",
        coords: [
            492.0,
            182.0,
            529.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:37.400000",
        "id": 46,
        "className": "Person",
        coords: [
            238.0,
            302.0,
            359.0,
            454.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:37.500000",
        "id": 23,
        "className": "Person",
        coords: [
            510.0,
            248.0,
            575.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:37.500000",
        "id": 41,
        "className": "Person",
        coords: [
            139.0,
            190.0,
            175.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:37.500000",
        "id": 47,
        "className": "Person",
        coords: [
            492.0,
            183.0,
            529.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:37.500000",
        "id": 46,
        "className": "Person",
        coords: [
            238.0,
            306.0,
            358.0,
            455.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:38",
        "id": 23,
        "className": "Person",
        coords: [
            510.0,
            248.0,
            575.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:38",
        "id": 41,
        "className": "Person",
        coords: [
            139.0,
            190.0,
            175.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:38",
        "id": 46,
        "className": "Person",
        coords: [
            238.0,
            308.0,
            359.0,
            455.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:38.100000",
        "id": 23,
        "className": "Person",
        coords: [
            510.0,
            248.0,
            575.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:38.100000",
        "id": 41,
        "className": "Person",
        coords: [
            140.0,
            190.0,
            175.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:38.100000",
        "id": 46,
        "className": "Person",
        coords: [
            239.0,
            310.0,
            359.0,
            455.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:38.200000",
        "id": 23,
        "className": "Person",
        coords: [
            510.0,
            248.0,
            575.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:38.200000",
        "id": 41,
        "className": "Person",
        coords: [
            140.0,
            190.0,
            175.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:38.200000",
        "id": 46,
        "className": "Person",
        coords: [
            239.0,
            310.0,
            360.0,
            454.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:38.200000",
        "id": 47,
        "className": "Person",
        coords: [
            491.0,
            183.0,
            528.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:38.300000",
        "id": 23,
        "className": "Person",
        coords: [
            510.0,
            248.0,
            575.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:38.300000",
        "id": 41,
        "className": "Person",
        coords: [
            139.0,
            188.0,
            176.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:38.300000",
        "id": 47,
        "className": "Person",
        coords: [
            490.0,
            180.0,
            528.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:38.300000",
        "id": 23,
        "className": "Person",
        coords: [
            510.0,
            248.0,
            575.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:38.300000",
        "id": 41,
        "className": "Person",
        coords: [
            139.0,
            188.0,
            176.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:38.400000",
        "id": 47,
        "className": "Person",
        coords: [
            490.0,
            180.0,
            528.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:38.400000",
        "id": 46,
        "className": "Person",
        coords: [
            239.0,
            310.0,
            360.0,
            453.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:38.400000",
        "id": 23,
        "className": "Person",
        coords: [
            510.0,
            248.0,
            575.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:38.500000",
        "id": 41,
        "className": "Person",
        coords: [
            140.0,
            188.0,
            177.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:38.500000",
        "id": 47,
        "className": "Person",
        coords: [
            489.0,
            179.0,
            528.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:38.500000",
        "id": 46,
        "className": "Person",
        coords: [
            239.0,
            310.0,
            361.0,
            454.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:38.600000",
        "id": 23,
        "className": "Person",
        coords: [
            510.0,
            248.0,
            575.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:38.600000",
        "id": 41,
        "className": "Person",
        coords: [
            140.0,
            188.0,
            177.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:38.600000",
        "id": 47,
        "className": "Person",
        coords: [
            490.0,
            179.0,
            528.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:38.600000",
        "id": 46,
        "className": "Person",
        coords: [
            239.0,
            310.0,
            362.0,
            453.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:39",
        "id": 23,
        "className": "Person",
        coords: [
            510.0,
            248.0,
            575.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:39",
        "id": 41,
        "className": "Person",
        coords: [
            140.0,
            188.0,
            177.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:39",
        "id": 46,
        "className": "Person",
        coords: [
            238.0,
            310.0,
            362.0,
            454.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:39.100000",
        "id": 23,
        "className": "Person",
        coords: [
            510.0,
            248.0,
            575.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:39.100000",
        "id": 41,
        "className": "Person",
        coords: [
            140.0,
            188.0,
            177.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:39.100000",
        "id": 46,
        "className": "Person",
        coords: [
            237.0,
            309.0,
            362.0,
            454.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:39.100000",
        "id": 47,
        "className": "Person",
        coords: [
            490.0,
            180.0,
            528.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:39.200000",
        "id": 23,
        "className": "Person",
        coords: [
            511.0,
            248.0,
            575.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:39.200000",
        "id": 41,
        "className": "Person",
        coords: [
            139.0,
            188.0,
            177.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:39.200000",
        "id": 46,
        "className": "Person",
        coords: [
            237.0,
            308.0,
            363.0,
            453.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:39.200000",
        "id": 47,
        "className": "Person",
        coords: [
            490.0,
            179.0,
            527.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:39.300000",
        "id": 23,
        "className": "Person",
        coords: [
            511.0,
            248.0,
            575.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:39.300000",
        "id": 41,
        "className": "Person",
        coords: [
            139.0,
            188.0,
            176.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:39.300000",
        "id": 46,
        "className": "Person",
        coords: [
            235.0,
            308.0,
            364.0,
            456.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:39.300000",
        "id": 47,
        "className": "Person",
        coords: [
            490.0,
            178.0,
            528.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:39.400000",
        "id": 23,
        "className": "Person",
        coords: [
            511.0,
            248.0,
            575.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:39.400000",
        "id": 41,
        "className": "Person",
        coords: [
            139.0,
            188.0,
            176.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:39.400000",
        "id": 46,
        "className": "Person",
        coords: [
            233.0,
            308.0,
            364.0,
            457.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:39.400000",
        "id": 47,
        "className": "Person",
        coords: [
            490.0,
            178.0,
            528.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:39.500000",
        "id": 23,
        "className": "Person",
        coords: [
            511.0,
            248.0,
            575.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:39.500000",
        "id": 41,
        "className": "Person",
        coords: [
            139.0,
            188.0,
            176.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:39.500000",
        "id": 46,
        "className": "Person",
        coords: [
            233.0,
            308.0,
            363.0,
            456.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:39.500000",
        "id": 47,
        "className": "Person",
        coords: [
            490.0,
            178.0,
            528.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:39.600000",
        "id": 23,
        "className": "Person",
        coords: [
            511.0,
            248.0,
            575.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:39.600000",
        "id": 41,
        "className": "Person",
        coords: [
            139.0,
            188.0,
            177.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:39.600000",
        "id": 46,
        "className": "Person",
        coords: [
            232.0,
            307.0,
            364.0,
            456.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:39.600000",
        "id": 47,
        "className": "Person",
        coords: [
            490.0,
            178.0,
            527.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:40",
        "id": 23,
        "className": "Person",
        coords: [
            511.0,
            248.0,
            574.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:40.100000",
        "id": 41,
        "className": "Person",
        coords: [
            139.0,
            188.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:40.100000",
        "id": 46,
        "className": "Person",
        coords: [
            232.0,
            306.0,
            363.0,
            455.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:40.100000",
        "id": 47,
        "className": "Person",
        coords: [
            490.0,
            178.0,
            527.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:40.100000",
        "id": 23,
        "className": "Person",
        coords: [
            511.0,
            248.0,
            574.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:40.200000",
        "id": 41,
        "className": "Person",
        coords: [
            139.0,
            187.0,
            177.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:40.200000",
        "id": 46,
        "className": "Person",
        coords: [
            232.0,
            305.0,
            363.0,
            454.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:40.200000",
        "id": 47,
        "className": "Person",
        coords: [
            489.0,
            178.0,
            526.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:40.200000",
        "id": 23,
        "className": "Person",
        coords: [
            511.0,
            248.0,
            574.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:40.300000",
        "id": 41,
        "className": "Person",
        coords: [
            139.0,
            187.0,
            177.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:40.300000",
        "id": 46,
        "className": "Person",
        coords: [
            232.0,
            304.0,
            363.0,
            453.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:40.300000",
        "id": 47,
        "className": "Person",
        coords: [
            489.0,
            177.0,
            526.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:40.300000",
        "id": 23,
        "className": "Person",
        coords: [
            511.0,
            248.0,
            574.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:40.400000",
        "id": 41,
        "className": "Person",
        coords: [
            139.0,
            187.0,
            177.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:40.400000",
        "id": 46,
        "className": "Person",
        coords: [
            231.0,
            304.0,
            363.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:40.400000",
        "id": 47,
        "className": "Person",
        coords: [
            489.0,
            178.0,
            526.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:40.400000",
        "id": 23,
        "className": "Person",
        coords: [
            511.0,
            249.0,
            574.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:40.500000",
        "id": 41,
        "className": "Person",
        coords: [
            138.0,
            188.0,
            176.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:40.500000",
        "id": 46,
        "className": "Person",
        coords: [
            231.0,
            303.0,
            362.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:40.500000",
        "id": 47,
        "className": "Person",
        coords: [
            489.0,
            178.0,
            525.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:40.500000",
        "id": 23,
        "className": "Person",
        coords: [
            511.0,
            249.0,
            573.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:40.600000",
        "id": 41,
        "className": "Person",
        coords: [
            138.0,
            189.0,
            176.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:40.600000",
        "id": 46,
        "className": "Person",
        coords: [
            229.0,
            302.0,
            362.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:40.600000",
        "id": 47,
        "className": "Person",
        coords: [
            489.0,
            179.0,
            525.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:40.600000",
        "id": 23,
        "className": "Person",
        coords: [
            510.0,
            249.0,
            573.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:40.700000",
        "id": 41,
        "className": "Person",
        coords: [
            138.0,
            189.0,
            176.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:40.700000",
        "id": 46,
        "className": "Person",
        coords: [
            229.0,
            302.0,
            362.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:40.700000",
        "id": 47,
        "className": "Person",
        coords: [
            489.0,
            180.0,
            524.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:40.800000",
        "id": 23,
        "className": "Person",
        coords: [
            510.0,
            249.0,
            573.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:40.800000",
        "id": 41,
        "className": "Person",
        coords: [
            138.0,
            189.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:40.800000",
        "id": 46,
        "className": "Person",
        coords: [
            228.0,
            300.0,
            363.0,
            454.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:40.800000",
        "id": 47,
        "className": "Person",
        coords: [
            490.0,
            180.0,
            524.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:40.900000",
        "id": 23,
        "className": "Person",
        coords: [
            510.0,
            249.0,
            574.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:40.900000",
        "id": 41,
        "className": "Person",
        coords: [
            138.0,
            189.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:40.900000",
        "id": 46,
        "className": "Person",
        coords: [
            227.0,
            299.0,
            364.0,
            454.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:40.900000",
        "id": 47,
        "className": "Person",
        coords: [
            490.0,
            180.0,
            524.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:41",
        "id": 23,
        "className": "Person",
        coords: [
            510.0,
            249.0,
            574.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:41",
        "id": 41,
        "className": "Person",
        coords: [
            138.0,
            189.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:41",
        "id": 46,
        "className": "Person",
        coords: [
            227.0,
            298.0,
            365.0,
            456.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:41",
        "id": 47,
        "className": "Person",
        coords: [
            490.0,
            180.0,
            524.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:41.100000",
        "id": 23,
        "className": "Person",
        coords: [
            510.0,
            249.0,
            574.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:41.100000",
        "id": 41,
        "className": "Person",
        coords: [
            138.0,
            189.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:41.100000",
        "id": 47,
        "className": "Person",
        coords: [
            490.0,
            180.0,
            523.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:41.600000",
        "id": 23,
        "className": "Person",
        coords: [
            510.0,
            249.0,
            574.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:41.600000",
        "id": 41,
        "className": "Person",
        coords: [
            138.0,
            190.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:41.600000",
        "id": 47,
        "className": "Person",
        coords: [
            489.0,
            180.0,
            523.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:41.700000",
        "id": 46,
        "className": "Person",
        coords: [
            254.0,
            295.0,
            385.0,
            453.0
        ],
        "status": "Moving",
        "speed": 347.89,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:41.700000",
        "id": 23,
        "className": "Person",
        coords: [
            510.0,
            249.0,
            574.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:41.700000",
        "id": 41,
        "className": "Person",
        coords: [
            139.0,
            190.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:41.700000",
        "id": 47,
        "className": "Person",
        coords: [
            489.0,
            179.0,
            523.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:41.700000",
        "id": 46,
        "className": "Person",
        coords: [
            238.0,
            294.0,
            369.0,
            453.0
        ],
        "status": "Moving",
        "speed": 240.45,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:41.800000",
        "id": 23,
        "className": "Person",
        coords: [
            510.0,
            249.0,
            574.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:41.800000",
        "id": 41,
        "className": "Person",
        coords: [
            139.0,
            190.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:41.800000",
        "id": 47,
        "className": "Person",
        coords: [
            490.0,
            180.0,
            523.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:41.800000",
        "id": 46,
        "className": "Person",
        coords: [
            232.0,
            293.0,
            364.0,
            452.0
        ],
        "status": "Moving",
        "speed": 76.48,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:41.900000",
        "id": 45,
        "className": "Person",
        coords: [
            327.0,
            536.0,
            465.0,
            718.0
        ],
        "status": "Moving",
        "speed": 229.44,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:41.900000",
        "id": 23,
        "className": "Person",
        coords: [
            510.0,
            249.0,
            574.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:41.900000",
        "id": 41,
        "className": "Person",
        coords: [
            140.0,
            190.0,
            178.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:41.900000",
        "id": 47,
        "className": "Person",
        coords: [
            490.0,
            180.0,
            523.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:42",
        "id": 45,
        "className": "Person",
        coords: [
            331.0,
            536.0,
            461.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:42",
        "id": 23,
        "className": "Person",
        coords: [
            510.0,
            249.0,
            574.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:42",
        "id": 41,
        "className": "Person",
        coords: [
            140.0,
            190.0,
            178.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:42",
        "id": 47,
        "className": "Person",
        coords: [
            490.0,
            180.0,
            523.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:42.100000",
        "id": 45,
        "className": "Person",
        coords: [
            321.0,
            536.0,
            453.0,
            718.0
        ],
        "status": "Moving",
        "speed": 134.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:42.100000",
        "id": 46,
        "className": "Person",
        coords: [
            229.0,
            291.0,
            366.0,
            457.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:42.100000",
        "id": 23,
        "className": "Person",
        coords: [
            510.0,
            249.0,
            574.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:42.100000",
        "id": 41,
        "className": "Person",
        coords: [
            140.0,
            191.0,
            178.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:42.200000",
        "id": 47,
        "className": "Person",
        coords: [
            490.0,
            180.0,
            523.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:42.200000",
        "id": 45,
        "className": "Person",
        coords: [
            315.0,
            535.0,
            450.0,
            718.0
        ],
        "status": "Moving",
        "speed": 76.48,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:42.200000",
        "id": 46,
        "className": "Person",
        coords: [
            228.0,
            290.0,
            366.0,
            458.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:42.600000",
        "id": 23,
        "className": "Person",
        coords: [
            509.0,
            249.0,
            574.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:42.700000",
        "id": 41,
        "className": "Person",
        coords: [
            140.0,
            191.0,
            178.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:42.700000",
        "id": 47,
        "className": "Person",
        coords: [
            490.0,
            180.0,
            523.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:42.700000",
        "id": 45,
        "className": "Person",
        coords: [
            313.0,
            535.0,
            449.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:42.800000",
        "id": 46,
        "className": "Person",
        coords: [
            228.0,
            289.0,
            368.0,
            461.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:42.800000",
        "id": 23,
        "className": "Person",
        coords: [
            509.0,
            249.0,
            574.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:42.800000",
        "id": 41,
        "className": "Person",
        coords: [
            140.0,
            191.0,
            177.0,
            273.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:42.800000",
        "id": 47,
        "className": "Person",
        coords: [
            490.0,
            180.0,
            523.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:42.900000",
        "id": 45,
        "className": "Person",
        coords: [
            315.0,
            535.0,
            451.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:42.900000",
        "id": 46,
        "className": "Person",
        coords: [
            226.0,
            288.0,
            369.0,
            466.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:42.900000",
        "id": 23,
        "className": "Person",
        coords: [
            509.0,
            249.0,
            574.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:42.900000",
        "id": 41,
        "className": "Person",
        coords: [
            140.0,
            191.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:43",
        "id": 47,
        "className": "Person",
        coords: [
            490.0,
            180.0,
            523.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:43",
        "id": 45,
        "className": "Person",
        coords: [
            322.0,
            536.0,
            456.0,
            718.0
        ],
        "status": "Moving",
        "speed": 91.23,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:43",
        "id": 46,
        "className": "Person",
        coords: [
            228.0,
            288.0,
            371.0,
            469.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:43.100000",
        "id": 23,
        "className": "Person",
        coords: [
            509.0,
            250.0,
            574.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:43.100000",
        "id": 41,
        "className": "Person",
        coords: [
            140.0,
            191.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:43.100000",
        "id": 47,
        "className": "Person",
        coords: [
            490.0,
            181.0,
            523.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:43.100000",
        "id": 45,
        "className": "Person",
        coords: [
            327.0,
            537.0,
            458.0,
            718.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:43.100000",
        "id": 23,
        "className": "Person",
        coords: [
            509.0,
            250.0,
            574.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:43.200000",
        "id": 41,
        "className": "Person",
        coords: [
            140.0,
            191.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:43.200000",
        "id": 47,
        "className": "Person",
        coords: [
            490.0,
            181.0,
            523.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:43.200000",
        "id": 45,
        "className": "Person",
        coords: [
            323.0,
            537.0,
            455.0,
            718.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:43.700000",
        "id": 23,
        "className": "Person",
        coords: [
            509.0,
            250.0,
            574.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:43.700000",
        "id": 41,
        "className": "Person",
        coords: [
            141.0,
            192.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:43.700000",
        "id": 47,
        "className": "Person",
        coords: [
            490.0,
            181.0,
            523.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:43.700000",
        "id": 45,
        "className": "Person",
        coords: [
            326.0,
            538.0,
            456.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:43.800000",
        "id": 23,
        "className": "Person",
        coords: [
            509.0,
            250.0,
            574.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:43.800000",
        "id": 41,
        "className": "Person",
        coords: [
            141.0,
            192.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:43.800000",
        "id": 47,
        "className": "Person",
        coords: [
            490.0,
            181.0,
            522.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:43.800000",
        "id": 45,
        "className": "Person",
        coords: [
            333.0,
            539.0,
            460.0,
            717.0
        ],
        "status": "Moving",
        "speed": 76.48,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:43.800000",
        "id": 23,
        "className": "Person",
        coords: [
            509.0,
            250.0,
            574.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:43.900000",
        "id": 41,
        "className": "Person",
        coords: [
            141.0,
            192.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:43.900000",
        "id": 47,
        "className": "Person",
        coords: [
            490.0,
            180.0,
            522.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:43.900000",
        "id": 45,
        "className": "Person",
        coords: [
            338.0,
            539.0,
            462.0,
            716.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:43.900000",
        "id": 23,
        "className": "Person",
        coords: [
            509.0,
            249.0,
            574.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:44",
        "id": 41,
        "className": "Person",
        coords: [
            141.0,
            192.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:44",
        "id": 47,
        "className": "Person",
        coords: [
            490.0,
            180.0,
            522.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:44",
        "id": 23,
        "className": "Person",
        coords: [
            509.0,
            249.0,
            574.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:44",
        "id": 41,
        "className": "Person",
        coords: [
            141.0,
            192.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:44",
        "id": 47,
        "className": "Person",
        coords: [
            490.0,
            180.0,
            522.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:44.100000",
        "id": 23,
        "className": "Person",
        coords: [
            509.0,
            249.0,
            575.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:44.100000",
        "id": 41,
        "className": "Person",
        coords: [
            141.0,
            192.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:44.100000",
        "id": 47,
        "className": "Person",
        coords: [
            490.0,
            180.0,
            522.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:44.200000",
        "id": 23,
        "className": "Person",
        coords: [
            509.0,
            249.0,
            575.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:44.200000",
        "id": 41,
        "className": "Person",
        coords: [
            140.0,
            192.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:44.200000",
        "id": 47,
        "className": "Person",
        coords: [
            490.0,
            179.0,
            522.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:44.200000",
        "id": 23,
        "className": "Person",
        coords: [
            510.0,
            250.0,
            575.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:44.200000",
        "id": 41,
        "className": "Person",
        coords: [
            141.0,
            192.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:44.300000",
        "id": 47,
        "className": "Person",
        coords: [
            490.0,
            179.0,
            522.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:44.300000",
        "id": 23,
        "className": "Person",
        coords: [
            510.0,
            249.0,
            575.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:44.300000",
        "id": 41,
        "className": "Person",
        coords: [
            141.0,
            192.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:44.300000",
        "id": 47,
        "className": "Person",
        coords: [
            489.0,
            179.0,
            522.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:44.400000",
        "id": 23,
        "className": "Person",
        coords: [
            510.0,
            250.0,
            575.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:44.400000",
        "id": 41,
        "className": "Person",
        coords: [
            141.0,
            192.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:44.400000",
        "id": 47,
        "className": "Person",
        coords: [
            490.0,
            179.0,
            522.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:44.500000",
        "id": 23,
        "className": "Person",
        coords: [
            510.0,
            250.0,
            575.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:44.500000",
        "id": 41,
        "className": "Person",
        coords: [
            141.0,
            192.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:44.500000",
        "id": 47,
        "className": "Person",
        coords: [
            490.0,
            179.0,
            522.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:44.500000",
        "id": 23,
        "className": "Person",
        coords: [
            510.0,
            250.0,
            575.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:44.500000",
        "id": 41,
        "className": "Person",
        coords: [
            141.0,
            192.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:44.600000",
        "id": 47,
        "className": "Person",
        coords: [
            490.0,
            180.0,
            522.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:44.600000",
        "id": 23,
        "className": "Person",
        coords: [
            510.0,
            250.0,
            575.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:44.600000",
        "id": 41,
        "className": "Person",
        coords: [
            140.0,
            192.0,
            176.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:44.600000",
        "id": 47,
        "className": "Person",
        coords: [
            491.0,
            181.0,
            522.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:44.700000",
        "id": 23,
        "className": "Person",
        coords: [
            511.0,
            249.0,
            575.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:44.700000",
        "id": 41,
        "className": "Person",
        coords: [
            139.0,
            192.0,
            176.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:44.700000",
        "id": 47,
        "className": "Person",
        coords: [
            492.0,
            181.0,
            523.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:44.700000",
        "id": 45,
        "className": "Person",
        coords: [
            320.0,
            539.0,
            446.0,
            715.0
        ],
        "status": "Moving",
        "speed": 254.98,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:44.800000",
        "id": 23,
        "className": "Person",
        coords: [
            511.0,
            249.0,
            575.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:44.800000",
        "id": 41,
        "className": "Person",
        coords: [
            139.0,
            191.0,
            176.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:44.800000",
        "id": 47,
        "className": "Person",
        coords: [
            492.0,
            182.0,
            523.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:44.800000",
        "id": 45,
        "className": "Person",
        coords: [
            317.0,
            538.0,
            446.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:44.900000",
        "id": 23,
        "className": "Person",
        coords: [
            511.0,
            249.0,
            575.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:44.900000",
        "id": 41,
        "className": "Person",
        coords: [
            140.0,
            191.0,
            177.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:44.900000",
        "id": 47,
        "className": "Person",
        coords: [
            492.0,
            182.0,
            523.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:44.900000",
        "id": 45,
        "className": "Person",
        coords: [
            315.0,
            538.0,
            446.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:45",
        "id": 23,
        "className": "Person",
        coords: [
            511.0,
            249.0,
            575.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:45",
        "id": 41,
        "className": "Person",
        coords: [
            139.0,
            191.0,
            176.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:45",
        "id": 47,
        "className": "Person",
        coords: [
            492.0,
            181.0,
            523.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:45.100000",
        "id": 45,
        "className": "Person",
        coords: [
            313.0,
            537.0,
            447.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:45.100000",
        "id": 46,
        "className": "Person",
        coords: [
            241.0,
            326.0,
            376.0,
            493.0
        ],
        "status": "Moving",
        "speed": 484.16,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:45.100000",
        "id": 23,
        "className": "Person",
        coords: [
            511.0,
            249.0,
            575.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:45.100000",
        "id": 41,
        "className": "Person",
        coords: [
            138.0,
            190.0,
            176.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:45.200000",
        "id": 47,
        "className": "Person",
        coords: [
            492.0,
            180.0,
            523.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:45.200000",
        "id": 45,
        "className": "Person",
        coords: [
            313.0,
            537.0,
            448.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:45.200000",
        "id": 46,
        "className": "Person",
        coords: [
            242.0,
            326.0,
            381.0,
            491.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:45.300000",
        "id": 23,
        "className": "Person",
        coords: [
            511.0,
            249.0,
            575.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:45.300000",
        "id": 41,
        "className": "Person",
        coords: [
            137.0,
            189.0,
            176.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:45.300000",
        "id": 47,
        "className": "Person",
        coords: [
            492.0,
            180.0,
            523.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:45.300000",
        "id": 45,
        "className": "Person",
        coords: [
            312.0,
            537.0,
            448.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:45.300000",
        "id": 46,
        "className": "Person",
        coords: [
            237.0,
            326.0,
            376.0,
            493.0
        ],
        "status": "Moving",
        "speed": 76.48,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:45.700000",
        "id": 23,
        "className": "Person",
        coords: [
            511.0,
            249.0,
            575.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:45.700000",
        "id": 41,
        "className": "Person",
        coords: [
            137.0,
            189.0,
            176.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:45.800000",
        "id": 47,
        "className": "Person",
        coords: [
            492.0,
            180.0,
            523.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:45.800000",
        "id": 45,
        "className": "Person",
        coords: [
            312.0,
            537.0,
            449.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:45.800000",
        "id": 46,
        "className": "Person",
        coords: [
            242.0,
            327.0,
            384.0,
            494.0
        ],
        "status": "Moving",
        "speed": 106.06,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:45.900000",
        "id": 23,
        "className": "Person",
        coords: [
            511.0,
            249.0,
            575.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:45.900000",
        "id": 41,
        "className": "Person",
        coords: [
            137.0,
            189.0,
            176.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:45.900000",
        "id": 47,
        "className": "Person",
        coords: [
            491.0,
            180.0,
            523.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:45.900000",
        "id": 45,
        "className": "Person",
        coords: [
            311.0,
            537.0,
            449.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:46",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            249.0,
            575.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:46",
        "id": 41,
        "className": "Person",
        coords: [
            137.0,
            189.0,
            175.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:46",
        "id": 47,
        "className": "Person",
        coords: [
            491.0,
            179.0,
            522.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:46",
        "id": 45,
        "className": "Person",
        coords: [
            311.0,
            537.0,
            449.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:46.100000",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            249.0,
            575.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:46.100000",
        "id": 41,
        "className": "Person",
        coords: [
            136.0,
            189.0,
            175.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:46.100000",
        "id": 47,
        "className": "Person",
        coords: [
            491.0,
            179.0,
            522.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:46.100000",
        "id": 45,
        "className": "Person",
        coords: [
            311.0,
            537.0,
            449.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:46.200000",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            249.0,
            575.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:46.200000",
        "id": 41,
        "className": "Person",
        coords: [
            136.0,
            189.0,
            175.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:46.200000",
        "id": 47,
        "className": "Person",
        coords: [
            491.0,
            179.0,
            522.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:46.200000",
        "id": 45,
        "className": "Person",
        coords: [
            311.0,
            537.0,
            450.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:46.300000",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            249.0,
            575.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:46.300000",
        "id": 41,
        "className": "Person",
        coords: [
            136.0,
            189.0,
            175.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:46.300000",
        "id": 47,
        "className": "Person",
        coords: [
            491.0,
            179.0,
            522.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:46.300000",
        "id": 45,
        "className": "Person",
        coords: [
            311.0,
            537.0,
            450.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:46.400000",
        "id": 46,
        "className": "Person",
        coords: [
            245.0,
            327.0,
            385.0,
            489.0
        ],
        "status": "Moving",
        "speed": 42.42,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:46.700000",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            249.0,
            575.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:46.800000",
        "id": 41,
        "className": "Person",
        coords: [
            135.0,
            189.0,
            174.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:46.800000",
        "id": 47,
        "className": "Person",
        coords: [
            491.0,
            179.0,
            522.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:46.800000",
        "id": 45,
        "className": "Person",
        coords: [
            314.0,
            537.0,
            452.0,
            717.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:46.800000",
        "id": 46,
        "className": "Person",
        coords: [
            243.0,
            327.0,
            385.0,
            488.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:46.900000",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            249.0,
            575.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:46.900000",
        "id": 41,
        "className": "Person",
        coords: [
            135.0,
            189.0,
            174.0,
            274.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:46.900000",
        "id": 47,
        "className": "Person",
        coords: [
            491.0,
            180.0,
            522.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:46.900000",
        "id": 45,
        "className": "Person",
        coords: [
            316.0,
            537.0,
            454.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:47",
        "id": 46,
        "className": "Person",
        coords: [
            245.0,
            326.0,
            386.0,
            486.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:47",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            249.0,
            575.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:47",
        "id": 41,
        "className": "Person",
        coords: [
            135.0,
            188.0,
            172.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:47",
        "id": 47,
        "className": "Person",
        coords: [
            491.0,
            180.0,
            521.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:47.100000",
        "id": 45,
        "className": "Person",
        coords: [
            318.0,
            538.0,
            453.0,
            714.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:47.100000",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            249.0,
            574.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:47.100000",
        "id": 41,
        "className": "Person",
        coords: [
            134.0,
            187.0,
            171.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:47.100000",
        "id": 47,
        "className": "Person",
        coords: [
            491.0,
            180.0,
            521.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:47.200000",
        "id": 45,
        "className": "Person",
        coords: [
            316.0,
            538.0,
            452.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:47.200000",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            249.0,
            574.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:47.200000",
        "id": 41,
        "className": "Person",
        coords: [
            134.0,
            188.0,
            170.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:47.200000",
        "id": 47,
        "className": "Person",
        coords: [
            491.0,
            181.0,
            521.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:47.300000",
        "id": 45,
        "className": "Person",
        coords: [
            326.0,
            538.0,
            459.0,
            716.0
        ],
        "status": "Moving",
        "speed": 119.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:47.300000",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            249.0,
            574.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:47.400000",
        "id": 41,
        "className": "Person",
        coords: [
            134.0,
            188.0,
            170.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:47.400000",
        "id": 47,
        "className": "Person",
        coords: [
            491.0,
            181.0,
            521.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:47.400000",
        "id": 46,
        "className": "Person",
        coords: [
            234.0,
            326.0,
            378.0,
            491.0
        ],
        "status": "Moving",
        "speed": 138.28,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:47.800000",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            249.0,
            574.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:47.800000",
        "id": 41,
        "className": "Person",
        coords: [
            135.0,
            190.0,
            169.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:47.800000",
        "id": 47,
        "className": "Person",
        coords: [
            491.0,
            181.0,
            521.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:47.800000",
        "id": 46,
        "className": "Person",
        coords: [
            233.0,
            327.0,
            376.0,
            492.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:47.900000",
        "id": 45,
        "className": "Person",
        coords: [
            332.0,
            538.0,
            463.0,
            717.0
        ],
        "status": "Moving",
        "speed": 74.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:47.900000",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            249.0,
            574.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:47.900000",
        "id": 41,
        "className": "Person",
        coords: [
            134.0,
            190.0,
            168.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:47.900000",
        "id": 47,
        "className": "Person",
        coords: [
            491.0,
            181.0,
            521.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:48",
        "id": 46,
        "className": "Person",
        coords: [
            233.0,
            327.0,
            374.0,
            493.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:48",
        "id": 45,
        "className": "Person",
        coords: [
            335.0,
            537.0,
            463.0,
            714.0
        ],
        "status": "Moving",
        "speed": 42.42,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:48.100000",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            249.0,
            574.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:48.100000",
        "id": 41,
        "className": "Person",
        coords: [
            135.0,
            190.0,
            168.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:48.100000",
        "id": 47,
        "className": "Person",
        coords: [
            492.0,
            182.0,
            521.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:48.100000",
        "id": 46,
        "className": "Person",
        coords: [
            233.0,
            328.0,
            374.0,
            495.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:48.200000",
        "id": 45,
        "className": "Person",
        coords: [
            335.0,
            537.0,
            462.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:48.200000",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            249.0,
            574.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:48.200000",
        "id": 41,
        "className": "Person",
        coords: [
            135.0,
            191.0,
            167.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:48.200000",
        "id": 47,
        "className": "Person",
        coords: [
            492.0,
            183.0,
            521.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:48.200000",
        "id": 46,
        "className": "Person",
        coords: [
            232.0,
            327.0,
            374.0,
            497.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:48.300000",
        "id": 45,
        "className": "Person",
        coords: [
            335.0,
            535.0,
            461.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:48.300000",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            249.0,
            574.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:48.300000",
        "id": 41,
        "className": "Person",
        coords: [
            135.0,
            192.0,
            167.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:48.400000",
        "id": 47,
        "className": "Person",
        coords: [
            492.0,
            184.0,
            521.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:48.400000",
        "id": 45,
        "className": "Person",
        coords: [
            323.0,
            534.0,
            452.0,
            717.0
        ],
        "status": "Moving",
        "speed": 165.67,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:48.800000",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            249.0,
            573.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:48.800000",
        "id": 41,
        "className": "Person",
        coords: [
            135.0,
            191.0,
            168.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:48.800000",
        "id": 47,
        "className": "Person",
        coords: [
            492.0,
            185.0,
            521.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:48.900000",
        "id": 45,
        "className": "Person",
        coords: [
            317.0,
            533.0,
            448.0,
            718.0
        ],
        "status": "Moving",
        "speed": 74.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:48.900000",
        "id": 46,
        "className": "Person",
        coords: [
            229.0,
            327.0,
            374.0,
            504.0
        ],
        "status": "Moving",
        "speed": 54.08,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:48.900000",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            249.0,
            574.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:48.900000",
        "id": 41,
        "className": "Person",
        coords: [
            136.0,
            191.0,
            168.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:49",
        "id": 47,
        "className": "Person",
        coords: [
            492.0,
            184.0,
            521.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:49",
        "id": 45,
        "className": "Person",
        coords: [
            314.0,
            533.0,
            446.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:49",
        "id": 46,
        "className": "Person",
        coords: [
            229.0,
            327.0,
            373.0,
            503.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:49.100000",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            249.0,
            573.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:49.100000",
        "id": 41,
        "className": "Person",
        coords: [
            136.0,
            192.0,
            168.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:49.100000",
        "id": 47,
        "className": "Person",
        coords: [
            492.0,
            185.0,
            521.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:49.100000",
        "id": 45,
        "className": "Person",
        coords: [
            313.0,
            533.0,
            446.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:49.200000",
        "id": 23,
        "className": "Person",
        coords: [
            513.0,
            249.0,
            573.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:49.200000",
        "id": 41,
        "className": "Person",
        coords: [
            136.0,
            192.0,
            169.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:49.200000",
        "id": 47,
        "className": "Person",
        coords: [
            492.0,
            184.0,
            521.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:49.200000",
        "id": 45,
        "className": "Person",
        coords: [
            313.0,
            532.0,
            448.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:49.300000",
        "id": 23,
        "className": "Person",
        coords: [
            513.0,
            249.0,
            573.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:49.300000",
        "id": 41,
        "className": "Person",
        coords: [
            137.0,
            191.0,
            171.0,
            271.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:49.300000",
        "id": 47,
        "className": "Person",
        coords: [
            492.0,
            184.0,
            521.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:49.300000",
        "id": 45,
        "className": "Person",
        coords: [
            312.0,
            532.0,
            448.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:49.400000",
        "id": 23,
        "className": "Person",
        coords: [
            513.0,
            249.0,
            573.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:49.400000",
        "id": 41,
        "className": "Person",
        coords: [
            139.0,
            191.0,
            174.0,
            272.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:49.400000",
        "id": 47,
        "className": "Person",
        coords: [
            492.0,
            186.0,
            520.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:49.400000",
        "id": 45,
        "className": "Person",
        coords: [
            312.0,
            533.0,
            448.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:49.900000",
        "id": 23,
        "className": "Person",
        coords: [
            513.0,
            249.0,
            573.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:49.900000",
        "id": 41,
        "className": "Person",
        coords: [
            141.0,
            191.0,
            176.0,
            275.0
        ],
        "status": "Moving",
        "speed": 42.42,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:49.900000",
        "id": 47,
        "className": "Person",
        coords: [
            492.0,
            188.0,
            520.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:49.900000",
        "id": 45,
        "className": "Person",
        coords: [
            313.0,
            533.0,
            449.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:50",
        "id": 23,
        "className": "Person",
        coords: [
            513.0,
            249.0,
            573.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:50",
        "id": 41,
        "className": "Person",
        coords: [
            141.0,
            191.0,
            177.0,
            276.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:50",
        "id": 47,
        "className": "Person",
        coords: [
            492.0,
            189.0,
            520.0,
            265.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:50",
        "id": 45,
        "className": "Person",
        coords: [
            313.0,
            534.0,
            449.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:50.100000",
        "id": 23,
        "className": "Person",
        coords: [
            513.0,
            249.0,
            573.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:50.100000",
        "id": 41,
        "className": "Person",
        coords: [
            142.0,
            191.0,
            177.0,
            276.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:50.100000",
        "id": 47,
        "className": "Person",
        coords: [
            492.0,
            188.0,
            520.0,
            265.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:50.100000",
        "id": 45,
        "className": "Person",
        coords: [
            313.0,
            534.0,
            450.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:50.200000",
        "id": 23,
        "className": "Person",
        coords: [
            513.0,
            249.0,
            573.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:50.200000",
        "id": 41,
        "className": "Person",
        coords: [
            143.0,
            192.0,
            178.0,
            277.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:50.200000",
        "id": 47,
        "className": "Person",
        coords: [
            493.0,
            189.0,
            520.0,
            265.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:50.200000",
        "id": 45,
        "className": "Person",
        coords: [
            324.0,
            535.0,
            458.0,
            718.0
        ],
        "status": "Moving",
        "speed": 149.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:50.300000",
        "id": 23,
        "className": "Person",
        coords: [
            513.0,
            249.0,
            573.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:50.300000",
        "id": 41,
        "className": "Person",
        coords: [
            144.0,
            193.0,
            179.0,
            278.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:50.300000",
        "id": 47,
        "className": "Person",
        coords: [
            493.0,
            185.0,
            522.0,
            264.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:50.300000",
        "id": 45,
        "className": "Person",
        coords: [
            320.0,
            535.0,
            454.0,
            717.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:50.400000",
        "id": 23,
        "className": "Person",
        coords: [
            513.0,
            249.0,
            573.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:50.400000",
        "id": 41,
        "className": "Person",
        coords: [
            145.0,
            193.0,
            180.0,
            278.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:50.400000",
        "id": 47,
        "className": "Person",
        coords: [
            493.0,
            184.0,
            522.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:50.400000",
        "id": 45,
        "className": "Person",
        coords: [
            329.0,
            535.0,
            461.0,
            717.0
        ],
        "status": "Moving",
        "speed": 119.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:50.900000",
        "id": 23,
        "className": "Person",
        coords: [
            513.0,
            249.0,
            573.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:50.900000",
        "id": 41,
        "className": "Person",
        coords: [
            145.0,
            193.0,
            180.0,
            278.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:50.900000",
        "id": 47,
        "className": "Person",
        coords: [
            493.0,
            183.0,
            523.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:50.900000",
        "id": 45,
        "className": "Person",
        coords: [
            333.0,
            536.0,
            463.0,
            717.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:51",
        "id": 48,
        "className": "Person",
        coords: [
            208.0,
            199.0,
            257.0,
            300.0
        ],
        "status": "First Seen",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:22:51",
        "id": 23,
        "className": "Person",
        coords: [
            513.0,
            249.0,
            573.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:51",
        "id": 41,
        "className": "Person",
        coords: [
            147.0,
            196.0,
            181.0,
            279.0
        ],
        "status": "Moving",
        "speed": 42.42,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:51",
        "id": 47,
        "className": "Person",
        coords: [
            492.0,
            181.0,
            523.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:51.100000",
        "id": 45,
        "className": "Person",
        coords: [
            335.0,
            535.0,
            463.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:51.100000",
        "id": 48,
        "className": "Person",
        coords: [
            208.0,
            199.0,
            257.0,
            300.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:22:51.100000",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            249.0,
            573.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:51.200000",
        "id": 41,
        "className": "Person",
        coords: [
            148.0,
            196.0,
            182.0,
            279.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:51.200000",
        "id": 47,
        "className": "Person",
        coords: [
            493.0,
            182.0,
            523.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:51.200000",
        "id": 45,
        "className": "Person",
        coords: [
            337.0,
            536.0,
            462.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:51.200000",
        "id": 48,
        "className": "Person",
        coords: [
            207.0,
            198.0,
            257.0,
            300.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:22:51.200000",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            249.0,
            572.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:51.300000",
        "id": 41,
        "className": "Person",
        coords: [
            149.0,
            195.0,
            183.0,
            279.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:51.300000",
        "id": 47,
        "className": "Person",
        coords: [
            493.0,
            182.0,
            523.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:51.300000",
        "id": 45,
        "className": "Person",
        coords: [
            338.0,
            536.0,
            462.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:51.300000",
        "id": 48,
        "className": "Person",
        coords: [
            208.0,
            198.0,
            257.0,
            301.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:22:51.300000",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            249.0,
            572.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:51.400000",
        "id": 41,
        "className": "Person",
        coords: [
            149.0,
            193.0,
            183.0,
            278.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:51.400000",
        "id": 47,
        "className": "Person",
        coords: [
            493.0,
            182.0,
            523.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:51.400000",
        "id": 45,
        "className": "Person",
        coords: [
            345.0,
            536.0,
            455.0,
            697.0
        ],
        "status": "Moving",
        "speed": 149.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:51.400000",
        "id": 48,
        "className": "Person",
        coords: [
            208.0,
            198.0,
            257.0,
            301.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:51.500000",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            249.0,
            572.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:51.500000",
        "id": 41,
        "className": "Person",
        coords: [
            149.0,
            192.0,
            183.0,
            278.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:51.500000",
        "id": 47,
        "className": "Person",
        coords: [
            493.0,
            183.0,
            523.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:51.500000",
        "id": 45,
        "className": "Person",
        coords: [
            348.0,
            536.0,
            453.0,
            689.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:51.500000",
        "id": 48,
        "className": "Person",
        coords: [
            208.0,
            198.0,
            257.0,
            300.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:52",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            250.0,
            572.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:52",
        "id": 41,
        "className": "Person",
        coords: [
            149.0,
            191.0,
            183.0,
            278.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:52",
        "id": 47,
        "className": "Person",
        coords: [
            493.0,
            183.0,
            522.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:52",
        "id": 45,
        "className": "Person",
        coords: [
            349.0,
            535.0,
            452.0,
            687.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:22:52",
        "id": 48,
        "className": "Person",
        coords: [
            207.0,
            198.0,
            256.0,
            300.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:52.100000",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            250.0,
            572.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:52.100000",
        "id": 41,
        "className": "Person",
        coords: [
            148.0,
            190.0,
            182.0,
            277.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:52.100000",
        "id": 47,
        "className": "Person",
        coords: [
            493.0,
            183.0,
            522.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:52.100000",
        "id": 48,
        "className": "Person",
        coords: [
            207.0,
            198.0,
            256.0,
            300.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:52.200000",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            250.0,
            572.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:52.200000",
        "id": 41,
        "className": "Person",
        coords: [
            148.0,
            189.0,
            182.0,
            277.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:52.200000",
        "id": 47,
        "className": "Person",
        coords: [
            493.0,
            183.0,
            522.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:52.200000",
        "id": 48,
        "className": "Person",
        coords: [
            206.0,
            198.0,
            255.0,
            300.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:52.300000",
        "id": 23,
        "className": "Person",
        coords: [
            513.0,
            250.0,
            573.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:52.300000",
        "id": 41,
        "className": "Person",
        coords: [
            149.0,
            188.0,
            183.0,
            276.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:52.300000",
        "id": 48,
        "className": "Person",
        coords: [
            205.0,
            197.0,
            256.0,
            307.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:52.300000",
        "id": 23,
        "className": "Person",
        coords: [
            513.0,
            250.0,
            573.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:52.300000",
        "id": 41,
        "className": "Person",
        coords: [
            150.0,
            187.0,
            184.0,
            275.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:52.400000",
        "id": 48,
        "className": "Person",
        coords: [
            204.0,
            197.0,
            257.0,
            312.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:52.400000",
        "id": 47,
        "className": "Person",
        coords: [
            493.0,
            182.0,
            523.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:52.400000",
        "id": 23,
        "className": "Person",
        coords: [
            513.0,
            250.0,
            573.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:52.400000",
        "id": 41,
        "className": "Person",
        coords: [
            149.0,
            187.0,
            184.0,
            275.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:52.400000",
        "id": 48,
        "className": "Person",
        coords: [
            202.0,
            197.0,
            256.0,
            315.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:52.400000",
        "id": 47,
        "className": "Person",
        coords: [
            493.0,
            181.0,
            523.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:52.500000",
        "id": 23,
        "className": "Person",
        coords: [
            513.0,
            250.0,
            573.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:52.500000",
        "id": 41,
        "className": "Person",
        coords: [
            149.0,
            186.0,
            184.0,
            276.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:52.500000",
        "id": 48,
        "className": "Person",
        coords: [
            202.0,
            196.0,
            255.0,
            315.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:53.100000",
        "id": 23,
        "className": "Person",
        coords: [
            513.0,
            250.0,
            572.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:22:53.200000",
        "id": 41,
        "className": "Person",
        coords: [
            148.0,
            186.0,
            183.0,
            276.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:28.700000",
        "id": 48,
        "className": "Person",
        coords: [
            201.0,
            196.0,
            255.0,
            315.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:28.800000",
        "id": 47,
        "className": "Person",
        coords: [
            494.0,
            183.0,
            523.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:29.500000",
        "id": 23,
        "className": "Person",
        coords: [
            513.0,
            250.0,
            572.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:29.600000",
        "id": 41,
        "className": "Person",
        coords: [
            146.0,
            185.0,
            182.0,
            276.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:29.600000",
        "id": 48,
        "className": "Person",
        coords: [
            202.0,
            195.0,
            254.0,
            314.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:29.600000",
        "id": 47,
        "className": "Person",
        coords: [
            495.0,
            180.0,
            526.0,
            261.0
        ],
        "status": "Moving",
        "speed": 42.42,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:29.700000",
        "id": 23,
        "className": "Person",
        coords: [
            513.0,
            250.0,
            573.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:29.700000",
        "id": 41,
        "className": "Person",
        coords: [
            145.0,
            185.0,
            181.0,
            276.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:29.700000",
        "id": 48,
        "className": "Person",
        coords: [
            202.0,
            195.0,
            254.0,
            313.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:29.700000",
        "id": 47,
        "className": "Person",
        coords: [
            495.0,
            179.0,
            526.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:29.800000",
        "id": 23,
        "className": "Person",
        coords: [
            513.0,
            250.0,
            573.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:29.800000",
        "id": 41,
        "className": "Person",
        coords: [
            145.0,
            185.0,
            181.0,
            276.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:29.900000",
        "id": 48,
        "className": "Person",
        coords: [
            202.0,
            195.0,
            252.0,
            310.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:29.900000",
        "id": 45,
        "className": "Person",
        coords: [
            318.0,
            533.0,
            445.0,
            715.0
        ],
        "status": "Moving",
        "speed": 345.3,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:23:30",
        "id": 23,
        "className": "Person",
        coords: [
            513.0,
            250.0,
            573.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:30",
        "id": 41,
        "className": "Person",
        coords: [
            144.0,
            185.0,
            180.0,
            276.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:30",
        "id": 48,
        "className": "Person",
        coords: [
            203.0,
            195.0,
            252.0,
            309.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:30",
        "id": 45,
        "className": "Person",
        coords: [
            315.0,
            533.0,
            446.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:23:30.100000",
        "id": 23,
        "className": "Person",
        coords: [
            513.0,
            249.0,
            573.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:30.100000",
        "id": 41,
        "className": "Person",
        coords: [
            143.0,
            185.0,
            180.0,
            276.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:30.100000",
        "id": 48,
        "className": "Person",
        coords: [
            204.0,
            195.0,
            248.0,
            299.0
        ],
        "status": "Moving",
        "speed": 76.48,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:30.200000",
        "id": 45,
        "className": "Person",
        coords: [
            314.0,
            533.0,
            447.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:23:30.200000",
        "id": 47,
        "className": "Person",
        coords: [
            497.0,
            178.0,
            529.0,
            259.0
        ],
        "status": "Moving",
        "speed": 54.08,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:30.300000",
        "id": 23,
        "className": "Person",
        coords: [
            513.0,
            250.0,
            573.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:30.300000",
        "id": 41,
        "className": "Person",
        coords: [
            140.0,
            185.0,
            178.0,
            276.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:30.300000",
        "id": 48,
        "className": "Person",
        coords: [
            204.0,
            195.0,
            247.0,
            295.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:30.400000",
        "id": 45,
        "className": "Person",
        coords: [
            313.0,
            534.0,
            447.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:23:30.400000",
        "id": 47,
        "className": "Person",
        coords: [
            496.0,
            178.0,
            530.0,
            260.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:30.400000",
        "id": 23,
        "className": "Person",
        coords: [
            513.0,
            249.0,
            573.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:30.400000",
        "id": 41,
        "className": "Person",
        coords: [
            139.0,
            185.0,
            176.0,
            273.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:30.500000",
        "id": 48,
        "className": "Person",
        coords: [
            205.0,
            195.0,
            247.0,
            292.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:30.500000",
        "id": 45,
        "className": "Person",
        coords: [
            313.0,
            534.0,
            448.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:23:30.500000",
        "id": 23,
        "className": "Person",
        coords: [
            513.0,
            250.0,
            573.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:30.600000",
        "id": 41,
        "className": "Person",
        coords: [
            138.0,
            185.0,
            175.0,
            270.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:30.600000",
        "id": 48,
        "className": "Person",
        coords: [
            205.0,
            195.0,
            247.0,
            291.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:30.600000",
        "id": 45,
        "className": "Person",
        coords: [
            313.0,
            535.0,
            449.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:23:30.600000",
        "id": 47,
        "className": "Person",
        coords: [
            494.0,
            177.0,
            528.0,
            260.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:30.700000",
        "id": 23,
        "className": "Person",
        coords: [
            513.0,
            249.0,
            573.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:30.700000",
        "id": 41,
        "className": "Person",
        coords: [
            136.0,
            183.0,
            173.0,
            268.0
        ],
        "status": "Moving",
        "speed": 42.42,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:30.700000",
        "id": 48,
        "className": "Person",
        coords: [
            205.0,
            195.0,
            247.0,
            293.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:30.700000",
        "id": 45,
        "className": "Person",
        coords: [
            312.0,
            535.0,
            449.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:23:30.700000",
        "id": 47,
        "className": "Person",
        coords: [
            495.0,
            178.0,
            530.0,
            260.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:30.800000",
        "id": 23,
        "className": "Person",
        coords: [
            513.0,
            249.0,
            574.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:30.800000",
        "id": 41,
        "className": "Person",
        coords: [
            135.0,
            183.0,
            173.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:30.800000",
        "id": 48,
        "className": "Person",
        coords: [
            204.0,
            195.0,
            250.0,
            302.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:30.800000",
        "id": 45,
        "className": "Person",
        coords: [
            312.0,
            535.0,
            449.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:23:30.800000",
        "id": 47,
        "className": "Person",
        coords: [
            495.0,
            178.0,
            530.0,
            260.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:30.900000",
        "id": 23,
        "className": "Person",
        coords: [
            513.0,
            249.0,
            574.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:30.900000",
        "id": 41,
        "className": "Person",
        coords: [
            134.0,
            182.0,
            172.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:30.900000",
        "id": 48,
        "className": "Person",
        coords: [
            204.0,
            195.0,
            250.0,
            305.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:30.900000",
        "id": 45,
        "className": "Person",
        coords: [
            312.0,
            535.0,
            450.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:23:31",
        "id": 47,
        "className": "Person",
        coords: [
            495.0,
            178.0,
            530.0,
            260.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:31",
        "id": 23,
        "className": "Person",
        coords: [
            513.0,
            249.0,
            574.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:31",
        "id": 41,
        "className": "Person",
        coords: [
            132.0,
            182.0,
            171.0,
            265.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:31",
        "id": 48,
        "className": "Person",
        coords: [
            203.0,
            194.0,
            250.0,
            307.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:31.100000",
        "id": 45,
        "className": "Person",
        coords: [
            317.0,
            536.0,
            454.0,
            717.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:23:31.100000",
        "id": 47,
        "className": "Person",
        coords: [
            495.0,
            177.0,
            530.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:31.100000",
        "id": 23,
        "className": "Person",
        coords: [
            513.0,
            249.0,
            574.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:31.100000",
        "id": 41,
        "className": "Person",
        coords: [
            132.0,
            181.0,
            171.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:31.100000",
        "id": 48,
        "className": "Person",
        coords: [
            203.0,
            194.0,
            250.0,
            308.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:31.200000",
        "id": 45,
        "className": "Person",
        coords: [
            320.0,
            536.0,
            456.0,
            718.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:23:31.200000",
        "id": 23,
        "className": "Person",
        coords: [
            513.0,
            249.0,
            574.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:31.200000",
        "id": 41,
        "className": "Person",
        coords: [
            132.0,
            181.0,
            171.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:31.200000",
        "id": 48,
        "className": "Person",
        coords: [
            203.0,
            194.0,
            250.0,
            308.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:31.300000",
        "id": 45,
        "className": "Person",
        coords: [
            318.0,
            536.0,
            454.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:23:31.300000",
        "id": 47,
        "className": "Person",
        coords: [
            495.0,
            176.0,
            530.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:31.300000",
        "id": 23,
        "className": "Person",
        coords: [
            513.0,
            249.0,
            574.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:31.300000",
        "id": 41,
        "className": "Person",
        coords: [
            130.0,
            181.0,
            169.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:31.400000",
        "id": 48,
        "className": "Person",
        coords: [
            204.0,
            194.0,
            250.0,
            308.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:31.400000",
        "id": 45,
        "className": "Person",
        coords: [
            315.0,
            536.0,
            452.0,
            717.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:23:31.400000",
        "id": 23,
        "className": "Person",
        coords: [
            513.0,
            249.0,
            574.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:31.400000",
        "id": 41,
        "className": "Person",
        coords: [
            129.0,
            181.0,
            168.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:31.500000",
        "id": 48,
        "className": "Person",
        coords: [
            204.0,
            194.0,
            250.0,
            307.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:31.500000",
        "id": 45,
        "className": "Person",
        coords: [
            314.0,
            535.0,
            451.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:23:31.500000",
        "id": 23,
        "className": "Person",
        coords: [
            513.0,
            249.0,
            574.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:31.500000",
        "id": 41,
        "className": "Person",
        coords: [
            129.0,
            181.0,
            167.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:31.500000",
        "id": 48,
        "className": "Person",
        coords: [
            205.0,
            194.0,
            248.0,
            300.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:31.600000",
        "id": 45,
        "className": "Person",
        coords: [
            312.0,
            535.0,
            450.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:23:31.600000",
        "id": 23,
        "className": "Person",
        coords: [
            513.0,
            249.0,
            574.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:31.600000",
        "id": 41,
        "className": "Person",
        coords: [
            129.0,
            182.0,
            167.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:31.600000",
        "id": 48,
        "className": "Person",
        coords: [
            204.0,
            194.0,
            249.0,
            305.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:31.700000",
        "id": 45,
        "className": "Person",
        coords: [
            311.0,
            536.0,
            450.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:23:31.700000",
        "id": 23,
        "className": "Person",
        coords: [
            513.0,
            249.0,
            574.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:31.700000",
        "id": 41,
        "className": "Person",
        coords: [
            130.0,
            182.0,
            168.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:31.700000",
        "id": 48,
        "className": "Person",
        coords: [
            204.0,
            194.0,
            250.0,
            307.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:31.800000",
        "id": 45,
        "className": "Person",
        coords: [
            311.0,
            536.0,
            450.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:23:31.800000",
        "id": 47,
        "className": "Person",
        coords: [
            496.0,
            178.0,
            530.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:31.800000",
        "id": 23,
        "className": "Person",
        coords: [
            513.0,
            249.0,
            574.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:31.800000",
        "id": 41,
        "className": "Person",
        coords: [
            131.0,
            182.0,
            169.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:31.900000",
        "id": 48,
        "className": "Person",
        coords: [
            205.0,
            194.0,
            251.0,
            308.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:31.900000",
        "id": 45,
        "className": "Person",
        coords: [
            310.0,
            536.0,
            450.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:23:31.900000",
        "id": 47,
        "className": "Person",
        coords: [
            496.0,
            178.0,
            530.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:31.900000",
        "id": 23,
        "className": "Person",
        coords: [
            513.0,
            249.0,
            574.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:32",
        "id": 41,
        "className": "Person",
        coords: [
            131.0,
            182.0,
            170.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:32",
        "id": 48,
        "className": "Person",
        coords: [
            205.0,
            194.0,
            251.0,
            309.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:32",
        "id": 45,
        "className": "Person",
        coords: [
            310.0,
            536.0,
            451.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:23:32",
        "id": 47,
        "className": "Person",
        coords: [
            496.0,
            178.0,
            530.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:32.100000",
        "id": 23,
        "className": "Person",
        coords: [
            513.0,
            248.0,
            574.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:32.100000",
        "id": 41,
        "className": "Person",
        coords: [
            132.0,
            183.0,
            170.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:32.100000",
        "id": 48,
        "className": "Person",
        coords: [
            205.0,
            194.0,
            251.0,
            309.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:32.100000",
        "id": 45,
        "className": "Person",
        coords: [
            310.0,
            536.0,
            451.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:23:32.200000",
        "id": 23,
        "className": "Person",
        coords: [
            513.0,
            248.0,
            574.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:32.200000",
        "id": 41,
        "className": "Person",
        coords: [
            132.0,
            183.0,
            171.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:32.200000",
        "id": 48,
        "className": "Person",
        coords: [
            205.0,
            194.0,
            251.0,
            310.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:32.200000",
        "id": 45,
        "className": "Person",
        coords: [
            311.0,
            536.0,
            451.0,
            715.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:23:32.300000",
        "id": 23,
        "className": "Person",
        coords: [
            513.0,
            248.0,
            574.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:32.300000",
        "id": 41,
        "className": "Person",
        coords: [
            132.0,
            183.0,
            171.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:32.300000",
        "id": 48,
        "className": "Person",
        coords: [
            205.0,
            194.0,
            251.0,
            310.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:32.300000",
        "id": 45,
        "className": "Person",
        coords: [
            311.0,
            536.0,
            451.0,
            715.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:23:32.400000",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            248.0,
            574.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:32.400000",
        "id": 41,
        "className": "Person",
        coords: [
            132.0,
            183.0,
            171.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:32.400000",
        "id": 48,
        "className": "Person",
        coords: [
            205.0,
            194.0,
            251.0,
            310.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:32.400000",
        "id": 45,
        "className": "Person",
        coords: [
            311.0,
            536.0,
            451.0,
            715.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:23:32.400000",
        "id": 47,
        "className": "Person",
        coords: [
            496.0,
            181.0,
            528.0,
            261.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:32.500000",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            248.0,
            574.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:32.500000",
        "id": 41,
        "className": "Person",
        coords: [
            132.0,
            181.0,
            172.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:32.500000",
        "id": 48,
        "className": "Person",
        coords: [
            206.0,
            195.0,
            252.0,
            309.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:32.500000",
        "id": 45,
        "className": "Person",
        coords: [
            310.0,
            536.0,
            452.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:23:32.500000",
        "id": 47,
        "className": "Person",
        coords: [
            496.0,
            184.0,
            528.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:32.600000",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            248.0,
            574.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:32.600000",
        "id": 41,
        "className": "Person",
        coords: [
            132.0,
            180.0,
            172.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:32.600000",
        "id": 48,
        "className": "Person",
        coords: [
            206.0,
            195.0,
            252.0,
            309.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:32.600000",
        "id": 45,
        "className": "Person",
        coords: [
            310.0,
            536.0,
            452.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:23:32.700000",
        "id": 47,
        "className": "Person",
        coords: [
            496.0,
            181.0,
            528.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:32.700000",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            248.0,
            574.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:32.700000",
        "id": 41,
        "className": "Person",
        coords: [
            131.0,
            179.0,
            171.0,
            260.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:32.700000",
        "id": 48,
        "className": "Person",
        coords: [
            206.0,
            194.0,
            252.0,
            309.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:32.800000",
        "id": 45,
        "className": "Person",
        coords: [
            310.0,
            536.0,
            452.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:23:32.800000",
        "id": 47,
        "className": "Person",
        coords: [
            496.0,
            180.0,
            529.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:32.800000",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            249.0,
            573.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:32.800000",
        "id": 41,
        "className": "Person",
        coords: [
            130.0,
            179.0,
            169.0,
            260.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:32.800000",
        "id": 48,
        "className": "Person",
        coords: [
            206.0,
            194.0,
            252.0,
            309.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:32.900000",
        "id": 45,
        "className": "Person",
        coords: [
            310.0,
            536.0,
            452.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:23:32.900000",
        "id": 47,
        "className": "Person",
        coords: [
            496.0,
            180.0,
            529.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:32.900000",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            249.0,
            573.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:32.900000",
        "id": 41,
        "className": "Person",
        coords: [
            130.0,
            178.0,
            169.0,
            259.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:33",
        "id": 48,
        "className": "Person",
        coords: [
            206.0,
            195.0,
            252.0,
            309.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:33",
        "id": 45,
        "className": "Person",
        coords: [
            310.0,
            536.0,
            453.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:23:33",
        "id": 47,
        "className": "Person",
        coords: [
            497.0,
            180.0,
            529.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:54.200000",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            249.0,
            573.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:54.300000",
        "id": 41,
        "className": "Person",
        coords: [
            129.0,
            179.0,
            168.0,
            260.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:54.300000",
        "id": 48,
        "className": "Person",
        coords: [
            206.0,
            195.0,
            251.0,
            309.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:54.400000",
        "id": 45,
        "className": "Person",
        coords: [
            310.0,
            536.0,
            453.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:23:54.400000",
        "id": 47,
        "className": "Person",
        coords: [
            497.0,
            180.0,
            529.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:54.700000",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            249.0,
            573.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:54.700000",
        "id": 41,
        "className": "Person",
        coords: [
            128.0,
            179.0,
            166.0,
            260.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:54.800000",
        "id": 48,
        "className": "Person",
        coords: [
            205.0,
            194.0,
            251.0,
            310.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:54.800000",
        "id": 45,
        "className": "Person",
        coords: [
            310.0,
            536.0,
            453.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:23:54.900000",
        "id": 47,
        "className": "Person",
        coords: [
            497.0,
            180.0,
            529.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:55",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            249.0,
            573.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:55",
        "id": 41,
        "className": "Person",
        coords: [
            128.0,
            179.0,
            166.0,
            260.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:55",
        "id": 48,
        "className": "Person",
        coords: [
            203.0,
            195.0,
            249.0,
            309.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:55",
        "id": 45,
        "className": "Person",
        coords: [
            309.0,
            536.0,
            453.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:23:55.100000",
        "id": 47,
        "className": "Person",
        coords: [
            497.0,
            180.0,
            528.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:55.200000",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            249.0,
            573.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:55.200000",
        "id": 41,
        "className": "Person",
        coords: [
            128.0,
            179.0,
            165.0,
            260.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:55.200000",
        "id": 48,
        "className": "Person",
        coords: [
            202.0,
            195.0,
            247.0,
            307.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:55.300000",
        "id": 45,
        "className": "Person",
        coords: [
            309.0,
            536.0,
            453.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:23:55.300000",
        "id": 47,
        "className": "Person",
        coords: [
            497.0,
            180.0,
            528.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:55.400000",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            249.0,
            573.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:55.400000",
        "id": 41,
        "className": "Person",
        coords: [
            128.0,
            181.0,
            164.0,
            260.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:55.400000",
        "id": 48,
        "className": "Person",
        coords: [
            201.0,
            195.0,
            244.0,
            305.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:55.500000",
        "id": 45,
        "className": "Person",
        coords: [
            309.0,
            536.0,
            453.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:23:55.500000",
        "id": 47,
        "className": "Person",
        coords: [
            497.0,
            180.0,
            528.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:55.600000",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            249.0,
            573.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:55.600000",
        "id": 41,
        "className": "Person",
        coords: [
            129.0,
            183.0,
            163.0,
            260.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:55.600000",
        "id": 48,
        "className": "Person",
        coords: [
            200.0,
            194.0,
            245.0,
            308.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:55.700000",
        "id": 45,
        "className": "Person",
        coords: [
            309.0,
            535.0,
            453.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:23:55.700000",
        "id": 47,
        "className": "Person",
        coords: [
            498.0,
            180.0,
            529.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:55.800000",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            249.0,
            573.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:55.800000",
        "id": 41,
        "className": "Person",
        coords: [
            128.0,
            183.0,
            162.0,
            260.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:55.800000",
        "id": 48,
        "className": "Person",
        coords: [
            200.0,
            194.0,
            244.0,
            308.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:55.900000",
        "id": 45,
        "className": "Person",
        coords: [
            308.0,
            535.0,
            453.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:23:56",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            249.0,
            573.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:56",
        "id": 41,
        "className": "Person",
        coords: [
            128.0,
            184.0,
            162.0,
            260.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:56",
        "id": 48,
        "className": "Person",
        coords: [
            200.0,
            194.0,
            244.0,
            309.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:56",
        "id": 45,
        "className": "Person",
        coords: [
            308.0,
            535.0,
            453.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:23:56.100000",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            249.0,
            573.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:56.200000",
        "id": 48,
        "className": "Person",
        coords: [
            200.0,
            194.0,
            244.0,
            309.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:56.200000",
        "id": 45,
        "className": "Person",
        coords: [
            308.0,
            535.0,
            453.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:23:56.200000",
        "id": 47,
        "className": "Person",
        coords: [
            497.0,
            180.0,
            528.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:56.300000",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            249.0,
            573.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:56.300000",
        "id": 48,
        "className": "Person",
        coords: [
            200.0,
            195.0,
            244.0,
            308.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:56.400000",
        "id": 45,
        "className": "Person",
        coords: [
            308.0,
            535.0,
            453.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:23:56.400000",
        "id": 47,
        "className": "Person",
        coords: [
            497.0,
            180.0,
            528.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:57",
        "id": 23,
        "className": "Person",
        coords: [
            510.0,
            247.0,
            569.0,
            334.0
        ],
        "status": "Moving",
        "speed": 63.63,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:57",
        "id": 47,
        "className": "Person",
        coords: [
            493.0,
            180.0,
            524.0,
            262.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:57.100000",
        "id": 49,
        "className": "Person",
        coords: [
            283.0,
            332.0,
            372.0,
            493.0
        ],
        "status": "First Seen",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:23:57.100000",
        "id": 50,
        "className": "Person",
        coords: [
            137.0,
            193.0,
            173.0,
            270.0
        ],
        "status": "First Seen",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:23:57.100000",
        "id": 23,
        "className": "Person",
        coords: [
            509.0,
            247.0,
            569.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:57.200000",
        "id": 47,
        "className": "Person",
        coords: [
            493.0,
            180.0,
            524.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:57.200000",
        "id": 49,
        "className": "Person",
        coords: [
            288.0,
            344.0,
            370.0,
            493.0
        ],
        "status": "Moving",
        "speed": 94.86,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:23:57.300000",
        "id": 50,
        "className": "Person",
        coords: [
            137.0,
            193.0,
            173.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:23:57.300000",
        "id": 23,
        "className": "Person",
        coords: [
            510.0,
            247.0,
            568.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:57.300000",
        "id": 47,
        "className": "Person",
        coords: [
            492.0,
            180.0,
            524.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:57.400000",
        "id": 50,
        "className": "Person",
        coords: [
            137.0,
            193.0,
            173.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:23:57.400000",
        "id": 23,
        "className": "Person",
        coords: [
            510.0,
            247.0,
            569.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:57.400000",
        "id": 47,
        "className": "Person",
        coords: [
            492.0,
            179.0,
            524.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:57.500000",
        "id": 50,
        "className": "Person",
        coords: [
            137.0,
            193.0,
            173.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:23:57.500000",
        "id": 23,
        "className": "Person",
        coords: [
            510.0,
            247.0,
            569.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:57.500000",
        "id": 47,
        "className": "Person",
        coords: [
            492.0,
            179.0,
            524.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:57.600000",
        "id": 50,
        "className": "Person",
        coords: [
            137.0,
            192.0,
            173.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:57.600000",
        "id": 23,
        "className": "Person",
        coords: [
            510.0,
            247.0,
            569.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:57.700000",
        "id": 47,
        "className": "Person",
        coords: [
            492.0,
            179.0,
            524.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:57.700000",
        "id": 50,
        "className": "Person",
        coords: [
            137.0,
            192.0,
            173.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:57.800000",
        "id": 23,
        "className": "Person",
        coords: [
            511.0,
            247.0,
            569.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:57.800000",
        "id": 47,
        "className": "Person",
        coords: [
            492.0,
            179.0,
            524.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:57.800000",
        "id": 50,
        "className": "Person",
        coords: [
            137.0,
            192.0,
            173.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:57.900000",
        "id": 23,
        "className": "Person",
        coords: [
            511.0,
            247.0,
            569.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:57.900000",
        "id": 47,
        "className": "Person",
        coords: [
            492.0,
            179.0,
            524.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:57.900000",
        "id": 48,
        "className": "Person",
        coords: [
            202.0,
            200.0,
            247.0,
            314.0
        ],
        "status": "Moving",
        "speed": 94.86,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:58",
        "id": 50,
        "className": "Person",
        coords: [
            137.0,
            192.0,
            173.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:58",
        "id": 23,
        "className": "Person",
        coords: [
            511.0,
            247.0,
            569.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:58",
        "id": 47,
        "className": "Person",
        coords: [
            492.0,
            179.0,
            524.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:58",
        "id": 48,
        "className": "Person",
        coords: [
            203.0,
            201.0,
            248.0,
            314.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:58.100000",
        "id": 50,
        "className": "Person",
        coords: [
            137.0,
            192.0,
            173.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:58.100000",
        "id": 23,
        "className": "Person",
        coords: [
            511.0,
            247.0,
            569.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:58.100000",
        "id": 47,
        "className": "Person",
        coords: [
            492.0,
            179.0,
            524.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:58.100000",
        "id": 48,
        "className": "Person",
        coords: [
            203.0,
            201.0,
            248.0,
            314.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:58.200000",
        "id": 50,
        "className": "Person",
        coords: [
            137.0,
            192.0,
            173.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:58.200000",
        "id": 23,
        "className": "Person",
        coords: [
            511.0,
            247.0,
            569.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:58.200000",
        "id": 47,
        "className": "Person",
        coords: [
            493.0,
            180.0,
            525.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:58.300000",
        "id": 48,
        "className": "Person",
        coords: [
            202.0,
            200.0,
            248.0,
            314.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:58.300000",
        "id": 50,
        "className": "Person",
        coords: [
            137.0,
            191.0,
            173.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:58.400000",
        "id": 23,
        "className": "Person",
        coords: [
            511.0,
            247.0,
            568.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:58.400000",
        "id": 47,
        "className": "Person",
        coords: [
            493.0,
            180.0,
            525.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:58.400000",
        "id": 48,
        "className": "Person",
        coords: [
            201.0,
            199.0,
            248.0,
            314.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:58.400000",
        "id": 50,
        "className": "Person",
        coords: [
            137.0,
            191.0,
            173.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:58.500000",
        "id": 23,
        "className": "Person",
        coords: [
            511.0,
            247.0,
            568.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:58.500000",
        "id": 47,
        "className": "Person",
        coords: [
            493.0,
            180.0,
            525.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:58.500000",
        "id": 48,
        "className": "Person",
        coords: [
            200.0,
            198.0,
            248.0,
            314.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:58.600000",
        "id": 50,
        "className": "Person",
        coords: [
            137.0,
            191.0,
            173.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:58.600000",
        "id": 23,
        "className": "Person",
        coords: [
            511.0,
            247.0,
            568.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:58.600000",
        "id": 47,
        "className": "Person",
        coords: [
            493.0,
            180.0,
            525.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:58.600000",
        "id": 48,
        "className": "Person",
        coords: [
            199.0,
            198.0,
            248.0,
            314.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:58.700000",
        "id": 50,
        "className": "Person",
        coords: [
            137.0,
            192.0,
            173.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:58.700000",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            247.0,
            569.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:58.700000",
        "id": 47,
        "className": "Person",
        coords: [
            492.0,
            180.0,
            525.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:58.700000",
        "id": 48,
        "className": "Person",
        coords: [
            198.0,
            199.0,
            246.0,
            315.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:58.700000",
        "id": 49,
        "className": "Person",
        coords: [
            282.0,
            335.0,
            370.0,
            494.0
        ],
        "status": "Moving",
        "speed": 74.99,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:23:58.800000",
        "id": 50,
        "className": "Person",
        coords: [
            136.0,
            191.0,
            173.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:58.800000",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            246.0,
            570.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:58.800000",
        "id": 47,
        "className": "Person",
        coords: [
            492.0,
            179.0,
            525.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:58.800000",
        "id": 48,
        "className": "Person",
        coords: [
            195.0,
            198.0,
            242.0,
            308.0
        ],
        "status": "Moving",
        "speed": 84.85,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:58.900000",
        "id": 49,
        "className": "Person",
        coords: [
            280.0,
            335.0,
            368.0,
            495.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:23:58.900000",
        "id": 50,
        "className": "Person",
        coords: [
            136.0,
            191.0,
            173.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:58.900000",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            246.0,
            571.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:59",
        "id": 47,
        "className": "Person",
        coords: [
            492.0,
            179.0,
            526.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:59",
        "id": 48,
        "className": "Person",
        coords: [
            195.0,
            199.0,
            241.0,
            306.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:23:59",
        "id": 49,
        "className": "Person",
        coords: [
            279.0,
            336.0,
            366.0,
            495.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:00.200000",
        "id": 50,
        "className": "Person",
        coords: [
            136.0,
            191.0,
            173.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:00.300000",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            246.0,
            571.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:00.300000",
        "id": 47,
        "className": "Person",
        coords: [
            492.0,
            180.0,
            526.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:00.300000",
        "id": 48,
        "className": "Person",
        coords: [
            193.0,
            198.0,
            242.0,
            309.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:00.400000",
        "id": 49,
        "className": "Person",
        coords: [
            279.0,
            336.0,
            366.0,
            495.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:00.400000",
        "id": 45,
        "className": "Person",
        coords: [
            307.0,
            535.0,
            450.0,
            714.0
        ],
        "status": "Moving",
        "speed": 42.42,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:00.700000",
        "id": 50,
        "className": "Person",
        coords: [
            136.0,
            191.0,
            173.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:00.700000",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            246.0,
            570.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:00.700000",
        "id": 47,
        "className": "Person",
        coords: [
            492.0,
            179.0,
            526.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:00.800000",
        "id": 48,
        "className": "Person",
        coords: [
            194.0,
            199.0,
            240.0,
            303.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:00.800000",
        "id": 49,
        "className": "Person",
        coords: [
            279.0,
            337.0,
            365.0,
            495.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:00.800000",
        "id": 45,
        "className": "Person",
        coords: [
            307.0,
            534.0,
            450.0,
            713.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:00.900000",
        "id": 50,
        "className": "Person",
        coords: [
            136.0,
            190.0,
            173.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:00.900000",
        "id": 23,
        "className": "Person",
        coords: [
            511.0,
            245.0,
            570.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:01",
        "id": 47,
        "className": "Person",
        coords: [
            491.0,
            179.0,
            525.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:01",
        "id": 48,
        "className": "Person",
        coords: [
            188.0,
            200.0,
            232.0,
            301.0
        ],
        "status": "Moving",
        "speed": 106.06,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:01",
        "id": 49,
        "className": "Person",
        coords: [
            279.0,
            337.0,
            365.0,
            496.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:01",
        "id": 45,
        "className": "Person",
        coords: [
            307.0,
            533.0,
            451.0,
            713.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:01.100000",
        "id": 50,
        "className": "Person",
        coords: [
            136.0,
            190.0,
            173.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:01.100000",
        "id": 23,
        "className": "Person",
        coords: [
            511.0,
            245.0,
            570.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:01.100000",
        "id": 47,
        "className": "Person",
        coords: [
            492.0,
            179.0,
            526.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:01.200000",
        "id": 48,
        "className": "Person",
        coords: [
            191.0,
            200.0,
            235.0,
            297.0
        ],
        "status": "Moving",
        "speed": 54.08,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:01.200000",
        "id": 49,
        "className": "Person",
        coords: [
            279.0,
            337.0,
            365.0,
            496.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:01.200000",
        "id": 45,
        "className": "Person",
        coords: [
            306.0,
            533.0,
            451.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:01.300000",
        "id": 50,
        "className": "Person",
        coords: [
            136.0,
            190.0,
            173.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:01.300000",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            246.0,
            570.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:01.300000",
        "id": 47,
        "className": "Person",
        coords: [
            491.0,
            179.0,
            526.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:01.300000",
        "id": 49,
        "className": "Person",
        coords: [
            280.0,
            338.0,
            365.0,
            496.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:01.300000",
        "id": 45,
        "className": "Person",
        coords: [
            306.0,
            532.0,
            451.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:01.400000",
        "id": 50,
        "className": "Person",
        coords: [
            136.0,
            190.0,
            173.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:01.400000",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            246.0,
            571.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:01.500000",
        "id": 47,
        "className": "Person",
        coords: [
            491.0,
            179.0,
            526.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:01.500000",
        "id": 49,
        "className": "Person",
        coords: [
            279.0,
            341.0,
            363.0,
            497.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:01.500000",
        "id": 45,
        "className": "Person",
        coords: [
            306.0,
            531.0,
            451.0,
            715.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:01.600000",
        "id": 50,
        "className": "Person",
        coords: [
            136.0,
            190.0,
            173.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:01.600000",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            245.0,
            571.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:01.600000",
        "id": 47,
        "className": "Person",
        coords: [
            491.0,
            180.0,
            526.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:01.600000",
        "id": 49,
        "className": "Person",
        coords: [
            278.0,
            338.0,
            364.0,
            496.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:01.700000",
        "id": 45,
        "className": "Person",
        coords: [
            306.0,
            531.0,
            451.0,
            715.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:01.800000",
        "id": 50,
        "className": "Person",
        coords: [
            136.0,
            190.0,
            173.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:01.800000",
        "id": 23,
        "className": "Person",
        coords: [
            511.0,
            245.0,
            570.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:01.800000",
        "id": 47,
        "className": "Person",
        coords: [
            491.0,
            179.0,
            525.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:01.800000",
        "id": 49,
        "className": "Person",
        coords: [
            277.0,
            337.0,
            363.0,
            497.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:01.900000",
        "id": 45,
        "className": "Person",
        coords: [
            305.0,
            530.0,
            452.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:01.900000",
        "id": 50,
        "className": "Person",
        coords: [
            136.0,
            190.0,
            174.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:02",
        "id": 23,
        "className": "Person",
        coords: [
            511.0,
            246.0,
            570.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:02",
        "id": 47,
        "className": "Person",
        coords: [
            491.0,
            179.0,
            525.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:02",
        "id": 49,
        "className": "Person",
        coords: [
            276.0,
            336.0,
            363.0,
            497.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:02",
        "id": 45,
        "className": "Person",
        coords: [
            306.0,
            530.0,
            453.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:02.100000",
        "id": 50,
        "className": "Person",
        coords: [
            136.0,
            190.0,
            173.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:02.100000",
        "id": 23,
        "className": "Person",
        coords: [
            511.0,
            246.0,
            570.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:02.200000",
        "id": 47,
        "className": "Person",
        coords: [
            490.0,
            180.0,
            525.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:02.200000",
        "id": 45,
        "className": "Person",
        coords: [
            307.0,
            530.0,
            454.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:02.200000",
        "id": 48,
        "className": "Person",
        coords: [
            189.0,
            198.0,
            231.0,
            295.0
        ],
        "status": "Moving",
        "speed": 54.08,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:02.300000",
        "id": 50,
        "className": "Person",
        coords: [
            136.0,
            190.0,
            173.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:02.300000",
        "id": 23,
        "className": "Person",
        coords: [
            511.0,
            245.0,
            570.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:02.300000",
        "id": 47,
        "className": "Person",
        coords: [
            491.0,
            180.0,
            525.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:02.400000",
        "id": 45,
        "className": "Person",
        coords: [
            312.0,
            530.0,
            457.0,
            718.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:02.400000",
        "id": 48,
        "className": "Person",
        coords: [
            187.0,
            198.0,
            229.0,
            296.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:02.400000",
        "id": 49,
        "className": "Person",
        coords: [
            277.0,
            337.0,
            363.0,
            496.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:02.400000",
        "id": 50,
        "className": "Person",
        coords: [
            137.0,
            190.0,
            173.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:02.500000",
        "id": 23,
        "className": "Person",
        coords: [
            511.0,
            245.0,
            570.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:02.500000",
        "id": 47,
        "className": "Person",
        coords: [
            491.0,
            179.0,
            526.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:02.500000",
        "id": 45,
        "className": "Person",
        coords: [
            317.0,
            531.0,
            460.0,
            718.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:02.500000",
        "id": 48,
        "className": "Person",
        coords: [
            187.0,
            198.0,
            227.0,
            295.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:02.600000",
        "id": 49,
        "className": "Person",
        coords: [
            277.0,
            338.0,
            363.0,
            496.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:02.600000",
        "id": 50,
        "className": "Person",
        coords: [
            137.0,
            190.0,
            173.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:02.700000",
        "id": 23,
        "className": "Person",
        coords: [
            511.0,
            245.0,
            570.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:02.700000",
        "id": 47,
        "className": "Person",
        coords: [
            491.0,
            179.0,
            526.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:02.700000",
        "id": 45,
        "className": "Person",
        coords: [
            322.0,
            532.0,
            462.0,
            717.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:02.800000",
        "id": 50,
        "className": "Person",
        coords: [
            137.0,
            192.0,
            173.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:02.800000",
        "id": 23,
        "className": "Person",
        coords: [
            515.0,
            246.0,
            573.0,
            334.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:02.800000",
        "id": 47,
        "className": "Person",
        coords: [
            491.0,
            179.0,
            525.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:02.800000",
        "id": 45,
        "className": "Person",
        coords: [
            326.0,
            533.0,
            463.0,
            717.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:02.800000",
        "id": 49,
        "className": "Person",
        coords: [
            277.0,
            337.0,
            363.0,
            496.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:02.900000",
        "id": 50,
        "className": "Person",
        coords: [
            137.0,
            192.0,
            173.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:02.900000",
        "id": 23,
        "className": "Person",
        coords: [
            514.0,
            246.0,
            573.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:02.900000",
        "id": 47,
        "className": "Person",
        coords: [
            491.0,
            180.0,
            525.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:03",
        "id": 45,
        "className": "Person",
        coords: [
            327.0,
            533.0,
            463.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:03",
        "id": 49,
        "className": "Person",
        coords: [
            277.0,
            338.0,
            362.0,
            496.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:03",
        "id": 50,
        "className": "Person",
        coords: [
            137.0,
            192.0,
            173.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:03.100000",
        "id": 23,
        "className": "Person",
        coords: [
            514.0,
            246.0,
            573.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:03.100000",
        "id": 47,
        "className": "Person",
        coords: [
            491.0,
            180.0,
            525.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:03.100000",
        "id": 45,
        "className": "Person",
        coords: [
            329.0,
            534.0,
            463.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:03.100000",
        "id": 49,
        "className": "Person",
        coords: [
            277.0,
            338.0,
            362.0,
            496.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:03.200000",
        "id": 50,
        "className": "Person",
        coords: [
            137.0,
            192.0,
            173.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:03.200000",
        "id": 23,
        "className": "Person",
        coords: [
            514.0,
            246.0,
            573.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:03.200000",
        "id": 47,
        "className": "Person",
        coords: [
            492.0,
            180.0,
            525.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:03.300000",
        "id": 45,
        "className": "Person",
        coords: [
            329.0,
            534.0,
            462.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:03.300000",
        "id": 49,
        "className": "Person",
        coords: [
            268.0,
            300.0,
            370.0,
            496.0
        ],
        "status": "Moving",
        "speed": 284.98,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:03.400000",
        "id": 50,
        "className": "Person",
        coords: [
            137.0,
            192.0,
            173.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:03.400000",
        "id": 23,
        "className": "Person",
        coords: [
            515.0,
            246.0,
            573.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:03.400000",
        "id": 45,
        "className": "Person",
        coords: [
            329.0,
            534.0,
            461.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:03.400000",
        "id": 49,
        "className": "Person",
        coords: [
            266.0,
            286.0,
            371.0,
            494.0
        ],
        "status": "Moving",
        "speed": 120.92,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:03.500000",
        "id": 50,
        "className": "Person",
        coords: [
            137.0,
            191.0,
            173.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:03.500000",
        "id": 23,
        "className": "Person",
        coords: [
            515.0,
            246.0,
            573.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:03.600000",
        "id": 45,
        "className": "Person",
        coords: [
            329.0,
            534.0,
            461.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:03.600000",
        "id": 49,
        "className": "Person",
        coords: [
            266.0,
            281.0,
            372.0,
            495.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:03.600000",
        "id": 47,
        "className": "Person",
        coords: [
            492.0,
            180.0,
            525.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:03.700000",
        "id": 50,
        "className": "Person",
        coords: [
            137.0,
            191.0,
            173.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:03.700000",
        "id": 23,
        "className": "Person",
        coords: [
            514.0,
            245.0,
            572.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:03.700000",
        "id": 45,
        "className": "Person",
        coords: [
            330.0,
            534.0,
            462.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:03.700000",
        "id": 49,
        "className": "Person",
        coords: [
            267.0,
            279.0,
            371.0,
            495.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:03.700000",
        "id": 47,
        "className": "Person",
        coords: [
            492.0,
            180.0,
            525.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:03.800000",
        "id": 50,
        "className": "Person",
        coords: [
            137.0,
            191.0,
            173.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:03.800000",
        "id": 23,
        "className": "Person",
        coords: [
            513.0,
            245.0,
            571.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:03.900000",
        "id": 45,
        "className": "Person",
        coords: [
            330.0,
            534.0,
            461.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:03.900000",
        "id": 49,
        "className": "Person",
        coords: [
            268.0,
            278.0,
            370.0,
            496.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:03.900000",
        "id": 47,
        "className": "Person",
        coords: [
            493.0,
            180.0,
            525.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:03.900000",
        "id": 50,
        "className": "Person",
        coords: [
            137.0,
            191.0,
            173.0,
            271.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:04",
        "id": 23,
        "className": "Person",
        coords: [
            515.0,
            245.0,
            572.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:04",
        "id": 45,
        "className": "Person",
        coords: [
            327.0,
            534.0,
            458.0,
            718.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:04",
        "id": 49,
        "className": "Person",
        coords: [
            269.0,
            278.0,
            369.0,
            496.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:04",
        "id": 47,
        "className": "Person",
        coords: [
            493.0,
            181.0,
            525.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:04.100000",
        "id": 50,
        "className": "Person",
        coords: [
            137.0,
            192.0,
            172.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:04.100000",
        "id": 23,
        "className": "Person",
        coords: [
            513.0,
            245.0,
            571.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:04.200000",
        "id": 45,
        "className": "Person",
        coords: [
            330.0,
            535.0,
            460.0,
            718.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:04.200000",
        "id": 49,
        "className": "Person",
        coords: [
            277.0,
            316.0,
            361.0,
            497.0
        ],
        "status": "Moving",
        "speed": 284.98,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:04.200000",
        "id": 47,
        "className": "Person",
        coords: [
            493.0,
            181.0,
            525.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:04.300000",
        "id": 23,
        "className": "Person",
        coords: [
            511.0,
            245.0,
            570.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:04.300000",
        "id": 45,
        "className": "Person",
        coords: [
            332.0,
            535.0,
            461.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:04.300000",
        "id": 49,
        "className": "Person",
        coords: [
            280.0,
            331.0,
            358.0,
            497.0
        ],
        "status": "Moving",
        "speed": 119.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:04.300000",
        "id": 47,
        "className": "Person",
        coords: [
            493.0,
            180.0,
            525.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:04.400000",
        "id": 23,
        "className": "Person",
        coords: [
            511.0,
            245.0,
            570.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:04.400000",
        "id": 45,
        "className": "Person",
        coords: [
            333.0,
            535.0,
            461.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:04.400000",
        "id": 49,
        "className": "Person",
        coords: [
            280.0,
            335.0,
            358.0,
            497.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:04.500000",
        "id": 47,
        "className": "Person",
        coords: [
            493.0,
            180.0,
            525.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:04.500000",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            245.0,
            571.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:04.500000",
        "id": 45,
        "className": "Person",
        coords: [
            335.0,
            535.0,
            462.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:04.600000",
        "id": 49,
        "className": "Person",
        coords: [
            280.0,
            337.0,
            357.0,
            498.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:04.600000",
        "id": 47,
        "className": "Person",
        coords: [
            493.0,
            180.0,
            525.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:04.600000",
        "id": 23,
        "className": "Person",
        coords: [
            511.0,
            245.0,
            569.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:04.700000",
        "id": 45,
        "className": "Person",
        coords: [
            337.0,
            534.0,
            463.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:04.700000",
        "id": 49,
        "className": "Person",
        coords: [
            280.0,
            338.0,
            358.0,
            498.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:04.700000",
        "id": 47,
        "className": "Person",
        coords: [
            493.0,
            180.0,
            526.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:04.800000",
        "id": 23,
        "className": "Person",
        coords: [
            511.0,
            245.0,
            570.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:04.800000",
        "id": 45,
        "className": "Person",
        coords: [
            328.0,
            534.0,
            455.0,
            718.0
        ],
        "status": "Moving",
        "speed": 134.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:04.800000",
        "id": 49,
        "className": "Person",
        coords: [
            279.0,
            339.0,
            358.0,
            498.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:04.800000",
        "id": 47,
        "className": "Person",
        coords: [
            494.0,
            180.0,
            526.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:04.900000",
        "id": 23,
        "className": "Person",
        coords: [
            504.0,
            246.0,
            562.0,
            334.0
        ],
        "status": "Moving",
        "speed": 104.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:04.900000",
        "id": 45,
        "className": "Person",
        coords: [
            321.0,
            534.0,
            450.0,
            718.0
        ],
        "status": "Moving",
        "speed": 89.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:05",
        "id": 49,
        "className": "Person",
        coords: [
            278.0,
            339.0,
            358.0,
            500.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:05",
        "id": 47,
        "className": "Person",
        coords: [
            494.0,
            180.0,
            527.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:05",
        "id": 23,
        "className": "Person",
        coords: [
            497.0,
            246.0,
            557.0,
            334.0
        ],
        "status": "Moving",
        "speed": 89.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:05.100000",
        "id": 45,
        "className": "Person",
        coords: [
            317.0,
            533.0,
            448.0,
            718.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:05.100000",
        "id": 49,
        "className": "Person",
        coords: [
            277.0,
            339.0,
            358.0,
            502.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:05.100000",
        "id": 23,
        "className": "Person",
        coords: [
            493.0,
            247.0,
            555.0,
            334.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:05.200000",
        "id": 45,
        "className": "Person",
        coords: [
            316.0,
            533.0,
            448.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:05.200000",
        "id": 49,
        "className": "Person",
        coords: [
            277.0,
            338.0,
            358.0,
            502.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:05.200000",
        "id": 47,
        "className": "Person",
        coords: [
            494.0,
            180.0,
            526.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:05.300000",
        "id": 23,
        "className": "Person",
        coords: [
            490.0,
            247.0,
            555.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:05.300000",
        "id": 45,
        "className": "Person",
        coords: [
            314.0,
            533.0,
            448.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:05.300000",
        "id": 49,
        "className": "Person",
        coords: [
            277.0,
            337.0,
            359.0,
            501.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:05.300000",
        "id": 47,
        "className": "Person",
        coords: [
            494.0,
            180.0,
            526.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:05.400000",
        "id": 45,
        "className": "Person",
        coords: [
            313.0,
            533.0,
            449.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:05.400000",
        "id": 49,
        "className": "Person",
        coords: [
            276.0,
            336.0,
            359.0,
            501.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:05.400000",
        "id": 47,
        "className": "Person",
        coords: [
            493.0,
            180.0,
            525.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:05.500000",
        "id": 45,
        "className": "Person",
        coords: [
            328.0,
            533.0,
            461.0,
            718.0
        ],
        "status": "Moving",
        "speed": 194.98,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:05.500000",
        "id": 49,
        "className": "Person",
        coords: [
            277.0,
            337.0,
            359.0,
            502.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:05.500000",
        "id": 47,
        "className": "Person",
        coords: [
            494.0,
            181.0,
            525.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:05.600000",
        "id": 45,
        "className": "Person",
        coords: [
            334.0,
            533.0,
            464.0,
            718.0
        ],
        "status": "Moving",
        "speed": 74.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:05.600000",
        "id": 49,
        "className": "Person",
        coords: [
            277.0,
            337.0,
            359.0,
            501.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:05.700000",
        "id": 47,
        "className": "Person",
        coords: [
            495.0,
            181.0,
            526.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:05.700000",
        "id": 23,
        "className": "Person",
        coords: [
            503.0,
            247.0,
            567.0,
            334.0
        ],
        "status": "Moving",
        "speed": 194.98,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:06.900000",
        "id": 45,
        "className": "Person",
        coords: [
            321.0,
            533.0,
            451.0,
            715.0
        ],
        "status": "Moving",
        "speed": 195.56,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:07",
        "id": 49,
        "className": "Person",
        coords: [
            276.0,
            336.0,
            359.0,
            501.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:07",
        "id": 47,
        "className": "Person",
        coords: [
            495.0,
            182.0,
            526.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:07.100000",
        "id": 23,
        "className": "Person",
        coords: [
            506.0,
            247.0,
            569.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:07.400000",
        "id": 45,
        "className": "Person",
        coords: [
            315.0,
            533.0,
            447.0,
            716.0
        ],
        "status": "Moving",
        "speed": 74.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:07.500000",
        "id": 49,
        "className": "Person",
        coords: [
            276.0,
            335.0,
            359.0,
            501.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:07.500000",
        "id": 47,
        "className": "Person",
        coords: [
            495.0,
            183.0,
            526.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:07.500000",
        "id": 23,
        "className": "Person",
        coords: [
            509.0,
            247.0,
            570.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:07.600000",
        "id": 49,
        "className": "Person",
        coords: [
            276.0,
            334.0,
            359.0,
            500.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:07.700000",
        "id": 47,
        "className": "Person",
        coords: [
            496.0,
            183.0,
            526.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:07.700000",
        "id": 23,
        "className": "Person",
        coords: [
            512.0,
            247.0,
            572.0,
            334.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:07.800000",
        "id": 49,
        "className": "Person",
        coords: [
            275.0,
            332.0,
            359.0,
            500.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:07.800000",
        "id": 23,
        "className": "Person",
        coords: [
            513.0,
            246.0,
            572.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:07.800000",
        "id": 45,
        "className": "Person",
        coords: [
            331.0,
            533.0,
            460.0,
            716.0
        ],
        "status": "Moving",
        "speed": 209.98,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:07.900000",
        "id": 49,
        "className": "Person",
        coords: [
            275.0,
            331.0,
            359.0,
            499.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:07.900000",
        "id": 23,
        "className": "Person",
        coords: [
            513.0,
            246.0,
            570.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:08",
        "id": 45,
        "className": "Person",
        coords: [
            336.0,
            533.0,
            462.0,
            717.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:08.100000",
        "id": 49,
        "className": "Person",
        coords: [
            275.0,
            330.0,
            359.0,
            499.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:08.100000",
        "id": 23,
        "className": "Person",
        coords: [
            514.0,
            246.0,
            571.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:08.100000",
        "id": 47,
        "className": "Person",
        coords: [
            495.0,
            181.0,
            527.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:08.200000",
        "id": 49,
        "className": "Person",
        coords: [
            275.0,
            330.0,
            359.0,
            499.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:08.200000",
        "id": 23,
        "className": "Person",
        coords: [
            515.0,
            246.0,
            570.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:08.200000",
        "id": 47,
        "className": "Person",
        coords: [
            495.0,
            179.0,
            528.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:08.300000",
        "id": 49,
        "className": "Person",
        coords: [
            275.0,
            331.0,
            359.0,
            499.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:08.300000",
        "id": 23,
        "className": "Person",
        coords: [
            517.0,
            246.0,
            571.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:08.300000",
        "id": 47,
        "className": "Person",
        coords: [
            495.0,
            180.0,
            528.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:08.400000",
        "id": 49,
        "className": "Person",
        coords: [
            276.0,
            331.0,
            359.0,
            497.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:08.400000",
        "id": 23,
        "className": "Person",
        coords: [
            519.0,
            245.0,
            574.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:08.500000",
        "id": 47,
        "className": "Person",
        coords: [
            496.0,
            179.0,
            529.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:08.500000",
        "id": 49,
        "className": "Person",
        coords: [
            276.0,
            331.0,
            359.0,
            496.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:08.600000",
        "id": 23,
        "className": "Person",
        coords: [
            520.0,
            245.0,
            575.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:08.600000",
        "id": 47,
        "className": "Person",
        coords: [
            496.0,
            179.0,
            530.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:08.600000",
        "id": 49,
        "className": "Person",
        coords: [
            276.0,
            331.0,
            359.0,
            495.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:08.700000",
        "id": 23,
        "className": "Person",
        coords: [
            521.0,
            244.0,
            575.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:08.700000",
        "id": 47,
        "className": "Person",
        coords: [
            497.0,
            178.0,
            530.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:08.800000",
        "id": 49,
        "className": "Person",
        coords: [
            276.0,
            332.0,
            359.0,
            495.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:08.800000",
        "id": 23,
        "className": "Person",
        coords: [
            521.0,
            244.0,
            575.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:08.800000",
        "id": 47,
        "className": "Person",
        coords: [
            498.0,
            178.0,
            531.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:08.800000",
        "id": 45,
        "className": "Person",
        coords: [
            316.0,
            533.0,
            445.0,
            717.0
        ],
        "status": "Moving",
        "speed": 284.98,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:08.900000",
        "id": 49,
        "className": "Person",
        coords: [
            277.0,
            332.0,
            358.0,
            493.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:09",
        "id": 23,
        "className": "Person",
        coords: [
            520.0,
            243.0,
            574.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:09",
        "id": 47,
        "className": "Person",
        coords: [
            498.0,
            178.0,
            531.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:09",
        "id": 45,
        "className": "Person",
        coords: [
            314.0,
            533.0,
            445.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:09.100000",
        "id": 49,
        "className": "Person",
        coords: [
            277.0,
            332.0,
            358.0,
            493.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:09.100000",
        "id": 23,
        "className": "Person",
        coords: [
            521.0,
            242.0,
            574.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:09.100000",
        "id": 47,
        "className": "Person",
        coords: [
            498.0,
            179.0,
            530.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:09.100000",
        "id": 45,
        "className": "Person",
        coords: [
            312.0,
            533.0,
            445.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:09.200000",
        "id": 49,
        "className": "Person",
        coords: [
            277.0,
            332.0,
            358.0,
            493.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:09.200000",
        "id": 23,
        "className": "Person",
        coords: [
            522.0,
            241.0,
            575.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:09.300000",
        "id": 47,
        "className": "Person",
        coords: [
            498.0,
            179.0,
            530.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:09.300000",
        "id": 45,
        "className": "Person",
        coords: [
            311.0,
            533.0,
            446.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:09.400000",
        "id": 49,
        "className": "Person",
        coords: [
            276.0,
            332.0,
            358.0,
            491.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:09.400000",
        "id": 23,
        "className": "Person",
        coords: [
            522.0,
            241.0,
            576.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:09.400000",
        "id": 47,
        "className": "Person",
        coords: [
            497.0,
            178.0,
            530.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:09.500000",
        "id": 45,
        "className": "Person",
        coords: [
            311.0,
            533.0,
            447.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:09.600000",
        "id": 49,
        "className": "Person",
        coords: [
            277.0,
            332.0,
            358.0,
            490.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:09.600000",
        "id": 23,
        "className": "Person",
        coords: [
            521.0,
            240.0,
            576.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:09.600000",
        "id": 47,
        "className": "Person",
        coords: [
            496.0,
            178.0,
            529.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:09.600000",
        "id": 45,
        "className": "Person",
        coords: [
            311.0,
            533.0,
            447.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:09.700000",
        "id": 49,
        "className": "Person",
        coords: [
            277.0,
            332.0,
            358.0,
            489.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:09.700000",
        "id": 23,
        "className": "Person",
        coords: [
            523.0,
            238.0,
            579.0,
            338.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:09.700000",
        "id": 47,
        "className": "Person",
        coords: [
            495.0,
            178.0,
            528.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:09.800000",
        "id": 45,
        "className": "Person",
        coords: [
            311.0,
            533.0,
            448.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:09.800000",
        "id": 23,
        "className": "Person",
        coords: [
            524.0,
            237.0,
            580.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:09.900000",
        "id": 47,
        "className": "Person",
        coords: [
            494.0,
            178.0,
            528.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:09.900000",
        "id": 45,
        "className": "Person",
        coords: [
            310.0,
            533.0,
            448.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:10",
        "id": 23,
        "className": "Person",
        coords: [
            525.0,
            234.0,
            581.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:10",
        "id": 47,
        "className": "Person",
        coords: [
            495.0,
            179.0,
            528.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:10.100000",
        "id": 45,
        "className": "Person",
        coords: [
            310.0,
            533.0,
            449.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:10.200000",
        "id": 23,
        "className": "Person",
        coords: [
            526.0,
            232.0,
            582.0,
            337.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:10.200000",
        "id": 47,
        "className": "Person",
        coords: [
            495.0,
            180.0,
            529.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:10.200000",
        "id": 45,
        "className": "Person",
        coords: [
            310.0,
            533.0,
            449.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:10.300000",
        "id": 23,
        "className": "Person",
        coords: [
            527.0,
            232.0,
            583.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:10.300000",
        "id": 47,
        "className": "Person",
        coords: [
            495.0,
            179.0,
            529.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:10.300000",
        "id": 45,
        "className": "Person",
        coords: [
            309.0,
            533.0,
            449.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:10.400000",
        "id": 23,
        "className": "Person",
        coords: [
            529.0,
            231.0,
            584.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:10.500000",
        "id": 47,
        "className": "Person",
        coords: [
            496.0,
            181.0,
            529.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:10.500000",
        "id": 45,
        "className": "Person",
        coords: [
            309.0,
            533.0,
            449.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:10.500000",
        "id": 49,
        "className": "Person",
        coords: [
            277.0,
            285.0,
            375.0,
            479.0
        ],
        "status": "Moving",
        "speed": 441.13,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:10.600000",
        "id": 23,
        "className": "Person",
        coords: [
            530.0,
            231.0,
            584.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:10.600000",
        "id": 47,
        "className": "Person",
        coords: [
            496.0,
            183.0,
            529.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:10.600000",
        "id": 49,
        "className": "Person",
        coords: [
            278.0,
            280.0,
            375.0,
            474.0
        ],
        "status": "Moving",
        "speed": 74.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:10.700000",
        "id": 23,
        "className": "Person",
        coords: [
            531.0,
            231.0,
            585.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:10.700000",
        "id": 47,
        "className": "Person",
        coords: [
            497.0,
            184.0,
            529.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:10.700000",
        "id": 49,
        "className": "Person",
        coords: [
            278.0,
            278.0,
            374.0,
            474.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:10.800000",
        "id": 23,
        "className": "Person",
        coords: [
            531.0,
            231.0,
            583.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:10.800000",
        "id": 47,
        "className": "Person",
        coords: [
            498.0,
            184.0,
            530.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:10.800000",
        "id": 49,
        "className": "Person",
        coords: [
            278.0,
            278.0,
            374.0,
            474.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:12.500000",
        "id": 23,
        "className": "Person",
        coords: [
            530.0,
            231.0,
            582.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:12.500000",
        "id": 47,
        "className": "Person",
        coords: [
            498.0,
            185.0,
            530.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:12.600000",
        "id": 49,
        "className": "Person",
        coords: [
            280.0,
            278.0,
            374.0,
            472.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:12.600000",
        "id": 23,
        "className": "Person",
        coords: [
            530.0,
            232.0,
            581.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:12.700000",
        "id": 47,
        "className": "Person",
        coords: [
            497.0,
            184.0,
            529.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:12.700000",
        "id": 49,
        "className": "Person",
        coords: [
            282.0,
            278.0,
            375.0,
            473.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:12.800000",
        "id": 23,
        "className": "Person",
        coords: [
            530.0,
            232.0,
            581.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:12.800000",
        "id": 47,
        "className": "Person",
        coords: [
            496.0,
            182.0,
            530.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:12.800000",
        "id": 49,
        "className": "Person",
        coords: [
            284.0,
            278.0,
            377.0,
            478.0
        ],
        "status": "Moving",
        "speed": 54.08,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:12.900000",
        "id": 23,
        "className": "Person",
        coords: [
            529.0,
            233.0,
            581.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:12.900000",
        "id": 47,
        "className": "Person",
        coords: [
            496.0,
            181.0,
            530.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:12.900000",
        "id": 49,
        "className": "Person",
        coords: [
            284.0,
            278.0,
            378.0,
            483.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:13",
        "id": 23,
        "className": "Person",
        coords: [
            527.0,
            232.0,
            579.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:13",
        "id": 47,
        "className": "Person",
        coords: [
            496.0,
            180.0,
            529.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:13",
        "id": 49,
        "className": "Person",
        coords: [
            287.0,
            278.0,
            377.0,
            480.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:13.100000",
        "id": 23,
        "className": "Person",
        coords: [
            523.0,
            228.0,
            575.0,
            337.0
        ],
        "status": "Moving",
        "speed": 74.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:13.100000",
        "id": 47,
        "className": "Person",
        coords: [
            495.0,
            180.0,
            529.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:13.100000",
        "id": 49,
        "className": "Person",
        coords: [
            290.0,
            278.0,
            378.0,
            479.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:13.200000",
        "id": 47,
        "className": "Person",
        coords: [
            495.0,
            180.0,
            529.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:13.200000",
        "id": 49,
        "className": "Person",
        coords: [
            292.0,
            279.0,
            379.0,
            480.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:13.300000",
        "id": 47,
        "className": "Person",
        coords: [
            495.0,
            180.0,
            529.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:13.300000",
        "id": 49,
        "className": "Person",
        coords: [
            293.0,
            279.0,
            379.0,
            482.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:13.400000",
        "id": 47,
        "className": "Person",
        coords: [
            495.0,
            180.0,
            529.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:13.400000",
        "id": 49,
        "className": "Person",
        coords: [
            298.0,
            313.0,
            369.0,
            481.0
        ],
        "status": "Moving",
        "speed": 258.92,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:13.500000",
        "id": 47,
        "className": "Person",
        coords: [
            495.0,
            180.0,
            529.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:13.600000",
        "id": 47,
        "className": "Person",
        coords: [
            495.0,
            180.0,
            529.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:13.600000",
        "id": 47,
        "className": "Person",
        coords: [
            495.0,
            180.0,
            529.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:13.700000",
        "id": 49,
        "className": "Person",
        coords: [
            300.0,
            335.0,
            366.0,
            489.0
        ],
        "status": "Moving",
        "speed": 224.98,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:13.700000",
        "id": 47,
        "className": "Person",
        coords: [
            495.0,
            180.0,
            529.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:13.700000",
        "id": 49,
        "className": "Person",
        coords: [
            302.0,
            335.0,
            369.0,
            492.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:13.800000",
        "id": 47,
        "className": "Person",
        coords: [
            495.0,
            180.0,
            528.0,
            259.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:13.900000",
        "id": 49,
        "className": "Person",
        coords: [
            301.0,
            335.0,
            369.0,
            495.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:14",
        "id": 49,
        "className": "Person",
        coords: [
            300.0,
            335.0,
            371.0,
            502.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:14",
        "id": 49,
        "className": "Person",
        coords: [
            291.0,
            334.0,
            363.0,
            500.0
        ],
        "status": "Moving",
        "speed": 120.92,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:14.100000",
        "id": 49,
        "className": "Person",
        coords: [
            288.0,
            334.0,
            360.0,
            497.0
        ],
        "status": "Moving",
        "speed": 54.08,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:14.300000",
        "id": 49,
        "className": "Person",
        coords: [
            294.0,
            293.0,
            377.0,
            487.0
        ],
        "status": "Moving",
        "speed": 409.66,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:14.300000",
        "id": 49,
        "className": "Person",
        coords: [
            296.0,
            284.0,
            381.0,
            485.0
        ],
        "status": "Moving",
        "speed": 100.61,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:14.400000",
        "id": 49,
        "className": "Person",
        coords: [
            298.0,
            281.0,
            383.0,
            484.0
        ],
        "status": "Moving",
        "speed": 42.42,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:14.400000",
        "id": 47,
        "className": "Person",
        coords: [
            496.0,
            182.0,
            528.0,
            255.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:14.500000",
        "id": 49,
        "className": "Person",
        coords: [
            301.0,
            280.0,
            386.0,
            485.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:14.500000",
        "id": 47,
        "className": "Person",
        coords: [
            495.0,
            181.0,
            528.0,
            255.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:14.600000",
        "id": 49,
        "className": "Person",
        coords: [
            304.0,
            280.0,
            388.0,
            485.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:14.600000",
        "id": 47,
        "className": "Person",
        coords: [
            496.0,
            181.0,
            529.0,
            256.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:14.700000",
        "id": 49,
        "className": "Person",
        coords: [
            306.0,
            281.0,
            391.0,
            485.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:14.700000",
        "id": 47,
        "className": "Person",
        coords: [
            495.0,
            181.0,
            529.0,
            257.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:14.800000",
        "id": 49,
        "className": "Person",
        coords: [
            307.0,
            282.0,
            392.0,
            482.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:14.800000",
        "id": 47,
        "className": "Person",
        coords: [
            495.0,
            181.0,
            529.0,
            257.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:14.900000",
        "id": 49,
        "className": "Person",
        coords: [
            316.0,
            282.0,
            391.0,
            456.0
        ],
        "status": "Moving",
        "speed": 204.01,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:15",
        "id": 47,
        "className": "Person",
        coords: [
            494.0,
            181.0,
            529.0,
            260.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:15",
        "id": 49,
        "className": "Person",
        coords: [
            320.0,
            283.0,
            389.0,
            435.0
        ],
        "status": "Moving",
        "speed": 150.74,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:15.100000",
        "id": 47,
        "className": "Person",
        coords: [
            493.0,
            180.0,
            529.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:15.100000",
        "id": 47,
        "className": "Person",
        coords: [
            493.0,
            180.0,
            529.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:15.200000",
        "id": 47,
        "className": "Person",
        coords: [
            492.0,
            180.0,
            529.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:15.200000",
        "id": 47,
        "className": "Person",
        coords: [
            492.0,
            180.0,
            530.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:15.300000",
        "id": 47,
        "className": "Person",
        coords: [
            492.0,
            180.0,
            530.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:15.400000",
        "id": 47,
        "className": "Person",
        coords: [
            492.0,
            180.0,
            530.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:15.400000",
        "id": 47,
        "className": "Person",
        coords: [
            492.0,
            180.0,
            530.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:15.500000",
        "id": 47,
        "className": "Person",
        coords: [
            493.0,
            181.0,
            530.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:15.500000",
        "id": 47,
        "className": "Person",
        coords: [
            493.0,
            181.0,
            530.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:15.600000",
        "id": 47,
        "className": "Person",
        coords: [
            492.0,
            181.0,
            530.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:15.700000",
        "id": 47,
        "className": "Person",
        coords: [
            492.0,
            181.0,
            530.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:15.700000",
        "id": 47,
        "className": "Person",
        coords: [
            492.0,
            181.0,
            530.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:15.800000",
        "id": 47,
        "className": "Person",
        coords: [
            492.0,
            182.0,
            530.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:15.800000",
        "id": 47,
        "className": "Person",
        coords: [
            492.0,
            181.0,
            530.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:15.900000",
        "id": 47,
        "className": "Person",
        coords: [
            492.0,
            181.0,
            530.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:15.900000",
        "id": 47,
        "className": "Person",
        coords: [
            492.0,
            181.0,
            530.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:16",
        "id": 47,
        "className": "Person",
        coords: [
            492.0,
            181.0,
            530.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:16",
        "id": 47,
        "className": "Person",
        coords: [
            493.0,
            181.0,
            531.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:16.100000",
        "id": 47,
        "className": "Person",
        coords: [
            494.0,
            181.0,
            531.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:16.100000",
        "id": 47,
        "className": "Person",
        coords: [
            493.0,
            181.0,
            530.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:16.200000",
        "id": 47,
        "className": "Person",
        coords: [
            490.0,
            178.0,
            529.0,
            262.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:18.100000",
        "id": 47,
        "className": "Person",
        coords: [
            487.0,
            177.0,
            528.0,
            262.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:18.200000",
        "id": 51,
        "className": "Person",
        coords: [
            302.0,
            285.0,
            394.0,
            488.0
        ],
        "status": "First Seen",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:24:18.900000",
        "id": 47,
        "className": "Person",
        coords: [
            486.0,
            174.0,
            528.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:18.900000",
        "id": 51,
        "className": "Person",
        coords: [
            302.0,
            285.0,
            394.0,
            489.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:24:19",
        "id": 51,
        "className": "Person",
        coords: [
            305.0,
            285.0,
            396.0,
            488.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:24:19.100000",
        "id": 51,
        "className": "Person",
        coords: [
            306.0,
            285.0,
            397.0,
            487.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:24:19.100000",
        "id": 47,
        "className": "Person",
        coords: [
            488.0,
            177.0,
            528.0,
            261.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:19.200000",
        "id": 51,
        "className": "Person",
        coords: [
            307.0,
            285.0,
            398.0,
            489.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:24:19.300000",
        "id": 47,
        "className": "Person",
        coords: [
            490.0,
            177.0,
            530.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:19.300000",
        "id": 51,
        "className": "Person",
        coords: [
            307.0,
            285.0,
            397.0,
            489.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:24:19.400000",
        "id": 47,
        "className": "Person",
        coords: [
            492.0,
            181.0,
            530.0,
            261.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:19.400000",
        "id": 51,
        "className": "Person",
        coords: [
            307.0,
            285.0,
            397.0,
            487.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:24:19.400000",
        "id": 47,
        "className": "Person",
        coords: [
            493.0,
            180.0,
            531.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:20",
        "id": 45,
        "className": "Person",
        coords: [
            327.0,
            537.0,
            466.0,
            718.0
        ],
        "status": "Moving",
        "speed": 256.74,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:20",
        "id": 51,
        "className": "Person",
        coords: [
            294.0,
            292.0,
            378.0,
            480.0
        ],
        "status": "Moving",
        "speed": 239.98,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:24:20",
        "id": 47,
        "className": "Person",
        coords: [
            489.0,
            181.0,
            526.0,
            262.0
        ],
        "status": "Moving",
        "speed": 74.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:20.100000",
        "id": 52,
        "className": "Person",
        coords: [
            507.0,
            245.0,
            566.0,
            331.0
        ],
        "status": "First Seen",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:24:20.100000",
        "id": 45,
        "className": "Person",
        coords: [
            327.0,
            537.0,
            468.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:20.100000",
        "id": 51,
        "className": "Person",
        coords: [
            293.0,
            293.0,
            378.0,
            482.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:20.100000",
        "id": 47,
        "className": "Person",
        coords: [
            489.0,
            180.0,
            525.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:20.200000",
        "id": 52,
        "className": "Person",
        coords: [
            507.0,
            245.0,
            566.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:24:20.200000",
        "id": 45,
        "className": "Person",
        coords: [
            327.0,
            537.0,
            470.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:20.200000",
        "id": 51,
        "className": "Person",
        coords: [
            294.0,
            293.0,
            377.0,
            475.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:20.300000",
        "id": 47,
        "className": "Person",
        coords: [
            489.0,
            180.0,
            525.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:20.300000",
        "id": 52,
        "className": "Person",
        coords: [
            507.0,
            245.0,
            566.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:24:20.400000",
        "id": 45,
        "className": "Person",
        coords: [
            330.0,
            537.0,
            473.0,
            718.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:20.400000",
        "id": 51,
        "className": "Person",
        coords: [
            294.0,
            293.0,
            377.0,
            474.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:20.400000",
        "id": 47,
        "className": "Person",
        coords: [
            490.0,
            180.0,
            524.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:20.500000",
        "id": 52,
        "className": "Person",
        coords: [
            507.0,
            245.0,
            566.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:24:20.500000",
        "id": 45,
        "className": "Person",
        coords: [
            330.0,
            537.0,
            475.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:20.500000",
        "id": 51,
        "className": "Person",
        coords: [
            294.0,
            293.0,
            377.0,
            473.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:20.500000",
        "id": 47,
        "className": "Person",
        coords: [
            490.0,
            180.0,
            524.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:20.600000",
        "id": 52,
        "className": "Person",
        coords: [
            506.0,
            245.0,
            565.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:20.600000",
        "id": 45,
        "className": "Person",
        coords: [
            331.0,
            537.0,
            476.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:20.700000",
        "id": 51,
        "className": "Person",
        coords: [
            295.0,
            293.0,
            376.0,
            466.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:20.700000",
        "id": 47,
        "className": "Person",
        coords: [
            490.0,
            180.0,
            524.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:20.700000",
        "id": 52,
        "className": "Person",
        coords: [
            506.0,
            245.0,
            565.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:20.800000",
        "id": 45,
        "className": "Person",
        coords: [
            331.0,
            537.0,
            477.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:20.800000",
        "id": 51,
        "className": "Person",
        coords: [
            295.0,
            293.0,
            376.0,
            465.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:20.800000",
        "id": 47,
        "className": "Person",
        coords: [
            490.0,
            180.0,
            523.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:20.900000",
        "id": 52,
        "className": "Person",
        coords: [
            506.0,
            245.0,
            565.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:20.900000",
        "id": 45,
        "className": "Person",
        coords: [
            331.0,
            537.0,
            478.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:20.900000",
        "id": 51,
        "className": "Person",
        coords: [
            296.0,
            293.0,
            376.0,
            463.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:20.900000",
        "id": 47,
        "className": "Person",
        coords: [
            490.0,
            180.0,
            523.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:21",
        "id": 52,
        "className": "Person",
        coords: [
            506.0,
            245.0,
            566.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:21.100000",
        "id": 45,
        "className": "Person",
        coords: [
            330.0,
            536.0,
            478.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:21.100000",
        "id": 51,
        "className": "Person",
        coords: [
            296.0,
            293.0,
            376.0,
            462.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:21.100000",
        "id": 47,
        "className": "Person",
        coords: [
            490.0,
            180.0,
            523.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:21.200000",
        "id": 52,
        "className": "Person",
        coords: [
            506.0,
            245.0,
            566.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:21.200000",
        "id": 45,
        "className": "Person",
        coords: [
            330.0,
            536.0,
            480.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:21.200000",
        "id": 51,
        "className": "Person",
        coords: [
            293.0,
            293.0,
            378.0,
            472.0
        ],
        "status": "Moving",
        "speed": 76.48,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:21.200000",
        "id": 47,
        "className": "Person",
        coords: [
            491.0,
            180.0,
            523.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:21.300000",
        "id": 52,
        "className": "Person",
        coords: [
            506.0,
            245.0,
            566.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:21.400000",
        "id": 45,
        "className": "Person",
        coords: [
            328.0,
            536.0,
            480.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:21.400000",
        "id": 51,
        "className": "Person",
        coords: [
            294.0,
            293.0,
            378.0,
            468.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:21.400000",
        "id": 47,
        "className": "Person",
        coords: [
            491.0,
            180.0,
            523.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:21.500000",
        "id": 52,
        "className": "Person",
        coords: [
            506.0,
            245.0,
            566.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:21.500000",
        "id": 45,
        "className": "Person",
        coords: [
            325.0,
            536.0,
            478.0,
            718.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:21.500000",
        "id": 51,
        "className": "Person",
        coords: [
            293.0,
            293.0,
            379.0,
            473.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:21.500000",
        "id": 47,
        "className": "Person",
        coords: [
            491.0,
            180.0,
            523.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:21.600000",
        "id": 52,
        "className": "Person",
        coords: [
            506.0,
            245.0,
            566.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:21.600000",
        "id": 45,
        "className": "Person",
        coords: [
            323.0,
            536.0,
            478.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:21.700000",
        "id": 51,
        "className": "Person",
        coords: [
            293.0,
            293.0,
            379.0,
            474.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:21.700000",
        "id": 47,
        "className": "Person",
        coords: [
            491.0,
            180.0,
            523.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:21.700000",
        "id": 52,
        "className": "Person",
        coords: [
            506.0,
            245.0,
            566.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:21.800000",
        "id": 45,
        "className": "Person",
        coords: [
            330.0,
            536.0,
            483.0,
            718.0
        ],
        "status": "Moving",
        "speed": 89.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:21.800000",
        "id": 51,
        "className": "Person",
        coords: [
            293.0,
            293.0,
            379.0,
            473.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:21.800000",
        "id": 47,
        "className": "Person",
        coords: [
            491.0,
            180.0,
            522.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:21.900000",
        "id": 52,
        "className": "Person",
        coords: [
            506.0,
            245.0,
            566.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:21.900000",
        "id": 45,
        "className": "Person",
        coords: [
            330.0,
            536.0,
            483.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:21.900000",
        "id": 51,
        "className": "Person",
        coords: [
            295.0,
            293.0,
            377.0,
            465.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:22",
        "id": 47,
        "className": "Person",
        coords: [
            491.0,
            180.0,
            522.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:22",
        "id": 52,
        "className": "Person",
        coords: [
            506.0,
            245.0,
            566.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:22.100000",
        "id": 45,
        "className": "Person",
        coords: [
            335.0,
            537.0,
            484.0,
            715.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:22.100000",
        "id": 51,
        "className": "Person",
        coords: [
            292.0,
            293.0,
            379.0,
            474.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:22.100000",
        "id": 47,
        "className": "Person",
        coords: [
            492.0,
            183.0,
            522.0,
            262.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:22.200000",
        "id": 52,
        "className": "Person",
        coords: [
            506.0,
            245.0,
            566.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:22.200000",
        "id": 45,
        "className": "Person",
        coords: [
            337.0,
            537.0,
            484.0,
            715.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:22.200000",
        "id": 51,
        "className": "Person",
        coords: [
            292.0,
            293.0,
            380.0,
            478.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:22.200000",
        "id": 47,
        "className": "Person",
        coords: [
            493.0,
            184.0,
            522.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:22.300000",
        "id": 52,
        "className": "Person",
        coords: [
            506.0,
            245.0,
            566.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:22.300000",
        "id": 45,
        "className": "Person",
        coords: [
            338.0,
            537.0,
            484.0,
            715.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:22.300000",
        "id": 51,
        "className": "Person",
        coords: [
            291.0,
            293.0,
            380.0,
            479.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:22.400000",
        "id": 47,
        "className": "Person",
        coords: [
            493.0,
            184.0,
            522.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:22.400000",
        "id": 52,
        "className": "Person",
        coords: [
            506.0,
            245.0,
            566.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:22.500000",
        "id": 45,
        "className": "Person",
        coords: [
            339.0,
            537.0,
            485.0,
            715.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:22.500000",
        "id": 51,
        "className": "Person",
        coords: [
            291.0,
            293.0,
            380.0,
            480.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:22.500000",
        "id": 47,
        "className": "Person",
        coords: [
            493.0,
            184.0,
            522.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:22.600000",
        "id": 52,
        "className": "Person",
        coords: [
            507.0,
            245.0,
            566.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:22.600000",
        "id": 45,
        "className": "Person",
        coords: [
            341.0,
            537.0,
            483.0,
            711.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:22.600000",
        "id": 51,
        "className": "Person",
        coords: [
            288.0,
            293.0,
            379.0,
            484.0
        ],
        "status": "Moving",
        "speed": 42.42,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:22.700000",
        "id": 47,
        "className": "Person",
        coords: [
            493.0,
            185.0,
            522.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:22.700000",
        "id": 52,
        "className": "Person",
        coords: [
            506.0,
            245.0,
            566.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:22.800000",
        "id": 45,
        "className": "Person",
        coords: [
            339.0,
            536.0,
            482.0,
            713.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:22.800000",
        "id": 51,
        "className": "Person",
        coords: [
            302.0,
            292.0,
            383.0,
            465.0
        ],
        "status": "Moving",
        "speed": 201.79,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:22.800000",
        "id": 47,
        "className": "Person",
        coords: [
            493.0,
            185.0,
            522.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:22.900000",
        "id": 52,
        "className": "Person",
        coords: [
            506.0,
            245.0,
            565.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:22.900000",
        "id": 45,
        "className": "Person",
        coords: [
            337.0,
            536.0,
            479.0,
            714.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:22.900000",
        "id": 51,
        "className": "Person",
        coords: [
            308.0,
            291.0,
            385.0,
            457.0
        ],
        "status": "Moving",
        "speed": 84.85,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:22.900000",
        "id": 47,
        "className": "Person",
        coords: [
            494.0,
            185.0,
            523.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:23",
        "id": 52,
        "className": "Person",
        coords: [
            506.0,
            245.0,
            565.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:23",
        "id": 45,
        "className": "Person",
        coords: [
            334.0,
            536.0,
            476.0,
            715.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:23",
        "id": 51,
        "className": "Person",
        coords: [
            311.0,
            291.0,
            385.0,
            454.0
        ],
        "status": "Moving",
        "speed": 42.42,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:23.100000",
        "id": 52,
        "className": "Person",
        coords: [
            506.0,
            245.0,
            565.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:23.100000",
        "id": 51,
        "className": "Person",
        coords: [
            310.0,
            291.0,
            383.0,
            452.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:25.500000",
        "id": 52,
        "className": "Person",
        coords: [
            506.0,
            245.0,
            566.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:25.500000",
        "id": 51,
        "className": "Person",
        coords: [
            307.0,
            292.0,
            380.0,
            451.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:25.600000",
        "id": 47,
        "className": "Person",
        coords: [
            495.0,
            185.0,
            524.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:25.700000",
        "id": 45,
        "className": "Person",
        coords: [
            329.0,
            536.0,
            471.0,
            716.0
        ],
        "status": "Moving",
        "speed": 76.48,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:26.100000",
        "id": 52,
        "className": "Person",
        coords: [
            506.0,
            245.0,
            566.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:26.100000",
        "id": 51,
        "className": "Person",
        coords: [
            295.0,
            292.0,
            378.0,
            472.0
        ],
        "status": "Moving",
        "speed": 195.56,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:26.200000",
        "id": 47,
        "className": "Person",
        coords: [
            495.0,
            185.0,
            525.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:26.300000",
        "id": 52,
        "className": "Person",
        coords: [
            506.0,
            245.0,
            566.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:26.300000",
        "id": 51,
        "className": "Person",
        coords: [
            291.0,
            292.0,
            378.0,
            481.0
        ],
        "status": "Moving",
        "speed": 67.08,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:26.300000",
        "id": 47,
        "className": "Person",
        coords: [
            494.0,
            183.0,
            526.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:26.400000",
        "id": 45,
        "className": "Person",
        coords: [
            333.0,
            536.0,
            472.0,
            715.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:26.500000",
        "id": 52,
        "className": "Person",
        coords: [
            506.0,
            245.0,
            566.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:26.500000",
        "id": 51,
        "className": "Person",
        coords: [
            290.0,
            292.0,
            379.0,
            485.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:26.500000",
        "id": 47,
        "className": "Person",
        coords: [
            494.0,
            183.0,
            526.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:26.600000",
        "id": 52,
        "className": "Person",
        coords: [
            506.0,
            245.0,
            566.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:26.600000",
        "id": 51,
        "className": "Person",
        coords: [
            291.0,
            291.0,
            374.0,
            465.0
        ],
        "status": "Moving",
        "speed": 152.96,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:26.700000",
        "id": 47,
        "className": "Person",
        coords: [
            494.0,
            185.0,
            525.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:26.700000",
        "id": 45,
        "className": "Person",
        coords: [
            337.0,
            536.0,
            472.0,
            714.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:26.800000",
        "id": 52,
        "className": "Person",
        coords: [
            506.0,
            245.0,
            566.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:26.800000",
        "id": 51,
        "className": "Person",
        coords: [
            282.0,
            291.0,
            373.0,
            480.0
        ],
        "status": "Moving",
        "speed": 129.02,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:26.800000",
        "id": 47,
        "className": "Person",
        coords: [
            495.0,
            186.0,
            526.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:26.900000",
        "id": 45,
        "className": "Person",
        coords: [
            337.0,
            536.0,
            473.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:26.900000",
        "id": 52,
        "className": "Person",
        coords: [
            508.0,
            245.0,
            567.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:27",
        "id": 51,
        "className": "Person",
        coords: [
            289.0,
            291.0,
            374.0,
            462.0
        ],
        "status": "Moving",
        "speed": 147.72,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:27",
        "id": 47,
        "className": "Person",
        coords: [
            495.0,
            182.0,
            527.0,
            263.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:27",
        "id": 45,
        "className": "Person",
        coords: [
            338.0,
            537.0,
            471.0,
            711.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:27.100000",
        "id": 52,
        "className": "Person",
        coords: [
            508.0,
            245.0,
            568.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:27.100000",
        "id": 51,
        "className": "Person",
        coords: [
            290.0,
            291.0,
            373.0,
            455.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:27.100000",
        "id": 47,
        "className": "Person",
        coords: [
            495.0,
            181.0,
            527.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:27.200000",
        "id": 45,
        "className": "Person",
        coords: [
            339.0,
            537.0,
            470.0,
            710.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:27.300000",
        "id": 52,
        "className": "Person",
        coords: [
            509.0,
            245.0,
            568.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:27.300000",
        "id": 51,
        "className": "Person",
        coords: [
            293.0,
            291.0,
            376.0,
            452.0
        ],
        "status": "Moving",
        "speed": 54.08,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:27.300000",
        "id": 47,
        "className": "Person",
        coords: [
            495.0,
            180.0,
            527.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:27.400000",
        "id": 45,
        "className": "Person",
        coords: [
            340.0,
            537.0,
            469.0,
            706.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:27.500000",
        "id": 52,
        "className": "Person",
        coords: [
            509.0,
            245.0,
            567.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:27.500000",
        "id": 51,
        "className": "Person",
        coords: [
            295.0,
            291.0,
            377.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:27.500000",
        "id": 47,
        "className": "Person",
        coords: [
            496.0,
            180.0,
            528.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:27.600000",
        "id": 45,
        "className": "Person",
        coords: [
            339.0,
            537.0,
            469.0,
            707.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:27.600000",
        "id": 52,
        "className": "Person",
        coords: [
            509.0,
            246.0,
            567.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:27.700000",
        "id": 51,
        "className": "Person",
        coords: [
            296.0,
            290.0,
            379.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:27.700000",
        "id": 47,
        "className": "Person",
        coords: [
            496.0,
            181.0,
            528.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:27.700000",
        "id": 45,
        "className": "Person",
        coords: [
            338.0,
            537.0,
            469.0,
            709.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:27.800000",
        "id": 52,
        "className": "Person",
        coords: [
            509.0,
            245.0,
            567.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:27.800000",
        "id": 51,
        "className": "Person",
        coords: [
            297.0,
            290.0,
            379.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:27.900000",
        "id": 47,
        "className": "Person",
        coords: [
            496.0,
            181.0,
            528.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:27.900000",
        "id": 45,
        "className": "Person",
        coords: [
            336.0,
            537.0,
            471.0,
            713.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:28",
        "id": 52,
        "className": "Person",
        coords: [
            509.0,
            245.0,
            566.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:28",
        "id": 51,
        "className": "Person",
        coords: [
            298.0,
            290.0,
            381.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:28",
        "id": 47,
        "className": "Person",
        coords: [
            496.0,
            182.0,
            527.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:28.100000",
        "id": 45,
        "className": "Person",
        coords: [
            335.0,
            537.0,
            470.0,
            713.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:28.100000",
        "id": 52,
        "className": "Person",
        coords: [
            508.0,
            246.0,
            566.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:28.100000",
        "id": 51,
        "className": "Person",
        coords: [
            299.0,
            290.0,
            381.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:28.200000",
        "id": 47,
        "className": "Person",
        coords: [
            495.0,
            182.0,
            527.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:28.200000",
        "id": 45,
        "className": "Person",
        coords: [
            334.0,
            537.0,
            469.0,
            713.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:28.300000",
        "id": 52,
        "className": "Person",
        coords: [
            509.0,
            246.0,
            566.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:28.300000",
        "id": 51,
        "className": "Person",
        coords: [
            299.0,
            290.0,
            381.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:28.300000",
        "id": 45,
        "className": "Person",
        coords: [
            333.0,
            537.0,
            468.0,
            712.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:28.400000",
        "id": 52,
        "className": "Person",
        coords: [
            509.0,
            246.0,
            566.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:28.400000",
        "id": 51,
        "className": "Person",
        coords: [
            300.0,
            290.0,
            382.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:28.500000",
        "id": 45,
        "className": "Person",
        coords: [
            332.0,
            537.0,
            468.0,
            713.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:28.600000",
        "id": 52,
        "className": "Person",
        coords: [
            509.0,
            246.0,
            566.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:28.600000",
        "id": 51,
        "className": "Person",
        coords: [
            301.0,
            290.0,
            382.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:28.600000",
        "id": 45,
        "className": "Person",
        coords: [
            332.0,
            537.0,
            467.0,
            711.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:28.600000",
        "id": 47,
        "className": "Person",
        coords: [
            495.0,
            180.0,
            526.0,
            260.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:28.700000",
        "id": 52,
        "className": "Person",
        coords: [
            509.0,
            245.0,
            566.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:28.700000",
        "id": 51,
        "className": "Person",
        coords: [
            302.0,
            290.0,
            382.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:28.800000",
        "id": 45,
        "className": "Person",
        coords: [
            333.0,
            537.0,
            467.0,
            708.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:28.800000",
        "id": 47,
        "className": "Person",
        coords: [
            495.0,
            180.0,
            525.0,
            260.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:28.900000",
        "id": 52,
        "className": "Person",
        coords: [
            509.0,
            245.0,
            566.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:28.900000",
        "id": 51,
        "className": "Person",
        coords: [
            302.0,
            289.0,
            383.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:28.900000",
        "id": 45,
        "className": "Person",
        coords: [
            328.0,
            537.0,
            464.0,
            709.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:28.900000",
        "id": 47,
        "className": "Person",
        coords: [
            496.0,
            180.0,
            528.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:29",
        "id": 52,
        "className": "Person",
        coords: [
            509.0,
            245.0,
            566.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:29.100000",
        "id": 51,
        "className": "Person",
        coords: [
            303.0,
            289.0,
            383.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:29.100000",
        "id": 45,
        "className": "Person",
        coords: [
            326.0,
            537.0,
            464.0,
            709.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:29.100000",
        "id": 47,
        "className": "Person",
        coords: [
            497.0,
            179.0,
            529.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:29.200000",
        "id": 52,
        "className": "Person",
        coords: [
            509.0,
            245.0,
            566.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:29.200000",
        "id": 51,
        "className": "Person",
        coords: [
            304.0,
            289.0,
            383.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:29.300000",
        "id": 45,
        "className": "Person",
        coords: [
            325.0,
            537.0,
            465.0,
            710.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:29.300000",
        "id": 52,
        "className": "Person",
        coords: [
            509.0,
            245.0,
            566.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:29.400000",
        "id": 51,
        "className": "Person",
        coords: [
            304.0,
            289.0,
            383.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:29.400000",
        "id": 45,
        "className": "Person",
        coords: [
            325.0,
            536.0,
            467.0,
            713.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:29.400000",
        "id": 47,
        "className": "Person",
        coords: [
            494.0,
            177.0,
            528.0,
            262.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:29.500000",
        "id": 52,
        "className": "Person",
        coords: [
            509.0,
            245.0,
            566.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:29.500000",
        "id": 51,
        "className": "Person",
        coords: [
            305.0,
            290.0,
            384.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:29.500000",
        "id": 45,
        "className": "Person",
        coords: [
            325.0,
            536.0,
            469.0,
            715.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:29.500000",
        "id": 47,
        "className": "Person",
        coords: [
            493.0,
            175.0,
            527.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:29.600000",
        "id": 52,
        "className": "Person",
        coords: [
            508.0,
            245.0,
            566.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:29.600000",
        "id": 51,
        "className": "Person",
        coords: [
            306.0,
            290.0,
            384.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:29.600000",
        "id": 45,
        "className": "Person",
        coords: [
            326.0,
            536.0,
            470.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:29.600000",
        "id": 47,
        "className": "Person",
        coords: [
            493.0,
            175.0,
            527.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:29.700000",
        "id": 52,
        "className": "Person",
        coords: [
            509.0,
            245.0,
            566.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:29.700000",
        "id": 51,
        "className": "Person",
        coords: [
            306.0,
            290.0,
            384.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:29.800000",
        "id": 45,
        "className": "Person",
        coords: [
            326.0,
            536.0,
            470.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:29.800000",
        "id": 52,
        "className": "Person",
        coords: [
            509.0,
            245.0,
            566.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:29.900000",
        "id": 51,
        "className": "Person",
        coords: [
            308.0,
            290.0,
            384.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:29.900000",
        "id": 45,
        "className": "Person",
        coords: [
            325.0,
            536.0,
            470.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:29.900000",
        "id": 47,
        "className": "Person",
        coords: [
            492.0,
            178.0,
            526.0,
            262.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:30",
        "id": 52,
        "className": "Person",
        coords: [
            509.0,
            246.0,
            566.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:30",
        "id": 51,
        "className": "Person",
        coords: [
            308.0,
            290.0,
            384.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:30",
        "id": 45,
        "className": "Person",
        coords: [
            324.0,
            536.0,
            468.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:30.100000",
        "id": 52,
        "className": "Person",
        coords: [
            509.0,
            246.0,
            566.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:30.100000",
        "id": 51,
        "className": "Person",
        coords: [
            309.0,
            290.0,
            384.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:30.200000",
        "id": 45,
        "className": "Person",
        coords: [
            324.0,
            536.0,
            467.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:30.200000",
        "id": 47,
        "className": "Person",
        coords: [
            493.0,
            179.0,
            527.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:30.300000",
        "id": 52,
        "className": "Person",
        coords: [
            509.0,
            246.0,
            566.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:30.300000",
        "id": 51,
        "className": "Person",
        coords: [
            310.0,
            290.0,
            385.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:30.300000",
        "id": 45,
        "className": "Person",
        coords: [
            323.0,
            536.0,
            466.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:30.300000",
        "id": 47,
        "className": "Person",
        coords: [
            495.0,
            180.0,
            530.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:30.400000",
        "id": 52,
        "className": "Person",
        coords: [
            509.0,
            246.0,
            566.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:30.400000",
        "id": 51,
        "className": "Person",
        coords: [
            311.0,
            290.0,
            385.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:30.500000",
        "id": 45,
        "className": "Person",
        coords: [
            323.0,
            536.0,
            465.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:30.500000",
        "id": 47,
        "className": "Person",
        coords: [
            497.0,
            179.0,
            532.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:31.700000",
        "id": 52,
        "className": "Person",
        coords: [
            509.0,
            246.0,
            566.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:31.700000",
        "id": 51,
        "className": "Person",
        coords: [
            311.0,
            290.0,
            385.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:32.500000",
        "id": 45,
        "className": "Person",
        coords: [
            319.0,
            536.0,
            462.0,
            718.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:32.500000",
        "id": 47,
        "className": "Person",
        coords: [
            497.0,
            179.0,
            533.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:33.200000",
        "id": 52,
        "className": "Person",
        coords: [
            509.0,
            246.0,
            566.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:33.300000",
        "id": 51,
        "className": "Person",
        coords: [
            312.0,
            290.0,
            385.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:33.300000",
        "id": 45,
        "className": "Person",
        coords: [
            323.0,
            536.0,
            465.0,
            718.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:33.400000",
        "id": 47,
        "className": "Person",
        coords: [
            498.0,
            179.0,
            533.0,
            260.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:33.400000",
        "id": 52,
        "className": "Person",
        coords: [
            509.0,
            246.0,
            566.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:33.500000",
        "id": 51,
        "className": "Person",
        coords: [
            312.0,
            290.0,
            385.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:33.500000",
        "id": 45,
        "className": "Person",
        coords: [
            325.0,
            536.0,
            467.0,
            717.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:33.500000",
        "id": 47,
        "className": "Person",
        coords: [
            498.0,
            178.0,
            534.0,
            260.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:33.600000",
        "id": 52,
        "className": "Person",
        coords: [
            509.0,
            246.0,
            566.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:33.600000",
        "id": 51,
        "className": "Person",
        coords: [
            312.0,
            290.0,
            385.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:33.700000",
        "id": 45,
        "className": "Person",
        coords: [
            326.0,
            536.0,
            468.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:33.700000",
        "id": 47,
        "className": "Person",
        coords: [
            498.0,
            178.0,
            533.0,
            260.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:33.700000",
        "id": 52,
        "className": "Person",
        coords: [
            509.0,
            246.0,
            566.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:33.800000",
        "id": 51,
        "className": "Person",
        coords: [
            313.0,
            290.0,
            386.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:33.800000",
        "id": 45,
        "className": "Person",
        coords: [
            329.0,
            536.0,
            471.0,
            717.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:33.800000",
        "id": 47,
        "className": "Person",
        coords: [
            498.0,
            178.0,
            533.0,
            260.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:33.900000",
        "id": 52,
        "className": "Person",
        coords: [
            509.0,
            246.0,
            566.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:33.900000",
        "id": 51,
        "className": "Person",
        coords: [
            313.0,
            290.0,
            386.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:34",
        "id": 45,
        "className": "Person",
        coords: [
            329.0,
            536.0,
            470.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:34",
        "id": 47,
        "className": "Person",
        coords: [
            497.0,
            178.0,
            533.0,
            260.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:34.100000",
        "id": 52,
        "className": "Person",
        coords: [
            509.0,
            246.0,
            567.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:34.100000",
        "id": 51,
        "className": "Person",
        coords: [
            314.0,
            290.0,
            386.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:34.100000",
        "id": 45,
        "className": "Person",
        coords: [
            331.0,
            537.0,
            469.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:34.200000",
        "id": 47,
        "className": "Person",
        coords: [
            496.0,
            178.0,
            531.0,
            260.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:34.300000",
        "id": 52,
        "className": "Person",
        coords: [
            509.0,
            246.0,
            567.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:34.300000",
        "id": 51,
        "className": "Person",
        coords: [
            314.0,
            290.0,
            386.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:34.300000",
        "id": 45,
        "className": "Person",
        coords: [
            332.0,
            537.0,
            468.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:34.300000",
        "id": 47,
        "className": "Person",
        coords: [
            496.0,
            179.0,
            531.0,
            260.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:34.400000",
        "id": 53,
        "className": "Person",
        coords: [
            31.0,
            219.0,
            77.0,
            355.0
        ],
        "status": "First Seen",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:24:34.400000",
        "id": 52,
        "className": "Person",
        coords: [
            510.0,
            246.0,
            567.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:34.500000",
        "id": 51,
        "className": "Person",
        coords: [
            315.0,
            290.0,
            386.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:34.500000",
        "id": 45,
        "className": "Person",
        coords: [
            332.0,
            537.0,
            467.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:34.600000",
        "id": 47,
        "className": "Person",
        coords: [
            495.0,
            179.0,
            531.0,
            260.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:34.600000",
        "id": 53,
        "className": "Person",
        coords: [
            31.0,
            218.0,
            77.0,
            355.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:24:34.700000",
        "id": 52,
        "className": "Person",
        coords: [
            509.0,
            246.0,
            567.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:34.700000",
        "id": 51,
        "className": "Person",
        coords: [
            315.0,
            291.0,
            386.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:34.700000",
        "id": 45,
        "className": "Person",
        coords: [
            332.0,
            537.0,
            466.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:34.700000",
        "id": 47,
        "className": "Person",
        coords: [
            495.0,
            179.0,
            530.0,
            260.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:34.800000",
        "id": 53,
        "className": "Person",
        coords: [
            31.0,
            219.0,
            77.0,
            355.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:24:34.900000",
        "id": 52,
        "className": "Person",
        coords: [
            509.0,
            246.0,
            566.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:34.900000",
        "id": 51,
        "className": "Person",
        coords: [
            315.0,
            291.0,
            386.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:34.900000",
        "id": 45,
        "className": "Person",
        coords: [
            326.0,
            537.0,
            461.0,
            716.0
        ],
        "status": "Moving",
        "speed": 89.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:34.900000",
        "id": 47,
        "className": "Person",
        coords: [
            495.0,
            179.0,
            530.0,
            260.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:35",
        "id": 53,
        "className": "Person",
        coords: [
            31.0,
            219.0,
            77.0,
            355.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:24:35",
        "id": 52,
        "className": "Person",
        coords: [
            509.0,
            246.0,
            567.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:35.100000",
        "id": 51,
        "className": "Person",
        coords: [
            315.0,
            291.0,
            386.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:35.100000",
        "id": 45,
        "className": "Person",
        coords: [
            325.0,
            537.0,
            460.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:35.100000",
        "id": 47,
        "className": "Person",
        coords: [
            495.0,
            179.0,
            531.0,
            260.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:35.100000",
        "id": 53,
        "className": "Person",
        coords: [
            31.0,
            219.0,
            77.0,
            355.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:35.200000",
        "id": 52,
        "className": "Person",
        coords: [
            509.0,
            246.0,
            567.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:35.200000",
        "id": 51,
        "className": "Person",
        coords: [
            315.0,
            290.0,
            385.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:35.300000",
        "id": 45,
        "className": "Person",
        coords: [
            329.0,
            538.0,
            463.0,
            717.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:35.300000",
        "id": 47,
        "className": "Person",
        coords: [
            495.0,
            179.0,
            531.0,
            260.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:35.300000",
        "id": 53,
        "className": "Person",
        coords: [
            31.0,
            219.0,
            77.0,
            355.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:35.400000",
        "id": 52,
        "className": "Person",
        coords: [
            509.0,
            246.0,
            567.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:35.400000",
        "id": 51,
        "className": "Person",
        coords: [
            315.0,
            290.0,
            385.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:35.400000",
        "id": 45,
        "className": "Person",
        coords: [
            335.0,
            537.0,
            467.0,
            717.0
        ],
        "status": "Moving",
        "speed": 74.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:35.400000",
        "id": 47,
        "className": "Person",
        coords: [
            495.0,
            179.0,
            531.0,
            260.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:35.500000",
        "id": 53,
        "className": "Person",
        coords: [
            31.0,
            218.0,
            77.0,
            355.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:35.500000",
        "id": 52,
        "className": "Person",
        coords: [
            509.0,
            246.0,
            566.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:35.500000",
        "id": 51,
        "className": "Person",
        coords: [
            315.0,
            291.0,
            385.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:35.500000",
        "id": 45,
        "className": "Person",
        coords: [
            340.0,
            537.0,
            470.0,
            716.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:35.600000",
        "id": 47,
        "className": "Person",
        coords: [
            496.0,
            179.0,
            531.0,
            260.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:35.600000",
        "id": 53,
        "className": "Person",
        coords: [
            31.0,
            218.0,
            77.0,
            355.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:35.600000",
        "id": 52,
        "className": "Person",
        coords: [
            509.0,
            246.0,
            566.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:35.700000",
        "id": 51,
        "className": "Person",
        coords: [
            315.0,
            291.0,
            385.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:35.700000",
        "id": 45,
        "className": "Person",
        coords: [
            344.0,
            537.0,
            471.0,
            715.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:35.700000",
        "id": 47,
        "className": "Person",
        coords: [
            496.0,
            179.0,
            532.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:35.700000",
        "id": 53,
        "className": "Person",
        coords: [
            31.0,
            218.0,
            77.0,
            355.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:35.800000",
        "id": 52,
        "className": "Person",
        coords: [
            509.0,
            246.0,
            566.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:35.800000",
        "id": 51,
        "className": "Person",
        coords: [
            315.0,
            291.0,
            385.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:35.800000",
        "id": 45,
        "className": "Person",
        coords: [
            350.0,
            537.0,
            466.0,
            699.0
        ],
        "status": "Moving",
        "speed": 120.92,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:35.900000",
        "id": 47,
        "className": "Person",
        coords: [
            497.0,
            179.0,
            532.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:35.900000",
        "id": 53,
        "className": "Person",
        coords: [
            31.0,
            218.0,
            77.0,
            355.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:35.900000",
        "id": 52,
        "className": "Person",
        coords: [
            509.0,
            246.0,
            566.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:35.900000",
        "id": 51,
        "className": "Person",
        coords: [
            315.0,
            291.0,
            385.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:36",
        "id": 45,
        "className": "Person",
        coords: [
            347.0,
            537.0,
            460.0,
            695.0
        ],
        "status": "Moving",
        "speed": 80.77,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:36",
        "id": 47,
        "className": "Person",
        coords: [
            497.0,
            179.0,
            532.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:36",
        "id": 53,
        "className": "Person",
        coords: [
            31.0,
            218.0,
            77.0,
            355.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:36.100000",
        "id": 52,
        "className": "Person",
        coords: [
            509.0,
            250.0,
            566.0,
            333.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:36.100000",
        "id": 51,
        "className": "Person",
        coords: [
            312.0,
            291.0,
            386.0,
            464.0
        ],
        "status": "Moving",
        "speed": 91.23,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:36.100000",
        "id": 45,
        "className": "Person",
        coords: [
            332.0,
            537.0,
            454.0,
            705.0
        ],
        "status": "Moving",
        "speed": 167.69,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:36.100000",
        "id": 53,
        "className": "Person",
        coords: [
            30.0,
            214.0,
            78.0,
            356.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:36.200000",
        "id": 52,
        "className": "Person",
        coords: [
            509.0,
            252.0,
            566.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:36.200000",
        "id": 51,
        "className": "Person",
        coords: [
            309.0,
            291.0,
            388.0,
            477.0
        ],
        "status": "Moving",
        "speed": 106.06,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:36.200000",
        "id": 45,
        "className": "Person",
        coords: [
            328.0,
            538.0,
            456.0,
            712.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:36.200000",
        "id": 53,
        "className": "Person",
        coords: [
            30.0,
            214.0,
            78.0,
            356.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:36.300000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            812.0,
            263.0
        ],
        "status": "First Seen",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:24:36.300000",
        "id": 52,
        "className": "Person",
        coords: [
            509.0,
            252.0,
            567.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:36.300000",
        "id": 51,
        "className": "Person",
        coords: [
            309.0,
            291.0,
            388.0,
            483.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:36.400000",
        "id": 45,
        "className": "Person",
        coords: [
            327.0,
            538.0,
            457.0,
            715.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:36.400000",
        "id": 53,
        "className": "Person",
        coords: [
            30.0,
            216.0,
            77.0,
            356.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:36.400000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            812.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:24:36.500000",
        "id": 52,
        "className": "Person",
        coords: [
            509.0,
            252.0,
            567.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:36.500000",
        "id": 51,
        "className": "Person",
        coords: [
            309.0,
            291.0,
            388.0,
            485.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:36.500000",
        "id": 45,
        "className": "Person",
        coords: [
            326.0,
            538.0,
            457.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:36.500000",
        "id": 53,
        "className": "Person",
        coords: [
            30.0,
            214.0,
            77.0,
            355.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:36.600000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            812.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:24:36.600000",
        "id": 52,
        "className": "Person",
        coords: [
            508.0,
            253.0,
            567.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:36.600000",
        "id": 51,
        "className": "Person",
        coords: [
            313.0,
            290.0,
            384.0,
            465.0
        ],
        "status": "Moving",
        "speed": 164.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:36.700000",
        "id": 45,
        "className": "Person",
        coords: [
            331.0,
            538.0,
            462.0,
            717.0
        ],
        "status": "Moving",
        "speed": 74.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:36.700000",
        "id": 53,
        "className": "Person",
        coords: [
            30.0,
            215.0,
            77.0,
            356.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:36.700000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            812.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:24:36.800000",
        "id": 52,
        "className": "Person",
        coords: [
            509.0,
            253.0,
            568.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:36.800000",
        "id": 51,
        "className": "Person",
        coords: [
            315.0,
            290.0,
            383.0,
            457.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:36.800000",
        "id": 45,
        "className": "Person",
        coords: [
            334.0,
            538.0,
            463.0,
            715.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:36.800000",
        "id": 53,
        "className": "Person",
        coords: [
            30.0,
            212.0,
            78.0,
            356.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:36.800000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            812.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:36.900000",
        "id": 52,
        "className": "Person",
        coords: [
            509.0,
            254.0,
            569.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:36.900000",
        "id": 51,
        "className": "Person",
        coords: [
            315.0,
            290.0,
            382.0,
            454.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:37",
        "id": 45,
        "className": "Person",
        coords: [
            336.0,
            538.0,
            463.0,
            714.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:37",
        "id": 53,
        "className": "Person",
        coords: [
            31.0,
            210.0,
            79.0,
            357.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:37",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            812.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:37.100000",
        "id": 52,
        "className": "Person",
        coords: [
            509.0,
            254.0,
            569.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:37.100000",
        "id": 51,
        "className": "Person",
        coords: [
            315.0,
            290.0,
            381.0,
            453.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:37.100000",
        "id": 45,
        "className": "Person",
        coords: [
            337.0,
            538.0,
            463.0,
            713.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:37.100000",
        "id": 53,
        "className": "Person",
        coords: [
            31.0,
            211.0,
            80.0,
            357.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:37.100000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            812.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:37.200000",
        "id": 52,
        "className": "Person",
        coords: [
            508.0,
            254.0,
            569.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:37.200000",
        "id": 51,
        "className": "Person",
        coords: [
            314.0,
            290.0,
            381.0,
            453.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:37.200000",
        "id": 45,
        "className": "Person",
        coords: [
            338.0,
            538.0,
            464.0,
            713.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:37.200000",
        "id": 53,
        "className": "Person",
        coords: [
            31.0,
            211.0,
            80.0,
            357.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:37.300000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            812.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:37.300000",
        "id": 52,
        "className": "Person",
        coords: [
            509.0,
            255.0,
            570.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:37.300000",
        "id": 51,
        "className": "Person",
        coords: [
            314.0,
            290.0,
            381.0,
            453.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:37.400000",
        "id": 45,
        "className": "Person",
        coords: [
            339.0,
            538.0,
            465.0,
            714.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:37.400000",
        "id": 53,
        "className": "Person",
        coords: [
            31.0,
            211.0,
            80.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:37.400000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            812.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:37.500000",
        "id": 52,
        "className": "Person",
        coords: [
            509.0,
            255.0,
            571.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:37.500000",
        "id": 51,
        "className": "Person",
        coords: [
            311.0,
            290.0,
            385.0,
            474.0
        ],
        "status": "Moving",
        "speed": 165.67,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:37.500000",
        "id": 45,
        "className": "Person",
        coords: [
            339.0,
            538.0,
            465.0,
            715.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:37.600000",
        "id": 53,
        "className": "Person",
        coords: [
            32.0,
            211.0,
            81.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:37.600000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            812.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:39.300000",
        "id": 52,
        "className": "Person",
        coords: [
            509.0,
            256.0,
            571.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:39.300000",
        "id": 51,
        "className": "Person",
        coords: [
            311.0,
            291.0,
            386.0,
            480.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:39.400000",
        "id": 45,
        "className": "Person",
        coords: [
            340.0,
            538.0,
            466.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:39.400000",
        "id": 53,
        "className": "Person",
        coords: [
            32.0,
            210.0,
            82.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:39.400000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            812.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:39.500000",
        "id": 52,
        "className": "Person",
        coords: [
            509.0,
            256.0,
            572.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:39.500000",
        "id": 51,
        "className": "Person",
        coords: [
            311.0,
            291.0,
            386.0,
            483.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:39.600000",
        "id": 45,
        "className": "Person",
        coords: [
            340.0,
            538.0,
            467.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:39.600000",
        "id": 53,
        "className": "Person",
        coords: [
            32.0,
            210.0,
            82.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:39.600000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            812.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:39.700000",
        "id": 52,
        "className": "Person",
        coords: [
            510.0,
            256.0,
            572.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:39.700000",
        "id": 51,
        "className": "Person",
        coords: [
            311.0,
            291.0,
            385.0,
            483.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:39.700000",
        "id": 45,
        "className": "Person",
        coords: [
            340.0,
            538.0,
            467.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:39.800000",
        "id": 53,
        "className": "Person",
        coords: [
            32.0,
            210.0,
            82.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:39.800000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            812.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:39.900000",
        "id": 52,
        "className": "Person",
        coords: [
            509.0,
            256.0,
            572.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:39.900000",
        "id": 51,
        "className": "Person",
        coords: [
            311.0,
            290.0,
            385.0,
            485.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:39.900000",
        "id": 45,
        "className": "Person",
        coords: [
            340.0,
            538.0,
            467.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:40",
        "id": 53,
        "className": "Person",
        coords: [
            32.0,
            210.0,
            82.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:40",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            812.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:40",
        "id": 52,
        "className": "Person",
        coords: [
            511.0,
            257.0,
            572.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:40.100000",
        "id": 51,
        "className": "Person",
        coords: [
            311.0,
            290.0,
            385.0,
            485.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:40.100000",
        "id": 45,
        "className": "Person",
        coords: [
            340.0,
            538.0,
            467.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:40.100000",
        "id": 53,
        "className": "Person",
        coords: [
            32.0,
            214.0,
            80.0,
            356.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:40.100000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            812.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:40.200000",
        "id": 52,
        "className": "Person",
        coords: [
            511.0,
            257.0,
            572.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:40.200000",
        "id": 51,
        "className": "Person",
        coords: [
            312.0,
            290.0,
            385.0,
            486.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:40.200000",
        "id": 45,
        "className": "Person",
        coords: [
            340.0,
            538.0,
            467.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:40.300000",
        "id": 53,
        "className": "Person",
        coords: [
            32.0,
            217.0,
            79.0,
            357.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:40.300000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:40.400000",
        "id": 52,
        "className": "Person",
        coords: [
            511.0,
            257.0,
            573.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:40.400000",
        "id": 51,
        "className": "Person",
        coords: [
            312.0,
            290.0,
            385.0,
            486.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:40.400000",
        "id": 45,
        "className": "Person",
        coords: [
            340.0,
            538.0,
            466.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:40.400000",
        "id": 53,
        "className": "Person",
        coords: [
            32.0,
            218.0,
            79.0,
            357.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:40.500000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:40.500000",
        "id": 52,
        "className": "Person",
        coords: [
            511.0,
            257.0,
            574.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:40.600000",
        "id": 51,
        "className": "Person",
        coords: [
            312.0,
            290.0,
            385.0,
            486.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:40.600000",
        "id": 45,
        "className": "Person",
        coords: [
            340.0,
            538.0,
            466.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:40.600000",
        "id": 53,
        "className": "Person",
        coords: [
            32.0,
            218.0,
            79.0,
            357.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:40.600000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:40.700000",
        "id": 52,
        "className": "Person",
        coords: [
            510.0,
            257.0,
            574.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:40.700000",
        "id": 51,
        "className": "Person",
        coords: [
            313.0,
            290.0,
            385.0,
            486.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:40.700000",
        "id": 45,
        "className": "Person",
        coords: [
            340.0,
            538.0,
            466.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:40.800000",
        "id": 53,
        "className": "Person",
        coords: [
            32.0,
            217.0,
            79.0,
            357.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:40.800000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            193.0,
            812.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:40.900000",
        "id": 52,
        "className": "Person",
        coords: [
            510.0,
            256.0,
            575.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:40.900000",
        "id": 51,
        "className": "Person",
        coords: [
            313.0,
            290.0,
            385.0,
            486.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:40.900000",
        "id": 45,
        "className": "Person",
        coords: [
            340.0,
            538.0,
            466.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:40.900000",
        "id": 53,
        "className": "Person",
        coords: [
            32.0,
            218.0,
            79.0,
            356.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:41",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            193.0,
            812.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:41",
        "id": 47,
        "className": "Person",
        coords: [
            491.0,
            181.0,
            525.0,
            263.0
        ],
        "status": "Moving",
        "speed": 94.86,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:41",
        "id": 52,
        "className": "Person",
        coords: [
            510.0,
            254.0,
            576.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:41.100000",
        "id": 51,
        "className": "Person",
        coords: [
            313.0,
            290.0,
            385.0,
            487.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:41.100000",
        "id": 45,
        "className": "Person",
        coords: [
            339.0,
            538.0,
            466.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:41.100000",
        "id": 53,
        "className": "Person",
        coords: [
            31.0,
            214.0,
            79.0,
            357.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:41.100000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            812.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:41.100000",
        "id": 47,
        "className": "Person",
        coords: [
            492.0,
            181.0,
            525.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:41.200000",
        "id": 52,
        "className": "Person",
        coords: [
            510.0,
            254.0,
            576.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:41.200000",
        "id": 51,
        "className": "Person",
        coords: [
            314.0,
            290.0,
            384.0,
            486.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:41.300000",
        "id": 45,
        "className": "Person",
        coords: [
            339.0,
            538.0,
            466.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:41.300000",
        "id": 53,
        "className": "Person",
        coords: [
            31.0,
            215.0,
            79.0,
            357.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:41.300000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            191.0,
            812.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:41.300000",
        "id": 47,
        "className": "Person",
        coords: [
            492.0,
            181.0,
            525.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:41.400000",
        "id": 52,
        "className": "Person",
        coords: [
            510.0,
            253.0,
            578.0,
            336.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:41.400000",
        "id": 51,
        "className": "Person",
        coords: [
            314.0,
            290.0,
            384.0,
            486.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:41.400000",
        "id": 45,
        "className": "Person",
        coords: [
            339.0,
            538.0,
            466.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:41.500000",
        "id": 53,
        "className": "Person",
        coords: [
            31.0,
            213.0,
            79.0,
            357.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:41.500000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            191.0,
            812.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:41.500000",
        "id": 47,
        "className": "Person",
        coords: [
            493.0,
            181.0,
            525.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:41.600000",
        "id": 52,
        "className": "Person",
        coords: [
            510.0,
            252.0,
            578.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:41.600000",
        "id": 51,
        "className": "Person",
        coords: [
            314.0,
            290.0,
            384.0,
            486.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:41.600000",
        "id": 45,
        "className": "Person",
        coords: [
            340.0,
            538.0,
            466.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:41.600000",
        "id": 53,
        "className": "Person",
        coords: [
            31.0,
            213.0,
            80.0,
            357.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:41.700000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            191.0,
            812.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:41.700000",
        "id": 47,
        "className": "Person",
        coords: [
            493.0,
            181.0,
            525.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:41.800000",
        "id": 52,
        "className": "Person",
        coords: [
            509.0,
            251.0,
            578.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:41.800000",
        "id": 51,
        "className": "Person",
        coords: [
            314.0,
            290.0,
            384.0,
            486.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:41.800000",
        "id": 45,
        "className": "Person",
        coords: [
            340.0,
            538.0,
            465.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:41.800000",
        "id": 53,
        "className": "Person",
        coords: [
            31.0,
            211.0,
            80.0,
            357.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:41.800000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            191.0,
            812.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:41.900000",
        "id": 47,
        "className": "Person",
        coords: [
            493.0,
            181.0,
            526.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:41.900000",
        "id": 52,
        "className": "Person",
        coords: [
            508.0,
            249.0,
            578.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:41.900000",
        "id": 51,
        "className": "Person",
        coords: [
            314.0,
            290.0,
            384.0,
            486.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:42",
        "id": 45,
        "className": "Person",
        coords: [
            340.0,
            538.0,
            465.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:42",
        "id": 53,
        "className": "Person",
        coords: [
            30.0,
            211.0,
            79.0,
            356.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:42",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            191.0,
            812.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:42",
        "id": 47,
        "className": "Person",
        coords: [
            494.0,
            182.0,
            526.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:42.100000",
        "id": 52,
        "className": "Person",
        coords: [
            508.0,
            248.0,
            579.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:42.100000",
        "id": 51,
        "className": "Person",
        coords: [
            315.0,
            290.0,
            384.0,
            486.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:42.100000",
        "id": 45,
        "className": "Person",
        coords: [
            340.0,
            538.0,
            465.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:42.100000",
        "id": 53,
        "className": "Person",
        coords: [
            30.0,
            211.0,
            79.0,
            356.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:42.200000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            191.0,
            812.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:42.200000",
        "id": 47,
        "className": "Person",
        coords: [
            494.0,
            182.0,
            526.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:42.200000",
        "id": 52,
        "className": "Person",
        coords: [
            507.0,
            247.0,
            579.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:42.200000",
        "id": 51,
        "className": "Person",
        coords: [
            315.0,
            290.0,
            384.0,
            486.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:42.300000",
        "id": 45,
        "className": "Person",
        coords: [
            340.0,
            538.0,
            465.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:42.300000",
        "id": 53,
        "className": "Person",
        coords: [
            30.0,
            211.0,
            79.0,
            356.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:42.300000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            191.0,
            812.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:42.300000",
        "id": 47,
        "className": "Person",
        coords: [
            494.0,
            181.0,
            526.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:42.400000",
        "id": 52,
        "className": "Person",
        coords: [
            507.0,
            246.0,
            579.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:42.400000",
        "id": 51,
        "className": "Person",
        coords: [
            315.0,
            290.0,
            384.0,
            486.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:42.500000",
        "id": 45,
        "className": "Person",
        coords: [
            340.0,
            538.0,
            465.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:42.500000",
        "id": 53,
        "className": "Person",
        coords: [
            30.0,
            211.0,
            79.0,
            356.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:42.500000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            191.0,
            812.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:42.500000",
        "id": 47,
        "className": "Person",
        coords: [
            495.0,
            182.0,
            526.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:42.600000",
        "id": 52,
        "className": "Person",
        coords: [
            505.0,
            245.0,
            578.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:42.700000",
        "id": 51,
        "className": "Person",
        coords: [
            316.0,
            291.0,
            384.0,
            488.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:42.700000",
        "id": 45,
        "className": "Person",
        coords: [
            340.0,
            537.0,
            466.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:42.700000",
        "id": 53,
        "className": "Person",
        coords: [
            31.0,
            212.0,
            80.0,
            356.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:42.800000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            191.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:42.800000",
        "id": 47,
        "className": "Person",
        coords: [
            495.0,
            180.0,
            527.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:42.900000",
        "id": 52,
        "className": "Person",
        coords: [
            504.0,
            245.0,
            577.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:42.900000",
        "id": 51,
        "className": "Person",
        coords: [
            317.0,
            291.0,
            385.0,
            488.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:42.900000",
        "id": 45,
        "className": "Person",
        coords: [
            340.0,
            537.0,
            466.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:43",
        "id": 53,
        "className": "Person",
        coords: [
            30.0,
            213.0,
            79.0,
            356.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:43",
        "id": 54,
        "className": "Person",
        coords: [
            771.0,
            191.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:43",
        "id": 47,
        "className": "Person",
        coords: [
            496.0,
            180.0,
            527.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:43",
        "id": 55,
        "className": "Person",
        coords: [
            136.0,
            166.0,
            172.0,
            264.0
        ],
        "status": "First Seen",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:24:43.100000",
        "id": 52,
        "className": "Person",
        coords: [
            503.0,
            245.0,
            576.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:43.200000",
        "id": 51,
        "className": "Person",
        coords: [
            320.0,
            290.0,
            381.0,
            465.0
        ],
        "status": "Moving",
        "speed": 180.61,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:43.200000",
        "id": 45,
        "className": "Person",
        coords: [
            340.0,
            537.0,
            466.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:43.200000",
        "id": 53,
        "className": "Person",
        coords: [
            30.0,
            215.0,
            78.0,
            355.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:43.200000",
        "id": 54,
        "className": "Person",
        coords: [
            771.0,
            192.0,
            811.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:43.200000",
        "id": 47,
        "className": "Person",
        coords: [
            496.0,
            180.0,
            527.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:43.300000",
        "id": 55,
        "className": "Person",
        coords: [
            137.0,
            167.0,
            172.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:24:44.900000",
        "id": 52,
        "className": "Person",
        coords: [
            503.0,
            244.0,
            575.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:45",
        "id": 51,
        "className": "Person",
        coords: [
            321.0,
            290.0,
            379.0,
            456.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:45",
        "id": 45,
        "className": "Person",
        coords: [
            340.0,
            537.0,
            466.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:45",
        "id": 53,
        "className": "Person",
        coords: [
            30.0,
            216.0,
            78.0,
            355.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:45",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:45.100000",
        "id": 47,
        "className": "Person",
        coords: [
            496.0,
            180.0,
            527.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:45.100000",
        "id": 55,
        "className": "Person",
        coords: [
            137.0,
            167.0,
            172.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:24:45.600000",
        "id": 52,
        "className": "Person",
        coords: [
            503.0,
            244.0,
            575.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:45.600000",
        "id": 51,
        "className": "Person",
        coords: [
            321.0,
            290.0,
            378.0,
            453.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:45.600000",
        "id": 45,
        "className": "Person",
        coords: [
            340.0,
            537.0,
            465.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:45.700000",
        "id": 53,
        "className": "Person",
        coords: [
            30.0,
            217.0,
            77.0,
            355.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:45.700000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:45.700000",
        "id": 47,
        "className": "Person",
        coords: [
            496.0,
            180.0,
            527.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:45.700000",
        "id": 55,
        "className": "Person",
        coords: [
            137.0,
            168.0,
            171.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:24:45.900000",
        "id": 52,
        "className": "Person",
        coords: [
            503.0,
            244.0,
            575.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:45.900000",
        "id": 51,
        "className": "Person",
        coords: [
            321.0,
            290.0,
            378.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:45.900000",
        "id": 45,
        "className": "Person",
        coords: [
            340.0,
            537.0,
            465.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:46",
        "id": 53,
        "className": "Person",
        coords: [
            30.0,
            217.0,
            77.0,
            355.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:46",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:46",
        "id": 47,
        "className": "Person",
        coords: [
            496.0,
            180.0,
            527.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:46.100000",
        "id": 55,
        "className": "Person",
        coords: [
            137.0,
            168.0,
            171.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:46.200000",
        "id": 52,
        "className": "Person",
        coords: [
            503.0,
            245.0,
            574.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:46.200000",
        "id": 51,
        "className": "Person",
        coords: [
            321.0,
            290.0,
            378.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:46.200000",
        "id": 45,
        "className": "Person",
        coords: [
            340.0,
            537.0,
            465.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:46.200000",
        "id": 53,
        "className": "Person",
        coords: [
            30.0,
            218.0,
            77.0,
            355.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:46.200000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:46.300000",
        "id": 47,
        "className": "Person",
        coords: [
            496.0,
            180.0,
            527.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:46.300000",
        "id": 55,
        "className": "Person",
        coords: [
            138.0,
            167.0,
            170.0,
            257.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:46.300000",
        "id": 52,
        "className": "Person",
        coords: [
            502.0,
            245.0,
            574.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:46.400000",
        "id": 51,
        "className": "Person",
        coords: [
            321.0,
            290.0,
            379.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:46.400000",
        "id": 45,
        "className": "Person",
        coords: [
            341.0,
            537.0,
            465.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:46.400000",
        "id": 53,
        "className": "Person",
        coords: [
            30.0,
            218.0,
            78.0,
            355.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:46.500000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:46.500000",
        "id": 47,
        "className": "Person",
        coords: [
            495.0,
            181.0,
            526.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:46.500000",
        "id": 55,
        "className": "Person",
        coords: [
            139.0,
            167.0,
            170.0,
            251.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:46.600000",
        "id": 52,
        "className": "Person",
        coords: [
            502.0,
            245.0,
            573.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:46.600000",
        "id": 51,
        "className": "Person",
        coords: [
            321.0,
            290.0,
            378.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:46.600000",
        "id": 45,
        "className": "Person",
        coords: [
            341.0,
            537.0,
            465.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:46.600000",
        "id": 53,
        "className": "Person",
        coords: [
            31.0,
            218.0,
            78.0,
            355.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:46.700000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:46.700000",
        "id": 47,
        "className": "Person",
        coords: [
            496.0,
            182.0,
            527.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:46.700000",
        "id": 55,
        "className": "Person",
        coords: [
            140.0,
            170.0,
            170.0,
            249.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:46.800000",
        "id": 52,
        "className": "Person",
        coords: [
            503.0,
            245.0,
            574.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:46.800000",
        "id": 51,
        "className": "Person",
        coords: [
            320.0,
            290.0,
            377.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:46.800000",
        "id": 45,
        "className": "Person",
        coords: [
            341.0,
            537.0,
            466.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:46.800000",
        "id": 53,
        "className": "Person",
        coords: [
            31.0,
            219.0,
            77.0,
            353.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:46.800000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:46.900000",
        "id": 55,
        "className": "Person",
        coords: [
            140.0,
            171.0,
            170.0,
            248.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:46.900000",
        "id": 52,
        "className": "Person",
        coords: [
            503.0,
            245.0,
            574.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:47",
        "id": 51,
        "className": "Person",
        coords: [
            320.0,
            290.0,
            377.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:47",
        "id": 45,
        "className": "Person",
        coords: [
            342.0,
            537.0,
            467.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:47",
        "id": 53,
        "className": "Person",
        coords: [
            31.0,
            220.0,
            77.0,
            353.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:47",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:47",
        "id": 55,
        "className": "Person",
        coords: [
            140.0,
            171.0,
            171.0,
            247.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:47.100000",
        "id": 47,
        "className": "Person",
        coords: [
            495.0,
            182.0,
            526.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:47.100000",
        "id": 52,
        "className": "Person",
        coords: [
            503.0,
            245.0,
            574.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:47.100000",
        "id": 51,
        "className": "Person",
        coords: [
            320.0,
            290.0,
            377.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:47.200000",
        "id": 45,
        "className": "Person",
        coords: [
            342.0,
            537.0,
            467.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:47.200000",
        "id": 53,
        "className": "Person",
        coords: [
            32.0,
            220.0,
            78.0,
            352.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:47.200000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:47.200000",
        "id": 55,
        "className": "Person",
        coords: [
            140.0,
            171.0,
            171.0,
            247.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:47.300000",
        "id": 47,
        "className": "Person",
        coords: [
            495.0,
            181.0,
            526.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:47.300000",
        "id": 52,
        "className": "Person",
        coords: [
            504.0,
            245.0,
            576.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:47.300000",
        "id": 51,
        "className": "Person",
        coords: [
            319.0,
            290.0,
            377.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:47.400000",
        "id": 45,
        "className": "Person",
        coords: [
            342.0,
            537.0,
            467.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:47.400000",
        "id": 53,
        "className": "Person",
        coords: [
            33.0,
            220.0,
            79.0,
            352.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:47.400000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:47.400000",
        "id": 55,
        "className": "Person",
        coords: [
            138.0,
            171.0,
            171.0,
            250.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:47.400000",
        "id": 47,
        "className": "Person",
        coords: [
            495.0,
            180.0,
            526.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:47.500000",
        "id": 52,
        "className": "Person",
        coords: [
            513.0,
            247.0,
            581.0,
            338.0
        ],
        "status": "Moving",
        "speed": 106.06,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:47.500000",
        "id": 51,
        "className": "Person",
        coords: [
            319.0,
            290.0,
            377.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:47.600000",
        "id": 45,
        "className": "Person",
        coords: [
            342.0,
            537.0,
            468.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:47.600000",
        "id": 53,
        "className": "Person",
        coords: [
            32.0,
            220.0,
            79.0,
            352.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:47.600000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:47.600000",
        "id": 55,
        "className": "Person",
        coords: [
            138.0,
            173.0,
            170.0,
            250.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:47.600000",
        "id": 47,
        "className": "Person",
        coords: [
            495.0,
            179.0,
            526.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:47.700000",
        "id": 52,
        "className": "Person",
        coords: [
            511.0,
            247.0,
            577.0,
            335.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:47.700000",
        "id": 51,
        "className": "Person",
        coords: [
            319.0,
            290.0,
            377.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:47.700000",
        "id": 45,
        "className": "Person",
        coords: [
            342.0,
            537.0,
            468.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:47.800000",
        "id": 53,
        "className": "Person",
        coords: [
            32.0,
            219.0,
            80.0,
            352.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:47.800000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:47.800000",
        "id": 55,
        "className": "Person",
        coords: [
            137.0,
            175.0,
            169.0,
            249.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:47.800000",
        "id": 47,
        "className": "Person",
        coords: [
            495.0,
            179.0,
            527.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:47.900000",
        "id": 52,
        "className": "Person",
        coords: [
            514.0,
            246.0,
            579.0,
            332.0
        ],
        "status": "Moving",
        "speed": 42.42,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:47.900000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            290.0,
            376.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:47.900000",
        "id": 45,
        "className": "Person",
        coords: [
            342.0,
            537.0,
            467.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:48",
        "id": 53,
        "className": "Person",
        coords: [
            32.0,
            218.0,
            80.0,
            354.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:48",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:48",
        "id": 55,
        "className": "Person",
        coords: [
            135.0,
            172.0,
            170.0,
            252.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:48",
        "id": 47,
        "className": "Person",
        coords: [
            496.0,
            178.0,
            528.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:48.100000",
        "id": 52,
        "className": "Person",
        coords: [
            514.0,
            245.0,
            577.0,
            328.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:48.200000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            290.0,
            376.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:48.200000",
        "id": 45,
        "className": "Person",
        coords: [
            342.0,
            537.0,
            467.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:48.200000",
        "id": 53,
        "className": "Person",
        coords: [
            31.0,
            219.0,
            81.0,
            355.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:48.200000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:48.300000",
        "id": 55,
        "className": "Person",
        coords: [
            135.0,
            172.0,
            170.0,
            250.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:48.300000",
        "id": 47,
        "className": "Person",
        coords: [
            497.0,
            178.0,
            530.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:48.400000",
        "id": 52,
        "className": "Person",
        coords: [
            515.0,
            245.0,
            576.0,
            325.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:48.400000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            290.0,
            375.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:48.400000",
        "id": 45,
        "className": "Person",
        coords: [
            342.0,
            538.0,
            467.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:48.500000",
        "id": 53,
        "className": "Person",
        coords: [
            31.0,
            219.0,
            80.0,
            355.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:48.500000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:48.500000",
        "id": 55,
        "className": "Person",
        coords: [
            135.0,
            173.0,
            170.0,
            252.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:48.500000",
        "id": 47,
        "className": "Person",
        coords: [
            498.0,
            178.0,
            533.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:48.600000",
        "id": 52,
        "className": "Person",
        coords: [
            517.0,
            245.0,
            577.0,
            323.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:48.600000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            290.0,
            375.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:48.600000",
        "id": 45,
        "className": "Person",
        coords: [
            342.0,
            537.0,
            467.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:48.700000",
        "id": 53,
        "className": "Person",
        coords: [
            32.0,
            221.0,
            82.0,
            355.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:48.700000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            191.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:48.700000",
        "id": 55,
        "className": "Person",
        coords: [
            134.0,
            173.0,
            170.0,
            254.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:48.700000",
        "id": 47,
        "className": "Person",
        coords: [
            499.0,
            178.0,
            534.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:48.800000",
        "id": 52,
        "className": "Person",
        coords: [
            517.0,
            245.0,
            577.0,
            322.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:48.800000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            290.0,
            375.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:48.800000",
        "id": 45,
        "className": "Person",
        coords: [
            341.0,
            537.0,
            467.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:48.800000",
        "id": 53,
        "className": "Person",
        coords: [
            31.0,
            221.0,
            81.0,
            355.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:48.900000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:48.900000",
        "id": 55,
        "className": "Person",
        coords: [
            135.0,
            175.0,
            170.0,
            255.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:48.900000",
        "id": 52,
        "className": "Person",
        coords: [
            520.0,
            244.0,
            580.0,
            322.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:49",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            290.0,
            375.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:49",
        "id": 45,
        "className": "Person",
        coords: [
            340.0,
            537.0,
            466.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:49",
        "id": 53,
        "className": "Person",
        coords: [
            31.0,
            221.0,
            81.0,
            355.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:49",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:49",
        "id": 55,
        "className": "Person",
        coords: [
            135.0,
            176.0,
            170.0,
            256.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:49.100000",
        "id": 52,
        "className": "Person",
        coords: [
            523.0,
            244.0,
            583.0,
            323.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:49.100000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            290.0,
            375.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:49.200000",
        "id": 45,
        "className": "Person",
        coords: [
            340.0,
            537.0,
            465.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:49.200000",
        "id": 53,
        "className": "Person",
        coords: [
            32.0,
            220.0,
            84.0,
            356.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:49.200000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:49.200000",
        "id": 55,
        "className": "Person",
        coords: [
            134.0,
            176.0,
            171.0,
            259.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:49.300000",
        "id": 52,
        "className": "Person",
        coords: [
            521.0,
            244.0,
            582.0,
            324.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:49.300000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            290.0,
            375.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:49.300000",
        "id": 45,
        "className": "Person",
        coords: [
            338.0,
            537.0,
            463.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:49.300000",
        "id": 53,
        "className": "Person",
        coords: [
            31.0,
            219.0,
            83.0,
            356.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:49.400000",
        "id": 54,
        "className": "Person",
        coords: [
            771.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:49.400000",
        "id": 55,
        "className": "Person",
        coords: [
            134.0,
            175.0,
            171.0,
            259.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:49.400000",
        "id": 52,
        "className": "Person",
        coords: [
            524.0,
            245.0,
            584.0,
            325.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:49.500000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            290.0,
            375.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:49.500000",
        "id": 45,
        "className": "Person",
        coords: [
            336.0,
            537.0,
            462.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:49.500000",
        "id": 53,
        "className": "Person",
        coords: [
            30.0,
            219.0,
            83.0,
            356.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:49.500000",
        "id": 54,
        "className": "Person",
        coords: [
            771.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:49.500000",
        "id": 55,
        "className": "Person",
        coords: [
            134.0,
            175.0,
            172.0,
            260.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:49.600000",
        "id": 52,
        "className": "Person",
        coords: [
            523.0,
            244.0,
            584.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:49.600000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            290.0,
            375.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:49.600000",
        "id": 45,
        "className": "Person",
        coords: [
            336.0,
            537.0,
            462.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:49.700000",
        "id": 53,
        "className": "Person",
        coords: [
            31.0,
            219.0,
            85.0,
            357.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:49.700000",
        "id": 54,
        "className": "Person",
        coords: [
            771.0,
            191.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:49.700000",
        "id": 55,
        "className": "Person",
        coords: [
            134.0,
            175.0,
            172.0,
            260.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:49.800000",
        "id": 52,
        "className": "Person",
        coords: [
            521.0,
            245.0,
            583.0,
            329.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:49.800000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            290.0,
            375.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:49.800000",
        "id": 45,
        "className": "Person",
        coords: [
            335.0,
            537.0,
            461.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:49.900000",
        "id": 53,
        "className": "Person",
        coords: [
            30.0,
            218.0,
            84.0,
            356.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:49.900000",
        "id": 54,
        "className": "Person",
        coords: [
            771.0,
            192.0,
            811.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:49.900000",
        "id": 55,
        "className": "Person",
        coords: [
            134.0,
            175.0,
            172.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:49.900000",
        "id": 47,
        "className": "Person",
        coords: [
            495.0,
            179.0,
            530.0,
            265.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:50",
        "id": 52,
        "className": "Person",
        coords: [
            519.0,
            245.0,
            582.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:50",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            290.0,
            375.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:50",
        "id": 45,
        "className": "Person",
        coords: [
            335.0,
            537.0,
            461.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:50",
        "id": 53,
        "className": "Person",
        coords: [
            30.0,
            218.0,
            84.0,
            356.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:50",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:50.100000",
        "id": 55,
        "className": "Person",
        coords: [
            134.0,
            176.0,
            172.0,
            260.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:50.100000",
        "id": 47,
        "className": "Person",
        coords: [
            495.0,
            179.0,
            531.0,
            265.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:50.100000",
        "id": 52,
        "className": "Person",
        coords: [
            519.0,
            244.0,
            582.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:50.200000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            290.0,
            375.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:50.200000",
        "id": 45,
        "className": "Person",
        coords: [
            334.0,
            537.0,
            461.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:50.200000",
        "id": 53,
        "className": "Person",
        coords: [
            30.0,
            219.0,
            83.0,
            356.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:50.200000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:50.200000",
        "id": 55,
        "className": "Person",
        coords: [
            133.0,
            176.0,
            171.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:50.300000",
        "id": 47,
        "className": "Person",
        coords: [
            496.0,
            178.0,
            531.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:50.300000",
        "id": 52,
        "className": "Person",
        coords: [
            519.0,
            244.0,
            581.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:50.400000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            290.0,
            375.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:50.400000",
        "id": 45,
        "className": "Person",
        coords: [
            334.0,
            537.0,
            462.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:50.400000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:50.400000",
        "id": 55,
        "className": "Person",
        coords: [
            132.0,
            176.0,
            171.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:50.400000",
        "id": 47,
        "className": "Person",
        coords: [
            497.0,
            177.0,
            532.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:50.500000",
        "id": 52,
        "className": "Person",
        coords: [
            518.0,
            244.0,
            581.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:50.500000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            290.0,
            375.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:50.500000",
        "id": 45,
        "className": "Person",
        coords: [
            334.0,
            537.0,
            462.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:50.600000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:50.600000",
        "id": 55,
        "className": "Person",
        coords: [
            132.0,
            177.0,
            170.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:50.600000",
        "id": 47,
        "className": "Person",
        coords: [
            497.0,
            177.0,
            532.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:50.700000",
        "id": 52,
        "className": "Person",
        coords: [
            522.0,
            245.0,
            583.0,
            329.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:50.700000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            290.0,
            375.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:50.700000",
        "id": 45,
        "className": "Person",
        coords: [
            332.0,
            537.0,
            460.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:50.700000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:50.800000",
        "id": 55,
        "className": "Person",
        coords: [
            131.0,
            176.0,
            169.0,
            260.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:50.800000",
        "id": 47,
        "className": "Person",
        coords: [
            497.0,
            178.0,
            531.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:50.800000",
        "id": 53,
        "className": "Person",
        coords: [
            30.0,
            216.0,
            85.0,
            356.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:50.900000",
        "id": 52,
        "className": "Person",
        coords: [
            524.0,
            245.0,
            583.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:50.900000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            290.0,
            375.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:50.900000",
        "id": 45,
        "className": "Person",
        coords: [
            330.0,
            537.0,
            459.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:50.900000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:51",
        "id": 55,
        "className": "Person",
        coords: [
            131.0,
            176.0,
            169.0,
            260.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:51",
        "id": 47,
        "className": "Person",
        coords: [
            497.0,
            179.0,
            531.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:51",
        "id": 53,
        "className": "Person",
        coords: [
            30.0,
            212.0,
            87.0,
            356.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:51",
        "id": 52,
        "className": "Person",
        coords: [
            523.0,
            245.0,
            583.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:51.100000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            290.0,
            375.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:51.100000",
        "id": 45,
        "className": "Person",
        coords: [
            330.0,
            537.0,
            459.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:51.100000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:51.100000",
        "id": 55,
        "className": "Person",
        coords: [
            131.0,
            176.0,
            168.0,
            258.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:51.200000",
        "id": 47,
        "className": "Person",
        coords: [
            497.0,
            179.0,
            530.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:51.200000",
        "id": 53,
        "className": "Person",
        coords: [
            30.0,
            211.0,
            88.0,
            356.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:51.200000",
        "id": 52,
        "className": "Person",
        coords: [
            522.0,
            244.0,
            583.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:51.300000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            290.0,
            375.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:51.300000",
        "id": 45,
        "className": "Person",
        coords: [
            331.0,
            537.0,
            460.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:51.300000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:51.300000",
        "id": 55,
        "className": "Person",
        coords: [
            131.0,
            176.0,
            168.0,
            258.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:51.300000",
        "id": 47,
        "className": "Person",
        coords: [
            497.0,
            179.0,
            531.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:51.400000",
        "id": 53,
        "className": "Person",
        coords: [
            30.0,
            211.0,
            88.0,
            356.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:51.400000",
        "id": 52,
        "className": "Person",
        coords: [
            523.0,
            244.0,
            585.0,
            334.0
        ],
        "status": "Moving",
        "speed": 42.42,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:51.500000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            290.0,
            375.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:51.500000",
        "id": 45,
        "className": "Person",
        coords: [
            330.0,
            537.0,
            460.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:51.500000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:51.500000",
        "id": 55,
        "className": "Person",
        coords: [
            131.0,
            176.0,
            169.0,
            258.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:51.600000",
        "id": 47,
        "className": "Person",
        coords: [
            497.0,
            179.0,
            531.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:51.600000",
        "id": 53,
        "className": "Person",
        coords: [
            29.0,
            210.0,
            89.0,
            356.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:51.600000",
        "id": 52,
        "className": "Person",
        coords: [
            523.0,
            244.0,
            585.0,
            334.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:51.700000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            290.0,
            375.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:51.700000",
        "id": 45,
        "className": "Person",
        coords: [
            331.0,
            538.0,
            460.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:51.700000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:51.700000",
        "id": 55,
        "className": "Person",
        coords: [
            131.0,
            176.0,
            169.0,
            258.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:51.700000",
        "id": 47,
        "className": "Person",
        coords: [
            498.0,
            179.0,
            531.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:51.800000",
        "id": 53,
        "className": "Person",
        coords: [
            28.0,
            209.0,
            88.0,
            357.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:51.800000",
        "id": 52,
        "className": "Person",
        coords: [
            522.0,
            244.0,
            585.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:51.800000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            290.0,
            375.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:51.900000",
        "id": 45,
        "className": "Person",
        coords: [
            331.0,
            538.0,
            461.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:51.900000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:51.900000",
        "id": 55,
        "className": "Person",
        coords: [
            132.0,
            177.0,
            169.0,
            260.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:51.900000",
        "id": 47,
        "className": "Person",
        coords: [
            497.0,
            179.0,
            531.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:51.900000",
        "id": 53,
        "className": "Person",
        coords: [
            26.0,
            208.0,
            88.0,
            356.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:52",
        "id": 52,
        "className": "Person",
        coords: [
            521.0,
            244.0,
            585.0,
            335.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:52",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            289.0,
            375.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:52",
        "id": 45,
        "className": "Person",
        coords: [
            332.0,
            538.0,
            462.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:52.100000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:52.100000",
        "id": 55,
        "className": "Person",
        coords: [
            132.0,
            177.0,
            170.0,
            260.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:52.100000",
        "id": 47,
        "className": "Person",
        coords: [
            497.0,
            179.0,
            531.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:52.100000",
        "id": 53,
        "className": "Person",
        coords: [
            26.0,
            208.0,
            88.0,
            356.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:52.200000",
        "id": 52,
        "className": "Person",
        coords: [
            521.0,
            245.0,
            586.0,
            337.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:52.200000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            289.0,
            375.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:52.200000",
        "id": 45,
        "className": "Person",
        coords: [
            333.0,
            537.0,
            462.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:52.200000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:52.300000",
        "id": 55,
        "className": "Person",
        coords: [
            134.0,
            182.0,
            171.0,
            262.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:52.300000",
        "id": 47,
        "className": "Person",
        coords: [
            497.0,
            179.0,
            530.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:52.300000",
        "id": 53,
        "className": "Person",
        coords: [
            24.0,
            208.0,
            86.0,
            356.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:52.400000",
        "id": 52,
        "className": "Person",
        coords: [
            520.0,
            245.0,
            585.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:52.400000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            290.0,
            375.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:52.400000",
        "id": 45,
        "className": "Person",
        coords: [
            333.0,
            537.0,
            463.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:52.500000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:52.500000",
        "id": 55,
        "className": "Person",
        coords: [
            137.0,
            185.0,
            172.0,
            263.0
        ],
        "status": "Moving",
        "speed": 42.42,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:52.500000",
        "id": 47,
        "className": "Person",
        coords: [
            496.0,
            179.0,
            530.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:52.500000",
        "id": 53,
        "className": "Person",
        coords: [
            23.0,
            209.0,
            85.0,
            357.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:52.600000",
        "id": 52,
        "className": "Person",
        coords: [
            518.0,
            245.0,
            583.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:52.600000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            290.0,
            375.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:52.600000",
        "id": 45,
        "className": "Person",
        coords: [
            334.0,
            537.0,
            463.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:52.600000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:52.700000",
        "id": 55,
        "className": "Person",
        coords: [
            139.0,
            188.0,
            173.0,
            264.0
        ],
        "status": "Moving",
        "speed": 42.42,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:52.700000",
        "id": 47,
        "className": "Person",
        coords: [
            497.0,
            179.0,
            530.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:52.700000",
        "id": 53,
        "className": "Person",
        coords: [
            22.0,
            209.0,
            85.0,
            357.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:52.800000",
        "id": 52,
        "className": "Person",
        coords: [
            518.0,
            245.0,
            583.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:52.800000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            290.0,
            375.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:52.800000",
        "id": 45,
        "className": "Person",
        coords: [
            334.0,
            537.0,
            463.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:52.800000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:52.800000",
        "id": 55,
        "className": "Person",
        coords: [
            140.0,
            189.0,
            174.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:52.900000",
        "id": 47,
        "className": "Person",
        coords: [
            497.0,
            179.0,
            530.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:52.900000",
        "id": 53,
        "className": "Person",
        coords: [
            21.0,
            209.0,
            84.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:53",
        "id": 52,
        "className": "Person",
        coords: [
            516.0,
            245.0,
            581.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:53",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            290.0,
            375.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:53",
        "id": 45,
        "className": "Person",
        coords: [
            334.0,
            537.0,
            463.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:53",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:53",
        "id": 55,
        "className": "Person",
        coords: [
            141.0,
            188.0,
            174.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:53.100000",
        "id": 47,
        "className": "Person",
        coords: [
            497.0,
            179.0,
            530.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:53.100000",
        "id": 53,
        "className": "Person",
        coords: [
            21.0,
            210.0,
            84.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:53.100000",
        "id": 52,
        "className": "Person",
        coords: [
            513.0,
            245.0,
            578.0,
            338.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:53.200000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            290.0,
            375.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:53.200000",
        "id": 45,
        "className": "Person",
        coords: [
            334.0,
            537.0,
            463.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:53.200000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:53.200000",
        "id": 55,
        "className": "Person",
        coords: [
            142.0,
            189.0,
            174.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:53.300000",
        "id": 47,
        "className": "Person",
        coords: [
            497.0,
            179.0,
            530.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:53.300000",
        "id": 53,
        "className": "Person",
        coords: [
            21.0,
            210.0,
            84.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:54.300000",
        "id": 52,
        "className": "Person",
        coords: [
            511.0,
            245.0,
            577.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:54.400000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            290.0,
            375.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:57.700000",
        "id": 45,
        "className": "Person",
        coords: [
            334.0,
            537.0,
            463.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:57.800000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:57.900000",
        "id": 55,
        "className": "Person",
        coords: [
            143.0,
            189.0,
            175.0,
            265.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:58",
        "id": 47,
        "className": "Person",
        coords: [
            497.0,
            179.0,
            530.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:58",
        "id": 53,
        "className": "Person",
        coords: [
            22.0,
            211.0,
            85.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:58.400000",
        "id": 52,
        "className": "Person",
        coords: [
            507.0,
            244.0,
            574.0,
            339.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:58.500000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            290.0,
            375.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:58.500000",
        "id": 45,
        "className": "Person",
        coords: [
            335.0,
            537.0,
            462.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:58.500000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:58.600000",
        "id": 55,
        "className": "Person",
        coords: [
            143.0,
            184.0,
            176.0,
            265.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:58.600000",
        "id": 47,
        "className": "Person",
        coords: [
            495.0,
            178.0,
            529.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:58.600000",
        "id": 53,
        "className": "Person",
        coords: [
            25.0,
            215.0,
            85.0,
            358.0
        ],
        "status": "Moving",
        "speed": 42.42,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:58.700000",
        "id": 52,
        "className": "Person",
        coords: [
            506.0,
            244.0,
            573.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:58.700000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            290.0,
            375.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:58.700000",
        "id": 45,
        "className": "Person",
        coords: [
            335.0,
            537.0,
            462.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:58.800000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:58.800000",
        "id": 55,
        "className": "Person",
        coords: [
            143.0,
            182.0,
            176.0,
            265.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:58.800000",
        "id": 47,
        "className": "Person",
        coords: [
            494.0,
            178.0,
            529.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:58.800000",
        "id": 53,
        "className": "Person",
        coords: [
            26.0,
            217.0,
            85.0,
            359.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:58.900000",
        "id": 52,
        "className": "Person",
        coords: [
            503.0,
            244.0,
            571.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:58.900000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            290.0,
            375.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:59",
        "id": 45,
        "className": "Person",
        coords: [
            335.0,
            537.0,
            462.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:59",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:59",
        "id": 55,
        "className": "Person",
        coords: [
            143.0,
            181.0,
            176.0,
            265.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:59",
        "id": 47,
        "className": "Person",
        coords: [
            494.0,
            178.0,
            528.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:59.100000",
        "id": 53,
        "className": "Person",
        coords: [
            27.0,
            218.0,
            84.0,
            359.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:59.200000",
        "id": 52,
        "className": "Person",
        coords: [
            504.0,
            244.0,
            572.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:59.200000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            290.0,
            375.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:59.200000",
        "id": 45,
        "className": "Person",
        coords: [
            335.0,
            537.0,
            462.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:59.200000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:59.300000",
        "id": 55,
        "className": "Person",
        coords: [
            144.0,
            182.0,
            176.0,
            265.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:59.300000",
        "id": 47,
        "className": "Person",
        coords: [
            493.0,
            178.0,
            528.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:59.300000",
        "id": 53,
        "className": "Person",
        coords: [
            28.0,
            218.0,
            84.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:59.400000",
        "id": 52,
        "className": "Person",
        coords: [
            500.0,
            244.0,
            569.0,
            339.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:59.400000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            290.0,
            375.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:59.500000",
        "id": 45,
        "className": "Person",
        coords: [
            335.0,
            537.0,
            462.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:59.500000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:59.500000",
        "id": 55,
        "className": "Person",
        coords: [
            144.0,
            182.0,
            176.0,
            265.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:59.500000",
        "id": 47,
        "className": "Person",
        coords: [
            493.0,
            178.0,
            529.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:59.500000",
        "id": 53,
        "className": "Person",
        coords: [
            28.0,
            218.0,
            83.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:59.600000",
        "id": 52,
        "className": "Person",
        coords: [
            501.0,
            245.0,
            570.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:59.600000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            290.0,
            375.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:59.700000",
        "id": 45,
        "className": "Person",
        coords: [
            335.0,
            537.0,
            462.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:59.700000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:59.700000",
        "id": 55,
        "className": "Person",
        coords: [
            145.0,
            180.0,
            176.0,
            265.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:59.700000",
        "id": 47,
        "className": "Person",
        coords: [
            493.0,
            178.0,
            529.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:59.700000",
        "id": 53,
        "className": "Person",
        coords: [
            29.0,
            218.0,
            84.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:59.800000",
        "id": 52,
        "className": "Person",
        coords: [
            503.0,
            245.0,
            571.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:59.800000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            290.0,
            375.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:59.900000",
        "id": 45,
        "className": "Person",
        coords: [
            335.0,
            537.0,
            462.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:59.900000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:59.900000",
        "id": 55,
        "className": "Person",
        coords: [
            145.0,
            180.0,
            177.0,
            266.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:24:59.900000",
        "id": 47,
        "className": "Person",
        coords: [
            493.0,
            178.0,
            529.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:24:59.900000",
        "id": 53,
        "className": "Person",
        coords: [
            29.0,
            218.0,
            84.0,
            359.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:00",
        "id": 52,
        "className": "Person",
        coords: [
            503.0,
            245.0,
            572.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:00",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            290.0,
            375.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:00",
        "id": 45,
        "className": "Person",
        coords: [
            336.0,
            537.0,
            463.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:00.100000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:00.100000",
        "id": 55,
        "className": "Person",
        coords: [
            145.0,
            180.0,
            177.0,
            266.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:00.100000",
        "id": 47,
        "className": "Person",
        coords: [
            493.0,
            178.0,
            529.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:00.100000",
        "id": 53,
        "className": "Person",
        coords: [
            29.0,
            217.0,
            84.0,
            359.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:00.200000",
        "id": 52,
        "className": "Person",
        coords: [
            504.0,
            246.0,
            572.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:00.200000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            290.0,
            375.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:00.200000",
        "id": 45,
        "className": "Person",
        coords: [
            336.0,
            537.0,
            463.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:00.200000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:00.200000",
        "id": 55,
        "className": "Person",
        coords: [
            145.0,
            181.0,
            177.0,
            266.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:00.300000",
        "id": 47,
        "className": "Person",
        coords: [
            492.0,
            178.0,
            528.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:00.300000",
        "id": 53,
        "className": "Person",
        coords: [
            29.0,
            217.0,
            84.0,
            359.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:00.300000",
        "id": 52,
        "className": "Person",
        coords: [
            505.0,
            246.0,
            573.0,
            339.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:00.300000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            290.0,
            375.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:00.400000",
        "id": 45,
        "className": "Person",
        coords: [
            336.0,
            537.0,
            463.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:00.400000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:00.400000",
        "id": 55,
        "className": "Person",
        coords: [
            145.0,
            181.0,
            177.0,
            266.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:00.400000",
        "id": 47,
        "className": "Person",
        coords: [
            492.0,
            178.0,
            529.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:00.400000",
        "id": 53,
        "className": "Person",
        coords: [
            29.0,
            216.0,
            84.0,
            359.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:00.500000",
        "id": 52,
        "className": "Person",
        coords: [
            507.0,
            247.0,
            573.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:00.500000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            290.0,
            375.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:00.600000",
        "id": 45,
        "className": "Person",
        coords: [
            336.0,
            537.0,
            462.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:00.600000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:00.600000",
        "id": 55,
        "className": "Person",
        coords: [
            145.0,
            181.0,
            176.0,
            266.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:00.600000",
        "id": 47,
        "className": "Person",
        coords: [
            492.0,
            178.0,
            529.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:00.600000",
        "id": 53,
        "className": "Person",
        coords: [
            29.0,
            216.0,
            83.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:00.700000",
        "id": 52,
        "className": "Person",
        coords: [
            507.0,
            247.0,
            573.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:00.700000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            290.0,
            375.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:00.800000",
        "id": 45,
        "className": "Person",
        coords: [
            336.0,
            537.0,
            462.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:00.800000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:00.800000",
        "id": 55,
        "className": "Person",
        coords: [
            144.0,
            181.0,
            176.0,
            266.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:00.800000",
        "id": 47,
        "className": "Person",
        coords: [
            492.0,
            178.0,
            530.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:00.800000",
        "id": 53,
        "className": "Person",
        coords: [
            29.0,
            216.0,
            83.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:00.900000",
        "id": 52,
        "className": "Person",
        coords: [
            510.0,
            247.0,
            574.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:00.900000",
        "id": 51,
        "className": "Person",
        coords: [
            317.0,
            290.0,
            374.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:01",
        "id": 45,
        "className": "Person",
        coords: [
            336.0,
            537.0,
            462.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:01",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:01",
        "id": 55,
        "className": "Person",
        coords: [
            144.0,
            182.0,
            176.0,
            266.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:01",
        "id": 47,
        "className": "Person",
        coords: [
            491.0,
            179.0,
            528.0,
            263.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:01",
        "id": 53,
        "className": "Person",
        coords: [
            29.0,
            216.0,
            83.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:01.100000",
        "id": 52,
        "className": "Person",
        coords: [
            511.0,
            248.0,
            574.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:01.100000",
        "id": 51,
        "className": "Person",
        coords: [
            317.0,
            291.0,
            374.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:01.100000",
        "id": 45,
        "className": "Person",
        coords: [
            336.0,
            537.0,
            462.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:01.100000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:01.200000",
        "id": 55,
        "className": "Person",
        coords: [
            143.0,
            183.0,
            175.0,
            266.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:01.200000",
        "id": 47,
        "className": "Person",
        coords: [
            492.0,
            179.0,
            529.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:01.200000",
        "id": 53,
        "className": "Person",
        coords: [
            29.0,
            216.0,
            82.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:01.300000",
        "id": 52,
        "className": "Person",
        coords: [
            513.0,
            248.0,
            574.0,
            338.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:01.300000",
        "id": 51,
        "className": "Person",
        coords: [
            317.0,
            291.0,
            375.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:01.300000",
        "id": 45,
        "className": "Person",
        coords: [
            336.0,
            537.0,
            462.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:01.300000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:01.400000",
        "id": 55,
        "className": "Person",
        coords: [
            142.0,
            183.0,
            174.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:01.400000",
        "id": 47,
        "className": "Person",
        coords: [
            492.0,
            179.0,
            530.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:01.400000",
        "id": 53,
        "className": "Person",
        coords: [
            30.0,
            217.0,
            82.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:01.500000",
        "id": 52,
        "className": "Person",
        coords: [
            508.0,
            248.0,
            568.0,
            335.0
        ],
        "status": "Moving",
        "speed": 80.77,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:01.500000",
        "id": 51,
        "className": "Person",
        coords: [
            319.0,
            290.0,
            376.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:01.500000",
        "id": 45,
        "className": "Person",
        coords: [
            338.0,
            538.0,
            461.0,
            714.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:01.500000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:01.600000",
        "id": 55,
        "className": "Person",
        coords: [
            140.0,
            183.0,
            174.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:01.600000",
        "id": 47,
        "className": "Person",
        coords: [
            488.0,
            179.0,
            528.0,
            263.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:01.600000",
        "id": 53,
        "className": "Person",
        coords: [
            28.0,
            216.0,
            81.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:01.600000",
        "id": 52,
        "className": "Person",
        coords: [
            507.0,
            247.0,
            565.0,
            332.0
        ],
        "status": "Moving",
        "speed": 42.42,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:01.700000",
        "id": 51,
        "className": "Person",
        coords: [
            319.0,
            291.0,
            376.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:01.700000",
        "id": 45,
        "className": "Person",
        coords: [
            337.0,
            538.0,
            462.0,
            714.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:01.700000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:01.700000",
        "id": 55,
        "className": "Person",
        coords: [
            140.0,
            184.0,
            174.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:01.700000",
        "id": 47,
        "className": "Person",
        coords: [
            490.0,
            179.0,
            531.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:01.700000",
        "id": 53,
        "className": "Person",
        coords: [
            28.0,
            218.0,
            81.0,
            359.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:01.800000",
        "id": 52,
        "className": "Person",
        coords: [
            506.0,
            246.0,
            564.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:01.800000",
        "id": 51,
        "className": "Person",
        coords: [
            319.0,
            291.0,
            376.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:01.800000",
        "id": 45,
        "className": "Person",
        coords: [
            337.0,
            538.0,
            462.0,
            715.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:01.900000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:01.900000",
        "id": 55,
        "className": "Person",
        coords: [
            140.0,
            185.0,
            174.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:01.900000",
        "id": 47,
        "className": "Person",
        coords: [
            491.0,
            179.0,
            532.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:01.900000",
        "id": 53,
        "className": "Person",
        coords: [
            29.0,
            218.0,
            81.0,
            359.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:01.900000",
        "id": 52,
        "className": "Person",
        coords: [
            506.0,
            246.0,
            564.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:02",
        "id": 51,
        "className": "Person",
        coords: [
            319.0,
            291.0,
            376.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:02",
        "id": 45,
        "className": "Person",
        coords: [
            337.0,
            538.0,
            462.0,
            715.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:02",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:02",
        "id": 55,
        "className": "Person",
        coords: [
            139.0,
            185.0,
            174.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:02",
        "id": 47,
        "className": "Person",
        coords: [
            491.0,
            179.0,
            532.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:02.100000",
        "id": 53,
        "className": "Person",
        coords: [
            29.0,
            218.0,
            81.0,
            359.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:02.100000",
        "id": 52,
        "className": "Person",
        coords: [
            503.0,
            245.0,
            564.0,
            333.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:02.100000",
        "id": 51,
        "className": "Person",
        coords: [
            319.0,
            291.0,
            376.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:02.100000",
        "id": 45,
        "className": "Person",
        coords: [
            337.0,
            538.0,
            462.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:02.200000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:02.200000",
        "id": 55,
        "className": "Person",
        coords: [
            138.0,
            183.0,
            174.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:02.200000",
        "id": 47,
        "className": "Person",
        coords: [
            492.0,
            179.0,
            534.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:02.200000",
        "id": 53,
        "className": "Person",
        coords: [
            29.0,
            218.0,
            81.0,
            359.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:02.300000",
        "id": 52,
        "className": "Person",
        coords: [
            499.0,
            245.0,
            560.0,
            332.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:02.300000",
        "id": 51,
        "className": "Person",
        coords: [
            319.0,
            291.0,
            376.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:02.300000",
        "id": 45,
        "className": "Person",
        coords: [
            337.0,
            537.0,
            463.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:02.300000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:02.300000",
        "id": 55,
        "className": "Person",
        coords: [
            138.0,
            182.0,
            174.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:02.400000",
        "id": 47,
        "className": "Person",
        coords: [
            493.0,
            180.0,
            535.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:02.400000",
        "id": 53,
        "className": "Person",
        coords: [
            29.0,
            219.0,
            81.0,
            359.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:02.400000",
        "id": 52,
        "className": "Person",
        coords: [
            496.0,
            245.0,
            557.0,
            332.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:02.400000",
        "id": 51,
        "className": "Person",
        coords: [
            319.0,
            290.0,
            376.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:02.500000",
        "id": 45,
        "className": "Person",
        coords: [
            336.0,
            538.0,
            462.0,
            715.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:02.500000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:02.500000",
        "id": 55,
        "className": "Person",
        coords: [
            138.0,
            182.0,
            174.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:02.500000",
        "id": 47,
        "className": "Person",
        coords: [
            496.0,
            180.0,
            538.0,
            264.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:02.500000",
        "id": 53,
        "className": "Person",
        coords: [
            30.0,
            219.0,
            81.0,
            359.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:02.600000",
        "id": 52,
        "className": "Person",
        coords: [
            490.0,
            245.0,
            554.0,
            333.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:02.600000",
        "id": 51,
        "className": "Person",
        coords: [
            319.0,
            290.0,
            376.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:02.600000",
        "id": 45,
        "className": "Person",
        coords: [
            338.0,
            538.0,
            461.0,
            712.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:02.700000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:02.700000",
        "id": 55,
        "className": "Person",
        coords: [
            137.0,
            181.0,
            174.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:02.700000",
        "id": 47,
        "className": "Person",
        coords: [
            496.0,
            180.0,
            539.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:02.700000",
        "id": 53,
        "className": "Person",
        coords: [
            29.0,
            218.0,
            80.0,
            359.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:02.800000",
        "id": 52,
        "className": "Person",
        coords: [
            487.0,
            245.0,
            551.0,
            332.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:02.800000",
        "id": 51,
        "className": "Person",
        coords: [
            319.0,
            290.0,
            376.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:02.800000",
        "id": 45,
        "className": "Person",
        coords: [
            339.0,
            538.0,
            461.0,
            709.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:02.900000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:02.900000",
        "id": 55,
        "className": "Person",
        coords: [
            137.0,
            181.0,
            174.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:02.900000",
        "id": 47,
        "className": "Person",
        coords: [
            497.0,
            180.0,
            540.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:02.900000",
        "id": 53,
        "className": "Person",
        coords: [
            29.0,
            219.0,
            81.0,
            359.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:03",
        "id": 52,
        "className": "Person",
        coords: [
            486.0,
            245.0,
            551.0,
            332.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:03",
        "id": 51,
        "className": "Person",
        coords: [
            319.0,
            291.0,
            375.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:03",
        "id": 45,
        "className": "Person",
        coords: [
            341.0,
            538.0,
            461.0,
            705.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:03",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:03",
        "id": 55,
        "className": "Person",
        coords: [
            137.0,
            180.0,
            174.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:03.100000",
        "id": 47,
        "className": "Person",
        coords: [
            498.0,
            180.0,
            541.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:03.100000",
        "id": 53,
        "className": "Person",
        coords: [
            29.0,
            219.0,
            81.0,
            359.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:03.100000",
        "id": 52,
        "className": "Person",
        coords: [
            485.0,
            244.0,
            550.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:03.200000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            290.0,
            375.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:03.200000",
        "id": 45,
        "className": "Person",
        coords: [
            342.0,
            539.0,
            461.0,
            705.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:03.200000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:03.200000",
        "id": 55,
        "className": "Person",
        coords: [
            137.0,
            180.0,
            174.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:03.200000",
        "id": 47,
        "className": "Person",
        coords: [
            498.0,
            180.0,
            541.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:03.300000",
        "id": 53,
        "className": "Person",
        coords: [
            29.0,
            218.0,
            80.0,
            359.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:03.300000",
        "id": 52,
        "className": "Person",
        coords: [
            484.0,
            244.0,
            550.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:03.300000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            290.0,
            375.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:03.400000",
        "id": 45,
        "className": "Person",
        coords: [
            342.0,
            540.0,
            461.0,
            705.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:03.400000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:03.400000",
        "id": 55,
        "className": "Person",
        coords: [
            136.0,
            180.0,
            174.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:03.400000",
        "id": 47,
        "className": "Person",
        coords: [
            498.0,
            180.0,
            543.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:03.400000",
        "id": 53,
        "className": "Person",
        coords: [
            29.0,
            217.0,
            81.0,
            359.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:03.500000",
        "id": 52,
        "className": "Person",
        coords: [
            483.0,
            244.0,
            550.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:03.500000",
        "id": 51,
        "className": "Person",
        coords: [
            319.0,
            290.0,
            375.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:03.500000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:03.600000",
        "id": 55,
        "className": "Person",
        coords: [
            136.0,
            180.0,
            175.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:03.600000",
        "id": 47,
        "className": "Person",
        coords: [
            497.0,
            179.0,
            543.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:03.600000",
        "id": 53,
        "className": "Person",
        coords: [
            29.0,
            217.0,
            81.0,
            359.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:03.600000",
        "id": 52,
        "className": "Person",
        coords: [
            481.0,
            244.0,
            549.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:03.700000",
        "id": 51,
        "className": "Person",
        coords: [
            319.0,
            290.0,
            376.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:03.700000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:03.700000",
        "id": 55,
        "className": "Person",
        coords: [
            136.0,
            180.0,
            175.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:03.700000",
        "id": 47,
        "className": "Person",
        coords: [
            498.0,
            179.0,
            544.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:03.700000",
        "id": 53,
        "className": "Person",
        coords: [
            29.0,
            217.0,
            81.0,
            359.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:03.800000",
        "id": 52,
        "className": "Person",
        coords: [
            479.0,
            244.0,
            548.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:03.800000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            290.0,
            375.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:03.900000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:03.900000",
        "id": 55,
        "className": "Person",
        coords: [
            136.0,
            180.0,
            175.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:03.900000",
        "id": 53,
        "className": "Person",
        coords: [
            29.0,
            217.0,
            81.0,
            359.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:03.900000",
        "id": 45,
        "className": "Person",
        coords: [
            340.0,
            540.0,
            462.0,
            710.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:04",
        "id": 52,
        "className": "Person",
        coords: [
            478.0,
            244.0,
            548.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:04",
        "id": 51,
        "className": "Person",
        coords: [
            319.0,
            290.0,
            375.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:04",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:04",
        "id": 55,
        "className": "Person",
        coords: [
            136.0,
            181.0,
            173.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:04.100000",
        "id": 53,
        "className": "Person",
        coords: [
            32.0,
            215.0,
            85.0,
            359.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:04.100000",
        "id": 45,
        "className": "Person",
        coords: [
            338.0,
            540.0,
            463.0,
            714.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:04.100000",
        "id": 47,
        "className": "Person",
        coords: [
            500.0,
            179.0,
            545.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:04.200000",
        "id": 52,
        "className": "Person",
        coords: [
            478.0,
            243.0,
            548.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:04.200000",
        "id": 51,
        "className": "Person",
        coords: [
            319.0,
            290.0,
            376.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:04.200000",
        "id": 54,
        "className": "Person",
        coords: [
            773.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:04.200000",
        "id": 55,
        "className": "Person",
        coords: [
            135.0,
            182.0,
            173.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:04.300000",
        "id": 53,
        "className": "Person",
        coords: [
            33.0,
            214.0,
            88.0,
            358.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:04.300000",
        "id": 45,
        "className": "Person",
        coords: [
            337.0,
            539.0,
            464.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:04.300000",
        "id": 47,
        "className": "Person",
        coords: [
            500.0,
            179.0,
            545.0,
            261.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:04.400000",
        "id": 52,
        "className": "Person",
        coords: [
            477.0,
            243.0,
            549.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:04.400000",
        "id": 51,
        "className": "Person",
        coords: [
            319.0,
            290.0,
            375.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:04.400000",
        "id": 54,
        "className": "Person",
        coords: [
            773.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:04.400000",
        "id": 55,
        "className": "Person",
        coords: [
            135.0,
            182.0,
            173.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:04.400000",
        "id": 53,
        "className": "Person",
        coords: [
            33.0,
            214.0,
            89.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:04.500000",
        "id": 45,
        "className": "Person",
        coords: [
            337.0,
            539.0,
            464.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:04.500000",
        "id": 52,
        "className": "Person",
        coords: [
            477.0,
            243.0,
            549.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:04.500000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            290.0,
            375.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:04.600000",
        "id": 54,
        "className": "Person",
        coords: [
            773.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:04.600000",
        "id": 55,
        "className": "Person",
        coords: [
            135.0,
            182.0,
            173.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:04.600000",
        "id": 53,
        "className": "Person",
        coords: [
            33.0,
            214.0,
            90.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:04.600000",
        "id": 45,
        "className": "Person",
        coords: [
            337.0,
            539.0,
            464.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:04.700000",
        "id": 52,
        "className": "Person",
        coords: [
            485.0,
            243.0,
            555.0,
            329.0
        ],
        "status": "Moving",
        "speed": 104.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:04.700000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            290.0,
            375.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:04.700000",
        "id": 54,
        "className": "Person",
        coords: [
            773.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:04.700000",
        "id": 55,
        "className": "Person",
        coords: [
            135.0,
            182.0,
            173.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:04.800000",
        "id": 53,
        "className": "Person",
        coords: [
            33.0,
            214.0,
            90.0,
            359.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:04.800000",
        "id": 45,
        "className": "Person",
        coords: [
            337.0,
            539.0,
            464.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:04.900000",
        "id": 52,
        "className": "Person",
        coords: [
            488.0,
            242.0,
            558.0,
            329.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:04.900000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            290.0,
            375.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:04.900000",
        "id": 54,
        "className": "Person",
        coords: [
            773.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:04.900000",
        "id": 55,
        "className": "Person",
        coords: [
            135.0,
            182.0,
            172.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:04.900000",
        "id": 53,
        "className": "Person",
        coords: [
            32.0,
            214.0,
            90.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:05",
        "id": 45,
        "className": "Person",
        coords: [
            337.0,
            539.0,
            464.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:05",
        "id": 52,
        "className": "Person",
        coords: [
            490.0,
            242.0,
            558.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:05",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            290.0,
            375.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:05.100000",
        "id": 54,
        "className": "Person",
        coords: [
            773.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:05.100000",
        "id": 55,
        "className": "Person",
        coords: [
            135.0,
            183.0,
            173.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:05.100000",
        "id": 53,
        "className": "Person",
        coords: [
            32.0,
            214.0,
            89.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:05.100000",
        "id": 45,
        "className": "Person",
        coords: [
            337.0,
            539.0,
            464.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:05.200000",
        "id": 52,
        "className": "Person",
        coords: [
            490.0,
            242.0,
            558.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:05.200000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            290.0,
            375.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:05.200000",
        "id": 54,
        "className": "Person",
        coords: [
            773.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:05.200000",
        "id": 55,
        "className": "Person",
        coords: [
            135.0,
            181.0,
            173.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:05.300000",
        "id": 53,
        "className": "Person",
        coords: [
            31.0,
            214.0,
            89.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:05.300000",
        "id": 45,
        "className": "Person",
        coords: [
            338.0,
            539.0,
            464.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:05.300000",
        "id": 52,
        "className": "Person",
        coords: [
            487.0,
            242.0,
            554.0,
            329.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:05.400000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            290.0,
            375.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:05.400000",
        "id": 54,
        "className": "Person",
        coords: [
            773.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:05.400000",
        "id": 55,
        "className": "Person",
        coords: [
            135.0,
            180.0,
            173.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:05.400000",
        "id": 53,
        "className": "Person",
        coords: [
            30.0,
            214.0,
            89.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:05.400000",
        "id": 45,
        "className": "Person",
        coords: [
            338.0,
            539.0,
            464.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:05.500000",
        "id": 52,
        "className": "Person",
        coords: [
            489.0,
            242.0,
            556.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:05.500000",
        "id": 51,
        "className": "Person",
        coords: [
            319.0,
            290.0,
            375.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:05.500000",
        "id": 54,
        "className": "Person",
        coords: [
            773.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:05.600000",
        "id": 55,
        "className": "Person",
        coords: [
            135.0,
            181.0,
            173.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:05.600000",
        "id": 53,
        "className": "Person",
        coords: [
            30.0,
            214.0,
            89.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:05.600000",
        "id": 45,
        "className": "Person",
        coords: [
            338.0,
            539.0,
            464.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:05.700000",
        "id": 52,
        "className": "Person",
        coords: [
            490.0,
            241.0,
            556.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:05.700000",
        "id": 51,
        "className": "Person",
        coords: [
            319.0,
            290.0,
            376.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:05.700000",
        "id": 54,
        "className": "Person",
        coords: [
            773.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:05.700000",
        "id": 55,
        "className": "Person",
        coords: [
            134.0,
            180.0,
            173.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:05.700000",
        "id": 53,
        "className": "Person",
        coords: [
            30.0,
            215.0,
            89.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:05.800000",
        "id": 45,
        "className": "Person",
        coords: [
            338.0,
            539.0,
            464.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:05.800000",
        "id": 52,
        "className": "Person",
        coords: [
            491.0,
            241.0,
            556.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:05.800000",
        "id": 51,
        "className": "Person",
        coords: [
            319.0,
            290.0,
            376.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:05.900000",
        "id": 54,
        "className": "Person",
        coords: [
            773.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:05.900000",
        "id": 55,
        "className": "Person",
        coords: [
            134.0,
            179.0,
            173.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:05.900000",
        "id": 53,
        "className": "Person",
        coords: [
            29.0,
            214.0,
            88.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:05.900000",
        "id": 45,
        "className": "Person",
        coords: [
            338.0,
            539.0,
            464.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:06",
        "id": 52,
        "className": "Person",
        coords: [
            492.0,
            241.0,
            557.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:06",
        "id": 51,
        "className": "Person",
        coords: [
            319.0,
            290.0,
            375.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:06",
        "id": 54,
        "className": "Person",
        coords: [
            773.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:06.100000",
        "id": 55,
        "className": "Person",
        coords: [
            134.0,
            179.0,
            174.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:06.100000",
        "id": 53,
        "className": "Person",
        coords: [
            28.0,
            214.0,
            88.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:06.100000",
        "id": 45,
        "className": "Person",
        coords: [
            337.0,
            539.0,
            463.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:06.200000",
        "id": 52,
        "className": "Person",
        coords: [
            491.0,
            241.0,
            556.0,
            330.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:06.200000",
        "id": 51,
        "className": "Person",
        coords: [
            319.0,
            290.0,
            376.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:06.200000",
        "id": 54,
        "className": "Person",
        coords: [
            773.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:06.200000",
        "id": 55,
        "className": "Person",
        coords: [
            134.0,
            178.0,
            174.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:06.200000",
        "id": 53,
        "className": "Person",
        coords: [
            28.0,
            214.0,
            88.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:06.300000",
        "id": 45,
        "className": "Person",
        coords: [
            337.0,
            539.0,
            463.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:06.300000",
        "id": 52,
        "className": "Person",
        coords: [
            487.0,
            242.0,
            552.0,
            330.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:06.300000",
        "id": 51,
        "className": "Person",
        coords: [
            319.0,
            289.0,
            376.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:06.400000",
        "id": 54,
        "className": "Person",
        coords: [
            773.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:06.400000",
        "id": 55,
        "className": "Person",
        coords: [
            134.0,
            179.0,
            174.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:06.400000",
        "id": 53,
        "className": "Person",
        coords: [
            28.0,
            214.0,
            88.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:06.400000",
        "id": 45,
        "className": "Person",
        coords: [
            337.0,
            538.0,
            463.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:06.500000",
        "id": 52,
        "className": "Person",
        coords: [
            485.0,
            243.0,
            551.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:06.500000",
        "id": 51,
        "className": "Person",
        coords: [
            319.0,
            289.0,
            376.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:06.500000",
        "id": 54,
        "className": "Person",
        coords: [
            773.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:06.500000",
        "id": 55,
        "className": "Person",
        coords: [
            135.0,
            178.0,
            175.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:06.600000",
        "id": 53,
        "className": "Person",
        coords: [
            27.0,
            214.0,
            86.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:06.600000",
        "id": 45,
        "className": "Person",
        coords: [
            336.0,
            538.0,
            462.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:06.600000",
        "id": 52,
        "className": "Person",
        coords: [
            490.0,
            243.0,
            555.0,
            331.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:06.700000",
        "id": 51,
        "className": "Person",
        coords: [
            320.0,
            289.0,
            376.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:06.700000",
        "id": 54,
        "className": "Person",
        coords: [
            773.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:06.700000",
        "id": 55,
        "className": "Person",
        coords: [
            135.0,
            178.0,
            175.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:06.700000",
        "id": 53,
        "className": "Person",
        coords: [
            27.0,
            214.0,
            86.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:06.800000",
        "id": 45,
        "className": "Person",
        coords: [
            336.0,
            538.0,
            462.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:06.800000",
        "id": 52,
        "className": "Person",
        coords: [
            491.0,
            244.0,
            556.0,
            331.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:06.800000",
        "id": 51,
        "className": "Person",
        coords: [
            320.0,
            289.0,
            376.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:06.800000",
        "id": 54,
        "className": "Person",
        coords: [
            773.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:06.900000",
        "id": 55,
        "className": "Person",
        coords: [
            135.0,
            178.0,
            175.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:06.900000",
        "id": 53,
        "className": "Person",
        coords: [
            27.0,
            214.0,
            86.0,
            357.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:06.900000",
        "id": 45,
        "className": "Person",
        coords: [
            336.0,
            538.0,
            462.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:07",
        "id": 52,
        "className": "Person",
        coords: [
            486.0,
            244.0,
            553.0,
            332.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:07",
        "id": 51,
        "className": "Person",
        coords: [
            320.0,
            289.0,
            376.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:07",
        "id": 54,
        "className": "Person",
        coords: [
            773.0,
            192.0,
            811.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:07",
        "id": 55,
        "className": "Person",
        coords: [
            135.0,
            178.0,
            175.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:07",
        "id": 53,
        "className": "Person",
        coords: [
            27.0,
            214.0,
            87.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:07.100000",
        "id": 45,
        "className": "Person",
        coords: [
            335.0,
            538.0,
            462.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:07.100000",
        "id": 52,
        "className": "Person",
        coords: [
            484.0,
            244.0,
            551.0,
            331.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:07.100000",
        "id": 51,
        "className": "Person",
        coords: [
            320.0,
            289.0,
            376.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:07.200000",
        "id": 54,
        "className": "Person",
        coords: [
            773.0,
            192.0,
            811.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:07.200000",
        "id": 55,
        "className": "Person",
        coords: [
            135.0,
            178.0,
            175.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:07.200000",
        "id": 53,
        "className": "Person",
        coords: [
            27.0,
            214.0,
            87.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:07.200000",
        "id": 45,
        "className": "Person",
        coords: [
            336.0,
            538.0,
            463.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:07.300000",
        "id": 52,
        "className": "Person",
        coords: [
            492.0,
            244.0,
            557.0,
            330.0
        ],
        "status": "Moving",
        "speed": 104.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:07.300000",
        "id": 51,
        "className": "Person",
        coords: [
            320.0,
            289.0,
            376.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:07.300000",
        "id": 54,
        "className": "Person",
        coords: [
            773.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:07.300000",
        "id": 55,
        "className": "Person",
        coords: [
            136.0,
            178.0,
            176.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:07.300000",
        "id": 53,
        "className": "Person",
        coords: [
            28.0,
            214.0,
            87.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:07.400000",
        "id": 45,
        "className": "Person",
        coords: [
            336.0,
            538.0,
            462.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:07.400000",
        "id": 52,
        "className": "Person",
        coords: [
            496.0,
            244.0,
            559.0,
            329.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:07.400000",
        "id": 51,
        "className": "Person",
        coords: [
            320.0,
            289.0,
            376.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:07.500000",
        "id": 54,
        "className": "Person",
        coords: [
            773.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:07.500000",
        "id": 55,
        "className": "Person",
        coords: [
            136.0,
            178.0,
            176.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:07.500000",
        "id": 53,
        "className": "Person",
        coords: [
            28.0,
            214.0,
            88.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:07.500000",
        "id": 45,
        "className": "Person",
        coords: [
            333.0,
            538.0,
            461.0,
            718.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:07.600000",
        "id": 52,
        "className": "Person",
        coords: [
            498.0,
            244.0,
            560.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:07.700000",
        "id": 51,
        "className": "Person",
        coords: [
            320.0,
            289.0,
            376.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:07.700000",
        "id": 54,
        "className": "Person",
        coords: [
            773.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:07.700000",
        "id": 55,
        "className": "Person",
        coords: [
            136.0,
            178.0,
            176.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:07.700000",
        "id": 53,
        "className": "Person",
        coords: [
            28.0,
            214.0,
            88.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:07.700000",
        "id": 45,
        "className": "Person",
        coords: [
            332.0,
            538.0,
            460.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:07.800000",
        "id": 52,
        "className": "Person",
        coords: [
            499.0,
            244.0,
            560.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:07.800000",
        "id": 51,
        "className": "Person",
        coords: [
            320.0,
            289.0,
            375.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:07.800000",
        "id": 54,
        "className": "Person",
        coords: [
            773.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:07.900000",
        "id": 55,
        "className": "Person",
        coords: [
            136.0,
            178.0,
            176.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:07.900000",
        "id": 53,
        "className": "Person",
        coords: [
            28.0,
            214.0,
            88.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:07.900000",
        "id": 45,
        "className": "Person",
        coords: [
            333.0,
            538.0,
            461.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:08",
        "id": 52,
        "className": "Person",
        coords: [
            500.0,
            244.0,
            560.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:08",
        "id": 51,
        "className": "Person",
        coords: [
            319.0,
            290.0,
            374.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:08",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:08",
        "id": 55,
        "className": "Person",
        coords: [
            136.0,
            178.0,
            176.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:08.100000",
        "id": 53,
        "className": "Person",
        coords: [
            27.0,
            214.0,
            87.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:08.100000",
        "id": 45,
        "className": "Person",
        coords: [
            334.0,
            538.0,
            462.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:08.100000",
        "id": 52,
        "className": "Person",
        coords: [
            500.0,
            244.0,
            560.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:08.200000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            290.0,
            374.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:08.200000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:08.200000",
        "id": 55,
        "className": "Person",
        coords: [
            136.0,
            178.0,
            176.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:08.200000",
        "id": 53,
        "className": "Person",
        coords: [
            27.0,
            214.0,
            87.0,
            359.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:08.300000",
        "id": 45,
        "className": "Person",
        coords: [
            334.0,
            538.0,
            462.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:08.300000",
        "id": 52,
        "className": "Person",
        coords: [
            501.0,
            244.0,
            559.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:08.400000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            289.0,
            375.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:08.400000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:08.400000",
        "id": 55,
        "className": "Person",
        coords: [
            136.0,
            178.0,
            176.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:08.400000",
        "id": 53,
        "className": "Person",
        coords: [
            27.0,
            214.0,
            87.0,
            359.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:08.400000",
        "id": 45,
        "className": "Person",
        coords: [
            334.0,
            538.0,
            461.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:08.500000",
        "id": 52,
        "className": "Person",
        coords: [
            501.0,
            244.0,
            558.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:08.500000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            290.0,
            374.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:08.500000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:08.600000",
        "id": 55,
        "className": "Person",
        coords: [
            136.0,
            178.0,
            176.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:08.600000",
        "id": 53,
        "className": "Person",
        coords: [
            27.0,
            215.0,
            87.0,
            359.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:08.600000",
        "id": 45,
        "className": "Person",
        coords: [
            334.0,
            539.0,
            460.0,
            715.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:08.700000",
        "id": 52,
        "className": "Person",
        coords: [
            501.0,
            244.0,
            558.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:08.700000",
        "id": 51,
        "className": "Person",
        coords: [
            317.0,
            290.0,
            374.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:08.700000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:08.700000",
        "id": 55,
        "className": "Person",
        coords: [
            136.0,
            178.0,
            176.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:08.700000",
        "id": 53,
        "className": "Person",
        coords: [
            28.0,
            215.0,
            87.0,
            359.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:08.800000",
        "id": 45,
        "className": "Person",
        coords: [
            332.0,
            539.0,
            460.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:08.800000",
        "id": 52,
        "className": "Person",
        coords: [
            501.0,
            244.0,
            558.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:08.900000",
        "id": 51,
        "className": "Person",
        coords: [
            317.0,
            290.0,
            374.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:08.900000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:08.900000",
        "id": 55,
        "className": "Person",
        coords: [
            136.0,
            178.0,
            175.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:08.900000",
        "id": 53,
        "className": "Person",
        coords: [
            28.0,
            215.0,
            87.0,
            359.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:09",
        "id": 45,
        "className": "Person",
        coords: [
            330.0,
            540.0,
            459.0,
            717.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:09",
        "id": 52,
        "className": "Person",
        coords: [
            501.0,
            244.0,
            557.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:09",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            290.0,
            374.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:09.100000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:09.100000",
        "id": 55,
        "className": "Person",
        coords: [
            136.0,
            178.0,
            175.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:09.100000",
        "id": 53,
        "className": "Person",
        coords: [
            27.0,
            215.0,
            85.0,
            357.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:09.100000",
        "id": 45,
        "className": "Person",
        coords: [
            332.0,
            540.0,
            460.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:09.200000",
        "id": 52,
        "className": "Person",
        coords: [
            502.0,
            245.0,
            557.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:09.200000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            290.0,
            374.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:09.200000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:09.200000",
        "id": 55,
        "className": "Person",
        coords: [
            136.0,
            179.0,
            175.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:09.200000",
        "id": 53,
        "className": "Person",
        coords: [
            27.0,
            215.0,
            84.0,
            357.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:09.300000",
        "id": 45,
        "className": "Person",
        coords: [
            333.0,
            540.0,
            461.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:09.300000",
        "id": 52,
        "className": "Person",
        coords: [
            502.0,
            245.0,
            557.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:09.400000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            291.0,
            374.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:09.400000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:09.400000",
        "id": 55,
        "className": "Person",
        coords: [
            136.0,
            179.0,
            175.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:09.400000",
        "id": 53,
        "className": "Person",
        coords: [
            27.0,
            215.0,
            84.0,
            357.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:09.400000",
        "id": 45,
        "className": "Person",
        coords: [
            333.0,
            540.0,
            461.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:09.500000",
        "id": 52,
        "className": "Person",
        coords: [
            502.0,
            245.0,
            557.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:09.500000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            290.0,
            374.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:09.500000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:09.600000",
        "id": 55,
        "className": "Person",
        coords: [
            135.0,
            178.0,
            175.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:09.600000",
        "id": 53,
        "className": "Person",
        coords: [
            27.0,
            215.0,
            84.0,
            356.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:09.600000",
        "id": 45,
        "className": "Person",
        coords: [
            333.0,
            540.0,
            462.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:09.700000",
        "id": 52,
        "className": "Person",
        coords: [
            502.0,
            245.0,
            556.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:09.700000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            290.0,
            374.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:09.700000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:09.700000",
        "id": 55,
        "className": "Person",
        coords: [
            135.0,
            178.0,
            175.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:09.700000",
        "id": 53,
        "className": "Person",
        coords: [
            27.0,
            216.0,
            83.0,
            356.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:09.800000",
        "id": 45,
        "className": "Person",
        coords: [
            333.0,
            540.0,
            462.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:09.800000",
        "id": 52,
        "className": "Person",
        coords: [
            502.0,
            245.0,
            556.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:09.800000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            290.0,
            374.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:09.900000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:09.900000",
        "id": 55,
        "className": "Person",
        coords: [
            134.0,
            178.0,
            174.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:09.900000",
        "id": 53,
        "className": "Person",
        coords: [
            27.0,
            216.0,
            83.0,
            356.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:09.900000",
        "id": 45,
        "className": "Person",
        coords: [
            334.0,
            540.0,
            463.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:10",
        "id": 52,
        "className": "Person",
        coords: [
            502.0,
            245.0,
            556.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:10",
        "id": 51,
        "className": "Person",
        coords: [
            319.0,
            290.0,
            374.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:10.100000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:10.100000",
        "id": 55,
        "className": "Person",
        coords: [
            134.0,
            178.0,
            174.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:10.100000",
        "id": 53,
        "className": "Person",
        coords: [
            27.0,
            217.0,
            83.0,
            356.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:10.100000",
        "id": 45,
        "className": "Person",
        coords: [
            334.0,
            540.0,
            463.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:10.200000",
        "id": 52,
        "className": "Person",
        coords: [
            503.0,
            245.0,
            556.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:10.200000",
        "id": 51,
        "className": "Person",
        coords: [
            319.0,
            290.0,
            374.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:10.200000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:10.200000",
        "id": 55,
        "className": "Person",
        coords: [
            134.0,
            177.0,
            174.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:10.300000",
        "id": 53,
        "className": "Person",
        coords: [
            28.0,
            217.0,
            83.0,
            357.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:10.300000",
        "id": 45,
        "className": "Person",
        coords: [
            334.0,
            540.0,
            463.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:10.300000",
        "id": 52,
        "className": "Person",
        coords: [
            503.0,
            245.0,
            556.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:10.300000",
        "id": 51,
        "className": "Person",
        coords: [
            319.0,
            290.0,
            374.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:10.400000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:10.400000",
        "id": 55,
        "className": "Person",
        coords: [
            134.0,
            178.0,
            175.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:10.400000",
        "id": 53,
        "className": "Person",
        coords: [
            27.0,
            218.0,
            82.0,
            356.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:10.400000",
        "id": 45,
        "className": "Person",
        coords: [
            334.0,
            541.0,
            463.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:10.500000",
        "id": 52,
        "className": "Person",
        coords: [
            503.0,
            245.0,
            556.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:10.500000",
        "id": 51,
        "className": "Person",
        coords: [
            319.0,
            290.0,
            374.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:10.500000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:10.500000",
        "id": 55,
        "className": "Person",
        coords: [
            134.0,
            178.0,
            175.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:10.600000",
        "id": 53,
        "className": "Person",
        coords: [
            27.0,
            218.0,
            82.0,
            356.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:10.600000",
        "id": 45,
        "className": "Person",
        coords: [
            334.0,
            541.0,
            463.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:10.700000",
        "id": 52,
        "className": "Person",
        coords: [
            503.0,
            245.0,
            556.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:10.700000",
        "id": 51,
        "className": "Person",
        coords: [
            319.0,
            290.0,
            374.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:10.700000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:10.700000",
        "id": 55,
        "className": "Person",
        coords: [
            134.0,
            178.0,
            175.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:10.700000",
        "id": 53,
        "className": "Person",
        coords: [
            27.0,
            218.0,
            82.0,
            356.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:10.800000",
        "id": 45,
        "className": "Person",
        coords: [
            333.0,
            541.0,
            463.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:10.800000",
        "id": 52,
        "className": "Person",
        coords: [
            503.0,
            245.0,
            555.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:10.800000",
        "id": 51,
        "className": "Person",
        coords: [
            319.0,
            290.0,
            374.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:10.900000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:10.900000",
        "id": 55,
        "className": "Person",
        coords: [
            134.0,
            178.0,
            175.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:10.900000",
        "id": 53,
        "className": "Person",
        coords: [
            27.0,
            217.0,
            82.0,
            356.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:10.900000",
        "id": 45,
        "className": "Person",
        coords: [
            333.0,
            541.0,
            463.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:11",
        "id": 52,
        "className": "Person",
        coords: [
            503.0,
            245.0,
            555.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:11",
        "id": 51,
        "className": "Person",
        coords: [
            319.0,
            290.0,
            374.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:11",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:11",
        "id": 55,
        "className": "Person",
        coords: [
            134.0,
            178.0,
            175.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:11",
        "id": 53,
        "className": "Person",
        coords: [
            27.0,
            217.0,
            82.0,
            356.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:11.100000",
        "id": 45,
        "className": "Person",
        coords: [
            332.0,
            540.0,
            463.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:11.100000",
        "id": 52,
        "className": "Person",
        coords: [
            503.0,
            245.0,
            555.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:11.200000",
        "id": 51,
        "className": "Person",
        coords: [
            319.0,
            290.0,
            374.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:11.200000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:11.200000",
        "id": 55,
        "className": "Person",
        coords: [
            134.0,
            178.0,
            175.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:11.200000",
        "id": 53,
        "className": "Person",
        coords: [
            27.0,
            218.0,
            81.0,
            356.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:11.200000",
        "id": 45,
        "className": "Person",
        coords: [
            333.0,
            540.0,
            463.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:11.300000",
        "id": 52,
        "className": "Person",
        coords: [
            503.0,
            245.0,
            555.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:11.300000",
        "id": 51,
        "className": "Person",
        coords: [
            319.0,
            290.0,
            374.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:11.300000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:11.300000",
        "id": 55,
        "className": "Person",
        coords: [
            134.0,
            178.0,
            175.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:11.400000",
        "id": 53,
        "className": "Person",
        coords: [
            27.0,
            217.0,
            82.0,
            356.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:11.400000",
        "id": 45,
        "className": "Person",
        coords: [
            334.0,
            540.0,
            464.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:11.400000",
        "id": 52,
        "className": "Person",
        coords: [
            502.0,
            245.0,
            554.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:11.500000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            290.0,
            373.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:11.500000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:11.500000",
        "id": 55,
        "className": "Person",
        coords: [
            134.0,
            178.0,
            175.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:11.500000",
        "id": 53,
        "className": "Person",
        coords: [
            28.0,
            217.0,
            82.0,
            356.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:11.500000",
        "id": 45,
        "className": "Person",
        coords: [
            335.0,
            540.0,
            465.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:11.600000",
        "id": 52,
        "className": "Person",
        coords: [
            502.0,
            244.0,
            554.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:11.600000",
        "id": 51,
        "className": "Person",
        coords: [
            316.0,
            290.0,
            371.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:11.600000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:11.700000",
        "id": 55,
        "className": "Person",
        coords: [
            134.0,
            178.0,
            175.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:11.700000",
        "id": 53,
        "className": "Person",
        coords: [
            27.0,
            216.0,
            82.0,
            356.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:11.700000",
        "id": 45,
        "className": "Person",
        coords: [
            335.0,
            539.0,
            465.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:11.800000",
        "id": 52,
        "className": "Person",
        coords: [
            501.0,
            244.0,
            554.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:11.800000",
        "id": 51,
        "className": "Person",
        coords: [
            316.0,
            290.0,
            371.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:11.800000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:11.800000",
        "id": 55,
        "className": "Person",
        coords: [
            134.0,
            179.0,
            175.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:11.800000",
        "id": 53,
        "className": "Person",
        coords: [
            27.0,
            216.0,
            82.0,
            356.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:11.900000",
        "id": 45,
        "className": "Person",
        coords: [
            336.0,
            539.0,
            465.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:11.900000",
        "id": 52,
        "className": "Person",
        coords: [
            501.0,
            244.0,
            554.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:11.900000",
        "id": 51,
        "className": "Person",
        coords: [
            315.0,
            290.0,
            371.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:12",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:12",
        "id": 55,
        "className": "Person",
        coords: [
            134.0,
            179.0,
            174.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:12",
        "id": 53,
        "className": "Person",
        coords: [
            27.0,
            216.0,
            81.0,
            356.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:12",
        "id": 45,
        "className": "Person",
        coords: [
            336.0,
            539.0,
            465.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:12.100000",
        "id": 52,
        "className": "Person",
        coords: [
            502.0,
            245.0,
            555.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:12.100000",
        "id": 51,
        "className": "Person",
        coords: [
            315.0,
            290.0,
            371.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:12.100000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            192.0,
            811.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:12.100000",
        "id": 55,
        "className": "Person",
        coords: [
            134.0,
            178.0,
            175.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:12.200000",
        "id": 53,
        "className": "Person",
        coords: [
            27.0,
            216.0,
            81.0,
            356.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:12.200000",
        "id": 45,
        "className": "Person",
        coords: [
            336.0,
            539.0,
            465.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:12.200000",
        "id": 52,
        "className": "Person",
        coords: [
            503.0,
            245.0,
            555.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:12.200000",
        "id": 51,
        "className": "Person",
        coords: [
            315.0,
            290.0,
            372.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:12.300000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            193.0,
            811.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:12.300000",
        "id": 55,
        "className": "Person",
        coords: [
            134.0,
            178.0,
            174.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:12.300000",
        "id": 53,
        "className": "Person",
        coords: [
            27.0,
            217.0,
            81.0,
            356.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:12.300000",
        "id": 45,
        "className": "Person",
        coords: [
            336.0,
            539.0,
            465.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:12.400000",
        "id": 52,
        "className": "Person",
        coords: [
            503.0,
            245.0,
            555.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:12.400000",
        "id": 51,
        "className": "Person",
        coords: [
            315.0,
            290.0,
            372.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:12.400000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            193.0,
            811.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:12.400000",
        "id": 55,
        "className": "Person",
        coords: [
            134.0,
            178.0,
            174.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:12.500000",
        "id": 53,
        "className": "Person",
        coords: [
            28.0,
            217.0,
            81.0,
            356.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:12.500000",
        "id": 45,
        "className": "Person",
        coords: [
            336.0,
            539.0,
            465.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:12.500000",
        "id": 52,
        "className": "Person",
        coords: [
            503.0,
            245.0,
            555.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:12.600000",
        "id": 51,
        "className": "Person",
        coords: [
            315.0,
            290.0,
            372.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:12.600000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            193.0,
            811.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:12.600000",
        "id": 55,
        "className": "Person",
        coords: [
            134.0,
            178.0,
            174.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:12.600000",
        "id": 53,
        "className": "Person",
        coords: [
            28.0,
            218.0,
            81.0,
            356.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:12.600000",
        "id": 45,
        "className": "Person",
        coords: [
            336.0,
            539.0,
            465.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:12.700000",
        "id": 52,
        "className": "Person",
        coords: [
            503.0,
            245.0,
            555.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:12.700000",
        "id": 51,
        "className": "Person",
        coords: [
            315.0,
            290.0,
            372.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:12.700000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            811.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:12.800000",
        "id": 55,
        "className": "Person",
        coords: [
            134.0,
            178.0,
            174.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:12.800000",
        "id": 53,
        "className": "Person",
        coords: [
            28.0,
            218.0,
            80.0,
            355.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:12.800000",
        "id": 45,
        "className": "Person",
        coords: [
            336.0,
            539.0,
            464.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:12.900000",
        "id": 52,
        "className": "Person",
        coords: [
            503.0,
            245.0,
            555.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:12.900000",
        "id": 51,
        "className": "Person",
        coords: [
            315.0,
            290.0,
            373.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:12.900000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            810.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:12.900000",
        "id": 55,
        "className": "Person",
        coords: [
            134.0,
            179.0,
            174.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:12.900000",
        "id": 53,
        "className": "Person",
        coords: [
            28.0,
            218.0,
            80.0,
            355.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:13",
        "id": 45,
        "className": "Person",
        coords: [
            336.0,
            539.0,
            464.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:13.100000",
        "id": 52,
        "className": "Person",
        coords: [
            503.0,
            245.0,
            555.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:13.100000",
        "id": 51,
        "className": "Person",
        coords: [
            316.0,
            290.0,
            373.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:13.100000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            810.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:13.100000",
        "id": 55,
        "className": "Person",
        coords: [
            134.0,
            179.0,
            174.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:13.100000",
        "id": 53,
        "className": "Person",
        coords: [
            27.0,
            219.0,
            79.0,
            355.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:13.200000",
        "id": 45,
        "className": "Person",
        coords: [
            336.0,
            539.0,
            464.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:13.200000",
        "id": 52,
        "className": "Person",
        coords: [
            503.0,
            245.0,
            555.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:13.200000",
        "id": 51,
        "className": "Person",
        coords: [
            316.0,
            290.0,
            374.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:13.300000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            810.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:13.300000",
        "id": 55,
        "className": "Person",
        coords: [
            134.0,
            179.0,
            174.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:13.300000",
        "id": 53,
        "className": "Person",
        coords: [
            27.0,
            219.0,
            79.0,
            355.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:13.300000",
        "id": 45,
        "className": "Person",
        coords: [
            336.0,
            539.0,
            464.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:13.400000",
        "id": 52,
        "className": "Person",
        coords: [
            503.0,
            245.0,
            555.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:13.400000",
        "id": 51,
        "className": "Person",
        coords: [
            316.0,
            290.0,
            374.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:13.400000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            811.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:13.400000",
        "id": 55,
        "className": "Person",
        coords: [
            134.0,
            179.0,
            174.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:13.500000",
        "id": 53,
        "className": "Person",
        coords: [
            28.0,
            219.0,
            79.0,
            355.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:13.500000",
        "id": 45,
        "className": "Person",
        coords: [
            336.0,
            539.0,
            464.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:13.500000",
        "id": 52,
        "className": "Person",
        coords: [
            502.0,
            245.0,
            554.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:13.600000",
        "id": 51,
        "className": "Person",
        coords: [
            316.0,
            290.0,
            374.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:13.600000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:13.600000",
        "id": 55,
        "className": "Person",
        coords: [
            134.0,
            178.0,
            174.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:13.600000",
        "id": 53,
        "className": "Person",
        coords: [
            28.0,
            219.0,
            79.0,
            355.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:13.600000",
        "id": 45,
        "className": "Person",
        coords: [
            336.0,
            539.0,
            464.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:13.700000",
        "id": 52,
        "className": "Person",
        coords: [
            499.0,
            245.0,
            552.0,
            326.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:13.700000",
        "id": 51,
        "className": "Person",
        coords: [
            316.0,
            290.0,
            374.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:13.700000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:13.800000",
        "id": 55,
        "className": "Person",
        coords: [
            135.0,
            178.0,
            174.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:13.800000",
        "id": 53,
        "className": "Person",
        coords: [
            28.0,
            219.0,
            79.0,
            355.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:13.800000",
        "id": 45,
        "className": "Person",
        coords: [
            336.0,
            539.0,
            464.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:13.900000",
        "id": 52,
        "className": "Person",
        coords: [
            492.0,
            244.0,
            548.0,
            328.0
        ],
        "status": "Moving",
        "speed": 76.48,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:13.900000",
        "id": 51,
        "className": "Person",
        coords: [
            317.0,
            290.0,
            376.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:13.900000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:13.900000",
        "id": 55,
        "className": "Person",
        coords: [
            135.0,
            179.0,
            174.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:13.900000",
        "id": 53,
        "className": "Person",
        coords: [
            28.0,
            217.0,
            80.0,
            357.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:14",
        "id": 45,
        "className": "Person",
        coords: [
            335.0,
            539.0,
            464.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:14",
        "id": 52,
        "className": "Person",
        coords: [
            489.0,
            244.0,
            547.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:14",
        "id": 51,
        "className": "Person",
        coords: [
            317.0,
            290.0,
            376.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:14.100000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:14.100000",
        "id": 55,
        "className": "Person",
        coords: [
            135.0,
            180.0,
            174.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:14.100000",
        "id": 53,
        "className": "Person",
        coords: [
            27.0,
            216.0,
            80.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:14.100000",
        "id": 45,
        "className": "Person",
        coords: [
            335.0,
            539.0,
            463.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:14.200000",
        "id": 52,
        "className": "Person",
        coords: [
            488.0,
            244.0,
            548.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:14.200000",
        "id": 51,
        "className": "Person",
        coords: [
            317.0,
            290.0,
            377.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:14.200000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:14.300000",
        "id": 55,
        "className": "Person",
        coords: [
            135.0,
            180.0,
            174.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:14.300000",
        "id": 53,
        "className": "Person",
        coords: [
            27.0,
            216.0,
            80.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:14.300000",
        "id": 45,
        "className": "Person",
        coords: [
            335.0,
            539.0,
            463.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:14.400000",
        "id": 52,
        "className": "Person",
        coords: [
            487.0,
            244.0,
            548.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:14.400000",
        "id": 51,
        "className": "Person",
        coords: [
            317.0,
            290.0,
            377.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:14.400000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:14.400000",
        "id": 55,
        "className": "Person",
        coords: [
            135.0,
            180.0,
            174.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:14.400000",
        "id": 53,
        "className": "Person",
        coords: [
            28.0,
            216.0,
            80.0,
            359.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:14.500000",
        "id": 45,
        "className": "Person",
        coords: [
            335.0,
            539.0,
            463.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:14.500000",
        "id": 52,
        "className": "Person",
        coords: [
            487.0,
            244.0,
            549.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:14.500000",
        "id": 51,
        "className": "Person",
        coords: [
            317.0,
            290.0,
            377.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:14.600000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:14.600000",
        "id": 55,
        "className": "Person",
        coords: [
            135.0,
            180.0,
            174.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:14.600000",
        "id": 53,
        "className": "Person",
        coords: [
            28.0,
            214.0,
            81.0,
            359.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:14.600000",
        "id": 45,
        "className": "Person",
        coords: [
            335.0,
            539.0,
            463.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:14.700000",
        "id": 52,
        "className": "Person",
        coords: [
            486.0,
            244.0,
            549.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:14.700000",
        "id": 51,
        "className": "Person",
        coords: [
            317.0,
            290.0,
            377.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:14.700000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:14.700000",
        "id": 55,
        "className": "Person",
        coords: [
            135.0,
            180.0,
            174.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:14.800000",
        "id": 53,
        "className": "Person",
        coords: [
            27.0,
            213.0,
            81.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:14.800000",
        "id": 45,
        "className": "Person",
        coords: [
            335.0,
            539.0,
            463.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:14.800000",
        "id": 52,
        "className": "Person",
        coords: [
            486.0,
            244.0,
            550.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:14.900000",
        "id": 51,
        "className": "Person",
        coords: [
            317.0,
            290.0,
            377.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:14.900000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:14.900000",
        "id": 55,
        "className": "Person",
        coords: [
            135.0,
            180.0,
            174.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:14.900000",
        "id": 53,
        "className": "Person",
        coords: [
            28.0,
            213.0,
            81.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:14.900000",
        "id": 45,
        "className": "Person",
        coords: [
            335.0,
            539.0,
            464.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:15",
        "id": 52,
        "className": "Person",
        coords: [
            486.0,
            244.0,
            551.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:15",
        "id": 51,
        "className": "Person",
        coords: [
            317.0,
            290.0,
            378.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:15",
        "id": 54,
        "className": "Person",
        coords: [
            773.0,
            194.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:15.100000",
        "id": 55,
        "className": "Person",
        coords: [
            135.0,
            180.0,
            174.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:15.100000",
        "id": 53,
        "className": "Person",
        coords: [
            28.0,
            211.0,
            82.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:15.100000",
        "id": 45,
        "className": "Person",
        coords: [
            335.0,
            539.0,
            464.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:15.200000",
        "id": 52,
        "className": "Person",
        coords: [
            486.0,
            245.0,
            552.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:15.200000",
        "id": 51,
        "className": "Person",
        coords: [
            317.0,
            290.0,
            378.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:15.200000",
        "id": 54,
        "className": "Person",
        coords: [
            773.0,
            194.0,
            811.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:15.200000",
        "id": 55,
        "className": "Person",
        coords: [
            135.0,
            180.0,
            174.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:15.300000",
        "id": 53,
        "className": "Person",
        coords: [
            28.0,
            211.0,
            82.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:15.300000",
        "id": 45,
        "className": "Person",
        coords: [
            335.0,
            539.0,
            464.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:15.400000",
        "id": 52,
        "className": "Person",
        coords: [
            486.0,
            245.0,
            552.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:15.400000",
        "id": 51,
        "className": "Person",
        coords: [
            317.0,
            290.0,
            378.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:15.400000",
        "id": 54,
        "className": "Person",
        coords: [
            773.0,
            194.0,
            812.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:15.400000",
        "id": 55,
        "className": "Person",
        coords: [
            135.0,
            180.0,
            174.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:15.500000",
        "id": 53,
        "className": "Person",
        coords: [
            29.0,
            212.0,
            82.0,
            359.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:15.500000",
        "id": 45,
        "className": "Person",
        coords: [
            335.0,
            539.0,
            464.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:15.500000",
        "id": 52,
        "className": "Person",
        coords: [
            487.0,
            245.0,
            553.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:15.600000",
        "id": 51,
        "className": "Person",
        coords: [
            317.0,
            290.0,
            378.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:15.600000",
        "id": 54,
        "className": "Person",
        coords: [
            773.0,
            194.0,
            812.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:15.600000",
        "id": 55,
        "className": "Person",
        coords: [
            135.0,
            180.0,
            174.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:15.600000",
        "id": 53,
        "className": "Person",
        coords: [
            29.0,
            212.0,
            82.0,
            359.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:15.700000",
        "id": 45,
        "className": "Person",
        coords: [
            335.0,
            539.0,
            464.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:15.700000",
        "id": 52,
        "className": "Person",
        coords: [
            487.0,
            244.0,
            553.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:15.700000",
        "id": 51,
        "className": "Person",
        coords: [
            317.0,
            290.0,
            378.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:15.800000",
        "id": 54,
        "className": "Person",
        coords: [
            773.0,
            194.0,
            812.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:15.800000",
        "id": 55,
        "className": "Person",
        coords: [
            134.0,
            179.0,
            174.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:15.800000",
        "id": 53,
        "className": "Person",
        coords: [
            29.0,
            212.0,
            82.0,
            359.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:15.800000",
        "id": 45,
        "className": "Person",
        coords: [
            335.0,
            539.0,
            464.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:15.900000",
        "id": 52,
        "className": "Person",
        coords: [
            487.0,
            244.0,
            553.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:15.900000",
        "id": 51,
        "className": "Person",
        coords: [
            316.0,
            290.0,
            379.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:15.900000",
        "id": 54,
        "className": "Person",
        coords: [
            773.0,
            194.0,
            812.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:15.900000",
        "id": 55,
        "className": "Person",
        coords: [
            134.0,
            178.0,
            174.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:16",
        "id": 53,
        "className": "Person",
        coords: [
            29.0,
            211.0,
            82.0,
            359.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:16",
        "id": 45,
        "className": "Person",
        coords: [
            335.0,
            539.0,
            464.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:16",
        "id": 52,
        "className": "Person",
        coords: [
            486.0,
            244.0,
            553.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:16.100000",
        "id": 51,
        "className": "Person",
        coords: [
            316.0,
            290.0,
            379.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:16.100000",
        "id": 54,
        "className": "Person",
        coords: [
            773.0,
            194.0,
            812.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:16.100000",
        "id": 55,
        "className": "Person",
        coords: [
            134.0,
            178.0,
            174.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:16.100000",
        "id": 53,
        "className": "Person",
        coords: [
            28.0,
            211.0,
            81.0,
            359.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:16.100000",
        "id": 45,
        "className": "Person",
        coords: [
            335.0,
            539.0,
            464.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:16.200000",
        "id": 52,
        "className": "Person",
        coords: [
            485.0,
            244.0,
            553.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:16.200000",
        "id": 51,
        "className": "Person",
        coords: [
            317.0,
            290.0,
            379.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:16.200000",
        "id": 54,
        "className": "Person",
        coords: [
            773.0,
            194.0,
            812.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:16.300000",
        "id": 55,
        "className": "Person",
        coords: [
            134.0,
            178.0,
            174.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:16.300000",
        "id": 53,
        "className": "Person",
        coords: [
            29.0,
            211.0,
            82.0,
            359.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:16.300000",
        "id": 45,
        "className": "Person",
        coords: [
            335.0,
            539.0,
            464.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:16.400000",
        "id": 52,
        "className": "Person",
        coords: [
            484.0,
            244.0,
            553.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:16.400000",
        "id": 51,
        "className": "Person",
        coords: [
            316.0,
            290.0,
            379.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:16.400000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            812.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:16.400000",
        "id": 55,
        "className": "Person",
        coords: [
            134.0,
            179.0,
            174.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:16.400000",
        "id": 53,
        "className": "Person",
        coords: [
            28.0,
            212.0,
            82.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:16.500000",
        "id": 45,
        "className": "Person",
        coords: [
            335.0,
            539.0,
            463.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:16.500000",
        "id": 52,
        "className": "Person",
        coords: [
            483.0,
            245.0,
            552.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:16.600000",
        "id": 51,
        "className": "Person",
        coords: [
            316.0,
            290.0,
            380.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:16.600000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            811.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:16.600000",
        "id": 55,
        "className": "Person",
        coords: [
            134.0,
            179.0,
            174.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:16.600000",
        "id": 53,
        "className": "Person",
        coords: [
            30.0,
            212.0,
            83.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:16.600000",
        "id": 45,
        "className": "Person",
        coords: [
            335.0,
            539.0,
            464.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:16.700000",
        "id": 52,
        "className": "Person",
        coords: [
            483.0,
            245.0,
            552.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:16.700000",
        "id": 51,
        "className": "Person",
        coords: [
            316.0,
            290.0,
            380.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:16.700000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            811.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:16.800000",
        "id": 55,
        "className": "Person",
        coords: [
            134.0,
            179.0,
            173.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:16.800000",
        "id": 53,
        "className": "Person",
        coords: [
            30.0,
            211.0,
            84.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:16.800000",
        "id": 45,
        "className": "Person",
        coords: [
            335.0,
            538.0,
            464.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:16.900000",
        "id": 52,
        "className": "Person",
        coords: [
            483.0,
            245.0,
            553.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:16.900000",
        "id": 51,
        "className": "Person",
        coords: [
            316.0,
            290.0,
            380.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:16.900000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            811.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:17",
        "id": 55,
        "className": "Person",
        coords: [
            134.0,
            179.0,
            173.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:17",
        "id": 53,
        "className": "Person",
        coords: [
            29.0,
            211.0,
            84.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:17",
        "id": 45,
        "className": "Person",
        coords: [
            335.0,
            538.0,
            464.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:17.100000",
        "id": 52,
        "className": "Person",
        coords: [
            483.0,
            245.0,
            553.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:17.100000",
        "id": 51,
        "className": "Person",
        coords: [
            316.0,
            290.0,
            380.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:17.100000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            811.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:17.100000",
        "id": 55,
        "className": "Person",
        coords: [
            134.0,
            179.0,
            173.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:17.200000",
        "id": 53,
        "className": "Person",
        coords: [
            29.0,
            211.0,
            84.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:17.200000",
        "id": 45,
        "className": "Person",
        coords: [
            335.0,
            538.0,
            464.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:17.200000",
        "id": 52,
        "className": "Person",
        coords: [
            482.0,
            245.0,
            553.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:17.300000",
        "id": 51,
        "className": "Person",
        coords: [
            316.0,
            290.0,
            380.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:17.300000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            811.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:17.300000",
        "id": 55,
        "className": "Person",
        coords: [
            134.0,
            179.0,
            173.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:17.300000",
        "id": 53,
        "className": "Person",
        coords: [
            29.0,
            210.0,
            85.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:17.400000",
        "id": 45,
        "className": "Person",
        coords: [
            334.0,
            538.0,
            463.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:17.400000",
        "id": 52,
        "className": "Person",
        coords: [
            479.0,
            245.0,
            551.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:17.400000",
        "id": 51,
        "className": "Person",
        coords: [
            316.0,
            291.0,
            381.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:17.500000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            811.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:17.500000",
        "id": 55,
        "className": "Person",
        coords: [
            134.0,
            180.0,
            173.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:17.500000",
        "id": 53,
        "className": "Person",
        coords: [
            28.0,
            209.0,
            85.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:17.500000",
        "id": 45,
        "className": "Person",
        coords: [
            334.0,
            538.0,
            463.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:17.600000",
        "id": 52,
        "className": "Person",
        coords: [
            479.0,
            245.0,
            551.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:17.600000",
        "id": 51,
        "className": "Person",
        coords: [
            316.0,
            291.0,
            381.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:17.600000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            811.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:17.700000",
        "id": 55,
        "className": "Person",
        coords: [
            134.0,
            180.0,
            173.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:17.700000",
        "id": 53,
        "className": "Person",
        coords: [
            28.0,
            211.0,
            85.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:17.700000",
        "id": 45,
        "className": "Person",
        coords: [
            334.0,
            538.0,
            463.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:17.800000",
        "id": 52,
        "className": "Person",
        coords: [
            491.0,
            245.0,
            560.0,
            329.0
        ],
        "status": "Moving",
        "speed": 149.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:17.800000",
        "id": 51,
        "className": "Person",
        coords: [
            316.0,
            291.0,
            381.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:17.800000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            811.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:17.900000",
        "id": 55,
        "className": "Person",
        coords: [
            134.0,
            180.0,
            173.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:17.900000",
        "id": 53,
        "className": "Person",
        coords: [
            28.0,
            212.0,
            84.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:17.900000",
        "id": 45,
        "className": "Person",
        coords: [
            332.0,
            539.0,
            462.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:18",
        "id": 52,
        "className": "Person",
        coords: [
            497.0,
            245.0,
            564.0,
            329.0
        ],
        "status": "Moving",
        "speed": 74.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:18",
        "id": 51,
        "className": "Person",
        coords: [
            316.0,
            291.0,
            381.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:18",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            812.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:18",
        "id": 55,
        "className": "Person",
        coords: [
            134.0,
            180.0,
            173.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:18",
        "id": 53,
        "className": "Person",
        coords: [
            28.0,
            215.0,
            84.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:18.100000",
        "id": 45,
        "className": "Person",
        coords: [
            330.0,
            539.0,
            461.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:18.100000",
        "id": 52,
        "className": "Person",
        coords: [
            501.0,
            245.0,
            565.0,
            328.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:18.200000",
        "id": 51,
        "className": "Person",
        coords: [
            316.0,
            291.0,
            381.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:18.200000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            812.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:18.200000",
        "id": 55,
        "className": "Person",
        coords: [
            134.0,
            180.0,
            173.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:18.200000",
        "id": 53,
        "className": "Person",
        coords: [
            28.0,
            213.0,
            85.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:18.300000",
        "id": 45,
        "className": "Person",
        coords: [
            330.0,
            539.0,
            461.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:18.300000",
        "id": 52,
        "className": "Person",
        coords: [
            502.0,
            245.0,
            565.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:18.400000",
        "id": 51,
        "className": "Person",
        coords: [
            317.0,
            291.0,
            381.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:18.400000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            812.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:18.400000",
        "id": 55,
        "className": "Person",
        coords: [
            134.0,
            180.0,
            173.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:18.400000",
        "id": 53,
        "className": "Person",
        coords: [
            27.0,
            211.0,
            85.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:18.400000",
        "id": 45,
        "className": "Person",
        coords: [
            331.0,
            539.0,
            462.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:18.500000",
        "id": 52,
        "className": "Person",
        coords: [
            502.0,
            245.0,
            563.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:18.500000",
        "id": 51,
        "className": "Person",
        coords: [
            317.0,
            291.0,
            382.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:18.600000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            812.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:18.600000",
        "id": 55,
        "className": "Person",
        coords: [
            134.0,
            180.0,
            173.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:18.600000",
        "id": 53,
        "className": "Person",
        coords: [
            27.0,
            215.0,
            84.0,
            358.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:18.600000",
        "id": 45,
        "className": "Person",
        coords: [
            332.0,
            539.0,
            463.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:18.700000",
        "id": 52,
        "className": "Person",
        coords: [
            504.0,
            245.0,
            563.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:18.700000",
        "id": 51,
        "className": "Person",
        coords: [
            317.0,
            290.0,
            382.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:18.700000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            812.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:18.700000",
        "id": 55,
        "className": "Person",
        coords: [
            134.0,
            180.0,
            173.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:18.800000",
        "id": 53,
        "className": "Person",
        coords: [
            26.0,
            216.0,
            83.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:18.800000",
        "id": 45,
        "className": "Person",
        coords: [
            333.0,
            539.0,
            464.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:18.900000",
        "id": 52,
        "className": "Person",
        coords: [
            505.0,
            245.0,
            563.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:18.900000",
        "id": 51,
        "className": "Person",
        coords: [
            317.0,
            290.0,
            382.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:18.900000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            812.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:18.900000",
        "id": 55,
        "className": "Person",
        coords: [
            134.0,
            180.0,
            173.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:19",
        "id": 45,
        "className": "Person",
        coords: [
            334.0,
            539.0,
            464.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:19",
        "id": 52,
        "className": "Person",
        coords: [
            504.0,
            245.0,
            560.0,
            328.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:19.100000",
        "id": 51,
        "className": "Person",
        coords: [
            317.0,
            290.0,
            382.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:19.100000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            812.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:19.100000",
        "id": 55,
        "className": "Person",
        coords: [
            134.0,
            180.0,
            174.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:19.100000",
        "id": 45,
        "className": "Person",
        coords: [
            335.0,
            539.0,
            465.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:19.100000",
        "id": 53,
        "className": "Person",
        coords: [
            26.0,
            219.0,
            82.0,
            359.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:19.200000",
        "id": 52,
        "className": "Person",
        coords: [
            505.0,
            244.0,
            560.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:19.200000",
        "id": 51,
        "className": "Person",
        coords: [
            316.0,
            290.0,
            382.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:19.300000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            811.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:19.300000",
        "id": 55,
        "className": "Person",
        coords: [
            134.0,
            180.0,
            174.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:19.300000",
        "id": 45,
        "className": "Person",
        coords: [
            335.0,
            539.0,
            465.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:19.300000",
        "id": 53,
        "className": "Person",
        coords: [
            27.0,
            220.0,
            81.0,
            359.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:19.400000",
        "id": 52,
        "className": "Person",
        coords: [
            505.0,
            244.0,
            559.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:19.400000",
        "id": 51,
        "className": "Person",
        coords: [
            316.0,
            290.0,
            382.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:19.400000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            811.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:19.400000",
        "id": 55,
        "className": "Person",
        coords: [
            134.0,
            180.0,
            174.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:19.500000",
        "id": 45,
        "className": "Person",
        coords: [
            335.0,
            540.0,
            464.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:19.500000",
        "id": 53,
        "className": "Person",
        coords: [
            27.0,
            220.0,
            81.0,
            359.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:19.600000",
        "id": 52,
        "className": "Person",
        coords: [
            503.0,
            243.0,
            557.0,
            328.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:19.600000",
        "id": 51,
        "className": "Person",
        coords: [
            316.0,
            290.0,
            382.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:19.600000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            811.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:19.600000",
        "id": 55,
        "className": "Person",
        coords: [
            134.0,
            180.0,
            174.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:19.600000",
        "id": 45,
        "className": "Person",
        coords: [
            334.0,
            540.0,
            463.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:19.700000",
        "id": 53,
        "className": "Person",
        coords: [
            27.0,
            220.0,
            81.0,
            359.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:19.700000",
        "id": 52,
        "className": "Person",
        coords: [
            502.0,
            243.0,
            556.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:19.700000",
        "id": 51,
        "className": "Person",
        coords: [
            316.0,
            290.0,
            382.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:19.800000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            811.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:19.800000",
        "id": 55,
        "className": "Person",
        coords: [
            134.0,
            180.0,
            174.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:19.800000",
        "id": 45,
        "className": "Person",
        coords: [
            334.0,
            540.0,
            463.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:19.800000",
        "id": 53,
        "className": "Person",
        coords: [
            28.0,
            220.0,
            81.0,
            359.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:19.900000",
        "id": 52,
        "className": "Person",
        coords: [
            502.0,
            243.0,
            555.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:19.900000",
        "id": 51,
        "className": "Person",
        coords: [
            316.0,
            290.0,
            381.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:19.900000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:19.900000",
        "id": 55,
        "className": "Person",
        coords: [
            134.0,
            180.0,
            174.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:20",
        "id": 45,
        "className": "Person",
        coords: [
            334.0,
            539.0,
            463.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:20",
        "id": 53,
        "className": "Person",
        coords: [
            28.0,
            220.0,
            80.0,
            359.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:20.100000",
        "id": 52,
        "className": "Person",
        coords: [
            502.0,
            243.0,
            555.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:20.100000",
        "id": 51,
        "className": "Person",
        coords: [
            316.0,
            290.0,
            382.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:20.100000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:20.100000",
        "id": 55,
        "className": "Person",
        coords: [
            134.0,
            180.0,
            174.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:20.200000",
        "id": 45,
        "className": "Person",
        coords: [
            334.0,
            540.0,
            463.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:20.200000",
        "id": 53,
        "className": "Person",
        coords: [
            28.0,
            219.0,
            81.0,
            359.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:20.200000",
        "id": 52,
        "className": "Person",
        coords: [
            502.0,
            243.0,
            555.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:20.300000",
        "id": 51,
        "className": "Person",
        coords: [
            316.0,
            290.0,
            382.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:20.300000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:20.300000",
        "id": 55,
        "className": "Person",
        coords: [
            134.0,
            180.0,
            174.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:20.300000",
        "id": 45,
        "className": "Person",
        coords: [
            334.0,
            540.0,
            463.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:20.300000",
        "id": 53,
        "className": "Person",
        coords: [
            29.0,
            218.0,
            81.0,
            359.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:20.400000",
        "id": 52,
        "className": "Person",
        coords: [
            503.0,
            243.0,
            556.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:20.400000",
        "id": 51,
        "className": "Person",
        coords: [
            316.0,
            290.0,
            382.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:20.400000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:20.500000",
        "id": 55,
        "className": "Person",
        coords: [
            133.0,
            179.0,
            174.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:20.500000",
        "id": 45,
        "className": "Person",
        coords: [
            333.0,
            541.0,
            462.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:20.500000",
        "id": 53,
        "className": "Person",
        coords: [
            29.0,
            218.0,
            80.0,
            359.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:20.600000",
        "id": 52,
        "className": "Person",
        coords: [
            505.0,
            243.0,
            557.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:20.600000",
        "id": 51,
        "className": "Person",
        coords: [
            316.0,
            290.0,
            382.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:20.600000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:20.600000",
        "id": 55,
        "className": "Person",
        coords: [
            133.0,
            179.0,
            174.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:20.600000",
        "id": 53,
        "className": "Person",
        coords: [
            29.0,
            218.0,
            80.0,
            359.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:20.700000",
        "id": 52,
        "className": "Person",
        coords: [
            505.0,
            243.0,
            556.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:20.700000",
        "id": 51,
        "className": "Person",
        coords: [
            316.0,
            290.0,
            382.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:20.700000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:20.800000",
        "id": 55,
        "className": "Person",
        coords: [
            133.0,
            179.0,
            174.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:20.800000",
        "id": 53,
        "className": "Person",
        coords: [
            29.0,
            218.0,
            80.0,
            359.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:20.800000",
        "id": 45,
        "className": "Person",
        coords: [
            334.0,
            542.0,
            461.0,
            715.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:20.900000",
        "id": 52,
        "className": "Person",
        coords: [
            505.0,
            243.0,
            556.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:20.900000",
        "id": 51,
        "className": "Person",
        coords: [
            316.0,
            290.0,
            382.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:21",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            811.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:21",
        "id": 55,
        "className": "Person",
        coords: [
            133.0,
            179.0,
            174.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:21",
        "id": 53,
        "className": "Person",
        coords: [
            30.0,
            218.0,
            80.0,
            359.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:21",
        "id": 52,
        "className": "Person",
        coords: [
            505.0,
            243.0,
            555.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:21.100000",
        "id": 51,
        "className": "Person",
        coords: [
            316.0,
            290.0,
            382.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:21.100000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            811.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:21.100000",
        "id": 55,
        "className": "Person",
        coords: [
            133.0,
            179.0,
            174.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:21.100000",
        "id": 53,
        "className": "Person",
        coords: [
            30.0,
            218.0,
            80.0,
            359.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:21.200000",
        "id": 52,
        "className": "Person",
        coords: [
            504.0,
            244.0,
            553.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:21.200000",
        "id": 51,
        "className": "Person",
        coords: [
            316.0,
            290.0,
            382.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:21.200000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            811.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:21.200000",
        "id": 55,
        "className": "Person",
        coords: [
            133.0,
            179.0,
            174.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:21.300000",
        "id": 53,
        "className": "Person",
        coords: [
            29.0,
            219.0,
            79.0,
            359.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:21.300000",
        "id": 45,
        "className": "Person",
        coords: [
            333.0,
            541.0,
            461.0,
            715.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:21.300000",
        "id": 52,
        "className": "Person",
        coords: [
            504.0,
            244.0,
            553.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:21.400000",
        "id": 51,
        "className": "Person",
        coords: [
            315.0,
            290.0,
            382.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:21.400000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            811.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:21.400000",
        "id": 55,
        "className": "Person",
        coords: [
            133.0,
            180.0,
            173.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:21.400000",
        "id": 53,
        "className": "Person",
        coords: [
            31.0,
            218.0,
            81.0,
            359.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:21.400000",
        "id": 45,
        "className": "Person",
        coords: [
            332.0,
            540.0,
            462.0,
            715.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:21.500000",
        "id": 52,
        "className": "Person",
        coords: [
            505.0,
            243.0,
            555.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:21.500000",
        "id": 51,
        "className": "Person",
        coords: [
            316.0,
            290.0,
            382.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:21.500000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            811.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:21.600000",
        "id": 55,
        "className": "Person",
        coords: [
            135.0,
            183.0,
            174.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:21.600000",
        "id": 53,
        "className": "Person",
        coords: [
            33.0,
            218.0,
            83.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:21.600000",
        "id": 45,
        "className": "Person",
        coords: [
            333.0,
            540.0,
            462.0,
            714.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:21.700000",
        "id": 52,
        "className": "Person",
        coords: [
            505.0,
            243.0,
            555.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:21.700000",
        "id": 51,
        "className": "Person",
        coords: [
            316.0,
            290.0,
            383.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:21.700000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            811.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:21.700000",
        "id": 55,
        "className": "Person",
        coords: [
            134.0,
            182.0,
            173.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:21.800000",
        "id": 53,
        "className": "Person",
        coords: [
            32.0,
            218.0,
            82.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:21.800000",
        "id": 45,
        "className": "Person",
        coords: [
            333.0,
            540.0,
            462.0,
            713.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:21.800000",
        "id": 56,
        "className": "Person",
        coords: [
            197.0,
            194.0,
            237.0,
            292.0
        ],
        "status": "First Seen",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:25:21.900000",
        "id": 52,
        "className": "Person",
        coords: [
            504.0,
            242.0,
            555.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:21.900000",
        "id": 51,
        "className": "Person",
        coords: [
            316.0,
            290.0,
            383.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:21.900000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            811.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:21.900000",
        "id": 55,
        "className": "Person",
        coords: [
            134.0,
            182.0,
            173.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:22",
        "id": 53,
        "className": "Person",
        coords: [
            33.0,
            218.0,
            83.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:22",
        "id": 45,
        "className": "Person",
        coords: [
            334.0,
            540.0,
            462.0,
            711.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:22",
        "id": 56,
        "className": "Person",
        coords: [
            197.0,
            194.0,
            237.0,
            292.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:25:22.100000",
        "id": 52,
        "className": "Person",
        coords: [
            505.0,
            242.0,
            555.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:22.100000",
        "id": 51,
        "className": "Person",
        coords: [
            317.0,
            290.0,
            383.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:22.100000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            811.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:22.100000",
        "id": 55,
        "className": "Person",
        coords: [
            134.0,
            181.0,
            173.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:22.100000",
        "id": 53,
        "className": "Person",
        coords: [
            32.0,
            218.0,
            83.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:22.200000",
        "id": 45,
        "className": "Person",
        coords: [
            333.0,
            540.0,
            462.0,
            711.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:22.200000",
        "id": 56,
        "className": "Person",
        coords: [
            197.0,
            194.0,
            237.0,
            292.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:25:22.200000",
        "id": 52,
        "className": "Person",
        coords: [
            505.0,
            242.0,
            555.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:22.300000",
        "id": 51,
        "className": "Person",
        coords: [
            317.0,
            290.0,
            383.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:22.300000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            811.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:22.300000",
        "id": 55,
        "className": "Person",
        coords: [
            134.0,
            181.0,
            174.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:22.300000",
        "id": 53,
        "className": "Person",
        coords: [
            33.0,
            218.0,
            83.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:22.300000",
        "id": 45,
        "className": "Person",
        coords: [
            333.0,
            539.0,
            463.0,
            713.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:22.400000",
        "id": 56,
        "className": "Person",
        coords: [
            197.0,
            194.0,
            237.0,
            292.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Analysing",
        "mask": "Analysing",
        "vest": "Analysing"
    },
    {
        "timestamp": "00:25:22.400000",
        "id": 52,
        "className": "Person",
        coords: [
            505.0,
            243.0,
            555.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:22.400000",
        "id": 51,
        "className": "Person",
        coords: [
            317.0,
            290.0,
            383.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:22.500000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            811.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:22.500000",
        "id": 55,
        "className": "Person",
        coords: [
            134.0,
            179.0,
            174.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:22.500000",
        "id": 53,
        "className": "Person",
        coords: [
            32.0,
            218.0,
            83.0,
            357.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:22.600000",
        "id": 45,
        "className": "Person",
        coords: [
            332.0,
            539.0,
            463.0,
            714.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:22.600000",
        "id": 56,
        "className": "Person",
        coords: [
            197.0,
            194.0,
            237.0,
            292.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:22.600000",
        "id": 52,
        "className": "Person",
        coords: [
            505.0,
            243.0,
            554.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:22.700000",
        "id": 51,
        "className": "Person",
        coords: [
            317.0,
            290.0,
            383.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:22.700000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            811.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:22.700000",
        "id": 55,
        "className": "Person",
        coords: [
            134.0,
            178.0,
            175.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:22.700000",
        "id": 53,
        "className": "Person",
        coords: [
            32.0,
            218.0,
            83.0,
            357.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:22.700000",
        "id": 45,
        "className": "Person",
        coords: [
            332.0,
            539.0,
            464.0,
            715.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:22.800000",
        "id": 56,
        "className": "Person",
        coords: [
            197.0,
            194.0,
            237.0,
            292.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:22.800000",
        "id": 52,
        "className": "Person",
        coords: [
            505.0,
            243.0,
            554.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:22.800000",
        "id": 51,
        "className": "Person",
        coords: [
            317.0,
            290.0,
            383.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:22.900000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            811.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:22.900000",
        "id": 55,
        "className": "Person",
        coords: [
            135.0,
            178.0,
            176.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:22.900000",
        "id": 53,
        "className": "Person",
        coords: [
            32.0,
            218.0,
            83.0,
            357.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:22.900000",
        "id": 45,
        "className": "Person",
        coords: [
            332.0,
            539.0,
            464.0,
            715.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:22.900000",
        "id": 56,
        "className": "Person",
        coords: [
            197.0,
            194.0,
            237.0,
            292.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:23",
        "id": 52,
        "className": "Person",
        coords: [
            505.0,
            243.0,
            554.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:23",
        "id": 51,
        "className": "Person",
        coords: [
            317.0,
            290.0,
            383.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:23",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            811.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:23.100000",
        "id": 55,
        "className": "Person",
        coords: [
            136.0,
            177.0,
            177.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:23.100000",
        "id": 53,
        "className": "Person",
        coords: [
            31.0,
            217.0,
            82.0,
            357.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:23.100000",
        "id": 45,
        "className": "Person",
        coords: [
            332.0,
            539.0,
            464.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:23.100000",
        "id": 56,
        "className": "Person",
        coords: [
            197.0,
            194.0,
            237.0,
            292.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:23.200000",
        "id": 52,
        "className": "Person",
        coords: [
            504.0,
            244.0,
            554.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:23.200000",
        "id": 51,
        "className": "Person",
        coords: [
            317.0,
            290.0,
            383.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:23.200000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            811.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:23.300000",
        "id": 55,
        "className": "Person",
        coords: [
            136.0,
            178.0,
            176.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:23.300000",
        "id": 53,
        "className": "Person",
        coords: [
            31.0,
            218.0,
            82.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:23.300000",
        "id": 45,
        "className": "Person",
        coords: [
            331.0,
            539.0,
            464.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:23.300000",
        "id": 56,
        "className": "Person",
        coords: [
            197.0,
            194.0,
            237.0,
            292.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:23.400000",
        "id": 52,
        "className": "Person",
        coords: [
            504.0,
            244.0,
            553.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:23.400000",
        "id": 51,
        "className": "Person",
        coords: [
            317.0,
            290.0,
            382.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:23.400000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            811.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:23.500000",
        "id": 55,
        "className": "Person",
        coords: [
            136.0,
            178.0,
            176.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:23.500000",
        "id": 53,
        "className": "Person",
        coords: [
            32.0,
            218.0,
            84.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:23.500000",
        "id": 45,
        "className": "Person",
        coords: [
            330.0,
            539.0,
            463.0,
            715.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:23.500000",
        "id": 56,
        "className": "Person",
        coords: [
            197.0,
            194.0,
            237.0,
            292.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:23.600000",
        "id": 52,
        "className": "Person",
        coords: [
            503.0,
            244.0,
            553.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:23.600000",
        "id": 51,
        "className": "Person",
        coords: [
            317.0,
            290.0,
            382.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:23.600000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            811.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:23.600000",
        "id": 55,
        "className": "Person",
        coords: [
            136.0,
            178.0,
            176.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:23.700000",
        "id": 53,
        "className": "Person",
        coords: [
            31.0,
            218.0,
            83.0,
            357.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:23.700000",
        "id": 45,
        "className": "Person",
        coords: [
            333.0,
            538.0,
            459.0,
            704.0
        ],
        "status": "Moving",
        "speed": 89.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:23.700000",
        "id": 56,
        "className": "Person",
        coords: [
            197.0,
            194.0,
            237.0,
            292.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:23.800000",
        "id": 52,
        "className": "Person",
        coords: [
            503.0,
            244.0,
            553.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:23.800000",
        "id": 51,
        "className": "Person",
        coords: [
            317.0,
            290.0,
            382.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:23.800000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            811.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:23.800000",
        "id": 55,
        "className": "Person",
        coords: [
            136.0,
            178.0,
            176.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:23.800000",
        "id": 53,
        "className": "Person",
        coords: [
            31.0,
            219.0,
            82.0,
            357.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:23.900000",
        "id": 45,
        "className": "Person",
        coords: [
            332.0,
            538.0,
            460.0,
            707.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:23.900000",
        "id": 56,
        "className": "Person",
        coords: [
            197.0,
            194.0,
            237.0,
            292.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:24",
        "id": 52,
        "className": "Person",
        coords: [
            503.0,
            244.0,
            553.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:24",
        "id": 51,
        "className": "Person",
        coords: [
            317.0,
            290.0,
            382.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:24",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            811.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:24",
        "id": 55,
        "className": "Person",
        coords: [
            136.0,
            179.0,
            176.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:24",
        "id": 45,
        "className": "Person",
        coords: [
            331.0,
            538.0,
            462.0,
            710.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:24.100000",
        "id": 56,
        "className": "Person",
        coords: [
            197.0,
            194.0,
            237.0,
            292.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:24.100000",
        "id": 52,
        "className": "Person",
        coords: [
            503.0,
            244.0,
            553.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:24.100000",
        "id": 51,
        "className": "Person",
        coords: [
            317.0,
            290.0,
            382.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:24.200000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            811.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:24.200000",
        "id": 55,
        "className": "Person",
        coords: [
            136.0,
            179.0,
            176.0,
            270.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:24.200000",
        "id": 45,
        "className": "Person",
        coords: [
            329.0,
            539.0,
            461.0,
            712.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:24.200000",
        "id": 56,
        "className": "Person",
        coords: [
            197.0,
            194.0,
            237.0,
            292.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:24.300000",
        "id": 52,
        "className": "Person",
        coords: [
            503.0,
            245.0,
            553.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:24.300000",
        "id": 51,
        "className": "Person",
        coords: [
            316.0,
            289.0,
            383.0,
            453.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:24.300000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            195.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:24.300000",
        "id": 55,
        "className": "Person",
        coords: [
            135.0,
            180.0,
            175.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:24.400000",
        "id": 45,
        "className": "Person",
        coords: [
            329.0,
            540.0,
            462.0,
            714.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:24.400000",
        "id": 56,
        "className": "Person",
        coords: [
            197.0,
            195.0,
            236.0,
            292.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:24.400000",
        "id": 53,
        "className": "Person",
        coords: [
            32.0,
            217.0,
            84.0,
            357.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:24.500000",
        "id": 52,
        "className": "Person",
        coords: [
            504.0,
            244.0,
            553.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:24.500000",
        "id": 51,
        "className": "Person",
        coords: [
            317.0,
            289.0,
            383.0,
            453.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:24.500000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            195.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:24.500000",
        "id": 55,
        "className": "Person",
        coords: [
            135.0,
            180.0,
            175.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:24.500000",
        "id": 45,
        "className": "Person",
        coords: [
            332.0,
            540.0,
            464.0,
            715.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:24.600000",
        "id": 56,
        "className": "Person",
        coords: [
            197.0,
            195.0,
            236.0,
            291.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:24.600000",
        "id": 53,
        "className": "Person",
        coords: [
            32.0,
            217.0,
            84.0,
            357.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:24.600000",
        "id": 52,
        "className": "Person",
        coords: [
            504.0,
            245.0,
            553.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:24.700000",
        "id": 51,
        "className": "Person",
        coords: [
            317.0,
            290.0,
            383.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:24.700000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            195.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:24.700000",
        "id": 55,
        "className": "Person",
        coords: [
            135.0,
            180.0,
            175.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:24.700000",
        "id": 45,
        "className": "Person",
        coords: [
            334.0,
            540.0,
            466.0,
            716.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:24.700000",
        "id": 56,
        "className": "Person",
        coords: [
            197.0,
            195.0,
            235.0,
            290.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:24.800000",
        "id": 53,
        "className": "Person",
        coords: [
            32.0,
            217.0,
            84.0,
            357.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:24.800000",
        "id": 52,
        "className": "Person",
        coords: [
            504.0,
            245.0,
            553.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:24.800000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            289.0,
            383.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:24.900000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            195.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:24.900000",
        "id": 55,
        "className": "Person",
        coords: [
            135.0,
            181.0,
            175.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:24.900000",
        "id": 45,
        "className": "Person",
        coords: [
            336.0,
            540.0,
            467.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:24.900000",
        "id": 56,
        "className": "Person",
        coords: [
            196.0,
            196.0,
            234.0,
            290.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:24.900000",
        "id": 53,
        "className": "Person",
        coords: [
            32.0,
            217.0,
            83.0,
            357.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:25",
        "id": 52,
        "className": "Person",
        coords: [
            504.0,
            245.0,
            554.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:25",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            290.0,
            383.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:25.100000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            195.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:25.100000",
        "id": 55,
        "className": "Person",
        coords: [
            135.0,
            181.0,
            175.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:25.100000",
        "id": 45,
        "className": "Person",
        coords: [
            336.0,
            540.0,
            466.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:25.100000",
        "id": 56,
        "className": "Person",
        coords: [
            196.0,
            197.0,
            234.0,
            290.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:25.100000",
        "id": 53,
        "className": "Person",
        coords: [
            32.0,
            217.0,
            83.0,
            357.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:25.200000",
        "id": 52,
        "className": "Person",
        coords: [
            504.0,
            244.0,
            553.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:25.200000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            290.0,
            383.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:25.200000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            195.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:25.200000",
        "id": 55,
        "className": "Person",
        coords: [
            135.0,
            181.0,
            175.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:25.300000",
        "id": 45,
        "className": "Person",
        coords: [
            337.0,
            540.0,
            466.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:25.300000",
        "id": 56,
        "className": "Person",
        coords: [
            197.0,
            198.0,
            233.0,
            289.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:25.300000",
        "id": 53,
        "className": "Person",
        coords: [
            32.0,
            217.0,
            83.0,
            357.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:25.400000",
        "id": 52,
        "className": "Person",
        coords: [
            504.0,
            245.0,
            554.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:25.400000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            290.0,
            383.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:25.400000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            195.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:25.400000",
        "id": 55,
        "className": "Person",
        coords: [
            134.0,
            180.0,
            176.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:25.500000",
        "id": 45,
        "className": "Person",
        coords: [
            337.0,
            541.0,
            466.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:25.500000",
        "id": 56,
        "className": "Person",
        coords: [
            196.0,
            199.0,
            233.0,
            290.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:25.500000",
        "id": 53,
        "className": "Person",
        coords: [
            32.0,
            217.0,
            84.0,
            357.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:25.500000",
        "id": 52,
        "className": "Person",
        coords: [
            505.0,
            245.0,
            554.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:25.600000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            289.0,
            383.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:25.600000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            195.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:25.600000",
        "id": 55,
        "className": "Person",
        coords: [
            134.0,
            180.0,
            176.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:25.600000",
        "id": 45,
        "className": "Person",
        coords: [
            338.0,
            541.0,
            466.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:25.700000",
        "id": 56,
        "className": "Person",
        coords: [
            196.0,
            199.0,
            233.0,
            292.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:25.700000",
        "id": 53,
        "className": "Person",
        coords: [
            32.0,
            217.0,
            84.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:25.700000",
        "id": 52,
        "className": "Person",
        coords: [
            505.0,
            245.0,
            554.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:25.700000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            289.0,
            383.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:25.800000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            195.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:25.800000",
        "id": 55,
        "className": "Person",
        coords: [
            134.0,
            180.0,
            176.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:25.800000",
        "id": 45,
        "className": "Person",
        coords: [
            339.0,
            541.0,
            466.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:25.800000",
        "id": 56,
        "className": "Person",
        coords: [
            196.0,
            199.0,
            234.0,
            293.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:25.800000",
        "id": 53,
        "className": "Person",
        coords: [
            32.0,
            217.0,
            85.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:25.900000",
        "id": 52,
        "className": "Person",
        coords: [
            505.0,
            245.0,
            554.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:25.900000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            289.0,
            383.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:26",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            195.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:26",
        "id": 55,
        "className": "Person",
        coords: [
            134.0,
            180.0,
            176.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:26",
        "id": 45,
        "className": "Person",
        coords: [
            339.0,
            541.0,
            466.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:26",
        "id": 56,
        "className": "Person",
        coords: [
            196.0,
            200.0,
            234.0,
            295.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:26.100000",
        "id": 53,
        "className": "Person",
        coords: [
            33.0,
            217.0,
            85.0,
            357.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:26.100000",
        "id": 52,
        "className": "Person",
        coords: [
            505.0,
            245.0,
            553.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:26.100000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            289.0,
            383.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:26.200000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            195.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:26.200000",
        "id": 55,
        "className": "Person",
        coords: [
            134.0,
            180.0,
            176.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:26.200000",
        "id": 45,
        "className": "Person",
        coords: [
            339.0,
            541.0,
            465.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:26.200000",
        "id": 53,
        "className": "Person",
        coords: [
            33.0,
            217.0,
            86.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:26.300000",
        "id": 52,
        "className": "Person",
        coords: [
            505.0,
            245.0,
            554.0,
            325.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:26.300000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            289.0,
            383.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:26.300000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            195.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:26.400000",
        "id": 55,
        "className": "Person",
        coords: [
            135.0,
            180.0,
            176.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:26.400000",
        "id": 45,
        "className": "Person",
        coords: [
            341.0,
            542.0,
            465.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:26.400000",
        "id": 53,
        "className": "Person",
        coords: [
            33.0,
            217.0,
            85.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:26.400000",
        "id": 52,
        "className": "Person",
        coords: [
            504.0,
            245.0,
            553.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:26.500000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            289.0,
            383.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:26.500000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            195.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:26.500000",
        "id": 55,
        "className": "Person",
        coords: [
            135.0,
            179.0,
            177.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:26.500000",
        "id": 45,
        "className": "Person",
        coords: [
            341.0,
            542.0,
            465.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:26.500000",
        "id": 53,
        "className": "Person",
        coords: [
            33.0,
            217.0,
            86.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:26.600000",
        "id": 52,
        "className": "Person",
        coords: [
            504.0,
            245.0,
            553.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:26.600000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            289.0,
            383.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:26.700000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            195.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:26.700000",
        "id": 55,
        "className": "Person",
        coords: [
            135.0,
            179.0,
            177.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:26.700000",
        "id": 45,
        "className": "Person",
        coords: [
            342.0,
            542.0,
            465.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:26.700000",
        "id": 53,
        "className": "Person",
        coords: [
            33.0,
            216.0,
            86.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:26.800000",
        "id": 52,
        "className": "Person",
        coords: [
            504.0,
            245.0,
            553.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:26.800000",
        "id": 51,
        "className": "Person",
        coords: [
            317.0,
            289.0,
            382.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:26.800000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            195.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:26.800000",
        "id": 55,
        "className": "Person",
        coords: [
            135.0,
            180.0,
            177.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:26.900000",
        "id": 53,
        "className": "Person",
        coords: [
            32.0,
            216.0,
            85.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:26.900000",
        "id": 56,
        "className": "Person",
        coords: [
            195.0,
            203.0,
            231.0,
            292.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:26.900000",
        "id": 52,
        "className": "Person",
        coords: [
            504.0,
            244.0,
            554.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:27",
        "id": 51,
        "className": "Person",
        coords: [
            317.0,
            289.0,
            383.0,
            455.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:27",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:27",
        "id": 55,
        "className": "Person",
        coords: [
            135.0,
            179.0,
            176.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:27",
        "id": 53,
        "className": "Person",
        coords: [
            33.0,
            217.0,
            86.0,
            356.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:27",
        "id": 56,
        "className": "Person",
        coords: [
            193.0,
            202.0,
            232.0,
            296.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:27.100000",
        "id": 52,
        "className": "Person",
        coords: [
            503.0,
            244.0,
            554.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:27.100000",
        "id": 51,
        "className": "Person",
        coords: [
            317.0,
            289.0,
            383.0,
            456.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:27.100000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            193.0,
            812.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:27.200000",
        "id": 55,
        "className": "Person",
        coords: [
            135.0,
            179.0,
            176.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:27.200000",
        "id": 53,
        "className": "Person",
        coords: [
            33.0,
            217.0,
            86.0,
            356.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:27.200000",
        "id": 56,
        "className": "Person",
        coords: [
            192.0,
            202.0,
            233.0,
            298.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:27.300000",
        "id": 52,
        "className": "Person",
        coords: [
            503.0,
            244.0,
            554.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:27.300000",
        "id": 51,
        "className": "Person",
        coords: [
            317.0,
            289.0,
            383.0,
            457.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:27.300000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            193.0,
            812.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:27.300000",
        "id": 55,
        "className": "Person",
        coords: [
            135.0,
            179.0,
            176.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:27.300000",
        "id": 53,
        "className": "Person",
        coords: [
            33.0,
            217.0,
            86.0,
            355.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:27.300000",
        "id": 56,
        "className": "Person",
        coords: [
            192.0,
            202.0,
            232.0,
            298.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:27.400000",
        "id": 52,
        "className": "Person",
        coords: [
            504.0,
            244.0,
            554.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:27.400000",
        "id": 51,
        "className": "Person",
        coords: [
            317.0,
            289.0,
            383.0,
            457.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:27.400000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            193.0,
            812.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:27.500000",
        "id": 55,
        "className": "Person",
        coords: [
            135.0,
            179.0,
            176.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:27.500000",
        "id": 53,
        "className": "Person",
        coords: [
            33.0,
            217.0,
            86.0,
            355.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:27.500000",
        "id": 56,
        "className": "Person",
        coords: [
            192.0,
            202.0,
            232.0,
            297.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:27.500000",
        "id": 52,
        "className": "Person",
        coords: [
            504.0,
            244.0,
            554.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:27.600000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            289.0,
            383.0,
            455.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:27.600000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            193.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:27.600000",
        "id": 55,
        "className": "Person",
        coords: [
            135.0,
            179.0,
            176.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:27.600000",
        "id": 53,
        "className": "Person",
        coords: [
            32.0,
            217.0,
            86.0,
            355.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:27.600000",
        "id": 56,
        "className": "Person",
        coords: [
            192.0,
            201.0,
            233.0,
            299.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:27.700000",
        "id": 52,
        "className": "Person",
        coords: [
            504.0,
            244.0,
            554.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:27.700000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            289.0,
            382.0,
            453.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:27.800000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            193.0,
            811.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:27.800000",
        "id": 55,
        "className": "Person",
        coords: [
            135.0,
            179.0,
            176.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:27.800000",
        "id": 53,
        "className": "Person",
        coords: [
            32.0,
            217.0,
            86.0,
            355.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:27.800000",
        "id": 52,
        "className": "Person",
        coords: [
            503.0,
            244.0,
            554.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:27.900000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            289.0,
            382.0,
            453.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:27.900000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            193.0,
            811.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:27.900000",
        "id": 55,
        "className": "Person",
        coords: [
            135.0,
            179.0,
            176.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:27.900000",
        "id": 53,
        "className": "Person",
        coords: [
            32.0,
            217.0,
            86.0,
            355.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:28",
        "id": 52,
        "className": "Person",
        coords: [
            503.0,
            244.0,
            554.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:28",
        "id": 51,
        "className": "Person",
        coords: [
            317.0,
            289.0,
            382.0,
            455.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:28",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            193.0,
            811.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:28",
        "id": 55,
        "className": "Person",
        coords: [
            135.0,
            179.0,
            176.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:28",
        "id": 53,
        "className": "Person",
        coords: [
            32.0,
            217.0,
            86.0,
            355.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:28.100000",
        "id": 45,
        "className": "Person",
        coords: [
            347.0,
            542.0,
            460.0,
            697.0
        ],
        "status": "Moving",
        "speed": 149.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:28.100000",
        "id": 52,
        "className": "Person",
        coords: [
            503.0,
            244.0,
            554.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:28.200000",
        "id": 51,
        "className": "Person",
        coords: [
            317.0,
            289.0,
            382.0,
            456.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:28.200000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            193.0,
            811.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:28.200000",
        "id": 55,
        "className": "Person",
        coords: [
            135.0,
            179.0,
            176.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:28.200000",
        "id": 53,
        "className": "Person",
        coords: [
            32.0,
            217.0,
            86.0,
            355.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:28.300000",
        "id": 45,
        "className": "Person",
        coords: [
            346.0,
            542.0,
            460.0,
            696.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:28.300000",
        "id": 52,
        "className": "Person",
        coords: [
            504.0,
            244.0,
            554.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:28.400000",
        "id": 51,
        "className": "Person",
        coords: [
            317.0,
            289.0,
            382.0,
            456.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:28.400000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            193.0,
            811.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:28.400000",
        "id": 55,
        "className": "Person",
        coords: [
            135.0,
            179.0,
            177.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:28.400000",
        "id": 53,
        "className": "Person",
        coords: [
            32.0,
            217.0,
            86.0,
            355.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:28.500000",
        "id": 45,
        "className": "Person",
        coords: [
            344.0,
            542.0,
            462.0,
            699.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:28.500000",
        "id": 52,
        "className": "Person",
        coords: [
            504.0,
            244.0,
            554.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:28.500000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            289.0,
            382.0,
            454.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:28.600000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            193.0,
            811.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:28.600000",
        "id": 55,
        "className": "Person",
        coords: [
            135.0,
            179.0,
            176.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:28.600000",
        "id": 53,
        "className": "Person",
        coords: [
            32.0,
            217.0,
            86.0,
            355.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:28.600000",
        "id": 45,
        "className": "Person",
        coords: [
            343.0,
            542.0,
            462.0,
            699.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:28.600000",
        "id": 56,
        "className": "Person",
        coords: [
            192.0,
            203.0,
            233.0,
            304.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:28.700000",
        "id": 52,
        "className": "Person",
        coords: [
            504.0,
            244.0,
            554.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:28.700000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            289.0,
            382.0,
            453.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:28.700000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            193.0,
            811.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:28.800000",
        "id": 55,
        "className": "Person",
        coords: [
            135.0,
            179.0,
            176.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:28.800000",
        "id": 53,
        "className": "Person",
        coords: [
            32.0,
            217.0,
            87.0,
            355.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:28.800000",
        "id": 45,
        "className": "Person",
        coords: [
            342.0,
            541.0,
            462.0,
            698.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:28.900000",
        "id": 52,
        "className": "Person",
        coords: [
            504.0,
            244.0,
            554.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:28.900000",
        "id": 51,
        "className": "Person",
        coords: [
            317.0,
            289.0,
            380.0,
            452.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:28.900000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            193.0,
            811.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:28.900000",
        "id": 55,
        "className": "Person",
        coords: [
            135.0,
            179.0,
            177.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:29",
        "id": 53,
        "className": "Person",
        coords: [
            32.0,
            216.0,
            87.0,
            355.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:29",
        "id": 45,
        "className": "Person",
        coords: [
            342.0,
            541.0,
            463.0,
            699.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:29",
        "id": 52,
        "className": "Person",
        coords: [
            504.0,
            244.0,
            554.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:29.100000",
        "id": 51,
        "className": "Person",
        coords: [
            317.0,
            289.0,
            379.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:29.100000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            193.0,
            811.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:29.100000",
        "id": 55,
        "className": "Person",
        coords: [
            136.0,
            180.0,
            177.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:29.100000",
        "id": 53,
        "className": "Person",
        coords: [
            32.0,
            216.0,
            87.0,
            355.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:29.200000",
        "id": 45,
        "className": "Person",
        coords: [
            341.0,
            540.0,
            463.0,
            697.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:29.200000",
        "id": 52,
        "className": "Person",
        coords: [
            504.0,
            244.0,
            554.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:29.300000",
        "id": 51,
        "className": "Person",
        coords: [
            317.0,
            289.0,
            379.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:29.300000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            193.0,
            811.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:29.300000",
        "id": 55,
        "className": "Person",
        coords: [
            137.0,
            180.0,
            178.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:29.300000",
        "id": 53,
        "className": "Person",
        coords: [
            32.0,
            216.0,
            87.0,
            355.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:29.300000",
        "id": 45,
        "className": "Person",
        coords: [
            341.0,
            540.0,
            463.0,
            697.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:29.400000",
        "id": 52,
        "className": "Person",
        coords: [
            504.0,
            243.0,
            554.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:29.400000",
        "id": 51,
        "className": "Person",
        coords: [
            315.0,
            289.0,
            377.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:29.400000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            193.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:29.500000",
        "id": 55,
        "className": "Person",
        coords: [
            139.0,
            181.0,
            179.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:29.500000",
        "id": 53,
        "className": "Person",
        coords: [
            32.0,
            217.0,
            88.0,
            356.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:29.500000",
        "id": 45,
        "className": "Person",
        coords: [
            336.0,
            539.0,
            467.0,
            709.0
        ],
        "status": "Moving",
        "speed": 91.23,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:29.600000",
        "id": 52,
        "className": "Person",
        coords: [
            503.0,
            243.0,
            554.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:29.600000",
        "id": 51,
        "className": "Person",
        coords: [
            313.0,
            289.0,
            375.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:29.600000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            193.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:29.600000",
        "id": 55,
        "className": "Person",
        coords: [
            139.0,
            181.0,
            180.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:29.600000",
        "id": 53,
        "className": "Person",
        coords: [
            32.0,
            218.0,
            88.0,
            357.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:29.700000",
        "id": 45,
        "className": "Person",
        coords: [
            334.0,
            538.0,
            468.0,
            714.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:29.700000",
        "id": 56,
        "className": "Person",
        coords: [
            188.0,
            197.0,
            229.0,
            300.0
        ],
        "status": "Moving",
        "speed": 96.04,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:29.800000",
        "id": 52,
        "className": "Person",
        coords: [
            503.0,
            243.0,
            554.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:29.800000",
        "id": 51,
        "className": "Person",
        coords: [
            314.0,
            289.0,
            375.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:29.800000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:29.800000",
        "id": 55,
        "className": "Person",
        coords: [
            140.0,
            181.0,
            180.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:29.800000",
        "id": 53,
        "className": "Person",
        coords: [
            32.0,
            219.0,
            88.0,
            357.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:29.900000",
        "id": 45,
        "className": "Person",
        coords: [
            334.0,
            538.0,
            468.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:29.900000",
        "id": 56,
        "className": "Person",
        coords: [
            188.0,
            196.0,
            228.0,
            298.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:29.900000",
        "id": 52,
        "className": "Person",
        coords: [
            503.0,
            243.0,
            554.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:30",
        "id": 51,
        "className": "Person",
        coords: [
            313.0,
            289.0,
            375.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:30",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            812.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:30",
        "id": 55,
        "className": "Person",
        coords: [
            140.0,
            181.0,
            180.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:30",
        "id": 53,
        "className": "Person",
        coords: [
            32.0,
            219.0,
            89.0,
            357.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:30",
        "id": 45,
        "className": "Person",
        coords: [
            334.0,
            538.0,
            468.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:30.100000",
        "id": 56,
        "className": "Person",
        coords: [
            189.0,
            195.0,
            228.0,
            295.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:30.100000",
        "id": 52,
        "className": "Person",
        coords: [
            503.0,
            243.0,
            554.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:30.100000",
        "id": 51,
        "className": "Person",
        coords: [
            315.0,
            289.0,
            376.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:30.200000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            812.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:30.200000",
        "id": 55,
        "className": "Person",
        coords: [
            140.0,
            182.0,
            180.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:30.200000",
        "id": 53,
        "className": "Person",
        coords: [
            32.0,
            218.0,
            89.0,
            357.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:30.200000",
        "id": 45,
        "className": "Person",
        coords: [
            334.0,
            538.0,
            468.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:30.200000",
        "id": 56,
        "className": "Person",
        coords: [
            188.0,
            195.0,
            226.0,
            292.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:30.300000",
        "id": 52,
        "className": "Person",
        coords: [
            503.0,
            243.0,
            554.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:30.300000",
        "id": 51,
        "className": "Person",
        coords: [
            315.0,
            289.0,
            375.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:30.300000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            812.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:30.400000",
        "id": 55,
        "className": "Person",
        coords: [
            140.0,
            182.0,
            181.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:30.400000",
        "id": 53,
        "className": "Person",
        coords: [
            32.0,
            218.0,
            90.0,
            357.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:30.400000",
        "id": 45,
        "className": "Person",
        coords: [
            334.0,
            539.0,
            468.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:30.400000",
        "id": 56,
        "className": "Person",
        coords: [
            189.0,
            195.0,
            226.0,
            291.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:30.500000",
        "id": 52,
        "className": "Person",
        coords: [
            503.0,
            243.0,
            554.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:30.500000",
        "id": 51,
        "className": "Person",
        coords: [
            315.0,
            290.0,
            375.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:30.500000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            812.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:30.500000",
        "id": 55,
        "className": "Person",
        coords: [
            140.0,
            182.0,
            181.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:30.600000",
        "id": 53,
        "className": "Person",
        coords: [
            31.0,
            218.0,
            90.0,
            357.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:30.600000",
        "id": 45,
        "className": "Person",
        coords: [
            334.0,
            539.0,
            467.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:30.600000",
        "id": 56,
        "className": "Person",
        coords: [
            190.0,
            195.0,
            226.0,
            290.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:30.700000",
        "id": 52,
        "className": "Person",
        coords: [
            503.0,
            243.0,
            554.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:30.700000",
        "id": 51,
        "className": "Person",
        coords: [
            315.0,
            290.0,
            375.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:30.700000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            812.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:30.700000",
        "id": 55,
        "className": "Person",
        coords: [
            140.0,
            182.0,
            181.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:30.800000",
        "id": 53,
        "className": "Person",
        coords: [
            31.0,
            218.0,
            90.0,
            357.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:30.800000",
        "id": 45,
        "className": "Person",
        coords: [
            334.0,
            538.0,
            467.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:30.800000",
        "id": 56,
        "className": "Person",
        coords: [
            190.0,
            195.0,
            226.0,
            289.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:30.900000",
        "id": 52,
        "className": "Person",
        coords: [
            504.0,
            243.0,
            554.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:30.900000",
        "id": 51,
        "className": "Person",
        coords: [
            316.0,
            290.0,
            375.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:30.900000",
        "id": 54,
        "className": "Person",
        coords: [
            771.0,
            194.0,
            812.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:30.900000",
        "id": 55,
        "className": "Person",
        coords: [
            140.0,
            182.0,
            181.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:31",
        "id": 53,
        "className": "Person",
        coords: [
            31.0,
            219.0,
            90.0,
            357.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:31",
        "id": 45,
        "className": "Person",
        coords: [
            334.0,
            538.0,
            467.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:31",
        "id": 56,
        "className": "Person",
        coords: [
            191.0,
            195.0,
            226.0,
            289.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:31.100000",
        "id": 52,
        "className": "Person",
        coords: [
            504.0,
            243.0,
            555.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:31.100000",
        "id": 51,
        "className": "Person",
        coords: [
            316.0,
            290.0,
            374.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:31.100000",
        "id": 54,
        "className": "Person",
        coords: [
            771.0,
            193.0,
            812.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:31.100000",
        "id": 55,
        "className": "Person",
        coords: [
            140.0,
            181.0,
            181.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:31.200000",
        "id": 53,
        "className": "Person",
        coords: [
            31.0,
            219.0,
            90.0,
            357.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:31.200000",
        "id": 45,
        "className": "Person",
        coords: [
            334.0,
            538.0,
            466.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:31.200000",
        "id": 56,
        "className": "Person",
        coords: [
            192.0,
            196.0,
            226.0,
            288.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:31.300000",
        "id": 52,
        "className": "Person",
        coords: [
            504.0,
            244.0,
            555.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:31.300000",
        "id": 51,
        "className": "Person",
        coords: [
            316.0,
            290.0,
            374.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:31.300000",
        "id": 54,
        "className": "Person",
        coords: [
            771.0,
            193.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:31.300000",
        "id": 55,
        "className": "Person",
        coords: [
            140.0,
            182.0,
            181.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:31.300000",
        "id": 53,
        "className": "Person",
        coords: [
            31.0,
            219.0,
            90.0,
            357.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:31.400000",
        "id": 45,
        "className": "Person",
        coords: [
            334.0,
            538.0,
            466.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:31.400000",
        "id": 56,
        "className": "Person",
        coords: [
            192.0,
            195.0,
            226.0,
            288.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:31.400000",
        "id": 52,
        "className": "Person",
        coords: [
            504.0,
            244.0,
            554.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:31.500000",
        "id": 51,
        "className": "Person",
        coords: [
            316.0,
            290.0,
            373.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:31.500000",
        "id": 54,
        "className": "Person",
        coords: [
            771.0,
            193.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:31.500000",
        "id": 55,
        "className": "Person",
        coords: [
            140.0,
            182.0,
            181.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:31.500000",
        "id": 53,
        "className": "Person",
        coords: [
            30.0,
            219.0,
            90.0,
            357.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:31.500000",
        "id": 45,
        "className": "Person",
        coords: [
            334.0,
            538.0,
            466.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:31.600000",
        "id": 56,
        "className": "Person",
        coords: [
            193.0,
            195.0,
            227.0,
            286.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:31.600000",
        "id": 52,
        "className": "Person",
        coords: [
            504.0,
            244.0,
            554.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:31.600000",
        "id": 51,
        "className": "Person",
        coords: [
            316.0,
            290.0,
            373.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:31.700000",
        "id": 54,
        "className": "Person",
        coords: [
            771.0,
            193.0,
            812.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:31.700000",
        "id": 55,
        "className": "Person",
        coords: [
            140.0,
            181.0,
            181.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:31.700000",
        "id": 53,
        "className": "Person",
        coords: [
            30.0,
            219.0,
            90.0,
            357.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:31.700000",
        "id": 45,
        "className": "Person",
        coords: [
            334.0,
            538.0,
            466.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:31.700000",
        "id": 56,
        "className": "Person",
        coords: [
            193.0,
            195.0,
            227.0,
            288.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:31.800000",
        "id": 52,
        "className": "Person",
        coords: [
            505.0,
            244.0,
            554.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:31.800000",
        "id": 51,
        "className": "Person",
        coords: [
            316.0,
            290.0,
            372.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:31.900000",
        "id": 54,
        "className": "Person",
        coords: [
            771.0,
            193.0,
            812.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:31.900000",
        "id": 55,
        "className": "Person",
        coords: [
            140.0,
            181.0,
            181.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:31.900000",
        "id": 53,
        "className": "Person",
        coords: [
            31.0,
            220.0,
            90.0,
            357.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:31.900000",
        "id": 45,
        "className": "Person",
        coords: [
            334.0,
            538.0,
            465.0,
            718.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:31.900000",
        "id": 56,
        "className": "Person",
        coords: [
            193.0,
            195.0,
            227.0,
            288.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:32",
        "id": 52,
        "className": "Person",
        coords: [
            505.0,
            244.0,
            554.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:32",
        "id": 51,
        "className": "Person",
        coords: [
            316.0,
            290.0,
            372.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:32.100000",
        "id": 54,
        "className": "Person",
        coords: [
            771.0,
            194.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:32.100000",
        "id": 55,
        "className": "Person",
        coords: [
            140.0,
            182.0,
            181.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:32.100000",
        "id": 53,
        "className": "Person",
        coords: [
            31.0,
            220.0,
            90.0,
            356.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:32.100000",
        "id": 45,
        "className": "Person",
        coords: [
            335.0,
            538.0,
            465.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:32.100000",
        "id": 56,
        "className": "Person",
        coords: [
            193.0,
            195.0,
            227.0,
            288.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:32.200000",
        "id": 52,
        "className": "Person",
        coords: [
            505.0,
            244.0,
            554.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:32.200000",
        "id": 51,
        "className": "Person",
        coords: [
            316.0,
            290.0,
            372.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:32.200000",
        "id": 54,
        "className": "Person",
        coords: [
            771.0,
            194.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:32.300000",
        "id": 55,
        "className": "Person",
        coords: [
            140.0,
            182.0,
            181.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:32.300000",
        "id": 53,
        "className": "Person",
        coords: [
            31.0,
            220.0,
            90.0,
            356.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:32.300000",
        "id": 45,
        "className": "Person",
        coords: [
            335.0,
            538.0,
            465.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:32.300000",
        "id": 56,
        "className": "Person",
        coords: [
            193.0,
            195.0,
            227.0,
            288.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:32.400000",
        "id": 52,
        "className": "Person",
        coords: [
            505.0,
            244.0,
            554.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:32.400000",
        "id": 51,
        "className": "Person",
        coords: [
            316.0,
            290.0,
            371.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:32.400000",
        "id": 54,
        "className": "Person",
        coords: [
            771.0,
            195.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:32.500000",
        "id": 55,
        "className": "Person",
        coords: [
            140.0,
            181.0,
            181.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:32.500000",
        "id": 53,
        "className": "Person",
        coords: [
            31.0,
            219.0,
            92.0,
            357.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:32.500000",
        "id": 45,
        "className": "Person",
        coords: [
            336.0,
            539.0,
            465.0,
            717.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:32.500000",
        "id": 56,
        "className": "Person",
        coords: [
            193.0,
            195.0,
            227.0,
            292.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:32.600000",
        "id": 52,
        "className": "Person",
        coords: [
            505.0,
            245.0,
            554.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:32.600000",
        "id": 51,
        "className": "Person",
        coords: [
            316.0,
            290.0,
            371.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:32.600000",
        "id": 54,
        "className": "Person",
        coords: [
            771.0,
            195.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:32.600000",
        "id": 55,
        "className": "Person",
        coords: [
            140.0,
            181.0,
            181.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:32.700000",
        "id": 53,
        "className": "Person",
        coords: [
            32.0,
            220.0,
            92.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:32.700000",
        "id": 45,
        "className": "Person",
        coords: [
            336.0,
            538.0,
            465.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:32.700000",
        "id": 52,
        "className": "Person",
        coords: [
            505.0,
            245.0,
            554.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:32.800000",
        "id": 51,
        "className": "Person",
        coords: [
            316.0,
            290.0,
            371.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:32.800000",
        "id": 54,
        "className": "Person",
        coords: [
            771.0,
            195.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:32.800000",
        "id": 55,
        "className": "Person",
        coords: [
            140.0,
            181.0,
            181.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:32.800000",
        "id": 53,
        "className": "Person",
        coords: [
            31.0,
            220.0,
            93.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:32.800000",
        "id": 45,
        "className": "Person",
        coords: [
            336.0,
            538.0,
            465.0,
            715.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:32.900000",
        "id": 52,
        "className": "Person",
        coords: [
            505.0,
            245.0,
            554.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:32.900000",
        "id": 51,
        "className": "Person",
        coords: [
            316.0,
            290.0,
            371.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:32.900000",
        "id": 54,
        "className": "Person",
        coords: [
            771.0,
            195.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:32.900000",
        "id": 55,
        "className": "Person",
        coords: [
            140.0,
            181.0,
            181.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:33",
        "id": 53,
        "className": "Person",
        coords: [
            31.0,
            220.0,
            93.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:33",
        "id": 45,
        "className": "Person",
        coords: [
            336.0,
            538.0,
            465.0,
            715.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:33.100000",
        "id": 52,
        "className": "Person",
        coords: [
            505.0,
            245.0,
            554.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:33.100000",
        "id": 51,
        "className": "Person",
        coords: [
            316.0,
            290.0,
            371.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:33.100000",
        "id": 54,
        "className": "Person",
        coords: [
            771.0,
            195.0,
            811.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:33.100000",
        "id": 55,
        "className": "Person",
        coords: [
            140.0,
            181.0,
            181.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:33.100000",
        "id": 53,
        "className": "Person",
        coords: [
            31.0,
            220.0,
            93.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:33.200000",
        "id": 45,
        "className": "Person",
        coords: [
            336.0,
            538.0,
            464.0,
            715.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:33.200000",
        "id": 52,
        "className": "Person",
        coords: [
            505.0,
            245.0,
            554.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:33.200000",
        "id": 51,
        "className": "Person",
        coords: [
            316.0,
            290.0,
            370.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:33.300000",
        "id": 54,
        "className": "Person",
        coords: [
            771.0,
            195.0,
            811.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:33.300000",
        "id": 55,
        "className": "Person",
        coords: [
            140.0,
            181.0,
            180.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:33.300000",
        "id": 53,
        "className": "Person",
        coords: [
            31.0,
            220.0,
            93.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:33.300000",
        "id": 45,
        "className": "Person",
        coords: [
            337.0,
            538.0,
            464.0,
            714.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:33.300000",
        "id": 56,
        "className": "Person",
        coords: [
            191.0,
            195.0,
            229.0,
            307.0
        ],
        "status": "Moving",
        "speed": 119.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:33.400000",
        "id": 52,
        "className": "Person",
        coords: [
            506.0,
            245.0,
            554.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:33.400000",
        "id": 51,
        "className": "Person",
        coords: [
            317.0,
            290.0,
            370.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:33.500000",
        "id": 54,
        "className": "Person",
        coords: [
            771.0,
            195.0,
            811.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:33.500000",
        "id": 55,
        "className": "Person",
        coords: [
            139.0,
            180.0,
            180.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:33.500000",
        "id": 53,
        "className": "Person",
        coords: [
            31.0,
            220.0,
            92.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:33.500000",
        "id": 45,
        "className": "Person",
        coords: [
            337.0,
            538.0,
            464.0,
            714.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:33.600000",
        "id": 56,
        "className": "Person",
        coords: [
            191.0,
            195.0,
            230.0,
            309.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:33.600000",
        "id": 52,
        "className": "Person",
        coords: [
            506.0,
            245.0,
            554.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:33.700000",
        "id": 51,
        "className": "Person",
        coords: [
            317.0,
            290.0,
            370.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:33.700000",
        "id": 54,
        "className": "Person",
        coords: [
            771.0,
            195.0,
            811.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:33.700000",
        "id": 55,
        "className": "Person",
        coords: [
            139.0,
            180.0,
            180.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:33.700000",
        "id": 53,
        "className": "Person",
        coords: [
            31.0,
            221.0,
            92.0,
            357.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:33.800000",
        "id": 45,
        "className": "Person",
        coords: [
            337.0,
            538.0,
            464.0,
            714.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:33.800000",
        "id": 56,
        "className": "Person",
        coords: [
            192.0,
            195.0,
            230.0,
            308.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:33.800000",
        "id": 52,
        "className": "Person",
        coords: [
            506.0,
            245.0,
            554.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:33.900000",
        "id": 51,
        "className": "Person",
        coords: [
            317.0,
            290.0,
            370.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:33.900000",
        "id": 54,
        "className": "Person",
        coords: [
            771.0,
            195.0,
            811.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:33.900000",
        "id": 55,
        "className": "Person",
        coords: [
            139.0,
            180.0,
            180.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:33.900000",
        "id": 53,
        "className": "Person",
        coords: [
            31.0,
            221.0,
            92.0,
            357.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:34",
        "id": 45,
        "className": "Person",
        coords: [
            336.0,
            538.0,
            464.0,
            715.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:34",
        "id": 56,
        "className": "Person",
        coords: [
            194.0,
            195.0,
            228.0,
            296.0
        ],
        "status": "Moving",
        "speed": 89.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:34.100000",
        "id": 52,
        "className": "Person",
        coords: [
            506.0,
            244.0,
            554.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:34.100000",
        "id": 51,
        "className": "Person",
        coords: [
            317.0,
            290.0,
            370.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:34.200000",
        "id": 54,
        "className": "Person",
        coords: [
            771.0,
            195.0,
            811.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:34.200000",
        "id": 55,
        "className": "Person",
        coords: [
            139.0,
            180.0,
            180.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:34.200000",
        "id": 53,
        "className": "Person",
        coords: [
            31.0,
            221.0,
            92.0,
            357.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:34.300000",
        "id": 45,
        "className": "Person",
        coords: [
            336.0,
            538.0,
            464.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:34.300000",
        "id": 56,
        "className": "Person",
        coords: [
            196.0,
            195.0,
            227.0,
            289.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:34.400000",
        "id": 52,
        "className": "Person",
        coords: [
            506.0,
            245.0,
            554.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:34.400000",
        "id": 51,
        "className": "Person",
        coords: [
            317.0,
            290.0,
            370.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:34.500000",
        "id": 54,
        "className": "Person",
        coords: [
            771.0,
            195.0,
            811.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:34.500000",
        "id": 55,
        "className": "Person",
        coords: [
            139.0,
            180.0,
            180.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:34.500000",
        "id": 53,
        "className": "Person",
        coords: [
            31.0,
            221.0,
            92.0,
            357.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:34.600000",
        "id": 45,
        "className": "Person",
        coords: [
            336.0,
            538.0,
            464.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:34.600000",
        "id": 56,
        "className": "Person",
        coords: [
            197.0,
            196.0,
            228.0,
            289.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:34.700000",
        "id": 52,
        "className": "Person",
        coords: [
            506.0,
            244.0,
            554.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:34.700000",
        "id": 51,
        "className": "Person",
        coords: [
            317.0,
            290.0,
            370.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:34.700000",
        "id": 55,
        "className": "Person",
        coords: [
            139.0,
            180.0,
            180.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:34.800000",
        "id": 53,
        "className": "Person",
        coords: [
            31.0,
            221.0,
            92.0,
            357.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:34.800000",
        "id": 45,
        "className": "Person",
        coords: [
            336.0,
            538.0,
            464.0,
            715.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:34.800000",
        "id": 56,
        "className": "Person",
        coords: [
            198.0,
            196.0,
            229.0,
            289.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:34.900000",
        "id": 52,
        "className": "Person",
        coords: [
            506.0,
            244.0,
            554.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:34.900000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            290.0,
            370.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:35",
        "id": 55,
        "className": "Person",
        coords: [
            139.0,
            180.0,
            180.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:35",
        "id": 53,
        "className": "Person",
        coords: [
            31.0,
            221.0,
            92.0,
            357.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:35",
        "id": 45,
        "className": "Person",
        coords: [
            336.0,
            539.0,
            464.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:35",
        "id": 56,
        "className": "Person",
        coords: [
            198.0,
            196.0,
            229.0,
            290.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:35.100000",
        "id": 52,
        "className": "Person",
        coords: [
            506.0,
            244.0,
            554.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:35.100000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            290.0,
            370.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:35.200000",
        "id": 55,
        "className": "Person",
        coords: [
            139.0,
            181.0,
            180.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:35.200000",
        "id": 53,
        "className": "Person",
        coords: [
            31.0,
            221.0,
            93.0,
            357.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:35.200000",
        "id": 45,
        "className": "Person",
        coords: [
            336.0,
            538.0,
            464.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:35.300000",
        "id": 56,
        "className": "Person",
        coords: [
            199.0,
            196.0,
            231.0,
            290.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:35.300000",
        "id": 54,
        "className": "Person",
        coords: [
            771.0,
            195.0,
            811.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:36.600000",
        "id": 52,
        "className": "Person",
        coords: [
            506.0,
            244.0,
            554.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:36.600000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            290.0,
            370.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:36.700000",
        "id": 55,
        "className": "Person",
        coords: [
            139.0,
            181.0,
            180.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:36.700000",
        "id": 53,
        "className": "Person",
        coords: [
            30.0,
            221.0,
            92.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:36.700000",
        "id": 45,
        "className": "Person",
        coords: [
            337.0,
            538.0,
            463.0,
            713.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:36.700000",
        "id": 54,
        "className": "Person",
        coords: [
            770.0,
            195.0,
            811.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:37.100000",
        "id": 52,
        "className": "Person",
        coords: [
            506.0,
            244.0,
            554.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:37.100000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            291.0,
            370.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:37.200000",
        "id": 55,
        "className": "Person",
        coords: [
            139.0,
            181.0,
            179.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:37.200000",
        "id": 53,
        "className": "Person",
        coords: [
            30.0,
            221.0,
            91.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:37.200000",
        "id": 45,
        "className": "Person",
        coords: [
            337.0,
            538.0,
            463.0,
            713.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:37.300000",
        "id": 54,
        "className": "Person",
        coords: [
            770.0,
            195.0,
            811.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:37.400000",
        "id": 52,
        "className": "Person",
        coords: [
            506.0,
            244.0,
            554.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:37.500000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            291.0,
            370.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:37.500000",
        "id": 55,
        "className": "Person",
        coords: [
            139.0,
            181.0,
            179.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:37.500000",
        "id": 53,
        "className": "Person",
        coords: [
            30.0,
            221.0,
            91.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:37.600000",
        "id": 45,
        "className": "Person",
        coords: [
            337.0,
            538.0,
            464.0,
            713.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:37.600000",
        "id": 54,
        "className": "Person",
        coords: [
            770.0,
            195.0,
            811.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:37.700000",
        "id": 52,
        "className": "Person",
        coords: [
            506.0,
            244.0,
            554.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:37.800000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            290.0,
            370.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:37.800000",
        "id": 55,
        "className": "Person",
        coords: [
            139.0,
            181.0,
            179.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:37.800000",
        "id": 53,
        "className": "Person",
        coords: [
            29.0,
            221.0,
            90.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:37.800000",
        "id": 45,
        "className": "Person",
        coords: [
            337.0,
            538.0,
            464.0,
            715.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:37.900000",
        "id": 54,
        "className": "Person",
        coords: [
            770.0,
            195.0,
            811.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:37.900000",
        "id": 52,
        "className": "Person",
        coords: [
            506.0,
            244.0,
            554.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:38",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            291.0,
            369.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:38",
        "id": 55,
        "className": "Person",
        coords: [
            139.0,
            181.0,
            179.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:38",
        "id": 53,
        "className": "Person",
        coords: [
            29.0,
            220.0,
            89.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:38.100000",
        "id": 45,
        "className": "Person",
        coords: [
            337.0,
            538.0,
            464.0,
            715.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:38.100000",
        "id": 54,
        "className": "Person",
        coords: [
            769.0,
            195.0,
            811.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:38.100000",
        "id": 56,
        "className": "Person",
        coords: [
            206.0,
            197.0,
            242.0,
            299.0
        ],
        "status": "Moving",
        "speed": 154.42,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:38.200000",
        "id": 52,
        "className": "Person",
        coords: [
            506.0,
            244.0,
            554.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:38.200000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            291.0,
            370.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:38.300000",
        "id": 55,
        "className": "Person",
        coords: [
            139.0,
            181.0,
            179.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:38.300000",
        "id": 53,
        "className": "Person",
        coords: [
            28.0,
            221.0,
            88.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:38.300000",
        "id": 45,
        "className": "Person",
        coords: [
            337.0,
            538.0,
            464.0,
            715.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:38.300000",
        "id": 54,
        "className": "Person",
        coords: [
            769.0,
            195.0,
            811.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:38.400000",
        "id": 56,
        "className": "Person",
        coords: [
            208.0,
            197.0,
            243.0,
            297.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:38.400000",
        "id": 52,
        "className": "Person",
        coords: [
            506.0,
            244.0,
            554.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:38.500000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            291.0,
            369.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:38.500000",
        "id": 55,
        "className": "Person",
        coords: [
            139.0,
            181.0,
            179.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:38.500000",
        "id": 53,
        "className": "Person",
        coords: [
            27.0,
            222.0,
            86.0,
            358.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:38.500000",
        "id": 45,
        "className": "Person",
        coords: [
            337.0,
            538.0,
            463.0,
            713.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:38.500000",
        "id": 54,
        "className": "Person",
        coords: [
            770.0,
            195.0,
            811.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:38.600000",
        "id": 56,
        "className": "Person",
        coords: [
            208.0,
            198.0,
            244.0,
            298.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:38.600000",
        "id": 52,
        "className": "Person",
        coords: [
            506.0,
            244.0,
            554.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:38.600000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            291.0,
            370.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:38.700000",
        "id": 55,
        "className": "Person",
        coords: [
            139.0,
            181.0,
            179.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:38.700000",
        "id": 53,
        "className": "Person",
        coords: [
            27.0,
            222.0,
            85.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:38.700000",
        "id": 45,
        "className": "Person",
        coords: [
            336.0,
            538.0,
            463.0,
            714.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:38.700000",
        "id": 54,
        "className": "Person",
        coords: [
            769.0,
            195.0,
            811.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:38.700000",
        "id": 56,
        "className": "Person",
        coords: [
            208.0,
            199.0,
            245.0,
            299.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:38.800000",
        "id": 52,
        "className": "Person",
        coords: [
            506.0,
            244.0,
            554.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:38.800000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            291.0,
            370.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:38.800000",
        "id": 55,
        "className": "Person",
        coords: [
            139.0,
            181.0,
            179.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:38.900000",
        "id": 53,
        "className": "Person",
        coords: [
            27.0,
            221.0,
            84.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:38.900000",
        "id": 45,
        "className": "Person",
        coords: [
            336.0,
            539.0,
            464.0,
            715.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:38.900000",
        "id": 54,
        "className": "Person",
        coords: [
            769.0,
            195.0,
            811.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:38.900000",
        "id": 56,
        "className": "Person",
        coords: [
            208.0,
            199.0,
            246.0,
            300.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:39",
        "id": 52,
        "className": "Person",
        coords: [
            507.0,
            243.0,
            554.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:39",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            291.0,
            371.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:39",
        "id": 55,
        "className": "Person",
        coords: [
            139.0,
            181.0,
            179.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:39.100000",
        "id": 53,
        "className": "Person",
        coords: [
            28.0,
            220.0,
            85.0,
            357.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:39.100000",
        "id": 45,
        "className": "Person",
        coords: [
            337.0,
            539.0,
            462.0,
            710.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:39.100000",
        "id": 54,
        "className": "Person",
        coords: [
            769.0,
            194.0,
            812.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:39.100000",
        "id": 56,
        "className": "Person",
        coords: [
            208.0,
            199.0,
            248.0,
            301.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:39.200000",
        "id": 52,
        "className": "Person",
        coords: [
            507.0,
            244.0,
            554.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:39.200000",
        "id": 51,
        "className": "Person",
        coords: [
            318.0,
            292.0,
            371.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:39.200000",
        "id": 55,
        "className": "Person",
        coords: [
            139.0,
            181.0,
            179.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:39.300000",
        "id": 53,
        "className": "Person",
        coords: [
            28.0,
            220.0,
            85.0,
            357.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:39.300000",
        "id": 45,
        "className": "Person",
        coords: [
            338.0,
            539.0,
            461.0,
            707.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:39.300000",
        "id": 54,
        "className": "Person",
        coords: [
            769.0,
            194.0,
            812.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:39.300000",
        "id": 56,
        "className": "Person",
        coords: [
            208.0,
            199.0,
            249.0,
            302.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:39.400000",
        "id": 52,
        "className": "Person",
        coords: [
            507.0,
            243.0,
            554.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:39.400000",
        "id": 51,
        "className": "Person",
        coords: [
            315.0,
            292.0,
            368.0,
            452.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:39.400000",
        "id": 55,
        "className": "Person",
        coords: [
            139.0,
            181.0,
            179.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:39.400000",
        "id": 53,
        "className": "Person",
        coords: [
            30.0,
            221.0,
            86.0,
            357.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:39.500000",
        "id": 45,
        "className": "Person",
        coords: [
            339.0,
            539.0,
            460.0,
            703.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:39.500000",
        "id": 54,
        "className": "Person",
        coords: [
            769.0,
            194.0,
            812.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:39.500000",
        "id": 56,
        "className": "Person",
        coords: [
            208.0,
            200.0,
            250.0,
            302.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:39.600000",
        "id": 52,
        "className": "Person",
        coords: [
            506.0,
            243.0,
            554.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:39.600000",
        "id": 51,
        "className": "Person",
        coords: [
            315.0,
            291.0,
            369.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:39.600000",
        "id": 55,
        "className": "Person",
        coords: [
            139.0,
            181.0,
            179.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:39.600000",
        "id": 53,
        "className": "Person",
        coords: [
            30.0,
            222.0,
            86.0,
            357.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:39.600000",
        "id": 45,
        "className": "Person",
        coords: [
            339.0,
            538.0,
            460.0,
            702.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:39.700000",
        "id": 54,
        "className": "Person",
        coords: [
            769.0,
            194.0,
            812.0,
            264.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:39.700000",
        "id": 56,
        "className": "Person",
        coords: [
            207.0,
            201.0,
            249.0,
            303.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:39.700000",
        "id": 52,
        "className": "Person",
        coords: [
            506.0,
            243.0,
            554.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:39.700000",
        "id": 51,
        "className": "Person",
        coords: [
            316.0,
            291.0,
            370.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:39.800000",
        "id": 55,
        "className": "Person",
        coords: [
            139.0,
            181.0,
            179.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:39.800000",
        "id": 53,
        "className": "Person",
        coords: [
            31.0,
            223.0,
            85.0,
            357.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:39.800000",
        "id": 45,
        "className": "Person",
        coords: [
            338.0,
            539.0,
            461.0,
            705.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:39.800000",
        "id": 54,
        "className": "Person",
        coords: [
            769.0,
            193.0,
            812.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:39.800000",
        "id": 56,
        "className": "Person",
        coords: [
            207.0,
            203.0,
            250.0,
            303.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:39.900000",
        "id": 52,
        "className": "Person",
        coords: [
            506.0,
            243.0,
            554.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:39.900000",
        "id": 51,
        "className": "Person",
        coords: [
            316.0,
            291.0,
            371.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:39.900000",
        "id": 55,
        "className": "Person",
        coords: [
            139.0,
            180.0,
            178.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:39.900000",
        "id": 53,
        "className": "Person",
        coords: [
            30.0,
            224.0,
            85.0,
            357.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:40",
        "id": 45,
        "className": "Person",
        coords: [
            337.0,
            539.0,
            462.0,
            708.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:40",
        "id": 54,
        "className": "Person",
        coords: [
            769.0,
            193.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:40",
        "id": 56,
        "className": "Person",
        coords: [
            208.0,
            205.0,
            253.0,
            308.0
        ],
        "status": "Moving",
        "speed": 54.08,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:40.100000",
        "id": 52,
        "className": "Person",
        coords: [
            506.0,
            243.0,
            553.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:40.100000",
        "id": 51,
        "className": "Person",
        coords: [
            316.0,
            292.0,
            371.0,
            453.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:40.100000",
        "id": 55,
        "className": "Person",
        coords: [
            140.0,
            180.0,
            179.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:40.100000",
        "id": 53,
        "className": "Person",
        coords: [
            28.0,
            224.0,
            81.0,
            356.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:40.100000",
        "id": 45,
        "className": "Person",
        coords: [
            336.0,
            539.0,
            464.0,
            712.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:40.100000",
        "id": 54,
        "className": "Person",
        coords: [
            768.0,
            192.0,
            810.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:40.200000",
        "id": 56,
        "className": "Person",
        coords: [
            204.0,
            205.0,
            257.0,
            327.0
        ],
        "status": "Moving",
        "speed": 149.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:40.200000",
        "id": 52,
        "className": "Person",
        coords: [
            505.0,
            243.0,
            553.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:40.200000",
        "id": 51,
        "className": "Person",
        coords: [
            316.0,
            292.0,
            372.0,
            454.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:40.200000",
        "id": 55,
        "className": "Person",
        coords: [
            140.0,
            180.0,
            179.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:40.300000",
        "id": 53,
        "className": "Person",
        coords: [
            28.0,
            224.0,
            80.0,
            356.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:40.300000",
        "id": 45,
        "className": "Person",
        coords: [
            335.0,
            539.0,
            464.0,
            714.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:40.300000",
        "id": 54,
        "className": "Person",
        coords: [
            768.0,
            192.0,
            809.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:40.300000",
        "id": 56,
        "className": "Person",
        coords: [
            202.0,
            205.0,
            257.0,
            333.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:40.400000",
        "id": 52,
        "className": "Person",
        coords: [
            505.0,
            243.0,
            553.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:40.400000",
        "id": 51,
        "className": "Person",
        coords: [
            316.0,
            292.0,
            372.0,
            454.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:40.400000",
        "id": 55,
        "className": "Person",
        coords: [
            140.0,
            180.0,
            180.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:40.400000",
        "id": 53,
        "className": "Person",
        coords: [
            28.0,
            224.0,
            80.0,
            356.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:40.500000",
        "id": 45,
        "className": "Person",
        coords: [
            335.0,
            539.0,
            464.0,
            715.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:40.500000",
        "id": 54,
        "className": "Person",
        coords: [
            768.0,
            192.0,
            809.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:40.500000",
        "id": 56,
        "className": "Person",
        coords: [
            203.0,
            206.0,
            254.0,
            323.0
        ],
        "status": "Moving",
        "speed": 76.48,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:40.600000",
        "id": 52,
        "className": "Person",
        coords: [
            505.0,
            243.0,
            553.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:40.600000",
        "id": 51,
        "className": "Person",
        coords: [
            316.0,
            292.0,
            372.0,
            454.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:40.600000",
        "id": 55,
        "className": "Person",
        coords: [
            140.0,
            180.0,
            180.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:40.600000",
        "id": 53,
        "className": "Person",
        coords: [
            28.0,
            223.0,
            80.0,
            356.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:40.600000",
        "id": 45,
        "className": "Person",
        coords: [
            335.0,
            539.0,
            464.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:40.700000",
        "id": 54,
        "className": "Person",
        coords: [
            768.0,
            192.0,
            809.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:40.700000",
        "id": 56,
        "className": "Person",
        coords: [
            205.0,
            207.0,
            252.0,
            314.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:40.700000",
        "id": 52,
        "className": "Person",
        coords: [
            505.0,
            243.0,
            553.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:40.700000",
        "id": 51,
        "className": "Person",
        coords: [
            316.0,
            292.0,
            373.0,
            454.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:40.800000",
        "id": 55,
        "className": "Person",
        coords: [
            141.0,
            180.0,
            180.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:40.800000",
        "id": 53,
        "className": "Person",
        coords: [
            29.0,
            223.0,
            81.0,
            356.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:40.800000",
        "id": 45,
        "className": "Person",
        coords: [
            335.0,
            539.0,
            464.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:40.800000",
        "id": 54,
        "className": "Person",
        coords: [
            768.0,
            192.0,
            809.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:40.800000",
        "id": 56,
        "className": "Person",
        coords: [
            205.0,
            207.0,
            252.0,
            313.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:40.900000",
        "id": 52,
        "className": "Person",
        coords: [
            505.0,
            243.0,
            553.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:40.900000",
        "id": 51,
        "className": "Person",
        coords: [
            316.0,
            291.0,
            373.0,
            454.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:40.900000",
        "id": 55,
        "className": "Person",
        coords: [
            141.0,
            180.0,
            180.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:40.900000",
        "id": 53,
        "className": "Person",
        coords: [
            30.0,
            223.0,
            81.0,
            356.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:41",
        "id": 45,
        "className": "Person",
        coords: [
            335.0,
            539.0,
            464.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:41",
        "id": 54,
        "className": "Person",
        coords: [
            769.0,
            192.0,
            810.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:41",
        "id": 56,
        "className": "Person",
        coords: [
            206.0,
            207.0,
            254.0,
            313.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:41.100000",
        "id": 52,
        "className": "Person",
        coords: [
            505.0,
            243.0,
            553.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:41.100000",
        "id": 51,
        "className": "Person",
        coords: [
            316.0,
            291.0,
            373.0,
            453.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:41.100000",
        "id": 55,
        "className": "Person",
        coords: [
            141.0,
            180.0,
            180.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:41.100000",
        "id": 53,
        "className": "Person",
        coords: [
            30.0,
            223.0,
            81.0,
            357.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:41.100000",
        "id": 45,
        "className": "Person",
        coords: [
            336.0,
            539.0,
            463.0,
            715.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:41.100000",
        "id": 54,
        "className": "Person",
        coords: [
            770.0,
            192.0,
            810.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:41.200000",
        "id": 56,
        "className": "Person",
        coords: [
            205.0,
            209.0,
            257.0,
            327.0
        ],
        "status": "Moving",
        "speed": 120.92,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:41.200000",
        "id": 52,
        "className": "Person",
        coords: [
            504.0,
            243.0,
            553.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:41.200000",
        "id": 51,
        "className": "Person",
        coords: [
            316.0,
            292.0,
            373.0,
            453.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:41.300000",
        "id": 55,
        "className": "Person",
        coords: [
            141.0,
            180.0,
            179.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:41.300000",
        "id": 53,
        "className": "Person",
        coords: [
            31.0,
            222.0,
            81.0,
            357.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:41.300000",
        "id": 45,
        "className": "Person",
        coords: [
            336.0,
            539.0,
            463.0,
            714.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:41.300000",
        "id": 54,
        "className": "Person",
        coords: [
            770.0,
            192.0,
            810.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:41.300000",
        "id": 56,
        "className": "Person",
        coords: [
            205.0,
            208.0,
            259.0,
            334.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:41.400000",
        "id": 52,
        "className": "Person",
        coords: [
            504.0,
            243.0,
            553.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:41.400000",
        "id": 51,
        "className": "Person",
        coords: [
            315.0,
            291.0,
            372.0,
            453.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:41.400000",
        "id": 55,
        "className": "Person",
        coords: [
            141.0,
            180.0,
            179.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:41.400000",
        "id": 53,
        "className": "Person",
        coords: [
            30.0,
            223.0,
            80.0,
            357.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:41.500000",
        "id": 45,
        "className": "Person",
        coords: [
            336.0,
            539.0,
            463.0,
            713.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:41.500000",
        "id": 54,
        "className": "Person",
        coords: [
            770.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:41.600000",
        "id": 56,
        "className": "Person",
        coords: [
            206.0,
            212.0,
            260.0,
            340.0
        ],
        "status": "Moving",
        "speed": 76.48,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:41.700000",
        "id": 52,
        "className": "Person",
        coords: [
            504.0,
            243.0,
            553.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:41.700000",
        "id": 51,
        "className": "Person",
        coords: [
            312.0,
            290.0,
            370.0,
            453.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:41.800000",
        "id": 55,
        "className": "Person",
        coords: [
            141.0,
            180.0,
            179.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:41.800000",
        "id": 53,
        "className": "Person",
        coords: [
            31.0,
            223.0,
            81.0,
            357.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:41.900000",
        "id": 45,
        "className": "Person",
        coords: [
            336.0,
            539.0,
            462.0,
            713.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:41.900000",
        "id": 54,
        "className": "Person",
        coords: [
            771.0,
            192.0,
            811.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:42",
        "id": 56,
        "className": "Person",
        coords: [
            210.0,
            217.0,
            263.0,
            344.0
        ],
        "status": "Moving",
        "speed": 74.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:42.100000",
        "id": 52,
        "className": "Person",
        coords: [
            504.0,
            243.0,
            553.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:42.100000",
        "id": 51,
        "className": "Person",
        coords: [
            310.0,
            290.0,
            367.0,
            452.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:42.200000",
        "id": 55,
        "className": "Person",
        coords: [
            141.0,
            180.0,
            178.0,
            269.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:42.200000",
        "id": 53,
        "className": "Person",
        coords: [
            30.0,
            222.0,
            80.0,
            357.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:42.300000",
        "id": 45,
        "className": "Person",
        coords: [
            337.0,
            539.0,
            462.0,
            712.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:42.300000",
        "id": 54,
        "className": "Person",
        coords: [
            771.0,
            192.0,
            812.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:42.400000",
        "id": 56,
        "className": "Person",
        coords: [
            213.0,
            221.0,
            265.0,
            345.0
        ],
        "status": "Moving",
        "speed": 63.63,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:50.700000",
        "id": 52,
        "className": "Person",
        coords: [
            504.0,
            243.0,
            553.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:50.900000",
        "id": 51,
        "className": "Person",
        coords: [
            307.0,
            289.0,
            365.0,
            451.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:50.900000",
        "id": 55,
        "className": "Person",
        coords: [
            141.0,
            180.0,
            178.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:51",
        "id": 53,
        "className": "Person",
        coords: [
            30.0,
            222.0,
            80.0,
            357.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:51",
        "id": 45,
        "className": "Person",
        coords: [
            337.0,
            539.0,
            462.0,
            712.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:51",
        "id": 54,
        "className": "Person",
        coords: [
            771.0,
            192.0,
            812.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:51.100000",
        "id": 56,
        "className": "Person",
        coords: [
            215.0,
            222.0,
            267.0,
            345.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:51.400000",
        "id": 52,
        "className": "Person",
        coords: [
            503.0,
            243.0,
            553.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:51.400000",
        "id": 51,
        "className": "Person",
        coords: [
            304.0,
            288.0,
            362.0,
            451.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:51.500000",
        "id": 55,
        "className": "Person",
        coords: [
            141.0,
            180.0,
            178.0,
            268.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:51.500000",
        "id": 53,
        "className": "Person",
        coords: [
            30.0,
            222.0,
            80.0,
            357.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:51.500000",
        "id": 45,
        "className": "Person",
        coords: [
            337.0,
            539.0,
            462.0,
            712.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:51.500000",
        "id": 54,
        "className": "Person",
        coords: [
            771.0,
            192.0,
            813.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:51.600000",
        "id": 56,
        "className": "Person",
        coords: [
            217.0,
            222.0,
            268.0,
            345.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:51.600000",
        "id": 52,
        "className": "Person",
        coords: [
            504.0,
            243.0,
            553.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:51.700000",
        "id": 51,
        "className": "Person",
        coords: [
            302.0,
            288.0,
            359.0,
            450.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:51.700000",
        "id": 55,
        "className": "Person",
        coords: [
            140.0,
            180.0,
            177.0,
            267.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:51.700000",
        "id": 53,
        "className": "Person",
        coords: [
            30.0,
            222.0,
            80.0,
            357.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:51.700000",
        "id": 45,
        "className": "Person",
        coords: [
            337.0,
            539.0,
            462.0,
            711.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:51.800000",
        "id": 54,
        "className": "Person",
        coords: [
            771.0,
            192.0,
            813.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:51.800000",
        "id": 56,
        "className": "Person",
        coords: [
            218.0,
            219.0,
            270.0,
            345.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:51.800000",
        "id": 52,
        "className": "Person",
        coords: [
            504.0,
            243.0,
            553.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:51.900000",
        "id": 51,
        "className": "Person",
        coords: [
            300.0,
            288.0,
            358.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:51.900000",
        "id": 55,
        "className": "Person",
        coords: [
            138.0,
            183.0,
            173.0,
            267.0
        ],
        "status": "Moving",
        "speed": 54.08,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:51.900000",
        "id": 53,
        "className": "Person",
        coords: [
            31.0,
            222.0,
            80.0,
            357.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:51.900000",
        "id": 45,
        "className": "Person",
        coords: [
            338.0,
            539.0,
            461.0,
            710.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:51.900000",
        "id": 54,
        "className": "Person",
        coords: [
            771.0,
            192.0,
            813.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:52",
        "id": 56,
        "className": "Person",
        coords: [
            218.0,
            221.0,
            269.0,
            344.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:52.100000",
        "id": 52,
        "className": "Person",
        coords: [
            503.0,
            243.0,
            552.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:52.100000",
        "id": 51,
        "className": "Person",
        coords: [
            298.0,
            287.0,
            356.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:52.100000",
        "id": 55,
        "className": "Person",
        coords: [
            136.0,
            183.0,
            169.0,
            264.0
        ],
        "status": "Moving",
        "speed": 54.08,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:52.100000",
        "id": 53,
        "className": "Person",
        coords: [
            30.0,
            221.0,
            80.0,
            357.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:52.100000",
        "id": 45,
        "className": "Person",
        coords: [
            337.0,
            538.0,
            462.0,
            711.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:52.100000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            193.0,
            813.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:52.200000",
        "id": 56,
        "className": "Person",
        coords: [
            220.0,
            219.0,
            272.0,
            344.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:52.200000",
        "id": 52,
        "className": "Person",
        coords: [
            502.0,
            243.0,
            552.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:52.200000",
        "id": 51,
        "className": "Person",
        coords: [
            296.0,
            286.0,
            356.0,
            452.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:52.200000",
        "id": 55,
        "className": "Person",
        coords: [
            134.0,
            184.0,
            166.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:52.300000",
        "id": 53,
        "className": "Person",
        coords: [
            30.0,
            220.0,
            79.0,
            356.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:52.300000",
        "id": 45,
        "className": "Person",
        coords: [
            337.0,
            538.0,
            462.0,
            712.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:52.300000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            813.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:52.300000",
        "id": 56,
        "className": "Person",
        coords: [
            219.0,
            218.0,
            275.0,
            353.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:52.400000",
        "id": 52,
        "className": "Person",
        coords: [
            502.0,
            243.0,
            552.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:52.400000",
        "id": 51,
        "className": "Person",
        coords: [
            293.0,
            285.0,
            353.0,
            451.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:52.400000",
        "id": 55,
        "className": "Person",
        coords: [
            132.0,
            184.0,
            164.0,
            261.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:52.400000",
        "id": 53,
        "className": "Person",
        coords: [
            30.0,
            220.0,
            79.0,
            356.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:52.500000",
        "id": 45,
        "className": "Person",
        coords: [
            337.0,
            538.0,
            462.0,
            712.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:52.500000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            814.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:52.500000",
        "id": 56,
        "className": "Person",
        coords: [
            218.0,
            219.0,
            276.0,
            357.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:52.600000",
        "id": 52,
        "className": "Person",
        coords: [
            502.0,
            243.0,
            552.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:52.600000",
        "id": 51,
        "className": "Person",
        coords: [
            291.0,
            285.0,
            351.0,
            450.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:52.600000",
        "id": 55,
        "className": "Person",
        coords: [
            130.0,
            182.0,
            161.0,
            256.0
        ],
        "status": "Moving",
        "speed": 63.63,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:52.600000",
        "id": 53,
        "className": "Person",
        coords: [
            30.0,
            220.0,
            79.0,
            356.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:52.600000",
        "id": 45,
        "className": "Person",
        coords: [
            337.0,
            538.0,
            461.0,
            711.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:52.700000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            814.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:52.700000",
        "id": 56,
        "className": "Person",
        coords: [
            218.0,
            220.0,
            276.0,
            361.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:52.700000",
        "id": 52,
        "className": "Person",
        coords: [
            502.0,
            243.0,
            552.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:52.700000",
        "id": 51,
        "className": "Person",
        coords: [
            294.0,
            307.0,
            347.0,
            448.0
        ],
        "status": "Moving",
        "speed": 150.74,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:52.800000",
        "id": 53,
        "className": "Person",
        coords: [
            30.0,
            220.0,
            79.0,
            356.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:52.800000",
        "id": 45,
        "className": "Person",
        coords: [
            337.0,
            538.0,
            461.0,
            711.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:52.800000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            814.0,
            262.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:52.800000",
        "id": 56,
        "className": "Person",
        coords: [
            219.0,
            221.0,
            276.0,
            362.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:52.900000",
        "id": 52,
        "className": "Person",
        coords: [
            502.0,
            243.0,
            552.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:52.900000",
        "id": 51,
        "className": "Person",
        coords: [
            294.0,
            313.0,
            344.0,
            447.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:52.900000",
        "id": 53,
        "className": "Person",
        coords: [
            30.0,
            220.0,
            78.0,
            356.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:52.900000",
        "id": 45,
        "className": "Person",
        coords: [
            337.0,
            538.0,
            461.0,
            710.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:53",
        "id": 54,
        "className": "Person",
        coords: [
            771.0,
            194.0,
            814.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:53",
        "id": 56,
        "className": "Person",
        coords: [
            219.0,
            222.0,
            277.0,
            363.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:53",
        "id": 52,
        "className": "Person",
        coords: [
            502.0,
            243.0,
            552.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:53.100000",
        "id": 51,
        "className": "Person",
        coords: [
            293.0,
            317.0,
            343.0,
            447.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:53.100000",
        "id": 53,
        "className": "Person",
        coords: [
            30.0,
            221.0,
            78.0,
            356.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:53.100000",
        "id": 45,
        "className": "Person",
        coords: [
            338.0,
            538.0,
            459.0,
            705.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:53.100000",
        "id": 54,
        "className": "Person",
        coords: [
            771.0,
            194.0,
            814.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:53.100000",
        "id": 56,
        "className": "Person",
        coords: [
            221.0,
            221.0,
            278.0,
            363.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:53.200000",
        "id": 52,
        "className": "Person",
        coords: [
            502.0,
            243.0,
            552.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:53.200000",
        "id": 51,
        "className": "Person",
        coords: [
            288.0,
            318.0,
            339.0,
            446.0
        ],
        "status": "Moving",
        "speed": 74.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:53.200000",
        "id": 53,
        "className": "Person",
        coords: [
            30.0,
            221.0,
            78.0,
            356.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:53.300000",
        "id": 45,
        "className": "Person",
        coords: [
            335.0,
            538.0,
            458.0,
            707.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:53.300000",
        "id": 54,
        "className": "Person",
        coords: [
            771.0,
            194.0,
            814.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:53.300000",
        "id": 56,
        "className": "Person",
        coords: [
            225.0,
            222.0,
            275.0,
            342.0
        ],
        "status": "Moving",
        "speed": 150.74,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:53.400000",
        "id": 52,
        "className": "Person",
        coords: [
            502.0,
            243.0,
            552.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:53.400000",
        "id": 53,
        "className": "Person",
        coords: [
            30.0,
            222.0,
            78.0,
            356.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:53.400000",
        "id": 45,
        "className": "Person",
        coords: [
            336.0,
            538.0,
            460.0,
            707.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:53.500000",
        "id": 54,
        "className": "Person",
        coords: [
            771.0,
            194.0,
            814.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:53.500000",
        "id": 56,
        "className": "Person",
        coords: [
            223.0,
            223.0,
            278.0,
            356.0
        ],
        "status": "Moving",
        "speed": 104.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:53.600000",
        "id": 52,
        "className": "Person",
        coords: [
            501.0,
            244.0,
            552.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:53.600000",
        "id": 53,
        "className": "Person",
        coords: [
            30.0,
            222.0,
            78.0,
            356.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:53.600000",
        "id": 45,
        "className": "Person",
        coords: [
            334.0,
            538.0,
            461.0,
            706.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:53.600000",
        "id": 54,
        "className": "Person",
        coords: [
            771.0,
            194.0,
            814.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:53.600000",
        "id": 56,
        "className": "Person",
        coords: [
            223.0,
            225.0,
            280.0,
            364.0
        ],
        "status": "Moving",
        "speed": 76.48,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:53.700000",
        "id": 51,
        "className": "Person",
        coords: [
            290.0,
            306.0,
            344.0,
            444.0
        ],
        "status": "Moving",
        "speed": 120.92,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:53.700000",
        "id": 52,
        "className": "Person",
        coords: [
            501.0,
            244.0,
            552.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:53.700000",
        "id": 53,
        "className": "Person",
        coords: [
            31.0,
            222.0,
            78.0,
            356.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:53.800000",
        "id": 45,
        "className": "Person",
        coords: [
            341.0,
            538.0,
            466.0,
            700.0
        ],
        "status": "Moving",
        "speed": 100.61,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:53.800000",
        "id": 54,
        "className": "Person",
        coords: [
            771.0,
            194.0,
            814.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:53.800000",
        "id": 56,
        "className": "Person",
        coords: [
            223.0,
            226.0,
            279.0,
            362.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:53.800000",
        "id": 51,
        "className": "Person",
        coords: [
            291.0,
            302.0,
            345.0,
            444.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:53.900000",
        "id": 52,
        "className": "Person",
        coords: [
            501.0,
            244.0,
            552.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:53.900000",
        "id": 53,
        "className": "Person",
        coords: [
            31.0,
            222.0,
            78.0,
            356.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:53.900000",
        "id": 45,
        "className": "Person",
        coords: [
            346.0,
            538.0,
            470.0,
            697.0
        ],
        "status": "Moving",
        "speed": 80.77,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:54",
        "id": 54,
        "className": "Person",
        coords: [
            771.0,
            194.0,
            814.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:54",
        "id": 56,
        "className": "Person",
        coords: [
            228.0,
            228.0,
            279.0,
            351.0
        ],
        "status": "Moving",
        "speed": 80.77,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:54",
        "id": 51,
        "className": "Person",
        coords: [
            289.0,
            296.0,
            345.0,
            443.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:54.100000",
        "id": 52,
        "className": "Person",
        coords: [
            501.0,
            244.0,
            552.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:54.100000",
        "id": 53,
        "className": "Person",
        coords: [
            31.0,
            222.0,
            78.0,
            356.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:54.100000",
        "id": 45,
        "className": "Person",
        coords: [
            347.0,
            538.0,
            472.0,
            697.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:54.100000",
        "id": 54,
        "className": "Person",
        coords: [
            771.0,
            194.0,
            814.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:54.200000",
        "id": 56,
        "className": "Person",
        coords: [
            227.0,
            230.0,
            282.0,
            361.0
        ],
        "status": "Moving",
        "speed": 91.23,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:54.200000",
        "id": 51,
        "className": "Person",
        coords: [
            287.0,
            288.0,
            345.0,
            443.0
        ],
        "status": "Moving",
        "speed": 61.84,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:54.200000",
        "id": 52,
        "className": "Person",
        coords: [
            502.0,
            244.0,
            552.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:54.300000",
        "id": 53,
        "className": "Person",
        coords: [
            31.0,
            222.0,
            79.0,
            356.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:54.300000",
        "id": 45,
        "className": "Person",
        coords: [
            346.0,
            538.0,
            473.0,
            697.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:54.300000",
        "id": 54,
        "className": "Person",
        coords: [
            771.0,
            194.0,
            815.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:54.300000",
        "id": 56,
        "className": "Person",
        coords: [
            228.0,
            234.0,
            283.0,
            363.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:54.300000",
        "id": 51,
        "className": "Person",
        coords: [
            287.0,
            284.0,
            344.0,
            442.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:54.400000",
        "id": 52,
        "className": "Person",
        coords: [
            502.0,
            245.0,
            551.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:54.400000",
        "id": 53,
        "className": "Person",
        coords: [
            31.0,
            221.0,
            78.0,
            356.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:54.400000",
        "id": 45,
        "className": "Person",
        coords: [
            345.0,
            538.0,
            474.0,
            699.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:54.500000",
        "id": 54,
        "className": "Person",
        coords: [
            771.0,
            194.0,
            814.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:54.500000",
        "id": 56,
        "className": "Person",
        coords: [
            228.0,
            236.0,
            284.0,
            366.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:54.500000",
        "id": 51,
        "className": "Person",
        coords: [
            285.0,
            282.0,
            343.0,
            441.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:54.600000",
        "id": 52,
        "className": "Person",
        coords: [
            503.0,
            245.0,
            551.0,
            326.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:54.600000",
        "id": 53,
        "className": "Person",
        coords: [
            32.0,
            224.0,
            78.0,
            355.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:54.600000",
        "id": 45,
        "className": "Person",
        coords: [
            344.0,
            538.0,
            475.0,
            701.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:54.600000",
        "id": 54,
        "className": "Person",
        coords: [
            770.0,
            193.0,
            814.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:54.600000",
        "id": 56,
        "className": "Person",
        coords: [
            229.0,
            240.0,
            285.0,
            368.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:54.700000",
        "id": 51,
        "className": "Person",
        coords: [
            285.0,
            280.0,
            342.0,
            441.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:54.700000",
        "id": 52,
        "className": "Person",
        coords: [
            502.0,
            245.0,
            551.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:54.700000",
        "id": 53,
        "className": "Person",
        coords: [
            31.0,
            221.0,
            77.0,
            352.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:54.800000",
        "id": 45,
        "className": "Person",
        coords: [
            344.0,
            538.0,
            476.0,
            700.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:54.800000",
        "id": 54,
        "className": "Person",
        coords: [
            770.0,
            193.0,
            814.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:54.800000",
        "id": 56,
        "className": "Person",
        coords: [
            229.0,
            240.0,
            285.0,
            370.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:54.800000",
        "id": 51,
        "className": "Person",
        coords: [
            285.0,
            280.0,
            341.0,
            442.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:54.900000",
        "id": 52,
        "className": "Person",
        coords: [
            503.0,
            245.0,
            551.0,
            327.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:54.900000",
        "id": 53,
        "className": "Person",
        coords: [
            31.0,
            220.0,
            76.0,
            350.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:54.900000",
        "id": 45,
        "className": "Person",
        coords: [
            345.0,
            538.0,
            475.0,
            697.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:54.900000",
        "id": 54,
        "className": "Person",
        coords: [
            770.0,
            193.0,
            814.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:55",
        "id": 56,
        "className": "Person",
        coords: [
            229.0,
            238.0,
            286.0,
            370.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:55",
        "id": 51,
        "className": "Person",
        coords: [
            285.0,
            280.0,
            341.0,
            442.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:55",
        "id": 52,
        "className": "Person",
        coords: [
            499.0,
            245.0,
            548.0,
            327.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:55",
        "id": 53,
        "className": "Person",
        coords: [
            31.0,
            221.0,
            75.0,
            350.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:55.100000",
        "id": 45,
        "className": "Person",
        coords: [
            345.0,
            538.0,
            475.0,
            697.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:55.100000",
        "id": 54,
        "className": "Person",
        coords: [
            770.0,
            193.0,
            814.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:55.100000",
        "id": 56,
        "className": "Person",
        coords: [
            231.0,
            240.0,
            287.0,
            369.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:55.100000",
        "id": 51,
        "className": "Person",
        coords: [
            286.0,
            280.0,
            341.0,
            442.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:55.200000",
        "id": 52,
        "className": "Person",
        coords: [
            498.0,
            246.0,
            548.0,
            328.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:55.200000",
        "id": 53,
        "className": "Person",
        coords: [
            31.0,
            221.0,
            75.0,
            350.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:55.200000",
        "id": 54,
        "className": "Person",
        coords: [
            770.0,
            193.0,
            814.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:55.200000",
        "id": 56,
        "className": "Person",
        coords: [
            232.0,
            244.0,
            285.0,
            363.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:55.200000",
        "id": 51,
        "className": "Person",
        coords: [
            286.0,
            280.0,
            341.0,
            444.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:55.300000",
        "id": 53,
        "className": "Person",
        coords: [
            31.0,
            222.0,
            74.0,
            349.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:55.300000",
        "id": 54,
        "className": "Person",
        coords: [
            770.0,
            193.0,
            815.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:55.300000",
        "id": 56,
        "className": "Person",
        coords: [
            233.0,
            244.0,
            285.0,
            360.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:55.400000",
        "id": 51,
        "className": "Person",
        coords: [
            285.0,
            281.0,
            340.0,
            444.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:55.400000",
        "id": 45,
        "className": "Person",
        coords: [
            342.0,
            540.0,
            476.0,
            706.0
        ],
        "status": "Moving",
        "speed": 91.23,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:55.400000",
        "id": 53,
        "className": "Person",
        coords: [
            31.0,
            222.0,
            74.0,
            349.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:55.500000",
        "id": 54,
        "className": "Person",
        coords: [
            771.0,
            193.0,
            815.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:55.500000",
        "id": 56,
        "className": "Person",
        coords: [
            233.0,
            243.0,
            286.0,
            361.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:55.500000",
        "id": 51,
        "className": "Person",
        coords: [
            281.0,
            281.0,
            337.0,
            444.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:55.500000",
        "id": 45,
        "className": "Person",
        coords: [
            346.0,
            543.0,
            472.0,
            698.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:55.600000",
        "id": 53,
        "className": "Person",
        coords: [
            31.0,
            222.0,
            74.0,
            349.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:55.600000",
        "id": 54,
        "className": "Person",
        coords: [
            771.0,
            193.0,
            815.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:55.600000",
        "id": 56,
        "className": "Person",
        coords: [
            232.0,
            242.0,
            287.0,
            363.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:55.600000",
        "id": 51,
        "className": "Person",
        coords: [
            278.0,
            281.0,
            335.0,
            445.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:55.700000",
        "id": 52,
        "className": "Person",
        coords: [
            469.0,
            244.0,
            527.0,
            329.0
        ],
        "status": "Moving",
        "speed": 375.27,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:55.800000",
        "id": 53,
        "className": "Person",
        coords: [
            31.0,
            221.0,
            74.0,
            350.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:55.800000",
        "id": 54,
        "className": "Person",
        coords: [
            771.0,
            193.0,
            816.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:25:55.900000",
        "id": 56,
        "className": "Person",
        coords: [
            232.0,
            244.0,
            287.0,
            364.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:25:55.900000",
        "id": 51,
        "className": "Person",
        coords: [
            276.0,
            281.0,
            334.0,
            446.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:00.900000",
        "id": 53,
        "className": "Person",
        coords: [
            32.0,
            221.0,
            75.0,
            350.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:01",
        "id": 54,
        "className": "Person",
        coords: [
            771.0,
            193.0,
            816.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:01.100000",
        "id": 56,
        "className": "Person",
        coords: [
            233.0,
            246.0,
            287.0,
            365.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:01.100000",
        "id": 51,
        "className": "Person",
        coords: [
            274.0,
            281.0,
            333.0,
            446.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:01.100000",
        "id": 45,
        "className": "Person",
        coords: [
            347.0,
            544.0,
            468.0,
            694.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:01.400000",
        "id": 53,
        "className": "Person",
        coords: [
            32.0,
            221.0,
            75.0,
            350.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:01.400000",
        "id": 54,
        "className": "Person",
        coords: [
            771.0,
            193.0,
            816.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:01.400000",
        "id": 56,
        "className": "Person",
        coords: [
            232.0,
            246.0,
            287.0,
            366.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:01.400000",
        "id": 51,
        "className": "Person",
        coords: [
            274.0,
            286.0,
            333.0,
            446.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:01.500000",
        "id": 52,
        "className": "Person",
        coords: [
            468.0,
            244.0,
            530.0,
            329.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:01.500000",
        "id": 53,
        "className": "Person",
        coords: [
            32.0,
            219.0,
            75.0,
            351.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:01.600000",
        "id": 54,
        "className": "Person",
        coords: [
            771.0,
            193.0,
            816.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:01.600000",
        "id": 56,
        "className": "Person",
        coords: [
            235.0,
            252.0,
            286.0,
            362.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:01.600000",
        "id": 51,
        "className": "Person",
        coords: [
            274.0,
            289.0,
            333.0,
            446.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:01.600000",
        "id": 52,
        "className": "Person",
        coords: [
            476.0,
            245.0,
            538.0,
            328.0
        ],
        "status": "Moving",
        "speed": 119.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:01.700000",
        "id": 45,
        "className": "Person",
        coords: [
            347.0,
            544.0,
            466.0,
            692.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:01.700000",
        "id": 53,
        "className": "Person",
        coords: [
            32.0,
            220.0,
            75.0,
            350.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:01.700000",
        "id": 54,
        "className": "Person",
        coords: [
            771.0,
            193.0,
            816.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:01.800000",
        "id": 56,
        "className": "Person",
        coords: [
            234.0,
            253.0,
            285.0,
            361.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:01.800000",
        "id": 51,
        "className": "Person",
        coords: [
            276.0,
            291.0,
            335.0,
            446.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:01.800000",
        "id": 52,
        "className": "Person",
        coords: [
            461.0,
            243.0,
            528.0,
            326.0
        ],
        "status": "Moving",
        "speed": 197.28,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:01.900000",
        "id": 45,
        "className": "Person",
        coords: [
            347.0,
            544.0,
            466.0,
            692.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:01.900000",
        "id": 53,
        "className": "Person",
        coords: [
            31.0,
            219.0,
            75.0,
            350.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:02",
        "id": 54,
        "className": "Person",
        coords: [
            771.0,
            193.0,
            816.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:02",
        "id": 56,
        "className": "Person",
        coords: [
            235.0,
            255.0,
            285.0,
            360.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:02",
        "id": 51,
        "className": "Person",
        coords: [
            276.0,
            286.0,
            337.0,
            446.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:02",
        "id": 52,
        "className": "Person",
        coords: [
            452.0,
            241.0,
            524.0,
            325.0
        ],
        "status": "Moving",
        "speed": 91.23,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:02.100000",
        "id": 45,
        "className": "Person",
        coords: [
            347.0,
            544.0,
            466.0,
            692.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:02.100000",
        "id": 53,
        "className": "Person",
        coords: [
            32.0,
            221.0,
            74.0,
            349.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:02.100000",
        "id": 54,
        "className": "Person",
        coords: [
            771.0,
            193.0,
            816.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:02.200000",
        "id": 56,
        "className": "Person",
        coords: [
            237.0,
            255.0,
            290.0,
            367.0
        ],
        "status": "Moving",
        "speed": 74.99,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:02.200000",
        "id": 51,
        "className": "Person",
        coords: [
            276.0,
            284.0,
            338.0,
            446.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:02.200000",
        "id": 52,
        "className": "Person",
        coords: [
            446.0,
            238.0,
            523.0,
            324.0
        ],
        "status": "Moving",
        "speed": 67.08,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:02.200000",
        "id": 45,
        "className": "Person",
        coords: [
            347.0,
            544.0,
            465.0,
            692.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:02.300000",
        "id": 53,
        "className": "Person",
        coords: [
            31.0,
            219.0,
            75.0,
            352.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:02.300000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            193.0,
            816.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:02.400000",
        "id": 56,
        "className": "Person",
        coords: [
            237.0,
            256.0,
            292.0,
            372.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:02.400000",
        "id": 51,
        "className": "Person",
        coords: [
            277.0,
            283.0,
            339.0,
            446.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:02.400000",
        "id": 52,
        "className": "Person",
        coords: [
            443.0,
            239.0,
            521.0,
            324.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:02.400000",
        "id": 45,
        "className": "Person",
        coords: [
            342.0,
            544.0,
            470.0,
            705.0
        ],
        "status": "Moving",
        "speed": 89.99,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:02.500000",
        "id": 53,
        "className": "Person",
        coords: [
            30.0,
            221.0,
            74.0,
            353.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:02.500000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            816.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:02.500000",
        "id": 56,
        "className": "Person",
        coords: [
            238.0,
            257.0,
            294.0,
            373.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:02.500000",
        "id": 51,
        "className": "Person",
        coords: [
            277.0,
            283.0,
            339.0,
            446.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:02.600000",
        "id": 52,
        "className": "Person",
        coords: [
            438.0,
            239.0,
            521.0,
            325.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:02.600000",
        "id": 45,
        "className": "Person",
        coords: [
            341.0,
            544.0,
            471.0,
            710.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:02.700000",
        "id": 53,
        "className": "Person",
        coords: [
            27.0,
            218.0,
            74.0,
            354.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:02.700000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            816.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:02.700000",
        "id": 56,
        "className": "Person",
        coords: [
            240.0,
            257.0,
            295.0,
            372.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:02.700000",
        "id": 51,
        "className": "Person",
        coords: [
            277.0,
            283.0,
            339.0,
            446.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:02.700000",
        "id": 52,
        "className": "Person",
        coords: [
            435.0,
            238.0,
            522.0,
            325.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:02.800000",
        "id": 45,
        "className": "Person",
        coords: [
            342.0,
            544.0,
            470.0,
            709.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:02.800000",
        "id": 53,
        "className": "Person",
        coords: [
            30.0,
            220.0,
            75.0,
            352.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:02.900000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            816.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:02.900000",
        "id": 56,
        "className": "Person",
        coords: [
            240.0,
            258.0,
            296.0,
            372.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:02.900000",
        "id": 51,
        "className": "Person",
        coords: [
            278.0,
            283.0,
            340.0,
            446.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:02.900000",
        "id": 45,
        "className": "Person",
        coords: [
            342.0,
            544.0,
            470.0,
            710.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:03",
        "id": 53,
        "className": "Person",
        coords: [
            28.0,
            221.0,
            74.0,
            355.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:03",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            816.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:03",
        "id": 56,
        "className": "Person",
        coords: [
            241.0,
            259.0,
            295.0,
            372.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:03",
        "id": 51,
        "className": "Person",
        coords: [
            278.0,
            282.0,
            340.0,
            446.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:03.100000",
        "id": 45,
        "className": "Person",
        coords: [
            342.0,
            544.0,
            469.0,
            711.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:03.100000",
        "id": 53,
        "className": "Person",
        coords: [
            28.0,
            221.0,
            75.0,
            357.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:03.200000",
        "id": 54,
        "className": "Person",
        coords: [
            771.0,
            194.0,
            816.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:03.200000",
        "id": 56,
        "className": "Person",
        coords: [
            241.0,
            261.0,
            295.0,
            371.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:03.200000",
        "id": 51,
        "className": "Person",
        coords: [
            279.0,
            283.0,
            340.0,
            446.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:03.200000",
        "id": 45,
        "className": "Person",
        coords: [
            343.0,
            544.0,
            469.0,
            712.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:03.300000",
        "id": 53,
        "className": "Person",
        coords: [
            27.0,
            221.0,
            75.0,
            357.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:03.300000",
        "id": 54,
        "className": "Person",
        coords: [
            771.0,
            194.0,
            816.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:03.300000",
        "id": 56,
        "className": "Person",
        coords: [
            242.0,
            261.0,
            296.0,
            369.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:03.400000",
        "id": 51,
        "className": "Person",
        coords: [
            279.0,
            286.0,
            339.0,
            446.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:03.400000",
        "id": 45,
        "className": "Person",
        coords: [
            343.0,
            544.0,
            468.0,
            711.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:03.500000",
        "id": 53,
        "className": "Person",
        coords: [
            25.0,
            219.0,
            74.0,
            358.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:03.500000",
        "id": 54,
        "className": "Person",
        coords: [
            771.0,
            194.0,
            815.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:03.500000",
        "id": 56,
        "className": "Person",
        coords: [
            246.0,
            265.0,
            295.0,
            359.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:03.500000",
        "id": 51,
        "className": "Person",
        coords: [
            281.0,
            295.0,
            338.0,
            446.0
        ],
        "status": "Moving",
        "speed": 60.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:03.600000",
        "id": 45,
        "className": "Person",
        coords: [
            343.0,
            545.0,
            467.0,
            711.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:03.600000",
        "id": 53,
        "className": "Person",
        coords: [
            23.0,
            217.0,
            74.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:03.600000",
        "id": 54,
        "className": "Person",
        coords: [
            771.0,
            194.0,
            815.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:03.700000",
        "id": 56,
        "className": "Person",
        coords: [
            246.0,
            270.0,
            296.0,
            364.0
        ],
        "status": "Moving",
        "speed": 76.48,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:03.700000",
        "id": 51,
        "className": "Person",
        coords: [
            280.0,
            288.0,
            340.0,
            446.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:03.700000",
        "id": 45,
        "className": "Person",
        coords: [
            344.0,
            545.0,
            467.0,
            711.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:03.800000",
        "id": 53,
        "className": "Person",
        coords: [
            22.0,
            217.0,
            74.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:03.800000",
        "id": 54,
        "className": "Person",
        coords: [
            771.0,
            194.0,
            814.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:03.800000",
        "id": 51,
        "className": "Person",
        coords: [
            281.0,
            289.0,
            340.0,
            446.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:03.800000",
        "id": 45,
        "className": "Person",
        coords: [
            344.0,
            545.0,
            466.0,
            712.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:03.900000",
        "id": 53,
        "className": "Person",
        coords: [
            24.0,
            220.0,
            75.0,
            357.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:03.900000",
        "id": 54,
        "className": "Person",
        coords: [
            771.0,
            194.0,
            814.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:03.900000",
        "id": 51,
        "className": "Person",
        coords: [
            283.0,
            294.0,
            340.0,
            446.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:04",
        "id": 45,
        "className": "Person",
        coords: [
            344.0,
            545.0,
            466.0,
            712.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:04",
        "id": 53,
        "className": "Person",
        coords: [
            27.0,
            223.0,
            76.0,
            356.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:04",
        "id": 54,
        "className": "Person",
        coords: [
            771.0,
            194.0,
            814.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:04",
        "id": 51,
        "className": "Person",
        coords: [
            285.0,
            294.0,
            341.0,
            446.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:04.100000",
        "id": 45,
        "className": "Person",
        coords: [
            344.0,
            545.0,
            466.0,
            712.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:04.100000",
        "id": 53,
        "className": "Person",
        coords: [
            26.0,
            224.0,
            76.0,
            356.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:04.100000",
        "id": 54,
        "className": "Person",
        coords: [
            771.0,
            194.0,
            814.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:04.200000",
        "id": 51,
        "className": "Person",
        coords: [
            287.0,
            298.0,
            341.0,
            446.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:04.200000",
        "id": 45,
        "className": "Person",
        coords: [
            345.0,
            545.0,
            465.0,
            712.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:04.200000",
        "id": 53,
        "className": "Person",
        coords: [
            26.0,
            225.0,
            76.0,
            356.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:04.200000",
        "id": 54,
        "className": "Person",
        coords: [
            771.0,
            194.0,
            813.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:04.300000",
        "id": 51,
        "className": "Person",
        coords: [
            289.0,
            303.0,
            340.0,
            445.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:04.300000",
        "id": 45,
        "className": "Person",
        coords: [
            345.0,
            545.0,
            464.0,
            712.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:04.300000",
        "id": 53,
        "className": "Person",
        coords: [
            25.0,
            222.0,
            76.0,
            354.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:04.400000",
        "id": 54,
        "className": "Person",
        coords: [
            771.0,
            194.0,
            813.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:04.400000",
        "id": 51,
        "className": "Person",
        coords: [
            289.0,
            301.0,
            341.0,
            445.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:04.400000",
        "id": 45,
        "className": "Person",
        coords: [
            344.0,
            545.0,
            464.0,
            713.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:04.500000",
        "id": 53,
        "className": "Person",
        coords: [
            25.0,
            222.0,
            76.0,
            356.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:04.500000",
        "id": 54,
        "className": "Person",
        coords: [
            771.0,
            194.0,
            813.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:04.500000",
        "id": 51,
        "className": "Person",
        coords: [
            289.0,
            296.0,
            343.0,
            445.0
        ],
        "status": "Moving",
        "speed": 47.43,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:04.500000",
        "id": 45,
        "className": "Person",
        coords: [
            344.0,
            545.0,
            464.0,
            714.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:04.600000",
        "id": 52,
        "className": "Person",
        coords: [
            423.0,
            234.0,
            517.0,
            322.0
        ],
        "status": "Moving",
        "speed": 128.15,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:04.600000",
        "id": 53,
        "className": "Person",
        coords: [
            19.0,
            220.0,
            73.0,
            355.0
        ],
        "status": "Moving",
        "speed": 67.08,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:04.600000",
        "id": 54,
        "className": "Person",
        coords: [
            771.0,
            194.0,
            813.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:04.700000",
        "id": 51,
        "className": "Person",
        coords: [
            289.0,
            291.0,
            346.0,
            445.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:04.700000",
        "id": 45,
        "className": "Person",
        coords: [
            344.0,
            544.0,
            463.0,
            714.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:04.700000",
        "id": 52,
        "className": "Person",
        coords: [
            420.0,
            234.0,
            520.0,
            322.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:04.800000",
        "id": 53,
        "className": "Person",
        coords: [
            23.0,
            221.0,
            76.0,
            357.0
        ],
        "status": "Moving",
        "speed": 54.08,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:04.800000",
        "id": 54,
        "className": "Person",
        coords: [
            771.0,
            194.0,
            813.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:04.800000",
        "id": 51,
        "className": "Person",
        coords: [
            288.0,
            290.0,
            347.0,
            445.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:04.800000",
        "id": 45,
        "className": "Person",
        coords: [
            343.0,
            543.0,
            464.0,
            715.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:04.900000",
        "id": 52,
        "className": "Person",
        coords: [
            419.0,
            234.0,
            522.0,
            322.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:04.900000",
        "id": 53,
        "className": "Person",
        coords: [
            25.0,
            225.0,
            76.0,
            354.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:04.900000",
        "id": 54,
        "className": "Person",
        coords: [
            771.0,
            194.0,
            813.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:04.900000",
        "id": 51,
        "className": "Person",
        coords: [
            287.0,
            289.0,
            347.0,
            445.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:05",
        "id": 45,
        "className": "Person",
        coords: [
            343.0,
            542.0,
            464.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:05",
        "id": 52,
        "className": "Person",
        coords: [
            418.0,
            234.0,
            523.0,
            322.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:05",
        "id": 53,
        "className": "Person",
        coords: [
            26.0,
            224.0,
            78.0,
            356.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:05.100000",
        "id": 54,
        "className": "Person",
        coords: [
            771.0,
            194.0,
            813.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:05.100000",
        "id": 51,
        "className": "Person",
        coords: [
            288.0,
            290.0,
            349.0,
            446.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:05.100000",
        "id": 45,
        "className": "Person",
        coords: [
            343.0,
            542.0,
            464.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:05.100000",
        "id": 52,
        "className": "Person",
        coords: [
            417.0,
            234.0,
            524.0,
            322.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:05.200000",
        "id": 56,
        "className": "Person",
        coords: [
            235.0,
            276.0,
            291.0,
            373.0
        ],
        "status": "Moving",
        "speed": 159.44,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:05.200000",
        "id": 53,
        "className": "Person",
        coords: [
            27.0,
            224.0,
            79.0,
            356.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:05.200000",
        "id": 54,
        "className": "Person",
        coords: [
            771.0,
            194.0,
            813.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:05.200000",
        "id": 51,
        "className": "Person",
        coords: [
            288.0,
            289.0,
            349.0,
            446.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:05.300000",
        "id": 45,
        "className": "Person",
        coords: [
            343.0,
            542.0,
            464.0,
            716.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:05.300000",
        "id": 52,
        "className": "Person",
        coords: [
            416.0,
            234.0,
            525.0,
            322.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:05.300000",
        "id": 53,
        "className": "Person",
        coords: [
            28.0,
            223.0,
            81.0,
            357.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:05.300000",
        "id": 54,
        "className": "Person",
        coords: [
            771.0,
            194.0,
            813.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:05.400000",
        "id": 51,
        "className": "Person",
        coords: [
            285.0,
            289.0,
            348.0,
            447.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:05.400000",
        "id": 45,
        "className": "Person",
        coords: [
            344.0,
            542.0,
            463.0,
            715.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:05.400000",
        "id": 52,
        "className": "Person",
        coords: [
            416.0,
            234.0,
            525.0,
            322.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:05.500000",
        "id": 53,
        "className": "Person",
        coords: [
            29.0,
            222.0,
            83.0,
            356.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:05.500000",
        "id": 54,
        "className": "Person",
        coords: [
            771.0,
            194.0,
            812.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:05.500000",
        "id": 51,
        "className": "Person",
        coords: [
            284.0,
            289.0,
            347.0,
            448.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:05.500000",
        "id": 45,
        "className": "Person",
        coords: [
            345.0,
            543.0,
            462.0,
            715.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:05.600000",
        "id": 52,
        "className": "Person",
        coords: [
            415.0,
            234.0,
            526.0,
            322.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:05.600000",
        "id": 53,
        "className": "Person",
        coords: [
            28.0,
            223.0,
            80.0,
            354.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:05.600000",
        "id": 54,
        "className": "Person",
        coords: [
            771.0,
            194.0,
            812.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:05.700000",
        "id": 51,
        "className": "Person",
        coords: [
            283.0,
            289.0,
            347.0,
            449.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:05.700000",
        "id": 45,
        "className": "Person",
        coords: [
            345.0,
            544.0,
            462.0,
            715.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:05.700000",
        "id": 52,
        "className": "Person",
        coords: [
            415.0,
            234.0,
            527.0,
            322.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:05.800000",
        "id": 53,
        "className": "Person",
        coords: [
            28.0,
            221.0,
            81.0,
            355.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:05.800000",
        "id": 54,
        "className": "Person",
        coords: [
            771.0,
            194.0,
            812.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:05.900000",
        "id": 51,
        "className": "Person",
        coords: [
            283.0,
            289.0,
            347.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:05.900000",
        "id": 45,
        "className": "Person",
        coords: [
            346.0,
            544.0,
            462.0,
            715.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:05.900000",
        "id": 52,
        "className": "Person",
        coords: [
            415.0,
            234.0,
            528.0,
            322.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:07.100000",
        "id": 53,
        "className": "Person",
        coords: [
            29.0,
            220.0,
            83.0,
            356.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:07.200000",
        "id": 54,
        "className": "Person",
        coords: [
            771.0,
            194.0,
            812.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:07.200000",
        "id": 51,
        "className": "Person",
        coords: [
            282.0,
            289.0,
            346.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:07.200000",
        "id": 45,
        "className": "Person",
        coords: [
            346.0,
            544.0,
            462.0,
            715.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:07.300000",
        "id": 52,
        "className": "Person",
        coords: [
            417.0,
            234.0,
            530.0,
            323.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:07.300000",
        "id": 56,
        "className": "Person",
        coords: [
            224.0,
            278.0,
            294.0,
            389.0
        ],
        "status": "Moving",
        "speed": 147.72,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:07.600000",
        "id": 53,
        "className": "Person",
        coords: [
            29.0,
            219.0,
            85.0,
            357.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:07.600000",
        "id": 54,
        "className": "Person",
        coords: [
            771.0,
            194.0,
            812.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:07.600000",
        "id": 51,
        "className": "Person",
        coords: [
            280.0,
            290.0,
            345.0,
            451.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:07.700000",
        "id": 45,
        "className": "Person",
        coords: [
            347.0,
            544.0,
            461.0,
            712.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:07.700000",
        "id": 52,
        "className": "Person",
        coords: [
            416.0,
            235.0,
            529.0,
            322.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:07.800000",
        "id": 56,
        "className": "Person",
        coords: [
            221.0,
            279.0,
            297.0,
            393.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:07.900000",
        "id": 53,
        "className": "Person",
        coords: [
            30.0,
            219.0,
            87.0,
            358.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:07.900000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            812.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:07.900000",
        "id": 51,
        "className": "Person",
        coords: [
            280.0,
            290.0,
            344.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:08",
        "id": 45,
        "className": "Person",
        coords: [
            347.0,
            545.0,
            460.0,
            710.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:08",
        "id": 52,
        "className": "Person",
        coords: [
            416.0,
            235.0,
            529.0,
            322.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:08",
        "id": 56,
        "className": "Person",
        coords: [
            221.0,
            279.0,
            297.0,
            388.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:08.100000",
        "id": 53,
        "className": "Person",
        coords: [
            30.0,
            219.0,
            87.0,
            359.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:08.100000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            812.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:08.100000",
        "id": 51,
        "className": "Person",
        coords: [
            280.0,
            290.0,
            345.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:08.200000",
        "id": 45,
        "className": "Person",
        coords: [
            348.0,
            545.0,
            460.0,
            709.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:08.200000",
        "id": 52,
        "className": "Person",
        coords: [
            416.0,
            234.0,
            529.0,
            322.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:08.200000",
        "id": 56,
        "className": "Person",
        coords: [
            220.0,
            279.0,
            298.0,
            387.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:08.300000",
        "id": 53,
        "className": "Person",
        coords: [
            29.0,
            218.0,
            87.0,
            359.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:08.300000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            812.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:08.300000",
        "id": 51,
        "className": "Person",
        coords: [
            280.0,
            290.0,
            346.0,
            450.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:08.300000",
        "id": 45,
        "className": "Person",
        coords: [
            348.0,
            545.0,
            459.0,
            708.0
        ],
        "status": "Stationary",
        "speed": 21.21,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:08.300000",
        "id": 52,
        "className": "Person",
        coords: [
            420.0,
            235.0,
            531.0,
            321.0
        ],
        "status": "Moving",
        "speed": 45.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:08.400000",
        "id": 56,
        "className": "Person",
        coords: [
            220.0,
            279.0,
            298.0,
            385.0
        ],
        "status": "Stationary",
        "speed": 15.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:08.400000",
        "id": 53,
        "className": "Person",
        coords: [
            27.0,
            216.0,
            85.0,
            359.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:08.400000",
        "id": 54,
        "className": "Person",
        coords: [
            772.0,
            194.0,
            812.0,
            263.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:08.500000",
        "id": 51,
        "className": "Person",
        coords: [
            283.0,
            291.0,
            348.0,
            451.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:08.500000",
        "id": 45,
        "className": "Person",
        coords: [
            347.0,
            545.0,
            461.0,
            711.0
        ],
        "status": "Moving",
        "speed": 33.54,
        "hardhat": "Yes",
        "mask": "No",
        "vest": "Yes"
    },
    {
        "timestamp": "00:26:08.500000",
        "id": 52,
        "className": "Person",
        coords: [
            421.0,
            236.0,
            530.0,
            321.0
        ],
        "status": "Stationary",
        "speed": 0.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    },
    {
        "timestamp": "00:26:08.500000",
        "id": 56,
        "className": "Person",
        coords: [
            221.0,
            280.0,
            301.0,
            385.0
        ],
        "status": "Stationary",
        "speed": 30.0,
        "hardhat": "No",
        "mask": "No",
        "vest": "No"
    }
  ];

  const [data, setData] = useState(sampleData);
// 2) Put these inside your component (top-level of PPEAnalyticsDashboard)
const [videoSrc1, setVideoSrc1] = useState(null);
const [videoSrc2, setVideoSrc2] = useState(null);
const [videoName1, setVideoName1] = useState("");
const [videoName2, setVideoName2] = useState("");

useEffect(() => {
  return () => {
    if (videoSrc1) URL.revokeObjectURL(videoSrc1);
    if (videoSrc2) URL.revokeObjectURL(videoSrc2);
  };
}, [videoSrc1, videoSrc2]);

const handlePickVideo1 = (e) => {
  const file = e.target.files?.[0];
  if (!file) return;
  if (videoSrc1) URL.revokeObjectURL(videoSrc1);
  setVideoSrc1(URL.createObjectURL(file));
  setVideoName1(file.name);
};

const handlePickVideo2 = (e) => {
  const file = e.target.files?.[0];
  if (!file) return;
  if (videoSrc2) URL.revokeObjectURL(videoSrc2);
  setVideoSrc2(URL.createObjectURL(file));
  setVideoName2(file.name);
};
  // File upload handler
  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const text = e.target.result;
        const lines = text.split('\n');
        const headers = lines[0].split('\t');
        
        const parsedData = lines.slice(1).map(line => {
          const values = line.split('\t');
          if (values.length < headers.length) return null;
          
          const coordMatch = values[3]?.match(/\((\d+),\s*(\d+),\s*(\d+),\s*(\d+)\)/);
          const coords = coordMatch ? [
            parseInt(coordMatch[1]),
            parseInt(coordMatch[2]),
            parseInt(coordMatch[3]),
            parseInt(coordMatch[4])
          ] : [0, 0, 0, 0];
          
          return {
            timestamp: values[0],
            id: parseInt(values[1]),
            className: values[2],
            coords: coords,
            status: values[4],
            speed: parseFloat(values[5]),
            hardhat: values[6],
            mask: values[7],
            vest: values[8]?.trim()
          };
        }).filter(Boolean);
        
        setData(parsedData);
      };
      reader.readAsText(file);
    }
  };

  // Analytics calculations
  const analytics = useMemo(() => {
    const validData = data.filter(d => d.hardhat != 'Analysing' && d.mask != 'Analysing' && d.vest != 'Analysing');
    
    const totalWorkers = new Set(data.map(d => d.id)).size;
    const totalRecords = validData.length;
    
    const compliant = validData.filter(d => 
      d.hardhat == 'Yes'  && d.vest == 'Yes'
    ).length;
    
    const hardhatCompliance = validData.filter(d => d.hardhat == 'Yes').length;
    const maskCompliance = validData.filter(d => d.mask == 'Yes').length;
    const vestCompliance = validData.filter(d => d.vest == 'Yes').length;
    
    const complianceRate =((compliant / totalRecords) * 100).toFixed(1) ;
    
    const violations = validData.filter(d => 
      d.hardhat == 'No' || d.vest == 'No'
    );
    
    const avgSpeed = data.reduce((acc, d) => acc + d.speed, 0) / data.length;
    
    const movingWorkers = data.filter(d => d.status == 'Moving').length;
    const stationaryWorkers = data.filter(d => d.status == 'Stationary').length;
    
    return {
      totalWorkers,
      complianceRate,
      violations: violations.length,
      avgSpeed: avgSpeed.toFixed(1),
      hardhatCompliance: totalRecords > 0 ? ((hardhatCompliance / totalRecords) * 100).toFixed(1) : 0,
      maskCompliance: totalRecords > 0 ? ((maskCompliance / totalRecords) * 100).toFixed(1) : 0,
      vestCompliance: totalRecords > 0 ? ((vestCompliance / totalRecords) * 100).toFixed(1) : 0,
      movingWorkers,
      stationaryWorkers
    };
  }, [data]);

  // PPE Compliance breakdown
  const ppeComplianceData = [
    { name: 'Hardhat', value: parseFloat(analytics.hardhatCompliance), color: '#3b82f6' },
    { name: 'Mask', value: parseFloat(analytics.maskCompliance), color: '#10b981' },
    { name: 'Vest', value: parseFloat(analytics.vestCompliance), color: '#f59e0b' }
  ];

  // Worker status data
  const statusData = [
    { name: 'Moving', value: analytics.movingWorkers, color: '#8b5cf6' },
    { name: 'Stationary', value: analytics.stationaryWorkers, color: '#06b6d4' }
  ];

  // Speed distribution
  const speedData = useMemo(() => {
    const ranges = [
      { range: '0-50', min: 0, max: 50, count: 0 },
      { range: '51-100', min: 51, max: 100, count: 0 },
      { range: '101-150', min: 101, max: 150, count: 0 },
      { range: '151-200', min: 151, max: 200, count: 0 },
      { range: '200+', min: 201, max: Infinity, count: 0 }
    ];
    
    data.forEach(d => {
      const range = ranges.find(r => d.speed >= r.min && d.speed <= r.max);
      if (range) range.count++;
    });
    
    return ranges;
  }, [data]);

  // Worker compliance by ID
  const workerComplianceData = useMemo(() => {
    const workerMap = {};
    
    data.forEach(d => {
      if (d.hardhat === 'Analysing') return;
      
      if (!workerMap[d.id]) {
        workerMap[d.id] = { id: d.id, compliant: 0, total: 0 };
      }
      
      workerMap[d.id].total++;
      if (d.hardhat === 'Yes' && d.vest === 'Yes') {
        workerMap[d.id].compliant++;
      }
    });
    
    return Object.values(workerMap)
      .map(w => ({
        name: `Worker ${w.id}`,
        rate: ((w.compliant / w.total) * 100).toFixed(1)
      }))
      .sort((a, b) => b.rate - a.rate);
  }, [data]);

  // Timeline data
  const timelineData = useMemo(() => {
    const timeMap = {};
    
    data.forEach(d => {
      const time = d.timestamp.split('.')[0];
      if (!timeMap[time]) {
        timeMap[time] = { time, compliant: 0, violations: 0 };
      }
      
      if (d.hardhat === 'Analysing') return;
      
      if (d.hardhat === 'Yes'  && d.vest === 'Yes') {
        timeMap[time].compliant++;
      } else if (d.hardhat === 'No' || d.vest === 'No') {
        timeMap[time].violations++;
      }
    });
    
    return Object.values(timeMap);
  }, [data]);

  // Violation details
  const violationDetails = useMemo(() => {
    const violations = data.filter(d => 
      d.hardhat === 'No'  || d.vest === 'No'
    );
    
    return violations.map(v => ({
      id: v.id,
      timestamp: v.timestamp,
      missing: [
        v.hardhat === 'No' ? 'Hardhat' : null,
        // v.mask === 'No' ? 'Mask' : null,
        v.vest === 'No' ? 'Vest' : null
      ].filter(Boolean).join(', '),
      speed: v.speed,
      status: v.status
    }));
  }, [data]);

  // Heat map data
  const heatMapData = useMemo(() => {
    return data
      .filter(d => d.coords && d.coords.length === 4)
      .map(d => ({
        x: (d.coords[0] + d.coords[2]) / 2,
        y: (d.coords[1] + d.coords[3]) / 2,
        compliant: d.hardhat === 'Yes'&& d.vest === 'Yes' ? 1 : 0
      }));
  }, [data]);

  const COLORS = ['#3b82f6', '#10b981', '#f59e0b', '#ef4444', '#8b5cf6'];

 
  return (
    <div className="min-h-screen bg-gradient-to-br from-white via-slate-50 to-slate-100 text-slate-900 p-6">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-4xl font-bold mb-2 bg-gradient-to-r from-blue-600 to-cyan-600 bg-clip-text text-transparent">
            PPE Detection Analytics
          </h1>
          <p className="text-slate-600">Real-time safety compliance monitoring and insights</p>
        </div>

        {/* File Upload */}
        {/* <div className="mb-6 bg-white backdrop-blur-sm rounded-lg p-4 border border-slate-200">
          <label className="block text-sm font-medium mb-2">Upload Data File (TSV/CSV)</label>
          <input
            type="file"
            accept=".txt,.tsv,.csv"
            onChange={handleFileUpload}
            className="block w-full text-sm text-slate-700 file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border file:border-slate-200 file:bg-blue-600 file:text-white hover:file:bg-blue-700 cursor-pointer"
          />
        </div> */}

        {/* View Selector */}
        <div className="flex gap-2 mb-6 flex-wrap">
          {["streaming",'overview', 'compliance', 'workers', 'violations', 'movement'].map(view => (
            <button
              key={view}
              onClick={() => setSelectedView(view)}
              className={`px-4 py-2 rounded-lg font-medium transition-all border ${
                selectedView === view
                  ? 'bg-blue-600 text-white border-blue-600 shadow-lg shadow-blue-200'
                  : 'bg-white text-slate-700 hover:bg-slate-100 border-slate-200'
              }`}
            >
              {view.charAt(0).toUpperCase() + view.slice(1)}
            </button>
          ))}
        </div>

        {/* Overview Dashboard */}
        {selectedView === 'overview' && (
          <div className="space-y-6">
            {/* KPI Cards */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
              <div className="bg-gradient-to-br from-blue-100 to-blue-200 rounded-lg p-6 shadow-sm border border-blue-200">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-blue-700 text-sm">Total Workers</p>
                    <h3 className="text-3xl font-bold mt-1">{analytics.totalWorkers}</h3>
                  </div>
                  <Users className="w-12 h-12 text-blue-500 opacity-80" />
                </div>
              </div>

              <div className="bg-gradient-to-br from-green-100 to-green-200 rounded-lg p-6 shadow-sm border border-green-200">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-green-700 text-sm">Compliance Rate</p>
                    <h3 className="text-3xl font-bold mt-1">{analytics.complianceRate}%</h3>
                  </div>
                  <Shield className="w-12 h-12 text-green-500 opacity-80" />
                </div>
              </div>

              <div className="bg-gradient-to-br from-red-100 to-red-200 rounded-lg p-6 shadow-sm border border-red-200">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-red-700 text-sm">Active Violations</p>
                    <h3 className="text-3xl font-bold mt-1">{analytics.violations}</h3>
                  </div>
                  <AlertTriangle className="w-12 h-12 text-red-500 opacity-80" />
                </div>
              </div>

              <div className="bg-gradient-to-br from-purple-100 to-purple-200 rounded-lg p-6 shadow-sm border border-purple-200">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-purple-700 text-sm">Avg Speed</p>
                    <h3 className="text-3xl font-bold mt-1">{analytics.avgSpeed}</h3>
                    <p className="text-purple-700/70 text-xs">px/s</p>
                  </div>
                  <Activity className="w-12 h-12 text-purple-500 opacity-80" />
                </div>
              </div>
            </div>

            {/* Charts Row */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              {/* PPE Compliance */}
              <div className="bg-white backdrop-blur-sm rounded-lg p-6 border border-slate-200">
                <h3 className="text-xl font-semibold mb-4 flex items-center gap-2">
                  <HardHat className="w-5 h-5 text-blue-500" />
                  PPE Item Compliance
                </h3>
                <ResponsiveContainer width="100%" height={250}>
                  <BarChart data={ppeComplianceData}>
                    <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
                    <XAxis dataKey="name" stroke="#374151" />
                    <YAxis stroke="#374151" />
                    <Tooltip 
                      contentStyle={{ backgroundColor: '#ffffff', border: '1px solid #e5e7eb', borderRadius: '8px' }}
                      labelStyle={{ color: '#0f172a' }}
                    />
                    <Bar dataKey="value" fill="#3b82f6" radius={[8, 8, 0, 0]} />
                  </BarChart>
                </ResponsiveContainer>
              </div>

              {/* Worker Status */}
              <div className="bg-white backdrop-blur-sm rounded-lg p-6 border border-slate-200">
                <h3 className="text-xl font-semibold mb-4">Worker Status Distribution</h3>
                <ResponsiveContainer width="100%" height={250}>
                  <PieChart>
                    <Pie
                      data={statusData}
                      cx="50%"
                      cy="50%"
                      labelLine={false}
                      label={({ name, value }) => `${name}: ${value}`}
                      outerRadius={80}
                      fill="#8884d8"
                      dataKey="value"
                    >
                      {statusData.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={entry.color} />
                      ))}
                    </Pie>
                    <Tooltip 
                      contentStyle={{ backgroundColor: '#ffffff', border: '1px solid #e5e7eb', borderRadius: '8px' }}
                    />
                  </PieChart>
                </ResponsiveContainer>
              </div>

              {/* Timeline */}
              <div className="bg-white backdrop-blur-sm rounded-lg p-6 border border-slate-200 lg:col-span-2">
                <h3 className="text-xl font-semibold mb-4">Compliance Timeline</h3>
                <ResponsiveContainer width="100%" height={250}>
                  <LineChart data={timelineData}>
                    <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
                    <XAxis dataKey="time" stroke="#374151" />
                    <YAxis stroke="#374151" />
                    <Tooltip 
                      contentStyle={{ backgroundColor: '#ffffff', border: '1px solid #e5e7eb', borderRadius: '8px' }}
                      labelStyle={{ color: '#0f172a' }}
                    />
                    <Legend />
                    <Line type="monotone" dataKey="compliant" stroke="#10b981" strokeWidth={2} name="Compliant" />
                    <Line type="monotone" dataKey="violations" stroke="#ef4444" strokeWidth={2} name="Violations" />
                  </LineChart>
                </ResponsiveContainer>
              </div>
            </div>
          </div>
        )}

        {/* Compliance View */}
        {selectedView === 'compliance' && (
          <div className="space-y-6">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
              <div className="bg-white backdrop-blur-sm rounded-lg p-6 border border-slate-200">
                <div className="flex items-center gap-3 mb-4">
                  <div className="p-3 bg-blue-100 rounded-lg">
                    <HardHat className="w-6 h-6 text-blue-600" />
                  </div>
                  <div>
                    <p className="text-sm text-slate-600">Hardhat</p>
                    <p className="text-2xl font-bold">{analytics.hardhatCompliance}%</p>
                  </div>
                </div>
                <div className="w-full bg-slate-200 rounded-full h-2">
                  <div 
                    className="bg-blue-500 h-2 rounded-full transition-all"
                    style={{ width: `${analytics.hardhatCompliance}%` }}
                  />
                </div>
              </div>

              <div className="bg-white backdrop-blur-sm rounded-lg p-6 border border-slate-200">
                <div className="flex items-center gap-3 mb-4">
                  <div className="p-3 bg-green-100 rounded-lg">
                    <User className="w-6 h-6 text-green-600" />
                  </div>
                  <div>
                    <p className="text-sm text-slate-600">Mask</p>
                    <p className="text-2xl font-bold">{analytics.maskCompliance}%</p>
                  </div>
                </div>
                <div className="w-full bg-slate-200 rounded-full h-2">
                  <div 
                    className="bg-green-500 h-2 rounded-full transition-all"
                    style={{ width: `${analytics.maskCompliance}%` }}
                  />
                </div>
              </div>

              <div className="bg-white backdrop-blur-sm rounded-lg p-6 border border-slate-200">
                <div className="flex items-center gap-3 mb-4">
                  <div className="p-3 bg-orange-100 rounded-lg">
                    <Shirt className="w-6 h-6 text-orange-600" />
                  </div>
                  <div>
                    <p className="text-sm text-slate-600">Vest</p>
                    <p className="text-2xl font-bold">{analytics.vestCompliance}%</p>
                  </div>
                </div>
                <div className="w-full bg-slate-200 rounded-full h-2">
                  <div 
                    className="bg-orange-500 h-2 rounded-full transition-all"
                    style={{ width: `${analytics.vestCompliance}%` }}
                  />
                </div>
              </div>
            </div>

            <div className="bg-white backdrop-blur-sm rounded-lg p-6 border border-slate-200">
              <h3 className="text-xl font-semibold mb-4">Individual Worker Compliance</h3>
              <ResponsiveContainer width="100%" height={400}>
                <BarChart data={workerComplianceData}>
                  <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
                  <XAxis dataKey="name" stroke="#374151" />
                  <YAxis stroke="#374151" />
                  <Tooltip 
                    contentStyle={{ backgroundColor: '#ffffff', border: '1px solid #e5e7eb', borderRadius: '8px' }}
                    labelStyle={{ color: '#0f172a' }}
                  />
                  <Bar dataKey="rate" fill="#10b981" radius={[8, 8, 0, 0]} />
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>
        )}

        {/* Violations View */}
        {selectedView === 'violations' && (
          <div className="space-y-6">
            <div className="bg-white backdrop-blur-sm rounded-lg p-6 border border-slate-200">
              <h3 className="text-xl font-semibold mb-4 flex items-center gap-2">
                <AlertTriangle className="w-5 h-5 text-red-500" />
                Active Violations ({violationDetails.length})
              </h3>
              <div className="overflow-x-auto">
                <table className="w-full">
                  <thead>
                    <tr className="border-b border-slate-200 bg-slate-50">
                      <th className="text-left py-3 px-4 text-sm font-medium text-slate-600">Worker ID</th>
                      <th className="text-left py-3 px-4 text-sm font-medium text-slate-600">Timestamp</th>
                      <th className="text-left py-3 px-4 text-sm font-medium text-slate-600">Missing PPE</th>
                      <th className="text-left py-3 px-4 text-sm font-medium text-slate-600">Speed</th>
                      <th className="text-left py-3 px-4 text-sm font-medium text-slate-600">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {violationDetails.map((v, idx) => (
                      <tr key={idx} className="border-b border-slate-100 hover:bg-slate-100/70">
                        <td className="py-3 px-4 text-sm">Worker {v.id}</td>
                        <td className="py-3 px-4 text-sm">{v.timestamp}</td>
                        <td className="py-3 px-4 text-sm">
                          <span className="px-2 py-1 bg-red-100 text-red-700 rounded text-xs">
                            {v.missing}
                          </span>
                        </td>
                        <td className="py-3 px-4 text-sm">{v.speed.toFixed(1)} px/s</td>
                        <td className="py-3 px-4 text-sm">
                          <span className={`px-2 py-1 rounded text-xs ${
                            v.status === 'Moving' ? 'bg-purple-100 text-purple-700' : 'bg-cyan-100 text-cyan-700'
                          }`}>
                            {v.status}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}

        {/* Movement View */}
        {selectedView === 'movement' && (
          <div className="space-y-6">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              <div className="bg-white backdrop-blur-sm rounded-lg p-6 border border-slate-200">
                <h3 className="text-xl font-semibold mb-4">Speed Distribution</h3>
                <ResponsiveContainer width="100%" height={300}>
                  <BarChart data={speedData}>
                    <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
                    <XAxis dataKey="range" stroke="#374151" />
                    <YAxis stroke="#374151" />
                    <Tooltip 
                      contentStyle={{ backgroundColor: '#ffffff', border: '1px solid #e5e7eb', borderRadius: '8px' }}
                      labelStyle={{ color: '#0f172a' }}
                    />
                    <Bar dataKey="count" fill="#8b5cf6" radius={[8, 8, 0, 0]} />
                  </BarChart>
                </ResponsiveContainer>
              </div>

              <div className="bg-white backdrop-blur-sm rounded-lg p-6 border border-slate-200">
                <h3 className="text-xl font-semibold mb-4">Worker Position Heat Map</h3>
                <ResponsiveContainer width="100%" height={300}>
                  <ScatterChart>
                    <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
                    <XAxis type="number" dataKey="x" stroke="#374151" />
                    <YAxis type="number" dataKey="y" stroke="#374151" />
                    <Tooltip 
                      contentStyle={{ backgroundColor: '#ffffff', border: '1px solid #e5e7eb', borderRadius: '8px' }}
                      labelStyle={{ color: '#0f172a' }}
                    />
                    <Scatter 
                      data={heatMapData} 
                      fill="#3b82f6"
                    >
                      {heatMapData.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={entry.compliant ? '#10b981' : '#ef4444'} />
                      ))}
                    </Scatter>
                  </ScatterChart>
                </ResponsiveContainer>
              </div>
            </div>
          </div>
        )}
{selectedView === 'streaming' && (
  <div className="space-y-6">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      {/* Video 1 */}
    <VideoPlayer src="https://storage.googleapis.com/afdd-storage/main_view.mp4?X-Goog-Algorithm=GOOG4-RSA-SHA256&X-Goog-Credential=afdd-uploader%40auto-annotation-461106.iam.gserviceaccount.com%2F20251109%2Fauto%2Fstorage%2Fgoog4_request&X-Goog-Date=20251109T131528Z&X-Goog-Expires=604800&X-Goog-SignedHeaders=host&X-Goog-Signature=b4ef8d5f9863dd9e7430fec6b9ff5468cd066a37c670150d8d24f9d89b4835993c215e55570d8b7f9e9b8910a1f619506cdc5415b174821e899ebe6ce215ad60ca846dbdd669797651f1a05baf8f35c0cbafd2f74544b223974b143068a7ace33ec70416670d51827ad2c41743e8dc214d36c28c3a496be5e5c7291ba9aa414fd7b5fccff2586559d30eed0b44dd636c8bdfcd2377f88fb0b8a52ef4669e9c7aa7efb46a1eb6f8dfcb19a521ba5bd218dab7dc5f6350a913193075baadf2620d6827592bf23830e070e0d70f5f2e2fd6a2801bf6cd16f1a25586cddccfd65a9df14a0100c282e18b4103339c92111da061b47b0fd0c1e8f92b8d18d833e79475" autoPlay loop />
    <VideoPlayer src="/bird_view.mp4" autoPlay loop />
      </div>
    </div>
)}
        {/* Workers View */}
        {selectedView === 'workers' && (
          <div className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {Array.from(new Set(data.map(d => d.id))).map(workerId => {
                const workerData = data.filter(d => d.id === workerId);
                const latestData = workerData[workerData.length - 1];
                const compliantCount = workerData.filter(d => 
                  d.hardhat === 'Yes'  && d.vest === 'Yes'
                ).length;
                const complianceRate = workerData.length > 0 ? 
                  ((compliantCount / workerData.length) * 100).toFixed(0) : 0;
                const avgSpeed = workerData.reduce((acc, d) => acc + d.speed, 0) / workerData.length;
                
                const isCompliant = latestData.hardhat === 'Yes' && 
                 latestData.vest === 'Yes';
                
                return (
                  <div 
                    key={workerId} 
                    className={`bg-white backdrop-blur-sm rounded-lg p-6 border ${
                      isCompliant ? 'border-green-300' : 'border-red-300'
                    }`}
                  >
                    <div className="flex items-center justify-between mb-4">
                      <h4 className="text-lg font-semibold">Worker {workerId}</h4>
                      <span className={`px-3 py-1 rounded-full text-xs font-medium ${
                        isCompliant 
                          ? 'bg-green-100 text-green-700' 
                          : 'bg-red-100 text-red-700'
                      }`}>
                        {isCompliant ? 'Compliant' : 'Violation'}
                      </span>
                    </div>
                    
                    <div className="space-y-3">
                      <div className="flex items-center justify-between text-sm">
                        <span className="text-slate-600">Status:</span>
                        <span className="font-medium">{latestData.status}</span>
                      </div>
                      
                      <div className="flex items-center justify-between text-sm">
                        <span className="text-slate-600">Speed:</span>
                        <span className="font-medium">{avgSpeed.toFixed(1)} px/s</span>
                      </div>
                      
                      <div className="flex items-center justify-between text-sm">
                        <span className="text-slate-600">Compliance Rate:</span>
                        <span className="font-medium">{complianceRate}%</span>
                      </div>
                      
                      <div className="pt-3 border-t border-slate-200">
                        <p className="text-xs text-slate-600 mb-2">PPE Status:</p>
                        <div className="flex gap-2">
                          <span className={`px-2 py-1 rounded text-xs ${
                            latestData.hardhat === 'Yes' 
                              ? 'bg-green-100 text-green-700' 
                              : latestData.hardhat === 'No'
                              ? 'bg-red-100 text-red-700'
                              : 'bg-yellow-100 text-yellow-700'
                          }`}>
                            Hardhat: {latestData.hardhat}
                          </span>
                          <span className={`px-2 py-1 rounded text-xs ${
                            latestData.mask === 'Yes' 
                              ? 'bg-green-100 text-green-700' 
                              : latestData.mask === 'No'
                              ? 'bg-red-100 text-red-700'
                              : 'bg-yellow-100 text-yellow-700'
                          }`}>
                            Mask: {latestData.mask}
                          </span>
                          <span className={`px-2 py-1 rounded text-xs ${
                            latestData.vest === 'Yes' 
                              ? 'bg-green-100 text-green-700' 
                              : latestData.vest === 'No'
                              ? 'bg-red-100 text-red-700'
                              : 'bg-yellow-100 text-yellow-700'
                          }`}>
                            Vest: {latestData.vest}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {/* Export Options */}
        <div className="mt-8 bg-white backdrop-blur-sm rounded-lg p-6 border border-slate-200">
          <h3 className="text-lg font-semibold mb-4">Export & Actions</h3>
          <div className="flex gap-4 flex-wrap">
            <button 
              onClick={() => {
                const report = {
                  generatedAt: new Date().toISOString(),
                  summary: analytics,
                  violations: violationDetails,
                  workers: workerComplianceData
                };
                const blob = new Blob([JSON.stringify(report, null, 2)], { type: 'application/json' });
                const url = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = 'ppe-report.json';
                a.click();
              }}
              className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-medium transition-all"
            >
              Export Report (JSON)
            </button>
            
            <button 
              onClick={() => {
                const csv = [
                  ['Metric', 'Value'],
                  ['Total Workers', analytics.totalWorkers],
                  ['Compliance Rate', `${analytics.complianceRate}%`],
                  ['Violations', analytics.violations],
                  ['Avg Speed', `${analytics.avgSpeed} px/s`],
                  ['Hardhat Compliance', `${analytics.hardhatCompliance}%`],
                  ['Mask Compliance', `${analytics.maskCompliance}%`],
                  ['Vest Compliance', `${analytics.vestCompliance}%`]
                ].map(row => row.join(',')).join('\n');
                
                const blob = new Blob([csv], { type: 'text/csv' });
                const url = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = 'ppe-summary.csv';
                a.click();
              }}
              className="px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded-lg font-medium transition-all"
            >
              Export Summary (CSV)
            </button>
            
            <button 
              onClick={() => window.print()}
              className="px-4 py-2 bg-purple-600 hover:bg-purple-700 text-white rounded-lg font-medium transition-all"
            >
              Print Dashboard
            </button>
          </div>
        </div>

        {/* Footer Stats */}
        <div className="mt-6 text-center text-sm text-slate-500">
          Last updated: {new Date().toLocaleString()} | Data points: {data.length}
        </div>
      </div>
    </div>
  );
};



export default PPEAnalyticsDashboard;